import { jsx as c, jsxs as A, Fragment as ae } from "react/jsx-runtime";
import * as Ue from "react";
import H, { useRef as K, useEffect as G, useState as W, forwardRef as Rt, memo as we, useLayoutEffect as kl, useMemo as ie, Fragment as wt, isValidElement as q0, cloneElement as Y0, createElement as is, useCallback as it, createContext as Be, useContext as Le, useReducer as Qr, createRef as bi, useImperativeHandle as Ml, Children as X0 } from "react";
import * as Z0 from "react-dom";
import Nd, { unstable_batchedUpdates as Js, flushSync as vm, createPortal as jd } from "react-dom";
class J0 extends Error {
  constructor(t, n) {
    super(t), this.error = t, this.errorData = n;
  }
}
const ca = async (e, { onError: t, onLoading: n, onResult: r, params: o, rawText: s, ...i }) => {
  try {
    n == null || n(!0);
    const a = o ? new URLSearchParams(o).toString() : "", l = a ? `?${a}` : "", u = await fetch(`${e}${l}`, i);
    if (!u.ok) {
      const p = await u.json();
      throw new J0(p.error || "Request failed!", p.errorData);
    }
    const d = s ? await u.text() : await u.json();
    return r == null || r(d), d;
  } catch (a) {
    const l = a instanceof Error ? a : new Error(a);
    return t == null || t(l), l;
  } finally {
    n == null || n(!1);
  }
};
class ar {
  static async get(t, n) {
    return ca(t, { ...n, method: "GET" });
  }
  static async post(t, n) {
    return ca(t, { ...n, method: "POST" });
  }
  static async put(t, n) {
    return ca(t, { ...n, method: "PUT" });
  }
  static async delete(t, n) {
    return ca(t, { ...n, method: "DELETE" });
  }
}
function He(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  throw new Error(typeof e == "number" ? "[MobX] minified error nr: " + e + (n.length ? " " + n.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + e);
}
var Q0 = {};
function $l() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : Q0;
}
var bm = Object.assign, el = Object.getOwnPropertyDescriptor, er = Object.defineProperty, $i = Object.prototype, Nu = [];
Object.freeze(Nu);
var Dd = {};
Object.freeze(Dd);
var ey = typeof Proxy < "u", ty = /* @__PURE__ */ Object.toString();
function ym() {
  ey || He("Proxy not available");
}
function wm(e) {
  var t = !1;
  return function() {
    if (!t)
      return t = !0, e.apply(this, arguments);
  };
}
var qo = function() {
};
function In(e) {
  return typeof e == "function";
}
function yo(e) {
  var t = typeof e;
  switch (t) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function Rl(e) {
  return e !== null && typeof e == "object";
}
function Or(e) {
  if (!Rl(e))
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t == null)
    return !0;
  var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n.toString() === ty;
}
function Sm(e) {
  var t = e == null ? void 0 : e.constructor;
  return t ? t.name === "GeneratorFunction" || t.displayName === "GeneratorFunction" : !1;
}
function Ri(e, t, n) {
  er(e, t, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: n
  });
}
function xm(e, t, n) {
  er(e, t, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: n
  });
}
function eo(e, t) {
  var n = "isMobX" + e;
  return t.prototype[n] = !0, function(r) {
    return Rl(r) && r[n] === !0;
  };
}
function Cs(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Map]";
}
function ny(e) {
  var t = Object.getPrototypeOf(e), n = Object.getPrototypeOf(t), r = Object.getPrototypeOf(n);
  return r === null;
}
function mr(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Set]";
}
var Cm = typeof Object.getOwnPropertySymbols < "u";
function ry(e) {
  var t = Object.keys(e);
  if (!Cm)
    return t;
  var n = Object.getOwnPropertySymbols(e);
  return n.length ? [].concat(t, n.filter(function(r) {
    return $i.propertyIsEnumerable.call(e, r);
  })) : t;
}
var as = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Cm ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function Pm(e) {
  return e === null ? null : typeof e == "object" ? "" + e : e;
}
function xr(e, t) {
  return $i.hasOwnProperty.call(e, t);
}
var oy = Object.getOwnPropertyDescriptors || function(t) {
  var n = {};
  return as(t).forEach(function(r) {
    n[r] = el(t, r);
  }), n;
};
function en(e, t) {
  return !!(e & t);
}
function tn(e, t, n) {
  return n ? e |= t : e &= ~t, e;
}
function gf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function mf(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, iy(r.key), r);
  }
}
function Ps(e, t, n) {
  return t && mf(e.prototype, t), n && mf(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Yo(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = ay(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[r++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wo() {
  return wo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wo.apply(null, arguments);
}
function Em(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, ju(e, t);
}
function ju(e, t) {
  return ju = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, ju(e, t);
}
function sy(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function iy(e) {
  var t = sy(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function ay(e, t) {
  if (e) {
    if (typeof e == "string")
      return gf(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? gf(e, t) : void 0;
  }
}
var Jn = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function tr(e) {
  function t(n, r) {
    if (ji(r))
      return e.decorate_20223_(n, r);
    Ni(n, r, e);
  }
  return Object.assign(t, e);
}
function Ni(e, t, n) {
  xr(e, Jn) || Ri(e, Jn, wo({}, e[Jn])), my(n) || (e[Jn][t] = n);
}
function ly(e) {
  return xr(e, Jn) || Ri(e, Jn, wo({}, e[Jn])), e[Jn];
}
function ji(e) {
  return typeof e == "object" && typeof e.kind == "string";
}
var xe = /* @__PURE__ */ Symbol("mobx administration"), to = /* @__PURE__ */ function() {
  function e(n) {
    n === void 0 && (n = "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = /* @__PURE__ */ new Set(), this.lastAccessedBy_ = 0, this.lowestObserverState_ = Ge.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = n;
  }
  var t = e.prototype;
  return t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(r) {
      return r();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(r) {
      return r();
    });
  }, t.reportObserved = function() {
    return Bm(this);
  }, t.reportChanged = function() {
    bn(), zm(this), yn();
  }, t.toString = function() {
    return this.name_;
  }, Ps(e, [{
    key: "isBeingObserved",
    get: function() {
      return en(this.flags_, e.isBeingObservedMask_);
    },
    set: function(r) {
      this.flags_ = tn(this.flags_, e.isBeingObservedMask_, r);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return en(this.flags_, e.isPendingUnobservationMask_);
    },
    set: function(r) {
      this.flags_ = tn(this.flags_, e.isPendingUnobservationMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return en(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = tn(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
}();
to.isBeingObservedMask_ = 1;
to.isPendingUnobservationMask_ = 2;
to.diffValueMask_ = 4;
var Id = /* @__PURE__ */ eo("Atom", to);
function Om(e, t, n) {
  t === void 0 && (t = qo), n === void 0 && (n = qo);
  var r = new to(e);
  return t !== qo && xw(r, t), n !== qo && Ym(r, n), r;
}
function cy(e, t) {
  return e === t;
}
function uy(e, t) {
  return Ud(e, t);
}
function dy(e, t) {
  return Ud(e, t, 1);
}
function py(e, t) {
  return Object.is ? Object.is(e, t) : e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
var ls = {
  identity: cy,
  structural: uy,
  default: py,
  shallow: dy
};
function So(e, t, n) {
  return Bd(e) ? e : Array.isArray(e) ? kt.array(e, {
    name: n
  }) : Or(e) ? kt.object(e, void 0, {
    name: n
  }) : Cs(e) ? kt.map(e, {
    name: n
  }) : mr(e) ? kt.set(e, {
    name: n
  }) : typeof e == "function" && !wi(e) && !Si(e) ? Sm(e) ? Co(e) : yi(n, e) : e;
}
function fy(e, t, n) {
  if (e == null || cs(e) || Bi(e) || no(e) || $n(e))
    return e;
  if (Array.isArray(e))
    return kt.array(e, {
      name: n,
      deep: !1
    });
  if (Or(e))
    return kt.object(e, void 0, {
      name: n,
      deep: !1
    });
  if (Cs(e))
    return kt.map(e, {
      name: n,
      deep: !1
    });
  if (mr(e))
    return kt.set(e, {
      name: n,
      deep: !1
    });
}
function Nl(e) {
  return e;
}
function hy(e, t) {
  return Ud(e, t) ? t : e;
}
var gy = "override";
function my(e) {
  return e.annotationType_ === gy;
}
function Di(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: vy,
    extend_: by,
    decorate_20223_: yy
  };
}
function vy(e, t, n, r) {
  var o;
  if ((o = this.options_) != null && o.bound)
    return this.extend_(e, t, n, !1) === null ? 0 : 1;
  if (r === e.target_)
    return this.extend_(e, t, n, !1) === null ? 0 : 2;
  if (wi(n.value))
    return 1;
  var s = _m(e, this, t, n, !1);
  return er(r, t, s), 2;
}
function by(e, t, n, r) {
  var o = _m(e, this, t, n);
  return e.defineProperty_(t, o, r);
}
function yy(e, t) {
  var n = t.kind, r = t.name, o = t.addInitializer, s = this, i = function(u) {
    var d, p, f, h;
    return xo((d = (p = s.options_) == null ? void 0 : p.name) != null ? d : r.toString(), u, (f = (h = s.options_) == null ? void 0 : h.autoAction) != null ? f : !1);
  };
  if (n == "field")
    return function(l) {
      var u, d = l;
      return wi(d) || (d = i(d)), (u = s.options_) != null && u.bound && (d = d.bind(this), d.isMobxAction = !0), d;
    };
  if (n == "method") {
    var a;
    return wi(e) || (e = i(e)), (a = this.options_) != null && a.bound && o(function() {
      var l = this, u = l[r].bind(l);
      u.isMobxAction = !0, l[r] = u;
    }), e;
  }
  He("Cannot apply '" + s.annotationType_ + "' to '" + String(r) + "' (kind: " + n + "):" + (`
'` + s.annotationType_ + "' can only be used on properties with a function value."));
}
function wy(e, t, n, r) {
  t.annotationType_, r.value;
}
function _m(e, t, n, r, o) {
  var s, i, a, l, u, d, p;
  o === void 0 && (o = fe.safeDescriptors), wy(e, t, n, r);
  var f = r.value;
  if ((s = t.options_) != null && s.bound) {
    var h;
    f = f.bind((h = e.proxy_) != null ? h : e.target_);
  }
  return {
    value: xo(
      (i = (a = t.options_) == null ? void 0 : a.name) != null ? i : n.toString(),
      f,
      (l = (u = t.options_) == null ? void 0 : u.autoAction) != null ? l : !1,
      // https://github.com/mobxjs/mobx/discussions/3140
      (d = t.options_) != null && d.bound ? (p = e.proxy_) != null ? p : e.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: o ? e.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !o
  };
}
function Tm(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: Sy,
    extend_: xy,
    decorate_20223_: Cy
  };
}
function Sy(e, t, n, r) {
  var o;
  if (r === e.target_)
    return this.extend_(e, t, n, !1) === null ? 0 : 2;
  if ((o = this.options_) != null && o.bound && (!xr(e.target_, t) || !Si(e.target_[t])) && this.extend_(e, t, n, !1) === null)
    return 0;
  if (Si(n.value))
    return 1;
  var s = Am(e, this, t, n, !1, !1);
  return er(r, t, s), 2;
}
function xy(e, t, n, r) {
  var o, s = Am(e, this, t, n, (o = this.options_) == null ? void 0 : o.bound);
  return e.defineProperty_(t, s, r);
}
function Cy(e, t) {
  var n, r = t.name, o = t.addInitializer;
  return Si(e) || (e = Co(e)), (n = this.options_) != null && n.bound && o(function() {
    var s = this, i = s[r].bind(s);
    i.isMobXFlow = !0, s[r] = i;
  }), e;
}
function Py(e, t, n, r) {
  t.annotationType_, r.value;
}
function Am(e, t, n, r, o, s) {
  s === void 0 && (s = fe.safeDescriptors), Py(e, t, n, r);
  var i = r.value;
  if (Si(i) || (i = Co(i)), o) {
    var a;
    i = i.bind((a = e.proxy_) != null ? a : e.target_), i.isMobXFlow = !0;
  }
  return {
    value: i,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: s ? e.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !s
  };
}
function Vd(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: Ey,
    extend_: Oy,
    decorate_20223_: _y
  };
}
function Ey(e, t, n) {
  return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function Oy(e, t, n, r) {
  return Ty(e, this, t, n), e.defineComputedProperty_(t, wo({}, this.options_, {
    get: n.get,
    set: n.set
  }), r);
}
function _y(e, t) {
  var n = this, r = t.name, o = t.addInitializer;
  return o(function() {
    var s = Ao(this)[xe], i = wo({}, n.options_, {
      get: e,
      context: this
    });
    i.name || (i.name = "ObservableObject." + r.toString()), s.values_.set(r, new Vn(i));
  }), function() {
    return this[xe].getObservablePropValue_(r);
  };
}
function Ty(e, t, n, r) {
  t.annotationType_, r.get;
}
function jl(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: Ay,
    extend_: Ly,
    decorate_20223_: ky
  };
}
function Ay(e, t, n) {
  return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function Ly(e, t, n, r) {
  var o, s;
  return My(e, this), e.defineObservableProperty_(t, n.value, (o = (s = this.options_) == null ? void 0 : s.enhancer) != null ? o : So, r);
}
function ky(e, t) {
  var n = this, r = t.kind, o = t.name, s = /* @__PURE__ */ new WeakSet();
  function i(a, l) {
    var u, d, p = Ao(a)[xe], f = new Kr(l, (u = (d = n.options_) == null ? void 0 : d.enhancer) != null ? u : So, "ObservableObject." + o.toString(), !1);
    p.values_.set(o, f), s.add(a);
  }
  if (r == "accessor")
    return {
      get: function() {
        return s.has(this) || i(this, e.get.call(this)), this[xe].getObservablePropValue_(o);
      },
      set: function(l) {
        return s.has(this) || i(this, l), this[xe].setObservablePropValue_(o, l);
      },
      init: function(l) {
        return s.has(this) || i(this, l), l;
      }
    };
}
function My(e, t, n, r) {
  t.annotationType_;
}
var $y = "true", Ry = /* @__PURE__ */ Lm();
function Lm(e) {
  return {
    annotationType_: $y,
    options_: e,
    make_: Ny,
    extend_: jy,
    decorate_20223_: Dy
  };
}
function Ny(e, t, n, r) {
  var o, s;
  if (n.get)
    return Dl.make_(e, t, n, r);
  if (n.set) {
    var i = xo(t.toString(), n.set);
    return r === e.target_ ? e.defineProperty_(t, {
      configurable: fe.safeDescriptors ? e.isPlainObject_ : !0,
      set: i
    }) === null ? 0 : 2 : (er(r, t, {
      configurable: !0,
      set: i
    }), 2);
  }
  if (r !== e.target_ && typeof n.value == "function") {
    var a;
    if (Sm(n.value)) {
      var l, u = (l = this.options_) != null && l.autoBind ? Co.bound : Co;
      return u.make_(e, t, n, r);
    }
    var d = (a = this.options_) != null && a.autoBind ? yi.bound : yi;
    return d.make_(e, t, n, r);
  }
  var p = ((o = this.options_) == null ? void 0 : o.deep) === !1 ? kt.ref : kt;
  if (typeof n.value == "function" && (s = this.options_) != null && s.autoBind) {
    var f;
    n.value = n.value.bind((f = e.proxy_) != null ? f : e.target_);
  }
  return p.make_(e, t, n, r);
}
function jy(e, t, n, r) {
  var o, s;
  if (n.get)
    return Dl.extend_(e, t, n, r);
  if (n.set)
    return e.defineProperty_(t, {
      configurable: fe.safeDescriptors ? e.isPlainObject_ : !0,
      set: xo(t.toString(), n.set)
    }, r);
  if (typeof n.value == "function" && (o = this.options_) != null && o.autoBind) {
    var i;
    n.value = n.value.bind((i = e.proxy_) != null ? i : e.target_);
  }
  var a = ((s = this.options_) == null ? void 0 : s.deep) === !1 ? kt.ref : kt;
  return a.extend_(e, t, n, r);
}
function Dy(e, t) {
  He("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var Iy = "observable", Vy = "observable.ref", Hy = "observable.shallow", By = "observable.struct", km = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze(km);
function ua(e) {
  return e || km;
}
var Du = /* @__PURE__ */ jl(Iy), zy = /* @__PURE__ */ jl(Vy, {
  enhancer: Nl
}), Fy = /* @__PURE__ */ jl(Hy, {
  enhancer: fy
}), Uy = /* @__PURE__ */ jl(By, {
  enhancer: hy
}), Mm = /* @__PURE__ */ tr(Du);
function da(e) {
  return e.deep === !0 ? So : e.deep === !1 ? Nl : Gy(e.defaultDecorator);
}
function Wy(e) {
  var t;
  return e ? (t = e.defaultDecorator) != null ? t : Lm(e) : void 0;
}
function Gy(e) {
  var t, n;
  return e && (t = (n = e.options_) == null ? void 0 : n.enhancer) != null ? t : So;
}
function $m(e, t, n) {
  if (ji(t))
    return Du.decorate_20223_(e, t);
  if (yo(t)) {
    Ni(e, t, Du);
    return;
  }
  return Bd(e) ? e : Or(e) ? kt.object(e, t, n) : Array.isArray(e) ? kt.array(e, t) : Cs(e) ? kt.map(e, t) : mr(e) ? kt.set(e, t) : typeof e == "object" && e !== null ? e : kt.box(e, t);
}
bm($m, Mm);
var Ky = {
  box: function(t, n) {
    var r = ua(n);
    return new Kr(t, da(r), r.name, !0, r.equals);
  },
  array: function(t, n) {
    var r = ua(n);
    return (fe.useProxies === !1 || r.proxy === !1 ? Kw : Dw)(t, da(r), r.name);
  },
  map: function(t, n) {
    var r = ua(n);
    return new t1(t, da(r), r.name);
  },
  set: function(t, n) {
    var r = ua(n);
    return new n1(t, da(r), r.name);
  },
  object: function(t, n, r) {
    return ro(function() {
      return Zm(fe.useProxies === !1 || (r == null ? void 0 : r.proxy) === !1 ? Ao({}, r) : $w({}, r), t, n);
    });
  },
  ref: /* @__PURE__ */ tr(zy),
  shallow: /* @__PURE__ */ tr(Fy),
  deep: Mm,
  struct: /* @__PURE__ */ tr(Uy)
}, kt = /* @__PURE__ */ bm($m, Ky), Rm = "computed", qy = "computed.struct", Iu = /* @__PURE__ */ Vd(Rm), Yy = /* @__PURE__ */ Vd(qy, {
  equals: ls.structural
}), Dl = function(t, n) {
  if (ji(n))
    return Iu.decorate_20223_(t, n);
  if (yo(n))
    return Ni(t, n, Iu);
  if (Or(t))
    return tr(Vd(Rm, t));
  var r = Or(n) ? n : {};
  return r.get = t, r.name || (r.name = t.name || ""), new Vn(r);
};
Object.assign(Dl, Iu);
Dl.struct = /* @__PURE__ */ tr(Yy);
var vf, bf, tl = 0, Xy = 1, Zy = (vf = (bf = /* @__PURE__ */ el(function() {
}, "name")) == null ? void 0 : bf.configurable) != null ? vf : !1, yf = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function xo(e, t, n, r) {
  n === void 0 && (n = !1);
  function o() {
    return Jy(e, n, t, r || this, arguments);
  }
  return o.isMobxAction = !0, o.toString = function() {
    return t.toString();
  }, Zy && (yf.value = e, er(o, "name", yf)), o;
}
function Jy(e, t, n, r, o) {
  var s = Qy(e, t);
  try {
    return n.apply(r, o);
  } catch (i) {
    throw s.error_ = i, i;
  } finally {
    ew(s);
  }
}
function Qy(e, t, n, r) {
  var o = !1, s = 0, i = fe.trackingDerivation, a = !t || !i;
  bn();
  var l = fe.allowStateChanges;
  a && (To(), l = Il(!0));
  var u = Hd(!0), d = {
    runAsAction_: a,
    prevDerivation_: i,
    prevAllowStateChanges_: l,
    prevAllowStateReads_: u,
    notifySpy_: o,
    startTime_: s,
    actionId_: Xy++,
    parentActionId_: tl
  };
  return tl = d.actionId_, d;
}
function ew(e) {
  tl !== e.actionId_ && He(30), tl = e.parentActionId_, e.error_ !== void 0 && (fe.suppressReactionErrors = !0), Vl(e.prevAllowStateChanges_), ri(e.prevAllowStateReads_), yn(), e.runAsAction_ && Cr(e.prevDerivation_), fe.suppressReactionErrors = !1;
}
function tw(e, t) {
  var n = Il(e);
  try {
    return t();
  } finally {
    Vl(n);
  }
}
function Il(e) {
  var t = fe.allowStateChanges;
  return fe.allowStateChanges = e, t;
}
function Vl(e) {
  fe.allowStateChanges = e;
}
var Kr = /* @__PURE__ */ function(e) {
  function t(r, o, s, i, a) {
    var l;
    return s === void 0 && (s = "ObservableValue"), a === void 0 && (a = ls.default), l = e.call(this, s) || this, l.enhancer = void 0, l.name_ = void 0, l.equals = void 0, l.hasUnreportedChange_ = !1, l.interceptors_ = void 0, l.changeListeners_ = void 0, l.value_ = void 0, l.dehancer = void 0, l.enhancer = o, l.name_ = s, l.equals = a, l.value_ = o(r, void 0, s), l;
  }
  Em(t, e);
  var n = t.prototype;
  return n.dehanceValue = function(o) {
    return this.dehancer !== void 0 ? this.dehancer(o) : o;
  }, n.set = function(o) {
    this.value_, o = this.prepareNewValue_(o), o !== fe.UNCHANGED && this.setNewValue_(o);
  }, n.prepareNewValue_ = function(o) {
    if (mn(this)) {
      var s = vn(this, {
        object: this,
        type: nr,
        newValue: o
      });
      if (!s)
        return fe.UNCHANGED;
      o = s.newValue;
    }
    return o = this.enhancer(o, this.value_, this.name_), this.equals(this.value_, o) ? fe.UNCHANGED : o;
  }, n.setNewValue_ = function(o) {
    var s = this.value_;
    this.value_ = o, this.reportChanged(), Nn(this) && jn(this, {
      type: nr,
      object: this,
      newValue: o,
      oldValue: s
    });
  }, n.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, n.intercept_ = function(o) {
    return Vi(this, o);
  }, n.observe_ = function(o, s) {
    return s && o({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: nr,
      newValue: this.value_,
      oldValue: void 0
    }), Hi(this, o);
  }, n.raw = function() {
    return this.value_;
  }, n.toJSON = function() {
    return this.get();
  }, n.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, n.valueOf = function() {
    return Pm(this.get());
  }, n[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, t;
}(to), nw = /* @__PURE__ */ eo("ObservableValue", Kr), Vn = /* @__PURE__ */ function() {
  function e(n) {
    this.dependenciesState_ = Ge.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = /* @__PURE__ */ new Set(), this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = Ge.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new rl(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = nl.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, n.get || He(31), this.derivation = n.get, this.name_ = n.name || "ComputedValue", n.set && (this.setter_ = xo("ComputedValue-setter", n.set)), this.equals_ = n.equals || (n.compareStructural || n.struct ? ls.structural : ls.default), this.scope_ = n.context, this.requiresReaction_ = n.requiresReaction, this.keepAlive_ = !!n.keepAlive;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    aw(this);
  }, t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(r) {
      return r();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(r) {
      return r();
    });
  }, t.get = function() {
    if (this.isComputing && He(32, this.name_, this.derivation), fe.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_)
      Vu(this) && (this.warnAboutUntrackedRead_(), bn(), this.value_ = this.computeValue_(!1), yn());
    else if (Bm(this), Vu(this)) {
      var r = fe.trackingContext;
      this.keepAlive_ && !r && (fe.trackingContext = this), this.trackAndCompute() && iw(this), fe.trackingContext = r;
    }
    var o = this.value_;
    if (Ga(o))
      throw o.cause;
    return o;
  }, t.set = function(r) {
    if (this.setter_) {
      this.isRunningSetter && He(33, this.name_), this.isRunningSetter = !0;
      try {
        this.setter_.call(this.scope_, r);
      } finally {
        this.isRunningSetter = !1;
      }
    } else
      He(34, this.name_);
  }, t.trackAndCompute = function() {
    var r = this.value_, o = (
      /* see #1208 */
      this.dependenciesState_ === Ge.NOT_TRACKING_
    ), s = this.computeValue_(!0), i = o || Ga(r) || Ga(s) || !this.equals_(r, s);
    return i && (this.value_ = s), i;
  }, t.computeValue_ = function(r) {
    this.isComputing = !0;
    var o = Il(!1), s;
    if (r)
      s = Nm(this, this.derivation, this.scope_);
    else if (fe.disableErrorBoundaries === !0)
      s = this.derivation.call(this.scope_);
    else
      try {
        s = this.derivation.call(this.scope_);
      } catch (i) {
        s = new rl(i);
      }
    return Vl(o), this.isComputing = !1, s;
  }, t.suspend_ = function() {
    this.keepAlive_ || (Hu(this), this.value_ = void 0);
  }, t.observe_ = function(r, o) {
    var s = this, i = !0, a = void 0;
    return vw(function() {
      var l = s.get();
      if (!i || o) {
        var u = To();
        r({
          observableKind: "computed",
          debugObjectName: s.name_,
          type: nr,
          object: s,
          newValue: l,
          oldValue: a
        }), Cr(u);
      }
      i = !1, a = l;
    });
  }, t.warnAboutUntrackedRead_ = function() {
  }, t.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, t.valueOf = function() {
    return Pm(this.get());
  }, t[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, Ps(e, [{
    key: "isComputing",
    get: function() {
      return en(this.flags_, e.isComputingMask_);
    },
    set: function(r) {
      this.flags_ = tn(this.flags_, e.isComputingMask_, r);
    }
  }, {
    key: "isRunningSetter",
    get: function() {
      return en(this.flags_, e.isRunningSetterMask_);
    },
    set: function(r) {
      this.flags_ = tn(this.flags_, e.isRunningSetterMask_, r);
    }
  }, {
    key: "isBeingObserved",
    get: function() {
      return en(this.flags_, e.isBeingObservedMask_);
    },
    set: function(r) {
      this.flags_ = tn(this.flags_, e.isBeingObservedMask_, r);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return en(this.flags_, e.isPendingUnobservationMask_);
    },
    set: function(r) {
      this.flags_ = tn(this.flags_, e.isPendingUnobservationMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return en(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = tn(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
}();
Vn.isComputingMask_ = 1;
Vn.isRunningSetterMask_ = 2;
Vn.isBeingObservedMask_ = 4;
Vn.isPendingUnobservationMask_ = 8;
Vn.diffValueMask_ = 16;
var Ii = /* @__PURE__ */ eo("ComputedValue", Vn), Ge;
(function(e) {
  e[e.NOT_TRACKING_ = -1] = "NOT_TRACKING_", e[e.UP_TO_DATE_ = 0] = "UP_TO_DATE_", e[e.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", e[e.STALE_ = 2] = "STALE_";
})(Ge || (Ge = {}));
var nl;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.LOG = 1] = "LOG", e[e.BREAK = 2] = "BREAK";
})(nl || (nl = {}));
var rl = function(t) {
  this.cause = void 0, this.cause = t;
};
function Ga(e) {
  return e instanceof rl;
}
function Vu(e) {
  switch (e.dependenciesState_) {
    case Ge.UP_TO_DATE_:
      return !1;
    case Ge.NOT_TRACKING_:
    case Ge.STALE_:
      return !0;
    case Ge.POSSIBLY_STALE_: {
      for (var t = Hd(!0), n = To(), r = e.observing_, o = r.length, s = 0; s < o; s++) {
        var i = r[s];
        if (Ii(i)) {
          if (fe.disableErrorBoundaries)
            i.get();
          else
            try {
              i.get();
            } catch {
              return Cr(n), ri(t), !0;
            }
          if (e.dependenciesState_ === Ge.STALE_)
            return Cr(n), ri(t), !0;
        }
      }
      return Dm(e), Cr(n), ri(t), !1;
    }
  }
}
function Nm(e, t, n) {
  var r = Hd(!0);
  Dm(e), e.newObserving_ = new Array(
    // Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    e.runId_ === 0 ? 100 : e.observing_.length
  ), e.unboundDepsCount_ = 0, e.runId_ = ++fe.runId;
  var o = fe.trackingDerivation;
  fe.trackingDerivation = e, fe.inBatch++;
  var s;
  if (fe.disableErrorBoundaries === !0)
    s = t.call(n);
  else
    try {
      s = t.call(n);
    } catch (i) {
      s = new rl(i);
    }
  return fe.inBatch--, fe.trackingDerivation = o, rw(e), ri(r), s;
}
function rw(e) {
  for (var t = e.observing_, n = e.observing_ = e.newObserving_, r = Ge.UP_TO_DATE_, o = 0, s = e.unboundDepsCount_, i = 0; i < s; i++) {
    var a = n[i];
    a.diffValue === 0 && (a.diffValue = 1, o !== i && (n[o] = a), o++), a.dependenciesState_ > r && (r = a.dependenciesState_);
  }
  for (n.length = o, e.newObserving_ = null, s = t.length; s--; ) {
    var l = t[s];
    l.diffValue === 0 && Vm(l, e), l.diffValue = 0;
  }
  for (; o--; ) {
    var u = n[o];
    u.diffValue === 1 && (u.diffValue = 0, sw(u, e));
  }
  r !== Ge.UP_TO_DATE_ && (e.dependenciesState_ = r, e.onBecomeStale_());
}
function Hu(e) {
  var t = e.observing_;
  e.observing_ = [];
  for (var n = t.length; n--; )
    Vm(t[n], e);
  e.dependenciesState_ = Ge.NOT_TRACKING_;
}
function jm(e) {
  var t = To();
  try {
    return e();
  } finally {
    Cr(t);
  }
}
function To() {
  var e = fe.trackingDerivation;
  return fe.trackingDerivation = null, e;
}
function Cr(e) {
  fe.trackingDerivation = e;
}
function Hd(e) {
  var t = fe.allowStateReads;
  return fe.allowStateReads = e, t;
}
function ri(e) {
  fe.allowStateReads = e;
}
function Dm(e) {
  if (e.dependenciesState_ !== Ge.UP_TO_DATE_) {
    e.dependenciesState_ = Ge.UP_TO_DATE_;
    for (var t = e.observing_, n = t.length; n--; )
      t[n].lowestObserverState_ = Ge.UP_TO_DATE_;
  }
}
var Ka = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
}, qa = !0, Im = !1, fe = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ $l();
  return e.__mobxInstanceCount > 0 && !e.__mobxGlobals && (qa = !1), e.__mobxGlobals && e.__mobxGlobals.version !== new Ka().version && (qa = !1), qa ? e.__mobxGlobals ? (e.__mobxInstanceCount += 1, e.__mobxGlobals.UNCHANGED || (e.__mobxGlobals.UNCHANGED = {}), e.__mobxGlobals) : (e.__mobxInstanceCount = 1, e.__mobxGlobals = /* @__PURE__ */ new Ka()) : (setTimeout(function() {
    Im || He(35);
  }, 1), new Ka());
}();
function ow() {
  if ((fe.pendingReactions.length || fe.inBatch || fe.isRunningReactions) && He(36), Im = !0, qa) {
    var e = $l();
    --e.__mobxInstanceCount === 0 && (e.__mobxGlobals = void 0), fe = new Ka();
  }
}
function sw(e, t) {
  e.observers_.add(t), e.lowestObserverState_ > t.dependenciesState_ && (e.lowestObserverState_ = t.dependenciesState_);
}
function Vm(e, t) {
  e.observers_.delete(t), e.observers_.size === 0 && Hm(e);
}
function Hm(e) {
  e.isPendingUnobservation === !1 && (e.isPendingUnobservation = !0, fe.pendingUnobservations.push(e));
}
function bn() {
  fe.inBatch++;
}
function yn() {
  if (--fe.inBatch === 0) {
    Fm();
    for (var e = fe.pendingUnobservations, t = 0; t < e.length; t++) {
      var n = e[t];
      n.isPendingUnobservation = !1, n.observers_.size === 0 && (n.isBeingObserved && (n.isBeingObserved = !1, n.onBUO()), n instanceof Vn && n.suspend_());
    }
    fe.pendingUnobservations = [];
  }
}
function Bm(e) {
  var t = fe.trackingDerivation;
  return t !== null ? (t.runId_ !== e.lastAccessedBy_ && (e.lastAccessedBy_ = t.runId_, t.newObserving_[t.unboundDepsCount_++] = e, !e.isBeingObserved && fe.trackingContext && (e.isBeingObserved = !0, e.onBO())), e.isBeingObserved) : (e.observers_.size === 0 && fe.inBatch > 0 && Hm(e), !1);
}
function zm(e) {
  e.lowestObserverState_ !== Ge.STALE_ && (e.lowestObserverState_ = Ge.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === Ge.UP_TO_DATE_ && t.onBecomeStale_(), t.dependenciesState_ = Ge.STALE_;
  }));
}
function iw(e) {
  e.lowestObserverState_ !== Ge.STALE_ && (e.lowestObserverState_ = Ge.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === Ge.POSSIBLY_STALE_ ? t.dependenciesState_ = Ge.STALE_ : t.dependenciesState_ === Ge.UP_TO_DATE_ && (e.lowestObserverState_ = Ge.UP_TO_DATE_);
  }));
}
function aw(e) {
  e.lowestObserverState_ === Ge.UP_TO_DATE_ && (e.lowestObserverState_ = Ge.POSSIBLY_STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === Ge.UP_TO_DATE_ && (t.dependenciesState_ = Ge.POSSIBLY_STALE_, t.onBecomeStale_());
  }));
}
var sr = /* @__PURE__ */ function() {
  function e(n, r, o, s) {
    n === void 0 && (n = "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = Ge.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = nl.NONE, this.name_ = n, this.onInvalidate_ = r, this.errorHandler_ = o, this.requiresObservable_ = s;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    this.schedule_();
  }, t.schedule_ = function() {
    this.isScheduled || (this.isScheduled = !0, fe.pendingReactions.push(this), Fm());
  }, t.runReaction_ = function() {
    if (!this.isDisposed) {
      bn(), this.isScheduled = !1;
      var r = fe.trackingContext;
      if (fe.trackingContext = this, Vu(this)) {
        this.isTrackPending = !0;
        try {
          this.onInvalidate_();
        } catch (o) {
          this.reportExceptionInDerivation_(o);
        }
      }
      fe.trackingContext = r, yn();
    }
  }, t.track = function(r) {
    if (!this.isDisposed) {
      bn(), this.isRunning = !0;
      var o = fe.trackingContext;
      fe.trackingContext = this;
      var s = Nm(this, r, void 0);
      fe.trackingContext = o, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && Hu(this), Ga(s) && this.reportExceptionInDerivation_(s.cause), yn();
    }
  }, t.reportExceptionInDerivation_ = function(r) {
    var o = this;
    if (this.errorHandler_) {
      this.errorHandler_(r, this);
      return;
    }
    if (fe.disableErrorBoundaries)
      throw r;
    var s = "[mobx] uncaught error in '" + this + "'";
    fe.suppressReactionErrors || console.error(s, r), fe.globalReactionErrorHandlers.forEach(function(i) {
      return i(r, o);
    });
  }, t.dispose = function() {
    this.isDisposed || (this.isDisposed = !0, this.isRunning || (bn(), Hu(this), yn()));
  }, t.getDisposer_ = function(r) {
    var o = this, s = function i() {
      o.dispose(), r == null || r.removeEventListener == null || r.removeEventListener("abort", i);
    };
    return r == null || r.addEventListener == null || r.addEventListener("abort", s), s[xe] = this, s;
  }, t.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, t.trace = function(r) {
  }, Ps(e, [{
    key: "isDisposed",
    get: function() {
      return en(this.flags_, e.isDisposedMask_);
    },
    set: function(r) {
      this.flags_ = tn(this.flags_, e.isDisposedMask_, r);
    }
  }, {
    key: "isScheduled",
    get: function() {
      return en(this.flags_, e.isScheduledMask_);
    },
    set: function(r) {
      this.flags_ = tn(this.flags_, e.isScheduledMask_, r);
    }
  }, {
    key: "isTrackPending",
    get: function() {
      return en(this.flags_, e.isTrackPendingMask_);
    },
    set: function(r) {
      this.flags_ = tn(this.flags_, e.isTrackPendingMask_, r);
    }
  }, {
    key: "isRunning",
    get: function() {
      return en(this.flags_, e.isRunningMask_);
    },
    set: function(r) {
      this.flags_ = tn(this.flags_, e.isRunningMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return en(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = tn(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
}();
sr.isDisposedMask_ = 1;
sr.isScheduledMask_ = 2;
sr.isTrackPendingMask_ = 4;
sr.isRunningMask_ = 8;
sr.diffValueMask_ = 16;
var lw = 100, Bu = function(t) {
  return t();
};
function Fm() {
  fe.inBatch > 0 || fe.isRunningReactions || Bu(cw);
}
function cw() {
  fe.isRunningReactions = !0;
  for (var e = fe.pendingReactions, t = 0; e.length > 0; ) {
    ++t === lw && (console.error("[mobx] cycle in reaction: " + e[0]), e.splice(0));
    for (var n = e.splice(0), r = 0, o = n.length; r < o; r++)
      n[r].runReaction_();
  }
  fe.isRunningReactions = !1;
}
var ol = /* @__PURE__ */ eo("Reaction", sr);
function uw(e) {
  var t = Bu;
  Bu = function(r) {
    return e(function() {
      return t(r);
    });
  };
}
function oi() {
  return !1;
}
function dw(e) {
  return console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  };
}
var Um = "action", pw = "action.bound", Wm = "autoAction", fw = "autoAction.bound", hw = "<unnamed action>", zu = /* @__PURE__ */ Di(Um), gw = /* @__PURE__ */ Di(pw, {
  bound: !0
}), Fu = /* @__PURE__ */ Di(Wm, {
  autoAction: !0
}), mw = /* @__PURE__ */ Di(fw, {
  autoAction: !0,
  bound: !0
});
function Gm(e) {
  var t = function(r, o) {
    if (In(r))
      return xo(r.name || hw, r, e);
    if (In(o))
      return xo(r, o, e);
    if (ji(o))
      return (e ? Fu : zu).decorate_20223_(r, o);
    if (yo(o))
      return Ni(r, o, e ? Fu : zu);
    if (yo(r))
      return tr(Di(e ? Wm : Um, {
        name: r,
        autoAction: e
      }));
  };
  return t;
}
var fo = /* @__PURE__ */ Gm(!1);
Object.assign(fo, zu);
var yi = /* @__PURE__ */ Gm(!0);
Object.assign(yi, Fu);
fo.bound = /* @__PURE__ */ tr(gw);
yi.bound = /* @__PURE__ */ tr(mw);
function wi(e) {
  return In(e) && e.isMobxAction === !0;
}
function vw(e, t) {
  var n, r, o, s;
  t === void 0 && (t = Dd);
  var i = (n = (r = t) == null ? void 0 : r.name) != null ? n : "Autorun", a = !t.scheduler && !t.delay, l;
  if (a)
    l = new sr(i, function() {
      this.track(p);
    }, t.onError, t.requiresObservable);
  else {
    var u = Km(t), d = !1;
    l = new sr(i, function() {
      d || (d = !0, u(function() {
        d = !1, l.isDisposed || l.track(p);
      }));
    }, t.onError, t.requiresObservable);
  }
  function p() {
    e(l);
  }
  return (o = t) != null && (o = o.signal) != null && o.aborted || l.schedule_(), l.getDisposer_((s = t) == null ? void 0 : s.signal);
}
var bw = function(t) {
  return t();
};
function Km(e) {
  return e.scheduler ? e.scheduler : e.delay ? function(t) {
    return setTimeout(t, e.delay);
  } : bw;
}
function qm(e, t, n) {
  var r, o, s;
  n === void 0 && (n = Dd);
  var i = (r = n.name) != null ? r : "Reaction", a = fo(i, n.onError ? yw(n.onError, t) : t), l = !n.scheduler && !n.delay, u = Km(n), d = !0, p = !1, f, h = n.compareStructural ? ls.structural : n.equals || ls.default, g = new sr(i, function() {
    d || l ? m() : p || (p = !0, u(m));
  }, n.onError, n.requiresObservable);
  function m() {
    if (p = !1, !g.isDisposed) {
      var v = !1, b = f;
      g.track(function() {
        var y = tw(!1, function() {
          return e(g);
        });
        v = d || !h(f, y), f = y;
      }), (d && n.fireImmediately || !d && v) && a(f, b, g), d = !1;
    }
  }
  return (o = n) != null && (o = o.signal) != null && o.aborted || g.schedule_(), g.getDisposer_((s = n) == null ? void 0 : s.signal);
}
function yw(e, t) {
  return function() {
    try {
      return t.apply(this, arguments);
    } catch (n) {
      e.call(this, n);
    }
  };
}
var ww = "onBO", Sw = "onBUO";
function xw(e, t, n) {
  return Xm(ww, e, t, n);
}
function Ym(e, t, n) {
  return Xm(Sw, e, t, n);
}
function Xm(e, t, n, r) {
  var o = typeof r == "function" ? us(t, n) : us(t), s = In(r) ? r : n, i = e + "L";
  return o[i] ? o[i].add(s) : o[i] = /* @__PURE__ */ new Set([s]), function() {
    var a = o[i];
    a && (a.delete(s), a.size === 0 && delete o[i]);
  };
}
var Cw = "never", pa = "always", Pw = "observed";
function Ew(e) {
  e.isolateGlobalState === !0 && ow();
  var t = e.useProxies, n = e.enforceActions;
  if (t !== void 0 && (fe.useProxies = t === pa ? !0 : t === Cw ? !1 : typeof Proxy < "u"), t === "ifavailable" && (fe.verifyProxies = !0), n !== void 0) {
    var r = n === pa ? pa : n === Pw;
    fe.enforceActions = r, fe.allowStateChanges = !(r === !0 || r === pa);
  }
  ["computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "disableErrorBoundaries", "safeDescriptors"].forEach(function(o) {
    o in e && (fe[o] = !!e[o]);
  }), fe.allowStateReads = !fe.observableRequiresReaction, e.reactionScheduler && uw(e.reactionScheduler);
}
function Zm(e, t, n, r) {
  var o = oy(t);
  return ro(function() {
    var s = Ao(e, r)[xe];
    as(o).forEach(function(i) {
      s.extend_(
        i,
        o[i],
        // must pass "undefined" for { key: undefined }
        n && i in n ? n[i] : !0
      );
    });
  }), e;
}
function Ow(e, t) {
  return Jm(us(e, t));
}
function Jm(e) {
  var t = {
    name: e.name_
  };
  return e.observing_ && e.observing_.length > 0 && (t.dependencies = _w(e.observing_).map(Jm)), t;
}
function _w(e) {
  return Array.from(new Set(e));
}
var Tw = 0;
function Qm() {
  this.message = "FLOW_CANCELLED";
}
Qm.prototype = /* @__PURE__ */ Object.create(Error.prototype);
var Oc = /* @__PURE__ */ Tm("flow"), Aw = /* @__PURE__ */ Tm("flow.bound", {
  bound: !0
}), Co = /* @__PURE__ */ Object.assign(function(t, n) {
  if (ji(n))
    return Oc.decorate_20223_(t, n);
  if (yo(n))
    return Ni(t, n, Oc);
  var r = t, o = r.name || "<unnamed flow>", s = function() {
    var a = this, l = arguments, u = ++Tw, d = fo(o + " - runid: " + u + " - init", r).apply(a, l), p, f = void 0, h = new Promise(function(g, m) {
      var v = 0;
      p = m;
      function b(S) {
        f = void 0;
        var x;
        try {
          x = fo(o + " - runid: " + u + " - yield " + v++, d.next).call(d, S);
        } catch (C) {
          return m(C);
        }
        w(x);
      }
      function y(S) {
        f = void 0;
        var x;
        try {
          x = fo(o + " - runid: " + u + " - yield " + v++, d.throw).call(d, S);
        } catch (C) {
          return m(C);
        }
        w(x);
      }
      function w(S) {
        if (In(S == null ? void 0 : S.then)) {
          S.then(w, m);
          return;
        }
        return S.done ? g(S.value) : (f = Promise.resolve(S.value), f.then(b, y));
      }
      b(void 0);
    });
    return h.cancel = fo(o + " - runid: " + u + " - cancel", function() {
      try {
        f && wf(f);
        var g = d.return(void 0), m = Promise.resolve(g.value);
        m.then(qo, qo), wf(m), p(new Qm());
      } catch (v) {
        p(v);
      }
    }), h;
  };
  return s.isMobXFlow = !0, s;
}, Oc);
Co.bound = /* @__PURE__ */ tr(Aw);
function wf(e) {
  In(e.cancel) && e.cancel();
}
function Si(e) {
  return (e == null ? void 0 : e.isMobXFlow) === !0;
}
function Lw(e, t) {
  return e ? t !== void 0 ? cs(e) ? e[xe].values_.has(t) : !1 : cs(e) || !!e[xe] || Id(e) || ol(e) || Ii(e) : !1;
}
function Bd(e) {
  return Lw(e);
}
function kw(e) {
  if (cs(e))
    return e[xe].ownKeys_();
  He(38);
}
function fa(e, t, n) {
  return e.set(t, n), n;
}
function Wo(e, t) {
  if (e == null || typeof e != "object" || e instanceof Date || !Bd(e))
    return e;
  if (nw(e) || Ii(e))
    return Wo(e.get(), t);
  if (t.has(e))
    return t.get(e);
  if (Bi(e)) {
    var n = fa(t, e, new Array(e.length));
    return e.forEach(function(i, a) {
      n[a] = Wo(i, t);
    }), n;
  }
  if ($n(e)) {
    var r = fa(t, e, /* @__PURE__ */ new Set());
    return e.forEach(function(i) {
      r.add(Wo(i, t));
    }), r;
  }
  if (no(e)) {
    var o = fa(t, e, /* @__PURE__ */ new Map());
    return e.forEach(function(i, a) {
      o.set(a, Wo(i, t));
    }), o;
  } else {
    var s = fa(t, e, {});
    return kw(e).forEach(function(i) {
      $i.propertyIsEnumerable.call(e, i) && (s[i] = Wo(e[i], t));
    }), s;
  }
}
function Fr(e, t) {
  return Wo(e, /* @__PURE__ */ new Map());
}
function vr(e, t) {
  t === void 0 && (t = void 0), bn();
  try {
    return e.apply(t);
  } finally {
    yn();
  }
}
function Ho(e) {
  return e[xe];
}
var Mw = {
  has: function(t, n) {
    return Ho(t).has_(n);
  },
  get: function(t, n) {
    return Ho(t).get_(n);
  },
  set: function(t, n, r) {
    var o;
    return yo(n) ? (o = Ho(t).set_(n, r, !0)) != null ? o : !0 : !1;
  },
  deleteProperty: function(t, n) {
    var r;
    return yo(n) ? (r = Ho(t).delete_(n, !0)) != null ? r : !0 : !1;
  },
  defineProperty: function(t, n, r) {
    var o;
    return (o = Ho(t).defineProperty_(n, r)) != null ? o : !0;
  },
  ownKeys: function(t) {
    return Ho(t).ownKeys_();
  },
  preventExtensions: function(t) {
    He(13);
  }
};
function $w(e, t) {
  var n, r;
  return ym(), e = Ao(e, t), (r = (n = e[xe]).proxy_) != null ? r : n.proxy_ = new Proxy(e, Mw);
}
function mn(e) {
  return e.interceptors_ !== void 0 && e.interceptors_.length > 0;
}
function Vi(e, t) {
  var n = e.interceptors_ || (e.interceptors_ = []);
  return n.push(t), wm(function() {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  });
}
function vn(e, t) {
  var n = To();
  try {
    for (var r = [].concat(e.interceptors_ || []), o = 0, s = r.length; o < s && (t = r[o](t), t && !t.type && He(14), !!t); o++)
      ;
    return t;
  } finally {
    Cr(n);
  }
}
function Nn(e) {
  return e.changeListeners_ !== void 0 && e.changeListeners_.length > 0;
}
function Hi(e, t) {
  var n = e.changeListeners_ || (e.changeListeners_ = []);
  return n.push(t), wm(function() {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  });
}
function jn(e, t) {
  var n = To(), r = e.changeListeners_;
  if (r) {
    r = r.slice();
    for (var o = 0, s = r.length; o < s; o++)
      r[o](t);
    Cr(n);
  }
}
function Rw(e, t, n) {
  return ro(function() {
    var r, o = Ao(e, n)[xe];
    (r = t) != null || (t = ly(e)), as(t).forEach(function(s) {
      return o.make_(s, t[s]);
    });
  }), e;
}
var _c = /* @__PURE__ */ Symbol("mobx-keys");
function Ut(e, t, n) {
  return Or(e) ? Zm(e, e, t, n) : (ro(function() {
    var r = Ao(e, n)[xe];
    if (!e[_c]) {
      var o = Object.getPrototypeOf(e), s = new Set([].concat(as(e), as(o)));
      s.delete("constructor"), s.delete(xe), Ri(o, _c, s);
    }
    e[_c].forEach(function(i) {
      return r.make_(
        i,
        // must pass "undefined" for { key: undefined }
        t && i in t ? t[i] : !0
      );
    });
  }), e);
}
var Sf = "splice", nr = "update", Nw = 1e4, jw = {
  get: function(t, n) {
    var r = t[xe];
    return n === xe ? r : n === "length" ? r.getArrayLength_() : typeof n == "string" && !isNaN(n) ? r.get_(parseInt(n)) : xr(sl, n) ? sl[n] : t[n];
  },
  set: function(t, n, r) {
    var o = t[xe];
    return n === "length" && o.setArrayLength_(r), typeof n == "symbol" || isNaN(n) ? t[n] = r : o.set_(parseInt(n), r), !0;
  },
  preventExtensions: function() {
    He(15);
  }
}, zd = /* @__PURE__ */ function() {
  function e(n, r, o, s) {
    n === void 0 && (n = "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = o, this.legacyMode_ = s, this.atom_ = new to(n), this.enhancer_ = function(i, a) {
      return r(i, a, "ObservableArray[..]");
    };
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.dehanceValues_ = function(r) {
    return this.dehancer !== void 0 && r.length > 0 ? r.map(this.dehancer) : r;
  }, t.intercept_ = function(r) {
    return Vi(this, r);
  }, t.observe_ = function(r, o) {
    return o === void 0 && (o = !1), o && r({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), Hi(this, r);
  }, t.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, t.setArrayLength_ = function(r) {
    (typeof r != "number" || isNaN(r) || r < 0) && He("Out of range: " + r);
    var o = this.values_.length;
    if (r !== o)
      if (r > o) {
        for (var s = new Array(r - o), i = 0; i < r - o; i++)
          s[i] = void 0;
        this.spliceWithArray_(o, 0, s);
      } else
        this.spliceWithArray_(r, o - r);
  }, t.updateArrayLength_ = function(r, o) {
    r !== this.lastKnownLength_ && He(16), this.lastKnownLength_ += o, this.legacyMode_ && o > 0 && i1(r + o + 1);
  }, t.spliceWithArray_ = function(r, o, s) {
    var i = this;
    this.atom_;
    var a = this.values_.length;
    if (r === void 0 ? r = 0 : r > a ? r = a : r < 0 && (r = Math.max(0, a + r)), arguments.length === 1 ? o = a - r : o == null ? o = 0 : o = Math.max(0, Math.min(o, a - r)), s === void 0 && (s = Nu), mn(this)) {
      var l = vn(this, {
        object: this.proxy_,
        type: Sf,
        index: r,
        removedCount: o,
        added: s
      });
      if (!l)
        return Nu;
      o = l.removedCount, s = l.added;
    }
    if (s = s.length === 0 ? s : s.map(function(p) {
      return i.enhancer_(p, void 0);
    }), this.legacyMode_) {
      var u = s.length - o;
      this.updateArrayLength_(a, u);
    }
    var d = this.spliceItemsIntoValues_(r, o, s);
    return (o !== 0 || s.length !== 0) && this.notifyArraySplice_(r, s, d), this.dehanceValues_(d);
  }, t.spliceItemsIntoValues_ = function(r, o, s) {
    if (s.length < Nw) {
      var i;
      return (i = this.values_).splice.apply(i, [r, o].concat(s));
    } else {
      var a = this.values_.slice(r, r + o), l = this.values_.slice(r + o);
      this.values_.length += s.length - o;
      for (var u = 0; u < s.length; u++)
        this.values_[r + u] = s[u];
      for (var d = 0; d < l.length; d++)
        this.values_[r + s.length + d] = l[d];
      return a;
    }
  }, t.notifyArrayChildUpdate_ = function(r, o, s) {
    var i = !this.owned_ && oi(), a = Nn(this), l = a || i ? {
      observableKind: "array",
      object: this.proxy_,
      type: nr,
      debugObjectName: this.atom_.name_,
      index: r,
      newValue: o,
      oldValue: s
    } : null;
    this.atom_.reportChanged(), a && jn(this, l);
  }, t.notifyArraySplice_ = function(r, o, s) {
    var i = !this.owned_ && oi(), a = Nn(this), l = a || i ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: Sf,
      index: r,
      removed: s,
      added: o,
      removedCount: s.length,
      addedCount: o.length
    } : null;
    this.atom_.reportChanged(), a && jn(this, l);
  }, t.get_ = function(r) {
    if (this.legacyMode_ && r >= this.values_.length) {
      console.warn("[mobx] Out of bounds read: " + r);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[r]);
  }, t.set_ = function(r, o) {
    var s = this.values_;
    if (this.legacyMode_ && r > s.length && He(17, r, s.length), r < s.length) {
      this.atom_;
      var i = s[r];
      if (mn(this)) {
        var a = vn(this, {
          type: nr,
          object: this.proxy_,
          // since "this" is the real array we need to pass its proxy
          index: r,
          newValue: o
        });
        if (!a)
          return;
        o = a.newValue;
      }
      o = this.enhancer_(o, i);
      var l = o !== i;
      l && (s[r] = o, this.notifyArrayChildUpdate_(r, o, i));
    } else {
      for (var u = new Array(r + 1 - s.length), d = 0; d < u.length - 1; d++)
        u[d] = void 0;
      u[u.length - 1] = o, this.spliceWithArray_(s.length, 0, u);
    }
  }, e;
}();
function Dw(e, t, n, r) {
  return n === void 0 && (n = "ObservableArray"), r === void 0 && (r = !1), ym(), ro(function() {
    var o = new zd(n, t, r, !1);
    xm(o.values_, xe, o);
    var s = new Proxy(o.values_, jw);
    return o.proxy_ = s, e && e.length && o.spliceWithArray_(0, 0, e), s;
  });
}
var sl = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(t) {
    var n = this[xe];
    return n.spliceWithArray_(0, n.values_.length, t);
  },
  // Used by JSON.stringify
  toJSON: function() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(t, n) {
    for (var r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), s = 2; s < r; s++)
      o[s - 2] = arguments[s];
    var i = this[xe];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return i.spliceWithArray_(t);
      case 2:
        return i.spliceWithArray_(t, n);
    }
    return i.spliceWithArray_(t, n, o);
  },
  spliceWithArray: function(t, n, r) {
    return this[xe].spliceWithArray_(t, n, r);
  },
  push: function() {
    for (var t = this[xe], n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.spliceWithArray_(t.values_.length, 0, r), t.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[xe].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var t = this[xe], n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.spliceWithArray_(0, 0, r), t.values_.length;
  },
  reverse: function() {
    return fe.trackingDerivation && He(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    fe.trackingDerivation && He(37, "sort");
    var t = this.slice();
    return t.sort.apply(t, arguments), this.replace(t), this;
  },
  remove: function(t) {
    var n = this[xe], r = n.dehanceValues_(n.values_).indexOf(t);
    return r > -1 ? (this.splice(r, 1), !0) : !1;
  }
};
st("at", ln);
st("concat", ln);
st("flat", ln);
st("includes", ln);
st("indexOf", ln);
st("join", ln);
st("lastIndexOf", ln);
st("slice", ln);
st("toString", ln);
st("toLocaleString", ln);
st("toSorted", ln);
st("toSpliced", ln);
st("with", ln);
st("every", Hn);
st("filter", Hn);
st("find", Hn);
st("findIndex", Hn);
st("findLast", Hn);
st("findLastIndex", Hn);
st("flatMap", Hn);
st("forEach", Hn);
st("map", Hn);
st("some", Hn);
st("toReversed", Hn);
st("reduce", e1);
st("reduceRight", e1);
function st(e, t) {
  typeof Array.prototype[e] == "function" && (sl[e] = t(e));
}
function ln(e) {
  return function() {
    var t = this[xe];
    t.atom_.reportObserved();
    var n = t.dehanceValues_(t.values_);
    return n[e].apply(n, arguments);
  };
}
function Hn(e) {
  return function(t, n) {
    var r = this, o = this[xe];
    o.atom_.reportObserved();
    var s = o.dehanceValues_(o.values_);
    return s[e](function(i, a) {
      return t.call(n, i, a, r);
    });
  };
}
function e1(e) {
  return function() {
    var t = this, n = this[xe];
    n.atom_.reportObserved();
    var r = n.dehanceValues_(n.values_), o = arguments[0];
    return arguments[0] = function(s, i, a) {
      return o(s, i, a, t);
    }, r[e].apply(r, arguments);
  };
}
var Iw = /* @__PURE__ */ eo("ObservableArrayAdministration", zd);
function Bi(e) {
  return Rl(e) && Iw(e[xe]);
}
var Vw = {}, Ur = "add", il = "delete", t1 = /* @__PURE__ */ function() {
  function e(n, r, o) {
    var s = this;
    r === void 0 && (r = So), o === void 0 && (o = "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[xe] = Vw, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = r, this.name_ = o, In(Map) || He(18), ro(function() {
      s.keysAtom_ = Om("ObservableMap.keys()"), s.data_ = /* @__PURE__ */ new Map(), s.hasMap_ = /* @__PURE__ */ new Map(), n && s.merge(n);
    });
  }
  var t = e.prototype;
  return t.has_ = function(r) {
    return this.data_.has(r);
  }, t.has = function(r) {
    var o = this;
    if (!fe.trackingDerivation)
      return this.has_(r);
    var s = this.hasMap_.get(r);
    if (!s) {
      var i = s = new Kr(this.has_(r), Nl, "ObservableMap.key?", !1);
      this.hasMap_.set(r, i), Ym(i, function() {
        return o.hasMap_.delete(r);
      });
    }
    return s.get();
  }, t.set = function(r, o) {
    var s = this.has_(r);
    if (mn(this)) {
      var i = vn(this, {
        type: s ? nr : Ur,
        object: this,
        newValue: o,
        name: r
      });
      if (!i)
        return this;
      o = i.newValue;
    }
    return s ? this.updateValue_(r, o) : this.addValue_(r, o), this;
  }, t.delete = function(r) {
    var o = this;
    if (this.keysAtom_, mn(this)) {
      var s = vn(this, {
        type: il,
        object: this,
        name: r
      });
      if (!s)
        return !1;
    }
    if (this.has_(r)) {
      var i = oi(), a = Nn(this), l = a || i ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: il,
        object: this,
        oldValue: this.data_.get(r).value_,
        name: r
      } : null;
      return vr(function() {
        var u;
        o.keysAtom_.reportChanged(), (u = o.hasMap_.get(r)) == null || u.setNewValue_(!1);
        var d = o.data_.get(r);
        d.setNewValue_(void 0), o.data_.delete(r);
      }), a && jn(this, l), !0;
    }
    return !1;
  }, t.updateValue_ = function(r, o) {
    var s = this.data_.get(r);
    if (o = s.prepareNewValue_(o), o !== fe.UNCHANGED) {
      var i = oi(), a = Nn(this), l = a || i ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: nr,
        object: this,
        oldValue: s.value_,
        name: r,
        newValue: o
      } : null;
      s.setNewValue_(o), a && jn(this, l);
    }
  }, t.addValue_ = function(r, o) {
    var s = this;
    this.keysAtom_, vr(function() {
      var u, d = new Kr(o, s.enhancer_, "ObservableMap.key", !1);
      s.data_.set(r, d), o = d.value_, (u = s.hasMap_.get(r)) == null || u.setNewValue_(!0), s.keysAtom_.reportChanged();
    });
    var i = oi(), a = Nn(this), l = a || i ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: Ur,
      object: this,
      name: r,
      newValue: o
    } : null;
    a && jn(this, l);
  }, t.get = function(r) {
    return this.has(r) ? this.dehanceValue_(this.data_.get(r).get()) : this.dehanceValue_(void 0);
  }, t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, t.values = function() {
    var r = this, o = this.keys();
    return xf({
      next: function() {
        var i = o.next(), a = i.done, l = i.value;
        return {
          done: a,
          value: a ? void 0 : r.get(l)
        };
      }
    });
  }, t.entries = function() {
    var r = this, o = this.keys();
    return xf({
      next: function() {
        var i = o.next(), a = i.done, l = i.value;
        return {
          done: a,
          value: a ? void 0 : [l, r.get(l)]
        };
      }
    });
  }, t[Symbol.iterator] = function() {
    return this.entries();
  }, t.forEach = function(r, o) {
    for (var s = Yo(this), i; !(i = s()).done; ) {
      var a = i.value, l = a[0], u = a[1];
      r.call(o, u, l, this);
    }
  }, t.merge = function(r) {
    var o = this;
    return no(r) && (r = new Map(r)), vr(function() {
      Or(r) ? ry(r).forEach(function(s) {
        return o.set(s, r[s]);
      }) : Array.isArray(r) ? r.forEach(function(s) {
        var i = s[0], a = s[1];
        return o.set(i, a);
      }) : Cs(r) ? (ny(r) || He(19, r), r.forEach(function(s, i) {
        return o.set(i, s);
      })) : r != null && He(20, r);
    }), this;
  }, t.clear = function() {
    var r = this;
    vr(function() {
      jm(function() {
        for (var o = Yo(r.keys()), s; !(s = o()).done; ) {
          var i = s.value;
          r.delete(i);
        }
      });
    });
  }, t.replace = function(r) {
    var o = this;
    return vr(function() {
      for (var s = Hw(r), i = /* @__PURE__ */ new Map(), a = !1, l = Yo(o.data_.keys()), u; !(u = l()).done; ) {
        var d = u.value;
        if (!s.has(d)) {
          var p = o.delete(d);
          if (p)
            a = !0;
          else {
            var f = o.data_.get(d);
            i.set(d, f);
          }
        }
      }
      for (var h = Yo(s.entries()), g; !(g = h()).done; ) {
        var m = g.value, v = m[0], b = m[1], y = o.data_.has(v);
        if (o.set(v, b), o.data_.has(v)) {
          var w = o.data_.get(v);
          i.set(v, w), y || (a = !0);
        }
      }
      if (!a)
        if (o.data_.size !== i.size)
          o.keysAtom_.reportChanged();
        else
          for (var S = o.data_.keys(), x = i.keys(), C = S.next(), P = x.next(); !C.done; ) {
            if (C.value !== P.value) {
              o.keysAtom_.reportChanged();
              break;
            }
            C = S.next(), P = x.next();
          }
      o.data_ = i;
    }), this;
  }, t.toString = function() {
    return "[object ObservableMap]";
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.observe_ = function(r, o) {
    return Hi(this, r);
  }, t.intercept_ = function(r) {
    return Vi(this, r);
  }, Ps(e, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Map";
    }
  }]);
}(), no = /* @__PURE__ */ eo("ObservableMap", t1);
function xf(e) {
  return e[Symbol.toStringTag] = "MapIterator", Wd(e);
}
function Hw(e) {
  if (Cs(e) || no(e))
    return e;
  if (Array.isArray(e))
    return new Map(e);
  if (Or(e)) {
    var t = /* @__PURE__ */ new Map();
    for (var n in e)
      t.set(n, e[n]);
    return t;
  } else
    return He(21, e);
}
var Bw = {}, n1 = /* @__PURE__ */ function() {
  function e(n, r, o) {
    var s = this;
    r === void 0 && (r = So), o === void 0 && (o = "ObservableSet"), this.name_ = void 0, this[xe] = Bw, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = o, In(Set) || He(22), this.enhancer_ = function(i, a) {
      return r(i, a, o);
    }, ro(function() {
      s.atom_ = Om(s.name_), n && s.replace(n);
    });
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.clear = function() {
    var r = this;
    vr(function() {
      jm(function() {
        for (var o = Yo(r.data_.values()), s; !(s = o()).done; ) {
          var i = s.value;
          r.delete(i);
        }
      });
    });
  }, t.forEach = function(r, o) {
    for (var s = Yo(this), i; !(i = s()).done; ) {
      var a = i.value;
      r.call(o, a, a, this);
    }
  }, t.add = function(r) {
    var o = this;
    if (this.atom_, mn(this)) {
      var s = vn(this, {
        type: Ur,
        object: this,
        newValue: r
      });
      if (!s)
        return this;
    }
    if (!this.has(r)) {
      vr(function() {
        o.data_.add(o.enhancer_(r, void 0)), o.atom_.reportChanged();
      });
      var i = !1, a = Nn(this), l = a || i ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: Ur,
        object: this,
        newValue: r
      } : null;
      a && jn(this, l);
    }
    return this;
  }, t.delete = function(r) {
    var o = this;
    if (mn(this)) {
      var s = vn(this, {
        type: il,
        object: this,
        oldValue: r
      });
      if (!s)
        return !1;
    }
    if (this.has(r)) {
      var i = !1, a = Nn(this), l = a || i ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: il,
        object: this,
        oldValue: r
      } : null;
      return vr(function() {
        o.atom_.reportChanged(), o.data_.delete(r);
      }), a && jn(this, l), !0;
    }
    return !1;
  }, t.has = function(r) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(r));
  }, t.entries = function() {
    var r = 0, o = Array.from(this.keys()), s = Array.from(this.values());
    return Cf({
      next: function() {
        var a = r;
        return r += 1, a < s.length ? {
          value: [o[a], s[a]],
          done: !1
        } : {
          value: void 0,
          done: !0
        };
      }
    });
  }, t.keys = function() {
    return this.values();
  }, t.values = function() {
    this.atom_.reportObserved();
    var r = this, o = 0, s = Array.from(this.data_.values());
    return Cf({
      next: function() {
        return o < s.length ? {
          value: r.dehanceValue_(s[o++]),
          done: !1
        } : {
          value: void 0,
          done: !0
        };
      }
    });
  }, t.intersection = function(r) {
    if (mr(r) && !$n(r))
      return r.intersection(this);
    var o = new Set(this);
    return o.intersection(r);
  }, t.union = function(r) {
    if (mr(r) && !$n(r))
      return r.union(this);
    var o = new Set(this);
    return o.union(r);
  }, t.difference = function(r) {
    return new Set(this).difference(r);
  }, t.symmetricDifference = function(r) {
    if (mr(r) && !$n(r))
      return r.symmetricDifference(this);
    var o = new Set(this);
    return o.symmetricDifference(r);
  }, t.isSubsetOf = function(r) {
    return new Set(this).isSubsetOf(r);
  }, t.isSupersetOf = function(r) {
    return new Set(this).isSupersetOf(r);
  }, t.isDisjointFrom = function(r) {
    if (mr(r) && !$n(r))
      return r.isDisjointFrom(this);
    var o = new Set(this);
    return o.isDisjointFrom(r);
  }, t.replace = function(r) {
    var o = this;
    return $n(r) && (r = new Set(r)), vr(function() {
      Array.isArray(r) ? (o.clear(), r.forEach(function(s) {
        return o.add(s);
      })) : mr(r) ? (o.clear(), r.forEach(function(s) {
        return o.add(s);
      })) : r != null && He("Cannot initialize set from " + r);
    }), this;
  }, t.observe_ = function(r, o) {
    return Hi(this, r);
  }, t.intercept_ = function(r) {
    return Vi(this, r);
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.toString = function() {
    return "[object ObservableSet]";
  }, t[Symbol.iterator] = function() {
    return this.values();
  }, Ps(e, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Set";
    }
  }]);
}(), $n = /* @__PURE__ */ eo("ObservableSet", n1);
function Cf(e) {
  return e[Symbol.toStringTag] = "SetIterator", Wd(e);
}
var Pf = /* @__PURE__ */ Object.create(null), Ef = "remove", r1 = /* @__PURE__ */ function() {
  function e(n, r, o, s) {
    r === void 0 && (r = /* @__PURE__ */ new Map()), s === void 0 && (s = Ry), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = n, this.values_ = r, this.name_ = o, this.defaultAnnotation_ = s, this.keysAtom_ = new to("ObservableObject.keys"), this.isPlainObject_ = Or(this.target_);
  }
  var t = e.prototype;
  return t.getObservablePropValue_ = function(r) {
    return this.values_.get(r).get();
  }, t.setObservablePropValue_ = function(r, o) {
    var s = this.values_.get(r);
    if (s instanceof Vn)
      return s.set(o), !0;
    if (mn(this)) {
      var i = vn(this, {
        type: nr,
        object: this.proxy_ || this.target_,
        name: r,
        newValue: o
      });
      if (!i)
        return null;
      o = i.newValue;
    }
    if (o = s.prepareNewValue_(o), o !== fe.UNCHANGED) {
      var a = Nn(this), l = !1, u = a || l ? {
        type: nr,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: s.value_,
        name: r,
        newValue: o
      } : null;
      s.setNewValue_(o), a && jn(this, u);
    }
    return !0;
  }, t.get_ = function(r) {
    return fe.trackingDerivation && !xr(this.target_, r) && this.has_(r), this.target_[r];
  }, t.set_ = function(r, o, s) {
    return s === void 0 && (s = !1), xr(this.target_, r) ? this.values_.has(r) ? this.setObservablePropValue_(r, o) : s ? Reflect.set(this.target_, r, o) : (this.target_[r] = o, !0) : this.extend_(r, {
      value: o,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, s);
  }, t.has_ = function(r) {
    if (!fe.trackingDerivation)
      return r in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var o = this.pendingKeys_.get(r);
    return o || (o = new Kr(r in this.target_, Nl, "ObservableObject.key?", !1), this.pendingKeys_.set(r, o)), o.get();
  }, t.make_ = function(r, o) {
    if (o === !0 && (o = this.defaultAnnotation_), o !== !1) {
      if (!(r in this.target_)) {
        var s;
        if ((s = this.target_[Jn]) != null && s[r])
          return;
        He(1, o.annotationType_, this.name_ + "." + r.toString());
      }
      for (var i = this.target_; i && i !== $i; ) {
        var a = el(i, r);
        if (a) {
          var l = o.make_(this, r, a, i);
          if (l === 0)
            return;
          if (l === 1)
            break;
        }
        i = Object.getPrototypeOf(i);
      }
      _f(this, o, r);
    }
  }, t.extend_ = function(r, o, s, i) {
    if (i === void 0 && (i = !1), s === !0 && (s = this.defaultAnnotation_), s === !1)
      return this.defineProperty_(r, o, i);
    var a = s.extend_(this, r, o, i);
    return a && _f(this, s, r), a;
  }, t.defineProperty_ = function(r, o, s) {
    s === void 0 && (s = !1), this.keysAtom_;
    try {
      bn();
      var i = this.delete_(r);
      if (!i)
        return i;
      if (mn(this)) {
        var a = vn(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: Ur,
          newValue: o.value
        });
        if (!a)
          return null;
        var l = a.newValue;
        o.value !== l && (o = wo({}, o, {
          value: l
        }));
      }
      if (s) {
        if (!Reflect.defineProperty(this.target_, r, o))
          return !1;
      } else
        er(this.target_, r, o);
      this.notifyPropertyAddition_(r, o.value);
    } finally {
      yn();
    }
    return !0;
  }, t.defineObservableProperty_ = function(r, o, s, i) {
    i === void 0 && (i = !1), this.keysAtom_;
    try {
      bn();
      var a = this.delete_(r);
      if (!a)
        return a;
      if (mn(this)) {
        var l = vn(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: Ur,
          newValue: o
        });
        if (!l)
          return null;
        o = l.newValue;
      }
      var u = Of(r), d = {
        configurable: fe.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: u.get,
        set: u.set
      };
      if (i) {
        if (!Reflect.defineProperty(this.target_, r, d))
          return !1;
      } else
        er(this.target_, r, d);
      var p = new Kr(o, s, "ObservableObject.key", !1);
      this.values_.set(r, p), this.notifyPropertyAddition_(r, p.value_);
    } finally {
      yn();
    }
    return !0;
  }, t.defineComputedProperty_ = function(r, o, s) {
    s === void 0 && (s = !1), this.keysAtom_;
    try {
      bn();
      var i = this.delete_(r);
      if (!i)
        return i;
      if (mn(this)) {
        var a = vn(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: Ur,
          newValue: void 0
        });
        if (!a)
          return null;
      }
      o.name || (o.name = "ObservableObject.key"), o.context = this.proxy_ || this.target_;
      var l = Of(r), u = {
        configurable: fe.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: l.get,
        set: l.set
      };
      if (s) {
        if (!Reflect.defineProperty(this.target_, r, u))
          return !1;
      } else
        er(this.target_, r, u);
      this.values_.set(r, new Vn(o)), this.notifyPropertyAddition_(r, void 0);
    } finally {
      yn();
    }
    return !0;
  }, t.delete_ = function(r, o) {
    if (o === void 0 && (o = !1), this.keysAtom_, !xr(this.target_, r))
      return !0;
    if (mn(this)) {
      var s = vn(this, {
        object: this.proxy_ || this.target_,
        name: r,
        type: Ef
      });
      if (!s)
        return null;
    }
    try {
      var i;
      bn();
      var a = Nn(this), l = !1, u = this.values_.get(r), d = void 0;
      if (!u && (a || l)) {
        var p;
        d = (p = el(this.target_, r)) == null ? void 0 : p.value;
      }
      if (o) {
        if (!Reflect.deleteProperty(this.target_, r))
          return !1;
      } else
        delete this.target_[r];
      if (u && (this.values_.delete(r), u instanceof Kr && (d = u.value_), zm(u)), this.keysAtom_.reportChanged(), (i = this.pendingKeys_) == null || (i = i.get(r)) == null || i.set(r in this.target_), a || l) {
        var f = {
          type: Ef,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: d,
          name: r
        };
        a && jn(this, f);
      }
    } finally {
      yn();
    }
    return !0;
  }, t.observe_ = function(r, o) {
    return Hi(this, r);
  }, t.intercept_ = function(r) {
    return Vi(this, r);
  }, t.notifyPropertyAddition_ = function(r, o) {
    var s, i = Nn(this), a = !1;
    if (i || a) {
      var l = i || a ? {
        type: Ur,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: r,
        newValue: o
      } : null;
      i && jn(this, l);
    }
    (s = this.pendingKeys_) == null || (s = s.get(r)) == null || s.set(!0), this.keysAtom_.reportChanged();
  }, t.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), as(this.target_);
  }, t.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, e;
}();
function Ao(e, t) {
  var n;
  if (xr(e, xe))
    return e;
  var r = (n = t == null ? void 0 : t.name) != null ? n : "ObservableObject", o = new r1(e, /* @__PURE__ */ new Map(), String(r), Wy(t));
  return Ri(e, xe, o), e;
}
var zw = /* @__PURE__ */ eo("ObservableObjectAdministration", r1);
function Of(e) {
  return Pf[e] || (Pf[e] = {
    get: function() {
      return this[xe].getObservablePropValue_(e);
    },
    set: function(n) {
      return this[xe].setObservablePropValue_(e, n);
    }
  });
}
function cs(e) {
  return Rl(e) ? zw(e[xe]) : !1;
}
function _f(e, t, n) {
  var r;
  (r = e.target_[Jn]) == null || delete r[n];
}
var Fw = /* @__PURE__ */ s1(0), Uw = /* @__PURE__ */ function() {
  var e = !1, t = {};
  return Object.defineProperty(t, "0", {
    set: function() {
      e = !0;
    }
  }), Object.create(t)[0] = 1, e === !1;
}(), Tc = 0, o1 = function() {
};
function Ww(e, t) {
  Object.setPrototypeOf ? Object.setPrototypeOf(e.prototype, t) : e.prototype.__proto__ !== void 0 ? e.prototype.__proto__ = t : e.prototype = t;
}
Ww(o1, Array.prototype);
var Fd = /* @__PURE__ */ function(e) {
  function t(r, o, s, i) {
    var a;
    return s === void 0 && (s = "ObservableArray"), i === void 0 && (i = !1), a = e.call(this) || this, ro(function() {
      var l = new zd(s, o, i, !0);
      l.proxy_ = a, xm(a, xe, l), r && r.length && a.spliceWithArray(0, 0, r), Uw && Object.defineProperty(a, "0", Fw);
    }), a;
  }
  Em(t, e);
  var n = t.prototype;
  return n.concat = function() {
    this[xe].atom_.reportObserved();
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      s.map(function(a) {
        return Bi(a) ? a.slice() : a;
      })
    );
  }, n[Symbol.iterator] = function() {
    var r = this, o = 0;
    return Wd({
      next: function() {
        return o < r.length ? {
          value: r[o++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, Ps(t, [{
    key: "length",
    get: function() {
      return this[xe].getArrayLength_();
    },
    set: function(o) {
      this[xe].setArrayLength_(o);
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Array";
    }
  }]);
}(o1);
Object.entries(sl).forEach(function(e) {
  var t = e[0], n = e[1];
  t !== "concat" && Ri(Fd.prototype, t, n);
});
function s1(e) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[xe].get_(e);
    },
    set: function(n) {
      this[xe].set_(e, n);
    }
  };
}
function Gw(e) {
  er(Fd.prototype, "" + e, s1(e));
}
function i1(e) {
  if (e > Tc) {
    for (var t = Tc; t < e + 100; t++)
      Gw(t);
    Tc = e;
  }
}
i1(1e3);
function Kw(e, t, n) {
  return new Fd(e, t, n);
}
function us(e, t) {
  if (typeof e == "object" && e !== null) {
    if (Bi(e))
      return t !== void 0 && He(23), e[xe].atom_;
    if ($n(e))
      return e.atom_;
    if (no(e)) {
      if (t === void 0)
        return e.keysAtom_;
      var n = e.data_.get(t) || e.hasMap_.get(t);
      return n || He(25, t, Uu(e)), n;
    }
    if (cs(e)) {
      if (!t)
        return He(26);
      var r = e[xe].values_.get(t);
      return r || He(27, t, Uu(e)), r;
    }
    if (Id(e) || Ii(e) || ol(e))
      return e;
  } else if (In(e) && ol(e[xe]))
    return e[xe];
  He(28);
}
function a1(e, t) {
  if (e || He(29), t !== void 0)
    return a1(us(e, t));
  if (Id(e) || Ii(e) || ol(e) || no(e) || $n(e))
    return e;
  if (e[xe])
    return e[xe];
  He(24, e);
}
function Uu(e, t) {
  var n;
  if (t !== void 0)
    n = us(e, t);
  else {
    if (wi(e))
      return e.name;
    cs(e) || no(e) || $n(e) ? n = a1(e) : n = us(e);
  }
  return n.name_;
}
function ro(e) {
  var t = To(), n = Il(!0);
  bn();
  try {
    return e();
  } finally {
    yn(), Vl(n), Cr(t);
  }
}
var Tf = $i.toString;
function Ud(e, t, n) {
  return n === void 0 && (n = -1), Wu(e, t, n);
}
function Wu(e, t, n, r, o) {
  if (e === t)
    return e !== 0 || 1 / e === 1 / t;
  if (e == null || t == null)
    return !1;
  if (e !== e)
    return t !== t;
  var s = typeof e;
  if (s !== "function" && s !== "object" && typeof t != "object")
    return !1;
  var i = Tf.call(e);
  if (i !== Tf.call(t))
    return !1;
  switch (i) {
    case "[object RegExp]":
    case "[object String]":
      return "" + e == "" + t;
    case "[object Number]":
      return +e != +e ? +t != +t : +e == 0 ? 1 / +e === 1 / t : +e == +t;
    case "[object Date]":
    case "[object Boolean]":
      return +e == +t;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(e) === Symbol.valueOf.call(t);
    case "[object Map]":
    case "[object Set]":
      n >= 0 && n++;
      break;
  }
  e = Af(e), t = Af(t);
  var a = i === "[object Array]";
  if (!a) {
    if (typeof e != "object" || typeof t != "object")
      return !1;
    var l = e.constructor, u = t.constructor;
    if (l !== u && !(In(l) && l instanceof l && In(u) && u instanceof u) && "constructor" in e && "constructor" in t)
      return !1;
  }
  if (n === 0)
    return !1;
  n < 0 && (n = -1), r = r || [], o = o || [];
  for (var d = r.length; d--; )
    if (r[d] === e)
      return o[d] === t;
  if (r.push(e), o.push(t), a) {
    if (d = e.length, d !== t.length)
      return !1;
    for (; d--; )
      if (!Wu(e[d], t[d], n - 1, r, o))
        return !1;
  } else {
    var p = Object.keys(e), f;
    if (d = p.length, Object.keys(t).length !== d)
      return !1;
    for (; d--; )
      if (f = p[d], !(xr(t, f) && Wu(e[f], t[f], n - 1, r, o)))
        return !1;
  }
  return r.pop(), o.pop(), !0;
}
function Af(e) {
  return Bi(e) ? e.slice() : Cs(e) || no(e) || mr(e) || $n(e) ? Array.from(e.entries()) : e;
}
var Lf, qw = ((Lf = $l().Iterator) == null ? void 0 : Lf.prototype) || {};
function Wd(e) {
  return e[Symbol.iterator] = Yw, Object.assign(Object.create(qw), e);
}
function Yw() {
  return this;
}
["Symbol", "Map", "Set"].forEach(function(e) {
  var t = $l();
  typeof t[e] > "u" && He("MobX requires global '" + e + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy: dw,
  extras: {
    getDebugName: Uu
  },
  $mobx: xe
});
const l1 = "app.grapesjs.com", c1 = "app-stage.grapesjs.com", u1 = "gs-studio-root", kf = [
  l1,
  c1,
  "localhost",
  "127.0.0.1",
  ".local-credentialless.webcontainer.io",
  // For stackblitz.com demos
  ".local.webcontainer.io",
  // For stackblitz.com demos
  "-sandpack.codesandbox.io"
  // For Sandpack demos
], Xw = "license:check:start", Mf = "license:check:end", lr = () => typeof window < "u", ds = (e) => e && e.stopPropagation(), Zw = (e, t) => {
  const n = (r) => r.key === e && t();
  return document.addEventListener("keydown", n), () => document.removeEventListener("keydown", n);
}, Jw = (e = "") => {
  const t = document.createElement("textarea");
  t.value = e, t.setAttribute("readonly", ""), t.style.position = "absolute", t.style.left = "-9999px", document.body.appendChild(t), t.select(), document.execCommand("copy"), document.body.removeChild(t);
}, Qw = (e) => Zw("Escape", e), eS = (e, t = {}) => {
  const n = Mt(e) ? { id: e, src: e } : e;
  return new Promise((r, o) => {
    var l, u;
    const s = document.querySelector(`script[src="${n.src}"]`), { id: i } = n;
    if (s)
      return (l = t.onScript) == null || l.call(t, s), r(i);
    const a = document.createElement("script");
    a.src = n.src, a.onload = () => r(i), a.onerror = () => o(i), document.head.appendChild(a), (u = t.onScript) == null || u.call(t, a);
  });
}, tS = (e) => {
  const t = e.map((n) => eS(n));
  return Promise.allSettled(t);
};
function nS(e) {
  const t = e.ownerDocument.createElement("script");
  return t.text = e.innerHTML, Array.from(e.attributes).forEach((n) => t.setAttribute(n.nodeName, n.nodeValue)), t;
}
function $f(e) {
  const t = (r) => {
    var o;
    if (r.length) {
      const s = r.shift(), i = nS(s);
      i.onerror = i.onload = t.bind(null, r), (o = s.parentNode) == null || o.replaceChild(i, s);
    }
  }, n = Array.from(e.querySelectorAll("script"));
  t(n);
}
const d1 = (e) => new DOMParser().parseFromString(e, "text/html"), rS = (e = "") => d1(`<body>${e}</body>`).body.innerHTML, oS = (e = "") => d1(`<head>${e}</head>`).head.innerHTML, sS = (e = "", t) => {
  const r = new DOMParser().parseFromString(e, "text/html");
  if (t) {
    const s = r.querySelectorAll("svg")[0].style || {}, i = dS(t) ? `${t}px` : t;
    s.width = i, s.height = i, s.fill = "currentColor";
  }
  return new XMLSerializer().serializeToString(r);
}, iS = ({ isDev: e, isStage: t }) => `${e ? "" : `https://${t ? c1 : l1}`}/api`, p1 = (e = {}) => {
  const { width: t = 300, height: n, text: r = "IMAGE", bg: o = "777", fg: s = "white" } = e, i = n ? `x${n}` : "";
  return `https://placehold.co/${t}${i}/${o}/${s}.png?text=${r}`;
}, aS = p1(), Gd = () => {
  const e = lr() && window.location.hostname;
  return !!e && (kf.includes(e) || kf.some((t) => e.endsWith(t)));
}, yr = (e) => e && e.charAt(0).toUpperCase() + e.substring(1), lS = (e) => e.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (t, n) => (n ? "-" : "") + t.toLowerCase()), cS = () => {
}, uS = 240, Pr = (e) => typeof e < "u", Mt = (e) => typeof e == "string", dS = (e) => typeof e == "number";
function ct(e) {
  return typeof e == "function";
}
function ps(e) {
  return e && !Array.isArray(e) && typeof e == "object";
}
const pS = (e) => !e || Object.keys(e).length === 0, Gu = (e, t) => {
  const n = { ...e }, r = { ...t };
  for (const o in r) {
    const s = n[o], i = r[o];
    ps(s) && ps(i) ? n[o] = Gu(s, i) : n[o] = i;
  }
  return n;
}, Qo = (e, t) => {
  const n = (e || "").toLocaleLowerCase(), r = (t || "").toLocaleLowerCase();
  return n.includes(r);
}, fS = (e = "") => {
  const t = e[0] === "?" ? e.substring(1) : e, n = new URLSearchParams(t);
  return Object.fromEntries(n);
}, hS = (e = 16) => {
  let t = "";
  const n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", r = n.length;
  for (let o = 0; o < e; o++)
    t += n.charAt(Math.floor(Math.random() * r));
  return t;
}, Kd = (e) => (e || "").toLowerCase().trim().replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-._]+/g, "").replace(/--+/g, "-").trim();
var ha, gS = new Uint8Array(16);
function mS() {
  if (!ha && (ha = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !ha))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return ha(gS);
}
const vS = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function bS(e) {
  return typeof e == "string" && vS.test(e);
}
var At = [];
for (var Ac = 0; Ac < 256; ++Ac)
  At.push((Ac + 256).toString(16).substr(1));
function yS(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (At[e[t + 0]] + At[e[t + 1]] + At[e[t + 2]] + At[e[t + 3]] + "-" + At[e[t + 4]] + At[e[t + 5]] + "-" + At[e[t + 6]] + At[e[t + 7]] + "-" + At[e[t + 8]] + At[e[t + 9]] + "-" + At[e[t + 10]] + At[e[t + 11]] + At[e[t + 12]] + At[e[t + 13]] + At[e[t + 14]] + At[e[t + 15]]).toLowerCase();
  if (!bS(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
function f1(e, t, n) {
  e = e || {};
  var r = e.random || (e.rng || mS)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
    n = n || 0;
    for (var o = 0; o < 16; ++o)
      t[n + o] = r[o];
    return t;
  }
  return yS(r);
}
const qd = () => {
  const { baseApiUrl: e } = ts();
  return `${e}/assets/sdk`;
}, wS = (e) => `${qd()}/${e}`, SS = async (e, t, n) => {
  const r = await ar.get(qd(), {
    params: { projectId: t, identityId: n, d: window.location.hostname, licenseKey: e }
  });
  return ((r == null ? void 0 : r.result) ?? []).map(({ asset: o, cdnUrl: s }) => ({
    ...o,
    size: parseInt(o.size),
    src: s
  }));
}, xS = async (e, t, n, r) => {
  const o = await ar.post(qd(), {
    body: JSON.stringify({ fileMetadata: e, projectId: n, identityId: r }),
    params: { d: window.location.hostname, licenseKey: t }
  });
  return o == null ? void 0 : o.result;
}, CS = async (e, t) => await ar.put(t, {
  body: e,
  rawText: !0
}), PS = async (e, t, n, r) => Promise.all(
  e.map(
    (o) => xS(
      // don't send the whole file, just the metadata
      { name: o.name, size: o.size, type: o.type },
      t,
      n,
      r
    ).then(async (s) => {
      if (!s)
        throw new Error("No asset");
      const { asset: i, cdnUrl: a, uploadUrl: l } = s, u = await CS(o, l);
      if (u instanceof Error)
        throw console.error(u), new Error("Upload failed");
      return {
        ...i,
        size: parseInt(i.size),
        src: a
      };
    })
  )
), ES = async (e, t, n, r) => {
  const o = await ar.delete(wS(e), {
    body: JSON.stringify({ projectId: n, identityId: r }),
    params: { d: window.location.hostname, licenseKey: t }
  });
  return o == null ? void 0 : o.result;
}, Rf = async (e, t, n, r) => Promise.all(e.map((o) => ES(o.id || o.src, t, n, r)));
var me = /* @__PURE__ */ ((e) => (e.toastAdd = "studio:toastAdd", e.dialogOpen = "studio:dialogOpen", e.dialogClose = "studio:dialogClose", e.sidebarLeftSet = "studio:sidebarLeft:set", e.sidebarLeftGet = "studio:sidebarLeft:get", e.sidebarLeftToggle = "studio:sidebarLeft:toggle", e.sidebarRightSet = "studio:sidebarRight:set", e.sidebarRightGet = "studio:sidebarRight:get", e.sidebarRightToggle = "studio:sidebarRight:toggle", e.sidebarTopSet = "studio:sidebarTop:set", e.sidebarTopGet = "studio:sidebarTop:get", e.sidebarTopToggle = "studio:sidebarTop:toggle", e.sidebarBottomSet = "studio:sidebarBottom:set", e.sidebarBottomGet = "studio:sidebarBottom:get", e.sidebarBottomToggle = "studio:sidebarBottom:toggle", e.symbolAdd = "studio:symbolAdd", e.symbolDetach = "studio:symbolDetach", e.symbolOverride = "studio:symbolOverride", e.symbolPropagateStyles = "studio:propagateStyles", e.getPagesConfig = "studio:getPagesConfig", e.setPagesConfig = "studio:setPagesConfig", e.getPageSettings = "studio:getPageSettings", e.setPageSettings = "studio:setPageSettings", e.projectFiles = "studio:projectFiles", e.canvasReload = "studio:canvasReload", e.getBlocksPanel = "studio:getBlocksPanel", e.setBlocksPanel = "studio:setBlocksPanel", e.getStateContextMenu = "studio:getStateContextMenu", e.setStateContextMenu = "studio:setStateContextMenu", e.contextMenuComponent = "studio:contextMenuComponent", e.layoutAdd = "studio:layoutAdd", e.layoutRemove = "studio:layoutRemove", e.layoutToggle = "studio:layoutToggle", e.layoutUpdate = "studio:layoutUpdate", e.layoutGet = "studio:layoutGet", e.layoutConfigGet = "studio:layoutConfigGet", e.layoutConfigSet = "studio:layoutConfigSet", e.getStateTheme = "studio:getStateTheme", e.setStateTheme = "studio:setStateTheme", e.assetProviderGet = "studio:assetProviderGet", e.assetProviderAdd = "studio:assetProviderAdd", e.assetProviderRemove = "studio:assetProviderRemove", e.fontGet = "studio:fontGet", e.fontAdd = "studio:fontAdd", e.fontRemove = "studio:fontRemove", e))(me || {}), _r = /* @__PURE__ */ ((e) => (e.layoutToggleId = "studio:layoutToggle:", e.toggleBlocksPanel = "studio:toggleBlocksPanel", e.pageSettingsUpdate = "studio:pageSettingsUpdate", e))(_r || {});
const h1 = /* @__PURE__ */ new Set(), rn = /* @__PURE__ */ new WeakMap(), es = /* @__PURE__ */ new WeakMap(), Po = /* @__PURE__ */ new WeakMap(), Ku = /* @__PURE__ */ new WeakMap(), OS = /* @__PURE__ */ new WeakMap(), fs = /* @__PURE__ */ new WeakMap(), al = /* @__PURE__ */ new WeakMap();
let Xr;
const ho = "__aa_tgt", qu = "__aa_del", _S = (e) => {
  const t = MS(e);
  t && t.forEach((n) => $S(n));
}, TS = (e) => {
  e.forEach((t) => {
    t.target === Xr && LS(), rn.has(t.target) && Lo(t.target);
  });
};
function AS(e) {
  const t = Ku.get(e);
  t == null || t.disconnect();
  let n = rn.get(e), r = 0;
  const o = 5;
  n || (n = hs(e), rn.set(e, n));
  const { offsetWidth: s, offsetHeight: i } = Xr, l = [
    n.top - o,
    s - (n.left + o + n.width),
    i - (n.top + o + n.height),
    n.left - o
  ].map((d) => `${-1 * Math.floor(d)}px`).join(" "), u = new IntersectionObserver(() => {
    ++r > 1 && Lo(e);
  }, {
    root: Xr,
    threshold: 1,
    rootMargin: l
  });
  u.observe(e), Ku.set(e, u);
}
function Lo(e) {
  clearTimeout(al.get(e));
  const t = Hl(e), n = typeof t == "function" ? 500 : t.duration;
  al.set(e, setTimeout(() => {
    const r = Po.get(e);
    (!r || r.finished) && (rn.set(e, hs(e)), AS(e));
  }, n));
}
function LS() {
  clearTimeout(al.get(Xr)), al.set(Xr, setTimeout(() => {
    h1.forEach((e) => v1(e, (t) => g1(() => Lo(t))));
  }, 100));
}
function kS(e) {
  setTimeout(() => {
    OS.set(e, setInterval(() => g1(Lo.bind(null, e)), 2e3));
  }, Math.round(2e3 * Math.random()));
}
function g1(e) {
  typeof requestIdleCallback == "function" ? requestIdleCallback(() => e()) : requestAnimationFrame(() => e());
}
let Yu, Xo;
typeof window < "u" && (Xr = document.documentElement, Yu = new MutationObserver(_S), Xo = new ResizeObserver(TS), Xo.observe(Xr));
function MS(e) {
  return e.reduce((t, n) => {
    if (t === !1)
      return !1;
    if (n.target instanceof Element) {
      if (Lc(n.target), !t.has(n.target)) {
        t.add(n.target);
        for (let r = 0; r < n.target.children.length; r++) {
          const o = n.target.children.item(r);
          if (o) {
            if (qu in o)
              return !1;
            Lc(n.target, o), t.add(o);
          }
        }
      }
      if (n.removedNodes.length)
        for (let r = 0; r < n.removedNodes.length; r++) {
          const o = n.removedNodes[r];
          if (qu in o)
            return !1;
          o instanceof Element && (t.add(o), Lc(n.target, o), es.set(o, [
            n.previousSibling,
            n.nextSibling
          ]));
        }
    }
    return t;
  }, /* @__PURE__ */ new Set());
}
function Lc(e, t) {
  !t && !(ho in e) ? Object.defineProperty(e, ho, { value: e }) : t && !(ho in t) && Object.defineProperty(t, ho, { value: e });
}
function $S(e) {
  var t;
  const n = Xr.contains(e), r = rn.has(e);
  n && es.has(e) && es.delete(e), Po.has(e) && ((t = Po.get(e)) === null || t === void 0 || t.cancel()), r && n ? RS(e) : r && !n ? jS(e) : NS(e);
}
function Gn(e) {
  return Number(e.replace(/[^0-9.\-]/g, ""));
}
function hs(e) {
  const t = e.getBoundingClientRect();
  return {
    top: t.top + window.scrollY,
    left: t.left + window.scrollX,
    width: t.width,
    height: t.height
  };
}
function m1(e, t, n) {
  let r = t.width, o = t.height, s = n.width, i = n.height;
  const a = getComputedStyle(e);
  if (a.getPropertyValue("box-sizing") === "content-box") {
    const u = Gn(a.paddingTop) + Gn(a.paddingBottom) + Gn(a.borderTopWidth) + Gn(a.borderBottomWidth), d = Gn(a.paddingLeft) + Gn(a.paddingRight) + Gn(a.borderRightWidth) + Gn(a.borderLeftWidth);
    r -= d, s -= d, o -= u, i -= u;
  }
  return [r, s, o, i].map(Math.round);
}
function Hl(e) {
  return ho in e && fs.has(e[ho]) ? fs.get(e[ho]) : { duration: 250, easing: "ease-in-out" };
}
function v1(e, ...t) {
  t.forEach((n) => n(e, fs.has(e)));
  for (let n = 0; n < e.children.length; n++) {
    const r = e.children.item(n);
    r && t.forEach((o) => o(r, fs.has(r)));
  }
}
function RS(e) {
  const t = rn.get(e), n = hs(e);
  let r;
  if (!t)
    return;
  const o = Hl(e);
  if (typeof o != "function") {
    const s = t.left - n.left, i = t.top - n.top, [a, l, u, d] = m1(e, t, n), p = {
      transform: `translate(${s}px, ${i}px)`
    }, f = {
      transform: "translate(0, 0)"
    };
    a !== l && (p.width = `${a}px`, f.width = `${l}px`), u !== d && (p.height = `${u}px`, f.height = `${d}px`), r = e.animate([p, f], o);
  } else
    r = new Animation(o(e, "remain", t, n)), r.play();
  Po.set(e, r), rn.set(e, n), r.addEventListener("finish", Lo.bind(null, e));
}
function NS(e) {
  const t = hs(e);
  rn.set(e, t);
  const n = Hl(e);
  let r;
  typeof n != "function" ? r = e.animate([
    { transform: "scale(.98)", opacity: 0 },
    { transform: "scale(0.98)", opacity: 0, offset: 0.5 },
    { transform: "scale(1)", opacity: 1 }
  ], {
    duration: n.duration * 1.5,
    easing: "ease-in"
  }) : (r = new Animation(n(e, "add", t)), r.play()), Po.set(e, r), r.addEventListener("finish", Lo.bind(null, e));
}
function jS(e) {
  if (!es.has(e) || !rn.has(e))
    return;
  const [t, n] = es.get(e);
  Object.defineProperty(e, qu, { value: !0 }), n && n.parentNode && n.parentNode instanceof Element ? n.parentNode.insertBefore(e, n) : t && t.parentNode && t.parentNode.appendChild(e);
  const [r, o, s, i] = DS(e), a = Hl(e), l = rn.get(e);
  let u;
  Object.assign(e.style, {
    position: "absolute",
    top: `${r}px`,
    left: `${o}px`,
    width: `${s}px`,
    height: `${i}px`,
    margin: 0,
    pointerEvents: "none",
    transformOrigin: "center",
    zIndex: 100
  }), typeof a != "function" ? u = e.animate([
    {
      transform: "scale(1)",
      opacity: 1
    },
    {
      transform: "scale(.98)",
      opacity: 0
    }
  ], { duration: a.duration, easing: "ease-out" }) : (u = new Animation(a(e, "remove", l)), u.play()), Po.set(e, u), u.addEventListener("finish", () => {
    var d;
    e.remove(), rn.delete(e), es.delete(e), Po.delete(e), (d = Ku.get(e)) === null || d === void 0 || d.disconnect();
  });
}
function DS(e) {
  const t = rn.get(e), [n, , r] = m1(e, t, hs(e));
  let o = e.parentElement;
  for (; o && (getComputedStyle(o).position === "static" || o instanceof HTMLBodyElement); )
    o = o.parentElement;
  o || (o = document.body);
  const s = getComputedStyle(o), i = rn.get(o) || hs(o), a = Math.round(t.top - i.top) - Gn(s.borderTopWidth), l = Math.round(t.left - i.left) - Gn(s.borderLeftWidth);
  return [a, l, n, r];
}
function IS(e, t = {}) {
  Yu && Xo && (getComputedStyle(e).position === "static" && Object.assign(e.style, { position: "relative" }), v1(e, Lo, kS, (n) => Xo == null ? void 0 : Xo.observe(n)), typeof t == "function" ? fs.set(e, t) : fs.set(e, { duration: 250, easing: "ease-in-out", ...t }), Yu.observe(e, { childList: !0 }), h1.add(e));
}
function VS(e) {
  const t = K(null);
  return G(() => {
    t.current instanceof HTMLElement && IS(t.current, e);
  }, [t]), t;
}
if (!W)
  throw new Error("mobx-react-lite requires React with Hooks support");
if (!Rw)
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
function HS(e) {
  e();
}
function BS(e) {
  e || (e = HS), Ew({ reactionScheduler: e });
}
function zS(e) {
  return Ow(e);
}
var FS = 1e4, US = 1e4, WS = (
  /** @class */
  function() {
    function e(t) {
      var n = this;
      Object.defineProperty(this, "finalize", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }), Object.defineProperty(this, "registrations", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: /* @__PURE__ */ new Map()
      }), Object.defineProperty(this, "sweepTimeout", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, "sweep", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(r) {
          r === void 0 && (r = FS), clearTimeout(n.sweepTimeout), n.sweepTimeout = void 0;
          var o = Date.now();
          n.registrations.forEach(function(s, i) {
            o - s.registeredAt >= r && (n.finalize(s.value), n.registrations.delete(i));
          }), n.registrations.size > 0 && n.scheduleSweep();
        }
      }), Object.defineProperty(this, "finalizeAllImmediately", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function() {
          n.sweep(0);
        }
      });
    }
    return Object.defineProperty(e.prototype, "register", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(t, n, r) {
        this.registrations.set(r, {
          value: n,
          registeredAt: Date.now()
        }), this.scheduleSweep();
      }
    }), Object.defineProperty(e.prototype, "unregister", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(t) {
        this.registrations.delete(t);
      }
    }), Object.defineProperty(e.prototype, "scheduleSweep", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, US));
      }
    }), e;
  }()
), GS = typeof FinalizationRegistry < "u" ? FinalizationRegistry : WS, Xu = new GS(function(e) {
  var t;
  (t = e.reaction) === null || t === void 0 || t.dispose(), e.reaction = null;
});
function Yd(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var b1 = { exports: {} }, kc = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nf;
function KS() {
  if (Nf)
    return kc;
  Nf = 1;
  var e = H;
  function t(p, f) {
    return p === f && (p !== 0 || 1 / p === 1 / f) || p !== p && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, s = e.useLayoutEffect, i = e.useDebugValue;
  function a(p, f) {
    var h = f(), g = r({ inst: { value: h, getSnapshot: f } }), m = g[0].inst, v = g[1];
    return s(function() {
      m.value = h, m.getSnapshot = f, l(m) && v({ inst: m });
    }, [p, h, f]), o(function() {
      return l(m) && v({ inst: m }), p(function() {
        l(m) && v({ inst: m });
      });
    }, [p]), i(h), h;
  }
  function l(p) {
    var f = p.getSnapshot;
    p = p.value;
    try {
      var h = f();
      return !n(p, h);
    } catch {
      return !0;
    }
  }
  function u(p, f) {
    return f();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : a;
  return kc.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : d, kc;
}
b1.exports = KS();
var qS = b1.exports;
function jf(e) {
  e.reaction = new sr("observer".concat(e.name), function() {
    var t;
    e.stateVersion = Symbol(), (t = e.onStoreChange) === null || t === void 0 || t.call(e);
  });
}
function YS(e, t) {
  t === void 0 && (t = "observed");
  var n = H.useRef(null);
  if (!n.current) {
    var r = {
      reaction: null,
      onStoreChange: null,
      stateVersion: Symbol(),
      name: t,
      subscribe: function(a) {
        return Xu.unregister(r), r.onStoreChange = a, r.reaction || (jf(r), r.stateVersion = Symbol()), function() {
          var l;
          r.onStoreChange = null, (l = r.reaction) === null || l === void 0 || l.dispose(), r.reaction = null;
        };
      },
      getSnapshot: function() {
        return r.stateVersion;
      }
    };
    n.current = r;
  }
  var o = n.current;
  o.reaction || (jf(o), Xu.register(n, o, o)), H.useDebugValue(o.reaction, zS), qS.useSyncExternalStore(
    // Both of these must be stable, otherwise it would keep resubscribing every render.
    o.subscribe,
    o.getSnapshot,
    o.getSnapshot
  );
  var s, i;
  if (o.reaction.track(function() {
    try {
      s = e();
    } catch (a) {
      i = a;
    }
  }), i)
    throw i;
  return s;
}
var Mc, $c, y1 = typeof Symbol == "function" && Symbol.for, XS = ($c = (Mc = Object.getOwnPropertyDescriptor(function() {
}, "name")) === null || Mc === void 0 ? void 0 : Mc.configurable) !== null && $c !== void 0 ? $c : !1, Df = y1 ? Symbol.for("react.forward_ref") : typeof Rt == "function" && Rt(function(e) {
  return null;
}).$$typeof, If = y1 ? Symbol.for("react.memo") : typeof we == "function" && we(function(e) {
  return null;
}).$$typeof;
function ue(e, t) {
  var n;
  if (If && e.$$typeof === If)
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  var r = (n = t == null ? void 0 : t.forwardRef) !== null && n !== void 0 ? n : !1, o = e, s = e.displayName || e.name;
  if (Df && e.$$typeof === Df && (r = !0, o = e.render, typeof o != "function"))
    throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
  var i = function(a, l) {
    return YS(function() {
      return o(a, l);
    }, s);
  };
  return i.displayName = e.displayName, XS && Object.defineProperty(i, "name", {
    value: e.name,
    writable: !0,
    configurable: !0
  }), e.contextTypes && (i.contextTypes = e.contextTypes), r && (i = Rt(i)), i = we(i), JS(e, i), i;
}
var ZS = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0,
  // Don't redefine `displayName`,
  // it's defined as getter-setter pair on `memo` (see #3192).
  displayName: !0
};
function JS(e, t) {
  Object.keys(e).forEach(function(n) {
    ZS[n] || Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
  });
}
var Rc;
BS(Js);
Rc = Xu.finalizeAllImmediately;
const F = $;
function $(...e) {
  return (Array.isArray(e[0]) ? e[0] : [...e]).filter(Boolean).flatMap((o) => typeof o == "string" ? o.split(" ").map((s) => {
    if (s = s.replace(/gjs-/g, "gs-utl-"), !s.includes("gs-utl-") && !s.startsWith("gs-")) {
      const i = s.split(":"), a = i.pop(), l = i.join(":"), u = a == null ? void 0 : a.startsWith("!"), p = `gs-utl-${u ? a == null ? void 0 : a.slice(1) : a}`, f = u ? `!${p}` : p;
      return l ? `${l}:${f}` : f;
    }
    return s;
  }) : o).join(" ");
}
var QS = "M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2M11 7H13V13H11V7M11 15H13V17H11V15Z", ex = "M11 2H13V7H21V10H13V14H18V17H13V22H11V17H6V14H11V10H3V7H11V2Z", tx = "M4 22H2V2H4V22M22 7H6V10H22V7M16 14H6V17H16V14Z", nx = "M20 2H22V22H20V2M2 10H18V7H2V10M8 17H18V14H8V17Z", rx = "M9.5,8.5L11,10L8,13L11,16L9.5,17.5L5,13L9.5,8.5M14.5,17.5L13,16L16,13L13,10L14.5,8.5L19,13L14.5,17.5M21,2H3A2,2 0 0,0 1,4V20A2,2 0 0,0 3,22H21A2,2 0 0,0 23,20V4A2,2 0 0,0 21,2M21,20H3V6H21V20Z", ox = "M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z", sx = "M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z", ix = "M20 13.5C20 17.09 17.09 20 13.5 20H6V18H13.5C16 18 18 16 18 13.5S16 9 13.5 9H7.83L10.91 12.09L9.5 13.5L4 8L9.5 2.5L10.92 3.91L7.83 7H13.5C17.09 7 20 9.91 20 13.5Z", ax = "M10.5 18H18V20H10.5C6.91 20 4 17.09 4 13.5S6.91 7 10.5 7H16.17L13.08 3.91L14.5 2.5L20 8L14.5 13.5L13.09 12.09L16.17 9H10.5C8 9 6 11 6 13.5S8 18 10.5 18Z", lx = "M3,21V3H21V21H3M5,5V19H19V5H5Z", cx = "M3 16C3 18.8 5.2 21 8 21H10V19H8C6.3 19 5 17.7 5 16V14H3V16M21 8C21 5.2 18.8 3 16 3H14V5H16C17.7 5 19 6.3 19 8V10H21V8M16 21C18.8 21 21 18.8 21 16V14H19V16C19 17.7 17.7 19 16 19H14V21H16M8 3C5.2 3 3 5.2 3 8V10H5V8C5 6.3 6.3 5 8 5H10V3H8Z", ux = "M15,21H17V19H15M19,21H21V19H19M7,21H9V19H7M11,21H13V19H11M19,17H21V15H19M19,13H21V11H19M3,3V21H5V5H21V3M19,9H21V7H19", dx = "M22,17H18V10H22M23,8H17A1,1 0 0,0 16,9V19A1,1 0 0,0 17,20H23A1,1 0 0,0 24,19V9A1,1 0 0,0 23,8M4,6H22V4H4A2,2 0 0,0 2,6V17H0V20H14V17H4V6Z", px = "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z", fx = "M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z", hx = "M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z", gx = "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z", mx = "M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z", vx = "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z", bx = "M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z", yx = "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z", wx = "M8,3A2,2 0 0,0 6,5V9A2,2 0 0,1 4,11H3V13H4A2,2 0 0,1 6,15V19A2,2 0 0,0 8,21H10V19H8V14A2,2 0 0,0 6,12A2,2 0 0,0 8,10V5H10V3M16,3A2,2 0 0,1 18,5V9A2,2 0 0,0 20,11H21V13H20A2,2 0 0,0 18,15V19A2,2 0 0,1 16,21H14V19H16V14A2,2 0 0,1 18,12A2,2 0 0,1 16,10V5H14V3H16Z", Sx = "M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z", xx = "M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z", Cx = "M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z", Px = "M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z", Ex = "M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z", Ox = "M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z", _x = "M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6M20 6L12 11L4 6H20M20 18H4V8L12 13L20 8V18Z", Tx = "M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z", Ax = "M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z", Lx = "M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z", kx = "M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z", Mx = "M6.92,19L5,17.08L13.06,9L15,10.94M20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L13.84,6.41L11.91,4.5L10.5,5.91L11.92,7.33L3,16.25V21H7.75L16.67,12.08L18.09,13.5L19.5,12.09L17.58,10.17L20.7,7.05C21.1,6.65 21.1,6 20.71,5.63Z", $x = "M17.66 11.2C17.43 10.9 17.15 10.64 16.89 10.38C16.22 9.78 15.46 9.35 14.82 8.72C13.33 7.26 13 4.85 13.95 3C13 3.23 12.17 3.75 11.46 4.32C8.87 6.4 7.85 10.07 9.07 13.22C9.11 13.32 9.15 13.42 9.15 13.55C9.15 13.77 9 13.97 8.8 14.05C8.57 14.15 8.33 14.09 8.14 13.93C8.08 13.88 8.04 13.83 8 13.76C6.87 12.33 6.69 10.28 7.45 8.64C5.78 10 4.87 12.3 5 14.47C5.06 14.97 5.12 15.47 5.29 15.97C5.43 16.57 5.7 17.17 6 17.7C7.08 19.43 8.95 20.67 10.96 20.92C13.1 21.19 15.39 20.8 17.03 19.32C18.86 17.66 19.5 15 18.56 12.72L18.43 12.46C18.22 12 17.66 11.2 17.66 11.2M14.5 17.5C14.22 17.74 13.76 18 13.4 18.1C12.28 18.5 11.16 17.94 10.5 17.28C11.69 17 12.4 16.12 12.61 15.23C12.78 14.43 12.46 13.77 12.33 13C12.21 12.26 12.23 11.63 12.5 10.94C12.69 11.32 12.89 11.7 13.13 12C13.9 13 15.11 13.44 15.37 14.8C15.41 14.94 15.43 15.08 15.43 15.23C15.46 16.05 15.1 16.95 14.5 17.5H14.5Z", Rx = "M7,11H1V13H7V11M9.17,7.76L7.05,5.64L5.64,7.05L7.76,9.17L9.17,7.76M13,1H11V7H13V1M18.36,7.05L16.95,5.64L14.83,7.76L16.24,9.17L18.36,7.05M17,11V13H23V11H17M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M14.83,16.24L16.95,18.36L18.36,16.95L16.24,14.83L14.83,16.24M5.64,16.95L7.05,18.36L9.17,16.24L7.76,14.83L5.64,16.95M11,23H13V17H11V23Z", Nx = "M5,3A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5.5L18.5,3H17V9A1,1 0 0,1 16,10H8A1,1 0 0,1 7,9V3H5M12,4V9H15V4H12M7,12H17A1,1 0 0,1 18,13V19H6V13A1,1 0 0,1 7,12Z", jx = "M10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z", Dx = "M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z", Ix = "M11,9H13V11H11V9M9,11H11V13H9V11M13,11H15V13H13V11M15,9H17V11H15V9M7,9H9V11H7V9M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M9,18H7V16H9V18M13,18H11V16H13V18M17,18H15V16H17V18M19,11H17V13H19V15H17V13H15V15H13V13H11V15H9V13H7V15H5V13H7V11H5V5H19V11Z", Vx = "M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7A2,2 0 0,0 10,9H8A4,4 0 0,1 12,5A4,4 0 0,1 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z", Hx = "M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z", Bx = "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z", zx = "M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z", Fx = "M12,16L19.36,10.27L21,9L12,2L3,9L4.63,10.27M12,18.54L4.62,12.81L3,14.07L12,21.07L21,14.07L19.37,12.8L12,18.54Z", Ux = "M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z", Wx = "M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z", Gx = "M12,17A2,2 0 0,0 14,15C14,13.89 13.1,13 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V10C4,8.89 4.9,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z", Kx = "M18 1C15.24 1 13 3.24 13 6V8H4C2.9 8 2 8.89 2 10V20C2 21.11 2.9 22 4 22H16C17.11 22 18 21.11 18 20V10C18 8.9 17.11 8 16 8H15V6C15 4.34 16.34 3 18 3C19.66 3 21 4.34 21 6V8H23V6C23 3.24 20.76 1 18 1M10 13C11.1 13 12 13.89 12 15C12 16.11 11.11 17 10 17C8.9 17 8 16.11 8 15C8 13.9 8.9 13 10 13Z", qx = "M7,10L12,15L17,10H7Z", Yx = "M20 5L20 19L4 19L4 5H20M20 3H4C2.89 3 2 3.89 2 5V19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V5C22 3.89 21.11 3 20 3M18 15H6V17H18V15M10 7H6V13H10V7M12 9H18V7H12V9M18 11H12V13H18V11Z", Xx = "M2.53,19.65L3.87,20.21V11.18L1.44,17.04C1.03,18.06 1.5,19.23 2.53,19.65M22.03,15.95L17.07,4C16.76,3.23 16.03,2.77 15.26,2.75C15,2.75 14.73,2.79 14.47,2.9L7.1,5.95C6.35,6.26 5.89,7 5.87,7.75C5.86,8 5.91,8.29 6,8.55L11,20.5C11.29,21.28 12.03,21.74 12.81,21.75C13.07,21.75 13.33,21.7 13.58,21.6L20.94,18.55C21.96,18.13 22.45,16.96 22.03,15.95M7.88,8.75A1,1 0 0,1 6.88,7.75A1,1 0 0,1 7.88,6.75C8.43,6.75 8.88,7.2 8.88,7.75C8.88,8.3 8.43,8.75 7.88,8.75M5.88,19.75A2,2 0 0,0 7.88,21.75H9.33L5.88,13.41V19.75Z", Zx = "M12,2.5L8,7H16L12,2.5M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M8,17L12,21.5L16,17H8Z", Jx = "M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z", Qx = "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z", e2 = "M17,13H13V17H11V13H7V11H11V7H13V11H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z", t2 = "M16,7V3H14V7H10V3H8V7H8C7,7 6,8 6,9V14.5L9.5,18V21H14.5V18L18,14.5V9C18,8 17,7 16,7Z", n2 = "M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z", r2 = "M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2M12 4L20 12L12 20L4 12Z", o2 = "M5.5,7A1.5,1.5 0 0,1 4,5.5A1.5,1.5 0 0,1 5.5,4A1.5,1.5 0 0,1 7,5.5A1.5,1.5 0 0,1 5.5,7M21.41,11.58L12.41,2.58C12.05,2.22 11.55,2 11,2H4C2.89,2 2,2.89 2,4V11C2,11.55 2.22,12.05 2.59,12.41L11.58,21.41C11.95,21.77 12.45,22 13,22C13.55,22 14.05,21.77 14.41,21.41L21.41,14.41C21.78,14.05 22,13.55 22,13C22,12.44 21.77,11.94 21.41,11.58Z", s2 = "M11,2V4.07C7.38,4.53 4.53,7.38 4.07,11H2V13H4.07C4.53,16.62 7.38,19.47 11,19.93V22H13V19.93C16.62,19.47 19.47,16.62 19.93,13H22V11H19.93C19.47,7.38 16.62,4.53 13,4.07V2M11,6.08V8H13V6.09C15.5,6.5 17.5,8.5 17.92,11H16V13H17.91C17.5,15.5 15.5,17.5 13,17.92V16H11V17.91C8.5,17.5 6.5,15.5 6.08,13H8V11H6.09C6.5,8.5 8.5,6.5 11,6.08M12,11A1,1 0 0,0 11,12A1,1 0 0,0 12,13A1,1 0 0,0 13,12A1,1 0 0,0 12,11Z", i2 = "M22.08,11.04H20.08V4H13.05V2H11.04V4H4V11.04H2V13.05H4V20.08H11.04V22.08H13.05V20.08H20.08V13.05H22.08V11.04M18.07,18.07H13.05V16.06H11.04V18.07H6V13.05H8.03V11.04H6V6H11.04V8.03H13.05V6H18.07V11.04H16.06V13.05H18.07V18.07M13.05,12.05A1,1 0 0,1 12.05,13.05C11.5,13.05 11.04,12.6 11.04,12.05C11.04,11.5 11.5,11.04 12.05,11.04C12.6,11.04 13.05,11.5 13.05,12.05Z", a2 = "M16,15H9V13H16M19,11H9V9H19M19,7H9V5H19M21,1H7C5.89,1 5,1.89 5,3V17C5,18.11 5.9,19 7,19H21C22.11,19 23,18.11 23,17V3C23,1.89 22.1,1 21,1M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3Z", l2 = "M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 15L17.55 9.54L16.13 8.13L13 11.25V2H11V11.25L7.88 8.13L6.46 9.55L12 15Z", c2 = "M16.59,5.41L15.17,4L12,7.17L8.83,4L7.41,5.41L12,10M7.41,18.59L8.83,20L12,16.83L15.17,20L16.58,18.59L12,14L7.41,18.59Z", u2 = "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z", d2 = "M21 18H2V20H21V18M19 10V14H4V10H19M20 8H3C2.45 8 2 8.45 2 9V15C2 15.55 2.45 16 3 16H20C20.55 16 21 15.55 21 15V9C21 8.45 20.55 8 20 8M21 4H2V6H21V4Z", p2 = "M13 3V11H21V3H13M3 21H11V13H3V21M3 3V11H11V3H3M13 16H16V13H18V16H21V18H18V21H16V18H13V16Z", f2 = "M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z", h2 = "M12.89,3L14.85,3.4L11.11,21L9.15,20.6L12.89,3M19.59,12L16,8.41V5.58L22.42,12L16,18.41V15.58L19.59,12M1.58,12L8,5.58V8.41L4.41,12L8,15.58V18.41L1.58,12Z";
const I = H.forwardRef(function({ as: t, children: n, className: r, col: o, revert: s, full: i, nowrap: a, space: l, justify: u, items: d, ...p }, f) {
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    /* @__PURE__ */ c(
      t || "div",
      {
        ref: f,
        className: $([
          "gs-utl-flex",
          r,
          o && !s && "gs-utl-flex-col",
          o && s && "gs-utl-flex-col-reverse",
          !o && s && "gs-utl-flex-row-reverse",
          i && !o && "gs-utl-w-full",
          i && o && "gs-utl-h-full",
          a ? "gs-utl-flex-nowrap" : "gs-utl-flex-wrap",
          l === "x2s" && (o ? "gs-utl-space-y-0.5" : "gs-utl-space-x-0.5"),
          l === "xs" && (o ? "gs-utl-space-y-1" : "gs-utl-space-x-1"),
          l === "s" && (o ? "gs-utl-space-y-2" : "gs-utl-space-x-2"),
          l === "m" && (o ? "gs-utl-space-y-4" : "gs-utl-space-x-4"),
          l === "l" && (o ? "gs-utl-space-y-6" : "gs-utl-space-x-6"),
          l === "xl" && (o ? "gs-utl-space-y-8" : "gs-utl-space-x-8"),
          // Items
          d === "start" && "gs-utl-items-start",
          d === "end" && "gs-utl-items-end",
          d === "center" && "gs-utl-items-center",
          // Justify
          u === "start" && "gs-utl-justify-start",
          u === "end" && "gs-utl-justify-end",
          u === "center" && "gs-utl-justify-center",
          u === "between" && "gs-utl-justify-between"
        ]),
        ...p,
        children: n
      }
    )
  );
}), N = H.forwardRef(function({ children: t, className: n, grow: r, ...o }, s) {
  return /* @__PURE__ */ c("div", { ref: s, className: $([n, r && "flex-1"]), ...o, children: t });
});
var Nc = { exports: {} }, jc, Vf;
function g2() {
  if (Vf)
    return jc;
  Vf = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return jc = e, jc;
}
var Dc, Hf;
function m2() {
  if (Hf)
    return Dc;
  Hf = 1;
  var e = g2();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Dc = function() {
    function r(i, a, l, u, d, p) {
      if (p !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return s.PropTypes = s, s;
  }, Dc;
}
var Bf;
function v2() {
  return Bf || (Bf = 1, Nc.exports = m2()()), Nc.exports;
}
var b2 = function(e) {
  var t = {};
  function n(r) {
    if (t[r])
      return t[r].exports;
    var o = t[r] = { i: r, l: !1, exports: {} };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }
  return n.m = e, n.c = t, n.d = function(r, o, s) {
    n.o(r, o) || Object.defineProperty(r, o, { enumerable: !0, get: s });
  }, n.r = function(r) {
    typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(r, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(r, "__esModule", { value: !0 });
  }, n.t = function(r, o) {
    if (1 & o && (r = n(r)), 8 & o || 4 & o && typeof r == "object" && r && r.__esModule)
      return r;
    var s = /* @__PURE__ */ Object.create(null);
    if (n.r(s), Object.defineProperty(s, "default", { enumerable: !0, value: r }), 2 & o && typeof r != "string")
      for (var i in r)
        n.d(s, i, (function(a) {
          return r[a];
        }).bind(null, i));
    return s;
  }, n.n = function(r) {
    var o = r && r.__esModule ? function() {
      return r.default;
    } : function() {
      return r;
    };
    return n.d(o, "a", o), o;
  }, n.o = function(r, o) {
    return Object.prototype.hasOwnProperty.call(r, o);
  }, n.p = "", n(n.s = 2);
}([function(e, t) {
  e.exports = v2();
}, function(e, t) {
  e.exports = H;
}, function(e, t, n) {
  n.r(t);
  var r = n(1), o = n(0), s = function() {
    return (s = Object.assign || function(g) {
      for (var m, v = 1, b = arguments.length; v < b; v++)
        for (var y in m = arguments[v])
          Object.prototype.hasOwnProperty.call(m, y) && (g[y] = m[y]);
      return g;
    }).apply(this, arguments);
  }, i = function(g, m) {
    var v = {};
    for (var b in g)
      Object.prototype.hasOwnProperty.call(g, b) && m.indexOf(b) < 0 && (v[b] = g[b]);
    if (g != null && typeof Object.getOwnPropertySymbols == "function") {
      var y = 0;
      for (b = Object.getOwnPropertySymbols(g); y < b.length; y++)
        m.indexOf(b[y]) < 0 && Object.prototype.propertyIsEnumerable.call(g, b[y]) && (v[b[y]] = g[b[y]]);
    }
    return v;
  }, a = 0, l = r.forwardRef(function(g, m) {
    var v = g.title, b = v === void 0 ? null : v, y = g.description, w = y === void 0 ? null : y, S = g.size, x = S === void 0 ? null : S, C = g.color, P = C === void 0 ? "currentColor" : C, _ = g.horizontal, O = _ === void 0 ? null : _, E = g.vertical, T = E === void 0 ? null : E, R = g.rotate, B = R === void 0 ? null : R, U = g.spin, L = U === void 0 ? null : U, M = g.style, D = M === void 0 ? {} : M, V = g.children, k = i(g, ["title", "description", "size", "color", "horizontal", "vertical", "rotate", "spin", "style", "children"]);
    a++;
    var j, Y = L !== null && L, J = r.Children.map(V, function(ge) {
      var X = ge;
      Y !== !0 && (Y = (L === null ? X.props.spin : L) === !0);
      var Z = X.props.size;
      typeof x == "number" && typeof X.props.size == "number" && (Z = X.props.size / x);
      var te = { size: Z, color: P === null ? X.props.color : P, horizontal: O === null ? X.props.horizontal : O, vertical: T === null ? X.props.vertical : T, rotate: B === null ? X.props.rotate : B, spin: L === null ? X.props.spin : L, inStack: !0 };
      return r.cloneElement(X, te);
    });
    x !== null && (D.width = typeof x == "string" ? x : 1.5 * x + "rem");
    var le, Q = "stack_labelledby_" + a, re = "stack_describedby_" + a;
    if (b)
      j = w ? Q + " " + re : Q;
    else if (le = "presentation", w)
      throw new Error("title attribute required when description is set");
    return r.createElement("svg", s({ ref: m, viewBox: "0 0 24 24", style: D, role: le, "aria-labelledby": j }, k), b && r.createElement("title", { id: Q }, b), w && r.createElement("desc", { id: re }, w), Y && r.createElement("style", null, "@keyframes spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }", "@keyframes spin-inverse { from { transform: rotate(0deg) } to { transform: rotate(-360deg) } }"), J);
  });
  l.displayName = "Stack", l.propTypes = { size: o.oneOfType([o.number, o.string]), color: o.string, horizontal: o.bool, vertical: o.bool, rotate: o.number, spin: o.oneOfType([o.bool, o.number]), children: o.oneOfType([o.arrayOf(o.node), o.node]).isRequired, className: o.string, style: o.object }, l.defaultProps = { size: null, color: null, horizontal: null, vertical: null, rotate: null, spin: null };
  var u = l;
  n.d(t, "Icon", function() {
    return h;
  }), n.d(t, "Stack", function() {
    return u;
  });
  var d = function() {
    return (d = Object.assign || function(g) {
      for (var m, v = 1, b = arguments.length; v < b; v++)
        for (var y in m = arguments[v])
          Object.prototype.hasOwnProperty.call(m, y) && (g[y] = m[y]);
      return g;
    }).apply(this, arguments);
  }, p = function(g, m) {
    var v = {};
    for (var b in g)
      Object.prototype.hasOwnProperty.call(g, b) && m.indexOf(b) < 0 && (v[b] = g[b]);
    if (g != null && typeof Object.getOwnPropertySymbols == "function") {
      var y = 0;
      for (b = Object.getOwnPropertySymbols(g); y < b.length; y++)
        m.indexOf(b[y]) < 0 && Object.prototype.propertyIsEnumerable.call(g, b[y]) && (v[b[y]] = g[b[y]]);
    }
    return v;
  }, f = 0, h = r.forwardRef(function(g, m) {
    var v = g.path, b = g.id, y = b === void 0 ? ++f : b, w = g.title, S = w === void 0 ? null : w, x = g.description, C = x === void 0 ? null : x, P = g.size, _ = P === void 0 ? null : P, O = g.color, E = O === void 0 ? "currentColor" : O, T = g.horizontal, R = T !== void 0 && T, B = g.vertical, U = B !== void 0 && B, L = g.rotate, M = L === void 0 ? 0 : L, D = g.spin, V = D !== void 0 && D, k = g.style, j = k === void 0 ? {} : k, Y = g.inStack, J = Y !== void 0 && Y, le = p(g, ["path", "id", "title", "description", "size", "color", "horizontal", "vertical", "rotate", "spin", "style", "inStack"]), Q = {}, re = [];
    _ !== null && (J ? re.push("scale(" + _ + ")") : (j.width = typeof _ == "string" ? _ : 1.5 * _ + "rem", j.height = j.width)), R && re.push("scaleX(-1)"), U && re.push("scaleY(-1)"), M !== 0 && re.push("rotate(" + M + "deg)"), E !== null && (Q.fill = E);
    var ge = r.createElement("path", d({ d: v, style: Q }, J ? le : {})), X = ge;
    re.length > 0 && (j.transform = re.join(" "), j.transformOrigin = "center", J && (X = r.createElement("g", { style: j }, ge, r.createElement("rect", { width: "24", height: "24", fill: "transparent" }))));
    var Z, te = X, de = V === !0 || typeof V != "number" ? 2 : V, ce = !J && (R || U);
    if (de < 0 && (ce = !ce), V && (te = r.createElement("g", { style: { animation: "spin" + (ce ? "-inverse" : "") + " linear " + Math.abs(de) + "s infinite", transformOrigin: "center" } }, X, !(R || U || M !== 0) && r.createElement("rect", { width: "24", height: "24", fill: "transparent" }))), J)
      return te;
    var Ce, Pe = "icon_labelledby_" + y, at = "icon_describedby_" + y;
    if (S)
      Z = C ? Pe + " " + at : Pe;
    else if (Ce = "presentation", C)
      throw new Error("title attribute required when description is set");
    return r.createElement("svg", d({ ref: m, viewBox: "0 0 24 24", style: j, role: Ce, "aria-labelledby": Z }, le), S && r.createElement("title", { id: Pe }, S), C && r.createElement("desc", { id: at }, C), !J && V && (ce ? r.createElement("style", null, "@keyframes spin-inverse { from { transform: rotate(0deg) } to { transform: rotate(-360deg) } }") : r.createElement("style", null, "@keyframes spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }")), te);
  });
  h.displayName = "Icon", h.propTypes = { path: o.string.isRequired, size: o.oneOfType([o.number, o.string]), color: o.string, horizontal: o.bool, vertical: o.bool, rotate: o.number, spin: o.oneOfType([o.bool, o.number]), style: o.object, inStack: o.bool, className: o.string }, h.defaultProps = { size: null, color: "currentColor", horizontal: !1, vertical: !1, rotate: 0, spin: !1 }, t.default = h;
}]);
const y2 = /* @__PURE__ */ Yd(b2);
var w1 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var s = "", i = 0; i < arguments.length; i++) {
        var a = arguments[i];
        a && (s = o(s, r(a)));
      }
      return s;
    }
    function r(s) {
      if (typeof s == "string" || typeof s == "number")
        return s;
      if (typeof s != "object")
        return "";
      if (Array.isArray(s))
        return n.apply(null, s);
      if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]"))
        return s.toString();
      var i = "";
      for (var a in s)
        t.call(s, a) && s[a] && (i = o(i, a));
      return i;
    }
    function o(s, i) {
      return i ? s ? s + " " + i : s + i : s;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(w1);
var w2 = w1.exports;
const q = /* @__PURE__ */ Yd(w2), zf = /* @__PURE__ */ new Map(), Xd = H.forwardRef(function({ svg: t, iconSize: n, ...r }, o) {
  let s = zf.get(t);
  return s || (s = sS(t, n), zf.set(t, s)), /* @__PURE__ */ c("div", { ...r, ref: o, dangerouslySetInnerHTML: { __html: s } });
});
var ne = /* @__PURE__ */ ((e) => (e.alertRhombus = "alertRhombus", e.alignHorizontalCenter = "alignHorizontalCenter", e.alignHorizontalLeft = "alignHorizontalLeft", e.alignHorizontalRight = "alignHorizontalRight", e.applicationBracketsOutline = "applicationBracketsOutline", e.arrowDown = "arrowDown", e.arrowRight = "arrowRight", e.arrowULeftTop = "arrowULeftTop", e.arrowURightTop = "arrowURightTop", e.borderAllVariant = "borderAllVariant", e.borderRadius = "borderRadius", e.borderStyle = "borderStyle", e.cellphoneLink = "cellphoneLink", e.check = "check", e.checkBold = "checkBold", e.checkboxBlank = "checkboxBlank", e.chevronUp = "chevronUp", e.chevronDown = "chevronDown", e.chevronLeft = "chevronLeft", e.chevronRight = "chevronRight", e.close = "close", e.codeBraces = "codeBraces", e.cog = "cog", e.contentCopy = "contentCopy", e.contentSave = "contentSave", e.delete = "delete", e.dotsVertical = "dotsVertical", e.email = "email", e.emailOutline = "emailOutline", e.eye = "eye", e.eyedropperVariant = "eyedropperVariant", e.eyeOff = "eyeOff", e.eyeOffOutline = "eyeOffOutline", e.eyeOutline = "eyeOutline", e.fire = "fire", e.flare = "flare", e.floppy = "floppy", e.folder = "folder", e.fullscreen = "fullscreen", e.gradientVertical = "gradientVertical", e.helpCircle = "helpCircle", e.image = "image", e.information = "information", e.informationVariant = "informationVariant", e.layers = "layers", e.link = "link", e.lock = "lock", e.lockOpenVariant = "lockOpenVariant", e.menuDown = "menuDown", e.newspaperVariantOutline = "newspaperVariantOutline", e.paletteSwatch = "paletteSwatch", e.panVertical = "panVertical", e.phone = "phone", e.plus = "plus", e.plusBox = "plusBox", e.powerPlug = "powerPlug", e.refresh = "refresh", e.rhombusOutline = "rhombusOutline", e.tag = "tag", e.target = "target", e.targetVariant = "targetVariant", e.textBoxMultiple = "textBoxMultiple", e.trayArrowDown = "trayArrowDown", e.unfoldLessHorizontal = "unfoldLessHorizontal", e.unfoldMoreHorizontal = "unfoldMoreHorizontal", e.viewDayOutline = "viewDayOutline", e.viewGridPlus = "viewGridPlus", e.web = "web", e.xml = "xml", e))(ne || {});
const Ic = {
  alertRhombus: QS,
  alignHorizontalCenter: ex,
  alignHorizontalLeft: tx,
  alignHorizontalRight: nx,
  applicationBracketsOutline: rx,
  arrowDown: ox,
  arrowRight: sx,
  arrowULeftTop: ix,
  arrowURightTop: ax,
  borderAllVariant: lx,
  borderRadius: cx,
  borderStyle: ux,
  cellphoneLink: dx,
  check: px,
  checkBold: fx,
  checkboxBlank: hx,
  chevronUp: bx,
  chevronDown: gx,
  chevronLeft: mx,
  chevronRight: vx,
  close: yx,
  codeBraces: wx,
  cog: Sx,
  contentCopy: xx,
  contentSave: Cx,
  delete: Px,
  dotsVertical: Ex,
  email: Ox,
  emailOutline: _x,
  eye: Tx,
  eyedropperVariant: Mx,
  eyeOff: Ax,
  eyeOffOutline: Lx,
  eyeOutline: kx,
  fire: $x,
  flare: Rx,
  floppy: Nx,
  folder: jx,
  fullscreen: Dx,
  gradientVertical: Ix,
  helpCircle: Vx,
  image: Hx,
  information: Bx,
  informationVariant: zx,
  layers: Fx,
  link: Ux,
  lock: Gx,
  lockOpenVariant: Kx,
  menuDown: qx,
  newspaperVariantOutline: Yx,
  paletteSwatch: Xx,
  panVertical: Zx,
  phone: Jx,
  plus: Qx,
  plusBox: e2,
  powerPlug: t2,
  refresh: n2,
  rhombusOutline: r2,
  tag: o2,
  target: s2,
  targetVariant: i2,
  textBoxMultiple: a2,
  trayArrowDown: l2,
  unfoldLessHorizontal: c2,
  unfoldMoreHorizontal: u2,
  viewDayOutline: d2,
  viewGridPlus: p2,
  web: f2,
  xml: h2
}, S2 = "gs-cmp-icon", oe = ue(function({
  className: t,
  icon: n,
  size: r,
  rotate: o,
  horizontal: s,
  vertical: i
}) {
  var p;
  const a = (p = lM()) == null ? void 0 : p.sdkCustomIcons, l = (a == null ? void 0 : a[n]) || (Ic == null ? void 0 : Ic[n]) || n, u = [s && "scaleX(-1)", i && "scaleY(-1)", o && `rotate(${o}deg)`].filter((f) => !!f).join(" ");
  if (!l)
    return null;
  const d = q(S2, t);
  return l.startsWith("<svg") || l.startsWith("<?xml") ? /* @__PURE__ */ c(
    Xd,
    {
      className: d,
      style: {
        transform: u || void 0
      },
      svg: l,
      iconSize: r
    }
  ) : /* @__PURE__ */ c(
    y2,
    {
      className: d,
      path: l,
      size: r,
      rotate: o,
      horizontal: s,
      vertical: i
    }
  );
}), S1 = 150;
var je = /* @__PURE__ */ ((e) => (e.txt = "gs-theme-cl-txt", e.bg = "gs-theme-cl-bg", e.br = "gs-theme-cl-br", e.bgA = "gs-theme-cl-bgA", e.bgA2 = "gs-theme-cl-bgA2", e.hBgAct = "gs-theme-cl-hBgAct", e.hBgA2 = "gs-theme-cl-hBgA2", e.tA = "gs-theme-cl-tA", e.tAo = "gs-theme-cl-tAo", e.hTAo = "gs-theme-cl-hTAo", e.grouphTAo = "gs-theme-cl-grouphTAo", e.bA = "gs-theme-cl-bA", e.bg0 = "gs-theme-cl-bg0", e.bgH = "gs-theme-cl-bgH", e.hBgH = "gs-theme-cl-hBgH", e.bgH2 = "gs-theme-cl-bgH2", e.hBgH2 = "gs-theme-cl-hBgH2", e.sel = "gs-theme-cl-sel", e.selBr = "gs-theme-cl-selBr", e.cmp = "gs-theme-cl-cmp", e.cmpBgSoft = "gs-theme-cl-cmpBgSoft", e.cmpBgSoftX = "gs-theme-cl-cmpBgSoftX", e.cmpBr = "gs-theme-cl-cmpBr", e.cmpSymbol = "gs-theme-cl-cmpSymbol", e.cmpBgSymbolSoft = "gs-theme-cl-cmpBgSymbolSoft", e.cmpBgSymbolSoftX = "gs-theme-cl-cmpBgSymbolSoftX", e.cmpSymbolBr = "gs-theme-cl-cmpSymbolBr", e.cmpTxtActive = "gs-theme-cl-cmpTxtActive", e.focus = "gs-theme-ring-focus", e.inputText = "gs-theme-elStyles-inputText", e))(je || {});
const z = {
  /** background transparent */
  bgTr: "gs-utl-bg-transparent",
  /** text */
  txt: "gs-theme-cl-txt gs-utl-text-gray-900 dark:gs-utl-text-gray-400",
  /** text low emphasis */
  txtLowEmphasis: "gs-utl-text-neutral-500 dark:gs-utl-text-neutral-500",
  /** text high emphasis */
  txtHighEmphasis: "gs-utl-text-black dark:gs-utl-text-gray-200",
  /** text high emphasis hovered */
  txtHighEmphasisH: "hover:gs-utl-text-black hover:dark:gs-utl-text-gray-200",
  /** text active */
  tA: "gs-theme-cl-tA gs-utl-text-violet-400",
  /** text active opaque */
  tAo: "gs-theme-cl-tAo gs-utl-text-violet-800 dark:gs-utl-text-violet-400",
  /** text active hovered opaque */
  hTAo: "gs-theme-cl-hTAo hover:gs-utl-text-violet-800 hover:dark:gs-utl-text-violet-400",
  /** text active group hovered opaque */
  grouphTAo: "gs-theme-cl-grouphTAo group-hover:gs-utl-text-violet-800 group-hover:dark:gs-utl-text-violet-400",
  /** border active */
  bA: "gs-theme-cl-bA gs-utl-border-violet-400",
  /** background active */
  bgA: "gs-theme-cl-bgA gs-utl-bg-violet-400 gs-utl-text-white dark:gs-utl-bg-violet-500",
  /** background active level 2 */
  bgA2: "gs-theme-cl-bgA2 gs-utl-bg-violet-500 gs-utl-text-white",
  /** background opaque */
  bgO: "gs-theme-cl-bg0 gs-utl-bg-violet-50 gs-utl-text-violet-900 dark:gs-utl-bg-zinc-800 dark:gs-utl-text-violet-400",
  /** background */
  bg: "gs-theme-cl-bg gs-utl-bg-white dark:gs-utl-bg-zinc-900",
  /** background that blurs content behind it */
  bgBlur: "gs-utl-bg-white/50 dark:gs-utl-bg-zinc-900/50 gs-utl-backdrop-blur-sm",
  /** background heading */
  bgH: "gs-theme-cl-bgH gs-utl-bg-gray-100 dark:gs-utl-bg-zinc-700",
  /** background heading 75 */
  bgH75: "gs-utl-bg-gray-100/75 dark:gs-utl-bg-zinc-700/75",
  /** background hovered heading */
  hBgH: "gs-theme-cl-hBgH hover:gs-utl-bg-gray-50 hover:dark:gs-utl-bg-zinc-800",
  /** background heading 2 */
  bgH2: "gs-theme-cl-bgH2 gs-utl-bg-gray-25 dark:gs-utl-bg-zinc-800",
  /** background hovered heading 2 */
  hBgH2: "gs-theme-cl-hBgH2 hover:gs-utl-bg-gray-25 hover:dark:gs-utl-bg-zinc-800",
  /** background hovered active */
  hBgAct: "gs-theme-cl-hBgAct hover:gs-utl-bg-violet-800 hover:dark:gs-utl-bg-violet-400",
  /** background hovered active 2 */
  hBgA2: "gs-theme-cl-hBgA2 hover:gs-utl-bg-violet-500 hover:dark:gs-utl-bg-violet-600",
  /** background hovered dark */
  hBgDark: "hover:gs-utl-bg-black/10",
  /** selector */
  sel: "gs-theme-cl-sel gs-utl-bg-pink-200 gs-utl-text-pink-900",
  /** selector border */
  selBr: "gs-theme-cl-selBr gs-utl-border-pink-900",
  /** component */
  cmp: "gs-theme-cl-cmp gs-utl-bg-blue-450 gs-utl-text-white",
  /** component symbol */
  cmpSymbol: "gs-theme-cl-cmpSymbol gs-utl-bg-[#7b61ff] gs-utl-text-white",
  /** component background soft */
  cmpBgSoft: "gs-theme-cl-cmpBgSoft gs-utl-bg-blue-100 dark:gs-utl-bg-sky-800",
  /** component background symbol soft */
  cmpBgSymbolSoft: "gs-theme-cl-cmpBgSymbolSoft gs-utl-bg-violet-200 dark:gs-utl-bg-violet-800",
  /** component background soft X?? */
  cmpBgSoftX: "gs-theme-cl-cmpBgSoftX gs-utl-bg-blue-50 dark:gs-utl-bg-gray-800",
  /** component background symbol soft X?? */
  cmpBgSymbolSoftX: "gs-theme-cl-cmpBgSymbolSoftX gs-utl-bg-[#edebff] dark:gs-utl-bg-[#2d1b4b]",
  /** component text active */
  cmpTxtActive: "gs-theme-cl-cmpTxtActive dark:gs-utl-text-gray-300",
  /** component border */
  cmpBr: "gs-theme-cl-cmpBr gs-utl-border-blue-450",
  /** component symbol border */
  cmpSymbolBr: "gs-theme-cl-cmpSymbolBr gs-utl-border-[#7b61ff]",
  /** component target background */
  cmpTargetBg: "gs-utl-bg-amber-500 gs-utl-text-white",
  /** component target background opaque */
  cmpTargetBgOpac: "gs-utl-bg-amber-500/5",
  /** component target border */
  cmpTargetBr: "gs-utl-border-amber-500",
  // warning
  /** text warning */
  tW: "gs-utl-text-amber-500",
  /** background warning */
  bgW: "gs-utl-bg-amber-500",
  /** background red */
  bgRed: "gs-utl-bg-red-500",
  /** hovered background red */
  hBgRed: "hover:gs-utl-bg-red-600",
  /** hovered background warning */
  hBgW: "hover:gs-utl-bg-amber-600",
  /** border */
  br: "gs-theme-cl-br gs-utl-border-gray-300 dark:gs-utl-border-zinc-700",
  brRed: "gs-utl-border-red-500",
  /** border light */
  brLight: "gs-utl-border-white/25"
}, Zd = {
  enter: "gs-utl-transition gs-utl-duration-100 gs-utl-ease-out",
  enterFrom: "gs-utl-scale-95 gs-utl-opacity-0",
  enterTo: "gs-utl-opacity-100",
  leave: "gs-utl-transition gs-utl-ease-in gs-utl-duration-100",
  leaveFrom: "gs-utl-scale-100 gs-utl-opacity-100",
  leaveTo: "gs-utl-scale-95 gs-utl-opacity-0"
}, x1 = {
  enter: "gs-utl-transition gs-utl-duration-100 gs-utl-ease-out",
  enterFrom: "gs-utl-opacity-0",
  enterTo: "gs-utl-opacity-100"
}, x2 = {
  leave: "gs-utl-transition gs-utl-ease-in gs-utl-duration-100",
  leaveFrom: "gs-utl-opacity-100",
  leaveTo: "gs-utl-opacity-0"
}, zi = {
  ...x1,
  ...x2
}, Re = {
  xy: "gs-utl-px-4 gs-utl-py-2",
  xyS: "gs-utl-px-2 gs-utl-py-1",
  xyS2: "gs-utl-px-2 gs-utl-py-0.5",
  x: "gs-utl-px-4",
  xS: "gs-utl-px-2",
  y: "gs-utl-py-2",
  s: "gs-utl-p-2"
}, Jd = {
  bg: z.bg,
  bgH: z.bgH
}, Ff = {
  bg: "gs-utl-bg-zinc-700",
  //'gs-utl-bg-gray-800',
  txt: "gs-utl-text-white",
  block: "gs-utl-text-xs gs-utl-mt-1 gs-utl-bg-white/10 gs-utl-rounded gs-utl-px-2 gs-utl-py-1"
}, se = {
  /** rounded */
  rnd: "gs-utl-rounded",
  pill: "gs-utl-rounded-full",
  /** border */
  b: "gs-utl-border",
  /** border transparent */
  bT: "gs-utl-border-transparent",
  /** border super? */
  bS: "gs-utl-border-2",
  /** border top */
  bt: "gs-utl-border-t",
  /** border bottom */
  bb: "gs-utl-border-b",
  /** border right */
  br: "gs-utl-border-r",
  /** border left */
  bl: "gs-utl-border-l",
  /** border active */
  bA: "gs-theme-cl-bA gs-utl-border-violet-400 dark:gs-utl-border-violet-500"
}, xi = {
  focus: "gs-theme-ring-focus focus:gs-utl-outline-none focus-visible:gs-utl-ring-2 gs-utl-ring-violet-300 gs-utl-ring-opacity-80",
  deepFocus: "focus:gs-utl-outline-none [&:has(:focus-visible)]:gs-utl-ring-2 gs-utl-ring-violet-300 gs-utl-ring-opacity-80"
}, pe = {
  s3x: "13px",
  s2x: "14px",
  sx: "16px",
  s: "18px"
}, Qe = {
  click: "gs-utl-cursor-pointer gs-utl-transition-opacity gs-utl-opacity-75 hover:gs-utl-opacity-100",
  hover: "gs-utl-transition-opacity gs-utl-opacity-50 hover:gs-utl-opacity-100",
  hoverGroup: "group-hover:gs-utl-opacity-100 gs-utl-opacity-0 gs-utl-transition-opacity",
  dot: "gs-utl-w-[6px] gs-utl-h-[6px] gs-utl-rounded-full",
  scrollY: "gs-utl-overflow-y-auto gs-utl-overflow-x-hidden",
  txtEllips: "gs-utl-text-ellipsis gs-utl-overflow-hidden gs-utl-whitespace-nowrap",
  coverAbs: "gs-utl-absolute gs-utl-top-0 gs-utl-left-0 gs-utl-w-full gs-utl-h-full",
  disabled: "gs-utl-opacity-50 gs-utl-pointer-events-none",
  disabledM: "gs-utl-opacity-50 gs-utl-cursor-not-allowed",
  noFocusOut: "focus:gs-utl-outline-none",
  spin: "gs-utl-animate-spin-fast"
}, Eo = {
  link: $(z.tAo),
  inputText: "gs-theme-elStyles-inputText focus:gs-utl-outline-none gs-utl-placeholder:text-neutral-400 placeholder:dark:gs-utl-text-neutral-500"
}, Qd = {
  itemList: ({ index: e = 0, open: t = !1, length: n = 0 } = {}) => $(z.bgH2, Re.xyS, z.br, e && se.bt, (t || e === n - 1) && se.bb)
}, C1 = (e) => ({
  bg: e ? "#18181b" : "#f9f9f9",
  text: e ? "#9ca3af" : "#111827",
  link: e ? "#a78bfa" : "#5b21b6"
}), Bl = (e) => {
  let t = {
    isSymbol: !1,
    bg: z.cmp,
    bgSoft: `${z.cmpBgSoft} ${z.cmpTxtActive}`,
    bgSoftX: z.cmpBgSoftX,
    border: z.cmpBr,
    txt: ""
  };
  if (!(e != null && e.em))
    return t;
  const { isSymbol: n } = e.em.Components.getSymbolInfo(e);
  return n && (t = {
    isSymbol: n,
    bg: z.cmpSymbol,
    bgSoft: `${z.cmpBgSymbolSoft} ${z.cmpTxtActive}`,
    bgSoftX: z.cmpBgSymbolSoftX,
    border: z.cmpSymbolBr,
    txt: ""
  }), t;
}, P1 = ({
  variant: e,
  size: t = "m",
  className: n,
  active: r,
  border: o = !0,
  rounded: s = !0,
  disabled: i = !1,
  withBg: a,
  block: l,
  full: u
}) => {
  const d = e === "pr", p = e === "out", f = e === "out-clear", h = e === "warn", g = e === "danger", m = o && (p || f || !e);
  return [
    "gs-utl-transition-colors gs-utl-cursor-pointer",
    l && "block",
    t === "s" && "gjs-p-1 text-sm",
    t === "m" && "gjs-p-1 gjs-px-2",
    t === "m2" && "gjs-p-1 gjs-px-3",
    t === "lg" && "gjs-p-2 gjs-px-4 text-lg",
    n,
    s && se.rnd,
    m && `${se.b} ${z.br}`,
    a && z.bg,
    // isDef && !disabled && !active && cl.hBgH,
    m && $(se.b, p && z.bA, p && z.tAo, !i && z.hBgH),
    h && $(z.bgW, z.hBgW, !i && z.hBgW, "text-white"),
    g && $(z.bgRed, !i && z.hBgRed, "text-white"),
    d && $(z.bgA2, !i && z.hBgAct),
    r && z.bgA,
    i && "disabled:gs-utl-opacity-80 cursor-not-allowed",
    u && "w-full",
    xi.focus
  ];
};
function Ze({ children: e, ...t }) {
  const {
    variant: n,
    size: r,
    active: o,
    border: s,
    rounded: i,
    block: a,
    full: l,
    className: u,
    icon: d,
    loading: p,
    withBg: f,
    type: h = "button",
    ...g
  } = t, m = p ? { icon: Wx, size: "18px", className: $("animate-spin-fast") } : Mt(d) ? { icon: d, size: "18px" } : d;
  return /* @__PURE__ */ c("button", { className: $(P1(t)), disabled: t.disabled, type: h, ...g, children: m ? /* @__PURE__ */ A(I, { className: $("gap-2"), items: "center", nowrap: !0, children: [
    /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(oe, { ...m }) }),
    e && /* @__PURE__ */ c(N, { children: e })
  ] }) : e });
}
function Bo(e, t, n) {
  let r = n.initialDeps ?? [], o;
  return () => {
    var s, i, a, l;
    let u;
    n.key && ((s = n.debug) != null && s.call(n)) && (u = Date.now());
    const d = e();
    if (!(d.length !== r.length || d.some((h, g) => r[g] !== h)))
      return o;
    r = d;
    let f;
    if (n.key && ((i = n.debug) != null && i.call(n)) && (f = Date.now()), o = t(...d), n.key && ((a = n.debug) != null && a.call(n))) {
      const h = Math.round((Date.now() - u) * 100) / 100, g = Math.round((Date.now() - f) * 100) / 100, m = g / 16, v = (b, y) => {
        for (b = String(b); b.length < y; )
          b = " " + b;
        return b;
      };
      console.info(
        `%c⏱ ${v(g, 5)} /${v(h, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * m, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (l = n == null ? void 0 : n.onChange) == null || l.call(n, o), o;
  };
}
function Vc(e, t) {
  if (e === void 0)
    throw new Error(`Unexpected undefined${t ? `: ${t}` : ""}`);
  return e;
}
const C2 = (e, t) => Math.abs(e - t) < 1, P2 = (e, t, n) => {
  let r;
  return function(...o) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, o), n);
  };
}, E2 = (e) => e, O2 = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let o = t; o <= n; o++)
    r.push(o);
  return r;
}, _2 = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const o = (i) => {
    const { width: a, height: l } = i;
    t({ width: Math.round(a), height: Math.round(l) });
  };
  if (o(n.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const s = new r.ResizeObserver((i) => {
    const a = i[0];
    if (a != null && a.borderBoxSize) {
      const l = a.borderBoxSize[0];
      if (l) {
        o({ width: l.inlineSize, height: l.blockSize });
        return;
      }
    }
    o(n.getBoundingClientRect());
  });
  return s.observe(n, { box: "border-box" }), () => {
    s.unobserve(n);
  };
}, Uf = {
  passive: !0
}, T2 = typeof window > "u" ? !0 : "onscrollend" in window, A2 = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  let o = 0;
  const s = T2 ? () => {
  } : P2(
    r,
    () => {
      t(o, !1);
    },
    e.options.isScrollingResetDelay
  ), i = (u) => () => {
    const { horizontal: d, isRtl: p } = e.options;
    o = d ? n.scrollLeft * (p && -1 || 1) : n.scrollTop, s(), t(o, u);
  }, a = i(!0), l = i(!1);
  return l(), n.addEventListener("scroll", a, Uf), n.addEventListener("scrollend", l, Uf), () => {
    n.removeEventListener("scroll", a), n.removeEventListener("scrollend", l);
  };
}, L2 = (e, t, n) => {
  if (t != null && t.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, k2 = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var o, s;
  const i = e + t;
  (s = (o = r.scrollElement) == null ? void 0 : o.scrollTo) == null || s.call(o, {
    [r.options.horizontal ? "left" : "top"]: i,
    behavior: n
  });
};
class M2 {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((o) => {
        o.forEach((s) => {
          this._measureElement(s.target, s);
        });
      }));
      return {
        disconnect: () => {
          var o;
          (o = r()) == null || o.disconnect(), n = null;
        },
        observe: (o) => {
          var s;
          return (s = r()) == null ? void 0 : s.observe(o, { box: "border-box" });
        },
        unobserve: (o) => {
          var s;
          return (s = r()) == null ? void 0 : s.unobserve(o);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, o]) => {
        typeof o > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: E2,
        rangeExtractor: O2,
        onChange: () => {
        },
        measureElement: L2,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        ...n
      };
    }, this.notify = (n) => {
      var r, o;
      (o = (r = this.options).onChange) == null || o.call(r, this, n);
    }, this.maybeNotify = Bo(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (n) => {
        this.notify(n);
      },
      {
        key: !1,
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this.elementsCache.forEach((o) => {
          this.observer.observe(o);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (o) => {
            this.scrollRect = o, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (o, s) => {
            this.scrollAdjustments = 0, this.scrollDirection = s ? this.getScrollOffset() < o ? "forward" : "backward" : null, this.scrollOffset = o, this.isScrolling = s, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
      for (let i = r - 1; i >= 0; i--) {
        const a = n[i];
        if (o.has(a.lane))
          continue;
        const l = s.get(
          a.lane
        );
        if (l == null || a.end > l.end ? s.set(a.lane, a) : a.end < l.end && o.set(a.lane, !0), o.size === this.options.lanes)
          break;
      }
      return s.size === this.options.lanes ? Array.from(s.values()).sort((i, a) => i.end === a.end ? i.index - a.index : i.end - a.end)[0] : void 0;
    }, this.getMeasurementOptions = Bo(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, o, s, i) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: o,
        getItemKey: s,
        enabled: i
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Bo(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: o, getItemKey: s, enabled: i }, a) => {
        if (!i)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((d) => {
          this.itemSizeCache.set(d.key, d.size);
        }));
        const l = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const u = this.measurementsCache.slice(0, l);
        for (let d = l; d < n; d++) {
          const p = s(d), f = this.options.lanes === 1 ? u[d - 1] : this.getFurthestMeasurement(u, d), h = f ? f.end + this.options.gap : r + o, g = a.get(p), m = typeof g == "number" ? g : this.options.estimateSize(d), v = h + m, b = f ? f.lane : d % this.options.lanes;
          u[d] = {
            index: d,
            start: h,
            size: m,
            end: v,
            key: p,
            lane: b
          };
        }
        return this.measurementsCache = u, u;
      },
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.calculateRange = Bo(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (n, r, o) => this.range = n.length > 0 && r > 0 ? $2({
        measurements: n,
        outerSize: r,
        scrollOffset: o
      }) : null,
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.getIndexes = Bo(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (n, r, o, s) => r === null ? [] : n({
        startIndex: r.startIndex,
        endIndex: r.endIndex,
        overscan: o,
        count: s
      }),
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, o = n.getAttribute(r);
      return o ? parseInt(o, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const o = this.indexFromElement(n), s = this.measurementsCache[o];
      if (!s)
        return;
      const i = s.key, a = this.elementsCache.get(i);
      a !== n && (a && this.observer.unobserve(a), this.observer.observe(n), this.elementsCache.set(i, n)), n.isConnected && this.resizeItem(o, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const o = this.measurementsCache[n];
      if (!o)
        return;
      const s = this.itemSizeCache.get(o.key) ?? o.size, i = r - s;
      i !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(o, i, this) : o.start < this.getScrollOffset() + this.scrollAdjustments) && this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += i,
        behavior: void 0
      }), this.pendingMeasuredCacheIndexes.push(o.index), this.itemSizeCache = new Map(this.itemSizeCache.set(o.key, r)), this.notify(!1));
    }, this.measureElement = (n) => {
      if (!n) {
        this.elementsCache.forEach((r, o) => {
          r.isConnected || (this.observer.unobserve(r), this.elementsCache.delete(o));
        });
        return;
      }
      this._measureElement(n, void 0);
    }, this.getVirtualItems = Bo(
      () => [this.getIndexes(), this.getMeasurements()],
      (n, r) => {
        const o = [];
        for (let s = 0, i = n.length; s < i; s++) {
          const a = n[s], l = r[a];
          o.push(l);
        }
        return o;
      },
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return Vc(
          r[E1(
            0,
            r.length - 1,
            (o) => Vc(r[o]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r) => {
      const o = this.getSize(), s = this.getScrollOffset();
      r === "auto" && (n <= s ? r = "start" : n >= s + o ? r = "end" : r = "start"), r === "start" ? n = n : r === "end" ? n = n - o : r === "center" && (n = n - o / 2);
      const i = this.options.horizontal ? "scrollWidth" : "scrollHeight", l = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[i] : this.scrollElement[i] : 0) - o;
      return Math.max(Math.min(l, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const o = this.measurementsCache[n];
      if (!o)
        return;
      const s = this.getSize(), i = this.getScrollOffset();
      if (r === "auto")
        if (o.end >= i + s - this.options.scrollPaddingEnd)
          r = "end";
        else if (o.start <= i + this.options.scrollPaddingStart)
          r = "start";
        else
          return [i, r];
      const a = r === "end" ? o.end + this.options.scrollPaddingEnd : o.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(a, r), r];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: r = "start", behavior: o } = {}) => {
      this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: o
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: o } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const s = this.getOffsetForIndex(n, r);
      if (!s)
        return;
      const [i, a] = s;
      this._scrollToOffset(i, { adjustments: void 0, behavior: o }), o !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [u] = Vc(
            this.getOffsetForIndex(n, a)
          );
          C2(u, this.getScrollOffset()) || this.scrollToIndex(n, { align: a, behavior: o });
        } else
          this.scrollToIndex(n, { align: a, behavior: o });
      }));
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let o;
      return r.length === 0 ? o = this.options.paddingStart : o = this.options.lanes === 1 ? ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0 : Math.max(
        ...r.slice(-this.options.lanes).map((s) => s.end)
      ), Math.max(
        o - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: o
    }) => {
      this.options.scrollToFn(n, { behavior: o, adjustments: r }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
}
const E1 = (e, t, n, r) => {
  for (; e <= t; ) {
    const o = (e + t) / 2 | 0, s = n(o);
    if (s < r)
      e = o + 1;
    else if (s > r)
      t = o - 1;
    else
      return o;
  }
  return e > 0 ? e - 1 : 0;
};
function $2({
  measurements: e,
  outerSize: t,
  scrollOffset: n
}) {
  const r = e.length - 1, s = E1(0, r, (a) => e[a].start, n);
  let i = s;
  for (; i < r && e[i].end < n + t; )
    i++;
  return { startIndex: s, endIndex: i };
}
const R2 = typeof document < "u" ? Ue.useLayoutEffect : Ue.useEffect;
function N2(e) {
  const t = Ue.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (o, s) => {
      var i;
      s ? vm(t) : t(), (i = e.onChange) == null || i.call(e, o, s);
    }
  }, [r] = Ue.useState(
    () => new M2(n)
  );
  return r.setOptions(n), Ue.useEffect(() => r._didMount(), []), R2(() => r._willUpdate()), r;
}
function j2(e) {
  return N2({
    observeElementRect: _2,
    observeElementOffset: A2,
    scrollToFn: k2,
    ...e
  });
}
var D2 = Object.defineProperty, I2 = (e, t, n) => t in e ? D2(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Hc = (e, t, n) => (I2(e, typeof t != "symbol" ? t + "" : t, n), n);
let V2 = class {
  constructor() {
    Hc(this, "current", this.detect()), Hc(this, "handoffState", "pending"), Hc(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.handoffState = "pending", this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, Er = new V2(), $e = (e, t) => {
  Er.isServer ? G(e, t) : kl(e, t);
};
function Ct(e) {
  let t = K(e);
  return $e(() => {
    t.current = e;
  }, [e]), t;
}
function Fi(e, t) {
  let [n, r] = W(e), o = Ct(e);
  return $e(() => r(o.current), [o, r, ...t]), n;
}
let ee = function(e) {
  let t = Ct(e);
  return H.useCallback((...n) => t.current(...n), [t]);
};
function zl(e, t, n) {
  let [r, o] = W(n), s = e !== void 0, i = K(s), a = K(!1), l = K(!1);
  return s && !i.current && !a.current ? (a.current = !0, i.current = s, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !s && i.current && !l.current && (l.current = !0, i.current = s, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [s ? e : r, ee((u) => (s || o(u), t == null ? void 0 : t(u)))];
}
function Ui(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function Cn() {
  let e = [], t = { addEventListener(n, r, o, s) {
    return n.addEventListener(r, o, s), t.add(() => n.removeEventListener(r, o, s));
  }, requestAnimationFrame(...n) {
    let r = requestAnimationFrame(...n);
    return t.add(() => cancelAnimationFrame(r));
  }, nextFrame(...n) {
    return t.requestAnimationFrame(() => t.requestAnimationFrame(...n));
  }, setTimeout(...n) {
    let r = setTimeout(...n);
    return t.add(() => clearTimeout(r));
  }, microTask(...n) {
    let r = { current: !0 };
    return Ui(() => {
      r.current && n[0]();
    }), t.add(() => {
      r.current = !1;
    });
  }, style(n, r, o) {
    let s = n.style.getPropertyValue(r);
    return Object.assign(n.style, { [r]: o }), this.add(() => {
      Object.assign(n.style, { [r]: s });
    });
  }, group(n) {
    let r = Cn();
    return n(r), this.add(() => r.dispose());
  }, add(n) {
    return e.push(n), () => {
      let r = e.indexOf(n);
      if (r >= 0)
        for (let o of e.splice(r, 1))
          o();
    };
  }, dispose() {
    for (let n of e.splice(0))
      n();
  } };
  return t;
}
function Pn() {
  let [e] = W(Cn);
  return G(() => () => e.dispose(), [e]), e;
}
function H2() {
  let e = typeof document > "u";
  return "useSyncExternalStore" in Ue ? ((t) => t.useSyncExternalStore)(Ue)(() => () => {
  }, () => !1, () => !e) : !1;
}
function Es() {
  let e = H2(), [t, n] = Ue.useState(Er.isHandoffComplete);
  return t && Er.isHandoffComplete === !1 && n(!1), Ue.useEffect(() => {
    t !== !0 && n(!0);
  }, [t]), Ue.useEffect(() => Er.handoff(), []), e ? !1 : t;
}
var Wf;
let Xe = (Wf = H.useId) != null ? Wf : function() {
  let e = Es(), [t, n] = H.useState(e ? () => Er.nextId() : null);
  return $e(() => {
    t === null && n(Er.nextId());
  }, [t]), t != null ? "" + t : void 0;
};
function Oe(e, t, ...n) {
  if (e in t) {
    let o = t[e];
    return typeof o == "function" ? o(...n) : o;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((o) => `"${o}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, Oe), r;
}
function oo(e) {
  return Er.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
let Zu = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var Ye = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(Ye || {}), Rn = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(Rn || {}), B2 = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(B2 || {});
function Fl(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Zu)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var Ul = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(Ul || {});
function ep(e, t = 0) {
  var n;
  return e === ((n = oo(e)) == null ? void 0 : n.body) ? !1 : Oe(t, { 0() {
    return e.matches(Zu);
  }, 1() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(Zu))
        return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
var z2 = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(z2 || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function mo(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let F2 = ["textarea", "input"].join(",");
function U2(e) {
  var t, n;
  return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, F2)) != null ? n : !1;
}
function wr(e, t = (n) => n) {
  return e.slice().sort((n, r) => {
    let o = t(n), s = t(r);
    if (o === null || s === null)
      return 0;
    let i = o.compareDocumentPosition(s);
    return i & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : i & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function xt(e, t, { sorted: n = !0, relativeTo: r = null, skipElements: o = [] } = {}) {
  let s = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, i = Array.isArray(e) ? n ? wr(e) : e : Fl(e);
  o.length > 0 && i.length > 1 && (i = i.filter((h) => !o.includes(h))), r = r ?? s.activeElement;
  let a = (() => {
    if (t & 5)
      return 1;
    if (t & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), l = (() => {
    if (t & 1)
      return 0;
    if (t & 2)
      return Math.max(0, i.indexOf(r)) - 1;
    if (t & 4)
      return Math.max(0, i.indexOf(r)) + 1;
    if (t & 8)
      return i.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = t & 32 ? { preventScroll: !0 } : {}, d = 0, p = i.length, f;
  do {
    if (d >= p || d + p <= 0)
      return 0;
    let h = l + d;
    if (t & 16)
      h = (h + p) % p;
    else {
      if (h < 0)
        return 3;
      if (h >= p)
        return 1;
    }
    f = i[h], f == null || f.focus(u), d += a;
  } while (f !== s.activeElement);
  return t & 6 && U2(f) && f.select(), 2;
}
function O1() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function W2() {
  return /Android/gi.test(window.navigator.userAgent);
}
function _1() {
  return O1() || W2();
}
function ga(e, t, n) {
  let r = Ct(t);
  G(() => {
    function o(s) {
      r.current(s);
    }
    return document.addEventListener(e, o, n), () => document.removeEventListener(e, o, n);
  }, [e, n]);
}
function T1(e, t, n) {
  let r = Ct(t);
  G(() => {
    function o(s) {
      r.current(s);
    }
    return window.addEventListener(e, o, n), () => window.removeEventListener(e, o, n);
  }, [e, n]);
}
function Wl(e, t, n = !0) {
  let r = K(!1);
  G(() => {
    requestAnimationFrame(() => {
      r.current = n;
    });
  }, [n]);
  function o(i, a) {
    if (!r.current || i.defaultPrevented)
      return;
    let l = a(i);
    if (l === null || !l.getRootNode().contains(l) || !l.isConnected)
      return;
    let u = function d(p) {
      return typeof p == "function" ? d(p()) : Array.isArray(p) || p instanceof Set ? p : [p];
    }(e);
    for (let d of u) {
      if (d === null)
        continue;
      let p = d instanceof HTMLElement ? d : d.current;
      if (p != null && p.contains(l) || i.composed && i.composedPath().includes(p))
        return;
    }
    return !ep(l, Ul.Loose) && l.tabIndex !== -1 && i.preventDefault(), t(i, l);
  }
  let s = K(null);
  ga("pointerdown", (i) => {
    var a, l;
    r.current && (s.current = ((l = (a = i.composedPath) == null ? void 0 : a.call(i)) == null ? void 0 : l[0]) || i.target);
  }, !0), ga("mousedown", (i) => {
    var a, l;
    r.current && (s.current = ((l = (a = i.composedPath) == null ? void 0 : a.call(i)) == null ? void 0 : l[0]) || i.target);
  }, !0), ga("click", (i) => {
    _1() || s.current && (o(i, () => s.current), s.current = null);
  }, !0), ga("touchend", (i) => o(i, () => i.target instanceof HTMLElement ? i.target : null), !0), T1("blur", (i) => o(i, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function $r(...e) {
  return ie(() => oo(...e), [...e]);
}
function Gf(e) {
  var t;
  if (e.type)
    return e.type;
  let n = (t = e.as) != null ? t : "button";
  if (typeof n == "string" && n.toLowerCase() === "button")
    return "button";
}
function Os(e, t) {
  let [n, r] = W(() => Gf(e));
  return $e(() => {
    r(Gf(e));
  }, [e.type, e.as]), $e(() => {
    n || t.current && t.current instanceof HTMLButtonElement && !t.current.hasAttribute("type") && r("button");
  }, [n, t]), n;
}
let A1 = Symbol();
function tp(e, t = !0) {
  return Object.assign(e, { [A1]: t });
}
function ke(...e) {
  let t = K(e);
  G(() => {
    t.current = e;
  }, [e]);
  let n = ee((r) => {
    for (let o of t.current)
      o != null && (typeof o == "function" ? o(r) : o.current = r);
  });
  return e.every((r) => r == null || (r == null ? void 0 : r[A1])) ? void 0 : n;
}
function Kf(e) {
  return [e.screenX, e.screenY];
}
function L1() {
  let e = K([-1, -1]);
  return { wasMoved(t) {
    let n = Kf(t);
    return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
  }, update(t) {
    e.current = Kf(t);
  } };
}
function k1({ container: e, accept: t, walk: n, enabled: r = !0 }) {
  let o = K(t), s = K(n);
  G(() => {
    o.current = t, s.current = n;
  }, [t, n]), $e(() => {
    if (!e || !r)
      return;
    let i = oo(e);
    if (!i)
      return;
    let a = o.current, l = s.current, u = Object.assign((p) => a(p), { acceptNode: a }), d = i.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, u, !1);
    for (; d.nextNode(); )
      l(d.currentNode);
  }, [e, r, o, s]);
}
function Ci(e, t) {
  let n = K([]), r = ee(e);
  G(() => {
    let o = [...n.current];
    for (let [s, i] of t.entries())
      if (n.current[s] !== i) {
        let a = r(t, o);
        return n.current = t, a;
      }
  }, [r, ...t]);
}
function ll(...e) {
  return Array.from(new Set(e.flatMap((t) => typeof t == "string" ? t.split(" ") : []))).filter(Boolean).join(" ");
}
var Dt = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Dt || {}), Wr = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Wr || {});
function _e({ ourProps: e, theirProps: t, slot: n, defaultTag: r, features: o, visible: s = !0, name: i, mergeRefs: a }) {
  a = a ?? G2;
  let l = M1(t, e);
  if (s)
    return ma(l, n, r, i, a);
  let u = o ?? 0;
  if (u & 2) {
    let { static: d = !1, ...p } = l;
    if (d)
      return ma(p, n, r, i, a);
  }
  if (u & 1) {
    let { unmount: d = !0, ...p } = l;
    return Oe(d ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return ma({ ...p, hidden: !0, style: { display: "none" } }, n, r, i, a);
    } });
  }
  return ma(l, n, r, i, a);
}
function ma(e, t = {}, n, r, o) {
  let { as: s = n, children: i, refName: a = "ref", ...l } = Bc(e, ["unmount", "static"]), u = e.ref !== void 0 ? { [a]: e.ref } : {}, d = typeof i == "function" ? i(t) : i;
  "className" in l && l.className && typeof l.className == "function" && (l.className = l.className(t));
  let p = {};
  if (t) {
    let f = !1, h = [];
    for (let [g, m] of Object.entries(t))
      typeof m == "boolean" && (f = !0), m === !0 && h.push(g);
    f && (p["data-headlessui-state"] = h.join(" "));
  }
  if (s === wt && Object.keys(gs(l)).length > 0) {
    if (!q0(d) || Array.isArray(d) && d.length > 1)
      throw new Error(['Passing props on "Fragment"!', "", `The current component <${r} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(l).map((m) => `  - ${m}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((m) => `  - ${m}`).join(`
`)].join(`
`));
    let f = d.props, h = typeof (f == null ? void 0 : f.className) == "function" ? (...m) => ll(f == null ? void 0 : f.className(...m), l.className) : ll(f == null ? void 0 : f.className, l.className), g = h ? { className: h } : {};
    return Y0(d, Object.assign({}, M1(d.props, gs(Bc(l, ["ref"]))), p, u, { ref: o(d.ref, u.ref) }, g));
  }
  return is(s, Object.assign({}, Bc(l, ["ref"]), s !== wt && u, s !== wt && p), d);
}
function np() {
  let e = K([]), t = it((n) => {
    for (let r of e.current)
      r != null && (typeof r == "function" ? r(n) : r.current = n);
  }, []);
  return (...n) => {
    if (!n.every((r) => r == null))
      return e.current = n, t;
  };
}
function G2(...e) {
  return e.every((t) => t == null) ? void 0 : (t) => {
    for (let n of e)
      n != null && (typeof n == "function" ? n(t) : n.current = t);
  };
}
function M1(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, n = {};
  for (let r of e)
    for (let o in r)
      o.startsWith("on") && typeof r[o] == "function" ? (n[o] != null || (n[o] = []), n[o].push(r[o])) : t[o] = r[o];
  if (t.disabled || t["aria-disabled"])
    return Object.assign(t, Object.fromEntries(Object.keys(n).map((r) => [r, void 0])));
  for (let r in n)
    Object.assign(t, { [r](o, ...s) {
      let i = n[r];
      for (let a of i) {
        if ((o instanceof Event || (o == null ? void 0 : o.nativeEvent) instanceof Event) && o.defaultPrevented)
          return;
        a(o, ...s);
      }
    } });
  return t;
}
function Te(e) {
  var t;
  return Object.assign(Rt(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function gs(e) {
  let t = Object.assign({}, e);
  for (let n in t)
    t[n] === void 0 && delete t[n];
  return t;
}
function Bc(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t)
    r in n && delete n[r];
  return n;
}
let K2 = "div";
var on = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(on || {});
function q2(e, t) {
  var n;
  let { features: r = 1, ...o } = e, s = { ref: t, "aria-hidden": (r & 2) === 2 ? !0 : (n = o["aria-hidden"]) != null ? n : void 0, hidden: (r & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(r & 4) === 4 && (r & 2) !== 2 && { display: "none" } } };
  return _e({ ourProps: s, theirProps: o, slot: {}, defaultTag: K2, name: "Hidden" });
}
let sn = Te(q2), rp = Be(null);
rp.displayName = "OpenClosedContext";
var Ke = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(Ke || {});
function so() {
  return Le(rp);
}
function Wi({ value: e, children: t }) {
  return H.createElement(rp.Provider, { value: e }, t);
}
function Y2(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let Zn = [];
Y2(() => {
  function e(t) {
    t.target instanceof HTMLElement && t.target !== document.body && Zn[0] !== t.target && (Zn.unshift(t.target), Zn = Zn.filter((n) => n != null && n.isConnected), Zn.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function Tr(e) {
  let t = e.parentElement, n = null;
  for (; t && !(t instanceof HTMLFieldSetElement); )
    t instanceof HTMLLegendElement && (n = t), t = t.parentElement;
  let r = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return r && X2(n) ? !1 : r;
}
function X2(e) {
  if (!e)
    return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement)
      return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
function Z2(e) {
  throw new Error("Unexpected object: " + e);
}
var We = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(We || {});
function Ju(e, t) {
  let n = t.resolveItems();
  if (n.length <= 0)
    return null;
  let r = t.resolveActiveIndex(), o = r ?? -1;
  switch (e.focus) {
    case 0: {
      for (let s = 0; s < n.length; ++s)
        if (!t.resolveDisabled(n[s], s, n))
          return s;
      return r;
    }
    case 1: {
      for (let s = o - 1; s >= 0; --s)
        if (!t.resolveDisabled(n[s], s, n))
          return s;
      return r;
    }
    case 2: {
      for (let s = o + 1; s < n.length; ++s)
        if (!t.resolveDisabled(n[s], s, n))
          return s;
      return r;
    }
    case 3: {
      for (let s = n.length - 1; s >= 0; --s)
        if (!t.resolveDisabled(n[s], s, n))
          return s;
      return r;
    }
    case 4: {
      for (let s = 0; s < n.length; ++s)
        if (t.resolveId(n[s], s, n) === e.id)
          return s;
      return r;
    }
    case 5:
      return null;
    default:
      Z2(e);
  }
}
function Gl(e = {}, t = null, n = []) {
  for (let [r, o] of Object.entries(e))
    R1(n, $1(t, r), o);
  return n;
}
function $1(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function R1(e, t, n) {
  if (Array.isArray(n))
    for (let [r, o] of n.entries())
      R1(e, $1(t, r.toString()), o);
  else
    n instanceof Date ? e.push([t, n.toISOString()]) : typeof n == "boolean" ? e.push([t, n ? "1" : "0"]) : typeof n == "string" ? e.push([t, n]) : typeof n == "number" ? e.push([t, `${n}`]) : n == null ? e.push([t, ""]) : Gl(n, t, e);
}
function N1(e) {
  var t, n;
  let r = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (r) {
    for (let o of r.elements)
      if (o !== e && (o.tagName === "INPUT" && o.type === "submit" || o.tagName === "BUTTON" && o.type === "submit" || o.nodeName === "INPUT" && o.type === "image")) {
        o.click();
        return;
      }
    (n = r.requestSubmit) == null || n.call(r);
  }
}
var ve = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(ve || {}), J2 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(J2 || {}), Q2 = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(Q2 || {}), eC = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Focus = 1] = "Focus", e[e.Other = 2] = "Other", e))(eC || {}), tC = ((e) => (e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.RegisterOption = 3] = "RegisterOption", e[e.UnregisterOption = 4] = "UnregisterOption", e[e.RegisterLabel = 5] = "RegisterLabel", e[e.SetActivationTrigger = 6] = "SetActivationTrigger", e[e.UpdateVirtualOptions = 7] = "UpdateVirtualOptions", e))(tC || {});
function zc(e, t = (n) => n) {
  let n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = t(e.options.slice()), o = r.length > 0 && r[0].dataRef.current.order !== null ? r.sort((i, a) => i.dataRef.current.order - a.dataRef.current.order) : wr(r, (i) => i.dataRef.current.domRef.current), s = n ? o.indexOf(n) : null;
  return s === -1 && (s = null), { options: o, activeOptionIndex: s };
}
let nC = { 1(e) {
  var t;
  return (t = e.dataRef.current) != null && t.disabled || e.comboboxState === 1 ? e : { ...e, activeOptionIndex: null, comboboxState: 1 };
}, 0(e) {
  var t, n;
  if ((t = e.dataRef.current) != null && t.disabled || e.comboboxState === 0)
    return e;
  if ((n = e.dataRef.current) != null && n.value) {
    let r = e.dataRef.current.calculateIndex(e.dataRef.current.value);
    if (r !== -1)
      return { ...e, activeOptionIndex: r, comboboxState: 0 };
  }
  return { ...e, comboboxState: 0 };
}, 2(e, t) {
  var n, r, o, s, i;
  if ((n = e.dataRef.current) != null && n.disabled || (r = e.dataRef.current) != null && r.optionsRef.current && !((o = e.dataRef.current) != null && o.optionsPropsRef.current.static) && e.comboboxState === 1)
    return e;
  if (e.virtual) {
    let d = t.focus === We.Specific ? t.idx : Ju(t, { resolveItems: () => e.virtual.options, resolveActiveIndex: () => {
      var f, h;
      return (h = (f = e.activeOptionIndex) != null ? f : e.virtual.options.findIndex((g) => !e.virtual.disabled(g))) != null ? h : null;
    }, resolveDisabled: e.virtual.disabled, resolveId() {
      throw new Error("Function not implemented.");
    } }), p = (s = t.trigger) != null ? s : 2;
    return e.activeOptionIndex === d && e.activationTrigger === p ? e : { ...e, activeOptionIndex: d, activationTrigger: p };
  }
  let a = zc(e);
  if (a.activeOptionIndex === null) {
    let d = a.options.findIndex((p) => !p.dataRef.current.disabled);
    d !== -1 && (a.activeOptionIndex = d);
  }
  let l = t.focus === We.Specific ? t.idx : Ju(t, { resolveItems: () => a.options, resolveActiveIndex: () => a.activeOptionIndex, resolveId: (d) => d.id, resolveDisabled: (d) => d.dataRef.current.disabled }), u = (i = t.trigger) != null ? i : 2;
  return e.activeOptionIndex === l && e.activationTrigger === u ? e : { ...e, ...a, activeOptionIndex: l, activationTrigger: u };
}, 3: (e, t) => {
  var n, r, o;
  if ((n = e.dataRef.current) != null && n.virtual)
    return { ...e, options: [...e.options, t.payload] };
  let s = t.payload, i = zc(e, (l) => (l.push(s), l));
  e.activeOptionIndex === null && (r = e.dataRef.current) != null && r.isSelected(t.payload.dataRef.current.value) && (i.activeOptionIndex = i.options.indexOf(s));
  let a = { ...e, ...i, activationTrigger: 2 };
  return (o = e.dataRef.current) != null && o.__demoMode && e.dataRef.current.value === void 0 && (a.activeOptionIndex = 0), a;
}, 4: (e, t) => {
  var n;
  if ((n = e.dataRef.current) != null && n.virtual)
    return { ...e, options: e.options.filter((o) => o.id !== t.id) };
  let r = zc(e, (o) => {
    let s = o.findIndex((i) => i.id === t.id);
    return s !== -1 && o.splice(s, 1), o;
  });
  return { ...e, ...r, activationTrigger: 2 };
}, 5: (e, t) => e.labelId === t.id ? e : { ...e, labelId: t.id }, 6: (e, t) => e.activationTrigger === t.trigger ? e : { ...e, activationTrigger: t.trigger }, 7: (e, t) => {
  var n;
  if (((n = e.virtual) == null ? void 0 : n.options) === t.options)
    return e;
  let r = e.activeOptionIndex;
  if (e.activeOptionIndex !== null) {
    let o = t.options.indexOf(e.virtual.options[e.activeOptionIndex]);
    o !== -1 ? r = o : r = null;
  }
  return { ...e, activeOptionIndex: r, virtual: Object.assign({}, e.virtual, { options: t.options }) };
} }, op = Be(null);
op.displayName = "ComboboxActionsContext";
function Gi(e) {
  let t = Le(op);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Gi), n;
  }
  return t;
}
let j1 = Be(null);
function rC(e) {
  var t;
  let n = ko("VirtualProvider"), [r, o] = ie(() => {
    let l = n.optionsRef.current;
    if (!l)
      return [0, 0];
    let u = window.getComputedStyle(l);
    return [parseFloat(u.paddingBlockStart || u.paddingTop), parseFloat(u.paddingBlockEnd || u.paddingBottom)];
  }, [n.optionsRef.current]), s = j2({ scrollPaddingStart: r, scrollPaddingEnd: o, count: n.virtual.options.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    var l;
    return (l = n.optionsRef.current) != null ? l : null;
  }, overscan: 12 }), [i, a] = W(0);
  return $e(() => {
    a((l) => l + 1);
  }, [(t = n.virtual) == null ? void 0 : t.options]), H.createElement(j1.Provider, { value: s }, H.createElement("div", { style: { position: "relative", width: "100%", height: `${s.getTotalSize()}px` }, ref: (l) => {
    if (l) {
      if (typeof process < "u" && { NODE_ENV: "production", NPM_PACKAGE_VERSION: "1.0.0", STUDIO_NPM_PACKAGE_VERSION: "1.0.35" }.JEST_WORKER_ID !== void 0 || n.activationTrigger === 0)
        return;
      n.activeOptionIndex !== null && n.virtual.options.length > n.activeOptionIndex && s.scrollToIndex(n.activeOptionIndex);
    }
  } }, s.getVirtualItems().map((l) => {
    var u;
    return H.createElement(wt, { key: l.key }, H.cloneElement((u = e.children) == null ? void 0 : u.call(e, { option: n.virtual.options[l.index], open: n.comboboxState === 0 }), { key: `${i}-${l.key}`, "data-index": l.index, "aria-setsize": n.virtual.options.length, "aria-posinset": l.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${l.start}px)`, overflowAnchor: "none" } }));
  })));
}
let sp = Be(null);
sp.displayName = "ComboboxDataContext";
function ko(e) {
  let t = Le(sp);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, ko), n;
  }
  return t;
}
function oC(e, t) {
  return Oe(t.type, nC, e, t);
}
let sC = wt;
function iC(e, t) {
  let { value: n, defaultValue: r, onChange: o, form: s, name: i, by: a = null, disabled: l = !1, __demoMode: u = !1, nullable: d = !1, multiple: p = !1, immediate: f = !1, virtual: h = null, ...g } = e, m = !1, v = null, [b = p ? [] : void 0, y] = zl(n, o, r), [w, S] = Qr(oC, { dataRef: bi(), comboboxState: u ? 0 : 1, options: [], virtual: null, activeOptionIndex: null, activationTrigger: 2, labelId: null }), x = K(!1), C = K({ static: !1, hold: !1 }), P = K(null), _ = K(null), O = K(null), E = K(null), T = ee(typeof a == "string" ? (te, de) => {
    let ce = a;
    return (te == null ? void 0 : te[ce]) === (de == null ? void 0 : de[ce]);
  } : a ?? ((te, de) => te === de)), R = ee((te) => w.options.findIndex((de) => T(de.dataRef.current.value, te))), B = it((te) => Oe(L.mode, { 1: () => b.some((de) => T(de, te)), 0: () => T(b, te) }), [b]), U = ee((te) => w.activeOptionIndex === R(te)), L = ie(() => ({ ...w, immediate: m, optionsPropsRef: C, labelRef: P, inputRef: _, buttonRef: O, optionsRef: E, value: b, defaultValue: r, disabled: l, mode: p ? 1 : 0, virtual: w.virtual, get activeOptionIndex() {
    if (x.current && w.activeOptionIndex === null && w.options.length > 0) {
      let te = w.options.findIndex((de) => !de.dataRef.current.disabled);
      if (te !== -1)
        return te;
    }
    return w.activeOptionIndex;
  }, calculateIndex: R, compare: T, isSelected: B, isActive: U, nullable: d, __demoMode: u }), [b, r, l, p, d, u, w, v]);
  $e(() => {
  }, [v, void 0]), $e(() => {
    w.dataRef.current = L;
  }, [L]), Wl([L.buttonRef, L.inputRef, L.optionsRef], () => re.closeCombobox(), L.comboboxState === 0);
  let M = ie(() => {
    var te, de, ce;
    return { open: L.comboboxState === 0, disabled: l, activeIndex: L.activeOptionIndex, activeOption: L.activeOptionIndex === null ? null : L.virtual ? L.virtual.options[(te = L.activeOptionIndex) != null ? te : 0] : (ce = (de = L.options[L.activeOptionIndex]) == null ? void 0 : de.dataRef.current.value) != null ? ce : null, value: b };
  }, [L, l, b]), D = ee(() => {
    if (L.activeOptionIndex !== null) {
      if (L.virtual)
        le(L.virtual.options[L.activeOptionIndex]);
      else {
        let { dataRef: te } = L.options[L.activeOptionIndex];
        le(te.current.value);
      }
      re.goToOption(We.Specific, L.activeOptionIndex);
    }
  }), V = ee(() => {
    S({ type: 0 }), x.current = !0;
  }), k = ee(() => {
    S({ type: 1 }), x.current = !1;
  }), j = ee((te, de, ce) => (x.current = !1, te === We.Specific ? S({ type: 2, focus: We.Specific, idx: de, trigger: ce }) : S({ type: 2, focus: te, trigger: ce }))), Y = ee((te, de) => (S({ type: 3, payload: { id: te, dataRef: de } }), () => {
    L.isActive(de.current.value) && (x.current = !0), S({ type: 4, id: te });
  })), J = ee((te) => (S({ type: 5, id: te }), () => S({ type: 5, id: null }))), le = ee((te) => Oe(L.mode, { 0() {
    return y == null ? void 0 : y(te);
  }, 1() {
    let de = L.value.slice(), ce = de.findIndex((Ce) => T(Ce, te));
    return ce === -1 ? de.push(te) : de.splice(ce, 1), y == null ? void 0 : y(de);
  } })), Q = ee((te) => {
    S({ type: 6, trigger: te });
  }), re = ie(() => ({ onChange: le, registerOption: Y, registerLabel: J, goToOption: j, closeCombobox: k, openCombobox: V, setActivationTrigger: Q, selectActiveOption: D }), []), ge = t === null ? {} : { ref: t }, X = K(null), Z = Pn();
  return G(() => {
    X.current && r !== void 0 && Z.addEventListener(X.current, "reset", () => {
      y == null || y(r);
    });
  }, [X, y]), H.createElement(op.Provider, { value: re }, H.createElement(sp.Provider, { value: L }, H.createElement(Wi, { value: Oe(L.comboboxState, { 0: Ke.Open, 1: Ke.Closed }) }, i != null && b != null && Gl({ [i]: b }).map(([te, de], ce) => H.createElement(sn, { features: on.Hidden, ref: ce === 0 ? (Ce) => {
    var Pe;
    X.current = (Pe = Ce == null ? void 0 : Ce.closest("form")) != null ? Pe : null;
  } : void 0, ...gs({ key: te, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: s, disabled: l, name: te, value: de }) })), _e({ ourProps: ge, theirProps: g, slot: M, defaultTag: sC, name: "Combobox" }))));
}
let aC = "input";
function lC(e, t) {
  var n, r, o, s, i;
  let a = Xe(), { id: l = `headlessui-combobox-input-${a}`, onChange: u, displayValue: d, type: p = "text", ...f } = e, h = ko("Combobox.Input"), g = Gi("Combobox.Input"), m = ke(h.inputRef, t), v = $r(h.inputRef), b = K(!1), y = Pn(), w = ee(() => {
    g.onChange(null), h.optionsRef.current && (h.optionsRef.current.scrollTop = 0), g.goToOption(We.Nothing);
  }), S = function() {
    var L;
    return typeof d == "function" && h.value !== void 0 ? (L = d(h.value)) != null ? L : "" : typeof h.value == "string" ? h.value : "";
  }();
  Ci(([L, M], [D, V]) => {
    if (b.current)
      return;
    let k = h.inputRef.current;
    k && ((V === 0 && M === 1 || L !== D) && (k.value = L), requestAnimationFrame(() => {
      if (b.current || !k || (v == null ? void 0 : v.activeElement) !== k)
        return;
      let { selectionStart: j, selectionEnd: Y } = k;
      Math.abs((Y ?? 0) - (j ?? 0)) === 0 && j === 0 && k.setSelectionRange(k.value.length, k.value.length);
    }));
  }, [S, h.comboboxState, v]), Ci(([L], [M]) => {
    if (L === 0 && M === 1) {
      if (b.current)
        return;
      let D = h.inputRef.current;
      if (!D)
        return;
      let V = D.value, { selectionStart: k, selectionEnd: j, selectionDirection: Y } = D;
      D.value = "", D.value = V, Y !== null ? D.setSelectionRange(k, j, Y) : D.setSelectionRange(k, j);
    }
  }, [h.comboboxState]);
  let x = K(!1), C = ee(() => {
    x.current = !0;
  }), P = ee(() => {
    y.nextFrame(() => {
      x.current = !1;
    });
  }), _ = ee((L) => {
    switch (b.current = !0, L.key) {
      case ve.Enter:
        if (b.current = !1, h.comboboxState !== 0 || x.current)
          return;
        if (L.preventDefault(), L.stopPropagation(), h.activeOptionIndex === null) {
          g.closeCombobox();
          return;
        }
        g.selectActiveOption(), h.mode === 0 && g.closeCombobox();
        break;
      case ve.ArrowDown:
        return b.current = !1, L.preventDefault(), L.stopPropagation(), Oe(h.comboboxState, { 0: () => g.goToOption(We.Next), 1: () => g.openCombobox() });
      case ve.ArrowUp:
        return b.current = !1, L.preventDefault(), L.stopPropagation(), Oe(h.comboboxState, { 0: () => g.goToOption(We.Previous), 1: () => {
          g.openCombobox(), y.nextFrame(() => {
            h.value || g.goToOption(We.Last);
          });
        } });
      case ve.Home:
        if (L.shiftKey)
          break;
        return b.current = !1, L.preventDefault(), L.stopPropagation(), g.goToOption(We.First);
      case ve.PageUp:
        return b.current = !1, L.preventDefault(), L.stopPropagation(), g.goToOption(We.First);
      case ve.End:
        if (L.shiftKey)
          break;
        return b.current = !1, L.preventDefault(), L.stopPropagation(), g.goToOption(We.Last);
      case ve.PageDown:
        return b.current = !1, L.preventDefault(), L.stopPropagation(), g.goToOption(We.Last);
      case ve.Escape:
        return b.current = !1, h.comboboxState !== 0 ? void 0 : (L.preventDefault(), h.optionsRef.current && !h.optionsPropsRef.current.static && L.stopPropagation(), h.nullable && h.mode === 0 && h.value === null && w(), g.closeCombobox());
      case ve.Tab:
        if (b.current = !1, h.comboboxState !== 0)
          return;
        h.mode === 0 && h.activationTrigger !== 1 && g.selectActiveOption(), g.closeCombobox();
        break;
    }
  }), O = ee((L) => {
    u == null || u(L), h.nullable && h.mode === 0 && L.target.value === "" && w(), g.openCombobox();
  }), E = ee((L) => {
    var M, D, V;
    let k = (M = L.relatedTarget) != null ? M : Zn.find((j) => j !== L.currentTarget);
    if (b.current = !1, !((D = h.optionsRef.current) != null && D.contains(k)) && !((V = h.buttonRef.current) != null && V.contains(k)) && h.comboboxState === 0)
      return L.preventDefault(), h.mode === 0 && (h.nullable && h.value === null ? w() : h.activationTrigger !== 1 && g.selectActiveOption()), g.closeCombobox();
  }), T = ee((L) => {
    var M, D, V;
    let k = (M = L.relatedTarget) != null ? M : Zn.find((j) => j !== L.currentTarget);
    (D = h.buttonRef.current) != null && D.contains(k) || (V = h.optionsRef.current) != null && V.contains(k) || h.disabled || h.immediate && h.comboboxState !== 0 && (g.openCombobox(), y.nextFrame(() => {
      g.setActivationTrigger(1);
    }));
  }), R = Fi(() => {
    if (h.labelId)
      return [h.labelId].join(" ");
  }, [h.labelId]), B = ie(() => ({ open: h.comboboxState === 0, disabled: h.disabled }), [h]), U = { ref: m, id: l, role: "combobox", type: p, "aria-controls": (n = h.optionsRef.current) == null ? void 0 : n.id, "aria-expanded": h.comboboxState === 0, "aria-activedescendant": h.activeOptionIndex === null ? void 0 : h.virtual ? (r = h.options.find((L) => {
    var M;
    return !((M = h.virtual) != null && M.disabled(L.dataRef.current.value)) && h.compare(L.dataRef.current.value, h.virtual.options[h.activeOptionIndex]);
  })) == null ? void 0 : r.id : (o = h.options[h.activeOptionIndex]) == null ? void 0 : o.id, "aria-labelledby": R, "aria-autocomplete": "list", defaultValue: (i = (s = e.defaultValue) != null ? s : h.defaultValue !== void 0 ? d == null ? void 0 : d(h.defaultValue) : null) != null ? i : h.defaultValue, disabled: h.disabled, onCompositionStart: C, onCompositionEnd: P, onKeyDown: _, onChange: O, onFocus: T, onBlur: E };
  return _e({ ourProps: U, theirProps: f, slot: B, defaultTag: aC, name: "Combobox.Input" });
}
let cC = "button";
function uC(e, t) {
  var n;
  let r = ko("Combobox.Button"), o = Gi("Combobox.Button"), s = ke(r.buttonRef, t), i = Xe(), { id: a = `headlessui-combobox-button-${i}`, ...l } = e, u = Pn(), d = ee((m) => {
    switch (m.key) {
      case ve.ArrowDown:
        return m.preventDefault(), m.stopPropagation(), r.comboboxState === 1 && o.openCombobox(), u.nextFrame(() => {
          var v;
          return (v = r.inputRef.current) == null ? void 0 : v.focus({ preventScroll: !0 });
        });
      case ve.ArrowUp:
        return m.preventDefault(), m.stopPropagation(), r.comboboxState === 1 && (o.openCombobox(), u.nextFrame(() => {
          r.value || o.goToOption(We.Last);
        })), u.nextFrame(() => {
          var v;
          return (v = r.inputRef.current) == null ? void 0 : v.focus({ preventScroll: !0 });
        });
      case ve.Escape:
        return r.comboboxState !== 0 ? void 0 : (m.preventDefault(), r.optionsRef.current && !r.optionsPropsRef.current.static && m.stopPropagation(), o.closeCombobox(), u.nextFrame(() => {
          var v;
          return (v = r.inputRef.current) == null ? void 0 : v.focus({ preventScroll: !0 });
        }));
      default:
        return;
    }
  }), p = ee((m) => {
    if (Tr(m.currentTarget))
      return m.preventDefault();
    r.comboboxState === 0 ? o.closeCombobox() : (m.preventDefault(), o.openCombobox()), u.nextFrame(() => {
      var v;
      return (v = r.inputRef.current) == null ? void 0 : v.focus({ preventScroll: !0 });
    });
  }), f = Fi(() => {
    if (r.labelId)
      return [r.labelId, a].join(" ");
  }, [r.labelId, a]), h = ie(() => ({ open: r.comboboxState === 0, disabled: r.disabled, value: r.value }), [r]), g = { ref: s, id: a, type: Os(e, r.buttonRef), tabIndex: -1, "aria-haspopup": "listbox", "aria-controls": (n = r.optionsRef.current) == null ? void 0 : n.id, "aria-expanded": r.comboboxState === 0, "aria-labelledby": f, disabled: r.disabled, onClick: p, onKeyDown: d };
  return _e({ ourProps: g, theirProps: l, slot: h, defaultTag: cC, name: "Combobox.Button" });
}
let dC = "label";
function pC(e, t) {
  let n = Xe(), { id: r = `headlessui-combobox-label-${n}`, ...o } = e, s = ko("Combobox.Label"), i = Gi("Combobox.Label"), a = ke(s.labelRef, t);
  $e(() => i.registerLabel(r), [r]);
  let l = ee(() => {
    var d;
    return (d = s.inputRef.current) == null ? void 0 : d.focus({ preventScroll: !0 });
  }), u = ie(() => ({ open: s.comboboxState === 0, disabled: s.disabled }), [s]);
  return _e({ ourProps: { ref: a, id: r, onClick: l }, theirProps: o, slot: u, defaultTag: dC, name: "Combobox.Label" });
}
let fC = "ul", hC = Dt.RenderStrategy | Dt.Static;
function gC(e, t) {
  let n = Xe(), { id: r = `headlessui-combobox-options-${n}`, hold: o = !1, ...s } = e, i = ko("Combobox.Options"), a = ke(i.optionsRef, t), l = so(), u = (() => l !== null ? (l & Ke.Open) === Ke.Open : i.comboboxState === 0)();
  $e(() => {
    var h;
    i.optionsPropsRef.current.static = (h = e.static) != null ? h : !1;
  }, [i.optionsPropsRef, e.static]), $e(() => {
    i.optionsPropsRef.current.hold = o;
  }, [i.optionsPropsRef, o]), k1({ container: i.optionsRef.current, enabled: i.comboboxState === 0, accept(h) {
    return h.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : h.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(h) {
    h.setAttribute("role", "none");
  } });
  let d = Fi(() => {
    var h, g;
    return (g = i.labelId) != null ? g : (h = i.buttonRef.current) == null ? void 0 : h.id;
  }, [i.labelId, i.buttonRef.current]), p = ie(() => ({ open: i.comboboxState === 0, option: void 0 }), [i]), f = { "aria-labelledby": d, role: "listbox", "aria-multiselectable": i.mode === 1 ? !0 : void 0, id: r, ref: a };
  return i.virtual && i.comboboxState === 0 && Object.assign(s, { children: H.createElement(rC, null, s.children) }), _e({ ourProps: f, theirProps: s, slot: p, defaultTag: fC, features: hC, visible: u, name: "Combobox.Options" });
}
let mC = "li";
function vC(e, t) {
  var n;
  let r = Xe(), { id: o = `headlessui-combobox-option-${r}`, disabled: s = !1, value: i, order: a = null, ...l } = e, u = ko("Combobox.Option"), d = Gi("Combobox.Option"), p = u.virtual ? u.activeOptionIndex === u.calculateIndex(i) : u.activeOptionIndex === null ? !1 : ((n = u.options[u.activeOptionIndex]) == null ? void 0 : n.id) === o, f = u.isSelected(i), h = K(null), g = Ct({ disabled: s, value: i, domRef: h, order: a }), m = Le(j1), v = ke(t, h, m ? m.measureElement : null), b = ee(() => d.onChange(i));
  $e(() => d.registerOption(o, g), [g, o]);
  let y = K(!(u.virtual || u.__demoMode));
  $e(() => {
    if (!u.virtual || !u.__demoMode)
      return;
    let E = Cn();
    return E.requestAnimationFrame(() => {
      y.current = !0;
    }), E.dispose;
  }, [u.virtual, u.__demoMode]), $e(() => {
    if (!y.current || u.comboboxState !== 0 || !p || u.activationTrigger === 0)
      return;
    let E = Cn();
    return E.requestAnimationFrame(() => {
      var T, R;
      (R = (T = h.current) == null ? void 0 : T.scrollIntoView) == null || R.call(T, { block: "nearest" });
    }), E.dispose;
  }, [h, p, u.comboboxState, u.activationTrigger, u.activeOptionIndex]);
  let w = ee((E) => {
    var T;
    if (s || (T = u.virtual) != null && T.disabled(i))
      return E.preventDefault();
    b(), _1() || requestAnimationFrame(() => {
      var R;
      return (R = u.inputRef.current) == null ? void 0 : R.focus({ preventScroll: !0 });
    }), u.mode === 0 && requestAnimationFrame(() => d.closeCombobox());
  }), S = ee(() => {
    var E;
    if (s || (E = u.virtual) != null && E.disabled(i))
      return d.goToOption(We.Nothing);
    let T = u.calculateIndex(i);
    d.goToOption(We.Specific, T);
  }), x = L1(), C = ee((E) => x.update(E)), P = ee((E) => {
    var T;
    if (!x.wasMoved(E) || s || (T = u.virtual) != null && T.disabled(i) || p)
      return;
    let R = u.calculateIndex(i);
    d.goToOption(We.Specific, R, 0);
  }), _ = ee((E) => {
    var T;
    x.wasMoved(E) && (s || (T = u.virtual) != null && T.disabled(i) || p && (u.optionsPropsRef.current.hold || d.goToOption(We.Nothing)));
  }), O = ie(() => ({ active: p, selected: f, disabled: s }), [p, f, s]);
  return _e({ ourProps: { id: o, ref: v, role: "option", tabIndex: s === !0 ? void 0 : -1, "aria-disabled": s === !0 ? !0 : void 0, "aria-selected": f, disabled: void 0, onClick: w, onFocus: S, onPointerEnter: C, onMouseEnter: C, onPointerMove: P, onMouseMove: P, onPointerLeave: _, onMouseLeave: _ }, theirProps: l, slot: O, defaultTag: mC, name: "Combobox.Option" });
}
let bC = Te(iC), yC = Te(uC), wC = Te(lC), SC = Te(pC), xC = Te(gC), CC = Te(vC), zo = Object.assign(bC, { Input: wC, Button: yC, Label: SC, Options: xC, Option: CC });
function ip(e, t, n, r) {
  let o = Ct(n);
  G(() => {
    e = e ?? window;
    function s(i) {
      o.current(i);
    }
    return e.addEventListener(t, s, r), () => e.removeEventListener(t, s, r);
  }, [e, t, r]);
}
function _s() {
  let e = K(!1);
  return $e(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function D1(e) {
  let t = ee(e), n = K(!1);
  G(() => (n.current = !1, () => {
    n.current = !0, Ui(() => {
      n.current && t();
    });
  }), [t]);
}
var nn = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(nn || {});
function ap() {
  let e = K(0);
  return T1("keydown", (t) => {
    t.key === "Tab" && (e.current = t.shiftKey ? 1 : 0);
  }, !0), e;
}
function I1(e) {
  if (!e)
    return /* @__PURE__ */ new Set();
  if (typeof e == "function")
    return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let n of e.current)
    n.current instanceof HTMLElement && t.add(n.current);
  return t;
}
let PC = "div";
var V1 = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(V1 || {});
function EC(e, t) {
  let n = K(null), r = ke(n, t), { initialFocus: o, containers: s, features: i = 30, ...a } = e;
  Es() || (i = 1);
  let l = $r(n);
  TC({ ownerDocument: l }, !!(i & 16));
  let u = AC({ ownerDocument: l, container: n, initialFocus: o }, !!(i & 2));
  LC({ ownerDocument: l, container: n, containers: s, previousActiveElement: u }, !!(i & 8));
  let d = ap(), p = ee((m) => {
    let v = n.current;
    v && ((b) => b())(() => {
      Oe(d.current, { [nn.Forwards]: () => {
        xt(v, Ye.First, { skipElements: [m.relatedTarget] });
      }, [nn.Backwards]: () => {
        xt(v, Ye.Last, { skipElements: [m.relatedTarget] });
      } });
    });
  }), f = Pn(), h = K(!1), g = { ref: r, onKeyDown(m) {
    m.key == "Tab" && (h.current = !0, f.requestAnimationFrame(() => {
      h.current = !1;
    }));
  }, onBlur(m) {
    let v = I1(s);
    n.current instanceof HTMLElement && v.add(n.current);
    let b = m.relatedTarget;
    b instanceof HTMLElement && b.dataset.headlessuiFocusGuard !== "true" && (H1(v, b) || (h.current ? xt(n.current, Oe(d.current, { [nn.Forwards]: () => Ye.Next, [nn.Backwards]: () => Ye.Previous }) | Ye.WrapAround, { relativeTo: m.target }) : m.target instanceof HTMLElement && mo(m.target)));
  } };
  return H.createElement(H.Fragment, null, !!(i & 4) && H.createElement(sn, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: p, features: on.Focusable }), _e({ ourProps: g, theirProps: a, defaultTag: PC, name: "FocusTrap" }), !!(i & 4) && H.createElement(sn, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: p, features: on.Focusable }));
}
let OC = Te(EC), Bs = Object.assign(OC, { features: V1 });
function _C(e = !0) {
  let t = K(Zn.slice());
  return Ci(([n], [r]) => {
    r === !0 && n === !1 && Ui(() => {
      t.current.splice(0);
    }), r === !1 && n === !0 && (t.current = Zn.slice());
  }, [e, Zn, t]), ee(() => {
    var n;
    return (n = t.current.find((r) => r != null && r.isConnected)) != null ? n : null;
  });
}
function TC({ ownerDocument: e }, t) {
  let n = _C(t);
  Ci(() => {
    t || (e == null ? void 0 : e.activeElement) === (e == null ? void 0 : e.body) && mo(n());
  }, [t]), D1(() => {
    t && mo(n());
  });
}
function AC({ ownerDocument: e, container: t, initialFocus: n }, r) {
  let o = K(null), s = _s();
  return Ci(() => {
    if (!r)
      return;
    let i = t.current;
    i && Ui(() => {
      if (!s.current)
        return;
      let a = e == null ? void 0 : e.activeElement;
      if (n != null && n.current) {
        if ((n == null ? void 0 : n.current) === a) {
          o.current = a;
          return;
        }
      } else if (i.contains(a)) {
        o.current = a;
        return;
      }
      n != null && n.current ? mo(n.current) : xt(i, Ye.First) === Rn.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), o.current = e == null ? void 0 : e.activeElement;
    });
  }, [r]), o;
}
function LC({ ownerDocument: e, container: t, containers: n, previousActiveElement: r }, o) {
  let s = _s();
  ip(e == null ? void 0 : e.defaultView, "focus", (i) => {
    if (!o || !s.current)
      return;
    let a = I1(n);
    t.current instanceof HTMLElement && a.add(t.current);
    let l = r.current;
    if (!l)
      return;
    let u = i.target;
    u && u instanceof HTMLElement ? H1(a, u) ? (r.current = u, mo(u)) : (i.preventDefault(), i.stopPropagation(), mo(l)) : mo(r.current);
  }, !0);
}
function H1(e, t) {
  for (let n of e)
    if (n.contains(t))
      return !0;
  return !1;
}
let B1 = Be(!1);
function kC() {
  return Le(B1);
}
function Qu(e) {
  return H.createElement(B1.Provider, { value: e.force }, e.children);
}
function MC(e) {
  let t = kC(), n = Le(z1), r = $r(e), [o, s] = W(() => {
    if (!t && n !== null || Er.isServer)
      return null;
    let i = r == null ? void 0 : r.getElementById("headlessui-portal-root");
    if (i)
      return i;
    if (r === null)
      return null;
    let a = r.createElement("div");
    return a.setAttribute("id", "headlessui-portal-root"), r.body.appendChild(a);
  });
  return G(() => {
    o !== null && (r != null && r.body.contains(o) || r == null || r.body.appendChild(o));
  }, [o, r]), G(() => {
    t || n !== null && s(n.current);
  }, [n, s, t]), o;
}
let $C = wt;
function RC(e, t) {
  let n = e, r = K(null), o = ke(tp((d) => {
    r.current = d;
  }), t), s = $r(r), i = MC(r), [a] = W(() => {
    var d;
    return Er.isServer ? null : (d = s == null ? void 0 : s.createElement("div")) != null ? d : null;
  }), l = Le(ed), u = Es();
  return $e(() => {
    !i || !a || i.contains(a) || (a.setAttribute("data-headlessui-portal", ""), i.appendChild(a));
  }, [i, a]), $e(() => {
    if (a && l)
      return l.register(a);
  }, [l, a]), D1(() => {
    var d;
    !i || !a || (a instanceof Node && i.contains(a) && i.removeChild(a), i.childNodes.length <= 0 && ((d = i.parentElement) == null || d.removeChild(i)));
  }), u ? !i || !a ? null : jd(_e({ ourProps: { ref: o }, theirProps: n, defaultTag: $C, name: "Portal" }), a) : null;
}
let NC = wt, z1 = Be(null);
function jC(e, t) {
  let { target: n, ...r } = e, o = { ref: ke(t) };
  return H.createElement(z1.Provider, { value: n }, _e({ ourProps: o, theirProps: r, defaultTag: NC, name: "Popover.Group" }));
}
let ed = Be(null);
function F1() {
  let e = Le(ed), t = K([]), n = ee((s) => (t.current.push(s), e && e.register(s), () => r(s))), r = ee((s) => {
    let i = t.current.indexOf(s);
    i !== -1 && t.current.splice(i, 1), e && e.unregister(s);
  }), o = ie(() => ({ register: n, unregister: r, portals: t }), [n, r, t]);
  return [t, ie(() => function({ children: s }) {
    return H.createElement(ed.Provider, { value: o }, s);
  }, [o])];
}
let DC = Te(RC), IC = Te(jC), td = Object.assign(DC, { Group: IC });
function VC(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
const HC = typeof Object.is == "function" ? Object.is : VC, { useState: BC, useEffect: zC, useLayoutEffect: FC, useDebugValue: UC } = Ue;
function WC(e, t, n) {
  const r = t(), [{ inst: o }, s] = BC({ inst: { value: r, getSnapshot: t } });
  return FC(() => {
    o.value = r, o.getSnapshot = t, Fc(o) && s({ inst: o });
  }, [e, r, t]), zC(() => (Fc(o) && s({ inst: o }), e(() => {
    Fc(o) && s({ inst: o });
  })), [e]), UC(r), r;
}
function Fc(e) {
  const t = e.getSnapshot, n = e.value;
  try {
    const r = t();
    return !HC(n, r);
  } catch {
    return !0;
  }
}
function GC(e, t, n) {
  return t();
}
const KC = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", qC = !KC, YC = qC ? GC : WC, XC = "useSyncExternalStore" in Ue ? ((e) => e.useSyncExternalStore)(Ue) : YC;
function ZC(e) {
  return XC(e.subscribe, e.getSnapshot, e.getSnapshot);
}
function JC(e, t) {
  let n = e(), r = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return n;
  }, subscribe(o) {
    return r.add(o), () => r.delete(o);
  }, dispatch(o, ...s) {
    let i = t[o].call(n, ...s);
    i && (n = i, r.forEach((a) => a()));
  } };
}
function QC() {
  let e;
  return { before({ doc: t }) {
    var n;
    let r = t.documentElement;
    e = ((n = t.defaultView) != null ? n : window).innerWidth - r.clientWidth;
  }, after({ doc: t, d: n }) {
    let r = t.documentElement, o = r.clientWidth - r.offsetWidth, s = e - o;
    n.style(r, "paddingRight", `${s}px`);
  } };
}
function eP() {
  return O1() ? { before({ doc: e, d: t, meta: n }) {
    function r(o) {
      return n.containers.flatMap((s) => s()).some((s) => s.contains(o));
    }
    t.microTask(() => {
      var o;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let a = Cn();
        a.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => a.dispose()));
      }
      let s = (o = window.scrollY) != null ? o : window.pageYOffset, i = null;
      t.addEventListener(e, "click", (a) => {
        if (a.target instanceof HTMLElement)
          try {
            let l = a.target.closest("a");
            if (!l)
              return;
            let { hash: u } = new URL(l.href), d = e.querySelector(u);
            d && !r(d) && (i = d);
          } catch {
          }
      }, !0), t.addEventListener(e, "touchstart", (a) => {
        if (a.target instanceof HTMLElement)
          if (r(a.target)) {
            let l = a.target;
            for (; l.parentElement && r(l.parentElement); )
              l = l.parentElement;
            t.style(l, "overscrollBehavior", "contain");
          } else
            t.style(a.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (a) => {
        if (a.target instanceof HTMLElement)
          if (r(a.target)) {
            let l = a.target;
            for (; l.parentElement && l.dataset.headlessuiPortal !== "" && !(l.scrollHeight > l.clientHeight || l.scrollWidth > l.clientWidth); )
              l = l.parentElement;
            l.dataset.headlessuiPortal === "" && a.preventDefault();
          } else
            a.preventDefault();
      }, { passive: !1 }), t.add(() => {
        var a;
        let l = (a = window.scrollY) != null ? a : window.pageYOffset;
        s !== l && window.scrollTo(0, s), i && i.isConnected && (i.scrollIntoView({ block: "nearest" }), i = null);
      });
    });
  } } : {};
}
function tP() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function nP(e) {
  let t = {};
  for (let n of e)
    Object.assign(t, n(t));
  return t;
}
let go = JC(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var n;
  let r = (n = this.get(e)) != null ? n : { doc: e, count: 0, d: Cn(), meta: /* @__PURE__ */ new Set() };
  return r.count++, r.meta.add(t), this.set(e, r), this;
}, POP(e, t) {
  let n = this.get(e);
  return n && (n.count--, n.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: n }) {
  let r = { doc: e, d: t, meta: nP(n) }, o = [eP(), QC(), tP()];
  o.forEach(({ before: s }) => s == null ? void 0 : s(r)), o.forEach(({ after: s }) => s == null ? void 0 : s(r));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
go.subscribe(() => {
  let e = go.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [n] of e)
    t.set(n, n.documentElement.style.overflow);
  for (let n of e.values()) {
    let r = t.get(n.doc) === "hidden", o = n.count !== 0;
    (o && !r || !o && r) && go.dispatch(n.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", n), n.count === 0 && go.dispatch("TEARDOWN", n);
  }
});
function rP(e, t, n) {
  let r = ZC(go), o = e ? r.get(e) : void 0, s = o ? o.count > 0 : !1;
  return $e(() => {
    if (!(!e || !t))
      return go.dispatch("PUSH", e, n), () => go.dispatch("POP", e, n);
  }, [t, e]), s;
}
let Uc = /* @__PURE__ */ new Map(), zs = /* @__PURE__ */ new Map();
function qf(e, t = !0) {
  $e(() => {
    var n;
    if (!t)
      return;
    let r = typeof e == "function" ? e() : e.current;
    if (!r)
      return;
    function o() {
      var i;
      if (!r)
        return;
      let a = (i = zs.get(r)) != null ? i : 1;
      if (a === 1 ? zs.delete(r) : zs.set(r, a - 1), a !== 1)
        return;
      let l = Uc.get(r);
      l && (l["aria-hidden"] === null ? r.removeAttribute("aria-hidden") : r.setAttribute("aria-hidden", l["aria-hidden"]), r.inert = l.inert, Uc.delete(r));
    }
    let s = (n = zs.get(r)) != null ? n : 0;
    return zs.set(r, s + 1), s !== 0 || (Uc.set(r, { "aria-hidden": r.getAttribute("aria-hidden"), inert: r.inert }), r.setAttribute("aria-hidden", "true"), r.inert = !0), o;
  }, [e, t]);
}
function U1({ defaultContainers: e = [], portals: t, mainTreeNodeRef: n } = {}) {
  var r;
  let o = K((r = n == null ? void 0 : n.current) != null ? r : null), s = $r(o), i = ee(() => {
    var a, l, u;
    let d = [];
    for (let p of e)
      p !== null && (p instanceof HTMLElement ? d.push(p) : "current" in p && p.current instanceof HTMLElement && d.push(p.current));
    if (t != null && t.current)
      for (let p of t.current)
        d.push(p);
    for (let p of (a = s == null ? void 0 : s.querySelectorAll("html > *, body > *")) != null ? a : [])
      p !== document.body && p !== document.head && p instanceof HTMLElement && p.id !== "headlessui-portal-root" && (p.contains(o.current) || p.contains((u = (l = o.current) == null ? void 0 : l.getRootNode()) == null ? void 0 : u.host) || d.some((f) => p.contains(f)) || d.push(p));
    return d;
  });
  return { resolveContainers: i, contains: ee((a) => i().some((l) => l.contains(a))), mainTreeNodeRef: o, MainTreeNode: ie(() => function() {
    return n != null ? null : H.createElement(sn, { features: on.Hidden, ref: o });
  }, [o, n]) };
}
function oP() {
  let e = K(null);
  return { mainTreeNodeRef: e, MainTreeNode: ie(() => function() {
    return H.createElement(sn, { features: on.Hidden, ref: e });
  }, [e]) };
}
let lp = Be(() => {
});
lp.displayName = "StackContext";
var nd = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(nd || {});
function sP() {
  return Le(lp);
}
function iP({ children: e, onUpdate: t, type: n, element: r, enabled: o }) {
  let s = sP(), i = ee((...a) => {
    t == null || t(...a), s(...a);
  });
  return $e(() => {
    let a = o === void 0 || o === !0;
    return a && i(0, n, r), () => {
      a && i(1, n, r);
    };
  }, [i, n, r, o]), H.createElement(lp.Provider, { value: i }, e);
}
let W1 = Be(null);
function G1() {
  let e = Le(W1);
  if (e === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, G1), t;
  }
  return e;
}
function Kl() {
  let [e, t] = W([]);
  return [e.length > 0 ? e.join(" ") : void 0, ie(() => function(n) {
    let r = ee((s) => (t((i) => [...i, s]), () => t((i) => {
      let a = i.slice(), l = a.indexOf(s);
      return l !== -1 && a.splice(l, 1), a;
    }))), o = ie(() => ({ register: r, slot: n.slot, name: n.name, props: n.props }), [r, n.slot, n.name, n.props]);
    return H.createElement(W1.Provider, { value: o }, n.children);
  }, [t])];
}
let aP = "p";
function lP(e, t) {
  let n = Xe(), { id: r = `headlessui-description-${n}`, ...o } = e, s = G1(), i = ke(t);
  $e(() => s.register(r), [r, s.register]);
  let a = { ref: i, ...s.props, id: r };
  return _e({ ourProps: a, theirProps: o, slot: s.slot || {}, defaultTag: aP, name: s.name || "Description" });
}
let cP = Te(lP), cp = Object.assign(cP, {});
var uP = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(uP || {}), dP = ((e) => (e[e.SetTitleId = 0] = "SetTitleId", e))(dP || {});
let pP = { 0(e, t) {
  return e.titleId === t.id ? e : { ...e, titleId: t.id };
} }, cl = Be(null);
cl.displayName = "DialogContext";
function Ki(e) {
  let t = Le(cl);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Ki), n;
  }
  return t;
}
function fP(e, t, n = () => [document.body]) {
  rP(e, t, (r) => {
    var o;
    return { containers: [...(o = r.containers) != null ? o : [], n] };
  });
}
function hP(e, t) {
  return Oe(t.type, pP, e, t);
}
let gP = "div", mP = Dt.RenderStrategy | Dt.Static;
function vP(e, t) {
  let n = Xe(), { id: r = `headlessui-dialog-${n}`, open: o, onClose: s, initialFocus: i, role: a = "dialog", __demoMode: l = !1, ...u } = e, [d, p] = W(0), f = K(!1);
  a = function() {
    return a === "dialog" || a === "alertdialog" ? a : (f.current || (f.current = !0, console.warn(`Invalid role [${a}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
  }();
  let h = so();
  o === void 0 && h !== null && (o = (h & Ke.Open) === Ke.Open);
  let g = K(null), m = ke(g, t), v = $r(g), b = e.hasOwnProperty("open") || h !== null, y = e.hasOwnProperty("onClose");
  if (!b && !y)
    throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!b)
    throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!y)
    throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (typeof o != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${o}`);
  if (typeof s != "function")
    throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${s}`);
  let w = o ? 0 : 1, [S, x] = Qr(hP, { titleId: null, descriptionId: null, panelRef: bi() }), C = ee(() => s(!1)), P = ee((ce) => x({ type: 0, id: ce })), _ = Es() ? l ? !1 : w === 0 : !1, O = d > 1, E = Le(cl) !== null, [T, R] = F1(), B = { get current() {
    var ce;
    return (ce = S.panelRef.current) != null ? ce : g.current;
  } }, { resolveContainers: U, mainTreeNodeRef: L, MainTreeNode: M } = U1({ portals: T, defaultContainers: [B] }), D = O ? "parent" : "leaf", V = h !== null ? (h & Ke.Closing) === Ke.Closing : !1, k = (() => E || V ? !1 : _)(), j = it(() => {
    var ce, Ce;
    return (Ce = Array.from((ce = v == null ? void 0 : v.querySelectorAll("body > *")) != null ? ce : []).find((Pe) => Pe.id === "headlessui-portal-root" ? !1 : Pe.contains(L.current) && Pe instanceof HTMLElement)) != null ? Ce : null;
  }, [L]);
  qf(j, k);
  let Y = (() => O ? !0 : _)(), J = it(() => {
    var ce, Ce;
    return (Ce = Array.from((ce = v == null ? void 0 : v.querySelectorAll("[data-headlessui-portal]")) != null ? ce : []).find((Pe) => Pe.contains(L.current) && Pe instanceof HTMLElement)) != null ? Ce : null;
  }, [L]);
  qf(J, Y);
  let le = (() => !(!_ || O))();
  Wl(U, (ce) => {
    ce.preventDefault(), C();
  }, le);
  let Q = (() => !(O || w !== 0))();
  ip(v == null ? void 0 : v.defaultView, "keydown", (ce) => {
    Q && (ce.defaultPrevented || ce.key === ve.Escape && (ce.preventDefault(), ce.stopPropagation(), C()));
  });
  let re = (() => !(V || w !== 0 || E))();
  fP(v, re, U), G(() => {
    if (w !== 0 || !g.current)
      return;
    let ce = new ResizeObserver((Ce) => {
      for (let Pe of Ce) {
        let at = Pe.target.getBoundingClientRect();
        at.x === 0 && at.y === 0 && at.width === 0 && at.height === 0 && C();
      }
    });
    return ce.observe(g.current), () => ce.disconnect();
  }, [w, g, C]);
  let [ge, X] = Kl(), Z = ie(() => [{ dialogState: w, close: C, setTitleId: P }, S], [w, S, C, P]), te = ie(() => ({ open: w === 0 }), [w]), de = { ref: m, id: r, role: a, "aria-modal": w === 0 ? !0 : void 0, "aria-labelledby": S.titleId, "aria-describedby": ge };
  return H.createElement(iP, { type: "Dialog", enabled: w === 0, element: g, onUpdate: ee((ce, Ce) => {
    Ce === "Dialog" && Oe(ce, { [nd.Add]: () => p((Pe) => Pe + 1), [nd.Remove]: () => p((Pe) => Pe - 1) });
  }) }, H.createElement(Qu, { force: !0 }, H.createElement(td, null, H.createElement(cl.Provider, { value: Z }, H.createElement(td.Group, { target: g }, H.createElement(Qu, { force: !1 }, H.createElement(X, { slot: te, name: "Dialog.Description" }, H.createElement(Bs, { initialFocus: i, containers: U, features: _ ? Oe(D, { parent: Bs.features.RestoreFocus, leaf: Bs.features.All & ~Bs.features.FocusLock }) : Bs.features.None }, H.createElement(R, null, _e({ ourProps: de, theirProps: u, slot: te, defaultTag: gP, features: mP, visible: w === 0, name: "Dialog" }))))))))), H.createElement(M, null));
}
let bP = "div";
function yP(e, t) {
  let n = Xe(), { id: r = `headlessui-dialog-overlay-${n}`, ...o } = e, [{ dialogState: s, close: i }] = Ki("Dialog.Overlay"), a = ke(t), l = ee((d) => {
    if (d.target === d.currentTarget) {
      if (Tr(d.currentTarget))
        return d.preventDefault();
      d.preventDefault(), d.stopPropagation(), i();
    }
  }), u = ie(() => ({ open: s === 0 }), [s]);
  return _e({ ourProps: { ref: a, id: r, "aria-hidden": !0, onClick: l }, theirProps: o, slot: u, defaultTag: bP, name: "Dialog.Overlay" });
}
let wP = "div";
function SP(e, t) {
  let n = Xe(), { id: r = `headlessui-dialog-backdrop-${n}`, ...o } = e, [{ dialogState: s }, i] = Ki("Dialog.Backdrop"), a = ke(t);
  G(() => {
    if (i.panelRef.current === null)
      throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
  }, [i.panelRef]);
  let l = ie(() => ({ open: s === 0 }), [s]);
  return H.createElement(Qu, { force: !0 }, H.createElement(td, null, _e({ ourProps: { ref: a, id: r, "aria-hidden": !0 }, theirProps: o, slot: l, defaultTag: wP, name: "Dialog.Backdrop" })));
}
let xP = "div";
function CP(e, t) {
  let n = Xe(), { id: r = `headlessui-dialog-panel-${n}`, ...o } = e, [{ dialogState: s }, i] = Ki("Dialog.Panel"), a = ke(t, i.panelRef), l = ie(() => ({ open: s === 0 }), [s]), u = ee((d) => {
    d.stopPropagation();
  });
  return _e({ ourProps: { ref: a, id: r, onClick: u }, theirProps: o, slot: l, defaultTag: xP, name: "Dialog.Panel" });
}
let PP = "h2";
function EP(e, t) {
  let n = Xe(), { id: r = `headlessui-dialog-title-${n}`, ...o } = e, [{ dialogState: s, setTitleId: i }] = Ki("Dialog.Title"), a = ke(t);
  G(() => (i(r), () => i(null)), [r, i]);
  let l = ie(() => ({ open: s === 0 }), [s]);
  return _e({ ourProps: { ref: a, id: r }, theirProps: o, slot: l, defaultTag: PP, name: "Dialog.Title" });
}
let OP = Te(vP), _P = Te(SP), TP = Te(CP), AP = Te(yP), LP = Te(EP), Fs = Object.assign(OP, { Backdrop: _P, Panel: TP, Overlay: AP, Title: LP, Description: cp });
var Yf;
let kP = (Yf = H.startTransition) != null ? Yf : function(e) {
  e();
};
var MP = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(MP || {}), $P = ((e) => (e[e.ToggleDisclosure = 0] = "ToggleDisclosure", e[e.CloseDisclosure = 1] = "CloseDisclosure", e[e.SetButtonId = 2] = "SetButtonId", e[e.SetPanelId = 3] = "SetPanelId", e[e.LinkPanel = 4] = "LinkPanel", e[e.UnlinkPanel = 5] = "UnlinkPanel", e))($P || {});
let RP = { 0: (e) => ({ ...e, disclosureState: Oe(e.disclosureState, { 0: 1, 1: 0 }) }), 1: (e) => e.disclosureState === 1 ? e : { ...e, disclosureState: 1 }, 4(e) {
  return e.linkedPanel === !0 ? e : { ...e, linkedPanel: !0 };
}, 5(e) {
  return e.linkedPanel === !1 ? e : { ...e, linkedPanel: !1 };
}, 2(e, t) {
  return e.buttonId === t.buttonId ? e : { ...e, buttonId: t.buttonId };
}, 3(e, t) {
  return e.panelId === t.panelId ? e : { ...e, panelId: t.panelId };
} }, up = Be(null);
up.displayName = "DisclosureContext";
function dp(e) {
  let t = Le(up);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, dp), n;
  }
  return t;
}
let pp = Be(null);
pp.displayName = "DisclosureAPIContext";
function K1(e) {
  let t = Le(pp);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, K1), n;
  }
  return t;
}
let fp = Be(null);
fp.displayName = "DisclosurePanelContext";
function NP() {
  return Le(fp);
}
function jP(e, t) {
  return Oe(t.type, RP, e, t);
}
let DP = wt;
function IP(e, t) {
  let { defaultOpen: n = !1, ...r } = e, o = K(null), s = ke(t, tp((v) => {
    o.current = v;
  }, e.as === void 0 || e.as === wt)), i = K(null), a = K(null), l = Qr(jP, { disclosureState: n ? 0 : 1, linkedPanel: !1, buttonRef: a, panelRef: i, buttonId: null, panelId: null }), [{ disclosureState: u, buttonId: d }, p] = l, f = ee((v) => {
    p({ type: 1 });
    let b = oo(o);
    if (!b || !d)
      return;
    let y = (() => v ? v instanceof HTMLElement ? v : v.current instanceof HTMLElement ? v.current : b.getElementById(d) : b.getElementById(d))();
    y == null || y.focus();
  }), h = ie(() => ({ close: f }), [f]), g = ie(() => ({ open: u === 0, close: f }), [u, f]), m = { ref: s };
  return H.createElement(up.Provider, { value: l }, H.createElement(pp.Provider, { value: h }, H.createElement(Wi, { value: Oe(u, { 0: Ke.Open, 1: Ke.Closed }) }, _e({ ourProps: m, theirProps: r, slot: g, defaultTag: DP, name: "Disclosure" }))));
}
let VP = "button";
function HP(e, t) {
  let n = Xe(), { id: r = `headlessui-disclosure-button-${n}`, ...o } = e, [s, i] = dp("Disclosure.Button"), a = NP(), l = a === null ? !1 : a === s.panelId, u = K(null), d = ke(u, t, l ? null : s.buttonRef), p = np();
  G(() => {
    if (!l)
      return i({ type: 2, buttonId: r }), () => {
        i({ type: 2, buttonId: null });
      };
  }, [r, i, l]);
  let f = ee((y) => {
    var w;
    if (l) {
      if (s.disclosureState === 1)
        return;
      switch (y.key) {
        case ve.Space:
        case ve.Enter:
          y.preventDefault(), y.stopPropagation(), i({ type: 0 }), (w = s.buttonRef.current) == null || w.focus();
          break;
      }
    } else
      switch (y.key) {
        case ve.Space:
        case ve.Enter:
          y.preventDefault(), y.stopPropagation(), i({ type: 0 });
          break;
      }
  }), h = ee((y) => {
    switch (y.key) {
      case ve.Space:
        y.preventDefault();
        break;
    }
  }), g = ee((y) => {
    var w;
    Tr(y.currentTarget) || e.disabled || (l ? (i({ type: 0 }), (w = s.buttonRef.current) == null || w.focus()) : i({ type: 0 }));
  }), m = ie(() => ({ open: s.disclosureState === 0 }), [s]), v = Os(e, u), b = l ? { ref: d, type: v, onKeyDown: f, onClick: g } : { ref: d, id: r, type: v, "aria-expanded": s.disclosureState === 0, "aria-controls": s.linkedPanel ? s.panelId : void 0, onKeyDown: f, onKeyUp: h, onClick: g };
  return _e({ mergeRefs: p, ourProps: b, theirProps: o, slot: m, defaultTag: VP, name: "Disclosure.Button" });
}
let BP = "div", zP = Dt.RenderStrategy | Dt.Static;
function FP(e, t) {
  let n = Xe(), { id: r = `headlessui-disclosure-panel-${n}`, ...o } = e, [s, i] = dp("Disclosure.Panel"), { close: a } = K1("Disclosure.Panel"), l = np(), u = ke(t, s.panelRef, (g) => {
    kP(() => i({ type: g ? 4 : 5 }));
  });
  G(() => (i({ type: 3, panelId: r }), () => {
    i({ type: 3, panelId: null });
  }), [r, i]);
  let d = so(), p = (() => d !== null ? (d & Ke.Open) === Ke.Open : s.disclosureState === 0)(), f = ie(() => ({ open: s.disclosureState === 0, close: a }), [s, a]), h = { ref: u, id: r };
  return H.createElement(fp.Provider, { value: s.panelId }, _e({ mergeRefs: l, ourProps: h, theirProps: o, slot: f, defaultTag: BP, features: zP, visible: p, name: "Disclosure.Panel" }));
}
let UP = Te(IP), WP = Te(HP), GP = Te(FP), Wc = Object.assign(UP, { Button: WP, Panel: GP }), Xf = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function Zf(e) {
  var t, n;
  let r = (t = e.innerText) != null ? t : "", o = e.cloneNode(!0);
  if (!(o instanceof HTMLElement))
    return r;
  let s = !1;
  for (let a of o.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    a.remove(), s = !0;
  let i = s ? (n = o.innerText) != null ? n : "" : r;
  return Xf.test(i) && (i = i.replace(Xf, "")), i;
}
function KP(e) {
  let t = e.getAttribute("aria-label");
  if (typeof t == "string")
    return t.trim();
  let n = e.getAttribute("aria-labelledby");
  if (n) {
    let r = n.split(" ").map((o) => {
      let s = document.getElementById(o);
      if (s) {
        let i = s.getAttribute("aria-label");
        return typeof i == "string" ? i.trim() : Zf(s).trim();
      }
      return null;
    }).filter(Boolean);
    if (r.length > 0)
      return r.join(", ");
  }
  return Zf(e).trim();
}
function qP(e) {
  let t = K(""), n = K("");
  return ee(() => {
    let r = e.current;
    if (!r)
      return "";
    let o = r.innerText;
    if (t.current === o)
      return n.current;
    let s = KP(r).trim().toLowerCase();
    return t.current = o, n.current = s, s;
  });
}
var YP = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(YP || {}), XP = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(XP || {}), ZP = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(ZP || {}), JP = ((e) => (e[e.OpenListbox = 0] = "OpenListbox", e[e.CloseListbox = 1] = "CloseListbox", e[e.GoToOption = 2] = "GoToOption", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterOption = 5] = "RegisterOption", e[e.UnregisterOption = 6] = "UnregisterOption", e[e.RegisterLabel = 7] = "RegisterLabel", e))(JP || {});
function Gc(e, t = (n) => n) {
  let n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = wr(t(e.options.slice()), (s) => s.dataRef.current.domRef.current), o = n ? r.indexOf(n) : null;
  return o === -1 && (o = null), { options: r, activeOptionIndex: o };
}
let QP = { 1(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 ? e : { ...e, activeOptionIndex: null, listboxState: 1 };
}, 0(e) {
  if (e.dataRef.current.disabled || e.listboxState === 0)
    return e;
  let t = e.activeOptionIndex, { isSelected: n } = e.dataRef.current, r = e.options.findIndex((o) => n(o.dataRef.current.value));
  return r !== -1 && (t = r), { ...e, listboxState: 0, activeOptionIndex: t };
}, 2(e, t) {
  var n;
  if (e.dataRef.current.disabled || e.listboxState === 1)
    return e;
  let r = Gc(e), o = Ju(t, { resolveItems: () => r.options, resolveActiveIndex: () => r.activeOptionIndex, resolveId: (s) => s.id, resolveDisabled: (s) => s.dataRef.current.disabled });
  return { ...e, ...r, searchQuery: "", activeOptionIndex: o, activationTrigger: (n = t.trigger) != null ? n : 1 };
}, 3: (e, t) => {
  if (e.dataRef.current.disabled || e.listboxState === 1)
    return e;
  let n = e.searchQuery !== "" ? 0 : 1, r = e.searchQuery + t.value.toLowerCase(), o = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + n).concat(e.options.slice(0, e.activeOptionIndex + n)) : e.options).find((i) => {
    var a;
    return !i.dataRef.current.disabled && ((a = i.dataRef.current.textValue) == null ? void 0 : a.startsWith(r));
  }), s = o ? e.options.indexOf(o) : -1;
  return s === -1 || s === e.activeOptionIndex ? { ...e, searchQuery: r } : { ...e, searchQuery: r, activeOptionIndex: s, activationTrigger: 1 };
}, 4(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : { ...e, searchQuery: "" };
}, 5: (e, t) => {
  let n = { id: t.id, dataRef: t.dataRef }, r = Gc(e, (o) => [...o, n]);
  return e.activeOptionIndex === null && e.dataRef.current.isSelected(t.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(n)), { ...e, ...r };
}, 6: (e, t) => {
  let n = Gc(e, (r) => {
    let o = r.findIndex((s) => s.id === t.id);
    return o !== -1 && r.splice(o, 1), r;
  });
  return { ...e, ...n, activationTrigger: 1 };
}, 7: (e, t) => ({ ...e, labelId: t.id }) }, hp = Be(null);
hp.displayName = "ListboxActionsContext";
function qi(e) {
  let t = Le(hp);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, qi), n;
  }
  return t;
}
let gp = Be(null);
gp.displayName = "ListboxDataContext";
function Yi(e) {
  let t = Le(gp);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Yi), n;
  }
  return t;
}
function eE(e, t) {
  return Oe(t.type, QP, e, t);
}
let tE = wt;
function nE(e, t) {
  let { value: n, defaultValue: r, form: o, name: s, onChange: i, by: a = (Q, re) => Q === re, disabled: l = !1, horizontal: u = !1, multiple: d = !1, ...p } = e;
  const f = u ? "horizontal" : "vertical";
  let h = ke(t), [g = d ? [] : void 0, m] = zl(n, i, r), [v, b] = Qr(eE, { dataRef: bi(), listboxState: 1, options: [], searchQuery: "", labelId: null, activeOptionIndex: null, activationTrigger: 1 }), y = K({ static: !1, hold: !1 }), w = K(null), S = K(null), x = K(null), C = ee(typeof a == "string" ? (Q, re) => {
    let ge = a;
    return (Q == null ? void 0 : Q[ge]) === (re == null ? void 0 : re[ge]);
  } : a), P = it((Q) => Oe(_.mode, { 1: () => g.some((re) => C(re, Q)), 0: () => C(g, Q) }), [g]), _ = ie(() => ({ ...v, value: g, disabled: l, mode: d ? 1 : 0, orientation: f, compare: C, isSelected: P, optionsPropsRef: y, labelRef: w, buttonRef: S, optionsRef: x }), [g, l, d, v]);
  $e(() => {
    v.dataRef.current = _;
  }, [_]), Wl([_.buttonRef, _.optionsRef], (Q, re) => {
    var ge;
    b({ type: 1 }), ep(re, Ul.Loose) || (Q.preventDefault(), (ge = _.buttonRef.current) == null || ge.focus());
  }, _.listboxState === 0);
  let O = ie(() => ({ open: _.listboxState === 0, disabled: l, value: g }), [_, l, g]), E = ee((Q) => {
    let re = _.options.find((ge) => ge.id === Q);
    re && D(re.dataRef.current.value);
  }), T = ee(() => {
    if (_.activeOptionIndex !== null) {
      let { dataRef: Q, id: re } = _.options[_.activeOptionIndex];
      D(Q.current.value), b({ type: 2, focus: We.Specific, id: re });
    }
  }), R = ee(() => b({ type: 0 })), B = ee(() => b({ type: 1 })), U = ee((Q, re, ge) => Q === We.Specific ? b({ type: 2, focus: We.Specific, id: re, trigger: ge }) : b({ type: 2, focus: Q, trigger: ge })), L = ee((Q, re) => (b({ type: 5, id: Q, dataRef: re }), () => b({ type: 6, id: Q }))), M = ee((Q) => (b({ type: 7, id: Q }), () => b({ type: 7, id: null }))), D = ee((Q) => Oe(_.mode, { 0() {
    return m == null ? void 0 : m(Q);
  }, 1() {
    let re = _.value.slice(), ge = re.findIndex((X) => C(X, Q));
    return ge === -1 ? re.push(Q) : re.splice(ge, 1), m == null ? void 0 : m(re);
  } })), V = ee((Q) => b({ type: 3, value: Q })), k = ee(() => b({ type: 4 })), j = ie(() => ({ onChange: D, registerOption: L, registerLabel: M, goToOption: U, closeListbox: B, openListbox: R, selectActiveOption: T, selectOption: E, search: V, clearSearch: k }), []), Y = { ref: h }, J = K(null), le = Pn();
  return G(() => {
    J.current && r !== void 0 && le.addEventListener(J.current, "reset", () => {
      m == null || m(r);
    });
  }, [J, m]), H.createElement(hp.Provider, { value: j }, H.createElement(gp.Provider, { value: _ }, H.createElement(Wi, { value: Oe(_.listboxState, { 0: Ke.Open, 1: Ke.Closed }) }, s != null && g != null && Gl({ [s]: g }).map(([Q, re], ge) => H.createElement(sn, { features: on.Hidden, ref: ge === 0 ? (X) => {
    var Z;
    J.current = (Z = X == null ? void 0 : X.closest("form")) != null ? Z : null;
  } : void 0, ...gs({ key: Q, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: o, disabled: l, name: Q, value: re }) })), _e({ ourProps: Y, theirProps: p, slot: O, defaultTag: tE, name: "Listbox" }))));
}
let rE = "button";
function oE(e, t) {
  var n;
  let r = Xe(), { id: o = `headlessui-listbox-button-${r}`, ...s } = e, i = Yi("Listbox.Button"), a = qi("Listbox.Button"), l = ke(i.buttonRef, t), u = Pn(), d = ee((v) => {
    switch (v.key) {
      case ve.Space:
      case ve.Enter:
      case ve.ArrowDown:
        v.preventDefault(), a.openListbox(), u.nextFrame(() => {
          i.value || a.goToOption(We.First);
        });
        break;
      case ve.ArrowUp:
        v.preventDefault(), a.openListbox(), u.nextFrame(() => {
          i.value || a.goToOption(We.Last);
        });
        break;
    }
  }), p = ee((v) => {
    switch (v.key) {
      case ve.Space:
        v.preventDefault();
        break;
    }
  }), f = ee((v) => {
    if (Tr(v.currentTarget))
      return v.preventDefault();
    i.listboxState === 0 ? (a.closeListbox(), u.nextFrame(() => {
      var b;
      return (b = i.buttonRef.current) == null ? void 0 : b.focus({ preventScroll: !0 });
    })) : (v.preventDefault(), a.openListbox());
  }), h = Fi(() => {
    if (i.labelId)
      return [i.labelId, o].join(" ");
  }, [i.labelId, o]), g = ie(() => ({ open: i.listboxState === 0, disabled: i.disabled, value: i.value }), [i]), m = { ref: l, id: o, type: Os(e, i.buttonRef), "aria-haspopup": "listbox", "aria-controls": (n = i.optionsRef.current) == null ? void 0 : n.id, "aria-expanded": i.listboxState === 0, "aria-labelledby": h, disabled: i.disabled, onKeyDown: d, onKeyUp: p, onClick: f };
  return _e({ ourProps: m, theirProps: s, slot: g, defaultTag: rE, name: "Listbox.Button" });
}
let sE = "label";
function iE(e, t) {
  let n = Xe(), { id: r = `headlessui-listbox-label-${n}`, ...o } = e, s = Yi("Listbox.Label"), i = qi("Listbox.Label"), a = ke(s.labelRef, t);
  $e(() => i.registerLabel(r), [r]);
  let l = ee(() => {
    var d;
    return (d = s.buttonRef.current) == null ? void 0 : d.focus({ preventScroll: !0 });
  }), u = ie(() => ({ open: s.listboxState === 0, disabled: s.disabled }), [s]);
  return _e({ ourProps: { ref: a, id: r, onClick: l }, theirProps: o, slot: u, defaultTag: sE, name: "Listbox.Label" });
}
let aE = "ul", lE = Dt.RenderStrategy | Dt.Static;
function cE(e, t) {
  var n;
  let r = Xe(), { id: o = `headlessui-listbox-options-${r}`, ...s } = e, i = Yi("Listbox.Options"), a = qi("Listbox.Options"), l = ke(i.optionsRef, t), u = Pn(), d = Pn(), p = so(), f = (() => p !== null ? (p & Ke.Open) === Ke.Open : i.listboxState === 0)();
  G(() => {
    var b;
    let y = i.optionsRef.current;
    y && i.listboxState === 0 && y !== ((b = oo(y)) == null ? void 0 : b.activeElement) && y.focus({ preventScroll: !0 });
  }, [i.listboxState, i.optionsRef]);
  let h = ee((b) => {
    switch (d.dispose(), b.key) {
      case ve.Space:
        if (i.searchQuery !== "")
          return b.preventDefault(), b.stopPropagation(), a.search(b.key);
      case ve.Enter:
        if (b.preventDefault(), b.stopPropagation(), i.activeOptionIndex !== null) {
          let { dataRef: y } = i.options[i.activeOptionIndex];
          a.onChange(y.current.value);
        }
        i.mode === 0 && (a.closeListbox(), Cn().nextFrame(() => {
          var y;
          return (y = i.buttonRef.current) == null ? void 0 : y.focus({ preventScroll: !0 });
        }));
        break;
      case Oe(i.orientation, { vertical: ve.ArrowDown, horizontal: ve.ArrowRight }):
        return b.preventDefault(), b.stopPropagation(), a.goToOption(We.Next);
      case Oe(i.orientation, { vertical: ve.ArrowUp, horizontal: ve.ArrowLeft }):
        return b.preventDefault(), b.stopPropagation(), a.goToOption(We.Previous);
      case ve.Home:
      case ve.PageUp:
        return b.preventDefault(), b.stopPropagation(), a.goToOption(We.First);
      case ve.End:
      case ve.PageDown:
        return b.preventDefault(), b.stopPropagation(), a.goToOption(We.Last);
      case ve.Escape:
        return b.preventDefault(), b.stopPropagation(), a.closeListbox(), u.nextFrame(() => {
          var y;
          return (y = i.buttonRef.current) == null ? void 0 : y.focus({ preventScroll: !0 });
        });
      case ve.Tab:
        b.preventDefault(), b.stopPropagation();
        break;
      default:
        b.key.length === 1 && (a.search(b.key), d.setTimeout(() => a.clearSearch(), 350));
        break;
    }
  }), g = Fi(() => {
    var b;
    return (b = i.buttonRef.current) == null ? void 0 : b.id;
  }, [i.buttonRef.current]), m = ie(() => ({ open: i.listboxState === 0 }), [i]), v = { "aria-activedescendant": i.activeOptionIndex === null || (n = i.options[i.activeOptionIndex]) == null ? void 0 : n.id, "aria-multiselectable": i.mode === 1 ? !0 : void 0, "aria-labelledby": g, "aria-orientation": i.orientation, id: o, onKeyDown: h, role: "listbox", tabIndex: 0, ref: l };
  return _e({ ourProps: v, theirProps: s, slot: m, defaultTag: aE, features: lE, visible: f, name: "Listbox.Options" });
}
let uE = "li";
function dE(e, t) {
  let n = Xe(), { id: r = `headlessui-listbox-option-${n}`, disabled: o = !1, value: s, ...i } = e, a = Yi("Listbox.Option"), l = qi("Listbox.Option"), u = a.activeOptionIndex !== null ? a.options[a.activeOptionIndex].id === r : !1, d = a.isSelected(s), p = K(null), f = qP(p), h = Ct({ disabled: o, value: s, domRef: p, get textValue() {
    return f();
  } }), g = ke(t, p);
  $e(() => {
    if (a.listboxState !== 0 || !u || a.activationTrigger === 0)
      return;
    let C = Cn();
    return C.requestAnimationFrame(() => {
      var P, _;
      (_ = (P = p.current) == null ? void 0 : P.scrollIntoView) == null || _.call(P, { block: "nearest" });
    }), C.dispose;
  }, [p, u, a.listboxState, a.activationTrigger, a.activeOptionIndex]), $e(() => l.registerOption(r, h), [h, r]);
  let m = ee((C) => {
    if (o)
      return C.preventDefault();
    l.onChange(s), a.mode === 0 && (l.closeListbox(), Cn().nextFrame(() => {
      var P;
      return (P = a.buttonRef.current) == null ? void 0 : P.focus({ preventScroll: !0 });
    }));
  }), v = ee(() => {
    if (o)
      return l.goToOption(We.Nothing);
    l.goToOption(We.Specific, r);
  }), b = L1(), y = ee((C) => b.update(C)), w = ee((C) => {
    b.wasMoved(C) && (o || u || l.goToOption(We.Specific, r, 0));
  }), S = ee((C) => {
    b.wasMoved(C) && (o || u && l.goToOption(We.Nothing));
  }), x = ie(() => ({ active: u, selected: d, disabled: o }), [u, d, o]);
  return _e({ ourProps: { id: r, ref: g, role: "option", tabIndex: o === !0 ? void 0 : -1, "aria-disabled": o === !0 ? !0 : void 0, "aria-selected": d, disabled: void 0, onClick: m, onFocus: v, onPointerEnter: y, onMouseEnter: y, onPointerMove: w, onMouseMove: w, onPointerLeave: S, onMouseLeave: S }, theirProps: i, slot: x, defaultTag: uE, name: "Listbox.Option" });
}
let pE = Te(nE), fE = Te(oE), hE = Te(iE), gE = Te(cE), mE = Te(dE), Us = Object.assign(pE, { Button: fE, Label: hE, Options: gE, Option: mE });
var vE = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(vE || {}), bE = ((e) => (e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))(bE || {});
let yE = { 0: (e) => {
  let t = { ...e, popoverState: Oe(e.popoverState, { 0: 1, 1: 0 }) };
  return t.popoverState === 0 && (t.__demoMode = !1), t;
}, 1(e) {
  return e.popoverState === 1 ? e : { ...e, popoverState: 1 };
}, 2(e, t) {
  return e.button === t.button ? e : { ...e, button: t.button };
}, 3(e, t) {
  return e.buttonId === t.buttonId ? e : { ...e, buttonId: t.buttonId };
}, 4(e, t) {
  return e.panel === t.panel ? e : { ...e, panel: t.panel };
}, 5(e, t) {
  return e.panelId === t.panelId ? e : { ...e, panelId: t.panelId };
} }, mp = Be(null);
mp.displayName = "PopoverContext";
function ql(e) {
  let t = Le(mp);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, ql), n;
  }
  return t;
}
let vp = Be(null);
vp.displayName = "PopoverAPIContext";
function bp(e) {
  let t = Le(vp);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, bp), n;
  }
  return t;
}
let yp = Be(null);
yp.displayName = "PopoverGroupContext";
function q1() {
  return Le(yp);
}
let Yl = Be(null);
Yl.displayName = "PopoverPanelContext";
function wE() {
  return Le(Yl);
}
function SE(e, t) {
  return Oe(t.type, yE, e, t);
}
let xE = "div";
function CE(e, t) {
  var n;
  let { __demoMode: r = !1, ...o } = e, s = K(null), i = ke(t, tp((M) => {
    s.current = M;
  })), a = K([]), l = Qr(SE, { __demoMode: r, popoverState: r ? 0 : 1, buttons: a, button: null, buttonId: null, panel: null, panelId: null, beforePanelSentinel: bi(), afterPanelSentinel: bi() }), [{ popoverState: u, button: d, buttonId: p, panel: f, panelId: h, beforePanelSentinel: g, afterPanelSentinel: m }, v] = l, b = $r((n = s.current) != null ? n : d), y = ie(() => {
    if (!d || !f)
      return !1;
    for (let J of document.querySelectorAll("body > *"))
      if (Number(J == null ? void 0 : J.contains(d)) ^ Number(J == null ? void 0 : J.contains(f)))
        return !0;
    let M = Fl(), D = M.indexOf(d), V = (D + M.length - 1) % M.length, k = (D + 1) % M.length, j = M[V], Y = M[k];
    return !f.contains(j) && !f.contains(Y);
  }, [d, f]), w = Ct(p), S = Ct(h), x = ie(() => ({ buttonId: w, panelId: S, close: () => v({ type: 1 }) }), [w, S, v]), C = q1(), P = C == null ? void 0 : C.registerPopover, _ = ee(() => {
    var M;
    return (M = C == null ? void 0 : C.isFocusWithinPopoverGroup()) != null ? M : (b == null ? void 0 : b.activeElement) && ((d == null ? void 0 : d.contains(b.activeElement)) || (f == null ? void 0 : f.contains(b.activeElement)));
  });
  G(() => P == null ? void 0 : P(x), [P, x]);
  let [O, E] = F1(), T = U1({ mainTreeNodeRef: C == null ? void 0 : C.mainTreeNodeRef, portals: O, defaultContainers: [d, f] });
  ip(b == null ? void 0 : b.defaultView, "focus", (M) => {
    var D, V, k, j;
    M.target !== window && M.target instanceof HTMLElement && u === 0 && (_() || d && f && (T.contains(M.target) || (V = (D = g.current) == null ? void 0 : D.contains) != null && V.call(D, M.target) || (j = (k = m.current) == null ? void 0 : k.contains) != null && j.call(k, M.target) || v({ type: 1 })));
  }, !0), Wl(T.resolveContainers, (M, D) => {
    v({ type: 1 }), ep(D, Ul.Loose) || (M.preventDefault(), d == null || d.focus());
  }, u === 0);
  let R = ee((M) => {
    v({ type: 1 });
    let D = (() => M ? M instanceof HTMLElement ? M : "current" in M && M.current instanceof HTMLElement ? M.current : d : d)();
    D == null || D.focus();
  }), B = ie(() => ({ close: R, isPortalled: y }), [R, y]), U = ie(() => ({ open: u === 0, close: R }), [u, R]), L = { ref: i };
  return H.createElement(Yl.Provider, { value: null }, H.createElement(mp.Provider, { value: l }, H.createElement(vp.Provider, { value: B }, H.createElement(Wi, { value: Oe(u, { 0: Ke.Open, 1: Ke.Closed }) }, H.createElement(E, null, _e({ ourProps: L, theirProps: o, slot: U, defaultTag: xE, name: "Popover" }), H.createElement(T.MainTreeNode, null))))));
}
let PE = "button";
function EE(e, t) {
  let n = Xe(), { id: r = `headlessui-popover-button-${n}`, ...o } = e, [s, i] = ql("Popover.Button"), { isPortalled: a } = bp("Popover.Button"), l = K(null), u = `headlessui-focus-sentinel-${Xe()}`, d = q1(), p = d == null ? void 0 : d.closeOthers, f = wE() !== null;
  G(() => {
    if (!f)
      return i({ type: 3, buttonId: r }), () => {
        i({ type: 3, buttonId: null });
      };
  }, [f, r, i]);
  let [h] = W(() => Symbol()), g = ke(l, t, f ? null : (T) => {
    if (T)
      s.buttons.current.push(h);
    else {
      let R = s.buttons.current.indexOf(h);
      R !== -1 && s.buttons.current.splice(R, 1);
    }
    s.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), T && i({ type: 2, button: T });
  }), m = ke(l, t), v = $r(l), b = ee((T) => {
    var R, B, U;
    if (f) {
      if (s.popoverState === 1)
        return;
      switch (T.key) {
        case ve.Space:
        case ve.Enter:
          T.preventDefault(), (B = (R = T.target).click) == null || B.call(R), i({ type: 1 }), (U = s.button) == null || U.focus();
          break;
      }
    } else
      switch (T.key) {
        case ve.Space:
        case ve.Enter:
          T.preventDefault(), T.stopPropagation(), s.popoverState === 1 && (p == null || p(s.buttonId)), i({ type: 0 });
          break;
        case ve.Escape:
          if (s.popoverState !== 0)
            return p == null ? void 0 : p(s.buttonId);
          if (!l.current || v != null && v.activeElement && !l.current.contains(v.activeElement))
            return;
          T.preventDefault(), T.stopPropagation(), i({ type: 1 });
          break;
      }
  }), y = ee((T) => {
    f || T.key === ve.Space && T.preventDefault();
  }), w = ee((T) => {
    var R, B;
    Tr(T.currentTarget) || e.disabled || (f ? (i({ type: 1 }), (R = s.button) == null || R.focus()) : (T.preventDefault(), T.stopPropagation(), s.popoverState === 1 && (p == null || p(s.buttonId)), i({ type: 0 }), (B = s.button) == null || B.focus()));
  }), S = ee((T) => {
    T.preventDefault(), T.stopPropagation();
  }), x = s.popoverState === 0, C = ie(() => ({ open: x }), [x]), P = Os(e, l), _ = f ? { ref: m, type: P, onKeyDown: b, onClick: w } : { ref: g, id: s.buttonId, type: P, "aria-expanded": s.popoverState === 0, "aria-controls": s.panel ? s.panelId : void 0, onKeyDown: b, onKeyUp: y, onClick: w, onMouseDown: S }, O = ap(), E = ee(() => {
    let T = s.panel;
    if (!T)
      return;
    function R() {
      Oe(O.current, { [nn.Forwards]: () => xt(T, Ye.First), [nn.Backwards]: () => xt(T, Ye.Last) }) === Rn.Error && xt(Fl().filter((B) => B.dataset.headlessuiFocusGuard !== "true"), Oe(O.current, { [nn.Forwards]: Ye.Next, [nn.Backwards]: Ye.Previous }), { relativeTo: s.button });
    }
    R();
  });
  return H.createElement(H.Fragment, null, _e({ ourProps: _, theirProps: o, slot: C, defaultTag: PE, name: "Popover.Button" }), x && !f && a && H.createElement(sn, { id: u, features: on.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: E }));
}
let OE = "div", _E = Dt.RenderStrategy | Dt.Static;
function TE(e, t) {
  let n = Xe(), { id: r = `headlessui-popover-overlay-${n}`, ...o } = e, [{ popoverState: s }, i] = ql("Popover.Overlay"), a = ke(t), l = so(), u = (() => l !== null ? (l & Ke.Open) === Ke.Open : s === 0)(), d = ee((f) => {
    if (Tr(f.currentTarget))
      return f.preventDefault();
    i({ type: 1 });
  }), p = ie(() => ({ open: s === 0 }), [s]);
  return _e({ ourProps: { ref: a, id: r, "aria-hidden": !0, onClick: d }, theirProps: o, slot: p, defaultTag: OE, features: _E, visible: u, name: "Popover.Overlay" });
}
let AE = "div", LE = Dt.RenderStrategy | Dt.Static;
function kE(e, t) {
  let n = Xe(), { id: r = `headlessui-popover-panel-${n}`, focus: o = !1, ...s } = e, [i, a] = ql("Popover.Panel"), { close: l, isPortalled: u } = bp("Popover.Panel"), d = `headlessui-focus-sentinel-before-${Xe()}`, p = `headlessui-focus-sentinel-after-${Xe()}`, f = K(null), h = ke(f, t, (_) => {
    a({ type: 4, panel: _ });
  }), g = $r(f), m = np();
  $e(() => (a({ type: 5, panelId: r }), () => {
    a({ type: 5, panelId: null });
  }), [r, a]);
  let v = so(), b = (() => v !== null ? (v & Ke.Open) === Ke.Open : i.popoverState === 0)(), y = ee((_) => {
    var O;
    switch (_.key) {
      case ve.Escape:
        if (i.popoverState !== 0 || !f.current || g != null && g.activeElement && !f.current.contains(g.activeElement))
          return;
        _.preventDefault(), _.stopPropagation(), a({ type: 1 }), (O = i.button) == null || O.focus();
        break;
    }
  });
  G(() => {
    var _;
    e.static || i.popoverState === 1 && ((_ = e.unmount) == null || _) && a({ type: 4, panel: null });
  }, [i.popoverState, e.unmount, e.static, a]), G(() => {
    if (i.__demoMode || !o || i.popoverState !== 0 || !f.current)
      return;
    let _ = g == null ? void 0 : g.activeElement;
    f.current.contains(_) || xt(f.current, Ye.First);
  }, [i.__demoMode, o, f, i.popoverState]);
  let w = ie(() => ({ open: i.popoverState === 0, close: l }), [i, l]), S = { ref: h, id: r, onKeyDown: y, onBlur: o && i.popoverState === 0 ? (_) => {
    var O, E, T, R, B;
    let U = _.relatedTarget;
    U && f.current && ((O = f.current) != null && O.contains(U) || (a({ type: 1 }), ((T = (E = i.beforePanelSentinel.current) == null ? void 0 : E.contains) != null && T.call(E, U) || (B = (R = i.afterPanelSentinel.current) == null ? void 0 : R.contains) != null && B.call(R, U)) && U.focus({ preventScroll: !0 })));
  } : void 0, tabIndex: -1 }, x = ap(), C = ee(() => {
    let _ = f.current;
    if (!_)
      return;
    function O() {
      Oe(x.current, { [nn.Forwards]: () => {
        var E;
        xt(_, Ye.First) === Rn.Error && ((E = i.afterPanelSentinel.current) == null || E.focus());
      }, [nn.Backwards]: () => {
        var E;
        (E = i.button) == null || E.focus({ preventScroll: !0 });
      } });
    }
    O();
  }), P = ee(() => {
    let _ = f.current;
    if (!_)
      return;
    function O() {
      Oe(x.current, { [nn.Forwards]: () => {
        var E;
        if (!i.button)
          return;
        let T = Fl(), R = T.indexOf(i.button), B = T.slice(0, R + 1), U = [...T.slice(R + 1), ...B];
        for (let L of U.slice())
          if (L.dataset.headlessuiFocusGuard === "true" || (E = i.panel) != null && E.contains(L)) {
            let M = U.indexOf(L);
            M !== -1 && U.splice(M, 1);
          }
        xt(U, Ye.First, { sorted: !1 });
      }, [nn.Backwards]: () => {
        var E;
        xt(_, Ye.Previous) === Rn.Error && ((E = i.button) == null || E.focus());
      } });
    }
    O();
  });
  return H.createElement(Yl.Provider, { value: r }, b && u && H.createElement(sn, { id: d, ref: i.beforePanelSentinel, features: on.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: C }), _e({ mergeRefs: m, ourProps: S, theirProps: s, slot: w, defaultTag: AE, features: LE, visible: b, name: "Popover.Panel" }), b && u && H.createElement(sn, { id: p, ref: i.afterPanelSentinel, features: on.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: P }));
}
let ME = "div";
function $E(e, t) {
  let n = K(null), r = ke(n, t), [o, s] = W([]), i = oP(), a = ee((m) => {
    s((v) => {
      let b = v.indexOf(m);
      if (b !== -1) {
        let y = v.slice();
        return y.splice(b, 1), y;
      }
      return v;
    });
  }), l = ee((m) => (s((v) => [...v, m]), () => a(m))), u = ee(() => {
    var m;
    let v = oo(n);
    if (!v)
      return !1;
    let b = v.activeElement;
    return (m = n.current) != null && m.contains(b) ? !0 : o.some((y) => {
      var w, S;
      return ((w = v.getElementById(y.buttonId.current)) == null ? void 0 : w.contains(b)) || ((S = v.getElementById(y.panelId.current)) == null ? void 0 : S.contains(b));
    });
  }), d = ee((m) => {
    for (let v of o)
      v.buttonId.current !== m && v.close();
  }), p = ie(() => ({ registerPopover: l, unregisterPopover: a, isFocusWithinPopoverGroup: u, closeOthers: d, mainTreeNodeRef: i.mainTreeNodeRef }), [l, a, u, d, i.mainTreeNodeRef]), f = ie(() => ({}), []), h = e, g = { ref: r };
  return H.createElement(yp.Provider, { value: p }, _e({ ourProps: g, theirProps: h, slot: f, defaultTag: ME, name: "Popover.Group" }), H.createElement(i.MainTreeNode, null));
}
let RE = Te(CE), NE = Te(EE), jE = Te(TE), DE = Te(kE), IE = Te($E), Kc = Object.assign(RE, { Button: NE, Overlay: jE, Panel: DE, Group: IE }), Y1 = Be(null);
function X1() {
  let e = Le(Y1);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, X1), t;
  }
  return e;
}
function wp() {
  let [e, t] = W([]);
  return [e.length > 0 ? e.join(" ") : void 0, ie(() => function(n) {
    let r = ee((s) => (t((i) => [...i, s]), () => t((i) => {
      let a = i.slice(), l = a.indexOf(s);
      return l !== -1 && a.splice(l, 1), a;
    }))), o = ie(() => ({ register: r, slot: n.slot, name: n.name, props: n.props }), [r, n.slot, n.name, n.props]);
    return H.createElement(Y1.Provider, { value: o }, n.children);
  }, [t])];
}
let VE = "label";
function HE(e, t) {
  let n = Xe(), { id: r = `headlessui-label-${n}`, passive: o = !1, ...s } = e, i = X1(), a = ke(t);
  $e(() => i.register(r), [r, i.register]);
  let l = { ref: a, ...i.props, id: r };
  return o && ("onClick" in l && (delete l.htmlFor, delete l.onClick), "onClick" in s && delete s.onClick), _e({ ourProps: l, theirProps: s, slot: i.slot || {}, defaultTag: VE, name: i.name || "Label" });
}
let BE = Te(HE), Z1 = Object.assign(BE, {});
function J1(e = 0) {
  let [t, n] = W(e), r = _s(), o = it((l) => {
    r.current && n((u) => u | l);
  }, [t, r]), s = it((l) => !!(t & l), [t]), i = it((l) => {
    r.current && n((u) => u & ~l);
  }, [n, r]), a = it((l) => {
    r.current && n((u) => u ^ l);
  }, [n]);
  return { flags: t, addFlag: o, hasFlag: s, removeFlag: i, toggleFlag: a };
}
var zE = ((e) => (e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e))(zE || {});
let FE = { 0(e, t) {
  let n = [...e.options, { id: t.id, element: t.element, propsRef: t.propsRef }];
  return { ...e, options: wr(n, (r) => r.element.current) };
}, 1(e, t) {
  let n = e.options.slice(), r = e.options.findIndex((o) => o.id === t.id);
  return r === -1 ? e : (n.splice(r, 1), { ...e, options: n });
} }, Sp = Be(null);
Sp.displayName = "RadioGroupDataContext";
function Q1(e) {
  let t = Le(Sp);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Q1), n;
  }
  return t;
}
let xp = Be(null);
xp.displayName = "RadioGroupActionsContext";
function ev(e) {
  let t = Le(xp);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, ev), n;
  }
  return t;
}
function UE(e, t) {
  return Oe(t.type, FE, e, t);
}
let WE = "div";
function GE(e, t) {
  let n = Xe(), { id: r = `headlessui-radiogroup-${n}`, value: o, defaultValue: s, form: i, name: a, onChange: l, by: u = (k, j) => k === j, disabled: d = !1, ...p } = e, f = ee(typeof u == "string" ? (k, j) => {
    let Y = u;
    return (k == null ? void 0 : k[Y]) === (j == null ? void 0 : j[Y]);
  } : u), [h, g] = Qr(UE, { options: [] }), m = h.options, [v, b] = wp(), [y, w] = Kl(), S = K(null), x = ke(S, t), [C, P] = zl(o, l, s), _ = ie(() => m.find((k) => !k.propsRef.current.disabled), [m]), O = ie(() => m.some((k) => f(k.propsRef.current.value, C)), [m, C]), E = ee((k) => {
    var j;
    if (d || f(k, C))
      return !1;
    let Y = (j = m.find((J) => f(J.propsRef.current.value, k))) == null ? void 0 : j.propsRef.current;
    return Y != null && Y.disabled ? !1 : (P == null || P(k), !0);
  });
  k1({ container: S.current, accept(k) {
    return k.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : k.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(k) {
    k.setAttribute("role", "none");
  } });
  let T = ee((k) => {
    let j = S.current;
    if (!j)
      return;
    let Y = oo(j), J = m.filter((le) => le.propsRef.current.disabled === !1).map((le) => le.element.current);
    switch (k.key) {
      case ve.Enter:
        N1(k.currentTarget);
        break;
      case ve.ArrowLeft:
      case ve.ArrowUp:
        if (k.preventDefault(), k.stopPropagation(), xt(J, Ye.Previous | Ye.WrapAround) === Rn.Success) {
          let le = m.find((Q) => Q.element.current === (Y == null ? void 0 : Y.activeElement));
          le && E(le.propsRef.current.value);
        }
        break;
      case ve.ArrowRight:
      case ve.ArrowDown:
        if (k.preventDefault(), k.stopPropagation(), xt(J, Ye.Next | Ye.WrapAround) === Rn.Success) {
          let le = m.find((Q) => Q.element.current === (Y == null ? void 0 : Y.activeElement));
          le && E(le.propsRef.current.value);
        }
        break;
      case ve.Space:
        {
          k.preventDefault(), k.stopPropagation();
          let le = m.find((Q) => Q.element.current === (Y == null ? void 0 : Y.activeElement));
          le && E(le.propsRef.current.value);
        }
        break;
    }
  }), R = ee((k) => (g({ type: 0, ...k }), () => g({ type: 1, id: k.id }))), B = ie(() => ({ value: C, firstOption: _, containsCheckedOption: O, disabled: d, compare: f, ...h }), [C, _, O, d, f, h]), U = ie(() => ({ registerOption: R, change: E }), [R, E]), L = { ref: x, id: r, role: "radiogroup", "aria-labelledby": v, "aria-describedby": y, onKeyDown: T }, M = ie(() => ({ value: C }), [C]), D = K(null), V = Pn();
  return G(() => {
    D.current && s !== void 0 && V.addEventListener(D.current, "reset", () => {
      E(s);
    });
  }, [D, E]), H.createElement(w, { name: "RadioGroup.Description" }, H.createElement(b, { name: "RadioGroup.Label" }, H.createElement(xp.Provider, { value: U }, H.createElement(Sp.Provider, { value: B }, a != null && C != null && Gl({ [a]: C }).map(([k, j], Y) => H.createElement(sn, { features: on.Hidden, ref: Y === 0 ? (J) => {
    var le;
    D.current = (le = J == null ? void 0 : J.closest("form")) != null ? le : null;
  } : void 0, ...gs({ key: k, as: "input", type: "radio", checked: j != null, hidden: !0, readOnly: !0, form: i, disabled: d, name: k, value: j }) })), _e({ ourProps: L, theirProps: p, slot: M, defaultTag: WE, name: "RadioGroup" })))));
}
var KE = ((e) => (e[e.Empty = 1] = "Empty", e[e.Active = 2] = "Active", e))(KE || {});
let qE = "div";
function YE(e, t) {
  var n;
  let r = Xe(), { id: o = `headlessui-radiogroup-option-${r}`, value: s, disabled: i = !1, ...a } = e, l = K(null), u = ke(l, t), [d, p] = wp(), [f, h] = Kl(), { addFlag: g, removeFlag: m, hasFlag: v } = J1(1), b = Ct({ value: s, disabled: i }), y = Q1("RadioGroup.Option"), w = ev("RadioGroup.Option");
  $e(() => w.registerOption({ id: o, element: l, propsRef: b }), [o, w, l, b]);
  let S = ee((R) => {
    var B;
    if (Tr(R.currentTarget))
      return R.preventDefault();
    w.change(s) && (g(2), (B = l.current) == null || B.focus());
  }), x = ee((R) => {
    if (Tr(R.currentTarget))
      return R.preventDefault();
    g(2);
  }), C = ee(() => m(2)), P = ((n = y.firstOption) == null ? void 0 : n.id) === o, _ = y.disabled || i, O = y.compare(y.value, s), E = { ref: u, id: o, role: "radio", "aria-checked": O ? "true" : "false", "aria-labelledby": d, "aria-describedby": f, "aria-disabled": _ ? !0 : void 0, tabIndex: (() => _ ? -1 : O || !y.containsCheckedOption && P ? 0 : -1)(), onClick: _ ? void 0 : S, onFocus: _ ? void 0 : x, onBlur: _ ? void 0 : C }, T = ie(() => ({ checked: O, disabled: _, active: v(2) }), [O, _, v]);
  return H.createElement(h, { name: "RadioGroup.Description" }, H.createElement(p, { name: "RadioGroup.Label" }, _e({ ourProps: E, theirProps: a, slot: T, defaultTag: qE, name: "RadioGroup.Option" })));
}
let XE = Te(GE), ZE = Te(YE), Jf = Object.assign(XE, { Option: ZE, Label: Z1, Description: cp }), Cp = Be(null);
Cp.displayName = "GroupContext";
let JE = wt;
function QE(e) {
  var t;
  let [n, r] = W(null), [o, s] = wp(), [i, a] = Kl(), l = ie(() => ({ switch: n, setSwitch: r, labelledby: o, describedby: i }), [n, r, o, i]), u = {}, d = e;
  return H.createElement(a, { name: "Switch.Description" }, H.createElement(s, { name: "Switch.Label", props: { htmlFor: (t = l.switch) == null ? void 0 : t.id, onClick(p) {
    n && (p.currentTarget.tagName === "LABEL" && p.preventDefault(), n.click(), n.focus({ preventScroll: !0 }));
  } } }, H.createElement(Cp.Provider, { value: l }, _e({ ourProps: u, theirProps: d, defaultTag: JE, name: "Switch.Group" }))));
}
let eO = "button";
function tO(e, t) {
  var n;
  let r = Xe(), { id: o = `headlessui-switch-${r}`, checked: s, defaultChecked: i = !1, onChange: a, disabled: l = !1, name: u, value: d, form: p, ...f } = e, h = Le(Cp), g = K(null), m = ke(g, t, h === null ? null : h.setSwitch), [v, b] = zl(s, a, i), y = ee(() => b == null ? void 0 : b(!v)), w = ee((O) => {
    if (Tr(O.currentTarget))
      return O.preventDefault();
    O.preventDefault(), y();
  }), S = ee((O) => {
    O.key === ve.Space ? (O.preventDefault(), y()) : O.key === ve.Enter && N1(O.currentTarget);
  }), x = ee((O) => O.preventDefault()), C = ie(() => ({ checked: v }), [v]), P = { id: o, ref: m, role: "switch", type: Os(e, g), tabIndex: e.tabIndex === -1 ? 0 : (n = e.tabIndex) != null ? n : 0, "aria-checked": v, "aria-labelledby": h == null ? void 0 : h.labelledby, "aria-describedby": h == null ? void 0 : h.describedby, disabled: l, onClick: w, onKeyUp: S, onKeyPress: x }, _ = Pn();
  return G(() => {
    var O;
    let E = (O = g.current) == null ? void 0 : O.closest("form");
    E && i !== void 0 && _.addEventListener(E, "reset", () => {
      b(i);
    });
  }, [g, b]), H.createElement(H.Fragment, null, u != null && v && H.createElement(sn, { features: on.Hidden, ...gs({ as: "input", type: "checkbox", hidden: !0, readOnly: !0, disabled: l, form: p, checked: v, name: u, value: d }) }), _e({ ourProps: P, theirProps: f, slot: C, defaultTag: eO, name: "Switch" }));
}
let nO = Te(tO), rO = QE, qc = Object.assign(nO, { Group: rO, Label: Z1, Description: cp });
function oO({ onFocus: e }) {
  let [t, n] = W(!0), r = _s();
  return t ? H.createElement(sn, { as: "button", type: "button", features: on.Focusable, onFocus: (o) => {
    o.preventDefault();
    let s, i = 50;
    function a() {
      if (i-- <= 0) {
        s && cancelAnimationFrame(s);
        return;
      }
      if (e()) {
        if (cancelAnimationFrame(s), !r.current)
          return;
        n(!1);
        return;
      }
      s = requestAnimationFrame(a);
    }
    s = requestAnimationFrame(a);
  } }) : null;
}
const tv = Ue.createContext(null);
function sO() {
  return { groups: /* @__PURE__ */ new Map(), get(e, t) {
    var n;
    let r = this.groups.get(e);
    r || (r = /* @__PURE__ */ new Map(), this.groups.set(e, r));
    let o = (n = r.get(t)) != null ? n : 0;
    r.set(t, o + 1);
    let s = Array.from(r.keys()).indexOf(t);
    function i() {
      let a = r.get(t);
      a > 1 ? r.set(t, a - 1) : r.delete(t);
    }
    return [s, i];
  } };
}
function iO({ children: e }) {
  let t = Ue.useRef(sO());
  return Ue.createElement(tv.Provider, { value: t }, e);
}
function nv(e) {
  let t = Ue.useContext(tv);
  if (!t)
    throw new Error("You must wrap your component in a <StableCollection>");
  let n = aO(), [r, o] = t.current.get(e, n);
  return Ue.useEffect(() => o, []), r;
}
function aO() {
  var e, t, n;
  let r = (n = (t = (e = Ue.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) == null ? void 0 : e.ReactCurrentOwner) == null ? void 0 : t.current) != null ? n : null;
  if (!r)
    return Symbol();
  let o = [], s = r;
  for (; s; )
    o.push(s.index), s = s.return;
  return "$." + o.join(".");
}
var lO = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(lO || {}), cO = ((e) => (e[e.Less = -1] = "Less", e[e.Equal = 0] = "Equal", e[e.Greater = 1] = "Greater", e))(cO || {}), uO = ((e) => (e[e.SetSelectedIndex = 0] = "SetSelectedIndex", e[e.RegisterTab = 1] = "RegisterTab", e[e.UnregisterTab = 2] = "UnregisterTab", e[e.RegisterPanel = 3] = "RegisterPanel", e[e.UnregisterPanel = 4] = "UnregisterPanel", e))(uO || {});
let dO = { 0(e, t) {
  var n;
  let r = wr(e.tabs, (d) => d.current), o = wr(e.panels, (d) => d.current), s = r.filter((d) => {
    var p;
    return !((p = d.current) != null && p.hasAttribute("disabled"));
  }), i = { ...e, tabs: r, panels: o };
  if (t.index < 0 || t.index > r.length - 1) {
    let d = Oe(Math.sign(t.index - e.selectedIndex), { [-1]: () => 1, 0: () => Oe(Math.sign(t.index), { [-1]: () => 0, 0: () => 0, 1: () => 1 }), 1: () => 0 });
    if (s.length === 0)
      return i;
    let p = Oe(d, { 0: () => r.indexOf(s[0]), 1: () => r.indexOf(s[s.length - 1]) });
    return { ...i, selectedIndex: p === -1 ? e.selectedIndex : p };
  }
  let a = r.slice(0, t.index), l = [...r.slice(t.index), ...a].find((d) => s.includes(d));
  if (!l)
    return i;
  let u = (n = r.indexOf(l)) != null ? n : e.selectedIndex;
  return u === -1 && (u = e.selectedIndex), { ...i, selectedIndex: u };
}, 1(e, t) {
  if (e.tabs.includes(t.tab))
    return e;
  let n = e.tabs[e.selectedIndex], r = wr([...e.tabs, t.tab], (s) => s.current), o = e.selectedIndex;
  return e.info.current.isControlled || (o = r.indexOf(n), o === -1 && (o = e.selectedIndex)), { ...e, tabs: r, selectedIndex: o };
}, 2(e, t) {
  return { ...e, tabs: e.tabs.filter((n) => n !== t.tab) };
}, 3(e, t) {
  return e.panels.includes(t.panel) ? e : { ...e, panels: wr([...e.panels, t.panel], (n) => n.current) };
}, 4(e, t) {
  return { ...e, panels: e.panels.filter((n) => n !== t.panel) };
} }, Pp = Be(null);
Pp.displayName = "TabsDataContext";
function ms(e) {
  let t = Le(Pp);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, ms), n;
  }
  return t;
}
let Ep = Be(null);
Ep.displayName = "TabsActionsContext";
function Op(e) {
  let t = Le(Ep);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Op), n;
  }
  return t;
}
function pO(e, t) {
  return Oe(t.type, dO, e, t);
}
let fO = wt;
function hO(e, t) {
  let { defaultIndex: n = 0, vertical: r = !1, manual: o = !1, onChange: s, selectedIndex: i = null, ...a } = e;
  const l = r ? "vertical" : "horizontal", u = o ? "manual" : "auto";
  let d = i !== null, p = Ct({ isControlled: d }), f = ke(t), [h, g] = Qr(pO, { info: p, selectedIndex: i ?? n, tabs: [], panels: [] }), m = ie(() => ({ selectedIndex: h.selectedIndex }), [h.selectedIndex]), v = Ct(s || (() => {
  })), b = Ct(h.tabs), y = ie(() => ({ orientation: l, activation: u, ...h }), [l, u, h]), w = ee((O) => (g({ type: 1, tab: O }), () => g({ type: 2, tab: O }))), S = ee((O) => (g({ type: 3, panel: O }), () => g({ type: 4, panel: O }))), x = ee((O) => {
    C.current !== O && v.current(O), d || g({ type: 0, index: O });
  }), C = Ct(d ? e.selectedIndex : h.selectedIndex), P = ie(() => ({ registerTab: w, registerPanel: S, change: x }), []);
  $e(() => {
    g({ type: 0, index: i ?? n });
  }, [i]), $e(() => {
    if (C.current === void 0 || h.tabs.length <= 0)
      return;
    let O = wr(h.tabs, (E) => E.current);
    O.some((E, T) => h.tabs[T] !== E) && x(O.indexOf(h.tabs[C.current]));
  });
  let _ = { ref: f };
  return H.createElement(iO, null, H.createElement(Ep.Provider, { value: P }, H.createElement(Pp.Provider, { value: y }, y.tabs.length <= 0 && H.createElement(oO, { onFocus: () => {
    var O, E;
    for (let T of b.current)
      if (((O = T.current) == null ? void 0 : O.tabIndex) === 0)
        return (E = T.current) == null || E.focus(), !0;
    return !1;
  } }), _e({ ourProps: _, theirProps: a, slot: m, defaultTag: fO, name: "Tabs" }))));
}
let gO = "div";
function mO(e, t) {
  let { orientation: n, selectedIndex: r } = ms("Tab.List"), o = ke(t);
  return _e({ ourProps: { ref: o, role: "tablist", "aria-orientation": n }, theirProps: e, slot: { selectedIndex: r }, defaultTag: gO, name: "Tabs.List" });
}
let vO = "button";
function bO(e, t) {
  var n, r;
  let o = Xe(), { id: s = `headlessui-tabs-tab-${o}`, ...i } = e, { orientation: a, activation: l, selectedIndex: u, tabs: d, panels: p } = ms("Tab"), f = Op("Tab"), h = ms("Tab"), g = K(null), m = ke(g, t);
  $e(() => f.registerTab(g), [f, g]);
  let v = nv("tabs"), b = d.indexOf(g);
  b === -1 && (b = v);
  let y = b === u, w = ee((E) => {
    var T;
    let R = E();
    if (R === Rn.Success && l === "auto") {
      let B = (T = oo(g)) == null ? void 0 : T.activeElement, U = h.tabs.findIndex((L) => L.current === B);
      U !== -1 && f.change(U);
    }
    return R;
  }), S = ee((E) => {
    let T = d.map((R) => R.current).filter(Boolean);
    if (E.key === ve.Space || E.key === ve.Enter) {
      E.preventDefault(), E.stopPropagation(), f.change(b);
      return;
    }
    switch (E.key) {
      case ve.Home:
      case ve.PageUp:
        return E.preventDefault(), E.stopPropagation(), w(() => xt(T, Ye.First));
      case ve.End:
      case ve.PageDown:
        return E.preventDefault(), E.stopPropagation(), w(() => xt(T, Ye.Last));
    }
    if (w(() => Oe(a, { vertical() {
      return E.key === ve.ArrowUp ? xt(T, Ye.Previous | Ye.WrapAround) : E.key === ve.ArrowDown ? xt(T, Ye.Next | Ye.WrapAround) : Rn.Error;
    }, horizontal() {
      return E.key === ve.ArrowLeft ? xt(T, Ye.Previous | Ye.WrapAround) : E.key === ve.ArrowRight ? xt(T, Ye.Next | Ye.WrapAround) : Rn.Error;
    } })) === Rn.Success)
      return E.preventDefault();
  }), x = K(!1), C = ee(() => {
    var E;
    x.current || (x.current = !0, (E = g.current) == null || E.focus({ preventScroll: !0 }), f.change(b), Ui(() => {
      x.current = !1;
    }));
  }), P = ee((E) => {
    E.preventDefault();
  }), _ = ie(() => {
    var E;
    return { selected: y, disabled: (E = e.disabled) != null ? E : !1 };
  }, [y, e.disabled]), O = { ref: m, onKeyDown: S, onMouseDown: P, onClick: C, id: s, role: "tab", type: Os(e, g), "aria-controls": (r = (n = p[b]) == null ? void 0 : n.current) == null ? void 0 : r.id, "aria-selected": y, tabIndex: y ? 0 : -1 };
  return _e({ ourProps: O, theirProps: i, slot: _, defaultTag: vO, name: "Tabs.Tab" });
}
let yO = "div";
function wO(e, t) {
  let { selectedIndex: n } = ms("Tab.Panels"), r = ke(t), o = ie(() => ({ selectedIndex: n }), [n]);
  return _e({ ourProps: { ref: r }, theirProps: e, slot: o, defaultTag: yO, name: "Tabs.Panels" });
}
let SO = "div", xO = Dt.RenderStrategy | Dt.Static;
function CO(e, t) {
  var n, r, o, s;
  let i = Xe(), { id: a = `headlessui-tabs-panel-${i}`, tabIndex: l = 0, ...u } = e, { selectedIndex: d, tabs: p, panels: f } = ms("Tab.Panel"), h = Op("Tab.Panel"), g = K(null), m = ke(g, t);
  $e(() => h.registerPanel(g), [h, g, a]);
  let v = nv("panels"), b = f.indexOf(g);
  b === -1 && (b = v);
  let y = b === d, w = ie(() => ({ selected: y }), [y]), S = { ref: m, id: a, role: "tabpanel", "aria-labelledby": (r = (n = p[b]) == null ? void 0 : n.current) == null ? void 0 : r.id, tabIndex: y ? l : -1 };
  return !y && ((o = u.unmount) == null || o) && !((s = u.static) != null && s) ? H.createElement(sn, { as: "span", "aria-hidden": "true", ...S }) : _e({ ourProps: S, theirProps: u, slot: w, defaultTag: SO, features: xO, visible: y, name: "Tabs.Panel" });
}
let PO = Te(bO), EO = Te(hO), OO = Te(mO), _O = Te(wO), TO = Te(CO), Ws = Object.assign(PO, { Group: EO, List: OO, Panels: _O, Panel: TO });
function AO(e) {
  let t = { called: !1 };
  return (...n) => {
    if (!t.called)
      return t.called = !0, e(...n);
  };
}
function Yc(e, ...t) {
  e && t.length > 0 && e.classList.add(...t);
}
function Xc(e, ...t) {
  e && t.length > 0 && e.classList.remove(...t);
}
function LO(e, t) {
  let n = Cn();
  if (!e)
    return n.dispose;
  let { transitionDuration: r, transitionDelay: o } = getComputedStyle(e), [s, i] = [r, o].map((l) => {
    let [u = 0] = l.split(",").filter(Boolean).map((d) => d.includes("ms") ? parseFloat(d) : parseFloat(d) * 1e3).sort((d, p) => p - d);
    return u;
  }), a = s + i;
  if (a !== 0) {
    n.group((u) => {
      u.setTimeout(() => {
        t(), u.dispose();
      }, a), u.addEventListener(e, "transitionrun", (d) => {
        d.target === d.currentTarget && u.dispose();
      });
    });
    let l = n.addEventListener(e, "transitionend", (u) => {
      u.target === u.currentTarget && (t(), l());
    });
  } else
    t();
  return n.add(() => t()), n.dispose;
}
function kO(e, t, n, r) {
  let o = n ? "enter" : "leave", s = Cn(), i = r !== void 0 ? AO(r) : () => {
  };
  o === "enter" && (e.removeAttribute("hidden"), e.style.display = "");
  let a = Oe(o, { enter: () => t.enter, leave: () => t.leave }), l = Oe(o, { enter: () => t.enterTo, leave: () => t.leaveTo }), u = Oe(o, { enter: () => t.enterFrom, leave: () => t.leaveFrom });
  return Xc(e, ...t.base, ...t.enter, ...t.enterTo, ...t.enterFrom, ...t.leave, ...t.leaveFrom, ...t.leaveTo, ...t.entered), Yc(e, ...t.base, ...a, ...u), s.nextFrame(() => {
    Xc(e, ...t.base, ...a, ...u), Yc(e, ...t.base, ...a, ...l), LO(e, () => (Xc(e, ...t.base, ...a), Yc(e, ...t.base, ...t.entered), i()));
  }), s.dispose;
}
function MO({ immediate: e, container: t, direction: n, classes: r, onStart: o, onStop: s }) {
  let i = _s(), a = Pn(), l = Ct(n);
  $e(() => {
    e && (l.current = "enter");
  }, [e]), $e(() => {
    let u = Cn();
    a.add(u.dispose);
    let d = t.current;
    if (d && l.current !== "idle" && i.current)
      return u.dispose(), o.current(l.current), u.add(kO(d, r.current, l.current === "enter", () => {
        u.dispose(), s.current(l.current);
      })), u.dispose;
  }, [n]);
}
function Nr(e = "") {
  return e.split(/\s+/).filter((t) => t.length > 1);
}
let Xl = Be(null);
Xl.displayName = "TransitionContext";
var $O = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))($O || {});
function RO() {
  let e = Le(Xl);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
function NO() {
  let e = Le(Zl);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
let Zl = Be(null);
Zl.displayName = "NestingContext";
function Jl(e) {
  return "children" in e ? Jl(e.children) : e.current.filter(({ el: t }) => t.current !== null).filter(({ state: t }) => t === "visible").length > 0;
}
function rv(e, t) {
  let n = Ct(e), r = K([]), o = _s(), s = Pn(), i = ee((h, g = Wr.Hidden) => {
    let m = r.current.findIndex(({ el: v }) => v === h);
    m !== -1 && (Oe(g, { [Wr.Unmount]() {
      r.current.splice(m, 1);
    }, [Wr.Hidden]() {
      r.current[m].state = "hidden";
    } }), s.microTask(() => {
      var v;
      !Jl(r) && o.current && ((v = n.current) == null || v.call(n));
    }));
  }), a = ee((h) => {
    let g = r.current.find(({ el: m }) => m === h);
    return g ? g.state !== "visible" && (g.state = "visible") : r.current.push({ el: h, state: "visible" }), () => i(h, Wr.Unmount);
  }), l = K([]), u = K(Promise.resolve()), d = K({ enter: [], leave: [], idle: [] }), p = ee((h, g, m) => {
    l.current.splice(0), t && (t.chains.current[g] = t.chains.current[g].filter(([v]) => v !== h)), t == null || t.chains.current[g].push([h, new Promise((v) => {
      l.current.push(v);
    })]), t == null || t.chains.current[g].push([h, new Promise((v) => {
      Promise.all(d.current[g].map(([b, y]) => y)).then(() => v());
    })]), g === "enter" ? u.current = u.current.then(() => t == null ? void 0 : t.wait.current).then(() => m(g)) : m(g);
  }), f = ee((h, g, m) => {
    Promise.all(d.current[g].splice(0).map(([v, b]) => b)).then(() => {
      var v;
      (v = l.current.shift()) == null || v();
    }).then(() => m(g));
  });
  return ie(() => ({ children: r, register: a, unregister: i, onStart: p, onStop: f, wait: u, chains: d }), [a, i, r, p, f, d, u]);
}
function jO() {
}
let DO = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function Qf(e) {
  var t;
  let n = {};
  for (let r of DO)
    n[r] = (t = e[r]) != null ? t : jO;
  return n;
}
function IO(e) {
  let t = K(Qf(e));
  return G(() => {
    t.current = Qf(e);
  }, [e]), t;
}
let VO = "div", ov = Dt.RenderStrategy;
function HO(e, t) {
  var n, r;
  let { beforeEnter: o, afterEnter: s, beforeLeave: i, afterLeave: a, enter: l, enterFrom: u, enterTo: d, entered: p, leave: f, leaveFrom: h, leaveTo: g, ...m } = e, v = K(null), b = ke(v, t), y = (n = m.unmount) == null || n ? Wr.Unmount : Wr.Hidden, { show: w, appear: S, initial: x } = RO(), [C, P] = W(w ? "visible" : "hidden"), _ = NO(), { register: O, unregister: E } = _;
  G(() => O(v), [O, v]), G(() => {
    if (y === Wr.Hidden && v.current) {
      if (w && C !== "visible") {
        P("visible");
        return;
      }
      return Oe(C, { hidden: () => E(v), visible: () => O(v) });
    }
  }, [C, v, O, E, w, y]);
  let T = Ct({ base: Nr(m.className), enter: Nr(l), enterFrom: Nr(u), enterTo: Nr(d), entered: Nr(p), leave: Nr(f), leaveFrom: Nr(h), leaveTo: Nr(g) }), R = IO({ beforeEnter: o, afterEnter: s, beforeLeave: i, afterLeave: a }), B = Es();
  G(() => {
    if (B && C === "visible" && v.current === null)
      throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [v, C, B]);
  let U = x && !S, L = S && w && x, M = (() => !B || U ? "idle" : w ? "enter" : "leave")(), D = J1(0), V = ee((Q) => Oe(Q, { enter: () => {
    D.addFlag(Ke.Opening), R.current.beforeEnter();
  }, leave: () => {
    D.addFlag(Ke.Closing), R.current.beforeLeave();
  }, idle: () => {
  } })), k = ee((Q) => Oe(Q, { enter: () => {
    D.removeFlag(Ke.Opening), R.current.afterEnter();
  }, leave: () => {
    D.removeFlag(Ke.Closing), R.current.afterLeave();
  }, idle: () => {
  } })), j = rv(() => {
    P("hidden"), E(v);
  }, _), Y = K(!1);
  MO({ immediate: L, container: v, classes: T, direction: M, onStart: Ct((Q) => {
    Y.current = !0, j.onStart(v, Q, V);
  }), onStop: Ct((Q) => {
    Y.current = !1, j.onStop(v, Q, k), Q === "leave" && !Jl(j) && (P("hidden"), E(v));
  }) });
  let J = m, le = { ref: b };
  return L ? J = { ...J, className: ll(m.className, ...T.current.enter, ...T.current.enterFrom) } : Y.current && (J.className = ll(m.className, (r = v.current) == null ? void 0 : r.className), J.className === "" && delete J.className), H.createElement(Zl.Provider, { value: j }, H.createElement(Wi, { value: Oe(C, { visible: Ke.Open, hidden: Ke.Closed }) | D.flags }, _e({ ourProps: le, theirProps: J, defaultTag: VO, features: ov, visible: C === "visible", name: "Transition.Child" })));
}
function BO(e, t) {
  let { show: n, appear: r = !1, unmount: o = !0, ...s } = e, i = K(null), a = ke(i, t);
  Es();
  let l = so();
  if (n === void 0 && l !== null && (n = (l & Ke.Open) === Ke.Open), ![!0, !1].includes(n))
    throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [u, d] = W(n ? "visible" : "hidden"), p = rv(() => {
    d("hidden");
  }), [f, h] = W(!0), g = K([n]);
  $e(() => {
    f !== !1 && g.current[g.current.length - 1] !== n && (g.current.push(n), h(!1));
  }, [g, n]);
  let m = ie(() => ({ show: n, appear: r, initial: f }), [n, r, f]);
  G(() => {
    if (n)
      d("visible");
    else if (!Jl(p))
      d("hidden");
    else {
      let w = i.current;
      if (!w)
        return;
      let S = w.getBoundingClientRect();
      S.x === 0 && S.y === 0 && S.width === 0 && S.height === 0 && d("hidden");
    }
  }, [n, p]);
  let v = { unmount: o }, b = ee(() => {
    var w;
    f && h(!1), (w = e.beforeEnter) == null || w.call(e);
  }), y = ee(() => {
    var w;
    f && h(!1), (w = e.beforeLeave) == null || w.call(e);
  });
  return H.createElement(Zl.Provider, { value: p }, H.createElement(Xl.Provider, { value: m }, _e({ ourProps: { ...v, as: wt, children: H.createElement(sv, { ref: a, ...v, ...s, beforeEnter: b, beforeLeave: y }) }, theirProps: {}, defaultTag: wt, features: ov, visible: u === "visible", name: "Transition" })));
}
function zO(e, t) {
  let n = Le(Xl) !== null, r = so() !== null;
  return H.createElement(H.Fragment, null, !n && r ? H.createElement(rd, { ref: t, ...e }) : H.createElement(sv, { ref: t, ...e }));
}
let rd = Te(BO), sv = Te(HO), FO = Te(zO), rr = Object.assign(rd, { Child: FO, Root: rd });
var eh = function(t) {
  return t.reduce(function(n, r) {
    var o = r[0], s = r[1];
    return n[o] = s, n;
  }, {});
}, th = typeof window < "u" && window.document && window.document.createElement ? Ue.useLayoutEffect : Ue.useEffect, Xt = "top", En = "bottom", On = "right", Zt = "left", _p = "auto", Xi = [Xt, En, On, Zt], vs = "start", Pi = "end", UO = "clippingParents", iv = "viewport", Gs = "popper", WO = "reference", nh = /* @__PURE__ */ Xi.reduce(function(e, t) {
  return e.concat([t + "-" + vs, t + "-" + Pi]);
}, []), av = /* @__PURE__ */ [].concat(Xi, [_p]).reduce(function(e, t) {
  return e.concat([t, t + "-" + vs, t + "-" + Pi]);
}, []), GO = "beforeRead", KO = "read", qO = "afterRead", YO = "beforeMain", XO = "main", ZO = "afterMain", JO = "beforeWrite", QO = "write", e_ = "afterWrite", t_ = [GO, KO, qO, YO, XO, ZO, JO, QO, e_];
function ir(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function an(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Oo(e) {
  var t = an(e).Element;
  return e instanceof t || e instanceof Element;
}
function xn(e) {
  var t = an(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Tp(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = an(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function n_(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, s = t.elements[n];
    !xn(s) || !ir(s) || (Object.assign(s.style, r), Object.keys(o).forEach(function(i) {
      var a = o[i];
      a === !1 ? s.removeAttribute(i) : s.setAttribute(i, a === !0 ? "" : a);
    }));
  });
}
function r_(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], s = t.attributes[r] || {}, i = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), a = i.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !xn(o) || !ir(o) || (Object.assign(o.style, a), Object.keys(s).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
const o_ = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: n_,
  effect: r_,
  requires: ["computeStyles"]
};
function or(e) {
  return e.split("-")[0];
}
var vo = Math.max, ul = Math.min, bs = Math.round;
function od() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function lv() {
  return !/^((?!chrome|android).)*safari/i.test(od());
}
function ys(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, s = 1;
  t && xn(e) && (o = e.offsetWidth > 0 && bs(r.width) / e.offsetWidth || 1, s = e.offsetHeight > 0 && bs(r.height) / e.offsetHeight || 1);
  var i = Oo(e) ? an(e) : window, a = i.visualViewport, l = !lv() && n, u = (r.left + (l && a ? a.offsetLeft : 0)) / o, d = (r.top + (l && a ? a.offsetTop : 0)) / s, p = r.width / o, f = r.height / s;
  return {
    width: p,
    height: f,
    top: d,
    right: u + p,
    bottom: d + f,
    left: u,
    x: u,
    y: d
  };
}
function Ap(e) {
  var t = ys(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function cv(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Tp(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Ar(e) {
  return an(e).getComputedStyle(e);
}
function s_(e) {
  return ["table", "td", "th"].indexOf(ir(e)) >= 0;
}
function io(e) {
  return ((Oo(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ql(e) {
  return ir(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Tp(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    io(e)
  );
}
function rh(e) {
  return !xn(e) || // https://github.com/popperjs/popper-core/issues/837
  Ar(e).position === "fixed" ? null : e.offsetParent;
}
function i_(e) {
  var t = /firefox/i.test(od()), n = /Trident/i.test(od());
  if (n && xn(e)) {
    var r = Ar(e);
    if (r.position === "fixed")
      return null;
  }
  var o = Ql(e);
  for (Tp(o) && (o = o.host); xn(o) && ["html", "body"].indexOf(ir(o)) < 0; ) {
    var s = Ar(o);
    if (s.transform !== "none" || s.perspective !== "none" || s.contain === "paint" || ["transform", "perspective"].indexOf(s.willChange) !== -1 || t && s.willChange === "filter" || t && s.filter && s.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Zi(e) {
  for (var t = an(e), n = rh(e); n && s_(n) && Ar(n).position === "static"; )
    n = rh(n);
  return n && (ir(n) === "html" || ir(n) === "body" && Ar(n).position === "static") ? t : n || i_(e) || t;
}
function Lp(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function si(e, t, n) {
  return vo(e, ul(t, n));
}
function a_(e, t, n) {
  var r = si(e, t, n);
  return r > n ? n : r;
}
function uv() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function dv(e) {
  return Object.assign({}, uv(), e);
}
function pv(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var l_ = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, dv(typeof t != "number" ? t : pv(t, Xi));
};
function c_(e) {
  var t, n = e.state, r = e.name, o = e.options, s = n.elements.arrow, i = n.modifiersData.popperOffsets, a = or(n.placement), l = Lp(a), u = [Zt, On].indexOf(a) >= 0, d = u ? "height" : "width";
  if (!(!s || !i)) {
    var p = l_(o.padding, n), f = Ap(s), h = l === "y" ? Xt : Zt, g = l === "y" ? En : On, m = n.rects.reference[d] + n.rects.reference[l] - i[l] - n.rects.popper[d], v = i[l] - n.rects.reference[l], b = Zi(s), y = b ? l === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, w = m / 2 - v / 2, S = p[h], x = y - f[d] - p[g], C = y / 2 - f[d] / 2 + w, P = si(S, C, x), _ = l;
    n.modifiersData[r] = (t = {}, t[_] = P, t.centerOffset = P - C, t);
  }
}
function u_(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || cv(t.elements.popper, o) && (t.elements.arrow = o));
}
const d_ = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: c_,
  effect: u_,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ws(e) {
  return e.split("-")[1];
}
var p_ = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function f_(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: bs(n * o) / o || 0,
    y: bs(r * o) / o || 0
  };
}
function oh(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, s = e.variation, i = e.offsets, a = e.position, l = e.gpuAcceleration, u = e.adaptive, d = e.roundOffsets, p = e.isFixed, f = i.x, h = f === void 0 ? 0 : f, g = i.y, m = g === void 0 ? 0 : g, v = typeof d == "function" ? d({
    x: h,
    y: m
  }) : {
    x: h,
    y: m
  };
  h = v.x, m = v.y;
  var b = i.hasOwnProperty("x"), y = i.hasOwnProperty("y"), w = Zt, S = Xt, x = window;
  if (u) {
    var C = Zi(n), P = "clientHeight", _ = "clientWidth";
    if (C === an(n) && (C = io(n), Ar(C).position !== "static" && a === "absolute" && (P = "scrollHeight", _ = "scrollWidth")), C = C, o === Xt || (o === Zt || o === On) && s === Pi) {
      S = En;
      var O = p && C === x && x.visualViewport ? x.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        C[P]
      );
      m -= O - r.height, m *= l ? 1 : -1;
    }
    if (o === Zt || (o === Xt || o === En) && s === Pi) {
      w = On;
      var E = p && C === x && x.visualViewport ? x.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        C[_]
      );
      h -= E - r.width, h *= l ? 1 : -1;
    }
  }
  var T = Object.assign({
    position: a
  }, u && p_), R = d === !0 ? f_({
    x: h,
    y: m
  }, an(n)) : {
    x: h,
    y: m
  };
  if (h = R.x, m = R.y, l) {
    var B;
    return Object.assign({}, T, (B = {}, B[S] = y ? "0" : "", B[w] = b ? "0" : "", B.transform = (x.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + m + "px)" : "translate3d(" + h + "px, " + m + "px, 0)", B));
  }
  return Object.assign({}, T, (t = {}, t[S] = y ? m + "px" : "", t[w] = b ? h + "px" : "", t.transform = "", t));
}
function h_(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, s = n.adaptive, i = s === void 0 ? !0 : s, a = n.roundOffsets, l = a === void 0 ? !0 : a, u = {
    placement: or(t.placement),
    variation: ws(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, oh(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: i,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, oh(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const g_ = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: h_,
  data: {}
};
var va = {
  passive: !0
};
function m_(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, s = o === void 0 ? !0 : o, i = r.resize, a = i === void 0 ? !0 : i, l = an(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return s && u.forEach(function(d) {
    d.addEventListener("scroll", n.update, va);
  }), a && l.addEventListener("resize", n.update, va), function() {
    s && u.forEach(function(d) {
      d.removeEventListener("scroll", n.update, va);
    }), a && l.removeEventListener("resize", n.update, va);
  };
}
const v_ = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: m_,
  data: {}
};
var b_ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Ya(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return b_[t];
  });
}
var y_ = {
  start: "end",
  end: "start"
};
function sh(e) {
  return e.replace(/start|end/g, function(t) {
    return y_[t];
  });
}
function kp(e) {
  var t = an(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function Mp(e) {
  return ys(io(e)).left + kp(e).scrollLeft;
}
function w_(e, t) {
  var n = an(e), r = io(e), o = n.visualViewport, s = r.clientWidth, i = r.clientHeight, a = 0, l = 0;
  if (o) {
    s = o.width, i = o.height;
    var u = lv();
    (u || !u && t === "fixed") && (a = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: s,
    height: i,
    x: a + Mp(e),
    y: l
  };
}
function S_(e) {
  var t, n = io(e), r = kp(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, s = vo(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), i = vo(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), a = -r.scrollLeft + Mp(e), l = -r.scrollTop;
  return Ar(o || n).direction === "rtl" && (a += vo(n.clientWidth, o ? o.clientWidth : 0) - s), {
    width: s,
    height: i,
    x: a,
    y: l
  };
}
function $p(e) {
  var t = Ar(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function fv(e) {
  return ["html", "body", "#document"].indexOf(ir(e)) >= 0 ? e.ownerDocument.body : xn(e) && $p(e) ? e : fv(Ql(e));
}
function ii(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = fv(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), s = an(r), i = o ? [s].concat(s.visualViewport || [], $p(r) ? r : []) : r, a = t.concat(i);
  return o ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(ii(Ql(i)))
  );
}
function sd(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function x_(e, t) {
  var n = ys(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function ih(e, t, n) {
  return t === iv ? sd(w_(e, n)) : Oo(t) ? x_(t, n) : sd(S_(io(e)));
}
function C_(e) {
  var t = ii(Ql(e)), n = ["absolute", "fixed"].indexOf(Ar(e).position) >= 0, r = n && xn(e) ? Zi(e) : e;
  return Oo(r) ? t.filter(function(o) {
    return Oo(o) && cv(o, r) && ir(o) !== "body";
  }) : [];
}
function P_(e, t, n, r) {
  var o = t === "clippingParents" ? C_(e) : [].concat(t), s = [].concat(o, [n]), i = s[0], a = s.reduce(function(l, u) {
    var d = ih(e, u, r);
    return l.top = vo(d.top, l.top), l.right = ul(d.right, l.right), l.bottom = ul(d.bottom, l.bottom), l.left = vo(d.left, l.left), l;
  }, ih(e, i, r));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function hv(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? or(r) : null, s = r ? ws(r) : null, i = t.x + t.width / 2 - n.width / 2, a = t.y + t.height / 2 - n.height / 2, l;
  switch (o) {
    case Xt:
      l = {
        x: i,
        y: t.y - n.height
      };
      break;
    case En:
      l = {
        x: i,
        y: t.y + t.height
      };
      break;
    case On:
      l = {
        x: t.x + t.width,
        y: a
      };
      break;
    case Zt:
      l = {
        x: t.x - n.width,
        y: a
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var u = o ? Lp(o) : null;
  if (u != null) {
    var d = u === "y" ? "height" : "width";
    switch (s) {
      case vs:
        l[u] = l[u] - (t[d] / 2 - n[d] / 2);
        break;
      case Pi:
        l[u] = l[u] + (t[d] / 2 - n[d] / 2);
        break;
    }
  }
  return l;
}
function Ei(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, s = n.strategy, i = s === void 0 ? e.strategy : s, a = n.boundary, l = a === void 0 ? UO : a, u = n.rootBoundary, d = u === void 0 ? iv : u, p = n.elementContext, f = p === void 0 ? Gs : p, h = n.altBoundary, g = h === void 0 ? !1 : h, m = n.padding, v = m === void 0 ? 0 : m, b = dv(typeof v != "number" ? v : pv(v, Xi)), y = f === Gs ? WO : Gs, w = e.rects.popper, S = e.elements[g ? y : f], x = P_(Oo(S) ? S : S.contextElement || io(e.elements.popper), l, d, i), C = ys(e.elements.reference), P = hv({
    reference: C,
    element: w,
    strategy: "absolute",
    placement: o
  }), _ = sd(Object.assign({}, w, P)), O = f === Gs ? _ : C, E = {
    top: x.top - O.top + b.top,
    bottom: O.bottom - x.bottom + b.bottom,
    left: x.left - O.left + b.left,
    right: O.right - x.right + b.right
  }, T = e.modifiersData.offset;
  if (f === Gs && T) {
    var R = T[o];
    Object.keys(E).forEach(function(B) {
      var U = [On, En].indexOf(B) >= 0 ? 1 : -1, L = [Xt, En].indexOf(B) >= 0 ? "y" : "x";
      E[B] += R[L] * U;
    });
  }
  return E;
}
function E_(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, s = n.rootBoundary, i = n.padding, a = n.flipVariations, l = n.allowedAutoPlacements, u = l === void 0 ? av : l, d = ws(r), p = d ? a ? nh : nh.filter(function(g) {
    return ws(g) === d;
  }) : Xi, f = p.filter(function(g) {
    return u.indexOf(g) >= 0;
  });
  f.length === 0 && (f = p);
  var h = f.reduce(function(g, m) {
    return g[m] = Ei(e, {
      placement: m,
      boundary: o,
      rootBoundary: s,
      padding: i
    })[or(m)], g;
  }, {});
  return Object.keys(h).sort(function(g, m) {
    return h[g] - h[m];
  });
}
function O_(e) {
  if (or(e) === _p)
    return [];
  var t = Ya(e);
  return [sh(e), t, sh(t)];
}
function __(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, s = o === void 0 ? !0 : o, i = n.altAxis, a = i === void 0 ? !0 : i, l = n.fallbackPlacements, u = n.padding, d = n.boundary, p = n.rootBoundary, f = n.altBoundary, h = n.flipVariations, g = h === void 0 ? !0 : h, m = n.allowedAutoPlacements, v = t.options.placement, b = or(v), y = b === v, w = l || (y || !g ? [Ya(v)] : O_(v)), S = [v].concat(w).reduce(function(Q, re) {
      return Q.concat(or(re) === _p ? E_(t, {
        placement: re,
        boundary: d,
        rootBoundary: p,
        padding: u,
        flipVariations: g,
        allowedAutoPlacements: m
      }) : re);
    }, []), x = t.rects.reference, C = t.rects.popper, P = /* @__PURE__ */ new Map(), _ = !0, O = S[0], E = 0; E < S.length; E++) {
      var T = S[E], R = or(T), B = ws(T) === vs, U = [Xt, En].indexOf(R) >= 0, L = U ? "width" : "height", M = Ei(t, {
        placement: T,
        boundary: d,
        rootBoundary: p,
        altBoundary: f,
        padding: u
      }), D = U ? B ? On : Zt : B ? En : Xt;
      x[L] > C[L] && (D = Ya(D));
      var V = Ya(D), k = [];
      if (s && k.push(M[R] <= 0), a && k.push(M[D] <= 0, M[V] <= 0), k.every(function(Q) {
        return Q;
      })) {
        O = T, _ = !1;
        break;
      }
      P.set(T, k);
    }
    if (_)
      for (var j = g ? 3 : 1, Y = function(re) {
        var ge = S.find(function(X) {
          var Z = P.get(X);
          if (Z)
            return Z.slice(0, re).every(function(te) {
              return te;
            });
        });
        if (ge)
          return O = ge, "break";
      }, J = j; J > 0; J--) {
        var le = Y(J);
        if (le === "break")
          break;
      }
    t.placement !== O && (t.modifiersData[r]._skip = !0, t.placement = O, t.reset = !0);
  }
}
const T_ = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: __,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ah(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function lh(e) {
  return [Xt, On, En, Zt].some(function(t) {
    return e[t] >= 0;
  });
}
function A_(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, s = t.modifiersData.preventOverflow, i = Ei(t, {
    elementContext: "reference"
  }), a = Ei(t, {
    altBoundary: !0
  }), l = ah(i, r), u = ah(a, o, s), d = lh(l), p = lh(u);
  t.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: d,
    hasPopperEscaped: p
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": p
  });
}
const L_ = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: A_
};
function k_(e, t, n) {
  var r = or(e), o = [Zt, Xt].indexOf(r) >= 0 ? -1 : 1, s = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, i = s[0], a = s[1];
  return i = i || 0, a = (a || 0) * o, [Zt, On].indexOf(r) >= 0 ? {
    x: a,
    y: i
  } : {
    x: i,
    y: a
  };
}
function M_(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, s = o === void 0 ? [0, 0] : o, i = av.reduce(function(d, p) {
    return d[p] = k_(p, t.rects, s), d;
  }, {}), a = i[t.placement], l = a.x, u = a.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += u), t.modifiersData[r] = i;
}
const $_ = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: M_
};
function R_(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = hv({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const N_ = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: R_,
  data: {}
};
function j_(e) {
  return e === "x" ? "y" : "x";
}
function D_(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, s = o === void 0 ? !0 : o, i = n.altAxis, a = i === void 0 ? !1 : i, l = n.boundary, u = n.rootBoundary, d = n.altBoundary, p = n.padding, f = n.tether, h = f === void 0 ? !0 : f, g = n.tetherOffset, m = g === void 0 ? 0 : g, v = Ei(t, {
    boundary: l,
    rootBoundary: u,
    padding: p,
    altBoundary: d
  }), b = or(t.placement), y = ws(t.placement), w = !y, S = Lp(b), x = j_(S), C = t.modifiersData.popperOffsets, P = t.rects.reference, _ = t.rects.popper, O = typeof m == "function" ? m(Object.assign({}, t.rects, {
    placement: t.placement
  })) : m, E = typeof O == "number" ? {
    mainAxis: O,
    altAxis: O
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, O), T = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, R = {
    x: 0,
    y: 0
  };
  if (C) {
    if (s) {
      var B, U = S === "y" ? Xt : Zt, L = S === "y" ? En : On, M = S === "y" ? "height" : "width", D = C[S], V = D + v[U], k = D - v[L], j = h ? -_[M] / 2 : 0, Y = y === vs ? P[M] : _[M], J = y === vs ? -_[M] : -P[M], le = t.elements.arrow, Q = h && le ? Ap(le) : {
        width: 0,
        height: 0
      }, re = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : uv(), ge = re[U], X = re[L], Z = si(0, P[M], Q[M]), te = w ? P[M] / 2 - j - Z - ge - E.mainAxis : Y - Z - ge - E.mainAxis, de = w ? -P[M] / 2 + j + Z + X + E.mainAxis : J + Z + X + E.mainAxis, ce = t.elements.arrow && Zi(t.elements.arrow), Ce = ce ? S === "y" ? ce.clientTop || 0 : ce.clientLeft || 0 : 0, Pe = (B = T == null ? void 0 : T[S]) != null ? B : 0, at = D + te - Pe - Ce, ut = D + de - Pe, Pt = si(h ? ul(V, at) : V, D, h ? vo(k, ut) : k);
      C[S] = Pt, R[S] = Pt - D;
    }
    if (a) {
      var gt, Je = S === "x" ? Xt : Zt, dn = S === "x" ? En : On, ht = C[x], rt = x === "y" ? "height" : "width", dt = ht + v[Je], Tt = ht - v[dn], vt = [Xt, Zt].indexOf(b) !== -1, Et = (gt = T == null ? void 0 : T[x]) != null ? gt : 0, An = vt ? dt : ht - P[rt] - _[rt] - Et + E.altAxis, Vt = vt ? ht + P[rt] + _[rt] - Et - E.altAxis : Tt, Ln = h && vt ? a_(An, ht, Vt) : si(h ? An : dt, ht, h ? Vt : Tt);
      C[x] = Ln, R[x] = Ln - ht;
    }
    t.modifiersData[r] = R;
  }
}
const I_ = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: D_,
  requiresIfExists: ["offset"]
};
function V_(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function H_(e) {
  return e === an(e) || !xn(e) ? kp(e) : V_(e);
}
function B_(e) {
  var t = e.getBoundingClientRect(), n = bs(t.width) / e.offsetWidth || 1, r = bs(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function z_(e, t, n) {
  n === void 0 && (n = !1);
  var r = xn(t), o = xn(t) && B_(t), s = io(t), i = ys(e, o, n), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((ir(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  $p(s)) && (a = H_(t)), xn(t) ? (l = ys(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : s && (l.x = Mp(s))), {
    x: i.left + a.scrollLeft - l.x,
    y: i.top + a.scrollTop - l.y,
    width: i.width,
    height: i.height
  };
}
function F_(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(s) {
    t.set(s.name, s);
  });
  function o(s) {
    n.add(s.name);
    var i = [].concat(s.requires || [], s.requiresIfExists || []);
    i.forEach(function(a) {
      if (!n.has(a)) {
        var l = t.get(a);
        l && o(l);
      }
    }), r.push(s);
  }
  return e.forEach(function(s) {
    n.has(s.name) || o(s);
  }), r;
}
function U_(e) {
  var t = F_(e);
  return t_.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function W_(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function G_(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var ch = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function uh() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function K_(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, s = o === void 0 ? ch : o;
  return function(a, l, u) {
    u === void 0 && (u = s);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, ch, s),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, p = [], f = !1, h = {
      state: d,
      setOptions: function(b) {
        var y = typeof b == "function" ? b(d.options) : b;
        m(), d.options = Object.assign({}, s, d.options, y), d.scrollParents = {
          reference: Oo(a) ? ii(a) : a.contextElement ? ii(a.contextElement) : [],
          popper: ii(l)
        };
        var w = U_(G_([].concat(r, d.options.modifiers)));
        return d.orderedModifiers = w.filter(function(S) {
          return S.enabled;
        }), g(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var b = d.elements, y = b.reference, w = b.popper;
          if (uh(y, w)) {
            d.rects = {
              reference: z_(y, Zi(w), d.options.strategy === "fixed"),
              popper: Ap(w)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(E) {
              return d.modifiersData[E.name] = Object.assign({}, E.data);
            });
            for (var S = 0; S < d.orderedModifiers.length; S++) {
              if (d.reset === !0) {
                d.reset = !1, S = -1;
                continue;
              }
              var x = d.orderedModifiers[S], C = x.fn, P = x.options, _ = P === void 0 ? {} : P, O = x.name;
              typeof C == "function" && (d = C({
                state: d,
                options: _,
                name: O,
                instance: h
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: W_(function() {
        return new Promise(function(v) {
          h.forceUpdate(), v(d);
        });
      }),
      destroy: function() {
        m(), f = !0;
      }
    };
    if (!uh(a, l))
      return h;
    h.setOptions(u).then(function(v) {
      !f && u.onFirstUpdate && u.onFirstUpdate(v);
    });
    function g() {
      d.orderedModifiers.forEach(function(v) {
        var b = v.name, y = v.options, w = y === void 0 ? {} : y, S = v.effect;
        if (typeof S == "function") {
          var x = S({
            state: d,
            name: b,
            instance: h,
            options: w
          }), C = function() {
          };
          p.push(x || C);
        }
      });
    }
    function m() {
      p.forEach(function(v) {
        return v();
      }), p = [];
    }
    return h;
  };
}
var q_ = [v_, N_, g_, o_, $_, T_, I_, d_, L_], Y_ = /* @__PURE__ */ K_({
  defaultModifiers: q_
}), X_ = typeof Element < "u", Z_ = typeof Map == "function", J_ = typeof Set == "function", Q_ = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Xa(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, o;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Xa(e[r], t[r]))
          return !1;
      return !0;
    }
    var s;
    if (Z_ && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (s = e.entries(); !(r = s.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      for (s = e.entries(); !(r = s.next()).done; )
        if (!Xa(r.value[1], t.get(r.value[0])))
          return !1;
      return !0;
    }
    if (J_ && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (s = e.entries(); !(r = s.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      return !0;
    }
    if (Q_ && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function")
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function")
      return e.toString() === t.toString();
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, o[r]))
        return !1;
    if (X_ && e instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!((o[r] === "_owner" || o[r] === "__v" || o[r] === "__o") && e.$$typeof) && !Xa(e[o[r]], t[o[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var e5 = function(t, n) {
  try {
    return Xa(t, n);
  } catch (r) {
    if ((r.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw r;
  }
};
const t5 = /* @__PURE__ */ Yd(e5);
var n5 = [], Ts = function(t, n, r) {
  r === void 0 && (r = {});
  var o = Ue.useRef(null), s = {
    onFirstUpdate: r.onFirstUpdate,
    placement: r.placement || "bottom",
    strategy: r.strategy || "absolute",
    modifiers: r.modifiers || n5
  }, i = Ue.useState({
    styles: {
      popper: {
        position: s.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), a = i[0], l = i[1], u = Ue.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(h) {
        var g = h.state, m = Object.keys(g.elements);
        Z0.flushSync(function() {
          l({
            styles: eh(m.map(function(v) {
              return [v, g.styles[v] || {}];
            })),
            attributes: eh(m.map(function(v) {
              return [v, g.attributes[v]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), d = Ue.useMemo(function() {
    var f = {
      onFirstUpdate: s.onFirstUpdate,
      placement: s.placement,
      strategy: s.strategy,
      modifiers: [].concat(s.modifiers, [u, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return t5(o.current, f) ? o.current || f : (o.current = f, f);
  }, [s.onFirstUpdate, s.placement, s.strategy, s.modifiers, u]), p = Ue.useRef();
  return th(function() {
    p.current && p.current.setOptions(d);
  }, [d]), th(function() {
    if (!(t == null || n == null)) {
      var f = r.createPopper || Y_, h = f(t, n, d);
      return p.current = h, function() {
        h.destroy(), p.current = null;
      };
    }
  }, [t, n, r.createPopper]), {
    state: p.current ? p.current.state : null,
    styles: a.styles,
    attributes: a.attributes,
    update: p.current ? p.current.update : null,
    forceUpdate: p.current ? p.current.forceUpdate : null
  };
};
const Ji = (e) => typeof e < "u";
var Ve = /* @__PURE__ */ ((e) => (e.web = "web", e.email = "email", e))(Ve || {});
const Jt = Rt(function({
  children: t,
  title: n,
  onClose: r,
  icon: o,
  skipOverflow: s,
  shadow: i = !0,
  padding: a = !0,
  border: l = !0,
  round: u = !0,
  className: d,
  classNameBody: p,
  size: f = "m",
  titleClass: h = $("gs-utl-mb-2 gs-utl-mt-0.5"),
  style: g,
  bg: m,
  ...v
}, b) {
  return /* @__PURE__ */ A(
    "div",
    {
      ...v,
      ref: b,
      style: g,
      className: $([
        "gs-utl-card",
        d,
        m || Jd.bg,
        se.b,
        u && se.rnd,
        l ? z.br : se.bT,
        !s && "gs-utl-overflow-auto",
        i && "gs-utl-shadow-md",
        a && f === "l" && "gs-utl-p-5",
        a && f === "m" && "gs-utl-px-4 gs-utl-py-2",
        a && f === "s" && "gs-utl-px-2 gs-utl-py-1",
        a && f === "xs" && "gs-utl-px-2 gs-utl-py-0.5",
        a && f === "x2s" && "gs-utl-px-0.5"
      ]),
      children: [
        (n || r) && n !== !1 && /* @__PURE__ */ A(I, { className: $("gs-utl-card-title", h), items: "center", children: [
          /* @__PURE__ */ c(N, { className: $("truncate"), grow: !0, children: n }),
          (r || o) && /* @__PURE__ */ c(
            N,
            {
              onClick: r,
              className: $("cursor-pointer transition-opacity opacity-50 hover:gs-utl-opacity-100"),
              children: /* @__PURE__ */ c(oe, { icon: o || ne.close, size: "18px" })
            }
          )
        ] }),
        /* @__PURE__ */ c("div", { className: $("gs-utl-card-body", p), children: t })
      ]
    }
  );
});
var Rp = /* @__PURE__ */ ((e) => (e.canvas = "canvas", e.layers = "layers", e))(Rp || {}), Hr = /* @__PURE__ */ ((e) => (e.selectParent = "selectParent", e.duplicate = "duplicate", e.delete = "delete", e.symbolCreate = "symbolCreate", e.symbolDetach = "symbolDetach", e.symbolOverride = "symbolOverride", e.symbolOverrideClear = "symbolOverrideClear", e))(Hr || {});
class r5 {
  constructor(t) {
    this.isOpen = !1, this.isEnabled = !0, this.items = [], this.coordinates = { x: 0, y: 0 }, this.getItemsForComponent = Co(function* (n, r = {}) {
      var b;
      if (!(n != null && n.em))
        return [];
      const o = n.em.getEditor(), { isSymbol: s, isRoot: i } = o.Components.getSymbolInfo(n), a = !!n.getSymbolOverride(), l = !!n.get("removable"), u = !!n.parent() && !!n.toolbar.length, d = !!n.get("copyable"), p = [
        u && {
          id: Hr.selectParent,
          label: "Select parent",
          onClick: () => {
            o.runCommand("core:component-exit", { force: !0 });
          }
        },
        d && {
          id: Hr.duplicate,
          label: "Duplicate",
          onClick: () => {
            o.runCommand("tlb-clone");
          }
        },
        !s && l && {
          id: Hr.symbolCreate,
          label: "Create Symbol",
          onClick: () => {
            o.runCommand(me.symbolAdd);
          }
        },
        s && i && {
          id: Hr.symbolDetach,
          label: "Detach instance",
          onClick: () => {
            o.runCommand(me.symbolDetach);
          }
        },
        s && !a && {
          id: Hr.symbolOverride,
          label: "Make overridable",
          onClick: () => {
            o.runCommand(me.symbolOverride, { override: !0 });
          }
        },
        s && a && {
          id: Hr.symbolOverrideClear,
          label: "Clear overridable",
          onClick: () => {
            o.runCommand(me.symbolOverride);
          }
        },
        l && {
          id: Hr.delete,
          label: "Delete",
          onClick: () => {
            o.runCommand("core:component-delete");
          }
        }
      ].filter(Boolean), f = n.get("contextMenu"), h = {
        ...r,
        items: p,
        component: n,
        editor: o,
        type: n.get("type") || "default",
        source: r.source || Rp.canvas
      }, g = yield dh(f, h), m = (b = this.store.appEditorStore.sdkComponentsConfig) == null ? void 0 : b.contextMenu;
      return yield dh(m, {
        ...h,
        items: g
      });
    }), this.store = t, Ut(this, {}, { autoBind: !0 });
  }
  get publicState() {
    return {
      enabled: this.isEnabled
    };
  }
  setPublicState(t) {
    t.enabled !== void 0 && (this.isEnabled = t.enabled);
  }
  *showForComponent(t, n) {
    const r = t == null ? void 0 : t.em;
    if (!r)
      return;
    n.skipSelect || r.selected.hasComponent(t) || r.setSelected(t);
    const o = yield this.getItemsForComponent(t, n);
    o.length && this.show({ ...n, items: o });
  }
  show({ items: t, x: n, y: r, w: o, h: s }) {
    this.isOpen = !0, this.coordinates = { x: n, y: r, w: o, h: s }, this.items = t;
  }
  hide() {
    this.isOpen = !1, setTimeout(this.clear, 101);
  }
  clear() {
    this.items = [], this.coordinates = { x: 0, y: 0 };
  }
}
const dh = async (e, t) => ct(e) ? (await e(t)).filter(Boolean) : t.items, Np = () => It().contextMenu;
var gv, ph = Nd;
gv = ph.createRoot, ph.hydrateRoot;
function mv(e, t) {
  G(() => {
    const n = "pointerdown", { current: r } = e;
    if (!r || !t.enabled)
      return;
    function o(s) {
      const i = s.target;
      r && i && !r.contains(i) && t.onTrigger(i);
    }
    return document.addEventListener(n, o), () => {
      document.removeEventListener(n, o);
    };
  }, [e.current, t.enabled]);
}
const vv = (e, t) => {
  const { boxRectScreen: n, vwHeight: r, initialPos: o = "top-right", zoomMultiplier: s = 1 } = t, i = o.split("-"), a = i[0], l = i[1], u = a === "top" ? "bottom" : "top", d = l === "right" ? "left" : "right";
  kl(() => {
    const p = e.current;
    if (p) {
      const { offsetWidth: f, offsetHeight: h } = p, g = n.y - h, m = n.x + n.width - f, v = n.height + h > r, b = g < 0, y = b && !v ? u : a, w = m < 0 ? d : l;
      if (t.setPos(`${y}-${w}`), v) {
        const S = n.y + n.height, x = S < 0 ? g - S : g;
        p.style.top = b ? `${parseInt(`${-x}`) * s}px` : "";
      } else
        p.style.top = "";
    }
  }, [e.current, n]);
}, bv = (e) => {
  const { ref: t, show: n, node: r, styles: o, update: s, reload: i } = e, a = {
    all: "initial",
    zIndex: "10",
    fontFamily: "inherit",
    ...o
  };
  G(() => {
    const l = t.current;
    if (l && n) {
      if (!l.__sh) {
        const p = l.attachShadow({ mode: "closed" });
        l.__sh = gv(p);
      }
      l.__sh.render(r), Object.keys(a).forEach((p) => {
        l.style.setProperty(lS(p), a[p], "important");
      });
      const u = new MutationObserver(i);
      u.observe(l, { attributeFilter: ["style"] });
      const d = new MutationObserver((p) => {
        Array.from(p[0].removedNodes).includes(l) && i();
      });
      return d.observe(l.parentNode, { childList: !0 }), () => {
        u.disconnect(), d.disconnect();
      };
    }
  }, [t.current, n, s]);
}, o5 = "gs-cmp-popover";
function Rr({
  children: e,
  handler: t,
  title: n,
  size: r,
  padding: o = !0,
  overlay: s,
  clickAway: i,
  topIcon: a,
  placement: l = "auto",
  offset: u,
  open: d,
  onClose: p,
  buttonAs: f,
  className: h,
  classNameBody: g,
  buttonProps: m = {}
}) {
  const [v, b] = W(!!d), [y, w] = W(v), [S, x] = W(null), [C, P] = W(null), _ = Ts(S, C, {
    ...Dp({ offset: u }),
    placement: l
  }), O = () => {
    w(!1), p == null || p();
  };
  mv(
    { current: C },
    {
      onTrigger: O,
      enabled: i && v
    }
  ), G(() => {
    w(!!d);
  }, [d]), G(() => {
    var R;
    v && ((R = _.update) == null || R.call(_));
  }, [v, _.update]), G(() => {
    const R = setTimeout(() => b(y), 10);
    return () => clearTimeout(R);
  }, [y]);
  const E = $("w-full transition-colors", ...P1({ border: !1, size: "", ...m })), T = $([
    "fixed z-20",
    a && "gjs-mt-5",
    r === "s" && "w-full max-w-64",
    r === "sm" && "w-full max-w-sm",
    r === "md" && "w-full max-w-md"
  ]);
  return /* @__PURE__ */ A(Kc, { className: $(o5, "relative flex", h), children: [
    /* @__PURE__ */ c(Kc.Button, { ref: x, as: f, className: E, children: /* @__PURE__ */ c("div", { onClick: () => !Ji(d) && w(!v), children: t }) }),
    v && s && /* @__PURE__ */ c("div", { onClick: O, className: $("z-10 fixed inset-0") }),
    y && /* @__PURE__ */ c(
      Kc.Panel,
      {
        static: !0,
        className: T,
        ref: P,
        style: _.styles.popper,
        ..._.attributes.popper,
        children: /* @__PURE__ */ c(rr, { as: wt, show: v, unmount: !1, ...Zd, children: /* @__PURE__ */ c(Jt, { title: n, onClose: O, padding: o, classNameBody: g, children: typeof e == "function" ? e({ close: O }) : e }) })
      }
    )
  ] });
}
function ec({ action: e, icon: t, label: n, className: r, items: o, ...s }) {
  const i = K(null), [a, l] = W(), u = i.current, d = $([
    r,
    "gs-utl-last:border-b-0 gs-utl-gap-2 gs-utl-select-none",
    z.br,
    Re.xy,
    se.bb,
    s.disabled && Qe.disabled,
    ...e ? [z.hBgH, "gs-utl-cursor-pointer"] : ["gs-utl-cursor-default"]
  ]), p = (h) => ct(e) && e({ event: h });
  return G(() => {
    if (!u)
      return;
    const h = setTimeout(() => l(u.getBoundingClientRect()), s.active ? 0 : S1);
    return () => clearTimeout(h);
  }, [u, s.active]), /* @__PURE__ */ A(I, { ref: i, items: "center", nowrap: !0, className: d, onClick: p, onPointerEnter: () => {
    var h;
    return (h = s.onActive) == null ? void 0 : h.call(s);
  }, children: [
    t && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(oe, { icon: t, size: pe.s }) }),
    /* @__PURE__ */ c(N, { className: $(s.classNameLabel, Qe.txtEllips), grow: !0, children: n }),
    !!(o != null && o.length) && /* @__PURE__ */ A(ae, { children: [
      /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(oe, { icon: ne.chevronRight, size: pe.s, className: $("-gs-utl-mr-2") }) }),
      a && s.active && /* @__PURE__ */ c(xv, { items: o, x: a.left, y: a.top, w: a.width, h: a.height, open: !0 })
    ] })
  ] });
}
function $t({
  className: e,
  as: t = "label",
  bold: n,
  m: r = "gjs-mb-1",
  size: o = "m",
  capitalize: s = !0,
  children: i,
  tip: a,
  ...l
}) {
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    /* @__PURE__ */ A(
      t,
      {
        className: $(
          e,
          r,
          a ? "gs-utl-flex gs-utl-gap-2 gs-utl-items-center" : "block",
          s && "capitalize",
          n && "font-semibold",
          o === "s" && "text-sm"
        ),
        ...l,
        children: [
          !!a && /* @__PURE__ */ c(yt, { classNameWrp: "gs-utl-normal-case", classNameContent: "gs-utl-max-w-60", title: a, children: /* @__PURE__ */ c(oe, { icon: ne.information, size: pe.s2x }) }),
          i
        ]
      }
    )
  );
}
const s5 = (e, t) => e.filter((n) => n.id === t)[0] || null, yv = (e, t) => (e == null ? void 0 : e.id) === (t == null ? void 0 : t.id), i5 = (e, t) => e.label.toLowerCase().indexOf(t.toLowerCase()) >= 0, wv = $("cursor-default select-none focus:gs-utl-outline-none", "z-20 max-h-full"), jp = {
  strategy: "fixed",
  placement: "bottom",
  modifiers: [
    {
      name: "offset",
      options: { offset: [0, 5] }
    },
    {
      name: "flip",
      options: { fallbackPlacements: ["top"] }
    }
  ]
};
function fh(e) {
  var s;
  const { option: t, active: n, selected: r } = e, o = ((s = e.isSelected) == null ? void 0 : s.call(e)) || !0;
  return /* @__PURE__ */ A(I, { items: "center", className: $([Re.xy, n && Jd.bgH]), children: [
    /* @__PURE__ */ c(N, { className: $("truncate"), grow: !0, children: t.label }),
    /* @__PURE__ */ c(N, { className: $("gjs-pl-2"), children: yv(t, r) && o && /* @__PURE__ */ c(oe, { className: $(z.tA), icon: ne.check, size: pe.s }) })
  ] });
}
const a5 = "gs-select-field";
function Ae({
  value: e,
  onChange: t,
  onBlur: n,
  onFocus: r,
  handlerSelected: o,
  label: s,
  options: i,
  includeEmpty: a,
  className: l,
  search: u,
  fixed: d,
  open: p,
  caret: f = ne.chevronDown,
  size: h = "m",
  width: g = "",
  border: m,
  style: v,
  pos: b,
  emptyState: y = "- Select an option -",
  name: w,
  required: S,
  disabled: x,
  tip: C,
  classNameContainer: P,
  autoFocus: _
}) {
  const [O, E] = W(null), [T, R] = W(null), [B, U] = W(""), { styles: L, attributes: M } = Ts(O, T, jp), D = typeof u == "object" ? u.onChange : void 0, V = [...i].filter((X) => u ? D || i5(X, B) : X), k = u && (typeof u == "object" && u.value || B), j = k && V.length ? V[0] : s5(V, e), Y = (X) => t(X.id), J = { id: null, label: y }, le = j ? o ? o(j) : j.content || j.label : o ? o(J) : y;
  a && V.unshift(J);
  const Q = (X) => {
    const { value: Z } = X.target, te = Z.trim();
    switch (X.key) {
      case "Escape":
        t(null);
        break;
      case "Enter":
        t((V.length ? V[0].id : te) || null);
        break;
      case " ":
        ds(X);
        break;
    }
  }, re = q("gs-utl-w-full gs-utl-text-left gs-utl-cursor-pointer gs-utl-block", se.rnd, xi.focus), ge = () => {
    n == null || n();
  };
  return /* @__PURE__ */ c(Us, { value: j, onChange: Y, children: ({ open: X }) => /* @__PURE__ */ A(
    "div",
    {
      className: q(a5, P, "gs-utl-relative gs-utl-w-full gs-utl-text-sm"),
      style: v,
      children: [
        s && /* @__PURE__ */ c(Us.Label, { children: /* @__PURE__ */ c($t, { as: "span", size: h, tip: C, children: s }) }),
        w && /* @__PURE__ */ c(
          "input",
          {
            type: "input",
            name: w,
            value: (j == null ? void 0 : j.id) ?? "",
            onChange: () => {
            },
            className: $("gs-utl-w-[1px] gs-utl-h-[1px] gs-utl-opacity-[0.001] gs-utl-absolute"),
            required: S,
            disabled: x
          }
        ),
        /* @__PURE__ */ c(Us.Button, { ref: E, className: re, tabIndex: u ? -1 : void 0, children: u ? /* @__PURE__ */ c(
          "input",
          {
            autoFocus: _,
            value: typeof u == "object" && u.value || B,
            className: q([l, "gs-utl-w-full", se.rnd, xi.focus, Re.xyS]),
            onChange: (Z) => {
              U(Z.target.value), D == null || D(Z.target.value);
            },
            onKeyDown: Q,
            onClick: ds,
            onBlur: ge,
            onFocus: r
          }
        ) : /* @__PURE__ */ c(
          Jt,
          {
            border: m,
            size: h,
            title: le,
            icon: f,
            shadow: !1,
            className: $(l),
            titleClass: ""
          }
        ) }),
        /* @__PURE__ */ c(
          Us.Options,
          {
            static: p,
            className: wv,
            ref: R,
            style: L.popper,
            ...M.popper,
            children: /* @__PURE__ */ A(
              Jt,
              {
                padding: !1,
                className: $("h-full"),
                style: { minWidth: `${O == null ? void 0 : O.offsetWidth}px`, maxHeight: 200 },
                children: [
                  !V.length && u && u !== !0 && /* @__PURE__ */ c("div", { className: $(Re.xy), children: u.empty }),
                  V.map((Z, te) => /* @__PURE__ */ c(Us.Option, { value: Z, children: ({ active: de, selected: ce }) => /* @__PURE__ */ A(I, { items: "center", className: $([Z.className, Re.xy, de && Jd.bgH]), children: [
                    /* @__PURE__ */ c(N, { className: $("truncate"), grow: !0, children: Z.content || Z.label }),
                    /* @__PURE__ */ c(N, { className: $("gjs-pl-2"), children: yv(Z, j) && !k && /* @__PURE__ */ c(oe, { className: $(z.tA), icon: ne.check, size: pe.s }) })
                  ] }) }, te))
                ]
              }
            )
          }
        )
      ]
    }
  ) });
}
const hh = lr() && document.body, Dp = (e = {}) => ({
  ...jp,
  placement: "right-start",
  modifiers: [
    {
      name: "offset",
      options: { offset: e.offset || [0, 5] }
    },
    {
      name: "flip",
      options: { boundary: e.boundary ?? hh }
    },
    {
      name: "preventOverflow",
      options: { boundary: e.boundary ?? hh }
    }
  ]
}), Sv = Dp(), ba = "gs-ctx-menu-list", xv = ue(function({ open: t, items: n, x: r, y: o, w: s, h: i }) {
  const a = Np(), [l, u] = W(), [d, p] = W(null), f = ie(() => ({ getBoundingClientRect: () => new DOMRect(r, o, s, i) }), [r, o, s, i, t]), { styles: h, attributes: g } = Ts(f, d, Sv), m = q(`${ba}-wrp gs-utl-z-20`), v = q(`${ba} gs-utl-z-20`), b = q(`${ba}-body gs-utl-max-w-56`), y = q(`${ba}-item`), w = "gs-utl-max-w-40", S = (x) => {
    const { action: C, onClick: P } = x;
    if (C || P)
      return (_) => {
        const O = {
          editor: a.store.appEditorStore.editor,
          ..._
        };
        ct(C) ? (C(O), a.hide()) : ct(P) && (P(O), a.hide());
      };
  };
  return /* @__PURE__ */ c("div", { className: m, ref: p, style: h.popper, ...g.popper, children: /* @__PURE__ */ c(rr, { show: !!t, ...zi, unmount: !1, children: /* @__PURE__ */ c(Jt, { padding: !1, className: v, classNameBody: b, children: n.map((x, C) => /* @__PURE__ */ is(
    ec,
    {
      ...x,
      key: x.id ?? C,
      className: y,
      classNameLabel: w,
      action: S(x),
      onActive: () => u(x),
      active: l === x
    }
  )) }) }) });
}), Zc = "gs-cmp-tooltip";
function yt({
  className: e,
  classNameWrp: t,
  classNameContent: n,
  children: r,
  title: o,
  onClick: s,
  inline: i,
  size: a
}) {
  const [l, u] = W(!1), [d, p] = W(!1), f = Ji(a), [h, g] = W(null), [m, v] = W(null), b = Ts(h, m, {
    ...Dp(),
    placement: "bottom"
  }), y = $(`${Zc}-target`, !i && "block", e, !s && "cursor-auto"), w = $(
    `${Zc}-content`,
    n,
    "fixed z-30 text-sm",
    !f && !n && "whitespace-nowrap",
    a === "s" && "w-60"
  );
  return G(() => {
    var S;
    l && ((S = b.update) == null || S.call(b));
  }, [l, b.update]), G(() => {
    const S = setTimeout(() => u(d), 10);
    return () => clearTimeout(S);
  }, [d]), /* @__PURE__ */ A("div", { className: $(Zc, "relative", t), children: [
    /* @__PURE__ */ c(
      "span",
      {
        ref: g,
        className: y,
        onMouseEnter: () => o && p(!0),
        onMouseLeave: () => p(!1),
        children: /* @__PURE__ */ c(
          "div",
          {
            className: $(i && "inline-block"),
            onClick: () => {
              p(!1), s == null || s();
            },
            children: r
          }
        )
      }
    ),
    !!d && /* @__PURE__ */ c(
      "div",
      {
        className: w,
        ref: v,
        style: b.styles.popper,
        ...b.attributes.popper,
        children: /* @__PURE__ */ c(rr, { show: !!l, unmount: !1, ...Zd, children: /* @__PURE__ */ c(Jt, { className: $(Ff.txt), bg: Ff.bg, size: "s", border: !1, children: o }) })
      }
    )
  ] });
}
function Ft({ children: e, title: t, classNameWrp: n, ...r }) {
  return /* @__PURE__ */ c(yt, { title: t, classNameWrp: n, children: /* @__PURE__ */ c(Ze, { ...r, children: e }) });
}
var Ht = /* @__PURE__ */ ((e) => (e.Info = "info", e.Error = "error", e.Success = "success", e.Warning = "warning", e))(Ht || {});
const l5 = {
  [Ht.Info]: z.bgA,
  [Ht.Error]: "bg-red-500",
  [Ht.Success]: "bg-green-500",
  [Ht.Warning]: "bg-orange-400"
}, c5 = H.forwardRef(function(t, n) {
  const r = {
    [Ht.Info]: ne.informationVariant,
    [Ht.Error]: ne.fire,
    [Ht.Success]: ne.checkBold,
    [Ht.Warning]: ne.alertRhombus
  }, { children: o, className: s, content: i, id: a, buttons: l = [], variant: u = Ht.Info, autoHideTimeout: d = 3e3 } = t, p = K(null), f = K(), h = r[u], g = l5[u];
  Ml(n, () => p.current, []);
  const m = () => {
    var w;
    return (w = t.onDismiss) == null ? void 0 : w.call(t, a);
  }, v = () => {
    d && (f.current = setTimeout(m, d));
  }, b = () => f.current && clearTimeout(f.current);
  G(() => (v(), b), []);
  const y = i || o;
  return /* @__PURE__ */ c(
    Jt,
    {
      className: F(s, "overflow-hidden relative"),
      ref: p,
      onPointerEnter: b,
      onPointerLeave: v,
      children: /* @__PURE__ */ A(I, { space: "m", items: "center", className: F(Re.y), children: [
        /* @__PURE__ */ c(N, { className: F(g, se.pill, "text-white gjs-p-1"), children: /* @__PURE__ */ c(oe, { icon: h, size: pe.s }) }),
        /* @__PURE__ */ c(N, { grow: !0, className: F("gjs-pr-3"), children: /* @__PURE__ */ A(I, { col: !0, space: "xs", children: [
          /* @__PURE__ */ c(N, { className: F("text-lg font-medium leading-6"), children: t.header }),
          y && /* @__PURE__ */ c(N, { className: F(z.txtLowEmphasis), children: y }),
          !!l.length && /* @__PURE__ */ c(I, { space: "m", justify: "end", children: l.map(({ id: w, ...S }) => /* @__PURE__ */ c(Ze, { ...S }, w)) })
        ] }) }),
        /* @__PURE__ */ c(N, { className: F("absolute top-1 right-1"), children: /* @__PURE__ */ c(Ft, { onClick: m, border: !1, children: /* @__PURE__ */ c(oe, { icon: ne.close, size: pe.s }) }) })
      ] })
    }
  );
}), u5 = ue(
  H.forwardRef(function({ className: t, toasts: n, onDismiss: r, ...o }, s) {
    const i = VS({});
    return (
      // For some reason with Grid, automate flickers
      /* @__PURE__ */ c("div", { className: F(t, "w-80 gs-utl-z-30"), ...o, ref: i, children: n.map((a) => /* @__PURE__ */ c(c5, { ...a, className: F("gjs-mb-2"), onDismiss: r }, a.uuid || a.id)) })
    );
  })
);
var id = /* @__PURE__ */ ((e) => (e.self = "self", e.cloud = "cloud", e))(id || {}), Ip = /* @__PURE__ */ ((e) => (e.IMAGE = "image", e.VIDEO = "video", e))(Ip || {}), kn = /* @__PURE__ */ ((e) => (e.componentOutline = "componentOutline", e.preview = "preview", e.fullscreen = "fullscreen", e.showCode = "showCode", e.showImportCode = "showImportCode", e.clearCanvas = "clearCanvas", e.store = "store", e.undo = "undo", e.redo = "redo", e))(kn || {}), d5 = /* @__PURE__ */ ((e) => (e.text = "text", e.number = "number", e.color = "color", e.select = "select", e.radio = "radio", e))(d5 || {}), Go = /* @__PURE__ */ ((e) => (e.left = "left", e.right = "right", e.top = "top", e.bottom = "bottom", e))(Go || {}), Ko = /* @__PURE__ */ ((e) => (e.popover = "popover", e.absolute = "absolute", e.static = "static", e.dialog = "dialog", e))(Ko || {}), ad = /* @__PURE__ */ ((e) => (e.browser = "browser", e.self = "self", e.cloud = "cloud", e))(ad || {}), qr = /* @__PURE__ */ ((e) => (e.dark = "dark", e.light = "light", e.auto = "auto", e))(qr || {});
function As(e, t, n) {
  let r, o, s, i, a;
  const l = t === void 0 ? 100 : t;
  function u() {
    const p = Date.now() - i;
    p < l && p >= 0 ? r = setTimeout(u, l - p) : (r = null, n || (a = e.apply(s, o), s = o = null));
  }
  const d = function() {
    s = this, o = arguments, i = Date.now();
    const p = n && !r;
    return r || (r = setTimeout(u, l)), p && (a = e.apply(s, o), s = o = null), a;
  };
  return d.clear = function() {
    r && (clearTimeout(r), r = null);
  }, d.flush = function() {
    r && (a = e.apply(s, o), s = o = null, clearTimeout(r), r = null);
  }, d;
}
const p5 = String.raw, dr = (e, t) => {
  if (!t)
    return "";
  const n = e[0], r = e[1];
  return `${n}${t}${r}`;
}, f5 = ({ family: e, source: t, options: n }) => {
  const {
    display: r,
    ascentOverride: o,
    descentOverride: s,
    featureSettings: i,
    lineGapOverride: a,
    stretch: l,
    style: u,
    unicodeRange: d,
    weight: p
  } = n ?? {}, f = [
    dr`font-ascent-override: ${o};`,
    dr`font-display: ${r};`,
    dr`font-descent-override: ${s};`,
    dr`font-feature-settings: ${i};`,
    dr`font-line-gap-override: ${a};`,
    dr`font-stretch: ${l};`,
    dr`font-style: ${u};`,
    dr`font-unicode-range: ${d};`,
    dr`font-weight: ${p};`
  ].filter(Boolean);
  return p5`
    @font-face {
      font-family: '${e}';
      src: url('${t}');
      ${f.join(`
`)}
    }
  `;
}, h5 = (e) => {
  let t = "";
  for (const n of e)
    for (const r of Object.values(n.variants))
      t += f5(r) + `
`;
  return t.trim();
}, Cv = (e) => {
  const t = h5(Object.values(e ?? {}));
  return t ? `<style data-project-fonts>${t}</style>` : "";
};
class g5 {
  constructor(t) {
    this.store = t, this.fonts = {}, Ut(this, {}, { autoBind: !0 });
  }
  loadFonts() {
    const { editor: t } = this.store.appEditorStore;
    if (!t)
      return;
    const { globalPageSettings: n } = Ss(t) ?? {}, { fonts: r } = n ?? {};
    if (r)
      for (const o of Object.values(r))
        this.addFont(o, !0);
  }
  addFont(t, n = !1) {
    const { editor: r } = this.store.appEditorStore;
    if (!r)
      return;
    const { family: o } = t;
    this.fonts[o] = t, n || this.updateProjectFonts(r);
  }
  removeFont(t) {
    const { editor: n } = this.store.appEditorStore;
    n && (delete this.fonts[t], this.updateProjectFonts(n));
  }
  updateProjectFonts(t) {
    const r = {
      ...Ss(t).globalPageSettings,
      fonts: Fr(this.fonts)
    };
    this.store.appEditorStore.setProjectDataCustom({ globalPageSettings: r }), Ov(t), t.trigger(_r.pageSettingsUpdate, { data: r });
  }
}
const Ks = (e) => (t) => (t.tagName || "").toLowerCase() === e, br = (...e) => e.map((t) => `[data-gjs-type="${t}"]`).join(","), m5 = (e, ...t) => {
  var n;
  return t.indexOf((n = e == null ? void 0 : e.tagName) == null ? void 0 : n.toUpperCase()) >= 0;
}, Zr = (e, t) => {
  var n;
  return (n = e == null ? void 0 : e.classList) == null ? void 0 : n.contains(t);
}, Pv = (e, t) => {
  var n;
  return !!((n = e == null ? void 0 : e.hasAttribute) != null && n.call(e, t));
}, Qi = (e, t) => {
  const n = e.Blocks.get(t);
  return n ? n.collection.indexOf(n) : -1;
}, v5 = (e) => e.replace(/[^a-z0-9.]/gi, "_").toLowerCase(), ld = (e, t, n = "html") => {
  const { Pages: r } = e, o = Gt({ page: t, key: "slug" }) ?? "";
  return `${r.getMain() === t ? "index" : Kd(o || t.getName())}.${n}`;
}, b5 = (e, t) => {
  const { toolbar: n } = e;
  n.some((o) => o.id === t.id) || (n.unshift(t), e.set("toolbar", [...n]));
}, dl = "custom-html-body", pl = "data-custom-html-body", gh = "data-global-custom-html-head", mh = "data-global-custom-html-body", vh = "global", y5 = function(e, t) {
  const n = (o) => {
    if (!o)
      return e.em.logError("loadGlobalHead: document not found");
    const s = cd(t.appStore);
    let i = o.querySelector(`[${gh}]`);
    i || (i = o.createElement("div"), i.setAttribute(gh, "true"), o.head.insertBefore(i, o.head.firstChild));
    const a = Cv(s.fonts), l = s.customCodeHead, u = [a, l].filter((d) => !!d).join(`
`);
    i.innerHTML = u, $f(i);
  }, r = (o) => {
    if (!o)
      return e.em.logError("loadGlobalBody: document not found");
    const s = cd(t.appStore);
    let i = o.querySelector(`[${mh}]`);
    if (!i) {
      i = o.createElement("div"), i.setAttribute(mh, "true");
      const a = o.querySelector('[data-gjs-type="wrapper"]');
      a == null || a.appendChild(i);
    }
    i.innerHTML = s.customCodeBody || "", $f(i);
  };
  e.on(e.Canvas.events.frameLoad, (o) => {
    var s;
    return n((s = o.el.contentWindow) == null ? void 0 : s.document);
  }), e.on(e.Canvas.events.frameLoadBody, (o) => {
    var s;
    return r((s = o.el.contentWindow) == null ? void 0 : s.document);
  }), e.on(_r.pageSettingsUpdate, (o) => {
    var i, a;
    if (o.page)
      return;
    const s = (a = (i = e.Canvas.getFrames()[0]) == null ? void 0 : i.view) == null ? void 0 : a.getDoc();
    n(s), r(s);
  }), e.Components.addType(dl, {
    isComponent: (o) => Pv(o, pl),
    model: {
      defaults: {
        attributes: { [pl]: !0 },
        locked: !0,
        layerable: !1
      },
      toHTML: () => ""
    }
  }), e.on(e.events.projectLoad, () => {
    const { appStore: o } = t, { globalPageSettings: s } = o.projectDataCustom;
    let i = (s == null ? void 0 : s.customCodeHead) || "", a = (s == null ? void 0 : s.customCodeBody) || "";
    e.Pages.getAll().forEach((l) => {
      const u = l.getMainComponent(), d = u.head.components(), p = [];
      d.forEach((g) => {
        g.has(vh) && p.push(g);
      }), p.forEach((g) => {
        const m = g.toHTML();
        i.includes(m) || (i += m), g.remove();
      });
      const f = [];
      u.findType(dl).forEach((g) => {
        g.has(vh) && f.push(g);
      }), f.forEach((g) => {
        const m = g.getInnerHTML();
        a.includes(m) || (a += m), g.remove();
      });
    }), (i || a) && o.setProjectDataCustom({
      globalPageSettings: {
        ...s,
        customCodeHead: i,
        customCodeBody: a
      }
    });
  });
}, bh = (e) => {
  const t = e.getDirtyCount() || 0;
  e.em.set({ changesCount: t + 1 }, {});
}, Ev = (e) => !!e.getSymbolOverride() ? /* @__PURE__ */ c(oe, { icon: ne.rhombusOutline, size: pe.s3x }) : /* @__PURE__ */ c(Xd, { className: q("gs-cmp-svg-icon gs-utl-w-[16px] gs-utl-fill-current"), svg: e.getIcon() }), Ov = (e) => {
  e.getModel().set({
    changesCount: e.getDirtyCount() + 1
  });
}, w5 = (e) => e && e === e.em.Pages.getMain(), et = {
  title: ({ cmp: e }) => e.tagName === "title",
  favicon: ({ cmp: e }) => {
    var t;
    return e.tagName === "link" && ((t = e.attributes.attributes) == null ? void 0 : t.rel) === "icon";
  },
  description: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.name) === "description";
  },
  keywords: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.name) === "keywords";
  },
  socialTitle: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.property) === "og:title";
  },
  socialImage: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.property) === "og:image";
  },
  socialDescription: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.property) === "og:description";
  },
  charset: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.charset);
  },
  viewport: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.name) === "viewport";
  },
  robots: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.name) === "robots";
  },
  generator: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.name) === "generator";
  }
}, _v = (e) => {
  for (const t in et) {
    const n = t;
    if (et[n]({ cmp: e }))
      return n;
  }
}, Tv = (e, t, n) => {
  const r = [];
  let o = n;
  return e.getMainComponent().findType(dl).forEach((s) => {
    r.push(s), o = (o || "") + s.getInnerHTML();
  }), { components: r, html: o, changed: o !== t };
}, S5 = (e, t) => {
  const n = { ...t }, r = e.getMainComponent(), { head: o } = r;
  if (o) {
    const i = [], a = o.components();
    a.forEach((u) => {
      et.title({ cmp: u }) ? (u.components(t.title), delete n.title) : et.favicon({ cmp: u }) ? (u.addAttributes({ href: t.favicon }), delete n.favicon) : et.description({ cmp: u }) ? (u.addAttributes({ content: t.description }), delete n.description) : et.keywords({ cmp: u }) ? (u.addAttributes({ content: t.keywords }), delete n.keywords) : et.socialTitle({ cmp: u }) ? (u.addAttributes({ content: t.socialTitle }), delete n.socialTitle) : et.socialDescription({ cmp: u }) ? (u.addAttributes({ content: t.socialDescription }), delete n.socialDescription) : et.socialImage({ cmp: u }) ? (u.addAttributes({ content: t.socialImage }), delete n.socialImage) : _v(u) || i.push(u);
    });
    const l = e.em.Parser.parseHtml(`<!DOCTYPE html><html><head>${t.customCodeHead}</head></html>`);
    l.head && (a.remove(i), l.head.components && a.add(l.head.components), delete n.customCodeHead);
  }
  const s = Tv(e, n.customCodeBody);
  if (s.changed) {
    const [i, ...a] = s.components;
    (i || r.append({ type: dl })[0]).components(n.customCodeBody), a.forEach((u) => u.remove()), delete n.customCodeBody;
  }
  return e.set("settings", n);
}, x5 = (e) => {
  const t = { ...e.get("settings") ?? {} }, n = e.getMainComponent(), { head: r } = n;
  if (r) {
    const o = [];
    r.components().forEach((s) => {
      const { content: i, href: a } = s.getAttributes({ noClass: !0, noStyle: !0 });
      et.title({ cmp: s }) ? t.title = s.getInnerHTML() : et.favicon({ cmp: s }) ? t.favicon = a : et.description({ cmp: s }) ? t.description = i : et.keywords({ cmp: s }) ? t.keywords = i : et.socialTitle({ cmp: s }) ? t.socialTitle = i : et.socialDescription({ cmp: s }) ? t.socialDescription = i : et.socialImage({ cmp: s }) ? t.socialImage = i : _v(s) || o.push(s.toHTML());
    }), o.length && (t.customCodeHead = o.join(`
`));
  }
  return t.customCodeBody = Tv(e, t.customCodeBody).html, t;
}, C5 = (e, t) => {
  e.getModel().set("customData", { ...Ss(e), ...t });
}, Ss = (e) => e.getModel().get("customData") ?? {}, cd = (e) => (e == null ? void 0 : e.projectDataCustom.globalPageSettings) ?? {}, Gt = (e) => {
  const { page: t, key: n, appEditorStore: r, def: o, defPage: s } = e;
  return t ? x5(t)[n] ?? s : cd(r)[n] ?? o;
}, jr = (e, t) => {
  const n = e.em.getEditor(), o = Ss(n).globalPageSettings || {};
  return Gt({ page: e, key: t }) || o[t];
}, yh = (e, t) => {
  const n = (e == null ? void 0 : e.getName()) ?? "", r = {
    page: e,
    appEditorStore: t,
    def: "",
    pageDef: ""
  };
  return {
    name: n,
    slug: Gt({ ...r, key: "slug", defPage: Kd(n) }),
    title: Gt({ ...r, key: "title", defPage: n }),
    description: Gt({ ...r, key: "description" }),
    favicon: Gt({ ...r, key: "favicon" }),
    keywords: Gt({ ...r, key: "keywords" }),
    socialTitle: Gt({ ...r, key: "socialTitle", defPage: n }),
    socialImage: Gt({ ...r, key: "socialImage" }),
    socialDescription: Gt({ ...r, key: "socialDescription" }),
    customCodeHead: Gt({ ...r, key: "customCodeHead" }),
    customCodeBody: Gt({ ...r, key: "customCodeBody" })
  };
}, Av = (e, t) => {
  var n;
  return (n = e.Styles.getSectors().find((r) => !!r.getProperty(t))) == null ? void 0 : n.getProperty(t);
}, P5 = (e, t, n) => {
  const r = Av(e, t);
  return r == null ? void 0 : r.getProperty(n);
};
class wh {
  constructor(t, n) {
    this.assetsStore = t, this.layoutPanelId = n, this.itemLayout = void 0, this.isLoadingAssets = !1, this.typeFilter = void 0, this.searchValue = "", this.customTypes = void 0, this.customProviders = void 0, this.providerFilter = void 0, this.customAssetProps = void 0, this.customPages = void 0, this.totalItems = void 0, this.optionalType = !1, Ut(this, {}, { autoBind: !0 }), this.initTypeFilter(), this.initProviderFilter(), this.initOptionalType(), this.loadAssetsDebounced = As(this.loadAssets, this.searchDebounceMs);
  }
  get typeFilterOptions() {
    return this.customTypes ?? [];
  }
  get providers() {
    return this.assetsStore.allProviders.map((t) => ({
      ...t,
      types: Array.isArray(t.types) ? t.types : [t.types]
    }));
  }
  get providerFilterOptions() {
    return this.providers.filter(
      (t) => (
        // filter by type
        (!this.typeFilter || t.types.includes(this.typeFilter)) && // filter by customProviders
        (!this.customProviders || this.customProviders.includes(t.id))
      )
    );
  }
  get provider() {
    return this.providers.find((t) => t.id === this.providerFilter);
  }
  get assetPropsFromPages() {
    if (!this.customPages)
      return;
    const t = [];
    for (const n of this.customPages)
      t.push(...n.items);
    return t;
  }
  get assetProps() {
    return !!!this.assetPropsFromPages && this.isLoadingAssets ? [] : this.customAssetProps ?? this.assetPropsFromPages ?? this.assetsStore.projectAssetProps ?? [];
  }
  get onProviderOrProjectDelete() {
    const { provider: t, assetsStore: n } = this;
    return t ? t.onDelete : n.onProjectDelete;
  }
  get t() {
    return this.assetsStore.t;
  }
  get isLoading() {
    return this.assetsStore.isLoadingAssets || this.isLoadingAssets;
  }
  get handleDelete() {
    return this.onProviderOrProjectDelete && this.handleDeleteCallback;
  }
  get shouldLoadNextPage() {
    var n;
    const t = (n = this.customPages) == null ? void 0 : n.at(-1);
    return t ? !t.isLastPage : !1;
  }
  get reloadOnInput() {
    var t, n;
    return ((n = (t = this.provider) == null ? void 0 : t.search) == null ? void 0 : n.reloadOnInput) ?? !1;
  }
  get searchDebounceMs() {
    var t, n;
    return ((n = (t = this.provider) == null ? void 0 : t.search) == null ? void 0 : n.debounceMs) ?? 1e3;
  }
  initOptionalType() {
    this.setOptionalType(!1);
  }
  initTypeFilter() {
    this.setTypeFilter(Ip.IMAGE);
  }
  initProviderFilter() {
    var t;
    this.setProviderFilter((t = this.assetsStore.sdkAssetConfig) == null ? void 0 : t.providerId);
  }
  setOptionalType(t) {
    this.optionalType = t;
  }
  setTypeFilter(t) {
    this.typeFilter = t;
  }
  setProviderFilter(t) {
    this.providerFilter = t;
  }
  setSearchValue(t) {
    this.searchValue = t, this.reloadOnInput && this.loadAssetsDebounced();
  }
  setCustomTypes(t) {
    this.customTypes = t;
  }
  setCustomProviders(t) {
    this.customProviders = t;
  }
  setCustomAssetProps(t) {
    this.customAssetProps = t;
  }
  setCustomPages(t) {
    this.customPages = t;
  }
  setItemLayout(t) {
    this.itemLayout = t;
  }
  setIsLoadingAssets(t) {
    this.isLoadingAssets = t;
  }
  selectProjectAssets() {
    this.setCustomAssetProps(void 0), this.setCustomPages(void 0), this.setItemLayout(void 0);
  }
  async loadProviderAssets(t) {
    var a, l, u, d;
    const { assetsStore: n } = this, { editor: r } = n;
    if (!r || !this.provider)
      return;
    t && (this.setCustomAssetProps(void 0), this.setCustomPages(void 0));
    const o = ((a = this.customPages) == null ? void 0 : a.length) ?? 0, s = (u = (l = this.customPages) == null ? void 0 : l.at(-1)) == null ? void 0 : u.nextPageCustomData, i = await this.provider.onLoad({
      editor: r,
      assetTypeFilter: this.typeFilter,
      pageIndex: o,
      searchValue: this.searchValue,
      pageCustomData: s
    }) ?? [];
    if (Array.isArray(i)) {
      const p = i.map(n.toAssetProps);
      this.setCustomAssetProps(p);
    } else {
      const p = {
        ...i,
        items: i.items.map(n.toAssetProps)
      };
      this.setCustomPages([...this.customPages ?? [], p]);
    }
    this.setItemLayout((d = this.provider) == null ? void 0 : d.itemLayout);
  }
  async loadAssets(t = !0) {
    const { assetsStore: n } = this, { toastStore: r } = n.store;
    try {
      this.provider ? (this.setIsLoadingAssets(!0), await this.loadProviderAssets(t)) : this.selectProjectAssets();
    } catch (o) {
      console.error(o), r.addError("assets-error-get", this.t("errorLoad"));
    } finally {
      this.setIsLoadingAssets(!1);
    }
  }
  async reloadAssets(t) {
    const { assetsStore: n } = this, { cachedOnLoadAssetProps: r } = n;
    await this.loadAssets(t == null ? void 0 : t.clearExisting), !this.provider && r && (n.cachedOnLoadAssetProps = void 0, await n.loadProjectAssets());
  }
  async handleDeleteCallback(t) {
    const { assetsStore: n, onProviderOrProjectDelete: r } = this, { appEditorStore: o } = n.store, { editor: s } = o;
    if (!(!s || !r))
      try {
        n.setIsLoadingAssets(!0), await r({
          assets: [n.toAsset(t)],
          assetProps: [t],
          editor: s,
          loadAssets: (i) => this.reloadAssets(i)
        });
      } catch (i) {
        console.error(i), n.store.toastStore.addError("assets-error-delete", {
          header: this.t("errorDelete"),
          content: i == null ? void 0 : i.message
        });
      } finally {
        n.setIsLoadingAssets(!1);
      }
  }
}
const Lv = (e) => It().assetsStore.assetPanelStores[e];
class E5 {
  constructor(t) {
    this.store = t, this.isLoadingAssets = !1, this.mainPanelId = `main-${f1()}`, this.assetPanelStores = {}, this.cachedOnLoadAssetProps = void 0, this.projectAssetProps = void 0, this.allProviders = [], this.assetPanelStores[this.mainPanelId] = new wh(this, this.mainPanelId), this.setAllProviders(this.isUsingAssetCloud ? [this.userProvider] : []), Ut(this, {}, { autoBind: !0 });
  }
  get sdkAssetConfig() {
    return this.store.appEditorStore.sdkOptions.assets;
  }
  get isUsingAssetCloud() {
    var t;
    return ((t = this.sdkAssetConfig) == null ? void 0 : t.storageType) === id.cloud;
  }
  get storageType() {
    var t;
    return (t = this.sdkAssetConfig) == null ? void 0 : t.storageType;
  }
  get isSelfStorage() {
    return this.storageType === id.self;
  }
  get editor() {
    return this.store.appEditorStore.editor;
  }
  get customOnLoad() {
    var t;
    return (t = this.sdkAssetConfig) == null ? void 0 : t.onLoad;
  }
  get customOnDelete() {
    var t;
    return (t = this.sdkAssetConfig) == null ? void 0 : t.onDelete;
  }
  get customOnUpload() {
    var t;
    return (t = this.sdkAssetConfig) == null ? void 0 : t.onUpload;
  }
  get onCloudOrCustomUpload() {
    const { appEditorStore: t } = this.store, { sdkProps: n } = t, o = n.options.licenseKey, s = t.sdkProjectId, i = t.sdkIdentityId, a = ({ files: l }) => PS(l, o, s, i);
    return this.isUsingAssetCloud ? a : this.customOnUpload;
  }
  get onProjectDelete() {
    const { customOnDelete: t, isSelfStorage: n, isUsingAssetCloud: r } = this;
    return n ? t ? async (o) => {
      await t(o), this.deleteFromProjectAssets(o);
    } : void 0 : r ? async (o) => {
      var l, u;
      const { sdkOptions: s } = this.store.appEditorStore, i = (l = s.project) == null ? void 0 : l.id, a = (u = s.identity) == null ? void 0 : u.id;
      await Rf(o.assetProps, s.licenseKey, i, a), this.deleteFromProjectAssets(o);
    } : this.deleteFromProjectAssets;
  }
  get t() {
    return this.store.i18nStore.tScoped("assetManager");
  }
  get userProvider() {
    var a, l;
    const { appEditorStore: t } = this.store, { sdkOptions: n } = t, r = (a = n.project) == null ? void 0 : a.id, o = (l = n.identity) == null ? void 0 : l.id, s = n.licenseKey;
    return {
      id: "grapesjs-user-provider",
      label: () => this.t("userAssets"),
      types: Ip.IMAGE,
      onLoad: () => SS(
        s,
        // both mandatory for storageType === 'cloud'
        r,
        o
      ),
      onDelete: async (u) => {
        const { assetProps: d, loadAssets: p } = u;
        await Rf(
          d,
          s,
          // both mandatory for storageType === 'cloud'
          r,
          o
        ), this.deleteFromProjectAssets(u), await p({ clearExisting: !1 });
      }
    };
  }
  onEditor() {
    const t = As(() => !this.loadProjectAssets()), n = this.store.appEditorStore.editor;
    this.addSdkProviders();
    const r = n.Assets.events.all;
    n.on(r, t), this.loadProjectAssets();
  }
  /**
   * Add sdk providers after any asset providers are added from plugins
   */
  addSdkProviders() {
    var r;
    const t = ((r = this.sdkAssetConfig) == null ? void 0 : r.providers) ?? [], n = ct(t) ? t({ providers: Fr(this.allProviders) }) : [...this.allProviders, ...t];
    this.setAllProviders(n);
  }
  addProvider(t, n = this.allProviders.length) {
    const r = [...this.allProviders];
    let o = this.allProviders.findIndex((i) => i.id === t.id);
    const s = o !== -1;
    r.splice(n, 0, t), s && (o >= n && (o += 1), r.splice(o, 1)), this.setAllProviders(r);
  }
  createAssetManager(t) {
    const n = new wh(this, t);
    this.assetPanelStores[t] = n;
  }
  removeAssetManager(t) {
    delete this.assetPanelStores[t];
  }
  async loadProjectAssets() {
    const { editor: t, isSelfStorage: n, cachedOnLoadAssetProps: r, customOnLoad: o } = this, { toastStore: s } = this.store;
    let i;
    if (t) {
      try {
        if (this.setIsLoadingAssets(!0), n && o)
          if (r)
            i = r;
          else {
            const a = await o({ editor: t });
            this.cachedOnLoadAssetProps = a.map(this.toAssetProps), i = this.cachedOnLoadAssetProps;
          }
        else
          i = t.Assets.getAll().map(this.toAssetProps);
      } catch (a) {
        console.error(a), s.addError("assets-error-load", {
          header: this.t("errorLoad"),
          content: a == null ? void 0 : a.message
        });
      } finally {
        this.setIsLoadingAssets(!1);
      }
      i && this.setProjectAssetProps(i);
    }
  }
  deleteFromProjectAssets({ assets: t, editor: n, assetProps: r }) {
    const { cachedOnLoadAssetProps: o, customOnLoad: s } = this;
    if (s) {
      if (o) {
        const i = r.map((a) => a.id);
        this.cachedOnLoadAssetProps = o.filter(({ id: a }) => !i.includes(a)), this.setProjectAssetProps(this.cachedOnLoadAssetProps);
      }
    } else
      t.forEach((i) => n.Assets.remove(i)), bh(n);
  }
  addToProjectAssets(t) {
    const n = this.store.appEditorStore.editor, { cachedOnLoadAssetProps: r, customOnLoad: o } = this;
    o ? r && (this.cachedOnLoadAssetProps = [...t, ...r], this.setProjectAssetProps(this.cachedOnLoadAssetProps)) : (n.Assets.add(t), bh(n));
  }
  async handleUpload(t) {
    var s, i;
    const { editor: n, onCloudOrCustomUpload: r } = this, { toastStore: o } = this.store;
    if (!(!n || !r))
      try {
        this.setIsLoadingAssets(!0);
        const a = ((s = t.dataTransfer) == null ? void 0 : s.files) || ((i = t.target) == null ? void 0 : i.files) || [], l = Array.from(a), u = await r({ files: l, editor: n });
        u != null && u.length ? this.addToProjectAssets(u.map(this.toAssetProps)) : console.warn("No assets returned from the upload handler. Ensure to return an array of assets.");
      } catch (a) {
        console.error(a), o.addError("assets-error-upload", {
          header: this.t("errorUpload"),
          content: a == null ? void 0 : a.message
        });
      } finally {
        this.setIsLoadingAssets(!1);
      }
  }
  uploadFile(t) {
    var n;
    return (n = this.editor) == null ? void 0 : n.Assets.FileUploader().uploadFile(t);
  }
  isAsset(t) {
    return !!t.getSrc;
  }
  toAssetProps(t) {
    if (this.isAsset(t)) {
      const r = t;
      return {
        ...r.attributes,
        id: r.attributes.id || r.getSrc(),
        src: r.getSrc(),
        name: r.attributes.name ?? r.getFilename(),
        asset: r
      };
    }
    return { ...t, id: t.id || t.src };
  }
  toAsset(t) {
    const { editor: n } = this.store.appEditorStore;
    if (n)
      return t.asset ?? new n.AssetManager.Asset(t);
  }
  setProjectAssetProps(t) {
    this.projectAssetProps = t;
  }
  setIsLoadingAssets(t) {
    this.isLoadingAssets = t;
  }
  setAllProviders(t) {
    this.allProviders = t;
  }
}
const ea = () => It().assetsStore;
class O5 {
  constructor(t) {
    this.store = t, Ut(this, {}, { autoBind: !0 });
  }
  t(t, n = {}) {
    var o;
    const { editor: r } = this.store.appEditorStore;
    return ((o = r == null ? void 0 : r.I18n) == null ? void 0 : o.t(t, n)) || "";
  }
  tScoped(t) {
    return (n, r) => this.t(`${t}.${n}`, r);
  }
}
const Ne = () => It().i18nStore, qt = (e, t) => X0.map(e, (n) => n && n.type === t ? n : null), Sh = "gs-custom-layout", _5 = Rt(function({ className: t, component: n, noWrapper: r, id: o, render: s, ...i }, a) {
  const { editor: l } = ye(), u = K(null), d = n, p = d && l ? /* @__PURE__ */ c(d, { editor: l }) : null, f = q(Sh, o && `${Sh}__${o}`, t), h = u.current, g = r && !s;
  return Ml(a, () => u.current, []), G(() => {
    if (!s || !h)
      return;
    const m = (y) => h.appendChild(y), v = (y) => h.removeChild(y), b = s({ editor: l, addEl: m, removeEl: v });
    if (Mt(b))
      h.innerHTML = b;
    else {
      if (b instanceof HTMLElement)
        return m(b), () => {
          v(b);
        };
      if (ct(b))
        return () => {
          b();
        };
    }
  }, [s, l, h]), g ? p : /* @__PURE__ */ c("div", { className: f, ref: u, ...i, children: p });
}), ud = ue(_5);
class T5 {
  constructor(t) {
    this.customConfig = void 0, this.layouts = [], this.layoutsById = /* @__PURE__ */ new Map(), this.store = t, Ut(this, {}, { autoBind: !0 });
  }
  get editor() {
    return this.store.appEditorStore.editor;
  }
  setCustomConfig(t) {
    this.customConfig = t;
  }
  add(t, n) {
    var r;
    this.get(t) || (this.layouts.push({
      id: t,
      ...n
    }), (r = this.editor) == null || r.trigger(`${_r.layoutToggleId}${t}`, { isOpen: !0 }));
  }
  remove(t, n) {
    var o;
    const r = n == null ? void 0 : n.layout;
    r && this.layouts.forEach((s) => {
      s.id === t && Object.assign(s, r);
    }), this.layouts = n != null && n.force ? this.layouts.filter((s) => s.id !== t) : this.layouts.map((s) => s.id === t ? { ...s, toRemove: !0 } : s), (o = this.editor) == null || o.trigger(`${_r.layoutToggleId}${t}`, { isOpen: !1 });
  }
  get(t) {
    return this.layouts.find((n) => n.id === t);
  }
  clear() {
    this.layouts = [];
  }
  get layoutChildren() {
    var r;
    const { children: t } = this.store.appEditorStore.sdkProps, n = ((r = qt(t, ud)) == null ? void 0 : r.filter(Boolean)) || [];
    return new Map(
      n.map(({ props: o }) => [o.id, o])
    );
  }
}
const Vp = () => It().layoutStore, A5 = () => oa().layoutStore;
class L5 {
  constructor(t) {
    this.isActive = !1, this.content = "", this.store = t, Ut(this, {}, { autoBind: !0 });
  }
  show(t) {
    this.isActive = !0, this.content = t;
  }
  hide() {
    this.isActive = !1, setTimeout(this.clear, 101);
  }
  clear() {
    this.content = "";
  }
}
const kv = () => It().pointerBadgeStore;
var Ls = /* @__PURE__ */ ((e) => (e.Projects = "projects", e.Settings = "settings", e))(Ls || {}), Mv = /* @__PURE__ */ ((e) => (e.gjs = "gjs", e.gjsStudio = "gjs-studio", e))(Mv || {});
const xh = {}, k5 = 1, M5 = (e = {}) => new Promise((t, n) => {
  const r = (e == null ? void 0 : e.db) || "gjs", o = r === "gjs-studio" ? k5 : 1, s = xh[r];
  if (s)
    t(s);
  else {
    if (!lr())
      return n(new Error("window context not found"));
    const i = window.indexedDB.open(r, o);
    i.onerror = n, i.onsuccess = () => {
      const a = i.result;
      a.onerror = n, xh[r] = a, t(a);
    }, i.onupgradeneeded = () => {
      const a = i.result;
      a.objectStoreNames.contains(
        "projects"
        /* Projects */
      ) || a.createObjectStore(
        "projects"
        /* Projects */
      ), a.objectStoreNames.contains(
        "settings"
        /* Settings */
      ) || a.createObjectStore(
        "settings"
        /* Settings */
      );
    };
  }
}), tc = async (e, t) => (await M5(t)).transaction([e], "readwrite").objectStore(e), $5 = async (e, t) => {
  const n = await tc(e, t);
  return new Promise((r, o) => {
    const s = [], i = n.openCursor();
    i.onerror = o, i.onsuccess = function(a) {
      const u = a.target.result;
      if (u) {
        const d = u.primaryKey, p = u.value;
        s.push({ key: d, data: p }), u.continue();
      } else
        r(s);
    };
  });
}, R5 = async (e, t, n) => {
  const r = await tc(e, n);
  return new Promise((o, s) => {
    const i = r.get(t);
    i.onerror = s, i.onsuccess = () => o(i.result);
  });
}, $v = async (e, t, n, r) => {
  const o = await tc(e, r);
  return new Promise((s, i) => {
    const a = o.put(n, t);
    a.onerror = i, a.onsuccess = () => s();
  });
}, N5 = async (e, t, n) => {
  const r = await tc(e, n);
  return new Promise((o, s) => {
    const i = r.delete(t);
    i.onerror = s, i.onsuccess = () => o();
  });
};
var Oi = /* @__PURE__ */ ((e) => (e.Existing = "existing", e.Templates = "templates", e))(Oi || {});
const j5 = (e) => {
  const { baseApiUrl: t } = ts();
  return `${t}/templates/${e}`;
}, D5 = (e, t) => ar.get(j5(e), {
  ...t
}), I5 = async (e) => {
  try {
    const t = await D5(e);
    return (t == null ? void 0 : t.result) ?? [];
  } catch (t) {
    return console.error(`Failed to load templates for type ${e}:`, t), [];
  }
}, Rv = async (e = Ve.web) => typeof window > "u" ? [] : (await $5(Ls.Projects)).map(({ key: r, data: o }) => {
  var s;
  return {
    id: `${r}`,
    name: `${((s = o.custom) == null ? void 0 : s.projectName) || r}`,
    data: o
  };
}).filter((r) => {
  var o;
  return ((o = r.data.custom) == null ? void 0 : o.projectType) === e;
});
class V5 {
  constructor(t) {
    this.store = t, this._projectSourceFilter = Oi.Existing, this._loadedProjects = void 0, this._loadedTemplates = void 0, this._projectTypeFilter = t.appEditorStore.projectType, Ut(this, {}, { autoBind: !0 });
  }
  get projectTypeFilter() {
    return this._projectTypeFilter;
  }
  get projectSourceFilter() {
    return this._projectSourceFilter;
  }
  get templates() {
    return this._loadedTemplates;
  }
  get projects() {
    return this._loadedProjects;
  }
  get filteredTemplates() {
    return this.projectSourceFilter === Oi.Existing ? this.projects : this.templates;
  }
  async loadProjects() {
    const t = await Rv(this.projectTypeFilter);
    this.setProjects(t);
  }
  async loadTemplates() {
    var o;
    const t = (o = this.store.appEditorStore.sdkOptions.templates) == null ? void 0 : o.onLoad, n = async () => await I5(this.projectTypeFilter);
    let r;
    if (t) {
      const s = this.store.appEditorStore.editor;
      r = await t({ editor: s, fetchCommunityTemplates: n });
    } else
      r = await n();
    this.setTemplates(r);
  }
  async loadAllTemplates() {
    await Promise.all([this.loadProjects(), this.loadTemplates()]);
  }
  async removeProject(t) {
    N5(Ls.Projects, t);
  }
  async setProjectTypeFilter(t) {
    this._projectTypeFilter = t, this.setProjects(void 0), this.setTemplates(void 0);
  }
  setProjectSourceFilter(t) {
    this._projectSourceFilter = t;
  }
  setTemplates(t) {
    this._loadedTemplates = t;
  }
  setProjects(t) {
    this._loadedProjects = t;
  }
}
const Nv = () => It().templatesStore;
class H5 {
  constructor(t) {
    this.toasts = [], this.store = t, Ut(this, {}, { autoBind: !0 });
  }
  add(t, n) {
    this.toasts.find((r) => r.id === t) || this.toasts.push({
      id: t,
      ...n
    });
  }
  addError(t, n) {
    this.add(t, {
      ...Mt(n) ? { header: n } : n,
      variant: Ht.Error
    });
  }
  addWarning(t, n) {
    this.add(t, {
      ...Mt(n) ? { header: n } : n,
      variant: Ht.Warning
    });
  }
  addSuccess(t, n) {
    this.add(t, {
      ...Mt(n) ? { header: n } : n,
      variant: Ht.Success
    });
  }
  addInfo(t, n) {
    this.add(t, {
      ...Mt(n) ? { header: n } : n,
      variant: Ht.Info
    });
  }
  remove(t) {
    this.toasts = this.toasts.filter((n) => n.id !== t);
  }
}
const jv = () => It().toastStore;
class B5 {
  constructor(t) {
    this.isOpen = !1, this.store = t, Ut(this, {}, { autoBind: !0 });
  }
  setOpen(t) {
    this.isOpen = t, this.triggerEvent();
  }
  toggleOpen() {
    this.isOpen = !this.isOpen, this.triggerEvent();
  }
  triggerEvent() {
    var t;
    (t = this.store.appEditorStore.editor) == null || t.trigger(_r.toggleBlocksPanel, { isOpen: this.isOpen });
  }
}
const Dv = () => It().blockManagerStore;
function z5(e) {
  const t = /* @__PURE__ */ new Map(), n = { items: [] };
  return e.forEach((o) => {
    const { category: s, item: i } = o;
    if (s) {
      const a = t.get(s.id);
      a ? (a.items.push(i), a.category = {
        ...a.category,
        ...s
      }) : t.set(s.id, { category: s, items: [i] });
    } else
      n.items.push(i);
  }), [...Array.from(t).map(([, o]) => o), n].filter((o) => o.items.length);
}
const Iv = (e) => e.get("groups") || [], Vv = (e, t) => Iv(e).includes(t), F5 = (e, t) => {
  Vv(e, t) || e.set("groups", [...Iv(e), t]);
};
class U5 {
  constructor(t) {
    this.dataSourceKeyid = "globalStyles", this.records = [], this.openCategories = /* @__PURE__ */ new Map(), this.store = t, Ut(
      this,
      {
        // will be used only on the initial render of GlobalStyleManager
        openCategories: !1
      },
      { autoBind: !0 }
    );
  }
  get sdkOptionStyles() {
    var t;
    return ((t = this.store.appEditorStore.sdkOptions.globalStyles) == null ? void 0 : t.default) || [];
  }
  get editor() {
    return this.store.appEditorStore.editor;
  }
  get DataSources() {
    var t;
    return (t = this.editor) == null ? void 0 : t.DataSources;
  }
  get recordsByCategory() {
    const { records: t, sdkOptionStyles: n } = this, r = [], o = t.reduce((s, i) => (s.set(i.get("id"), i), s), /* @__PURE__ */ new Map());
    return n.forEach(({ id: s }) => {
      const i = o.get(s);
      i && (r.push(i), o.delete(s));
    }), Array.from(o).map(([, s]) => {
      s.get("_internal") || r.push(s);
    }), z5(r.map((s) => ({ category: s.get("category"), item: s })));
  }
  setCategoryOpen(t, n) {
    this.openCategories.set(t, n);
  }
  getDataSource() {
    var t;
    return (t = this.DataSources) == null ? void 0 : t.get(this.dataSourceKeyid);
  }
  getRuleByGroup(t) {
    var n;
    return (n = this.editor) == null ? void 0 : n.CssComposer.getAll().find((r) => Vv(r, t));
  }
  addStyleRule(t) {
    var u;
    const n = t.get("id"), r = t.get("selector"), o = t.get("property"), s = t.getPath("value"), i = `globalStyles:${n}`, a = {
      [o]: {
        type: "data-variable",
        path: s,
        defaultValue: t.get("defaultValue")
      }
    }, l = this.getRuleByGroup(i);
    if (l)
      l.addStyle(a);
    else {
      const d = (u = this.editor) == null ? void 0 : u.CssComposer.addCollection(
        [
          {
            selectors: [],
            selectorsAdd: r,
            style: a
          }
        ],
        {
          extend: !0,
          at: t.index
        }
      )[0];
      d && F5(d, i);
    }
  }
  createDataSource() {
    return this.DataSources.add({
      id: this.dataSourceKeyid,
      records: []
    });
  }
  onLoad() {
    var r;
    const { sdkOptionStyles: t } = this;
    if (!t.length) {
      this.records = [];
      return;
    }
    let n = this.getDataSource();
    n || (n = this.createDataSource()), t.forEach((o) => {
      const s = n.getRecord(o.id);
      if (s) {
        const i = {
          label: o.label,
          field: o.field,
          category: o.category
        };
        s.set({
          ...i,
          _undo: !0
        });
      } else
        n.addRecord({
          value: void 0,
          // make the first undo work if value is not provided
          ...o,
          _internal: !0,
          // setByGlobalStyleManager
          _undo: !0
          // Make globalStyle records undoable
        });
    }), n.getRecords().forEach((o) => {
      this.addStyleRule(o);
    }), n.listenTo(n.records, "add", (o) => {
      this.addStyleRule(o);
    }), (r = this.editor) == null || r.UndoManager.add(n.records), this.records = n.getRecords();
  }
}
const W5 = () => It().globalStylesStore, Hv = (e, t) => {
  let n;
  try {
    const r = lr() && e && localStorage.getItem(e);
    r && (n = JSON.parse(r));
  } catch (r) {
    console.error(r);
  }
  return {
    lastProjectId: "",
    ...t,
    ...n
  };
}, Ch = (e, t) => {
  const r = { ...Hv(e), ...t };
  try {
    lr() && e && localStorage.setItem(e, JSON.stringify(r));
  } catch (o) {
    console.error(o);
  }
  return r;
}, dd = "gs-utl-dark", G5 = () => lr() && window.matchMedia("(prefers-color-scheme: dark)").matches, Bv = (e) => e === "dark" || e === "auto" && G5(), Ph = (e, t) => {
  if (e && lr() && t.rootEl) {
    const { classList: n } = t.rootEl;
    let r = !1;
    if (Bv(e) ? (n.add(dd), r = !0) : n.remove(dd), t.updateAppShell) {
      const o = document.head.querySelector('meta[name="theme-color"]');
      o && (o.content = r ? "#18181b" : "#ffffff");
    }
  }
};
class K5 {
  constructor(t) {
    this.key = "", this.theme = qr.auto, this.lastProjectId = "", this.updateAppShell = !1, this.rootEl = void 0, t && Object.keys(t).forEach((n) => {
      const r = n, o = t[r];
      o !== void 0 && (this[r] = o);
    }), Ut(this, {}, { autoBind: !0 }), this.init();
  }
  init() {
    Ph(this.theme, this);
  }
  changeTheme(t) {
    Ph(t, this), Ch(this.key, { theme: t });
  }
  setTheme(t) {
    this.theme = t;
  }
  setRootEl(t) {
    this.rootEl = t;
  }
  setLocalState(t) {
    Object.keys(t).forEach((n) => {
      const r = n, o = t[r];
      o !== void 0 && (this[r] = o);
    }), Ch(this.key, t);
  }
  get isDarkTheme() {
    return Bv(this.theme);
  }
}
const q5 = (e) => {
  qm(
    () => e.theme,
    (t) => {
      e.changeTheme(t);
    }
  );
}, cn = () => It().localSettingsStore;
class Y5 {
  constructor(t) {
    this.isOpen = !1, this.title = "", this.content = "", this.size = "l", this.fullH = !1, this.modalProps = {}, this.buttons = [], this.store = t, Ut(this, {}, { autoBind: !0 });
  }
  setModalProps(t) {
    this.modalProps = {
      title: "",
      size: "l",
      fullH: !1,
      buttons: [],
      ...t
    };
  }
  open({ content: t, ...n }) {
    this.isOpen = !0, this.content = t, this.setModalProps(n);
  }
  close() {
    this.isOpen = !1, setTimeout(this.clear, 101);
  }
  clear() {
    this.content = "", this.setModalProps({
      size: this.modalProps.size
    });
  }
  confirm({ content: t, size: n = "m", onConfirm: r, confirmButton: o, ...s }) {
    this.isOpen = !0, this.content = t;
    const i = () => {
      r == null || r(), this.close();
    };
    this.setModalProps({
      ...s,
      size: n,
      buttons: [
        { children: "Cancel", onClick: this.close, size: "m2" },
        { children: "Confirm", onClick: i, size: "m2", variant: "pr", ...o }
      ]
    });
  }
}
const Bn = () => It().modalStore, X5 = {
  add: "Add",
  delete: "Delete",
  duplicate: "Duplicate",
  rename: "Rename",
  remove: "Remove",
  clear: "Clear",
  select: "Select",
  selectList: "Select from the list",
  search: "Search",
  update: "Update",
  updated: "Updated!",
  confirm: "Confirm",
  cancel: "Cancel",
  enable: "Enable",
  disable: "Disable",
  upload: "Upload",
  close: "Close",
  load: "Load",
  copy: "Copy",
  save: "Save",
  current: "Current",
  toggleCss: "Toggle CSS",
  selectTarget: "Target Component",
  noCode: "No code available",
  noItems: "No items found",
  confirmAction: "Do you confirm this action?",
  eyeDropper: "Eyedropper",
  noEyeDropper: "Eyedropper not supported",
  unauthorized: "Unauthorized project",
  notItemsFound: "No items found",
  actions: {
    componentOutline: { title: "Component outline" },
    preview: { title: "Preview" },
    fullscreen: { title: "Fullscreen" },
    showCode: {
      title: "Code",
      exportButton: "Export to ZIP"
    },
    undo: { title: "Undo" },
    redo: { title: "Redo" },
    save: { title: "Save project" },
    store: { title: "Save content" },
    open: { title: "Open project" },
    importCode: {
      title: "Import code",
      parseError: "Parser error",
      content: "Paste here your HTML/CSS and click Import",
      button: "Import"
    },
    clearCanvas: {
      title: "Clear page",
      content: "Are you sure you want to clear the page?"
    },
    about: {
      title: "About"
    },
    embed: {
      title: "Embed Studio"
    },
    newProject: {
      title: "Load project"
    },
    installApp: {
      title: "Install App",
      installed: "App installed"
    }
  },
  modals: {
    styleCatalog: {
      title: "Style Catalog",
      noStyles: "No styles found"
    },
    openProject: {
      title: "Open project"
    }
  },
  pluginManager: {
    plugins: "Plugins",
    all: "Available",
    installed: "Installed",
    install: "Install",
    uninstall: "Uninstall",
    allPlugins: "All plugins",
    updateStudio: "Restart Studio for plugin updates"
  },
  globalStyleManager: {
    notFound: "No global styles found"
  },
  pageManager: {
    pages: "Pages",
    page: "Page",
    newPage: "New Page",
    add: "Add page",
    rename: "Rename",
    duplicate: "Duplicate",
    copy: "Copy",
    delete: "Delete",
    deletePage: "Delete Page",
    confirmDelete: "Are you sure you want to delete the page?",
    settings: {
      label: "Settings",
      title: "Page settings",
      global: "Global settings",
      fields: {
        name: {
          label: "Name"
        },
        slug: {
          label: "Slug",
          description: "The slug is the URL-friendly version of the name. It is usually all lowercase and contains only letters, numbers, and hyphens."
        },
        favicon: {
          label: "Favicon",
          description: "The favicon is the small icon that appears in the browser tab."
        },
        title: {
          label: "Title",
          description: "The title is the name of the page that appears in the browser tab."
        },
        description: {
          label: "Description",
          description: "The description is a short summary of the page content."
        },
        keywords: {
          label: "Keywords",
          description: "Keywords are words or phrases that describe the content of the page."
        },
        socialTitle: {
          label: "Social title",
          description: "The title is the name of the page that appears on social networks."
        },
        socialImage: {
          label: "Social image",
          description: "The image is the picture that appears on social networks."
        },
        socialDescription: {
          label: "Social description",
          description: "The description is a short summary of the page content that appears on social networks."
        },
        customCodeHead: {
          label: "Custom HTML head",
          description: "Add any custom HTML (e.g., meta tags, stylesheets, scripts) to be included in the <head> section of the page."
        },
        customCodeBody: {
          label: "Custom HTML body",
          description: "Add any custom HTML (e.g., scripts, tracking codes) to be included just before the closing </body> tag."
        }
      }
    }
  },
  projectManager: {
    existentProjects: "Your projects",
    templates: "Templates",
    notAvailable: "No projects available",
    projectType: "Project type",
    projectName: "Project name",
    pages: "Pages"
  },
  templates: {
    notFound: "No templates found"
  },
  storageManager: {
    errorLoad: "Failed to load the project",
    errorStore: "Failed to save the project"
  },
  assetManager: {
    addUrl: "Add URL",
    projectAssets: "Assets in this project",
    userAssets: "Assets from all projects",
    errorLoad: "Failed to load assets",
    errorUpload: "Failed to upload",
    errorDelete: "Failed to delete",
    deleteConfirmQuestion: "Delete asset?",
    deleteConfirmExplanation: "This will affect existing and published projects that rely on this asset, if any exist.",
    assetTypes: {
      all: "All",
      image: "Images"
    },
    noProvider: "Project assets"
  },
  blockManager: {
    notFound: "No blocks found",
    blocks: "Blocks",
    add: "Add more blocks",
    search: "Search...",
    labels: {
      section: "Section",
      column1: "1 Column",
      column2: "2 Columns",
      column3: "3 Columns",
      "column3-7": "2 Columns 3/7",
      gridRow: "Grid",
      heading: "Heading",
      divider: "Divider",
      imageBox: "Image Box",
      linkBox: "Link Box"
    },
    categories: {
      // 'category-id': 'Category Label',
    },
    types: {
      regular: "Regular",
      symbols: "Symbols"
    },
    symbols: {
      notFound: "No symbols found",
      instancesProject: "Instance/s in the project",
      delete: "Delete symbol",
      deleteConfirm: "Are you sure you want to delete the symbol? All instances inside the project will be detached."
    }
  },
  domComponents: {
    names: {
      section: "Section",
      gridRow: "Row",
      gridColumn: "Column",
      heading: "Heading",
      divider: "Divider",
      imageBox: "Image Box",
      linkBox: "Link Box"
    }
  },
  traitManager: {
    empty: "Select a component to see its properties",
    panelLabel: "Properties",
    traits: {
      labels: {
        loading: "Lazy load",
        target: "Open in new tab",
        showList: "Show element list",
        customAttributes: "Custom Attributes"
      },
      attributes: {
        // href: { placeholder: 'eg. https://google.com' },
      }
    }
  },
  deviceManager: {
    allDevices: "All devices"
  },
  selectorManager: {
    noSelecton: "You don't have any selected element.",
    selectFromCanvas: "Select an element from the canvas.",
    selectFromList: "Pick any style from the Style Catalog.",
    selectCustom: "Add your custom style selector.",
    selection: "Selection",
    selector: "Selector",
    addNewSelector: "Add new selector",
    removeSelector: "Remove selector",
    target: "Target",
    device: "Device",
    state: "State",
    deleteStyle: "Delete style",
    showCSS: "Show CSS code",
    searchStyle: "Search style",
    applyOnSelector: "Apply style changes on Selectors",
    noSelectors: "No Selectors applied",
    applyOnComponents: "Apply style changes on Components",
    noComponents: "No Components selected",
    currentSelection: "The current selection from which styles are displayed of"
    // label: 'Classes',
    // selected: 'Selected',
    // emptyState: '- State -',
    // states: {
    //   hover: 'Hover',
    //   active: 'Click',
    //   'nth-of-type(2n)': 'Even/Odd',
    // },
  },
  layerManager: {
    layers: "Layers"
  },
  styleManager: {
    panelLabel: "Styles",
    layout: {
      flexChild: "Flex child",
      display: {
        tips: {
          block: "Block generates a block element box, generating line breaks both before and after the element when in the normal flow.",
          inline: "Inline generates one or more inline element boxes that do not generate line breaks. The inline is generally default for text content.",
          "inline-block": "Inline-block is similar to inline but allows to define width and height properties.",
          flex: "Flex behaves like a block element and lays out its child elements on a vertical/horizontal axis",
          none: "The element is hidden from the layout"
        }
      },
      direction: {
        title: {
          row: "Horizontal",
          "row-reverse": "Horizontal reversed",
          column: "Vertical",
          "column-reverse": "Vertical reversed"
        }
      }
    },
    position: {
      tips: {
        static: "Default position",
        relative: "Similar to Static but with the ability to be moved relative to itself",
        absolute: "Absolute position, relative to its closest non-static parent",
        fixed: "Fixed position (even when the page is scrolled), relative to the browser viewport",
        sticky: "Elements are keept in place but moved when the page is scrolled, based on indicated distance"
      },
      presets: {
        title: "Presets",
        options: {
          topLeft: "Top left",
          topRight: "Top right",
          bottomLeft: "Bottom left",
          bottomRight: "Bottom right",
          left: "Left",
          right: "Right",
          bottom: "Bottom",
          top: "Top",
          full: "Full"
        }
      }
    },
    properties: {
      "margin-top": "Top",
      "margin-right": "Right",
      "margin-bottom": "Bottom",
      "margin-left": "Left",
      "padding-top": "Top",
      "padding-right": "Right",
      "padding-bottom": "Bottom",
      "padding-left": "Left",
      "border-top-left-radius": "Top Left",
      "border-top-right-radius": "Top Right",
      "border-bottom-right-radius": "Bottom Right",
      "border-bottom-left-radius": "Bottom Left",
      "mix-blend-mode": "Blend mode",
      "transform-style": "Type",
      "backface-visibility": "Backface",
      "perspective-origin": "Perspective origin",
      "perspective-origin-x": "Left",
      "perspective-origin-y": "Top",
      "transform-origin-x": "Left",
      "transform-origin-y": "Top",
      "align-items": "Align",
      "align-self": "Align",
      "justify-content": "Justify",
      "row-gap": "Row",
      "column-gap": "Column",
      // Typography
      "font-family": "Font",
      "font-size": "Size",
      "font-weight": "Weight",
      "letter-spacing": "Spacing",
      "text-align": "Align",
      "text-decoration": "Decoration",
      "text-transform": "Transform",
      "white-space": "Breaking",
      // Borders
      "border-top-width": "Top",
      "border-right-width": "Right",
      "border-bottom-width": "Bottom",
      "border-left-width": "Left",
      "border-top-style": "Top",
      "border-right-style": "Right",
      "border-bottom-style": "Bottom",
      "border-left-style": "Left",
      "border-top-color": "Top",
      "border-right-color": "Right",
      "border-bottom-color": "Bottom",
      "border-left-color": "Left",
      // Bg
      "background-position": "Position",
      "background-position-x": "Left",
      "background-position-y": "Top",
      "background-size": "Size",
      "background-size-x": "Left",
      "background-size-y": "Top",
      "background-repeat": "Repeat",
      "background-attachment": "Attachment",
      "background-origin": "Origin",
      "background-clip": "Clip",
      // Effects
      "overflow-x": "X",
      "overflow-y": "Y"
    },
    options: {
      "__background-type": {
        image: "Image",
        gradient: "Gradient",
        color: "Color"
      },
      display: {
        block: "Block",
        inline: "Inline",
        "inline-block": "Inline block",
        flex: "Flex",
        none: "None"
      },
      overflow: {
        visible: "Visible",
        hidden: "Hidden",
        scroll: "Scroll",
        auto: "Auto"
      },
      "flex-wrap": {
        nowrap: "No wrap",
        wrap: "Wrap",
        "wrap-reverse": "Reverse wrap"
      }
    }
  }
}, Eh = "column1", Oh = "column2", _h = "column3", pd = "column3-7", Z5 = function(e, t = {}) {
  const { Components: n, Blocks: r } = e, o = "gridRow", s = "gridColumn", i = "gjs-grid-row", a = "gjs-grid-column", l = { tl: 0, tc: 0, tr: 0, cl: 0, bl: 0, br: 0 }, u = "flex-basis", d = 1, p = 1, f = 1;
  n.addType(o, {
    isComponent: (v) => Zr(v, i),
    model: {
      defaults: {
        emptyState: !0,
        droppable: br(s),
        highlightable: !1,
        attributes: { class: i },
        resizable: { ...l, keyHeight: "min-height" },
        icon: `
            <svg viewBox="0 0 24 24">
              <path d="M22 14c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v4M4 14h4v-4H4v4m6 0h4v-4h-4v4m6 0h4v-4h-4v4z"></path>
            </svg>
          `,
        "stylable-require": ["flex-align-items", "flex-align-items-v", "flex-direction-id", "flex-multiline"],
        traits: [
          "id",
          "title",
          {
            name: "add-column",
            labelButton: "Add column",
            type: "button",
            full: !0,
            command: (v) => {
              v.getSelected().components().add({ type: s });
            }
          }
        ],
        styles: `
            .${i} {
              display: flex;
              justify-content: flex-start;
              align-items: stretch;
              flex-direction: row;
              min-height: auto;
              padding: 10px 0;
            }
            @media (max-width: 992px) {
              .${i} {
                flex-direction: column;
              }
            }
          `
      }
    }
  }), n.addType(s, {
    isComponent: (v) => Zr(v, a),
    model: {
      defaults: {
        emptyState: !0,
        attributes: { class: a },
        draggable: br(o),
        resizable: { ...l, bc: 0, keyWidth: u, currentUnit: f, minDim: d, step: p },
        icon: `
            <svg viewBox="0 0 24 24">
              <path d="M8 2h8c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2m0 8v4h8v-4H8m0 6v4h8v-4H8M8 4v4h8V4H8z"></path>
            </svg>
          `,
        unstylable: ["width"],
        "stylable-require": ["flex-basis", "flex-item-behaviour", "flex-item-h-align", "flex-order"],
        traits: [
          {
            label: "Center content",
            name: "center-content",
            type: "checkbox",
            changeProp: !0
          }
        ],
        styles: `
            .${a} {
              flex: 1 1 0%;
              padding: 5px 0;
            }
          `
      },
      init() {
        this.listenTo(this, "change:center-content", this.handleCenter);
      },
      handleCenter() {
        const v = this.get("center-content");
        this.addStyle({
          display: v ? "flex" : "block",
          "align-items": v ? "center" : "",
          "justify-content": v ? "center" : ""
        });
      }
    }
  });
  const h = {
    label: o,
    content: {
      type: o,
      components: [{ type: s }, { type: s }, { type: s }]
    },
    ...t.block
  }, g = { merge: !0 }, m = (v) => r.get(v).category || h.category;
  r.add(
    Eh,
    {
      ...h,
      category: m(Eh),
      content: {
        type: o,
        components: [{ type: s }]
      }
    },
    g
  ), r.add(
    Oh,
    {
      ...h,
      category: m(Oh),
      content: {
        type: o,
        components: [{ type: s }, { type: s }]
      }
    },
    g
  ), r.add(
    _h,
    {
      ...h,
      category: m(_h),
      content: {
        type: o,
        components: [{ type: s }, { type: s }, { type: s }]
      }
    },
    g
  ), r.add(
    pd,
    {
      ...h,
      category: m(pd),
      content: {
        type: o,
        components: [{ type: s, style: { "flex-basis": "30%", "flex-grow": 0 } }, { type: s }]
      }
    },
    g
  );
}, Qs = "section", Jc = "container", Qc = "gjs-section", eu = "gjs-container", J5 = function(e, t = {}) {
  const { Components: n, Blocks: r } = e;
  r.add(
    Qs,
    {
      label: Qs,
      media: `
        <svg viewBox="0 0 24 24">
          <path fill="currentColor" d="M21 18H2V20H21V18M19 10V14H4V10H19M20 8H3C2.45 8 2 8.45 2 9V15C2 15.55 2.45 16 3 16H20C20.55 16 21 15.55 21 15V9C21 8.45 20.55 8 20 8M21 4H2V6H21V4Z" />
        </svg>
      `,
      content: { type: Qs },
      ...t.block
    },
    { at: Qi(e, pd) + 1 }
  ), n.addType(Qs, {
    isComponent: (o) => Zr(o, Qc),
    model: {
      defaults: {
        tagName: "section",
        emptyState: !0,
        draggable: br("wrapper"),
        droppable: br(Jc),
        attributes: { class: Qc },
        components: { type: Jc },
        styles: `
            .${Qc} {
              display: flex;
              padding: 50px 0;
            }
          `
      }
    }
  }), n.addType(Jc, {
    isComponent: (o) => Zr(o, eu),
    model: {
      defaults: {
        emptyState: !0,
        copyable: !1,
        removable: !1,
        draggable: !1,
        attributes: { class: eu },
        styles: `
            .${eu} {
              width: 90%;
              margin: 0 auto;
              max-width: 1200px;
            }
          `
      }
    }
  });
}, Q5 = function(e, t = {}) {
  const { Components: n, Blocks: r } = e, o = "divider", s = "gjs-divider";
  r.add(
    o,
    {
      label: o,
      media: `
        <svg viewBox="0 0 24 24">
          <path d="M8,18H11V15H2V13H22V15H13V18H16L12,22L8,18M12,2L8,6H11V9H2V11H22V9H13V6H16L12,2Z" />
        </svg>
      `,
      content: { type: o },
      ...t.block
    },
    { at: Qi(e, Qs) + 1 }
  ), n.addType(o, {
    isComponent: (i) => Zr(i, s),
    model: {
      defaults: {
        droppable: !1,
        highlightable: !1,
        attributes: { class: s },
        stylable: [
          "height",
          "width",
          "background-color",
          "margin",
          "margin-top",
          "margin-right",
          "margin-bottom",
          "margin-left"
        ],
        styles: `
            .${s} {
              height: 3px;
              width: 100%;
              margin: 10px;
              background-color: rgba(0, 0, 0, 0.05);
            }
          `
      }
    }
  });
}, Th = "page://", eT = function(e) {
  const { Components: t, Blocks: n } = e, o = t.getType("wrapper").model.getDefaults(), s = t.getType("head").model;
  t.addType("wrapper", {
    model: {
      defaults: {
        emptyState: { styleIn: "height: 100vh", styleOut: "padding: 0;" },
        stylable: [
          ...o.stylable,
          "padding",
          "font-family",
          "color",
          "font-size",
          "font-weight",
          "line-height",
          "letter-spacing",
          "text-align",
          "vertical-align",
          "text-decoration",
          "text-transform",
          "direction",
          "white-space"
        ]
      }
    }
  }), t.addType("head", {
    model: {
      components(u, d) {
        return s.prototype.components.call(this, u, {
          ...d,
          skipDomReset: !0
        });
      }
    },
    view: {
      updateContent() {
      }
    }
  }), t.addType("text", {
    model: {
      defaults: {
        highlightable: !1,
        emptyState: { styleIn: "min-height: auto; font-size: inherit;" }
      }
    }
  }), t.addType("image", {
    model: {
      defaults: {
        traits: [
          {
            type: "image",
            name: "src",
            label: "Image",
            typeProps: { inputField: !0 }
          },
          "alt",
          {
            type: "checkbox",
            name: "loading",
            valueTrue: "lazy"
          }
        ]
      }
    }
  });
  const a = t.getType("link").model;
  t.addType("link", {
    model: {
      defaults: {
        emptyState: !0,
        traits: [
          "title",
          {
            type: "checkbox",
            name: "target",
            valueTrue: "_blank"
          },
          {
            type: "href",
            name: "href"
          }
        ]
      },
      getAttrToHTML() {
        const u = a.prototype.getAttrToHTML.apply(this), { href: d } = u;
        if (d && d.indexOf(Th) === 0) {
          const p = d.replace(Th, ""), f = e.Pages.get(p);
          u.href = f ? `./${ld(e, f)}` : "##";
        }
        return u;
      }
    }
  }), n.add(
    "link",
    {
      label: "Link",
      content: {
        type: "link",
        content: "Link",
        style: { color: "#d983a6", padding: "10px" }
      }
    },
    { merge: !0 }
  ), t.addType("select", {
    model: {
      defaults: {
        traits: [
          { name: "name" },
          {
            type: "checkbox",
            name: "required"
          },
          {
            name: "options",
            type: "stack",
            getValue({ component: u }) {
              return u.components().map((d) => ({
                id: d.getAttributes().value || "",
                label: d.getInnerHTML()
              }));
            },
            setValue: ({ component: u, value: d, emitUpdate: p }) => {
              u.components(
                d.map((f) => ({
                  type: "option",
                  content: f.label,
                  attributes: { value: f.id }
                }))
              ), p();
            },
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            properties: [{ name: "id" }, { name: "label" }]
          }
        ]
      }
    }
  });
  const l = "contentEditable";
  t.addType(l, {
    extend: "text",
    model: {
      defaults: {
        name: "Content",
        tagName: "span",
        hoverable: !1,
        selectable: !1
      },
      toHTML(u) {
        return this.getInnerHTML(u);
      }
    }
  }), t.addType("button", {
    model: {
      defaults: {
        components: [
          {
            type: l,
            components: { type: "textnode", content: "Button" }
          }
        ],
        traits: [
          {
            type: "select",
            name: "type",
            options: [
              { id: "button", label: "Button" },
              { id: "submit", label: "Submit" },
              { id: "reset", label: "Reset" }
            ]
          }
        ]
      },
      init() {
        var d;
        const u = [...this.components().models];
        (u.length > 1 || !((d = u[0]) != null && d.is(l))) && this.append({ type: l })[0].append(u);
      }
    }
  });
}, tT = function(e, t = {}) {
  const { Components: n, Blocks: r } = e, o = "heading";
  r.add(
    o,
    {
      label: o,
      media: `
        <svg viewBox="0 0 24 24">
          <path d="M8.3 11.5h7.4V6.9l-.2-1.6a1 1 0 00-.5-.5c-.3-.2-.7-.3-1-.3h-.6v-.4h6.8v.4h-.6c-.4 0-.7.1-1 .3a1 1 0 00-.6.6L18 6.9v10.3c0 .8 0 1.3.2 1.6 0 .2.2.3.4.5.4.2.7.3 1.1.3h.6v.4h-6.8v-.4h.5c.7 0 1.2-.2 1.5-.6.2-.3.3-.9.3-1.8v-4.9H8.3v4.9l.1 1.6.5.5c.3.2.7.3 1 .3h.7v.4H3.7v-.4h.6c.7 0 1.1-.2 1.4-.6.2-.3.3-.9.3-1.8V6.9L6 5.3a1 1 0 00-.5-.5l-1-.3h-.7v-.4h6.9v.4H10c-.4 0-.8.1-1 .3a1 1 0 00-.6.6l-.1 1.5v4.6z"></path>
        </svg>
      `,
      content: { type: o, components: "Insert your text here" },
      ...t.block
    },
    { at: Qi(e, "text") }
  ), n.addType(o, {
    extend: "text",
    isComponent: (s) => m5(s, "H1", "H2", "H3", "H4", "H5", "H6"),
    model: {
      defaults: {
        emptyState: !0,
        tagName: "h1",
        traits: [
          {
            type: "select",
            options: [
              { value: "h1", name: "One (largest)" },
              { value: "h2", name: "Two" },
              { value: "h3", name: "Three" },
              { value: "h4", name: "Four" },
              { value: "h5", name: "Five" },
              { value: "h6", name: "Six (smallest)" }
            ],
            label: "Size",
            name: "tagName",
            changeProp: !0
          }
        ]
      }
    }
  });
}, nT = function(e, t = {}) {
  const { Components: n, Blocks: r } = e, o = e.Components.getType("default").model, s = "imageBox", i = "gjs-image-box";
  r.add(
    s,
    {
      label: s,
      media: `
        <svg viewBox="0 0 24 24">
          <path d="M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M13.96,12.29L11.21,15.83L9.25,13.47L6.5,17H17.5L13.96,12.29Z" />
        </svg>
      `,
      content: { type: s },
      ...t.block
    },
    { at: Qi(e, "image") + 1 }
  ), n.addType(s, {
    extend: "image",
    isComponent: (a) => Zr(a, i),
    model: {
      defaults: {
        tagName: "div",
        void: !1,
        droppable: !0,
        emptyState: !1,
        resizable: { tl: 0, tc: 0, tr: 0, cl: 0, cr: 0, bl: 0, br: 0 },
        traits: ["title"],
        attributes: { class: i },
        styles: `
            .${i} {
              height: 200px;
              width: 100%;
            }
          `
      },
      getAttrToHTML(...a) {
        return o.prototype.getAttrToHTML.apply(this, a);
      }
    },
    view: {
      // @ts-ignore TODO ts
      tagName: "div",
      updateSrc() {
        const { model: a, em: l } = this, u = a.getSrcResult(), d = a.isDefaultSrc(), p = a.getStyle(), f = `url('${u}')`;
        u && a.addStyle({
          "background-image": d && p["background-image"] || f,
          "background-size": p["background-size"] || "contain",
          "background-position": p["background-position"] || "center center",
          "background-attachment": p["background-attachment"] || "scroll",
          "background-repeat": p["background-repeat"] || "no-repeat"
        }), u && l.trigger("component:toggled"), this.$el[u ? "removeClass" : "addClass"](this.classEmpty);
      },
      onRender() {
        this.renderChildren(), this.updateSrc();
      }
    }
  });
}, rT = function(e, t = {}) {
  const { Components: n, Blocks: r } = e, o = "linkBox", s = "gjs-link-box";
  r.add(
    o,
    {
      label: o,
      media: `
        <svg viewBox="0 0 24 24">
          <path d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M11,16H10C8.39,16 6,14.94 6,12C6,9.07 8.39,8 10,8H11V10H10C9.54,10 8,10.17 8,12C8,13.9 9.67,14 10,14H11V16M14,16H13V14H14C14.46,14 16,13.83 16,12C16,10.1 14.33,10 14,10H13V8H14C15.61,8 18,9.07 18,12C18,14.94 15.61,16 14,16M15,13H9V11H15V13Z" />
        </svg>
      `,
      content: { type: o },
      ...t.block
    },
    { at: Qi(e, "link") + 1 }
  ), n.addType(o, {
    isComponent: (i) => Zr(i, s),
    extend: "link",
    model: {
      defaults: {
        editable: !1,
        droppable: !0,
        attributes: { class: s },
        styles: `
            .${s} {
              color: inherit;
              display: inline-block;
              vertical-align: top;
              padding: 10px;
              max-width: 100%;
              text-decoration: none;
            }
          `
      }
    }
  });
}, Ah = (e) => {
  const t = (e || "").split(" ");
  let n = t[0], r = t[0], o = t[0], s = t[0];
  return t.length === 4 ? (n = t[0], r = t[1], o = t[2], s = t[3]) : t.length === 3 ? (n = t[0], r = t[1], s = t[1], o = t[2]) : t.length === 2 && (n = t[0], r = t[1], s = t[1], o = t[0]), [n, r, o, s];
};
function oT(e) {
  const t = {};
  if (e.padding) {
    const n = e.padding.split(" ");
    let r = n[0], o = n[0], s = n[0], i = n[0];
    n.length === 4 ? (r = n[0], o = n[1], s = n[2], i = n[3]) : n.length === 3 ? (r = n[0], o = n[1], i = n[1], s = n[2]) : n.length === 2 && (r = n[0], o = n[1], i = n[1], s = n[0]), t["padding-top"] = e["padding-top"] || r, t["padding-right"] = e["padding-right"] || o, t["padding-bottom"] = e["padding-bottom"] || s, t["padding-left"] = e["padding-left"] || i, delete e.padding;
  }
  return {
    ...e,
    ...t
  };
}
const sT = { ratioDefault: !0, tc: !1, cl: !1, cr: !1, bc: !1 }, Lh = `<svg viewBox="0 0 24 24">
  <path d="M16 9h3l-5 7m-4-7h4l-2 8M5 9h3l2 7m5-12h2l2 3h-3m-5-3h2l1 3h-4M7 4h2L8 7H5m1-5L2 8l10 14L22 8l-4-6H6z"></path>
</svg>`, iT = function(e, t = {}) {
  const { Components: n, Blocks: r } = e, o = "icon", s = "gjs-icon", i = "data-type-icon";
  r.add(
    o,
    {
      label: "Icon",
      media: Lh,
      content: { type: o },
      ...t.block
    }
    //{ at: getBlockIndex(editor, 'link') + 1 }
  ), n.addType(o, {
    isComponent: (a) => Zr(a, s) || Pv(a, i),
    model: {
      defaults: {
        droppable: !1,
        attributes: { class: s, [i]: !0 },
        resizable: sT,
        components: Lh,
        traits: [
          "id",
          "title",
          {
            type: "code",
            label: "Content",
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            typeProps: {
              language: "html",
              clean: !0,
              padding: 5
            },
            getValue({ component: a }) {
              return a.getInnerHTML();
            },
            setValue: As(({ editor: a, component: l, value: u }) => {
              const d = a.Parser.parseHtml(u).html, p = Array.isArray(d) ? d[0] : d;
              p && p.tagName === "svg" && l.components(p);
            }, 500)
          }
        ],
        styles: `
            .${s} {
              display: inline-block;
              text-decoration: none;
              color: inherit;
              vertical-align: middle;
              fill: currentColor;
              width: 50px;
              height: 50px;
            }
          `
      },
      init() {
        this.listenTo(this.components(), "change add", this.disableLayers), this.disableLayers();
      },
      disableLayers() {
        this.components().forEach((a) => a.set("layerable", !1));
      }
    },
    view: {
      init() {
        const { model: a } = this;
        this.listenTo(a.components(), "change", this.disableChildren);
      },
      onRender() {
        this.disableChildren();
      },
      disableChildren() {
        this.model.components().forEach((a) => {
          var u;
          const l = (u = a.view) == null ? void 0 : u.el;
          l && (l.style.pointerEvents = "none");
        });
      }
    }
  });
}, tu = "__nc", aT = (e) => {
  const t = e.getAttributes({ noClass: !0, noStyle: !0 });
  return e.traits.forEach((n) => {
    const r = n.getName();
    n.get("changeProp") || delete t[r];
  }), delete t.id, delete t.__p, t;
};
function lT(e) {
  const { Components: t } = e, n = (r) => {
    const { model: o, id: s } = r, i = o.getDefaults();
    t.addType(s, {
      model: {
        defaults: {
          traits: [
            ...i.traits,
            {
              name: "customAttributes",
              type: "stack",
              getValue({ component: a }) {
                const l = aT(a);
                return Object.keys(l).map((d) => ({
                  id: d,
                  value: l[d]
                }));
              },
              setValue: ({ component: a, value: l, options: u, emitUpdate: d }) => {
                const p = u.removed, f = u.previous, h = u.item;
                if (p)
                  a.removeAttributes(p.id);
                else {
                  f && h && f.id !== h.id && a.removeAttributes(f.id);
                  const g = l.reduce((m, v) => (m[v.id] = v.value || "", m), {});
                  a.addAttributes(g);
                }
                d();
              },
              addItem: () => ({
                id: tu,
                value: !1
              }),
              labelItem: (a) => a.id === tu || !a.id && !a.value ? "- Empty -" : `${a.id || ""}="${a.value || ""}"`,
              properties: [
                {
                  name: "id",
                  label: "Name",
                  getValue: (a) => a === tu ? "" : a,
                  setValue: (a, l) => a.trim().toLowerCase().replace(/^[^a-z]{1}/gi, "_").replace(/\s+/g, "-") || l
                },
                {
                  name: "value",
                  label: "Value",
                  getValue: (a) => typeof a == "boolean" ? "" : a
                }
              ]
            }
          ]
        }
      }
    });
  };
  t.getTypes().forEach(n);
}
const cT = "Basic";
function uT(e, t) {
  const { appStore: n } = t;
  e.Css.getConfig().onBeforeStyle = oT;
  const r = e.Parser.getConfig().optionsHtml;
  r.htmlType = "text/html";
  const o = n.sdkOptions.pages || {};
  (Pr(o.allowDocuments) ? o.allowDocuments : !0) && (r.detectDocument = !0, r.allowScripts = !0), e.Components.addType("trait-check", {
    model: {
      defaults: {
        traits: [
          "id",
          "title",
          {
            type: "select",
            name: "select-type",
            options: [
              { id: "value1", label: "Value 1" },
              { id: "value2", label: "Value 2" },
              { id: "value3", label: "Value 3" }
            ]
          },
          {
            type: "number",
            name: "number-type",
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore TODO ts
            units: ["px", "rem", "%"]
          },
          {
            type: "checkbox",
            name: "checkbox-type"
          },
          {
            type: "color",
            name: "color-type"
          },
          {
            type: "button",
            name: "button-type",
            label: "Delete",
            command: "core:component-delete"
          }
        ]
      }
    }
  });
  const i = { category: cT, select: !0, activate: !0 };
  y5(e, t), eT(e), Z5(e, { block: i }), tT(e, { block: i }), J5(e, { block: i }), Q5(e, { block: i }), nT(e, { block: i }), rT(e, { block: i }), iT(e, { block: i }), lT(e);
}
function dT(e) {
  const { code: t, appStore: n, showToastError: r } = e, { appEditorStore: o, toastStore: s, i18nStore: i } = n.store, { isProjectTypeEmail: a } = o, l = (t || "").trim(), u = new DOMParser(), d = { input: t, output: "", error: "" };
  let p = "";
  try {
    if (a) {
      const f = pT(l), g = u.parseFromString(`<div>${f}</div>`, "text/xml").querySelector("parsererror div");
      d.error = (g == null ? void 0 : g.textContent) || "", p = f;
    } else {
      const f = u.parseFromString(l, "text/html");
      zv(f.documentElement);
    }
  } catch (f) {
    d.error = f.message;
  }
  return d.error ? r && s.addError("error-parser", {
    header: i.t("actions.importCode.parseError"),
    content: d.error
  }) : d.output = p || l, d;
}
function zv(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE)
    return;
  const t = Array.from(e.attributes), n = Array.from(e.children);
  for (const r of t)
    e.setAttribute(r.name, r.value);
  for (const r of n)
    zv(r);
}
function pT(e) {
  return (e || "").replace(/(\s[\w:-]+=\s*)("[^"]*"|'[^']*')/g, (t, n, r) => {
    const o = r.slice(1, -1).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
    return `${n}"${o}"`;
  });
}
const fT = (e) => e.Assets.getAll().reduce((r, o) => {
  const s = o.getSrc(), i = s.match(/^data:([^;]+);/);
  if (i) {
    const a = s.split(",")[1], l = v5(o.get("name"));
    r[s] = {
      mime: i[1],
      name: l,
      base64: a
    };
  }
  return r;
}, {}), hT = (e) => e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), kh = (e, t, n = {}) => {
  let r = e;
  const o = n.pathPfx || "";
  for (const s in t)
    if (r.includes(s)) {
      const i = t[s];
      r = r.replace(new RegExp(hT(s), "g"), `${o}${i.name}`), i.found = !0;
    }
  return r;
}, gT = (e, t, n) => `${t || ""}${e || ""}${n || ""}`, mT = (e, t) => {
  const n = e ? `<div ${pl}>${e}</div>` : "", r = t ? `<div ${pl} data-gjs-global>${t}</div>` : "";
  return `${n}${r}`;
}, fl = async (e, t = {}) => {
  const { page: n, skipProject: r, assetsFolder: o = "assets", filenameCss: s = "style.css", styles: i, isMJML: a } = t, l = [], u = n ? [n] : e.Pages.getAll(), d = fT(e), p = `${o}/`, f = e.getCss({ keepUnusedStyles: !0, component: n == null ? void 0 : n.getMainComponent() }) || "", h = kh(f, d, { pathPfx: p }), g = i === "inline", m = i === "skip", v = Ss(e).globalPageSettings || {}, b = u.map((y) => {
    var Je, dn, ht;
    const w = y.getName(), S = jr(y, "title") || w, x = jr(y, "favicon"), C = jr(y, "description"), P = jr(y, "keywords"), _ = jr(y, "socialTitle"), O = jr(y, "socialDescription"), E = jr(y, "socialImage"), T = Cv(jr(y, "fonts")), R = Gt({ page: y, key: "customCodeHead" }) ?? "", B = gT(R, v.customCodeHead, T), U = Gt({ page: y, key: "customCodeBody" }) ?? "", L = mT(U, v.customCodeBody), M = y.getMainComponent(), D = e.getJs({ component: M }), V = D ? `<script>${D}<\/script>` : "", k = [], j = [], Y = M.toHTML({ asDocument: !1 }).replace("</body>", `${L}${V}</body>`), J = M.head;
    let le = S && `<title>${S}</title>`, Q = x && `<link rel="icon" href="${x}"/>`, re = C && `<meta name="description" content="${C}"/>`, ge = P && `<meta name="keywords" content="${P}"/>`, X = _ && `<meta property="og:title" content="${_}"/>`, Z = O && `<meta property="og:description" content="${O}"/>`, te = E && `<meta property="og:image" content="${E}"/>`, de = '<meta charset="utf-8">', ce = '<meta name="viewport" content="width=device-width,initial-scale=1">', Ce = '<meta name="robots" content="index,follow">', Pe = '<meta name="generator" content="GrapesJS Studio">';
    J.components().forEach((rt) => {
      const dt = rt.toHTML();
      et.title({ cmp: rt }) ? le = dt : et.favicon({ cmp: rt }) ? Q = dt : et.description({ cmp: rt }) ? re = dt : et.keywords({ cmp: rt }) ? ge = dt : et.socialTitle({ cmp: rt }) ? X = dt : et.socialDescription({ cmp: rt }) ? Z = dt : et.socialImage({ cmp: rt }) ? te = dt : et.charset({ cmp: rt }) ? de = dt : et.viewport({ cmp: rt }) ? ce = dt : et.robots({ cmp: rt }) ? Ce = dt : et.generator({ cmp: rt }) && (Pe = dt);
    }), le && k.push(le), de && k.push(de), ce && k.push(ce), Ce && k.push(Ce), Pe && k.push(Pe), re && k.push(re), ge && k.push(ge), X && k.push(X), Z && k.push(Z), te && k.push(te), Q && k.push(Q), j.length && k.push(...j), B && k.push(B), h && !m && k.push(g ? `<style>${h}</style>` : `<link rel="stylesheet" href="./${s}">`);
    const at = M.doctype || "<!DOCTYPE html>", ut = (dn = (Je = M.docEl).__attrToString) == null ? void 0 : dn.call(Je), Pt = (ht = J.__attrToString) == null ? void 0 : ht.call(J), gt = a ? e.runCommand("mjml-code-to-html").html : `${at}
<html${ut ? ` ${ut}` : ""}>
  <head${Pt ? ` ${Pt}` : ""}>
    ${k.join(`
  `)}
  </head>
  ${Y}
</html>
`;
    return {
      filename: ld(e, y),
      content: kh(gt, d, { pathPfx: p }),
      mimeType: "text/html"
    };
  });
  l.push(...b), a && u.forEach((y) => {
    l.push({
      filename: ld(e, y, "mjml"),
      content: y.getMainComponent().toHTML(),
      mimeType: "text/mjml"
    });
  });
  for (const y in d) {
    const w = d[y];
    w.found && l.push({
      path: o,
      filename: w.name,
      content: atob(w.base64),
      mimeType: w.mime
    });
  }
  return h && !g && !m && l.push({
    filename: s,
    content: h,
    mimeType: "text/css"
  }), r || l.push({
    filename: "gjs-project.grapesjs",
    content: JSON.stringify(e.getProjectData()),
    mimeType: "application/json"
  }), l;
};
function vT(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Mh(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $h(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mh(Object(n), !0).forEach(function(r) {
      vT(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mh(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function bT(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, s;
  for (s = 0; s < r.length; s++)
    o = r[s], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function yT(e, t) {
  if (e == null)
    return {};
  var n = bT(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (o = 0; o < s.length; o++)
      r = s[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function wT(e, t) {
  return ST(e) || xT(e, t) || CT(e, t) || PT();
}
function ST(e) {
  if (Array.isArray(e))
    return e;
}
function xT(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var n = [], r = !0, o = !1, s = void 0;
    try {
      for (var i = e[Symbol.iterator](), a; !(r = (a = i.next()).done) && (n.push(a.value), !(t && n.length === t)); r = !0)
        ;
    } catch (l) {
      o = !0, s = l;
    } finally {
      try {
        !r && i.return != null && i.return();
      } finally {
        if (o)
          throw s;
      }
    }
    return n;
  }
}
function CT(e, t) {
  if (e) {
    if (typeof e == "string")
      return Rh(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Rh(e, t);
  }
}
function Rh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function PT() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ET(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Nh(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function jh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Nh(Object(n), !0).forEach(function(r) {
      ET(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Nh(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function OT() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    return t.reduceRight(function(o, s) {
      return s(o);
    }, r);
  };
}
function ei(e) {
  return function t() {
    for (var n = this, r = arguments.length, o = new Array(r), s = 0; s < r; s++)
      o[s] = arguments[s];
    return o.length >= e.length ? e.apply(this, o) : function() {
      for (var i = arguments.length, a = new Array(i), l = 0; l < i; l++)
        a[l] = arguments[l];
      return t.apply(n, [].concat(o, a));
    };
  };
}
function hl(e) {
  return {}.toString.call(e).includes("Object");
}
function _T(e) {
  return !Object.keys(e).length;
}
function _i(e) {
  return typeof e == "function";
}
function TT(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function AT(e, t) {
  return hl(t) || Yr("changeType"), Object.keys(t).some(function(n) {
    return !TT(e, n);
  }) && Yr("changeField"), t;
}
function LT(e) {
  _i(e) || Yr("selectorType");
}
function kT(e) {
  _i(e) || hl(e) || Yr("handlerType"), hl(e) && Object.values(e).some(function(t) {
    return !_i(t);
  }) && Yr("handlersType");
}
function MT(e) {
  e || Yr("initialIsRequired"), hl(e) || Yr("initialType"), _T(e) && Yr("initialContent");
}
function $T(e, t) {
  throw new Error(e[t] || e.default);
}
var RT = {
  initialIsRequired: "initial state is required",
  initialType: "initial state should be an object",
  initialContent: "initial state shouldn't be an empty object",
  handlerType: "handler should be an object or a function",
  handlersType: "all handlers should be a functions",
  selectorType: "selector should be a function",
  changeType: "provided value of changes should be an object",
  changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state',
  default: "an unknown error accured in `state-local` package"
}, Yr = ei($T)(RT), ya = {
  changes: AT,
  selector: LT,
  handler: kT,
  initial: MT
};
function NT(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  ya.initial(e), ya.handler(t);
  var n = {
    current: e
  }, r = ei(IT)(n, t), o = ei(DT)(n), s = ei(ya.changes)(e), i = ei(jT)(n);
  function a() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(d) {
      return d;
    };
    return ya.selector(u), u(n.current);
  }
  function l(u) {
    OT(r, o, s, i)(u);
  }
  return [a, l];
}
function jT(e, t) {
  return _i(t) ? t(e.current) : t;
}
function DT(e, t) {
  return e.current = jh(jh({}, e.current), t), t;
}
function IT(e, t, n) {
  return _i(t) ? t(e.current) : Object.keys(n).forEach(function(r) {
    var o;
    return (o = t[r]) === null || o === void 0 ? void 0 : o.call(t, e.current[r]);
  }), n;
}
var VT = {
  create: NT
}, HT = {
  paths: {
    vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.43.0/min/vs"
  }
};
function BT(e) {
  return function t() {
    for (var n = this, r = arguments.length, o = new Array(r), s = 0; s < r; s++)
      o[s] = arguments[s];
    return o.length >= e.length ? e.apply(this, o) : function() {
      for (var i = arguments.length, a = new Array(i), l = 0; l < i; l++)
        a[l] = arguments[l];
      return t.apply(n, [].concat(o, a));
    };
  };
}
function zT(e) {
  return {}.toString.call(e).includes("Object");
}
function FT(e) {
  return e || Dh("configIsRequired"), zT(e) || Dh("configType"), e.urls ? (UT(), {
    paths: {
      vs: e.urls.monacoBase
    }
  }) : e;
}
function UT() {
  console.warn(Fv.deprecation);
}
function WT(e, t) {
  throw new Error(e[t] || e.default);
}
var Fv = {
  configIsRequired: "the configuration object is required",
  configType: "the configuration object should be an object",
  default: "an unknown error accured in `@monaco-editor/loader` package",
  deprecation: `Deprecation warning!
    You are using deprecated way of configuration.

    Instead of using
      monaco.config({ urls: { monacoBase: '...' } })
    use
      monaco.config({ paths: { vs: '...' } })

    For more please check the link https://github.com/suren-atoyan/monaco-loader#config
  `
}, Dh = BT(WT)(Fv), GT = {
  config: FT
}, KT = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return function(o) {
    return n.reduceRight(function(s, i) {
      return i(s);
    }, o);
  };
};
function Uv(e, t) {
  return Object.keys(t).forEach(function(n) {
    t[n] instanceof Object && e[n] && Object.assign(t[n], Uv(e[n], t[n]));
  }), $h($h({}, e), t);
}
var qT = {
  type: "cancelation",
  msg: "operation is manually canceled"
};
function nu(e) {
  var t = !1, n = new Promise(function(r, o) {
    e.then(function(s) {
      return t ? o(qT) : r(s);
    }), e.catch(o);
  });
  return n.cancel = function() {
    return t = !0;
  }, n;
}
var YT = VT.create({
  config: HT,
  isInitialized: !1,
  resolve: null,
  reject: null,
  monaco: null
}), Wv = wT(YT, 2), ta = Wv[0], nc = Wv[1];
function XT(e) {
  var t = GT.config(e), n = t.monaco, r = yT(t, ["monaco"]);
  nc(function(o) {
    return {
      config: Uv(o.config, r),
      monaco: n
    };
  });
}
function ZT() {
  var e = ta(function(t) {
    var n = t.monaco, r = t.isInitialized, o = t.resolve;
    return {
      monaco: n,
      isInitialized: r,
      resolve: o
    };
  });
  if (!e.isInitialized) {
    if (nc({
      isInitialized: !0
    }), e.monaco)
      return e.resolve(e.monaco), nu(ru);
    if (window.monaco && window.monaco.editor)
      return Gv(window.monaco), e.resolve(window.monaco), nu(ru);
    KT(JT, eA)(tA);
  }
  return nu(ru);
}
function JT(e) {
  return document.body.appendChild(e);
}
function QT(e) {
  var t = document.createElement("script");
  return e && (t.src = e), t;
}
function eA(e) {
  var t = ta(function(r) {
    var o = r.config, s = r.reject;
    return {
      config: o,
      reject: s
    };
  }), n = QT("".concat(t.config.paths.vs, "/loader.js"));
  return n.onload = function() {
    return e();
  }, n.onerror = t.reject, n;
}
function tA() {
  var e = ta(function(n) {
    var r = n.config, o = n.resolve, s = n.reject;
    return {
      config: r,
      resolve: o,
      reject: s
    };
  }), t = window.require;
  t.config(e.config), t(["vs/editor/editor.main"], function(n) {
    Gv(n), e.resolve(n);
  }, function(n) {
    e.reject(n);
  });
}
function Gv(e) {
  ta().monaco || nc({
    monaco: e
  });
}
function nA() {
  return ta(function(e) {
    var t = e.monaco;
    return t;
  });
}
var ru = new Promise(function(e, t) {
  return nc({
    resolve: e,
    reject: t
  });
}), Kv = {
  config: XT,
  init: ZT,
  __getMonacoInstance: nA
}, rA = { wrapper: { display: "flex", position: "relative", textAlign: "initial" }, fullWidth: { width: "100%" }, hide: { display: "none" } }, ou = rA, oA = { container: { display: "flex", height: "100%", width: "100%", justifyContent: "center", alignItems: "center" } }, sA = oA;
function iA({ children: e }) {
  return H.createElement("div", { style: sA.container }, e);
}
var aA = iA, lA = aA;
function cA({ width: e, height: t, isEditorReady: n, loading: r, _ref: o, className: s, wrapperProps: i }) {
  return H.createElement("section", { style: { ...ou.wrapper, width: e, height: t }, ...i }, !n && H.createElement(lA, null, r), H.createElement("div", { ref: o, style: { ...ou.fullWidth, ...!n && ou.hide }, className: s }));
}
var uA = cA, qv = we(uA);
function dA(e) {
  G(e, []);
}
var Yv = dA;
function pA(e, t, n = !0) {
  let r = K(!0);
  G(r.current || !n ? () => {
    r.current = !1;
  } : e, t);
}
var Qt = pA;
function ai() {
}
function Zo(e, t, n, r) {
  return fA(e, r) || hA(e, t, n, r);
}
function fA(e, t) {
  return e.editor.getModel(Xv(e, t));
}
function hA(e, t, n, r) {
  return e.editor.createModel(t, n, r ? Xv(e, r) : void 0);
}
function Xv(e, t) {
  return e.Uri.parse(t);
}
function gA({ original: e, modified: t, language: n, originalLanguage: r, modifiedLanguage: o, originalModelPath: s, modifiedModelPath: i, keepCurrentOriginalModel: a = !1, keepCurrentModifiedModel: l = !1, theme: u = "light", loading: d = "Loading...", options: p = {}, height: f = "100%", width: h = "100%", className: g, wrapperProps: m = {}, beforeMount: v = ai, onMount: b = ai }) {
  let [y, w] = W(!1), [S, x] = W(!0), C = K(null), P = K(null), _ = K(null), O = K(b), E = K(v), T = K(!1);
  Yv(() => {
    let L = Kv.init();
    return L.then((M) => (P.current = M) && x(!1)).catch((M) => (M == null ? void 0 : M.type) !== "cancelation" && console.error("Monaco initialization: error:", M)), () => C.current ? U() : L.cancel();
  }), Qt(() => {
    if (C.current && P.current) {
      let L = C.current.getOriginalEditor(), M = Zo(P.current, e || "", r || n || "text", s || "");
      M !== L.getModel() && L.setModel(M);
    }
  }, [s], y), Qt(() => {
    if (C.current && P.current) {
      let L = C.current.getModifiedEditor(), M = Zo(P.current, t || "", o || n || "text", i || "");
      M !== L.getModel() && L.setModel(M);
    }
  }, [i], y), Qt(() => {
    let L = C.current.getModifiedEditor();
    L.getOption(P.current.editor.EditorOption.readOnly) ? L.setValue(t || "") : t !== L.getValue() && (L.executeEdits("", [{ range: L.getModel().getFullModelRange(), text: t || "", forceMoveMarkers: !0 }]), L.pushUndoStop());
  }, [t], y), Qt(() => {
    var L, M;
    (M = (L = C.current) == null ? void 0 : L.getModel()) == null || M.original.setValue(e || "");
  }, [e], y), Qt(() => {
    let { original: L, modified: M } = C.current.getModel();
    P.current.editor.setModelLanguage(L, r || n || "text"), P.current.editor.setModelLanguage(M, o || n || "text");
  }, [n, r, o], y), Qt(() => {
    var L;
    (L = P.current) == null || L.editor.setTheme(u);
  }, [u], y), Qt(() => {
    var L;
    (L = C.current) == null || L.updateOptions(p);
  }, [p], y);
  let R = it(() => {
    var D;
    if (!P.current)
      return;
    E.current(P.current);
    let L = Zo(P.current, e || "", r || n || "text", s || ""), M = Zo(P.current, t || "", o || n || "text", i || "");
    (D = C.current) == null || D.setModel({ original: L, modified: M });
  }, [n, t, o, e, r, s, i]), B = it(() => {
    var L;
    !T.current && _.current && (C.current = P.current.editor.createDiffEditor(_.current, { automaticLayout: !0, ...p }), R(), (L = P.current) == null || L.editor.setTheme(u), w(!0), T.current = !0);
  }, [p, u, R]);
  G(() => {
    y && O.current(C.current, P.current);
  }, [y]), G(() => {
    !S && !y && B();
  }, [S, y, B]);
  function U() {
    var M, D, V, k;
    let L = (M = C.current) == null ? void 0 : M.getModel();
    a || ((D = L == null ? void 0 : L.original) == null || D.dispose()), l || ((V = L == null ? void 0 : L.modified) == null || V.dispose()), (k = C.current) == null || k.dispose();
  }
  return H.createElement(qv, { width: h, height: f, isEditorReady: y, loading: d, _ref: _, className: g, wrapperProps: m });
}
var mA = gA;
we(mA);
function vA(e) {
  let t = K();
  return G(() => {
    t.current = e;
  }, [e]), t.current;
}
var bA = vA, wa = /* @__PURE__ */ new Map();
function yA({ defaultValue: e, defaultLanguage: t, defaultPath: n, value: r, language: o, path: s, theme: i = "light", line: a, loading: l = "Loading...", options: u = {}, overrideServices: d = {}, saveViewState: p = !0, keepCurrentModel: f = !1, width: h = "100%", height: g = "100%", className: m, wrapperProps: v = {}, beforeMount: b = ai, onMount: y = ai, onChange: w, onValidate: S = ai }) {
  let [x, C] = W(!1), [P, _] = W(!0), O = K(null), E = K(null), T = K(null), R = K(y), B = K(b), U = K(), L = K(r), M = bA(s), D = K(!1), V = K(!1);
  Yv(() => {
    let Y = Kv.init();
    return Y.then((J) => (O.current = J) && _(!1)).catch((J) => (J == null ? void 0 : J.type) !== "cancelation" && console.error("Monaco initialization: error:", J)), () => E.current ? j() : Y.cancel();
  }), Qt(() => {
    var J, le, Q, re;
    let Y = Zo(O.current, e || r || "", t || o || "", s || n || "");
    Y !== ((J = E.current) == null ? void 0 : J.getModel()) && (p && wa.set(M, (le = E.current) == null ? void 0 : le.saveViewState()), (Q = E.current) == null || Q.setModel(Y), p && ((re = E.current) == null || re.restoreViewState(wa.get(s))));
  }, [s], x), Qt(() => {
    var Y;
    (Y = E.current) == null || Y.updateOptions(u);
  }, [u], x), Qt(() => {
    !E.current || r === void 0 || (E.current.getOption(O.current.editor.EditorOption.readOnly) ? E.current.setValue(r) : r !== E.current.getValue() && (V.current = !0, E.current.executeEdits("", [{ range: E.current.getModel().getFullModelRange(), text: r, forceMoveMarkers: !0 }]), E.current.pushUndoStop(), V.current = !1));
  }, [r], x), Qt(() => {
    var J, le;
    let Y = (J = E.current) == null ? void 0 : J.getModel();
    Y && o && ((le = O.current) == null || le.editor.setModelLanguage(Y, o));
  }, [o], x), Qt(() => {
    var Y;
    a !== void 0 && ((Y = E.current) == null || Y.revealLine(a));
  }, [a], x), Qt(() => {
    var Y;
    (Y = O.current) == null || Y.editor.setTheme(i);
  }, [i], x);
  let k = it(() => {
    var Y;
    if (!(!T.current || !O.current) && !D.current) {
      B.current(O.current);
      let J = s || n, le = Zo(O.current, r || e || "", t || o || "", J || "");
      E.current = (Y = O.current) == null ? void 0 : Y.editor.create(T.current, { model: le, automaticLayout: !0, ...u }, d), p && E.current.restoreViewState(wa.get(J)), O.current.editor.setTheme(i), a !== void 0 && E.current.revealLine(a), C(!0), D.current = !0;
    }
  }, [e, t, n, r, o, s, u, d, p, i, a]);
  G(() => {
    x && R.current(E.current, O.current);
  }, [x]), G(() => {
    !P && !x && k();
  }, [P, x, k]), L.current = r, G(() => {
    var Y, J;
    x && w && ((Y = U.current) == null || Y.dispose(), U.current = (J = E.current) == null ? void 0 : J.onDidChangeModelContent((le) => {
      V.current || w(E.current.getValue(), le);
    }));
  }, [x, w]), G(() => {
    if (x) {
      let Y = O.current.editor.onDidChangeMarkers((J) => {
        var Q;
        let le = (Q = E.current.getModel()) == null ? void 0 : Q.uri;
        if (le && J.find((re) => re.path === le.path)) {
          let re = O.current.editor.getModelMarkers({ resource: le });
          S == null || S(re);
        }
      });
      return () => {
        Y == null || Y.dispose();
      };
    }
    return () => {
    };
  }, [x, S]);
  function j() {
    var Y, J;
    (Y = U.current) == null || Y.dispose(), f ? p && wa.set(s, E.current.saveViewState()) : (J = E.current.getModel()) == null || J.dispose(), E.current.dispose();
  }
  return H.createElement(qv, { width: h, height: g, isEditorReady: x, loading: l, _ref: T, className: m, wrapperProps: v });
}
var wA = yA, SA = we(wA), xA = SA;
const Zv = (e) => {
  var t;
  (t = e.getAction("editor.action.formatDocument")) == null || t.run();
}, CA = "gs-field-code", PA = {
  minimap: { enabled: !1 },
  lineNumbers: "off",
  scrollBeyondLastLine: !1,
  contextmenu: !1,
  fixedOverflowWidgets: !0,
  // Render widgets outside of the container
  showFoldingControls: "always",
  suggestOnTriggerCharacters: !1,
  lineDecorationsWidth: 0,
  renderLineHighlight: "none",
  wordWrapOverride1: "off",
  // disable wordWrap
  tabSize: 2,
  // formatOnType: true,
  // formatOnPaste: true,
  // autoIndent: true,
  scrollbar: {
    verticalScrollbarSize: 8,
    horizontal: "hidden",
    alwaysConsumeMouseWheel: !1
  }
  // readOnly: true,
  // language: 'json',
  // lineNumbers: (lineNumber: number) => lineNumber.toString(),
  // lineNumbersMinChars: 5,
  // selectOnLineNumbers: false,
  // matchBrackets: 'never',
};
function Jr({
  size: e,
  value: t,
  label: n,
  language: r,
  onChange: o,
  clean: s,
  padding: i,
  isDarkTheme: a,
  className: l,
  containerClassName: u,
  noMinHeight: d,
  onMount: p,
  readOnly: f,
  description: h
}) {
  const g = typeof t == "string" ? t : JSON.stringify(t, null, 2);
  return (
    // This 3 div container fixes problems with autolayout, like not shrinking width on resize.
    /* @__PURE__ */ A("div", { className: F(CA, "flex flex-col w-full h-full", u), children: [
      !!n && /* @__PURE__ */ c($t, { children: n }),
      !!h && /* @__PURE__ */ c($t, { as: "span", size: e, className: F(z.txtLowEmphasis), capitalize: !1, children: h }),
      /* @__PURE__ */ c(
        "div",
        {
          className: F("flex-grow", "w-full", "h-full", !d && "gs-utl-min-h-48"),
          style: {
            position: "relative",
            width: "100%",
            height: "100%"
          },
          children: /* @__PURE__ */ c(
            "div",
            {
              style: {
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
              },
              children: /* @__PURE__ */ c(
                xA,
                {
                  defaultLanguage: r,
                  defaultValue: g,
                  theme: a ? "vs-dark" : "light",
                  className: F(se.b, se.rnd, z.br, l),
                  options: {
                    ...PA,
                    readOnly: f,
                    ...s && {
                      domReadOnly: !0,
                      // disables "Cannot edit in read-only editor" tooltip when typing
                      overviewRulerLanes: 0,
                      // disable the right side ruler
                      selectOnLineNumbers: !1,
                      folding: !1,
                      matchBrackets: "never",
                      guides: {
                        indentation: !1
                      }
                    },
                    ...Pr(i) && {
                      lineDecorationsWidth: i * 2,
                      padding: {
                        top: i,
                        bottom: i
                      }
                    }
                  },
                  onChange: o,
                  onMount: (m, v) => {
                    let b = !1;
                    const y = () => Zv(m);
                    m.onDidChangeModelLanguageConfiguration(y), m.onDidScrollChange(() => {
                      b || (b = !0, y());
                    }), setTimeout(y, 10), p == null || p(m, v);
                  }
                }
              )
            }
          )
        }
      )
    ] })
  );
}
const Jv = ue(function({ buttonProps: t, content: n, code: r, onAction: o }) {
  const s = Bn(), i = Ne(), a = ye(), { isProjectTypeEmail: l } = a, u = a.editor, { isDarkTheme: d } = cn(), [p, f] = W(), h = () => {
    let m = (p || "").trim();
    const v = dT({ code: m, appStore: a, showToastError: !0 });
    if (!v.error)
      m = v.output;
    else
      return;
    o ? o(m) : u.setComponents(m), s.close();
  };
  G(() => {
    r ? f(r) : (async () => {
      if (l)
        f(u.getHtml());
      else {
        const b = (await fl(u, {
          page: u.Pages.getSelected(),
          skipProject: !0,
          styles: "inline"
        })).find((y) => y.mimeType === "text/html");
        b && f(b.content);
      }
    })();
  }, []);
  const g = (t == null ? void 0 : t.children) || i.t("actions.importCode.button");
  return /* @__PURE__ */ A(I, { col: !0, space: "m", children: [
    /* @__PURE__ */ c(N, { children: n ?? i.t("actions.importCode.content") }),
    /* @__PURE__ */ c(N, { className: $("h-96"), children: p !== void 0 && /* @__PURE__ */ c(Jr, { value: p, onChange: (m) => f(m || ""), isDarkTheme: d, language: "html" }) }),
    /* @__PURE__ */ c(I, { justify: "end", children: /* @__PURE__ */ c(Ze, { size: "m2", variant: "pr", onClick: h, ...t, children: g }) })
  ] });
}), fd = "data-type-empty", Ih = (e, t) => {
  e.Canvas.getFrames().forEach((n) => {
    const { view: r } = n, o = Array.from(r.getDoc().querySelectorAll(`style[${fd}]`));
    for (const s of o)
      s.disabled = !t;
  });
}, EA = (e, t, n = "Empty", r = {}) => {
  const o = `[${fd}="${t}"]`, s = e.frameView.getHead(), { midSelector: i = "", styleOut: a = "", styleIn: l = "" } = r;
  if (!s.querySelector(`style${o}`)) {
    const u = document.createElement("style");
    u.setAttribute(fd, t), u.innerHTML = `
    [data-gjs-type="${t}"]${i}:empty {
      text-decoration: none;
      padding: 5px;
      ${r.limitW ? "min-width: 50px;" : ""}
      ${a}
    }
    [data-gjs-type="${t}"]${i}:empty:before {
      background-color: #ddd;
      color: #000;
      font-size: 16px;
      font-weight: bold;
      font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", "Open Sans", Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 30px;
      padding: 0 10px;
      opacity: 0.3;
      border-radius: 3px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      content: "${n}";
      ${r.limitH ? "height: auto;" : ""}
      ${r.smallH ? "min-height: 30px;" : ""}
      ${l}
    }`, s.appendChild(u);
  }
}, Qv = (e, t) => {
  const { model: n } = t, r = n.constructor.getDefaults(), o = r.emptyState, s = n.get("type");
  if (!o || r.void === !0 || s !== e)
    return;
  const i = o === !0 ? {} : o;
  EA(t, s, n.getName({ noCustom: !0 }), i);
}, OA = function(t) {
  const { Components: n } = t, r = (o) => {
    const { id: s } = o;
    n.addType(s, {
      extendFnView: ["onRender"],
      view: {
        onRender() {
          Qv(s, this);
        }
      }
    });
  };
  n.getTypes().forEach(r), t.on("component:type:add", r);
};
function _A(e) {
  const { Components: t } = e, n = t.events, { modalStore: r, i18nStore: o } = oa(), s = {
    id: "link",
    name: "href",
    label: "Link",
    placeholder: "Link to redirect on click"
  }, i = {
    name: "src",
    changeProp: !0,
    type: "image",
    label: "Image"
  }, a = {
    label: "Content",
    getValue: ({ component: m }) => m.getInnerHTML(),
    setValue: ({ component: m, value: v }) => m.components(v)
  }, l = (m) => {
    var b;
    const v = m.getChildrenContainer();
    ((b = v == null ? void 0 : v.innerHTML) == null ? void 0 : b.trim()) === "" && (v.innerHTML = "");
  }, u = (m) => m.set({ void: !1 }, { silent: !0 });
  t.addType("wrapper", {
    extendFn: ["init"],
    model: {
      defaults: {
        stylable: !1,
        delegate: {
          layer: (m) => m.findType("mjml")[0]
        }
      },
      init() {
        this.on(`${n.update}:components`, this.__updateLayersRoot);
      },
      __updateLayersRoot() {
        this.findFirstType("mjml") && e.Layers.setRoot(this);
      }
    }
  }), t.addType("mjml", {
    model: {
      defaults: {
        name: "Root",
        toolbar: []
      }
    }
  }), t.addType("mj-head", {
    model: {
      defaults: {
        name: "Head",
        copyable: !1,
        stylable: !1,
        traits: [],
        icon: `<svg viewBox="0 0 24 24">
          <path d="M14.6,16.6L19.2,12L14.6,7.4L16,6L22,12L16,18L14.6,16.6M9.4,16.6L4.8,12L9.4,7.4L8,6L2,12L8,18L9.4,16.6Z" />
        </svg>`
      }
    },
    view: {
      init() {
        const { em: m, el: v } = this, b = "core:preview", y = m.Commands.events;
        this.listenTo(m, `${y.runCommand}${b}`, () => {
          v.style.display = "none";
        }), this.listenTo(m, `${y.stopCommand}${b}`, () => {
          v.style.display = "";
        });
      }
    }
  }), t.addType("mj-attributes", {
    isComponent: Ks("mj-attributes"),
    model: {
      defaults: {
        name: "Attributes",
        copyable: !1,
        layerable: !1,
        stylable: !1,
        draggable: br("mj-head"),
        traits: []
      }
    },
    view: {
      onRender() {
        this.el.style.display = "none";
      }
    }
  }), t.addType("mj-class", {
    isComponent: Ks("mj-class"),
    model: {
      defaults: {
        name: "Class",
        stylable: !1,
        draggable: br("mj-attributes"),
        traits: []
      }
    }
  }), t.addType("mj-font", {
    model: {
      defaults: {
        name: "Font",
        stylable: !1,
        draggable: br("mj-head"),
        icon: '<svg viewBox="0 0 24 24"><path d="M17 8h3v12h1v1h-4v-1h1v-3h-4l-1.5 3H14v1h-4v-1h1l6-12m1 1-3.5 7H18V9M5 3h5a2 2 0 0 1 2 2v11H9v-5H6v5H3V5a2 2 0 0 1 2-2m1 2v4h3V5H6Z"/></svg>',
        traits: [
          {
            name: "name",
            placeholder: "Name of the font"
          },
          {
            name: "href",
            placeholder: "URL of a hosted CSS file"
          }
        ]
      }
    }
  }), t.addType("mj-all", {
    isComponent: Ks("mj-all"),
    model: {
      defaults: {
        name: "All",
        stylable: !1,
        draggable: br("mj-attributes"),
        traits: []
      }
    }
  }), t.addType("mj-preview", {
    isComponent: Ks("mj-preview"),
    model: {
      defaults: {
        name: "Preview",
        copyable: !1,
        droppable: !1,
        stylable: !1,
        draggable: br("mj-head"),
        traits: [a],
        icon: `<svg viewBox="0 0 24 24">
          <path d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z" />
        </svg>`
      }
    },
    view: {
      tagName: () => "div",
      init() {
        const m = this.model.components();
        this.onRender = As(this.onRender, 1), this.listenTo(m, "add remove reset change", this.onRender);
      },
      onRender() {
        const { model: m, el: v } = this, b = m.getName({ noCustom: !0 }), y = m.getInnerHTML();
        v.innerHTML = `<b>${b}</B>: ${y}`, v.style.padding = "5px 10px", v.style.fontFamily = "system-ui";
      }
    }
  }), t.addType("mj-title", {
    isComponent: Ks("mj-title"),
    extend: "mj-preview",
    model: {
      defaults: {
        name: "Title",
        icon: '<svg viewBox="0 0 24 24"><path d="M5,4V7H10.5V19H13.5V7H19V4H5Z" /></svg>'
      }
    }
  }), t.addType("mj-style", {
    model: {
      defaults: {
        name: "Style",
        droppable: !1,
        stylable: !1,
        traits: []
      }
    }
  }), t.addType("mj-body", {
    model: {
      defaults: {
        icon: `<svg viewBox="0 0 24 24">
          <path d="M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M6,8V16H18V8H6Z" />
        </svg>`,
        traits: [],
        emptyState: {
          midSelector: ">div",
          styleOut: "height: 100vh;"
        }
      }
    }
  }), t.addType("mj-section", {
    extendFn: ["init"],
    model: {
      defaults: {
        icon: `<svg viewBox="0 0 24 24">
          <path d="M2,3V6H21V3M20,8H3A1,1 0 0,0 2,9V15A1,1 0 0,0 3,16H20A1,1 0 0,0 21,15V9A1,1 0 0,0 20,8M2,21H21V18H2V21Z" />
        </svg>`,
        "style-default": {
          padding: "20px 0px",
          "text-align": "center"
        },
        traits: [
          {
            type: "checkbox",
            label: "Full width",
            name: "full-width",
            valueTrue: "full-width",
            valueFalse: ""
          }
        ],
        emptyState: {
          midSelector: ">div>div>table>tbody>tr>td"
        }
      },
      init() {
        u(this);
      }
    },
    extendFnView: ["render"],
    view: {
      render() {
        return l(this), this;
      }
    }
  }), t.addType("mj-column", {
    extendFn: ["init"],
    model: {
      defaults: {
        icon: `<svg viewBox="0 0 24 24" style="rotate: 90deg;">
          <path d="M2,3V6H21V3M20,8H3A1,1 0 0,0 2,9V15A1,1 0 0,0 3,16H20A1,1 0 0,0 21,15V9A1,1 0 0,0 20,8M2,21H21V18H2V21Z" />
        </svg>`,
        traits: [],
        emptyState: {
          midSelector: ">table",
          styleIn: "margin: 0 10px;"
        }
      },
      init() {
        u(this);
      }
    }
  }), t.addType("mj-text", {
    model: {
      defaults: {
        emptyState: {
          midSelector: ' [contenteditable="false"]',
          styleIn: "min-height: 20px;",
          styleOut: "padding: 0 5px;"
        },
        traits: [],
        "style-default": {
          padding: "10px 25px",
          "font-size": "13px",
          align: "left"
        }
      }
    }
  }), t.addType("mj-button", {
    model: {
      defaults: {
        traits: [s]
      }
    }
  }), t.addType("mj-image", {
    model: {
      defaults: {
        "style-default": {
          padding: "10px 25px",
          align: "center"
        },
        traits: [
          {
            name: "src",
            changeProp: !0,
            type: "image",
            label: "Image"
          },
          {
            id: "altText",
            name: "alt",
            placeholder: "Image description"
          },
          "title",
          s
        ]
      }
    },
    view: {
      getMjmlTemplate() {
        return {
          start: "<mjml><mj-body><mj-section><mj-column>",
          end: "</mj-column></mj-section></mj-body></mjml>"
        };
      },
      getTemplateFromEl(m) {
        var v, b, y;
        return (y = (b = (v = m.querySelector("img")) == null ? void 0 : v.closest("table")) == null ? void 0 : b.closest("tr")) == null ? void 0 : y.innerHTML;
      }
    }
  }), t.addType("mj-divider", {
    model: {
      defaults: {
        attributes: { align: "center" },
        traits: [
          {
            name: "align",
            type: "radio",
            options: [
              {
                id: "left",
                title: "Left",
                labelReact: /* @__PURE__ */ c(oe, { icon: ne.alignHorizontalLeft, size: pe.sx })
              },
              {
                id: "center",
                title: "Center",
                labelReact: /* @__PURE__ */ c(oe, { icon: ne.alignHorizontalCenter, size: pe.sx })
              },
              {
                id: "right",
                title: "Right",
                labelReact: /* @__PURE__ */ c(oe, { icon: ne.alignHorizontalRight, size: pe.sx })
              }
            ]
          }
        ]
      }
    }
  }), t.addType("mj-social", {
    model: {
      defaults: {
        name: "Social",
        traits: [],
        emptyState: {
          midSelector: ">td"
        }
      }
    }
  });
  const { view: d, model: p } = t.getType("mj-social-element");
  t.addType("mj-social-element", {
    extendFn: ["init"],
    model: {
      defaults: {
        traits: [
          {
            type: "select",
            label: "Icon",
            name: "name",
            options: [
              { id: "custom", name: "Custom" },
              { id: "facebook", name: "Facebook" },
              { id: "twitter", name: "Twitter/X" },
              { id: "google", name: "Google" },
              { id: "instagram", name: "Instagram" },
              { id: "web", name: "Web" },
              { id: "youtube", name: "YouTube" },
              { id: "pinterest", name: "Pinterest" },
              { id: "linkedin", name: "Linkedin" },
              { id: "snapchat", name: "Snapchat" },
              { id: "vimeo", name: "Vimeo" },
              { id: "tumblr", name: "Tumblr" },
              { id: "github", name: "Github" },
              { id: "soundcloud", name: "SoundCloud" },
              { id: "medium", name: "Medium" },
              { id: "dribbble", name: "Dribbble" },
              { id: "xing", name: "Xing" }
            ]
          },
          i,
          s,
          a
        ]
      },
      init() {
        u(this);
      },
      getMjmlAttributes() {
        const m = p.prototype.getMjmlAttributes.call(this);
        return { ...this.getDefaultIconProps()[m.name], ...m };
      },
      getAttrToHTML() {
        const m = p.prototype.getAttrToHTML.call(this);
        return { ...this.getDefaultIconProps()[m.name], ...m };
      },
      getDefaultIconProps() {
        return {
          twitter: {
            src: "https://upload.wikimedia.org/wikipedia/commons/5/57/X_logo_2023_%28white%29.png",
            "background-color": "black"
          }
        };
      }
    },
    extendFnView: ["init"],
    view: {
      init() {
        this.listenTo(this.model, "component:update:components", this.rerender);
      },
      getInnerMjmlTemplate() {
        var y;
        const { start: m, end: v } = d.prototype.getInnerMjmlTemplate.call(this), b = ((y = this.model.getInnerHTML()) == null ? void 0 : y.trim()) || "";
        return {
          start: `${m}${b}`,
          end: v
        };
      },
      getChildrenContainer() {
        var y;
        const { el: m } = this, v = (y = m.querySelector("tbody > tr > td")) == null ? void 0 : y.nextElementSibling;
        return (v == null ? void 0 : v.firstElementChild) || m.querySelector("img") || m;
      }
    }
  }), t.addType("mj-spacer", {
    model: {
      defaults: {
        traits: []
      }
    }
  }), t.addType("mj-navbar", {
    model: {
      defaults: {
        emptyState: {
          midSelector: ">td>div"
        }
      }
    }
  }), t.addType("mj-navbar-link", {
    model: {
      defaults: {
        icon: `<svg viewBox="0 0 24 24">
          <path fill="currentColor" d="M21,15.61L19.59,17L14.58,12L19.59,7L21,8.39L17.44,12L21,15.61M3,6H16V8H3V6M3,13V11H13V13H3M3,18V16H16V18H3Z" />
        </svg>`,
        emptyState: {
          midSelector: ">td>div"
        }
      }
    }
  });
  const f = (m) => {
    r.open({
      title: m.getName({ noCustom: !0 }),
      content: () => /* @__PURE__ */ c(
        Jv,
        {
          content: "",
          code: m.getInnerHTML(),
          onAction: (v) => m.components(v),
          buttonProps: { children: o.t("save") }
        }
      )
    });
  };
  t.addType("mj-raw", {
    extendFn: ["initToolbar"],
    model: {
      defaults: {
        name: "HTML block",
        emptyState: {
          midSelector: ">div"
        }
      },
      initToolbar() {
        b5(this, {
          id: "edit",
          command: () => f(this),
          label: `<svg viewBox="0 0 24 24">
            <path d="M14.6 16.6l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4m-5.2 0L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4z"></path>
          </svg>`
        });
      }
    },
    view: {
      events: {
        dblclick: "onActive"
      },
      onActive() {
        f(this.model);
      }
    }
  });
  const h = (m) => {
    const { id: v, view: b } = m, y = b.prototype;
    t.addType(v, {
      view: {
        // TODO FIX: mjml preset plugin removes onRender method
        render() {
          return y.render.apply(this, arguments), Qv(v, this), this;
        }
      }
    });
  };
  ["mj-body", "mj-section", "mj-column", "mj-text", "mj-navbar", "mj-social", "mj-raw"].forEach((m) => h(t.getType(m))), t.getTypes().forEach(({ id: m, view: v }) => {
    v.prototype.disableEditing && t.addType(m, {
      view: {
        onDisable(b = {}) {
          this.disableEditing({
            ...b,
            parserOptions: {
              htmlType: "text/html"
            }
          });
        }
      }
    });
  });
}
function TA(e) {
  const { Blocks: t } = e, n = "Content", r = "Layout", o = { className: "h-7", full: !0, space: "s", nowrap: !0 }, s = {
    category: r,
    full: !0
  }, i = "gjs-border-2 gjs-border-current gjs-rounded-sm", a = (l, u) => {
    t.add(l, {
      select: !0,
      category: n,
      ...u
    });
  };
  a("mj-text", {
    label: "Text",
    media: `<svg viewBox="0 0 24 24">
      <path fill="currentColor" d="M18.5,4L19.66,8.35L18.7,8.61C18.25,7.74 17.79,6.87 17.26,6.43C16.73,6 16.11,6 15.5,6H13V16.5C13,17 13,17.5 13.33,17.75C13.67,18 14.33,18 15,18V19H9V18C9.67,18 10.33,18 10.67,17.75C11,17.5 11,17 11,16.5V6H8.5C7.89,6 7.27,6 6.74,6.43C6.21,6.87 5.75,7.74 5.3,8.61L4.34,8.35L5.5,4H18.5Z" />
    </svg>`,
    content: "<mj-text>Insert text here</mj-text>",
    activate: !0
  }), a("mj-button", {
    label: "Button",
    media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M20 20.5C20 21.3 19.3 22 18.5 22H13C12.6 22 12.3 21.9 12 21.6L8 17.4L8.7 16.6C8.9 16.4 9.2 16.3 9.5 16.3H9.7L12 18V9C12 8.4 12.4 8 13 8S14 8.4 14 9V13.5L15.2 13.6L19.1 15.8C19.6 16 20 16.6 20 17.1V20.5M20 2H4C2.9 2 2 2.9 2 4V12C2 13.1 2.9 14 4 14H8V12H4V4H20V12H18V14H20C21.1 14 22 13.1 22 12V4C22 2.9 21.1 2 20 2Z" />
    </svg>`,
    content: "<mj-button>Button</mj-button>"
  }), a("mj-image", {
    label: "Image",
    media: `<svg viewBox="0 0 24 24">
      <path fill="currentColor" d="M21,3H3C2,3 1,4 1,5V19A2,2 0 0,0 3,21H21C22,21 23,20 23,19V5C23,4 22,3 21,3M5,17L8.5,12.5L11,15.5L14.5,11L19,17H5Z" />
    </svg>`,
    content: `<mj-image src="${aS}"/>`,
    activate: !0
  }), a("mj-divider", {
    label: "Divider",
    media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M21 18H2V20H21V18M19 10V14H4V10H19M20 8H3C2.45 8 2 8.45 2 9V15C2 15.55 2.45 16 3 16H20C20.55 16 21 15.55 21 15V9C21 8.45 20.55 8 20 8M21 4H2V6H21V4Z" />
    </svg>`,
    content: "<mj-divider/>"
  }), a("mj-social", {
    label: "Social",
    media: `<svg viewBox="0 0 24 24">
      <path fill="currentColor" d="M18,16.08C17.24,16.08 16.56,16.38 16.04,16.85L8.91,12.7C8.96,12.47 9,12.24 9,12C9,11.76 8.96,11.53 8.91,11.3L15.96,7.19C16.5,7.69 17.21,8 18,8A3,3 0 0,0 21,5A3,3 0 0,0 18,2A3,3 0 0,0 15,5C15,5.24 15.04,5.47 15.09,5.7L8.04,9.81C7.5,9.31 6.79,9 6,9A3,3 0 0,0 3,12A3,3 0 0,0 6,15C6.79,15 7.5,14.69 8.04,14.19L15.16,18.34C15.11,18.55 15.08,18.77 15.08,19C15.08,20.61 16.39,21.91 18,21.91C19.61,21.91 20.92,20.61 20.92,19A2.92,2.92 0 0,0 18,16.08Z" />
    </svg>`,
    content: `<mj-social font-size="12px" icon-size="24px" border-radius="12px" mode="horizontal">
        <mj-social-element name="facebook"></mj-social-element>
        <mj-social-element name="linkedin"></mj-social-element>
        <mj-social-element name="twitter"></mj-social-element>
      </mj-social>`
  }), a("mj-social-element", {
    label: "Social Element",
    media: `<svg viewBox="0 0 24 24">
      <path d="M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12S8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5S19.66 2 18 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12S4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.34C15.11 18.55 15.08 18.77 15.08 19C15.08 20.61 16.39 21.91 18 21.91S20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08M18 4C18.55 4 19 4.45 19 5S18.55 6 18 6 17 5.55 17 5 17.45 4 18 4M6 13C5.45 13 5 12.55 5 12S5.45 11 6 11 7 11.45 7 12 6.55 13 6 13M18 20C17.45 20 17 19.55 17 19S17.45 18 18 18 19 18.45 19 19 18.55 20 18 20Z" />
    </svg>`,
    content: '<mj-social-element name="facebook">Facebook</mj-social-element>'
  }), a("mj-spacer", {
    label: "Spacer",
    media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M8,18H11V15H2V13H22V15H13V18H16L12,22L8,18M12,2L8,6H11V9H2V11H22V9H13V6H16L12,2Z" />
    </svg>`,
    content: "<mj-spacer/>"
  }), a("mj-navbar", {
    label: "Navbar",
    media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
    </svg>`,
    content: `<mj-navbar>
      <mj-navbar-link>HOME</mj-navbar-link>
      <mj-navbar-link>ABOUT</mj-navbar-link>
      <mj-navbar-link>CONTACT</mj-navbar-link>
      <mj-navbar-link>BLOG</mj-navbar-link>
    </mj-navbar>`
  }), a("mj-hero", {
    label: "Hero",
    media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M4,6V18H20V6H4M6,9H18V11H6V9M6,13H16V15H6V13Z" />
    </svg>`,
    content: `<mj-hero mode="fixed-height" height="469px" background-width="600px" background-height="469px" background-url="${p1({ width: 600, height: 300, text: "Hero Image", fg: "555" })}" background-color="#2a3448" padding="100px 0px">
      <mj-text padding="20px" color="#ffffff" font-family="Helvetica" align="center" font-size="45px" line-height="45px" font-weight="900">
        Heading title
      </mj-text>
      <mj-text padding="20px" color="#ffffff" font-family="Helvetica" align="center">
        Place here your hero content text
      </mj-text>
      <mj-button href="https://mjml.io/" align="center">
        Call to action!
      </mj-button>
    </mj-hero>`
  }), a("mj-raw", {
    label: "HTML block",
    activate: !0,
    media: `<svg viewBox="0 0 24 24">
      <path d="M5.59 3.41L7 4.82L3.82 8L7 11.18L5.59 12.6L1 8L5.59 3.41M11.41 3.41L16 8L11.41 12.6L10 11.18L13.18 8L10 4.82L11.41 3.41M22 6V18C22 19.11 21.11 20 20 20H4C2.9 20 2 19.11 2 18V14H4V18H20V6H17.03V4H20C21.11 4 22 4.89 22 6Z" />
    </svg>`,
    content: `<mj-raw>
      <span>Insert here you custom HTML</span>
    </mj-raw>`
  }), a("mj-1-column", {
    ...s,
    label: "1 Column",
    mediaReact: /* @__PURE__ */ c(I, { ...o, children: /* @__PURE__ */ c(N, { className: i, grow: !0 }) }),
    content: `<mj-section>
        <mj-column></mj-column>
      </mj-section>`
  }), a("mj-2-columns-50-50", {
    ...s,
    label: "2 Columns 50/50",
    mediaReact: /* @__PURE__ */ A(I, { ...o, children: [
      /* @__PURE__ */ c(N, { className: i, grow: !0 }),
      /* @__PURE__ */ c(N, { className: i, grow: !0 })
    ] }),
    content: `<mj-section>
      <mj-column></mj-column>
      <mj-column></mj-column>
    </mj-section>`
  }), a("mj-2-columns-25-75", {
    ...s,
    label: "2 Columns 25/75",
    mediaReact: /* @__PURE__ */ A(I, { ...o, children: [
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-1/4") }),
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-3/4") })
    ] }),
    content: `<mj-section>
      <mj-column width="25%"></mj-column>
      <mj-column width="75%"></mj-column>
    </mj-section>`
  }), a("mj-2-columns-33-67", {
    ...s,
    label: "2 Columns 33/67",
    mediaReact: /* @__PURE__ */ A(I, { ...o, children: [
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-1/3") }),
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-2/3") })
    ] }),
    content: `<mj-section>
      <mj-column width="33%"></mj-column>
      <mj-column width="67%"></mj-column>
    </mj-section>`
  }), a("mj-2-columns-67-33", {
    ...s,
    label: "2 Columns 67/33",
    mediaReact: /* @__PURE__ */ A(I, { ...o, children: [
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-2/3") }),
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-1/3") })
    ] }),
    content: `<mj-section>
      <mj-column width="67%"></mj-column>
      <mj-column width="33%"></mj-column>
    </mj-section>`
  }), a("mj-2-columns-75-25", {
    ...s,
    label: "2 Columns 75/25",
    mediaReact: /* @__PURE__ */ A(I, { ...o, children: [
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-3/4") }),
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-1/4") })
    ] }),
    content: `<mj-section>
      <mj-column width="75%"></mj-column>
      <mj-column width="25%"></mj-column>
    </mj-section>`
  }), a("mj-3-columns", {
    ...s,
    label: "3 Columns",
    mediaReact: /* @__PURE__ */ A(I, { ...o, children: [
      /* @__PURE__ */ c(N, { className: i, grow: !0 }),
      /* @__PURE__ */ c(N, { className: i, grow: !0 }),
      /* @__PURE__ */ c(N, { className: i, grow: !0 })
    ] }),
    content: `<mj-section>
        <mj-column></mj-column>
        <mj-column></mj-column>
        <mj-column></mj-column>
      </mj-section>`
  }), a("mj-3-columns-25-25-50", {
    ...s,
    label: "3 Columns 25/25/50",
    mediaReact: /* @__PURE__ */ A(I, { ...o, children: [
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-1/4") }),
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-1/4") }),
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-2/4") })
    ] }),
    content: `<mj-section>
        <mj-column width="25%"></mj-column>
        <mj-column width="25%"></mj-column>
        <mj-column width="50%"></mj-column>
      </mj-section>`
  }), a("mj-3-columns-25-50-25", {
    ...s,
    label: "3 Columns 25/50/25",
    mediaReact: /* @__PURE__ */ A(I, { ...o, children: [
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-1/4") }),
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-2/4") }),
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-1/4") })
    ] }),
    content: `<mj-section>
        <mj-column width="25%"></mj-column>
        <mj-column width="50%"></mj-column>
        <mj-column width="25%"></mj-column>
      </mj-section>`
  }), a("mj-3-columns-50-25-25", {
    ...s,
    label: "3 Columns 50/25/25",
    mediaReact: /* @__PURE__ */ A(I, { ...o, children: [
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-2/4") }),
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-1/4") }),
      /* @__PURE__ */ c(N, { className: F(i, "gs-utl-basis-1/4") })
    ] }),
    content: `<mj-section>
        <mj-column width="50%"></mj-column>
        <mj-column width="25%"></mj-column>
        <mj-column width="25%"></mj-column>
      </mj-section>`
  }), a("mj-4-columns", {
    ...s,
    label: "4 Columns",
    mediaReact: /* @__PURE__ */ A(I, { ...o, children: [
      /* @__PURE__ */ c(N, { className: i, grow: !0 }),
      /* @__PURE__ */ c(N, { className: i, grow: !0 }),
      /* @__PURE__ */ c(N, { className: i, grow: !0 }),
      /* @__PURE__ */ c(N, { className: i, grow: !0 })
    ] }),
    content: `<mj-section>
        <mj-column></mj-column>
        <mj-column></mj-column>
        <mj-column></mj-column>
        <mj-column></mj-column>
      </mj-section>`
  });
}
const AA = (e, t) => ({
  [Ve.web]: (r) => uT(r, t),
  [Ve.email]: _A
})[e], Vh = {
  global: [
    {
      id: "grapesjs-indexeddb",
      src: "https://unpkg.com/grapesjs-indexeddb@1.0.4/dist/index.js",
      options: { type: "local" }
    }
  ],
  [Ve.email]: [
    // Adding blocks before so the icon will be transferred from Blocks to Components (via blockIconsToComponent plugin)
    TA,
    {
      id: "grapesjs-mjml",
      src: "https://unpkg.com/grapesjs-mjml@1.0.6/dist/index.js",
      options: {
        columnsPadding: "",
        // avoid injecting custom styles
        useCustomTheme: !1,
        // avoid loading the default panel for devices
        resetDevices: !1,
        // no need to reset blocks
        resetBlocks: !1,
        blocks: [],
        // allow to import mjml void strings like '<mj-image ... />'
        useXmlParser: !0,
        // no need to reset style manager
        resetStyleManager: !1
      }
    }
  ],
  [Ve.web]: [
    { id: "gjs-blocks-basic", src: "https://unpkg.com/grapesjs-blocks-basic@1.0.1/dist/index.js" },
    { id: "grapesjs-plugin-forms", src: "https://unpkg.com/grapesjs-plugin-forms@2.0.5/dist/index.js" },
    {
      id: "grapesjs-plugin-export",
      src: "https://unpkg.com/grapesjs-plugin-export@1.0.11/dist/index.js",
      options: {
        isBinary: (e, t) => {
          const n = t.split(".")[1];
          return /[\x00-\x08\x0E-\x1F]/.test(e) && !(n && ["html", "css"].indexOf(n) >= 0);
        }
      }
    },
    { id: "grapesjs-parser-postcss", src: "https://unpkg.com/grapesjs-parser-postcss@1.0.1/dist/index.js" },
    { id: "grapesjs-tui-image-editor", src: "https://unpkg.com/grapesjs-tui-image-editor@1.0.1/dist/index.js" },
    // { id: 'grapesjs-component-countdown', src: 'https://unpkg.com/grapesjs-component-countdown@1.0.1/dist/index.js' },
    // { id: 'grapesjs-tabs', src: 'https://unpkg.com/grapesjs-tabs@1.0.6/dist/grapesjs-tabs.min.js', options: { tabsBlock: { category: 'Extra' } } },
    // { id: 'grapesjs-custom-code', src: 'https://unpkg.com/grapesjs-custom-code@1.0.1/dist/index.js' },
    // { id: 'grapesjs-tooltip', src: 'https://unpkg.com/grapesjs-tooltip@0.1.7/dist/index.js' },
    // { id: 'grapesjs-typed', src: 'https://unpkg.com/grapesjs-typed@1.0.5/dist/grapesjs-typed.min.js', options: { block: { category: 'Extra' } } },
    // TODO remove empty state
    {
      id: "grapesjs-navbar",
      src: "https://unpkg.com/grapesjs-navbar@1.0.1/dist/index.js",
      options: { block: { category: "Extra" } }
    }
    // { id: 'grapesjs-touch', src: 'https://unpkg.com/grapesjs-touch@0.1.1' },
    // { id: 'grapesjs-style-bg', src: 'https://unpkg.com/grapesjs-style-bg@1.0.5' },
  ]
};
function LA(e) {
  const { Components: t, Blocks: n } = e, r = (o) => {
    const { model: s, id: i } = o, a = s.getDefaults(), l = n.get(i), u = a.icon, d = l == null ? void 0 : l.get("media"), p = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5h14z"></path></svg>', f = u && u !== p && !d ? u : d || p;
    t.addType(i, {
      model: {
        defaults: { icon: f }
      }
    });
  };
  t.getTypes().forEach(r), e.on("component:type:add", r);
}
const kA = (e, t) => {
  const { contextMenu: n } = t.appStore.store, { Canvas: r } = e;
  e.on(r.events.frameLoad, ({ window: o, el: s }) => {
    o.document.addEventListener("contextmenu", async (a) => {
      if (!n.isEnabled)
        return;
      a.preventDefault();
      const l = a.target, u = e.getModel().get("componentHovered") || e.Utils.helpers.getModel(l);
      if (u) {
        const d = s.getBoundingClientRect(), p = r.getZoomDecimal();
        e.runCommand(me.contextMenuComponent, {
          component: u,
          event: a,
          x: a.clientX * p + d.left,
          y: a.clientY * p + d.top
        });
      }
    });
  });
};
function MA(e) {
  const { Components: t } = e, n = (r) => {
    const { id: o, model: s } = r;
    if (o === "custom-code") {
      const i = "<span>Insert here your custom code</span>";
      t.addType(o, {
        model: {
          defaults: {
            emptyState: !0,
            icon: '<svg viewBox="0 0 24 24"><path d="M14.6 16.6l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4m-5.2 0L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4z"></path></svg>',
            classes: "gjs-custom-code",
            components: i,
            "custom-code-plugin__code": i,
            styles: ".gjs-custom-code { padding: 5px; }"
          }
        }
      });
    }
    if (o === "typed") {
      const i = s.getDefaults().traits.map(
        (a) => a.name === "strings" ? {
          ...a,
          type: "stack",
          addItem(l) {
            return {
              id: l,
              label: `New string ${l}`
            };
          },
          getValue({ component: l }) {
            return l.get("strings").map((u, d) => ({
              id: `${d}`,
              label: u
            }));
          },
          setValue: ({ component: l, value: u }) => {
            const d = u.map((p) => p.label);
            l.set({ strings: d }), l.trigger("rerender");
          },
          properties: [{ name: "label" }]
        } : a
      );
      t.addType(o, {
        model: {
          defaults: {
            traits: i,
            strings: [
              "These are the default values...!!!",
              "Use your own strings from Properties!",
              "Have a great day!"
            ],
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300"><path d="M212.3 44l2.3 49.6h-6A60 60 0 00204 75c-3.2-6-7.5-10.5-12.9-13.3a44.9 44.9 0 00-21.1-4.3h-29.8V219c0 13 1.4 21 4.2 24.3 4 4.4 10 6.6 18.2 6.6h7.4v5.7H80.2V250h7.5c9 0 15.3-2.7 19-8.2 2.4-3.3 3.5-10.9 3.5-22.7V57.3H84.8a71 71 0 00-21.1 2.2 29 29 0 00-13.9 11.3 46.1 46.1 0 00-6.9 22.8H37L39.5 44h172.8zM245 22h18v256h-18z"/></svg>',
            classes: "gjs-typed",
            styles: `
                  .gjs-typed {
                    padding: 5px;
                  }
                `
          }
        }
      });
    }
    if (["tabs", "tab-content", "tab-contents", "tab", "tab-container"].indexOf(o) >= 0) {
      const a = {
        emptyState: !0,
        icon: o === "tabs" ? `
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 9.3c0-.8-.5-1.3-1.3-1.3H3.4C2.5 8 2 8.5 2 9.3v7.4c0 .8.5 1.3 1.3 1.3h17.4c.8 0 1.3-.5 1.3-1.3V9.3zM21 17H3V9h18v8z" fill-rule="nonzero"/><rect x="3" y="5" width="4" height="2" rx=".5"/><rect x="8" y="5" width="4" height="2" rx=".5"/><rect x="13" y="5" width="4" height="2" rx=".5"/>
            </svg>
          ` : void 0
      };
      o === "tab" && (a.traits = [
        {
          type: "button",
          label: !1,
          text: "Style Active",
          command: (l) => {
            l.select(), l.runCommand(tb), setTimeout(() => l.Selectors.select(".tab.tab-active"));
          }
        }
      ]), t.addType(o, {
        model: {
          defaults: a
        }
      });
    }
  };
  e.on("component:type:add", n);
}
const $A = (e, t) => {
  var r;
  const { globalStylesStore: n } = t.appStore.store;
  (r = e.DataSources) == null || r.all.on("reset", () => n.onLoad());
}, RA = (e) => {
  const { assetsStore: t } = oa();
  if (t.onCloudOrCustomUpload) {
    const { Assets: n } = e;
    n.getConfig().uploadFile = (r) => t.handleUpload(r);
  }
}, NA = () => {
  const { baseApiUrl: e } = ts();
  return `${e}/sdk/projects`;
}, eb = (e) => `${NA()}/${e}`, jA = async ({ licenseKey: e, projectId: t, ...n }) => {
  const r = await ar.put(eb(t), {
    body: JSON.stringify(n),
    params: { d: window.location.hostname, licenseKey: e }
  });
  return r == null ? void 0 : r.result;
}, DA = async (e, t) => await ar.put(t, {
  body: e,
  headers: {
    "Content-Type": "application/json"
  }
}), IA = async (e, t, n, r) => {
  const o = JSON.stringify(e), s = await jA({
    licenseKey: t,
    projectId: n,
    fileMetadata: { size: new Blob([o]).size },
    identityId: r,
    name: e.name,
    description: e.description
  });
  if (!s)
    throw new Error("Project not found");
  const { uploadUrl: i } = s;
  await DA(o, i);
}, VA = (e, t, n) => ar.get(eb(t), {
  params: { d: window.location.hostname, licenseKey: e, identityId: n }
}), HA = async (e) => await ar.get(e), BA = async (e, t, n, r) => {
  const o = await VA(t, n, r), s = o == null ? void 0 : o.result, i = o == null ? void 0 : o.errorData;
  if (!s && (i != null && i.notFoundInDb))
    return { id: n, project: {} };
  if (!s)
    throw new Error("Project not found");
  const { downloadUrl: a } = s, l = await HA(a);
  if (!l || l instanceof Error)
    throw new Error("Project download failed");
  return { id: n, project: l };
}, zA = (e, t) => {
  const { appEditorStore: n, toastStore: r, i18nStore: o } = t.appStore.store, { isUsingProjectSelfHosted: s, isUsingProjectCloud: i, sdkOptions: a } = n, l = a.storage || {}, {
    project: u,
    onLoad: d,
    onSave: p,
    autosaveChanges: f,
    autosaveIntervalMs: h
  } = l;
  let g, m, v, b;
  if (s)
    v = d, b = p, g = f, m = h;
  else if (i) {
    const C = a.licenseKey, P = n.sdkProjectId, _ = n.sdkIdentityId, O = 10, E = 1e4;
    b = ({ project: T }) => IA(T, C, P, _), v = ({ editor: T }) => BA(T, C, P, _), g = Math.max(O, f ?? O), h && (m = Math.max(E, h));
  }
  const { Storage: y } = e, { events: w } = y;
  let S = !1;
  const x = e.em.constructor.prototype;
  if (e.em.loadData = function(...C) {
    const P = x.loadData.apply(e.em, C);
    return S = P && !!Object.keys(P).length, P;
  }, e.once("change:readyLoad", () => {
    var P;
    const C = (P = a.project) == null ? void 0 : P.default;
    !S && C && e.loadProjectData(C);
  }), e.on(w.startStore, () => n.setIsSaving(!0)), e.on(w.endStore, () => n.setIsSaving(!1)), (v || u) && b) {
    const C = "remote";
    y.setCurrent(C), y.add(C, {
      async load() {
        return u || (await v({ editor: e })).project;
      },
      async store(P) {
        await b({ project: P, editor: e });
      }
    }), e.on(w.errorLoad, (P) => {
      r.addError("storage-error-load", {
        header: o.t("storageManager.errorLoad"),
        content: P.message
      });
    }), e.on(w.errorStore, (P) => {
      r.addError("storage-error-store", {
        header: o.t("storageManager.errorStore"),
        content: P.message
      });
    }), g && y.setStepsBeforeSave(g), m && e.onReady(() => {
      const P = setInterval(async () => {
        e.getDirtyCount() > 0 && !n.isSaving && await e.store();
      }, m);
      e.on("destroy", () => clearInterval(P));
    });
  }
}, gl = "select-target", tb = "enable-sm";
function FA(e, t) {
  var B, U, L, M;
  const {
    appEditorStore: n,
    blockManagerStore: r,
    toastStore: o,
    modalStore: s,
    layoutStore: i,
    contextMenu: a,
    assetsStore: l,
    fontsStore: u
  } = t.appStore.store, { projectIdToLoad: d, nextProjectData: p, sdkOptions: f } = n, h = () => r.toggleOpen(), g = () => n.toggleLeftSidebar(), m = () => n.toggleRightSidebar(), v = e.getConfig(), { Assets: b, Storage: y, Commands: w } = e, S = w.events, x = e.events, C = (U = (B = f.gjsOptions) == null ? void 0 : B.assetManager) == null ? void 0 : U.custom;
  if (b.all.model.prototype.idAttribute = "src", Pr(C) && (b.getConfig().custom = C), p && (v.projectData = p, n.setNextProjectData()), d) {
    const D = y.getConfig().options;
    D && (D.local.key = d);
  }
  e.on(x.projectLoad, ({ project: D }) => {
    t.appStore.setProjectDataCustom(D.custom), u.loadFonts();
  }), e.on(x.projectGet, ({ project: D }) => {
    D.custom = Ss(e);
  }), e.RichTextEditor.getConfig().custom = !0;
  const { Canvas: P } = e, _ = As(() => n.setCanvasPanning(!1), 200);
  e.on(P.events.coords, () => {
    n.setCanvasPanning(!0), _();
  }), e.on(P.events.frameLoad, ({ el: D }) => {
    D.tabIndex = -1;
  });
  const { Parser: O } = e, E = ((L = n.sdkOptions.parser) == null ? void 0 : L.showErrors) !== !1;
  (M = O.events) != null && M.css && E && e.on(O.events.css, (D) => {
    const { error: V } = D;
    if (V) {
      const k = Mt(V) ? V : V.name && V.reason ? `${V.name}: ${V.reason}` : V.message;
      o.addError("css-error", { header: "CSS Parser Error", content: k });
    }
  }), [
    // { id: `save`, keys: 'ctrl+s, ⌘+s', cmd: 'save-page' },
    // { id: `duplicate`, keys: 'ctrl+d, ⌘+d', cmd: 'tlb-clone' },
    // { id: `custom-component`, keys: 'ctrl+k, ⌘+k', cmd: 'open-custom-block' },
    { id: "toggle-lsidebar", keys: "alt+ctrl+,", cmd: g },
    { id: "toggle-lsidebar2", keys: "alt+⌘+,", cmd: g },
    { id: "toggle-rsidebar", keys: "alt+ctrl+., alt+⌘+.", cmd: m },
    { id: "show-blocks", keys: "ctrl+b, ⌘+b", cmd: h },
    { id: "add-symbol", keys: "alt+ctrl+k, alt+⌘+k", cmd: me.symbolAdd },
    { id: "detach-symbol", keys: "shift+alt+ctrl+k, shift+alt+⌘+k", cmd: me.symbolDetach }
  ].forEach(({ id: D, keys: V, cmd: k }) => {
    e.Keymaps.add(`preset:${D}`, V, k, { prevent: !0 });
  }), e.on(`${S.runCommand}core:preview`, () => {
    n.setPreview(!0), r.setOpen(!1), Ih(e, !1);
  }), e.on(`${S.stopCommand}core:preview`, () => {
    n.setPreview(!1), Ih(e, !0), setTimeout(() => {
      e.refresh();
    }, n.transitionTime);
  });
  const T = "target-selection", { Components: R } = e;
  w.add(gl, {
    opts: {},
    init() {
      this.beforeSelect = this.beforeSelect.bind(this);
    },
    onComponentHover(D, V) {
      const k = { id: T, type: "target", component: V };
      V ? P.addSpot(k) : P.removeSpots(k);
    },
    beforeSelect(D, V = {}) {
      V.abort = !0, V.useValid = !1, this.opts.onSelect(D), e.stopCommand(gl);
    },
    run(D, V, k) {
      this.opts = k, e.on("component:select:before", this.beforeSelect), e.on("change:componentHovered", this.onComponentHover);
    },
    stop() {
      e.off("component:select:before", this.beforeSelect), e.off("change:componentHovered", this.onComponentHover), P.removeSpots({ id: T }), n.setSelectingTarget(!1);
    }
  }), w.add(tb, () => {
    n.setSelectedDesignerTab("style");
  }), w.add(me.toastAdd, (D, V, k) => {
    o.add(k.id, k);
  }), w.add(me.dialogOpen, (D, V, k) => {
    s.open(k);
  }), w.add(me.dialogClose, () => {
    s.close();
  }), w.add(me.sidebarLeftGet, () => ({
    visible: n.isLeftSidebarOpen
  })), w.add(me.sidebarLeftSet, (D, V, k) => {
    n.setLeftSidebarOpen(!!k.visible);
  }), w.add(me.sidebarLeftToggle, () => {
    n.setLeftSidebarOpen(!n.isLeftSidebarOpen);
  }), w.add(me.sidebarRightGet, () => ({
    visible: n.isRightSidebarOpen
  })), w.add(me.sidebarRightSet, (D, V, k) => {
    n.setRightSidebarOpen(!!k.visible);
  }), w.add(me.sidebarRightToggle, () => {
    n.setRightSidebarOpen(!n.isRightSidebarOpen);
  }), w.add(me.sidebarTopGet, () => ({
    visible: n.isTopSidebarOpen
  })), w.add(me.sidebarTopSet, (D, V, k) => {
    n.setTopSidebarOpen(!!k.visible);
  }), w.add(me.sidebarTopToggle, () => {
    n.setTopSidebarOpen(!n.isTopSidebarOpen);
  }), w.add(me.sidebarBottomGet, () => ({
    visible: n.isBottomSidebarOpen
  })), w.add(me.sidebarBottomSet, (D, V, k) => {
    n.setBottomSidebarOpen(!!k.visible);
  }), w.add(me.sidebarBottomToggle, () => {
    n.setBottomSidebarOpen(!n.isBottomSidebarOpen);
  }), w.add(me.layoutAdd, (D, V, k) => {
    k.id && i.add(k.id, k);
  }), w.add(me.layoutRemove, (D, V, k) => {
    const { id: j, ...Y } = k;
    i.remove(j, Y);
  }), w.add(me.layoutToggle, (D, V, k) => {
    const { id: j, ...Y } = k;
    j && (i.get(j) ? i.remove(j, Y) : i.add(j, Y));
  }), w.add(me.layoutUpdate, (D, V, k) => {
    const j = k;
    e.runCommand(me.layoutRemove, {
      id: j.id,
      layout: { placer: { ...j.placer, skipCleanup: !0 } },
      force: !0
    }), setTimeout(() => e.runCommand(me.layoutAdd, { ...j }));
  }), w.add(me.layoutGet, (D, V, k) => [Fr(i.get(k.id))]), w.add(me.layoutConfigGet, () => Fr(i.customConfig)), w.add(me.layoutConfigSet, (D, V, k) => {
    const j = k;
    i.setCustomConfig(j);
  }), w.add(me.getStateTheme, () => n.publicStateTheme), w.add(me.setStateTheme, (D, V, k) => n.setPublicStateTheme(k)), w.add(me.getPagesConfig, () => n.sdkPagesConfig), w.add(me.setPagesConfig, (D, V, k) => {
    const { config: j } = k || {};
    Pr(j) && n.setSdkPagesConfig(j);
  }), w.add(me.getPageSettings, () => JSON.parse(JSON.stringify(n.panelPageSettings))), w.add(me.setPageSettings, (D, V, k) => {
    n.setPanelPageSettings(k);
  }), w.add(me.projectFiles, (D, V, k) => fl(D, { isMJML: n.isProjectTypeEmail, ...k })), w.add(me.getBlocksPanel, () => ({
    isOpen: r.isOpen
  })), w.add(me.setBlocksPanel, (D, V, k) => {
    const j = k || {};
    Pr(j.isOpen) && r.setOpen(j.isOpen);
  }), w.add(me.canvasReload, () => {
    const D = e.getSelected(), V = P.getCanvasView(), { frames: k } = P.canvas;
    k.once("loaded:all", () => {
      const j = D == null ? void 0 : D.getView();
      j && !j.isInViewport() && j.el.scrollIntoView({ block: "center" });
    }), V.renderFrames();
  }), w.add(me.contextMenuComponent, (D, V, k) => {
    const { component: j, ...Y } = k;
    a.showForComponent(j, Y);
  }), w.add(me.getStateContextMenu, () => a.publicState), w.add(me.setStateContextMenu, (D, V, k) => {
    a.setPublicState(k);
  }), w.add(me.symbolAdd, (D, V, k) => {
    const j = k.component || e.getSelected();
    if (j)
      return R.getSymbolInfo(j).isSymbol ? o.add("skip-symbol", {
        header: "The selected element is already a symbol",
        variant: Ht.Warning
      }) : R.addSymbol(j);
  }), w.add(me.symbolDetach, (D, V, k) => {
    const j = k.component || e.getSelected();
    j && R.getSymbolInfo(j).isRoot && R.detachSymbol(j);
  }), w.add(me.symbolOverride, (D, V, k) => {
    const j = k.component || e.getSelected();
    j && (j.setSymbolOverride(k.override), e.Layers.updateLayer(j));
  }), w.add(
    me.symbolPropagateStyles,
    (D, V, k) => {
      const j = k.component || e.getSelected();
      if (!j)
        return;
      const { Css: Y } = e, J = Y.getComponentRules(j, { current: !0 })[0];
      if (J) {
        const { state: le, mediaText: Q } = J.attributes, re = J.getStyle();
        R.getSymbolInfo(j).relatives.forEach((ge) => {
          Y.setIdRule(ge.getId(), re, { state: le, mediaText: Q });
        });
      }
      k.deep && j.components().forEach((le) => e.runCommand(me.symbolPropagateStyles, { ...k, component: le }));
    }
  ), w.add(me.assetProviderGet, () => Fr(l.allProviders)), w.add(
    me.assetProviderAdd,
    (D, V, { provider: k, index: j }) => {
      l.addProvider(k, j);
    }
  ), w.add(me.assetProviderRemove, (D, V, { id: k }) => {
    const j = l.allProviders.filter((Y) => Y.id !== k);
    l.setAllProviders(j);
  }), w.add(me.fontGet, () => Fr(u.fonts)), w.add(me.fontAdd, (D, V, { font: k }) => {
    u.addFont(k);
  }), w.add(me.fontRemove, (D, V, { family: k }) => {
    u.removeFont(k);
  }), RA(e), zA(e, t), $A(e, t), MA(e), LA(e), OA(e), kA(e, t);
}
const UA = /\s(?![^(]*\))/, Hh = /^-?[0-9]+[a-zA-Z%]{0,}$/;
function Bh(e) {
  const t = e.split(UA), n = t.indexOf("inset") >= 0, r = t.filter((d) => d !== "inset"), o = r.filter((d) => !Hh.test(d))[0] || "currentColor", s = r.filter((d) => Hh.test(d)), [i = "0", a = "0", l = "0", u = "0"] = s;
  return {
    x: i,
    y: a,
    blur: l,
    spread: u,
    inset: n,
    color: o
  };
}
function rc(e) {
  const t = e.indexOf("(") + 1, n = e.lastIndexOf(")");
  return {
    name: e.substring(0, t - 1).trim(),
    value: String.prototype.substring.apply(e, [t, n >= 0 ? n : void 0]).trim()
  };
}
const nb = Be(null), WA = ({ children: e }) => {
  const [t, n] = W({
    setEditor: (r) => {
      n((o) => ({ ...o, editor: r }));
    }
  });
  return /* @__PURE__ */ c(nb.Provider, { value: t, children: e });
}, _n = () => {
  const e = Le(nb);
  if (!e)
    throw new Error("useEditorInstance must be used within EditorInstanceProvider");
  return e;
}, Tn = () => {
  const { editor: e } = _n();
  if (!e)
    throw new Error(
      "useEditor used before the load of the editor instance. You can wrap your component in `<WithEditor>` or make use of `useEditorMaybe` hook and ensure the `editor` exists."
    );
  return e;
}, Hp = () => _n().editor, rb = Be(null), GA = ({ children: e }) => {
  const [t, n] = W(() => ({
    setRefCanvas(r) {
      n((o) => ({ ...o, refCanvas: r }));
    },
    setCustomModal(r) {
      n((o) => ({ ...o, customModal: r }));
    },
    setCustomAssets(r) {
      n((o) => ({ ...o, customAssets: r }));
    },
    setCustomBlocks(r) {
      n((o) => ({ ...o, customBlocks: r }));
    },
    setCustomRte(r) {
      n((o) => ({ ...o, customRte: r }));
    },
    setCustomStyles(r) {
      n((o) => ({ ...o, customStyles: r }));
    },
    setCustomLayers(r) {
      n((o) => ({ ...o, customLayers: r }));
    },
    setCustomSelectors(r) {
      n((o) => ({ ...o, customSelectors: r }));
    },
    setCustomTraits(r) {
      n((o) => ({ ...o, customTraits: r }));
    },
    setReady(r) {
      n((o) => ({ ...o, ready: r }));
    }
  }));
  return /* @__PURE__ */ c(rb.Provider, { value: t, children: e });
}, cr = () => {
  const e = Le(rb);
  if (!e)
    throw new Error("useEditorOptions must be used within EditorOptionsProvider");
  return e;
};
function KA(...e) {
  return (Array.isArray(e[0]) ? e[0] : [...e]).filter(Boolean).join(" ");
}
function ao(e) {
  return typeof e == "function";
}
function Dn() {
}
const ob = (e) => typeof e == "string", qA = async (e) => {
  const t = document.createElement("link");
  t.href = e, t.rel = "stylesheet", document.head.appendChild(t);
}, sb = (e) => {
  const t = ob(e) ? { id: e, src: e } : e;
  return new Promise((n, r) => {
    const o = document.createElement("script");
    if (document.querySelector(`script[src="${t.src}"]`))
      return n(t.id);
    o.src = t.src, o.onload = () => n(t.id), o.onerror = () => r(t.id), document.head.appendChild(o);
  });
}, YA = (e) => {
  const t = e.map((n) => sb(n));
  return Promise.allSettled(t);
}, zh = (e) => function() {
  const t = K(null);
  return G(() => {
    const { current: n } = t;
    n && (ob(e) ? n.innerHTML = e : n.appendChild(e));
  }, [t.current]), /* @__PURE__ */ c("div", { ref: t });
}, Fh = /* @__PURE__ */ new WeakMap();
function ks(e) {
  if (!e)
    return () => /* @__PURE__ */ c(ae, {});
  const t = Fh.get(e);
  if (t)
    return t;
  const n = function({ children: r }) {
    return jd(is("div", null, r), e);
  };
  return Fh.set(e, n), n;
}
const XA = we(function({ children: e }) {
  const { editor: t } = _n(), n = cr(), [r, o] = W(!1), [s, i] = W({
    assets: [],
    types: [],
    close: () => {
    },
    select: () => {
    },
    Container: () => /* @__PURE__ */ c(ae, {})
  });
  return G(() => {
    if (!t)
      return;
    const a = t.Assets.events.custom, l = ({ open: u, assets: d, types: p, select: f, close: h, container: g }) => {
      u && i({
        assets: d,
        types: p,
        select: f,
        close: h,
        Container: ks(g)
      }), o(u);
    };
    return t.on(a, l), () => {
      t.off(a, l);
    };
  }, [t]), G(() => n.setCustomAssets(!0), []), t ? ao(e) ? e({ open: r, ...s }) : /* @__PURE__ */ c(ae, {}) : /* @__PURE__ */ c(ae, {});
});
we(function({ children: e }) {
  const { editor: t } = _n(), n = cr(), [r, o] = W(() => ({
    blocks: [],
    dragStart: Dn,
    dragStop: Dn,
    mapCategoryBlocks: /* @__PURE__ */ new Map(),
    Container: () => /* @__PURE__ */ c(ae, {})
  }));
  return G(() => {
    if (!t)
      return;
    const s = t.Blocks.events.custom, i = ({ blocks: a, container: l, dragStart: u, dragStop: d }) => {
      const p = a.reduce((f, h) => {
        const g = h.getCategoryLabel(), m = f.get(g);
        return m ? m.push(h) : f.set(g, [h]), f;
      }, /* @__PURE__ */ new Map());
      o({
        blocks: a,
        dragStart: u,
        dragStop: d,
        mapCategoryBlocks: p,
        Container: ks(l)
      });
    };
    return t.on(s, i), t.Blocks.__trgCustom(), () => {
      t.off(s, i);
    };
  }, [t]), G(() => n.setCustomBlocks(!0), []), t ? ao(e) ? e(r) : /* @__PURE__ */ c(ae, {}) : /* @__PURE__ */ c(ae, {});
});
function ZA({ children: e, ...t }) {
  const n = cr(), r = K(null);
  return G(() => {
    r.current && n.setRefCanvas(r.current);
  }, [r.current]), /* @__PURE__ */ c("div", { ...t, ref: r, children: e });
}
const JA = we(function({ children: e }) {
  const { editor: t } = _n(), [n, r] = W(() => ({
    devices: [],
    selected: "",
    select: Dn
  }));
  return G(() => {
    if (!t)
      return;
    const { Devices: o } = t, s = o.events.all, i = () => {
      var a;
      r({
        devices: o.getDevices(),
        selected: (a = o.getSelected()) == null ? void 0 : a.id,
        select: (l) => o.select(l)
      });
    };
    return t.on(s, i), i(), () => {
      t.off(s, i);
    };
  }, [t]), t ? ao(e) ? e(n) : /* @__PURE__ */ c(ae, {}) : /* @__PURE__ */ c(ae, {});
}), QA = (e) => !!(e && !Array.isArray(e) && typeof e == "object");
async function e3(e) {
  const t = e.map(({ id: s, src: i }) => ({ id: s, src: i })), n = e.reduce(
    (s, i) => (s[i.id] = i, s),
    {}
  ), r = [], o = [];
  return (await YA(t)).forEach((s) => {
    s.status === "fulfilled" ? r.push(n[s.value]) : o.push(n[s.reason]);
  }), { loaded: r, failed: o };
}
const t3 = async (e) => {
  const t = [...e], n = {};
  if (t.length) {
    const r = {}, o = [];
    if (t.forEach((s, i) => {
      QA(s) && (r[s.id] = { index: i }, o.push(s));
    }), o.length) {
      const { loaded: s } = await e3(o);
      s.forEach(({ id: i, options: a }) => {
        r[i].loaded = !0, n[i] = a || {};
      });
    }
    Object.keys(r).forEach((s) => {
      const i = r[s];
      i.loaded ? t[i.index] = s : t[i.index] = !1;
    });
  }
  return {
    plugins: t.filter(Boolean),
    pluginOptions: n
  };
}, n3 = we(function({
  children: e,
  className: t,
  style: n,
  options: r = {},
  plugins: o = [],
  grapesjs: s,
  grapesjsCss: i,
  onEditor: a = Dn,
  onReady: l,
  onUpdate: u,
  waitReady: d,
  ...p
}) {
  const { setEditor: f } = _n(), h = cr(), [g, m] = W(!1), v = K(null);
  G(() => {
    if (!h.ready || !v.current)
      return;
    const P = v.current, _ = h.refCanvas;
    let O, E = {}, T = [];
    const R = (B) => {
      const U = {
        height: "100%",
        ...r,
        plugins: [...T, ...r.plugins || []],
        pluginsOpts: {
          ...r.pluginsOpts,
          ...E
        },
        modal: {
          custom: !!h.customModal,
          ...r.modal
        },
        assetManager: {
          custom: !!h.customAssets,
          ...r.assetManager
        },
        styleManager: {
          custom: !!h.customStyles,
          ...r.styleManager
        },
        blockManager: {
          custom: !!h.customBlocks,
          ...r.blockManager
        },
        richTextEditor: {
          custom: !!h.customRte,
          ...r.richTextEditor
        },
        layerManager: {
          custom: !!h.customLayers,
          ...r.layerManager
        },
        traitManager: {
          custom: !!h.customTraits,
          ...r.traitManager
        },
        selectorManager: {
          custom: !!h.customSelectors,
          ...r.selectorManager
        },
        container: _ || P,
        customUI: !!_,
        // Disables all default panels if Canvas is used
        ..._ ? {
          panels: { defaults: [] }
        } : {}
      };
      O = B.init(U), f(O), a(O), u && O.on("update", () => {
        u(O.getProjectData(), O);
      }), O.onReady(() => {
        m(!0), l == null || l(O);
      });
    };
    return (async () => {
      i && await qA(i);
      const B = await t3(o);
      T = B.plugins, E = B.pluginOptions, typeof s == "string" ? (await sb(s), R(window.grapesjs)) : R(s);
    })(), () => O == null ? void 0 : O.destroy();
  }, [h.ready]);
  const b = r.height ?? "100%", y = r.width ?? "100%", w = KA("gjs-editor-wrapper", t), S = d && !g, x = ie(
    () => ({
      ...n,
      height: b,
      width: y
    }),
    [b, y, n]
  ), C = ie(
    () => ({
      ...x,
      ...S ? {
        opacity: 0,
        width: 0,
        height: 0
      } : {}
    }),
    [x, S]
  );
  return /* @__PURE__ */ A(ae, { children: [
    d && !g ? /* @__PURE__ */ c("div", { className: w, style: x, children: d }) : null,
    /* @__PURE__ */ c("div", { ...p, ref: v, className: w, style: C, children: e })
  ] });
}), r3 = we(function() {
  const e = cr();
  return G(() => e.setReady(!0), []), /* @__PURE__ */ c(ae, {});
}), o3 = we(function({ children: e, ...t }) {
  return /* @__PURE__ */ c(WA, { children: /* @__PURE__ */ c(GA, { children: /* @__PURE__ */ A(n3, { ...t, children: [
    e,
    /* @__PURE__ */ c(r3, {})
  ] }) }) });
}), ib = we(function({ children: e }) {
  const { editor: t } = _n(), n = cr(), [r, o] = W(() => ({
    root: void 0,
    Container: () => /* @__PURE__ */ c(ae, {})
  }));
  return G(() => {
    if (!t)
      return;
    const { Layers: s } = t, i = s.events.custom, a = ({ container: l }) => {
      o({
        root: s.getRoot(),
        Container: ks(l)
      });
    };
    return t.on(i, a), s.__trgCustom({}), () => {
      t.off(i, a);
    };
  }, [t]), G(() => n.setCustomLayers(!0), []), t ? ao(e) ? e(r) : /* @__PURE__ */ c(ae, {}) : /* @__PURE__ */ c(ae, {});
}), s3 = we(function({ children: e }) {
  const { editor: t } = _n(), n = cr(), [r, o] = W(!1), [s, i] = W({
    title: /* @__PURE__ */ c(ae, {}),
    content: /* @__PURE__ */ c(ae, {}),
    attributes: {},
    close: Dn
  });
  return G(() => {
    if (!t)
      return;
    const a = "modal", l = ({ open: u, title: d, content: p, close: f, attributes: h }) => {
      u && i({
        title: is(zh(d)),
        content: is(zh(p)),
        attributes: h,
        close: f
      }), o(u);
    };
    return t.on(a, l), () => {
      t.off(a, l);
    };
  }, [t]), G(() => n.setCustomModal(!0), []), t ? typeof e == "function" ? e({ open: r, ...s }) : /* @__PURE__ */ c(ae, {}) : /* @__PURE__ */ c(ae, {});
}), ab = we(function({ children: e }) {
  const { editor: t } = _n(), [n, r] = W(() => ({
    pages: [],
    selected: void 0,
    select: Dn,
    add: Dn,
    remove: Dn
  }));
  return G(() => {
    if (!t)
      return;
    const { Pages: o } = t, s = o.events.all, i = () => {
      r({
        pages: o.getAll(),
        selected: o.getSelected(),
        select: (...a) => o.select(...a),
        add: (...a) => o.add(...a),
        remove: (...a) => o.remove(...a)
      });
    };
    return t.on(s, i), i(), () => {
      t.off(s, i);
    };
  }, [t]), t ? ao(e) ? e(n) : /* @__PURE__ */ c(ae, {}) : /* @__PURE__ */ c(ae, {});
}), lb = we(function({ children: e }) {
  const { editor: t } = _n(), n = cr(), [r, o] = W(() => ({
    selectors: [],
    states: [],
    selectedState: "",
    targets: [],
    addSelector: Dn,
    removeSelector: Dn,
    setState: Dn,
    Container: () => /* @__PURE__ */ c(ae, {})
  }));
  return G(() => {
    if (!t)
      return;
    const { Selectors: s } = t, i = s.events.custom, a = ({ container: l }) => {
      o({
        selectors: s.getSelected(),
        states: s.getStates(),
        selectedState: s.getState(),
        targets: s.getSelectedTargets().map((u) => u.getSelectorsString()),
        addSelector: (...u) => s.addSelected(...u),
        removeSelector: (...u) => s.removeSelected(...u),
        setState: (...u) => s.setState(...u),
        Container: ks(l)
      });
    };
    return t.on(i, a), () => {
      t.off(i, a);
    };
  }, [t]), G(() => n.setCustomSelectors(!0), []), t ? ao(e) ? e(r) : /* @__PURE__ */ c(ae, {}) : /* @__PURE__ */ c(ae, {});
}), cb = we(function({ children: e }) {
  const { editor: t } = _n(), n = cr(), [r, o] = W(() => ({
    sectors: [],
    Container: () => /* @__PURE__ */ c(ae, {})
  }));
  return G(() => {
    if (!t)
      return;
    const { Styles: s } = t, i = s.events.custom, a = ({ container: l }) => {
      o({
        sectors: s.getSectors({ visible: !0 }),
        Container: ks(l)
      });
    };
    return t.on(i, a), () => {
      t.off(i, a);
    };
  }, [t]), G(() => n.setCustomStyles(!0), []), t ? ao(e) ? e(r) : /* @__PURE__ */ c(ae, {}) : /* @__PURE__ */ c(ae, {});
}), hd = we(function({ children: e }) {
  const { editor: t } = _n(), n = cr(), [r, o] = W(() => ({
    traits: [],
    Container: () => /* @__PURE__ */ c(ae, {})
  }));
  return G(() => {
    if (!t)
      return;
    const { Traits: s } = t, i = s.events.custom, a = ({ container: l }) => {
      o({
        traits: s.getCurrent(),
        Container: ks(l)
      });
    };
    return t.on(i, a), s.__trgCustom(), () => {
      t.off(i, a);
    };
  }, [t]), G(() => n.setCustomTraits(!0), []), t ? ao(e) ? e(r) : /* @__PURE__ */ c(ae, {}) : /* @__PURE__ */ c(ae, {});
}), Mo = ({ children: e }) => Hp() ? /* @__PURE__ */ c(ae, { children: e }) : /* @__PURE__ */ c(ae, {}), Bp = "gs-cmp-accordion", gd = `${Bp}-handler`, Sa = `${gd}__content`, i3 = `${Bp}-content`;
function $o({
  className: e,
  classNameWrap: t,
  classNameContent: n,
  style: r,
  handler: o,
  handlerIcon: s,
  children: i,
  inverted: a,
  disabled: l,
  sticky: u,
  onChange: d,
  open: p
}) {
  return /* @__PURE__ */ c(Wc, { as: "div", defaultOpen: p, className: $(Bp, t, "relative"), children: ({ open: f }) => /* @__PURE__ */ A(ae, { children: [
    /* @__PURE__ */ c(
      Wc.Button,
      {
        as: l ? "div" : "button",
        disabled: l,
        style: r,
        onClick: (h) => d == null ? void 0 : d({ event: h, open: !f }),
        className: ({ open: h }) => q(
          gd,
          ct(e) ? e(h) : e,
          u && "gs-utl-sticky gs-utl-top-0 gs-utl-z-10",
          "gs-utl-w-full"
        ),
        children: ({ open: h }) => /* @__PURE__ */ A(I, { items: "center", className: $("gap-2"), full: !0, children: [
          /* @__PURE__ */ c(N, { className: $(Sa, "text-left"), grow: !0, children: ct(o) ? o(h) : /* @__PURE__ */ A(I, { items: "center", className: $(`${Sa}-wrp`, "gap-3"), nowrap: !0, children: [
            !!s && /* @__PURE__ */ c(oe, { className: $(`${Sa}-icon`), icon: s, size: pe.s2x }),
            /* @__PURE__ */ c(N, { className: $(`${Sa}-label gs-utl-w-full`), children: o })
          ] }) }),
          /* @__PURE__ */ c(N, { className: $(`${gd}-toggle`, a && "-order-1", l && "gs-utl-hidden"), children: /* @__PURE__ */ c(
            oe,
            {
              icon: ne.chevronDown,
              className: $("w-5 h-5 transition-transform", h && "rotate-180")
            }
          ) })
        ] })
      }
    ),
    /* @__PURE__ */ c(Wc.Panel, { className: $(i3, n), children: i })
  ] }) });
}
function he({
  label: e,
  property: t,
  hasValue: n,
  empty: r,
  onClear: o,
  children: s,
  shallow: i,
  row: a,
  tooltip: l,
  className: u,
  ...d
}) {
  const p = e || (t == null ? void 0 : t.getLabel()), f = t == null ? void 0 : t.getParentTarget(), h = n || !r && (t == null ? void 0 : t.hasValue({ noParent: !0 })), g = !h && (t == null ? void 0 : t.hasValue()) && f, m = f == null ? void 0 : f.getDevice(), v = f == null ? void 0 : f.getState(), b = f == null ? void 0 : f.getComponent(), y = () => o ? o() : t == null ? void 0 : t.clear(), w = {
    className: $(u, "text-sm w-full"),
    col: !a,
    items: a ? "center" : void 0,
    ...d
  };
  return t && !t.isVisible() ? null : /* @__PURE__ */ c(ae, { children: /* @__PURE__ */ A(I, { ...w, children: [
    /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ A(
      I,
      {
        as: "label",
        items: "center",
        space: "xs",
        className: $("block", !a && "gjs-mb-1", h && !i && z.tAo),
        children: [
          l && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(yt, { title: l, children: /* @__PURE__ */ c(oe, { icon: ne.information, size: pe.sx }) }) }),
          /* @__PURE__ */ c(N, { children: r ? /* @__PURE__ */ c("span", { children: " " }) : p }),
          !!g && !i && /* @__PURE__ */ c(
            yt,
            {
              title: /* @__PURE__ */ A(ae, { children: [
                /* @__PURE__ */ c("div", { className: $("gjs-mb-1"), children: "Value inherited from" }),
                !!m && /* @__PURE__ */ A(I, { space: "s", children: [
                  /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(oe, { icon: ne.cellphoneLink, size: pe.sx }) }),
                  /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c("b", { children: m.getName() }) })
                ] }),
                /* @__PURE__ */ A(I, { space: "s", children: [
                  /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(oe, { icon: b ? ne.targetVariant : ne.tag, size: pe.sx }) }),
                  /* @__PURE__ */ A(N, { children: [
                    /* @__PURE__ */ c("b", { children: b ? "Components" : "Selectors" }),
                    /* @__PURE__ */ A("span", { className: $("text-xs opacity-75"), children: [
                      " ",
                      f == null ? void 0 : f.selectorsToString({ skipState: 1 })
                    ] })
                  ] })
                ] }),
                !!v && /* @__PURE__ */ A(I, { space: "s", children: [
                  /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(oe, { icon: ne.flare, size: pe.sx }) }),
                  /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c("b", { children: v.getLabel() }) })
                ] })
              ] }),
              children: /* @__PURE__ */ c("div", { className: $("gs-utl-w-[6px] gs-utl-h-[6px] gjs-rounded-full", z.bgW) })
            }
          ),
          h && !i && /* @__PURE__ */ c(yt, { title: "Clear value", onClick: y, children: /* @__PURE__ */ c(oe, { className: $(Qe.click), icon: ne.close, size: pe.s2x }) })
        ]
      }
    ) }),
    /* @__PURE__ */ c(N, { grow: !0, className: $("max-w-full"), children: s })
  ] }) });
}
function Bt({
  className: e,
  options: t,
  label: n,
  name: r,
  value: o,
  size: s = "m",
  required: i,
  disabled: a,
  style: l,
  onChange: u
}) {
  const d = (f) => {
    const h = t.filter((g) => g.id === f)[0];
    return t.indexOf(h) === t.length - 1;
  }, p = (f, h) => $(
    "cursor-pointer",
    s === "m" && Re.xy,
    s === "s" && "gs-utl-px-2 gs-utl-py-1 text-sm",
    s === "xs" && "gs-utl-p-1 text-sm",
    z.br,
    f && z.bgO,
    !d(h) && se.br
  );
  return /* @__PURE__ */ A(
    Jf,
    {
      value: o,
      onChange: u,
      className: $("gs-field-buttons w-full"),
      disabled: a,
      style: l,
      children: [
        !!n && /* @__PURE__ */ c($t, { size: s, children: n }),
        r && /* @__PURE__ */ c("input", { type: "hidden", name: r, value: o, required: i }),
        /* @__PURE__ */ c(I, { className: $(e, se.b, se.rnd, z.br, "cursor-pointer"), items: "center", full: !0, nowrap: !0, children: t.map(({ id: f, label: h, title: g, icon: m }) => /* @__PURE__ */ c(yt, { title: g, className: $("w-full"), classNameWrp: $("flex-1"), children: /* @__PURE__ */ c(Jf.Option, { value: f, className: ({ checked: v }) => p(v, f), children: /* @__PURE__ */ A(I, { justify: "center", space: "s", full: !0, children: [
          !!m && /* @__PURE__ */ c(oe, { icon: m, size: pe.s }),
          h && /* @__PURE__ */ c(N, { children: h })
        ] }) }) }, f)) })
      ]
    }
  );
}
var a3 = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, pr = function(e) {
  return typeof e == "string" ? e.length > 0 : typeof e == "number";
}, _t = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Math.pow(10, t)), Math.round(n * e) / n + 0;
}, wn = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 1), e > n ? n : e > t ? e : t;
}, ub = function(e) {
  return (e = isFinite(e) ? e % 360 : 0) > 0 ? e : e + 360;
}, Uh = function(e) {
  return { r: wn(e.r, 0, 255), g: wn(e.g, 0, 255), b: wn(e.b, 0, 255), a: wn(e.a) };
}, su = function(e) {
  return { r: _t(e.r), g: _t(e.g), b: _t(e.b), a: _t(e.a, 3) };
}, l3 = /^#([0-9a-f]{3,8})$/i, xa = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, db = function(e) {
  var t = e.r, n = e.g, r = e.b, o = e.a, s = Math.max(t, n, r), i = s - Math.min(t, n, r), a = i ? s === t ? (n - r) / i : s === n ? 2 + (r - t) / i : 4 + (t - n) / i : 0;
  return { h: 60 * (a < 0 ? a + 6 : a), s: s ? i / s * 100 : 0, v: s / 255 * 100, a: o };
}, pb = function(e) {
  var t = e.h, n = e.s, r = e.v, o = e.a;
  t = t / 360 * 6, n /= 100, r /= 100;
  var s = Math.floor(t), i = r * (1 - n), a = r * (1 - (t - s) * n), l = r * (1 - (1 - t + s) * n), u = s % 6;
  return { r: 255 * [r, a, i, i, l, r][u], g: 255 * [l, r, r, a, i, i][u], b: 255 * [i, i, l, r, r, a][u], a: o };
}, Wh = function(e) {
  return { h: ub(e.h), s: wn(e.s, 0, 100), l: wn(e.l, 0, 100), a: wn(e.a) };
}, Gh = function(e) {
  return { h: _t(e.h), s: _t(e.s), l: _t(e.l), a: _t(e.a, 3) };
}, Kh = function(e) {
  return pb((n = (t = e).s, { h: t.h, s: (n *= ((r = t.l) < 50 ? r : 100 - r) / 100) > 0 ? 2 * n / (r + n) * 100 : 0, v: r + n, a: t.a }));
  var t, n, r;
}, li = function(e) {
  return { h: (t = db(e)).h, s: (o = (200 - (n = t.s)) * (r = t.v) / 100) > 0 && o < 200 ? n * r / 100 / (o <= 100 ? o : 200 - o) * 100 : 0, l: o / 2, a: t.a };
  var t, n, r, o;
}, c3 = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, u3 = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, d3 = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, p3 = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, md = { string: [[function(e) {
  var t = l3.exec(e);
  return t ? (e = t[1]).length <= 4 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? _t(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : e.length === 6 || e.length === 8 ? { r: parseInt(e.substr(0, 2), 16), g: parseInt(e.substr(2, 2), 16), b: parseInt(e.substr(4, 2), 16), a: e.length === 8 ? _t(parseInt(e.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(e) {
  var t = d3.exec(e) || p3.exec(e);
  return t ? t[2] !== t[4] || t[4] !== t[6] ? null : Uh({ r: Number(t[1]) / (t[2] ? 100 / 255 : 1), g: Number(t[3]) / (t[4] ? 100 / 255 : 1), b: Number(t[5]) / (t[6] ? 100 / 255 : 1), a: t[7] === void 0 ? 1 : Number(t[7]) / (t[8] ? 100 : 1) }) : null;
}, "rgb"], [function(e) {
  var t = c3.exec(e) || u3.exec(e);
  if (!t)
    return null;
  var n, r, o = Wh({ h: (n = t[1], r = t[2], r === void 0 && (r = "deg"), Number(n) * (a3[r] || 1)), s: Number(t[3]), l: Number(t[4]), a: t[5] === void 0 ? 1 : Number(t[5]) / (t[6] ? 100 : 1) });
  return Kh(o);
}, "hsl"]], object: [[function(e) {
  var t = e.r, n = e.g, r = e.b, o = e.a, s = o === void 0 ? 1 : o;
  return pr(t) && pr(n) && pr(r) ? Uh({ r: Number(t), g: Number(n), b: Number(r), a: Number(s) }) : null;
}, "rgb"], [function(e) {
  var t = e.h, n = e.s, r = e.l, o = e.a, s = o === void 0 ? 1 : o;
  if (!pr(t) || !pr(n) || !pr(r))
    return null;
  var i = Wh({ h: Number(t), s: Number(n), l: Number(r), a: Number(s) });
  return Kh(i);
}, "hsl"], [function(e) {
  var t = e.h, n = e.s, r = e.v, o = e.a, s = o === void 0 ? 1 : o;
  if (!pr(t) || !pr(n) || !pr(r))
    return null;
  var i = function(a) {
    return { h: ub(a.h), s: wn(a.s, 0, 100), v: wn(a.v, 0, 100), a: wn(a.a) };
  }({ h: Number(t), s: Number(n), v: Number(r), a: Number(s) });
  return pb(i);
}, "hsv"]] }, qh = function(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n][0](e);
    if (r)
      return [r, t[n][1]];
  }
  return [null, void 0];
}, f3 = function(e) {
  return typeof e == "string" ? qh(e.trim(), md.string) : typeof e == "object" && e !== null ? qh(e, md.object) : [null, void 0];
}, iu = function(e, t) {
  var n = li(e);
  return { h: n.h, s: wn(n.s + 100 * t, 0, 100), l: n.l, a: n.a };
}, au = function(e) {
  return (299 * e.r + 587 * e.g + 114 * e.b) / 1e3 / 255;
}, Yh = function(e, t) {
  var n = li(e);
  return { h: n.h, s: n.s, l: wn(n.l + 100 * t, 0, 100), a: n.a };
}, vd = function() {
  function e(t) {
    this.parsed = f3(t)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return e.prototype.isValid = function() {
    return this.parsed !== null;
  }, e.prototype.brightness = function() {
    return _t(au(this.rgba), 2);
  }, e.prototype.isDark = function() {
    return au(this.rgba) < 0.5;
  }, e.prototype.isLight = function() {
    return au(this.rgba) >= 0.5;
  }, e.prototype.toHex = function() {
    return t = su(this.rgba), n = t.r, r = t.g, o = t.b, i = (s = t.a) < 1 ? xa(_t(255 * s)) : "", "#" + xa(n) + xa(r) + xa(o) + i;
    var t, n, r, o, s, i;
  }, e.prototype.toRgb = function() {
    return su(this.rgba);
  }, e.prototype.toRgbString = function() {
    return t = su(this.rgba), n = t.r, r = t.g, o = t.b, (s = t.a) < 1 ? "rgba(" + n + ", " + r + ", " + o + ", " + s + ")" : "rgb(" + n + ", " + r + ", " + o + ")";
    var t, n, r, o, s;
  }, e.prototype.toHsl = function() {
    return Gh(li(this.rgba));
  }, e.prototype.toHslString = function() {
    return t = Gh(li(this.rgba)), n = t.h, r = t.s, o = t.l, (s = t.a) < 1 ? "hsla(" + n + ", " + r + "%, " + o + "%, " + s + ")" : "hsl(" + n + ", " + r + "%, " + o + "%)";
    var t, n, r, o, s;
  }, e.prototype.toHsv = function() {
    return t = db(this.rgba), { h: _t(t.h), s: _t(t.s), v: _t(t.v), a: _t(t.a, 3) };
    var t;
  }, e.prototype.invert = function() {
    return Wn({ r: 255 - (t = this.rgba).r, g: 255 - t.g, b: 255 - t.b, a: t.a });
    var t;
  }, e.prototype.saturate = function(t) {
    return t === void 0 && (t = 0.1), Wn(iu(this.rgba, t));
  }, e.prototype.desaturate = function(t) {
    return t === void 0 && (t = 0.1), Wn(iu(this.rgba, -t));
  }, e.prototype.grayscale = function() {
    return Wn(iu(this.rgba, -1));
  }, e.prototype.lighten = function(t) {
    return t === void 0 && (t = 0.1), Wn(Yh(this.rgba, t));
  }, e.prototype.darken = function(t) {
    return t === void 0 && (t = 0.1), Wn(Yh(this.rgba, -t));
  }, e.prototype.rotate = function(t) {
    return t === void 0 && (t = 15), this.hue(this.hue() + t);
  }, e.prototype.alpha = function(t) {
    return typeof t == "number" ? Wn({ r: (n = this.rgba).r, g: n.g, b: n.b, a: t }) : _t(this.rgba.a, 3);
    var n;
  }, e.prototype.hue = function(t) {
    var n = li(this.rgba);
    return typeof t == "number" ? Wn({ h: t, s: n.s, l: n.l, a: n.a }) : _t(n.h);
  }, e.prototype.isEqual = function(t) {
    return this.toHex() === Wn(t).toHex();
  }, e;
}(), Wn = function(e) {
  return e instanceof vd ? e : new vd(e);
}, Xh = [], h3 = function(e) {
  e.forEach(function(t) {
    Xh.indexOf(t) < 0 && (t(vd, md), Xh.push(t));
  });
};
function g3(e, t) {
  var n = { white: "#ffffff", bisque: "#ffe4c4", blue: "#0000ff", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", antiquewhite: "#faebd7", aqua: "#00ffff", azure: "#f0ffff", whitesmoke: "#f5f5f5", papayawhip: "#ffefd5", plum: "#dda0dd", blanchedalmond: "#ffebcd", black: "#000000", gold: "#ffd700", goldenrod: "#daa520", gainsboro: "#dcdcdc", cornsilk: "#fff8dc", cornflowerblue: "#6495ed", burlywood: "#deb887", aquamarine: "#7fffd4", beige: "#f5f5dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkkhaki: "#bdb76b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", peachpuff: "#ffdab9", darkmagenta: "#8b008b", darkred: "#8b0000", darkorchid: "#9932cc", darkorange: "#ff8c00", darkslateblue: "#483d8b", gray: "#808080", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", deeppink: "#ff1493", deepskyblue: "#00bfff", wheat: "#f5deb3", firebrick: "#b22222", floralwhite: "#fffaf0", ghostwhite: "#f8f8ff", darkviolet: "#9400d3", magenta: "#ff00ff", green: "#008000", dodgerblue: "#1e90ff", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", blueviolet: "#8a2be2", forestgreen: "#228b22", lawngreen: "#7cfc00", indianred: "#cd5c5c", indigo: "#4b0082", fuchsia: "#ff00ff", brown: "#a52a2a", maroon: "#800000", mediumblue: "#0000cd", lightcoral: "#f08080", darkturquoise: "#00ced1", lightcyan: "#e0ffff", ivory: "#fffff0", lightyellow: "#ffffe0", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", linen: "#faf0e6", mediumaquamarine: "#66cdaa", lemonchiffon: "#fffacd", lime: "#00ff00", khaki: "#f0e68c", mediumseagreen: "#3cb371", limegreen: "#32cd32", mediumspringgreen: "#00fa9a", lightskyblue: "#87cefa", lightblue: "#add8e6", midnightblue: "#191970", lightpink: "#ffb6c1", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", mintcream: "#f5fffa", lightslategray: "#778899", lightslategrey: "#778899", navajowhite: "#ffdead", navy: "#000080", mediumvioletred: "#c71585", powderblue: "#b0e0e6", palegoldenrod: "#eee8aa", oldlace: "#fdf5e6", paleturquoise: "#afeeee", mediumturquoise: "#48d1cc", mediumorchid: "#ba55d3", rebeccapurple: "#663399", lightsteelblue: "#b0c4de", mediumslateblue: "#7b68ee", thistle: "#d8bfd8", tan: "#d2b48c", orchid: "#da70d6", mediumpurple: "#9370db", purple: "#800080", pink: "#ffc0cb", skyblue: "#87ceeb", springgreen: "#00ff7f", palegreen: "#98fb98", red: "#ff0000", yellow: "#ffff00", slateblue: "#6a5acd", lavenderblush: "#fff0f5", peru: "#cd853f", palevioletred: "#db7093", violet: "#ee82ee", teal: "#008080", slategray: "#708090", slategrey: "#708090", aliceblue: "#f0f8ff", darkseagreen: "#8fbc8f", darkolivegreen: "#556b2f", greenyellow: "#adff2f", seagreen: "#2e8b57", seashell: "#fff5ee", tomato: "#ff6347", silver: "#c0c0c0", sienna: "#a0522d", lavender: "#e6e6fa", lightgreen: "#90ee90", orange: "#ffa500", orangered: "#ff4500", steelblue: "#4682b4", royalblue: "#4169e1", turquoise: "#40e0d0", yellowgreen: "#9acd32", salmon: "#fa8072", saddlebrown: "#8b4513", sandybrown: "#f4a460", rosybrown: "#bc8f8f", darksalmon: "#e9967a", lightgoldenrodyellow: "#fafad2", snow: "#fffafa", lightgrey: "#d3d3d3", lightgray: "#d3d3d3", dimgray: "#696969", dimgrey: "#696969", olivedrab: "#6b8e23", olive: "#808000" }, r = {};
  for (var o in n)
    r[n[o]] = o;
  var s = {};
  e.prototype.toName = function(i) {
    if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b))
      return "transparent";
    var a, l, u = r[this.toHex()];
    if (u)
      return u;
    if (i != null && i.closest) {
      var d = this.toRgb(), p = 1 / 0, f = "black";
      if (!s.length)
        for (var h in n)
          s[h] = new e(n[h]).toRgb();
      for (var g in n) {
        var m = (a = d, l = s[g], Math.pow(a.r - l.r, 2) + Math.pow(a.g - l.g, 2) + Math.pow(a.b - l.b, 2));
        m < p && (p = m, f = g);
      }
      return f;
    }
  }, t.string.push([function(i) {
    var a = i.toLowerCase(), l = a === "transparent" ? "#0000" : n[a];
    return l ? new e(l).toRgb() : null;
  }, "name"]);
}
function oc() {
  return (oc = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function fb(e, t) {
  if (e == null)
    return {};
  var n, r, o = {}, s = Object.keys(e);
  for (r = 0; r < s.length; r++)
    t.indexOf(n = s[r]) >= 0 || (o[n] = e[n]);
  return o;
}
function bd(e) {
  var t = K(e), n = K(function(r) {
    t.current && t.current(r);
  });
  return t.current = e, n.current;
}
var xs = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 1), e > n ? n : e < t ? t : e;
}, ci = function(e) {
  return "touches" in e;
}, yd = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, Zh = function(e, t, n) {
  var r = e.getBoundingClientRect(), o = ci(t) ? function(s, i) {
    for (var a = 0; a < s.length; a++)
      if (s[a].identifier === i)
        return s[a];
    return s[0];
  }(t.touches, n) : t;
  return { left: xs((o.pageX - (r.left + yd(e).pageXOffset)) / r.width), top: xs((o.pageY - (r.top + yd(e).pageYOffset)) / r.height) };
}, Jh = function(e) {
  !ci(e) && e.preventDefault();
}, zp = H.memo(function(e) {
  var t = e.onMove, n = e.onKey, r = fb(e, ["onMove", "onKey"]), o = K(null), s = bd(t), i = bd(n), a = K(null), l = K(!1), u = ie(function() {
    var h = function(v) {
      Jh(v), (ci(v) ? v.touches.length > 0 : v.buttons > 0) && o.current ? s(Zh(o.current, v, a.current)) : m(!1);
    }, g = function() {
      return m(!1);
    };
    function m(v) {
      var b = l.current, y = yd(o.current), w = v ? y.addEventListener : y.removeEventListener;
      w(b ? "touchmove" : "mousemove", h), w(b ? "touchend" : "mouseup", g);
    }
    return [function(v) {
      var b = v.nativeEvent, y = o.current;
      if (y && (Jh(b), !function(S, x) {
        return x && !ci(S);
      }(b, l.current) && y)) {
        if (ci(b)) {
          l.current = !0;
          var w = b.changedTouches || [];
          w.length && (a.current = w[0].identifier);
        }
        y.focus(), s(Zh(y, b, a.current)), m(!0);
      }
    }, function(v) {
      var b = v.which || v.keyCode;
      b < 37 || b > 40 || (v.preventDefault(), i({ left: b === 39 ? 0.05 : b === 37 ? -0.05 : 0, top: b === 40 ? 0.05 : b === 38 ? -0.05 : 0 }));
    }, m];
  }, [i, s]), d = u[0], p = u[1], f = u[2];
  return G(function() {
    return f;
  }, [f]), H.createElement("div", oc({}, r, { onTouchStart: d, onMouseDown: d, className: "react-colorful__interactive", ref: o, onKeyDown: p, tabIndex: 0, role: "slider" }));
}), sc = function(e) {
  return e.filter(Boolean).join(" ");
}, Fp = function(e) {
  var t = e.color, n = e.left, r = e.top, o = r === void 0 ? 0.5 : r, s = sc(["react-colorful__pointer", e.className]);
  return H.createElement("div", { className: s, style: { top: 100 * o + "%", left: 100 * n + "%" } }, H.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, zt = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Math.pow(10, t)), Math.round(n * e) / n;
}, hb = function(e) {
  var t = e.s, n = e.v, r = e.a, o = (200 - t) * n / 100;
  return { h: zt(e.h), s: zt(o > 0 && o < 200 ? t * n / 100 / (o <= 100 ? o : 200 - o) * 100 : 0), l: zt(o / 2), a: zt(r, 2) };
}, wd = function(e) {
  var t = hb(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, lu = function(e) {
  var t = hb(e);
  return "hsla(" + t.h + ", " + t.s + "%, " + t.l + "%, " + t.a + ")";
}, m3 = function(e) {
  var t = e.h, n = e.s, r = e.v, o = e.a;
  t = t / 360 * 6, n /= 100, r /= 100;
  var s = Math.floor(t), i = r * (1 - n), a = r * (1 - (t - s) * n), l = r * (1 - (1 - t + s) * n), u = s % 6;
  return { r: zt(255 * [r, a, i, i, l, r][u]), g: zt(255 * [l, r, r, a, i, i][u]), b: zt(255 * [i, i, l, r, r, a][u]), a: zt(o, 2) };
}, v3 = function(e) {
  var t = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
  return t ? b3({ r: Number(t[1]) / (t[2] ? 100 / 255 : 1), g: Number(t[3]) / (t[4] ? 100 / 255 : 1), b: Number(t[5]) / (t[6] ? 100 / 255 : 1), a: t[7] === void 0 ? 1 : Number(t[7]) / (t[8] ? 100 : 1) }) : { h: 0, s: 0, v: 0, a: 1 };
}, b3 = function(e) {
  var t = e.r, n = e.g, r = e.b, o = e.a, s = Math.max(t, n, r), i = s - Math.min(t, n, r), a = i ? s === t ? (n - r) / i : s === n ? 2 + (r - t) / i : 4 + (t - n) / i : 0;
  return { h: zt(60 * (a < 0 ? a + 6 : a)), s: zt(s ? i / s * 100 : 0), v: zt(s / 255 * 100), a: o };
}, y3 = H.memo(function(e) {
  var t = e.hue, n = e.onChange, r = sc(["react-colorful__hue", e.className]);
  return H.createElement("div", { className: r }, H.createElement(zp, { onMove: function(o) {
    n({ h: 360 * o.left });
  }, onKey: function(o) {
    n({ h: xs(t + 360 * o.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": zt(t), "aria-valuemax": "360", "aria-valuemin": "0" }, H.createElement(Fp, { className: "react-colorful__hue-pointer", left: t / 360, color: wd({ h: t, s: 100, v: 100, a: 1 }) })));
}), w3 = H.memo(function(e) {
  var t = e.hsva, n = e.onChange, r = { backgroundColor: wd({ h: t.h, s: 100, v: 100, a: 1 }) };
  return H.createElement("div", { className: "react-colorful__saturation", style: r }, H.createElement(zp, { onMove: function(o) {
    n({ s: 100 * o.left, v: 100 - 100 * o.top });
  }, onKey: function(o) {
    n({ s: xs(t.s + 100 * o.left, 0, 100), v: xs(t.v - 100 * o.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + zt(t.s) + "%, Brightness " + zt(t.v) + "%" }, H.createElement(Fp, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: wd(t) })));
}), S3 = function(e, t) {
  if (e === t)
    return !0;
  for (var n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}, x3 = function(e, t) {
  return e.replace(/\s/g, "") === t.replace(/\s/g, "");
};
function C3(e, t, n) {
  var r = bd(n), o = W(function() {
    return e.toHsva(t);
  }), s = o[0], i = o[1], a = K({ color: t, hsva: s });
  G(function() {
    if (!e.equal(t, a.current.color)) {
      var u = e.toHsva(t);
      a.current = { hsva: u, color: t }, i(u);
    }
  }, [t, e]), G(function() {
    var u;
    S3(s, a.current.hsva) || e.equal(u = e.fromHsva(s), a.current.color) || (a.current = { hsva: s, color: u }, r(u));
  }, [s, e, r]);
  var l = it(function(u) {
    i(function(d) {
      return Object.assign({}, d, u);
    });
  }, []);
  return [s, l];
}
var P3 = typeof window < "u" ? kl : G, E3 = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, Qh = /* @__PURE__ */ new Map(), O3 = function(e) {
  P3(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !Qh.has(t)) {
      var n = t.createElement("style");
      n.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, Qh.set(t, n);
      var r = E3();
      r && n.setAttribute("nonce", r), t.head.appendChild(n);
    }
  }, []);
}, _3 = function(e) {
  var t = e.className, n = e.hsva, r = e.onChange, o = { backgroundImage: "linear-gradient(90deg, " + lu(Object.assign({}, n, { a: 0 })) + ", " + lu(Object.assign({}, n, { a: 1 })) + ")" }, s = sc(["react-colorful__alpha", t]), i = zt(100 * n.a);
  return H.createElement("div", { className: s }, H.createElement("div", { className: "react-colorful__alpha-gradient", style: o }), H.createElement(zp, { onMove: function(a) {
    r({ a: a.left });
  }, onKey: function(a) {
    r({ a: xs(n.a + a.left) });
  }, "aria-label": "Alpha", "aria-valuetext": i + "%", "aria-valuenow": i, "aria-valuemin": "0", "aria-valuemax": "100" }, H.createElement(Fp, { className: "react-colorful__alpha-pointer", left: n.a, color: lu(n) })));
}, T3 = function(e) {
  var t = e.className, n = e.colorModel, r = e.color, o = r === void 0 ? n.defaultColor : r, s = e.onChange, i = fb(e, ["className", "colorModel", "color", "onChange"]), a = K(null);
  O3(a);
  var l = C3(n, o, s), u = l[0], d = l[1], p = sc(["react-colorful", t]);
  return H.createElement("div", oc({}, i, { ref: a, className: p }), H.createElement(w3, { hsva: u, onChange: d }), H.createElement(y3, { hue: u.h, onChange: d }), H.createElement(_3, { hsva: u, onChange: d, className: "react-colorful__last-control" }));
}, A3 = { defaultColor: "rgba(0, 0, 0, 1)", toHsva: v3, fromHsva: function(e) {
  var t = m3(e);
  return "rgba(" + t.r + ", " + t.g + ", " + t.b + ", " + t.a + ")";
}, equal: x3 }, L3 = function(e) {
  return H.createElement(T3, oc({}, e, { colorModel: A3 }));
}, ic = /* @__PURE__ */ ((e) => (e.m = "m", e.s = "s", e))(ic || {});
const eg = (e) => Ji(e) ? e : "", Up = (e = {}) => $("w-full placeholder:italic", z.bgTr, Eo.inputText, e.disabled && z.txtLowEmphasis), k3 = "gs-input-field", ft = Rt(function(t, n) {
  const {
    className: r,
    value: o,
    label: s,
    size: i = "m",
    type: a,
    placeholder: l,
    required: u,
    disabled: d,
    readOnly: p,
    description: f,
    name: h,
    style: g,
    tip: m,
    onInput: v,
    onChange: b,
    onBlur: y
  } = t, [w, S] = W(eg(o)), x = Up(t), C = K(null);
  Ml(n, () => C.current, []), G(() => {
    S(eg(o));
  }, [o]);
  const P = (T, R) => {
    b == null || b(T, R);
  }, _ = (T) => {
    const { key: R } = T;
    switch (R) {
      case "Escape":
        return S(o);
      case "Enter":
        return P(w);
    }
  }, O = () => {
    P(w), y == null || y();
  }, E = (T) => {
    const R = T.target.value;
    S(R), v == null || v(R);
  };
  return /* @__PURE__ */ A("div", { className: $(k3, r), style: g, ref: C, children: [
    !!s && /* @__PURE__ */ c($t, { size: i, children: s }),
    !!f && /* @__PURE__ */ c($t, { size: i, tip: m, as: "span", className: $(z.txtLowEmphasis), capitalize: !1, children: f }),
    /* @__PURE__ */ c(
      I,
      {
        className: $(z.bg, se.b, se.rnd, z.br, i === "m" && Re.xy, i === "s" && "gjs-px-3 gjs-py-1"),
        items: "center",
        space: "x2s",
        children: /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(
          "input",
          {
            className: x,
            name: h,
            value: w,
            onChange: E,
            placeholder: l,
            required: u,
            onBlur: O,
            onKeyDown: _,
            readOnly: p,
            disabled: d,
            type: a
          }
        ) })
      }
    )
  ] });
});
h3([g3]);
const M3 = "gs-cmp-color-picker", $3 = { backgroundSize: "10px" }, R3 = [0, 15], N3 = (e) => e.startsWith("rgba") ? e : Wn(e).toRgbString();
function gb({ className: e, value: t, onChange: n }) {
  const r = N3(t || ""), [o, s] = W(!1), i = lr() && !!window.EyeDropper, a = q(
    `${M3}-handler gs-utl-bg-checker gs-utl-overflow-hidden gs-utl-cursor-pointer`,
    e,
    se.b,
    se.rnd,
    z.br
  ), l = (h) => {
    n == null || n(h, !0);
  }, u = () => {
    i && new window.EyeDropper().open().then((g) => l(g.sRGBHex));
  }, d = () => {
    s(!0);
  }, p = () => {
    n == null || n(r, !1), s(!1);
  }, f = /* @__PURE__ */ A("div", { style: $3, className: a, children: [
    o && /* @__PURE__ */ c(
      "div",
      {
        onPointerUp: p,
        className: q("gs-utl-fixed gs-utl-inset-0 gs-utl-z-50 gs-utl-cursor-grabbing")
      }
    ),
    /* @__PURE__ */ c("div", { className: q("gs-utl-w-4 gs-utl-h-4"), style: { backgroundColor: t } })
  ] });
  return /* @__PURE__ */ A(Rr, { handler: f, title: "Color", size: "s", placement: "left-end", offset: R3, clickAway: !0, children: [
    /* @__PURE__ */ c(
      L3,
      {
        className: "color-picker",
        color: r,
        onChange: l,
        onPointerDown: d,
        onPointerUp: p
      }
    ),
    /* @__PURE__ */ A(I, { className: q("gs-utl-mt-3"), space: "s", children: [
      /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(ft, { size: "s", value: r, onChange: l }) }),
      i && /* @__PURE__ */ c(Ze, { type: "button", onClick: u, children: /* @__PURE__ */ c(oe, { icon: ne.eyedropperVariant, size: pe.s }) })
    ] })
  ] });
}
const tg = (e) => Ji(e) ? e : "", j3 = "gs-cmp-color-field";
function Lr({
  className: e,
  value: t,
  label: n,
  size: r = "m",
  placeholder: o,
  preventSubmitOnEnter: s = !1,
  onChange: i
}) {
  const [a, l] = W(tg(t));
  G(() => {
    l(tg(t));
  }, [t]);
  const u = (f, h) => {
    i == null || i(f, h);
  }, d = (f) => {
    switch (f.key) {
      case "Escape":
        return l(t);
      case "Enter":
        u(a), s && (f.preventDefault(), f.stopPropagation());
    }
  }, p = () => {
    u(a);
  };
  return /* @__PURE__ */ A("div", { className: $(j3, e), children: [
    !!n && /* @__PURE__ */ c($t, { size: r, children: n }),
    /* @__PURE__ */ A(
      I,
      {
        className: $(z.bg, z.br, se.b, se.rnd, r === "m" && Re.xy, r === "s" && "gjs-px-3 gjs-py-1"),
        items: "center",
        space: "s",
        children: [
          /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(gb, { value: t, onChange: i }) }),
          /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(
            "input",
            {
              className: $("w-full focus:gs-utl-outline-none", z.bgTr),
              value: a,
              onChange: (f) => l(f.target.value),
              placeholder: o,
              onBlur: p,
              onKeyDown: d
            }
          ) })
        ]
      }
    )
  ] });
}
const D3 = (e) => {
  const t = parseFloat(e), n = e.replace(`${t}`, "").trim();
  return { number: t || t === 0 ? `${t}` : "", unit: n };
}, mb = ({ value: e, step: t }) => {
  const n = parseFloat(`${e}`);
  let r = 0;
  if (Math.floor(n) !== n && t) {
    const o = `${t}`.split(".")[1];
    r = (o == null ? void 0 : o.length) || 0;
  }
  return r ? parseFloat(n.toFixed(r)) : n;
}, I3 = ({
  value: e,
  key: t,
  shiftKey: n,
  min: r,
  max: o,
  step: s = 1
}) => {
  const i = t === "ArrowUp", a = t === "ArrowDown";
  let l = null;
  if (i || a) {
    l = Number(e);
    const u = parseFloat(`${s}`);
    i && (l += (n ? 10 : 1) * u), a && (l -= (n ? 10 : 1) * u), l = `${ac({ min: r, max: o, value: l })}`, l = mb({ value: l, step: s });
  }
  return l;
}, ac = ({ min: e, max: t, value: n }) => {
  const r = parseFloat(`${n}`);
  let o = r || 0;
  return Pr(e) && (o = Math.max(o, parseFloat(`${e}`) || 0)), Pr(t) && (o = Math.min(o, parseFloat(`${t}`) || 0)), `${`${r}` != `${n}` ? n : o}`;
}, V3 = (e, t, n, r = {}) => {
  const o = parseInt(`${e}`, 10) || 0, { min: s, max: i, step: a = 1 } = r;
  let l = o;
  const u = (p) => {
    const f = p.clientY - t, h = o - f * parseFloat(`${a}`);
    l = mb({
      value: ac({ min: s, max: i, value: h }),
      step: a
    }), n(l, !0);
  }, d = () => {
    window.removeEventListener("mousemove", u), window.removeEventListener("mouseup", d), n(l);
  };
  window.addEventListener("mousemove", u), window.addEventListener("mouseup", d);
}, H3 = (e, t, n = {}) => {
  const { partial: r } = n, o = (s, i) => s === i || r && s.startsWith(i);
  return t.some((s) => o(typeof s == "string" ? s : s.id, e));
}, ng = (e) => Ji(e) ? e : "", B3 = "gs-cmp-number-field";
function Me({
  className: e,
  value: t,
  units: n,
  valueUnit: r,
  label: o,
  size: s = "m",
  pan: i = !0,
  min: a,
  max: l,
  step: u,
  tip: d,
  placeholder: p,
  onChange: f,
  onChangeUnit: h
}) {
  const [g, m] = W(ng(t)), [v, b] = W(!1), y = (n == null ? void 0 : n.map((_) => ({ id: _, label: _ }))) || [], w = { min: a, max: l, step: u };
  G(() => {
    m(ng(t));
  }, [t, r]);
  const S = (_, O) => {
    f == null || f(ac({ min: a, max: l, value: _ }), O);
  }, x = (_) => {
    b(!0);
    const O = (E, T) => {
      S(E, !!T), !T && b(!1);
    };
    V3(g, _.clientY, O, w);
  }, C = (_) => {
    const { key: O, shiftKey: E } = _;
    switch (O) {
      case "Escape":
        return m(t);
      case "Enter":
        return S(g);
    }
    const T = I3({ step: u, value: t, key: O, shiftKey: E });
    T !== null && (_.preventDefault(), S(T));
  }, P = () => {
    S(g);
  };
  return /* @__PURE__ */ A("div", { className: $(B3, e), children: [
    v && /* @__PURE__ */ c("div", { className: $("fixed inset-0 z-50 cursor-ns") }),
    !!o && /* @__PURE__ */ c($t, { size: s, tip: d, children: o }),
    /* @__PURE__ */ A(
      I,
      {
        className: $(z.bg, z.br, se.b, se.rnd, s === "m" && Re.xy, s === "s" && "gjs-px-3 gjs-py-1"),
        items: "center",
        space: "x2s",
        children: [
          !!i && /* @__PURE__ */ c(
            N,
            {
              onMouseDown: x,
              className: $(
                "opacity-50 cursor-ns",
                s === "m" && "-gjs-ml-3",
                s === "s" && "-gjs-ml-2",
                i !== !0 && "gjs-mr-0.5 -gjs-ml-1"
              ),
              children: i === !0 ? /* @__PURE__ */ c(oe, { icon: ne.panVertical, size: pe.s2x }) : i
            }
          ),
          /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(
            "input",
            {
              className: $("w-full", z.bgTr, Eo.inputText),
              value: g,
              onChange: (_) => m(_.target.value),
              placeholder: p,
              onBlur: P,
              onKeyDown: C
            }
          ) }),
          !!y.length && /* @__PURE__ */ c(N, { className: $(y.length === 1 && "opacity-50 pointer-events-none"), children: /* @__PURE__ */ c(
            Ae,
            {
              caret: "",
              size: "x2s",
              pos: "right",
              width: "75px",
              emptyState: "-",
              border: !1,
              value: r,
              onChange: (_) => h == null ? void 0 : h(_),
              options: y
            }
          ) })
        ]
      }
    )
  ] });
}
function z3() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return ie(
    () => (r) => {
      t.forEach((o) => o(r));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
const lc = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function Ms(e) {
  const t = Object.prototype.toString.call(e);
  return t === "[object Window]" || // In Electron context the Window object serializes to [object global]
  t === "[object global]";
}
function Wp(e) {
  return "nodeType" in e;
}
function lo(e) {
  var t, n;
  return e ? Ms(e) ? e : Wp(e) && (t = (n = e.ownerDocument) == null ? void 0 : n.defaultView) != null ? t : window : window;
}
function Gp(e) {
  const {
    Document: t
  } = lo(e);
  return e instanceof t;
}
function $s(e) {
  return Ms(e) ? !1 : e instanceof lo(e).HTMLElement;
}
function vb(e) {
  return e instanceof lo(e).SVGElement;
}
function Rs(e) {
  return e ? Ms(e) ? e.document : Wp(e) ? Gp(e) ? e : $s(e) || vb(e) ? e.ownerDocument : document : document : document;
}
const _o = lc ? kl : G;
function F3(e) {
  const t = K(e);
  return _o(() => {
    t.current = e;
  }), it(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
function U3() {
  const e = K(null), t = it((r, o) => {
    e.current = setInterval(r, o);
  }, []), n = it(() => {
    e.current !== null && (clearInterval(e.current), e.current = null);
  }, []);
  return [t, n];
}
function na(e, t) {
  const n = K();
  return ie(
    () => {
      const r = e(n.current);
      return n.current = r, r;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
function Kp(e) {
  const t = F3(e), n = K(null), r = it(
    (o) => {
      o !== n.current && (t == null || t(o, n.current)), n.current = o;
    },
    //eslint-disable-next-line
    []
  );
  return [n, r];
}
let cu = {};
function ra(e, t) {
  return ie(() => {
    if (t)
      return t;
    const n = cu[e] == null ? 0 : cu[e] + 1;
    return cu[e] = n, e + "-" + n;
  }, [e, t]);
}
function bb(e) {
  return function(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      r[o - 1] = arguments[o];
    return r.reduce((s, i) => {
      const a = Object.entries(i);
      for (const [l, u] of a) {
        const d = s[l];
        d != null && (s[l] = d + e * u);
      }
      return s;
    }, {
      ...t
    });
  };
}
const Ti = /* @__PURE__ */ bb(1), yb = /* @__PURE__ */ bb(-1);
function W3(e) {
  return "clientX" in e && "clientY" in e;
}
function G3(e) {
  if (!e)
    return !1;
  const {
    KeyboardEvent: t
  } = lo(e.target);
  return t && e instanceof t;
}
function K3(e) {
  if (!e)
    return !1;
  const {
    TouchEvent: t
  } = lo(e.target);
  return t && e instanceof t;
}
function Sd(e) {
  if (K3(e)) {
    if (e.touches && e.touches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.touches[0];
      return {
        x: t,
        y: n
      };
    } else if (e.changedTouches && e.changedTouches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.changedTouches[0];
      return {
        x: t,
        y: n
      };
    }
  }
  return W3(e) ? {
    x: e.clientX,
    y: e.clientY
  } : null;
}
const Ai = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(e) {
      if (!e)
        return;
      const {
        x: t,
        y: n
      } = e;
      return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (n ? Math.round(n) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(e) {
      if (!e)
        return;
      const {
        scaleX: t,
        scaleY: n
      } = e;
      return "scaleX(" + t + ") scaleY(" + n + ")";
    }
  },
  Transform: {
    toString(e) {
      if (e)
        return [Ai.Translate.toString(e), Ai.Scale.toString(e)].join(" ");
    }
  },
  Transition: {
    toString(e) {
      let {
        property: t,
        duration: n,
        easing: r
      } = e;
      return t + " " + n + "ms " + r;
    }
  }
}), q3 = {
  display: "none"
};
function Y3(e) {
  let {
    id: t,
    value: n
  } = e;
  return H.createElement("div", {
    id: t,
    style: q3
  }, n);
}
function X3(e) {
  let {
    id: t,
    announcement: n,
    ariaLiveType: r = "assertive"
  } = e;
  const o = {
    position: "fixed",
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return H.createElement("div", {
    id: t,
    style: o,
    role: "status",
    "aria-live": r,
    "aria-atomic": !0
  }, n);
}
function Z3() {
  const [e, t] = W("");
  return {
    announce: it((r) => {
      r != null && t(r);
    }, []),
    announcement: e
  };
}
const J3 = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, Q3 = {
  onDragStart(e) {
    return `Picked up draggable item ${e}.`;
  },
  onDragOver(e, t) {
    return t ? `Draggable item ${e} was moved over droppable area ${t}.` : `Draggable item ${e} is no longer over a droppable area.`;
  },
  onDragEnd(e, t) {
    return t ? `Draggable item ${e} was dropped over droppable area ${t}` : `Draggable item ${e} was dropped.`;
  },
  onDragCancel(e) {
    return `Dragging was cancelled. Draggable item ${e} was dropped.`;
  }
};
var tt;
(function(e) {
  e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(tt || (tt = {}));
function uu(...e) {
}
class ui extends Map {
  get(t) {
    var n;
    return t != null && (n = super.get(t)) != null ? n : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter(({
      disabled: t
    }) => !t);
  }
  getNodeFor(t) {
    var n, r;
    return (n = (r = this.get(t)) == null ? void 0 : r.node.current) != null ? n : void 0;
  }
}
const cc = /* @__PURE__ */ Be({
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  activeNodeClientRect: null,
  activators: [],
  ariaDescribedById: {
    draggable: ""
  },
  containerNodeRect: null,
  dispatch: uu,
  draggableNodes: {},
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new ui(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: uu
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  recomputeLayouts: uu,
  windowRect: null,
  willRecomputeLayouts: !1
});
function eL() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: {},
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new ui()
    }
  };
}
function tL(e, t) {
  switch (t.type) {
    case tt.DragStart:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          initialCoordinates: t.initialCoordinates,
          active: t.active
        }
      };
    case tt.DragMove:
      return e.draggable.active ? {
        ...e,
        draggable: {
          ...e.draggable,
          translate: {
            x: t.coordinates.x - e.draggable.initialCoordinates.x,
            y: t.coordinates.y - e.draggable.initialCoordinates.y
          }
        }
      } : e;
    case tt.DragEnd:
    case tt.DragCancel:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case tt.RegisterDroppable: {
      const {
        element: n
      } = t, {
        id: r
      } = n, o = new ui(e.droppable.containers);
      return o.set(r, n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: o
        }
      };
    }
    case tt.SetDroppableDisabled: {
      const {
        id: n,
        key: r,
        disabled: o
      } = t, s = e.droppable.containers.get(n);
      if (!s || r !== s.key)
        return e;
      const i = new ui(e.droppable.containers);
      return i.set(n, {
        ...s,
        disabled: o
      }), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: i
        }
      };
    }
    case tt.UnregisterDroppable: {
      const {
        id: n,
        key: r
      } = t, o = e.droppable.containers.get(n);
      if (!o || r !== o.key)
        return e;
      const s = new ui(e.droppable.containers);
      return s.delete(n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: s
        }
      };
    }
    default:
      return e;
  }
}
const wb = /* @__PURE__ */ Be({
  type: null,
  event: null
});
function nL({
  onDragStart: e,
  onDragMove: t,
  onDragOver: n,
  onDragEnd: r,
  onDragCancel: o
}) {
  const s = Le(wb), i = K(s);
  G(() => {
    if (s !== i.current) {
      const {
        type: a,
        event: l
      } = s;
      switch (a) {
        case tt.DragStart:
          e == null || e(l);
          break;
        case tt.DragMove:
          t == null || t(l);
          break;
        case tt.DragOver:
          n == null || n(l);
          break;
        case tt.DragCancel:
          o == null || o(l);
          break;
        case tt.DragEnd:
          r == null || r(l);
          break;
      }
      i.current = s;
    }
  }, [s, e, t, n, r, o]);
}
function rL({
  announcements: e = Q3,
  hiddenTextDescribedById: t,
  screenReaderInstructions: n
}) {
  const {
    announce: r,
    announcement: o
  } = Z3(), s = ra("DndLiveRegion"), [i, a] = W(!1);
  return G(() => {
    a(!0);
  }, []), nL(ie(() => ({
    onDragStart({
      active: l
    }) {
      r(e.onDragStart(l.id));
    },
    onDragMove({
      active: l,
      over: u
    }) {
      e.onDragMove && r(e.onDragMove(l.id, u == null ? void 0 : u.id));
    },
    onDragOver({
      active: l,
      over: u
    }) {
      r(e.onDragOver(l.id, u == null ? void 0 : u.id));
    },
    onDragEnd({
      active: l,
      over: u
    }) {
      r(e.onDragEnd(l.id, u == null ? void 0 : u.id));
    },
    onDragCancel({
      active: l
    }) {
      r(e.onDragCancel(l.id));
    }
  }), [r, e])), i ? jd(H.createElement(H.Fragment, null, H.createElement(Y3, {
    id: t,
    value: n.draggable
  }), H.createElement(X3, {
    id: s,
    announcement: o
  })), document.body) : null;
}
const kr = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function Sb(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function rg(e, t = e.offsetLeft, n = e.offsetTop) {
  return {
    x: t + e.width * 0.5,
    y: n + e.height * 0.5
  };
}
const oL = ({
  collisionRect: e,
  droppableContainers: t
}) => {
  const n = rg(e, e.left, e.top);
  let r = 1 / 0, o = null;
  for (const s of t) {
    const {
      rect: {
        current: i
      }
    } = s;
    if (i) {
      const a = Sb(rg(i), n);
      a < r && (r = a, o = s.id);
    }
  }
  return o;
};
function sL(e, t, n) {
  return {
    ...e,
    scaleX: t && n ? t.width / n.width : 1,
    scaleY: t && n ? t.height / n.height : 1
  };
}
function iL(e, t) {
  return e && t ? {
    x: e.left - t.left,
    y: e.top - t.top
  } : kr;
}
function aL(e) {
  return function(n, ...r) {
    return r.reduce((o, s) => ({
      ...o,
      top: o.top + e * s.y,
      bottom: o.bottom + e * s.y,
      left: o.left + e * s.x,
      right: o.right + e * s.x,
      offsetLeft: o.offsetLeft + e * s.x,
      offsetTop: o.offsetTop + e * s.y
    }), {
      ...n
    });
  };
}
const og = /* @__PURE__ */ aL(1);
function lL(e, t = window.getComputedStyle(e)) {
  return t.position === "fixed";
}
function cL(e, t = window.getComputedStyle(e)) {
  const n = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].find((o) => {
    const s = t[o];
    return typeof s == "string" ? n.test(s) : !1;
  }) != null;
}
function qp(e) {
  const t = [];
  function n(r) {
    if (!r)
      return t;
    if (Gp(r) && r.scrollingElement != null && !t.includes(r.scrollingElement))
      return t.push(r.scrollingElement), t;
    if (!$s(r) || vb(r) || t.includes(r))
      return t;
    const o = window.getComputedStyle(r);
    return cL(r, o) && t.push(r), lL(r, o) ? t : n(r.parentNode);
  }
  return e ? n(e.parentNode) : t;
}
function du(e) {
  return !lc || !e ? null : Ms(e) ? e : Wp(e) ? Gp(e) || e === Rs(e).scrollingElement ? window : $s(e) ? e : null : null;
}
function xd(e) {
  return Ms(e) ? {
    x: e.scrollX,
    y: e.scrollY
  } : {
    x: e.scrollLeft,
    y: e.scrollTop
  };
}
var Jo;
(function(e) {
  e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(Jo || (Jo = {}));
function xb(e) {
  const t = {
    x: 0,
    y: 0
  }, n = {
    x: e.scrollWidth - e.clientWidth,
    y: e.scrollHeight - e.clientHeight
  }, r = e.scrollTop <= t.y, o = e.scrollLeft <= t.x, s = e.scrollTop >= n.y, i = e.scrollLeft >= n.x;
  return {
    isTop: r,
    isLeft: o,
    isBottom: s,
    isRight: i,
    maxScroll: n,
    minScroll: t
  };
}
function uL(e) {
  return !lc || !e ? !1 : e === document.scrollingElement;
}
const dL = {
  x: 0.2,
  y: 0.2
};
function pL(e, t, {
  top: n,
  left: r,
  right: o,
  bottom: s
}, i = 10, a = dL) {
  const {
    clientHeight: l,
    clientWidth: u
  } = e, d = uL(e) ? {
    top: 0,
    left: 0,
    right: u,
    bottom: l,
    width: u,
    height: l
  } : t, {
    isTop: p,
    isBottom: f,
    isLeft: h,
    isRight: g
  } = xb(e), m = {
    x: 0,
    y: 0
  }, v = {
    x: 0,
    y: 0
  }, b = {
    height: d.height * a.y,
    width: d.width * a.x
  };
  return !p && n <= d.top + b.height ? (m.y = Jo.Backward, v.y = i * Math.abs((d.top + b.height - n) / b.height)) : !f && s >= d.bottom - b.height && (m.y = Jo.Forward, v.y = i * Math.abs((d.bottom - b.height - s) / b.height)), !g && o >= d.right - b.width ? (m.x = Jo.Forward, v.x = i * Math.abs((d.right - b.width - o) / b.width)) : !h && r <= d.left + b.width && (m.x = Jo.Backward, v.x = i * Math.abs((d.left + b.width - r) / b.width)), {
    direction: m,
    speed: v
  };
}
function fL(e) {
  if (e === document.scrollingElement) {
    const {
      innerWidth: s,
      innerHeight: i
    } = window;
    return {
      top: 0,
      left: 0,
      right: s,
      bottom: i,
      width: s,
      height: i
    };
  }
  const {
    top: t,
    left: n,
    right: r,
    bottom: o
  } = e.getBoundingClientRect();
  return {
    top: t,
    left: n,
    right: r,
    bottom: o,
    width: e.clientWidth,
    height: e.clientHeight
  };
}
function Cb(e) {
  return e.reduce((t, n) => Ti(t, xd(n)), kr);
}
function Pb(e, t, n = kr) {
  if (!e || !$s(e))
    return n;
  const r = {
    x: n.x + e.offsetLeft,
    y: n.y + e.offsetTop
  };
  return e.offsetParent === t ? r : Pb(e.offsetParent, t, r);
}
function uc(e) {
  const {
    offsetWidth: t,
    offsetHeight: n
  } = e, {
    x: r,
    y: o
  } = Pb(e, null);
  return {
    width: t,
    height: n,
    offsetTop: o,
    offsetLeft: r
  };
}
function dc(e) {
  if (Ms(e)) {
    const u = window.innerWidth, d = window.innerHeight;
    return {
      top: 0,
      left: 0,
      right: u,
      bottom: d,
      width: u,
      height: d,
      offsetTop: 0,
      offsetLeft: 0
    };
  }
  const {
    offsetTop: t,
    offsetLeft: n
  } = uc(e), {
    width: r,
    height: o,
    top: s,
    bottom: i,
    left: a,
    right: l
  } = e.getBoundingClientRect();
  return {
    width: r,
    height: o,
    top: s,
    bottom: i,
    right: l,
    left: a,
    offsetTop: t,
    offsetLeft: n
  };
}
function Cd(e) {
  const {
    width: t,
    height: n,
    offsetTop: r,
    offsetLeft: o
  } = uc(e), s = qp(e), i = Cb(s), a = r - i.y, l = o - i.x;
  return {
    width: t,
    height: n,
    top: a,
    bottom: a + n,
    right: l + t,
    left: l,
    offsetTop: r,
    offsetLeft: o
  };
}
function sg(e) {
  return "top" in e;
}
function ig(e, t = e.offsetLeft, n = e.offsetTop) {
  return [{
    x: t,
    y: n
  }, {
    x: t + e.width,
    y: n
  }, {
    x: t,
    y: n + e.height
  }, {
    x: t + e.width,
    y: n + e.height
  }];
}
const hL = ({
  collisionRect: e,
  droppableContainers: t
}) => {
  let n = 1 / 0, r = null;
  const o = ig(e, e.left, e.top);
  for (const s of t) {
    const {
      rect: {
        current: i
      }
    } = s;
    if (i) {
      const a = ig(i, sg(i) ? i.left : void 0, sg(i) ? i.top : void 0), l = o.reduce((d, p, f) => d + Sb(a[f], p), 0), u = Number((l / 4).toFixed(4));
      u < n && (n = u, r = s.id);
    }
  }
  return r;
};
function gL(e, t) {
  const n = Math.max(t.top, e.offsetTop), r = Math.max(t.left, e.offsetLeft), o = Math.min(t.left + t.width, e.offsetLeft + e.width), s = Math.min(t.top + t.height, e.offsetTop + e.height), i = o - r, a = s - n;
  if (r < o && n < s) {
    const l = t.width * t.height, u = e.width * e.height, d = i * a, p = d / (l + u - d);
    return Number(p.toFixed(4));
  }
  return 0;
}
const mL = ({
  collisionRect: e,
  droppableContainers: t
}) => {
  let n = 0, r = null;
  for (const o of t) {
    const {
      rect: {
        current: s
      }
    } = o;
    if (s) {
      const i = gL(s, e);
      i > n && (n = i, r = o.id);
    }
  }
  return r;
};
var di;
(function(e) {
  e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})(di || (di = {}));
var ml;
(function(e) {
  e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(ml || (ml = {}));
function vL({
  acceleration: e,
  activator: t = di.Pointer,
  canScroll: n,
  draggingRect: r,
  enabled: o,
  interval: s = 5,
  order: i = ml.TreeOrder,
  pointerCoordinates: a,
  scrollableAncestors: l,
  scrollableAncestorRects: u,
  threshold: d
}) {
  const [p, f] = U3(), h = K({
    x: 1,
    y: 1
  }), g = ie(() => {
    switch (t) {
      case di.Pointer:
        return a ? {
          top: a.y,
          bottom: a.y,
          left: a.x,
          right: a.x
        } : null;
      case di.DraggableRect:
        return r;
    }
    return null;
  }, [t, r, a]), m = K(kr), v = K(null), b = it(() => {
    const w = v.current;
    if (!w)
      return;
    const S = h.current.x * m.current.x, x = h.current.y * m.current.y;
    w.scrollBy(S, x);
  }, []), y = ie(() => i === ml.TreeOrder ? [...l].reverse() : l, [i, l]);
  G(
    () => {
      if (!o || !l.length || !g) {
        f();
        return;
      }
      for (const w of y) {
        if ((n == null ? void 0 : n(w)) === !1)
          continue;
        const S = l.indexOf(w), x = u[S];
        if (!x)
          continue;
        const {
          direction: C,
          speed: P
        } = pL(w, x, g, e, d);
        if (P.x > 0 || P.y > 0) {
          f(), v.current = w, p(b, s), h.current = P, m.current = C;
          return;
        }
      }
      h.current = {
        x: 0,
        y: 0
      }, m.current = {
        x: 0,
        y: 0
      }, f();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      e,
      b,
      n,
      f,
      o,
      s,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(g),
      p,
      l,
      y,
      u,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(d)
    ]
  );
}
function bL(e, t) {
  const n = t !== null ? e[t] : void 0, r = n ? n.node.current : null;
  return na((o) => {
    var s;
    return t === null ? null : (s = r ?? o) != null ? s : null;
  }, [r, t]);
}
function yL(e, t) {
  return ie(() => e.reduce((n, r) => {
    const {
      sensor: o
    } = r, s = o.activators.map((i) => ({
      eventName: i.eventName,
      handler: t(i.handler, r)
    }));
    return [...n, ...s];
  }, []), [e, t]);
}
function Eb(e) {
  const t = K(e);
  return _o(() => {
    t.current !== e && (t.current = e);
  }, [e]), t;
}
var Li;
(function(e) {
  e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(Li || (Li = {}));
var Pd;
(function(e) {
  e.Optimized = "optimized";
})(Pd || (Pd = {}));
const ag = /* @__PURE__ */ new Map(), wL = {
  measure: uc,
  strategy: Li.WhileDragging,
  frequency: Pd.Optimized
};
function SL(e, {
  dragging: t,
  dependencies: n,
  config: r
}) {
  const [o, s] = W(!1), {
    frequency: i,
    measure: a,
    strategy: l
  } = {
    ...wL,
    ...r
  }, u = K(e), d = it(() => s(!0), []), p = K(null), f = g(), h = na((m) => {
    if (f && !t)
      return ag;
    if (!m || m === ag || u.current !== e || o) {
      for (let v of e)
        v && (v.rect.current = v.node.current ? a(v.node.current) : null);
      return xL(e);
    }
    return m;
  }, [e, t, f, a, o]);
  return G(() => {
    u.current = e;
  }, [e]), G(() => {
    o && s(!1);
  }, [o]), G(
    function() {
      f || requestAnimationFrame(d);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, f]
  ), G(
    function() {
      f || typeof i != "number" || p.current !== null || (p.current = setTimeout(() => {
        d(), p.current = null;
      }, i));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i, f, d, ...n]
  ), {
    layoutRectMap: h,
    recomputeLayouts: d,
    willRecomputeLayouts: o
  };
  function g() {
    switch (l) {
      case Li.Always:
        return !1;
      case Li.BeforeDragging:
        return t;
      default:
        return !t;
    }
  }
}
function xL(e) {
  const t = /* @__PURE__ */ new Map();
  if (e)
    for (const n of e) {
      if (!n)
        continue;
      const {
        id: r,
        rect: o
      } = n;
      o.current != null && t.set(r, o.current);
    }
  return t;
}
function CL(e) {
  const [t, n] = W(null), r = K(e), o = it((s) => {
    const i = du(s.target);
    i && n((a) => a ? (a.set(i, xd(i)), new Map(a)) : null);
  }, []);
  return G(() => {
    const s = r.current;
    if (e !== s) {
      i(s);
      const a = e.map((l) => {
        const u = du(l);
        return u ? (u.addEventListener("scroll", o, {
          passive: !0
        }), [u, xd(u)]) : null;
      }).filter((l) => l != null);
      n(a.length ? new Map(a) : null), r.current = e;
    }
    return () => {
      i(e), i(s);
    };
    function i(a) {
      a.forEach((l) => {
        const u = du(l);
        u == null || u.removeEventListener("scroll", o);
      });
    }
  }, [o, e]), ie(() => e.length ? t ? Array.from(t.values()).reduce((s, i) => Ti(s, i), kr) : Cb(e) : kr, [e, t]);
}
const PL = [];
function EL(e) {
  const t = K(e), n = na((r) => e ? r && e && t.current && e.parentNode === t.current.parentNode ? r : qp(e) : PL, [e]);
  return G(() => {
    t.current = e;
  }, [e]), n;
}
function OL(e) {
  G(
    () => {
      if (!lc)
        return;
      const t = e.map(({
        sensor: n
      }) => n.setup == null ? void 0 : n.setup());
      return () => {
        for (const n of t)
          n == null || n();
      };
    },
    // TO-DO: Sensors lenght could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map(({
      sensor: t
    }) => t)
  );
}
function _L(e, t) {
  return ie(() => e.reduce((n, {
    eventName: r,
    handler: o
  }) => (n[r] = (s) => {
    o(s, t);
  }, n), {}), [e, t]);
}
const pu = /* @__PURE__ */ _b(dc), TL = /* @__PURE__ */ AL(dc);
function Ob(e, t, n) {
  const r = K(e);
  return na((o) => e ? n || !o && e || e !== r.current ? $s(e) && e.parentNode == null ? null : t(e) : o ?? null : null, [e, n, t]);
}
function _b(e) {
  return (t, n) => Ob(t, e, n);
}
function AL(e) {
  const t = [];
  return function(r, o) {
    const s = K(r);
    return na((i) => r.length ? o || !i && r.length || r !== s.current ? r.map((a) => e(a)) : i ?? t : t, [r, o]);
  };
}
function LL(e) {
  if (!e)
    return null;
  if (e.children.length > 1)
    return e;
  const t = e.children[0];
  return $s(t) ? t : e;
}
function kL(e) {
  const {
    width: t,
    height: n,
    offsetLeft: r,
    offsetTop: o
  } = uc(e);
  return {
    top: o,
    bottom: o + n,
    left: r,
    right: r + t,
    width: t,
    height: n,
    offsetTop: o,
    offsetLeft: r
  };
}
const ML = /* @__PURE__ */ _b(kL);
function $L({
  disabled: e,
  forceRecompute: t
}) {
  const [n, r] = Kp(), o = ML(e ? null : LL(n.current), t);
  return ie(() => ({
    nodeRef: n,
    rect: o,
    setRef: r
  }), [o, n, r]);
}
function lg(e, t) {
  return ie(
    () => ({
      sensor: e,
      options: t ?? {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e, t]
  );
}
function RL(...e) {
  return ie(
    () => [...e].filter((t) => t != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...e]
  );
}
class pi {
  constructor(t) {
    this.target = t, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((n) => {
        var r;
        return (r = this.target) == null ? void 0 : r.removeEventListener(...n);
      });
    };
  }
  add(t, n, r) {
    var o;
    (o = this.target) == null || o.addEventListener(t, n, r), this.listeners.push([t, n, r]);
  }
}
function NL(e) {
  const {
    EventTarget: t
  } = lo(e);
  return e instanceof t ? e : Rs(e);
}
function fu(e, t) {
  const n = Math.abs(e.x), r = Math.abs(e.y);
  return typeof t == "number" ? Math.sqrt(n ** 2 + r ** 2) > t : "x" in t && "y" in t ? n > t.x && r > t.y : "x" in t ? n > t.x : "y" in t ? r > t.y : !1;
}
var gn;
(function(e) {
  e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(gn || (gn = {}));
function cg(e) {
  e.preventDefault();
}
function jL(e) {
  e.stopPropagation();
}
var Ie;
(function(e) {
  e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter";
})(Ie || (Ie = {}));
const Tb = {
  start: [Ie.Space, Ie.Enter],
  cancel: [Ie.Esc],
  end: [Ie.Space, Ie.Enter]
}, DL = (e, {
  currentCoordinates: t
}) => {
  switch (e.code) {
    case Ie.Right:
      return {
        ...t,
        x: t.x + 25
      };
    case Ie.Left:
      return {
        ...t,
        x: t.x - 25
      };
    case Ie.Down:
      return {
        ...t,
        y: t.y + 25
      };
    case Ie.Up:
      return {
        ...t,
        y: t.y - 25
      };
  }
};
class Yp {
  constructor(t) {
    this.props = t, this.autoScrollEnabled = !1, this.coordinates = kr;
    const {
      event: {
        target: n
      }
    } = t;
    this.props = t, this.listeners = new pi(Rs(n)), this.windowListeners = new pi(lo(n)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(gn.Resize, this.handleCancel), this.windowListeners.add(gn.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(gn.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: t,
      onStart: n
    } = this.props;
    if (!t.node.current)
      throw new Error("Active draggable node is undefined");
    const r = dc(t.node.current), o = {
      x: r.left,
      y: r.top
    };
    this.coordinates = o, n(o);
  }
  handleKeyDown(t) {
    if (G3(t)) {
      const {
        coordinates: n
      } = this, {
        active: r,
        context: o,
        options: s
      } = this.props, {
        keyboardCodes: i = Tb,
        coordinateGetter: a = DL,
        scrollBehavior: l = "smooth"
      } = s, {
        code: u
      } = t;
      if (i.end.includes(u)) {
        this.handleEnd(t);
        return;
      }
      if (i.cancel.includes(u)) {
        this.handleCancel(t);
        return;
      }
      const d = a(t, {
        active: r,
        context: o.current,
        currentCoordinates: n
      });
      if (d) {
        const p = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: f
        } = o.current;
        for (const h of f) {
          const g = t.code, m = yb(d, n), {
            isTop: v,
            isRight: b,
            isLeft: y,
            isBottom: w,
            maxScroll: S,
            minScroll: x
          } = xb(h), C = fL(h), P = {
            x: Math.min(g === Ie.Right ? C.right - C.width / 2 : C.right, Math.max(g === Ie.Right ? C.left : C.left + C.width / 2, d.x)),
            y: Math.min(g === Ie.Down ? C.bottom - C.height / 2 : C.bottom, Math.max(g === Ie.Down ? C.top : C.top + C.height / 2, d.y))
          }, _ = g === Ie.Right && !b || g === Ie.Left && !y, O = g === Ie.Down && !w || g === Ie.Up && !v;
          if (_ && P.x !== d.x) {
            if (g === Ie.Right && h.scrollLeft + m.x <= S.x || g === Ie.Left && h.scrollLeft + m.x >= x.x) {
              h.scrollBy({
                left: m.x,
                behavior: l
              });
              return;
            }
            p.x = g === Ie.Right ? h.scrollLeft - S.x : h.scrollLeft - x.x, h.scrollBy({
              left: -p.x,
              behavior: l
            });
            break;
          } else if (O && P.y !== d.y) {
            if (g === Ie.Down && h.scrollTop + m.y <= S.y || g === Ie.Up && h.scrollTop + m.y >= x.y) {
              h.scrollBy({
                top: m.y,
                behavior: l
              });
              return;
            }
            p.y = g === Ie.Down ? h.scrollTop - S.y : h.scrollTop - x.y, h.scrollBy({
              top: -p.y,
              behavior: l
            });
            break;
          }
        }
        this.handleMove(t, Ti(d, p));
      }
    }
  }
  handleMove(t, n) {
    const {
      onMove: r
    } = this.props;
    t.preventDefault(), r(n), this.coordinates = n;
  }
  handleEnd(t) {
    const {
      onEnd: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  handleCancel(t) {
    const {
      onCancel: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
Yp.activators = [{
  eventName: "onKeyDown",
  handler: (e, {
    keyboardCodes: t = Tb,
    onActivation: n
  }) => {
    const {
      code: r
    } = e.nativeEvent;
    return t.start.includes(r) ? (e.preventDefault(), n == null || n({
      event: e.nativeEvent
    }), !0) : !1;
  }
}];
function ug(e) {
  return !!(e && "distance" in e);
}
function dg(e) {
  return !!(e && "delay" in e);
}
class Xp {
  constructor(t, n, r = NL(t.event.target)) {
    this.props = t, this.events = n, this.autoScrollEnabled = !0, this.activated = !1, this.timeoutId = null;
    const {
      event: o
    } = t, {
      target: s
    } = o;
    this.props = t, this.events = n, this.document = Rs(s), this.documentListeners = new pi(this.document), this.listeners = new pi(r), this.windowListeners = new pi(lo(s)), this.initialCoordinates = Sd(o), this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: t,
      props: {
        options: {
          activationConstraint: n
        }
      }
    } = this;
    if (this.listeners.add(t.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(t.end.name, this.handleEnd), this.windowListeners.add(gn.Resize, this.handleCancel), this.windowListeners.add(gn.DragStart, cg), this.windowListeners.add(gn.VisibilityChange, this.handleCancel), this.windowListeners.add(gn.ContextMenu, cg), this.documentListeners.add(gn.Keydown, this.handleKeydown), n) {
      if (ug(n))
        return;
      if (dg(n)) {
        this.timeoutId = setTimeout(this.handleStart, n.delay);
        return;
      }
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handleStart() {
    const {
      initialCoordinates: t
    } = this, {
      onStart: n
    } = this.props;
    t && (this.activated = !0, this.documentListeners.add(gn.Click, jL, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add(gn.SelectionChange, this.removeTextSelection), n(t));
  }
  handleMove(t) {
    const {
      activated: n,
      initialCoordinates: r,
      props: o
    } = this, {
      onMove: s,
      options: {
        activationConstraint: i
      }
    } = o;
    if (!r)
      return;
    const a = Sd(t), l = yb(r, a);
    if (!n && i) {
      if (dg(i))
        return fu(l, i.tolerance) ? this.handleCancel() : void 0;
      if (ug(i))
        return i.tolerance != null && fu(l, i.tolerance) ? this.handleCancel() : fu(l, i.distance) ? this.handleStart() : void 0;
    }
    t.cancelable && t.preventDefault(), s(a);
  }
  handleEnd() {
    const {
      onEnd: t
    } = this.props;
    this.detach(), t();
  }
  handleCancel() {
    const {
      onCancel: t
    } = this.props;
    this.detach(), t();
  }
  handleKeydown(t) {
    t.code === Ie.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var t;
    (t = this.document.getSelection()) == null || t.removeAllRanges();
  }
}
const IL = {
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class Zp extends Xp {
  constructor(t) {
    const {
      event: n
    } = t, r = Rs(n.target);
    super(t, IL, r);
  }
}
Zp.activators = [{
  eventName: "onPointerDown",
  handler: ({
    nativeEvent: e
  }, {
    onActivation: t
  }) => !e.isPrimary || e.button !== 0 ? !1 : (t == null || t({
    event: e
  }), !0)
}];
const VL = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var Ed;
(function(e) {
  e[e.RightClick = 2] = "RightClick";
})(Ed || (Ed = {}));
class HL extends Xp {
  constructor(t) {
    super(t, VL, Rs(t.event.target));
  }
}
HL.activators = [{
  eventName: "onMouseDown",
  handler: ({
    nativeEvent: e
  }, {
    onActivation: t
  }) => e.button === Ed.RightClick ? !1 : (t == null || t({
    event: e
  }), !0)
}];
const hu = {
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class BL extends Xp {
  constructor(t) {
    super(t, hu);
  }
  static setup() {
    return window.addEventListener(hu.move.name, t, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener(hu.move.name, t);
    };
    function t() {
    }
  }
}
BL.activators = [{
  eventName: "onTouchStart",
  handler: ({
    nativeEvent: e
  }, {
    onActivation: t
  }) => {
    const {
      touches: n
    } = e;
    return n.length > 1 ? !1 : (t == null || t({
      event: e
    }), !0);
  }
}];
function zL(e, {
  transform: t,
  ...n
}) {
  return e != null && e.length ? e.reduce((r, o) => o({
    transform: r,
    ...n
  }), t) : t;
}
const FL = [{
  sensor: Zp,
  options: {}
}, {
  sensor: Yp,
  options: {}
}], UL = {
  current: {}
}, Ab = /* @__PURE__ */ Be({
  ...kr,
  scaleX: 1,
  scaleY: 1
}), WL = /* @__PURE__ */ we(function({
  id: t,
  autoScroll: n = !0,
  announcements: r,
  children: o,
  sensors: s = FL,
  collisionDetection: i = mL,
  measuring: a,
  modifiers: l,
  screenReaderInstructions: u = J3,
  ...d
}) {
  var p, f, h, g, m;
  const v = Qr(tL, void 0, eL), [b, y] = v, [w, S] = W(() => ({
    type: null,
    event: null
  })), [x, C] = W(!1), {
    draggable: {
      active: P,
      nodes: _,
      translate: O
    },
    droppable: {
      containers: E
    }
  } = b, T = P ? _[P] : null, R = K({
    initial: null,
    translated: null
  }), B = ie(() => {
    var Nt;
    return P != null ? {
      id: P,
      // It's possible for the active node to unmount while dragging
      data: (Nt = T == null ? void 0 : T.data) != null ? Nt : UL,
      rect: R
    } : null;
  }, [P, T]), U = K(null), [L, M] = W(null), [D, V] = W(null), k = K(d), j = ra("DndDescribedBy", t), Y = ie(() => E.getEnabled(), [E]), {
    layoutRectMap: J,
    recomputeLayouts: le,
    willRecomputeLayouts: Q
  } = SL(Y, {
    dragging: x,
    dependencies: [O.x, O.y],
    config: a == null ? void 0 : a.droppable
  }), re = bL(_, P), ge = D ? Sd(D) : null, X = Ob(re, (p = a == null || (f = a.draggable) == null ? void 0 : f.measure) != null ? p : Cd), Z = pu(re), te = K(null), de = te.current, ce = K({
    active: null,
    activeNode: re,
    collisionRect: null,
    droppableRects: J,
    draggableNodes: _,
    draggingNodeRect: null,
    droppableContainers: E,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null,
    translatedRect: null
  }), Ce = E.getNodeFor((h = ce.current.over) == null ? void 0 : h.id), Pe = pu(re ? re.ownerDocument.defaultView : null), at = pu(re ? re.parentElement : null), ut = EL(P ? Ce ?? re : null), Pt = TL(ut), gt = $L({
    disabled: P == null,
    forceRecompute: Q
  }), Je = (g = gt.rect) != null ? g : X, dn = Je === X ? iL(X, de) : kr, ht = zL(l, {
    transform: {
      x: O.x - dn.x,
      y: O.y - dn.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: D,
    active: B,
    activeNodeRect: Z,
    containerNodeRect: at,
    draggingNodeRect: Je,
    over: ce.current.over,
    overlayNodeRect: gt.rect,
    scrollableAncestors: ut,
    scrollableAncestorRects: Pt,
    windowRect: Pe
  }), rt = ge ? Ti(ge, O) : null, dt = CL(ut), Tt = Ti(ht, dt), vt = Je ? og(Je, ht) : null, Et = vt ? og(vt, dt) : null, An = B && Et ? i({
    active: B,
    collisionRect: Et,
    droppableContainers: Y
  }) : null, [Vt, Ln] = W(null), uo = sL(ht, (m = Vt == null ? void 0 : Vt.rect) != null ? m : null, X), Do = it((Nt, {
    sensor: pn,
    options: Wt
  }) => {
    if (!U.current)
      return;
    const Fn = _[U.current];
    if (!Fn)
      return;
    const fn = new pn({
      active: U.current,
      activeNode: Fn,
      event: Nt.nativeEvent,
      options: Wt,
      // Sensors need to be instantiated with refs for arguments that change over time
      // otherwise they are frozen in time with the stale arguments
      context: ce,
      onStart(hn) {
        const Is = U.current;
        if (!Is)
          return;
        const Vs = _[Is];
        if (!Vs)
          return;
        const {
          onDragStart: aa
        } = k.current, Hs = {
          active: {
            id: Is,
            data: Vs.data,
            rect: R
          }
        };
        Js(() => {
          y({
            type: tt.DragStart,
            initialCoordinates: hn,
            active: Is
          }), S({
            type: tt.DragStart,
            event: Hs
          });
        }), aa == null || aa(Hs);
      },
      onMove(hn) {
        y({
          type: tt.DragMove,
          coordinates: hn
        });
      },
      onEnd: Ds(tt.DragEnd),
      onCancel: Ds(tt.DragCancel)
    });
    Js(() => {
      M(fn), V(Nt.nativeEvent);
    });
    function Ds(hn) {
      return async function() {
        const {
          active: Vs,
          over: aa,
          scrollAdjustedTranslate: Hs
        } = ce.current;
        let Vo = null;
        if (Vs && Hs) {
          const {
            cancelDrop: la
          } = k.current;
          Vo = {
            active: Vs,
            delta: Hs,
            over: aa
          }, hn === tt.DragEnd && typeof la == "function" && await Promise.resolve(la(Vo)) && (hn = tt.DragCancel);
        }
        if (U.current = null, Js(() => {
          y({
            type: hn
          }), Ln(null), C(!1), M(null), V(null), Vo && S({
            type: hn,
            event: Vo
          });
        }), Vo) {
          const {
            onDragCancel: la,
            onDragEnd: ff
          } = k.current, hf = hn === tt.DragEnd ? ff : la;
          hf == null || hf(Vo);
        }
      };
    }
  }, [y, _]), Io = it((Nt, pn) => (Wt, Fn) => {
    const fn = Wt.nativeEvent;
    // No active draggable
    U.current !== null || // Event has already been captured
    fn.dndKit || fn.defaultPrevented || Nt(Wt, pn.options) === !0 && (fn.dndKit = {
      capturedBy: pn.sensor
    }, U.current = Fn, Do(Wt, pn));
  }, [Do]), js = yL(s, Io);
  OL(s), _o(
    () => {
      k.current = d;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    Object.values(d)
  ), G(() => {
    P != null && C(!0);
  }, [P]), G(() => {
    B || (te.current = null), B && X && !te.current && (te.current = X);
  }, [X, B]), G(() => {
    const {
      onDragMove: Nt
    } = k.current, {
      active: pn,
      over: Wt
    } = ce.current;
    if (!pn)
      return;
    const Fn = {
      active: pn,
      delta: {
        x: Tt.x,
        y: Tt.y
      },
      over: Wt
    };
    S({
      type: tt.DragMove,
      event: Fn
    }), Nt == null || Nt(Fn);
  }, [Tt.x, Tt.y]), G(
    () => {
      const {
        active: Nt,
        droppableContainers: pn,
        scrollAdjustedTranslate: Wt
      } = ce.current;
      if (!Nt || !U.current || !Wt)
        return;
      const {
        onDragOver: Fn
      } = k.current, fn = pn.get(An), Ds = fn && fn.rect.current ? {
        id: fn.id,
        rect: fn.rect.current,
        data: fn.data,
        disabled: fn.disabled
      } : null, hn = {
        active: Nt,
        delta: {
          x: Wt.x,
          y: Wt.y
        },
        over: Ds
      };
      Js(() => {
        Ln(Ds), S({
          type: tt.DragOver,
          event: hn
        }), Fn == null || Fn(hn);
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [An]
  ), _o(() => {
    ce.current = {
      active: B,
      activeNode: re,
      collisionRect: Et,
      droppableRects: J,
      draggableNodes: _,
      draggingNodeRect: Je,
      droppableContainers: E,
      over: Vt,
      scrollableAncestors: ut,
      scrollAdjustedTranslate: Tt,
      translatedRect: vt
    }, R.current = {
      initial: Je,
      translated: vt
    };
  }, [B, re, Et, _, Je, J, E, Vt, ut, Tt, vt]), vL({
    ...K0(),
    draggingRect: vt,
    pointerCoordinates: rt,
    scrollableAncestors: ut,
    scrollableAncestorRects: Pt
  });
  const Ec = ie(() => ({
    active: B,
    activeNode: re,
    activeNodeRect: X,
    activeNodeClientRect: Z,
    activatorEvent: D,
    activators: js,
    ariaDescribedById: {
      draggable: j
    },
    containerNodeRect: at,
    dispatch: y,
    dragOverlay: gt,
    draggableNodes: _,
    droppableContainers: E,
    droppableRects: J,
    over: Vt,
    recomputeLayouts: le,
    scrollableAncestors: ut,
    scrollableAncestorRects: Pt,
    willRecomputeLayouts: Q,
    windowRect: Pe
  }), [B, re, Z, X, D, js, at, gt, y, _, j, E, J, Vt, le, ut, Pt, Q, Pe]);
  return H.createElement(wb.Provider, {
    value: w
  }, H.createElement(cc.Provider, {
    value: Ec
  }, H.createElement(Ab.Provider, {
    value: uo
  }, o)), H.createElement(rL, {
    announcements: r,
    hiddenTextDescribedById: j,
    screenReaderInstructions: u
  }));
  function K0() {
    const Nt = (L == null ? void 0 : L.autoScrollEnabled) === !1, pn = typeof n == "object" ? n.enabled === !1 : n === !1, Wt = !Nt && !pn;
    return typeof n == "object" ? {
      ...n,
      enabled: Wt
    } : {
      enabled: Wt
    };
  }
}), GL = /* @__PURE__ */ Be(null), pg = "button", KL = "Droppable";
function qL({
  id: e,
  data: t,
  disabled: n = !1,
  attributes: r
}) {
  const o = ra(KL), {
    active: s,
    activeNodeRect: i,
    activatorEvent: a,
    ariaDescribedById: l,
    draggableNodes: u,
    droppableRects: d,
    activators: p,
    over: f
  } = Le(cc), {
    role: h = pg,
    roleDescription: g = "draggable",
    tabIndex: m = 0
  } = r ?? {}, v = (s == null ? void 0 : s.id) === e, b = Le(v ? Ab : GL), [y, w] = Kp(), S = _L(p, e), x = Eb(t);
  G(
    () => (u[e] = {
      id: e,
      key: o,
      node: y,
      data: x
    }, () => {
      const P = u[e];
      P && P.key === o && delete u[e];
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [u, e]
  );
  const C = ie(() => ({
    role: h,
    tabIndex: m,
    "aria-pressed": v && h === pg ? !0 : void 0,
    "aria-roledescription": g,
    "aria-describedby": l.draggable
  }), [h, m, v, g, l.draggable]);
  return {
    active: s,
    activeNodeRect: i,
    activatorEvent: a,
    attributes: C,
    droppableRects: d,
    isDragging: v,
    listeners: n ? void 0 : S,
    node: y,
    over: f,
    setNodeRef: w,
    transform: b
  };
}
function YL() {
  return Le(cc);
}
const XL = "Droppable";
function ZL({
  data: e,
  disabled: t = !1,
  id: n
}) {
  const r = ra(XL), {
    active: o,
    dispatch: s,
    over: i
  } = Le(cc), a = K(null), [l, u] = Kp(), d = Eb(e);
  return _o(
    () => (s({
      type: tt.RegisterDroppable,
      element: {
        id: n,
        key: r,
        disabled: t,
        node: l,
        rect: a,
        data: d
      }
    }), () => s({
      type: tt.UnregisterDroppable,
      key: r,
      id: n
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  ), G(
    () => {
      s({
        type: tt.SetDroppableDisabled,
        id: n,
        key: r,
        disabled: t
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t]
  ), {
    active: o,
    rect: a,
    isOver: (i == null ? void 0 : i.id) === n,
    node: l,
    over: i,
    setNodeRef: u
  };
}
function JL(e, t, n) {
  const r = {
    ...e
  };
  return t.top + e.y <= n.top ? r.y = n.top - t.top : t.bottom + e.y >= n.top + n.height && (r.y = n.top + n.height - t.bottom), t.left + e.x <= n.left ? r.x = n.left - t.left : t.right + e.x >= n.left + n.width && (r.x = n.left + n.width - t.right), r;
}
const QL = ({
  draggingNodeRect: e,
  transform: t,
  scrollableAncestorRects: n
}) => {
  const r = n[0];
  return !e || !r ? t : JL(t, e, r);
}, ek = ({
  transform: e
}) => ({
  ...e,
  x: 0
});
function Lb(e, t, n) {
  const r = e.slice();
  return r.splice(n < 0 ? r.length + n : n, 0, r.splice(t, 1)[0]), r;
}
function tk(e, t) {
  return e.reduce((n, r, o) => {
    const s = t.get(r);
    return s && (n[o] = s), n;
  }, Array(e.length));
}
function Ca(e) {
  return e !== null && e >= 0;
}
const kb = ({
  layoutRects: e,
  activeIndex: t,
  overIndex: n,
  index: r
}) => {
  const o = Lb(e, n, t), s = e[r], i = o[r];
  return !i || !s ? null : {
    x: i.offsetLeft - s.offsetLeft,
    y: i.offsetTop - s.offsetTop,
    scaleX: i.width / s.width,
    scaleY: i.height / s.height
  };
}, Pa = {
  scaleX: 1,
  scaleY: 1
}, nk = ({
  activeIndex: e,
  activeNodeRect: t,
  index: n,
  layoutRects: r,
  overIndex: o
}) => {
  var s;
  const i = (s = r[e]) != null ? s : t;
  if (!i)
    return null;
  if (n === e) {
    const l = r[o];
    return l ? {
      x: 0,
      y: e < o ? l.offsetTop + l.height - (i.offsetTop + i.height) : l.offsetTop - i.offsetTop,
      ...Pa
    } : null;
  }
  const a = rk(r, n, e);
  return n > e && n <= o ? {
    x: 0,
    y: -i.height - a,
    ...Pa
  } : n < e && n >= o ? {
    x: 0,
    y: i.height + a,
    ...Pa
  } : {
    x: 0,
    y: 0,
    ...Pa
  };
};
function rk(e, t, n) {
  const r = e[t], o = e[t - 1], s = e[t + 1];
  return r ? n < t ? o ? r.offsetTop - (o.offsetTop + o.height) : s ? s.offsetTop - (r.offsetTop + r.height) : 0 : s ? s.offsetTop - (r.offsetTop + r.height) : o ? r.offsetTop - (o.offsetTop + o.height) : 0 : 0;
}
const Mb = "Sortable", $b = /* @__PURE__ */ H.createContext({
  activeIndex: -1,
  containerId: Mb,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: kb,
  wasDragging: {
    current: !1
  }
});
function ok({
  children: e,
  id: t,
  items: n,
  strategy: r = kb
}) {
  const {
    active: o,
    dragOverlay: s,
    droppableRects: i,
    over: a,
    recomputeLayouts: l,
    willRecomputeLayouts: u
  } = YL(), d = ra(Mb, t), p = s.rect !== null, f = ie(() => n.map((P) => typeof P == "string" ? P : P.id), [n]), h = o != null, g = K(!1), m = o ? f.indexOf(o.id) : -1, v = m !== -1, b = a ? f.indexOf(a.id) : -1, y = K(f), w = tk(f, i), S = !sk(f, y.current), x = b !== -1 && m === -1 || S;
  _o(() => {
    S && v && !u && l();
  }, [S, v, l, u]), G(() => {
    y.current = f;
  }, [f]), G(() => {
    const P = setTimeout(() => {
      g.current = h;
    }, 100);
    return () => clearTimeout(P);
  }, [h]);
  const C = ie(() => ({
    activeIndex: m,
    containerId: d,
    disableTransforms: x,
    items: f,
    overIndex: b,
    useDragOverlay: p,
    sortedRects: w,
    strategy: r,
    wasDragging: g
  }), [m, d, x, f, b, w, p, r, g]);
  return H.createElement($b.Provider, {
    value: C
  }, e);
}
function sk(e, t) {
  return e.join() === t.join();
}
const ik = ({
  id: e,
  items: t,
  activeIndex: n,
  overIndex: r
}) => Lb(t, n, r).indexOf(e), ak = ({
  containerId: e,
  isSorting: t,
  wasDragging: n,
  index: r,
  items: o,
  newIndex: s,
  previousItems: i,
  previousContainerId: a,
  transition: l
}) => !l || !n || i !== o && r === s ? !1 : t ? !0 : s !== r && e === a, lk = {
  duration: 200,
  easing: "ease"
}, Rb = "transform", ck = /* @__PURE__ */ Ai.Transition.toString({
  property: Rb,
  duration: 0,
  easing: "linear"
}), uk = {
  roleDescription: "sortable"
};
function dk({
  disabled: e,
  index: t,
  node: n,
  rect: r
}) {
  const [o, s] = W(null), i = K(t);
  return _o(() => {
    if (!e && t !== i.current && n.current) {
      const a = r.current;
      if (a) {
        const l = dc(n.current), u = {
          x: a.offsetLeft - l.offsetLeft,
          y: a.offsetTop - l.offsetTop,
          scaleX: a.width / l.width,
          scaleY: a.height / l.height
        };
        (u.x || u.y) && s(u);
      }
    }
    t !== i.current && (i.current = t);
  }, [e, t, n, r]), G(() => {
    o && requestAnimationFrame(() => {
      s(null);
    });
  }, [o]), o;
}
function pk({
  animateLayoutChanges: e = ak,
  attributes: t,
  disabled: n,
  data: r,
  getNewIndex: o = ik,
  id: s,
  strategy: i,
  transition: a = lk
}) {
  const {
    items: l,
    containerId: u,
    activeIndex: d,
    disableTransforms: p,
    sortedRects: f,
    overIndex: h,
    useDragOverlay: g,
    strategy: m,
    wasDragging: v
  } = Le($b), b = l.indexOf(s), y = ie(() => ({
    sortable: {
      containerId: u,
      index: b,
      items: l
    },
    ...r
  }), [u, r, b, l]), {
    rect: w,
    node: S,
    setNodeRef: x
  } = ZL({
    id: s,
    data: y
  }), {
    active: C,
    activeNodeRect: P,
    activatorEvent: _,
    attributes: O,
    setNodeRef: E,
    listeners: T,
    isDragging: R,
    over: B,
    transform: U
  } = qL({
    id: s,
    data: y,
    attributes: {
      ...uk,
      ...t
    },
    disabled: n
  }), L = z3(x, E), M = !!C, D = M && v.current && !p && Ca(d) && Ca(h), V = !g && R, k = V && D ? U : null, Y = D ? k ?? (i ?? m)({
    layoutRects: f,
    activeNodeRect: P,
    activeIndex: d,
    overIndex: h,
    index: b
  }) : null, J = Ca(d) && Ca(h) ? o({
    id: s,
    items: l,
    activeIndex: d,
    overIndex: h
  }) : b, le = K(l), Q = l !== le.current, re = K(J), ge = K(u), X = e({
    active: C,
    containerId: u,
    isDragging: R,
    isSorting: M,
    id: s,
    index: b,
    items: l,
    newIndex: re.current,
    previousItems: le.current,
    previousContainerId: ge.current,
    transition: a,
    wasDragging: v.current
  }), Z = dk({
    disabled: !X,
    index: b,
    node: S,
    rect: w
  });
  return G(() => {
    M && re.current !== J && (re.current = J), u !== ge.current && (ge.current = u), l !== le.current && (le.current = l);
  }, [M, J, u, l]), {
    active: C,
    attributes: O,
    activatorEvent: _,
    rect: w,
    index: b,
    isSorting: M,
    isDragging: R,
    listeners: T,
    node: S,
    overIndex: h,
    over: B,
    setNodeRef: L,
    setDroppableNodeRef: x,
    setDraggableNodeRef: E,
    transform: Z ?? Y,
    transition: te()
  };
  function te() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      Z || // Or to prevent items jumping to back to their "new" position when items change
      Q && re.current === b
    )
      return ck;
    if (!(V || !a) && (M || X))
      return Ai.Transition.toString({
        ...a,
        property: Rb
      });
  }
}
const fk = [Ie.Down, Ie.Right, Ie.Up, Ie.Left], hk = (e, {
  context: {
    active: t,
    droppableContainers: n,
    translatedRect: r,
    scrollableAncestors: o
  }
}) => {
  if (fk.includes(e.code)) {
    if (e.preventDefault(), !t || !r)
      return;
    const i = [];
    n.getEnabled().forEach((l) => {
      if (!l || l != null && l.disabled)
        return;
      const u = l == null ? void 0 : l.node.current;
      if (!u)
        return;
      const d = Cd(u), p = {
        ...l,
        rect: {
          current: d
        }
      };
      switch (e.code) {
        case Ie.Down:
          r.top + r.height <= d.top && i.push(p);
          break;
        case Ie.Up:
          r.top >= d.top + d.height && i.push(p);
          break;
        case Ie.Left:
          r.left >= d.left + d.width && i.push(p);
          break;
        case Ie.Right:
          r.left + r.width <= d.left && i.push(p);
          break;
      }
    });
    const a = hL({
      active: t,
      collisionRect: r,
      droppableContainers: i
    });
    if (a) {
      var s;
      const l = (s = n.get(a)) == null ? void 0 : s.node.current;
      if (l) {
        const d = qp(l).some((g, m) => o[m] !== g), p = Cd(l), f = d ? {
          x: 0,
          y: 0
        } : {
          x: r.width - p.width,
          y: r.height - p.height
        };
        return {
          x: p.left - f.x,
          y: p.top - f.y
        };
      }
    }
  }
};
function gk(e) {
  const { id: t, item: n, className: r, select: o, remove: s, renderItem: i, previewStyle: a } = e, { attributes: l, listeners: u, setNodeRef: d, transform: p, transition: f } = pk({ id: t }), h = {
    transform: Ai.Transform.toString(p),
    transition: f
  };
  return /* @__PURE__ */ c("div", { ref: d, style: h, ...l, children: /* @__PURE__ */ A(
    I,
    {
      space: "s",
      onClick: () => o == null ? void 0 : o(n),
      className: r,
      items: "center",
      nowrap: !0,
      children: [
        /* @__PURE__ */ c(N, { className: $(Qe.hover, "cursor-grab"), ...u, children: /* @__PURE__ */ c(oe, { icon: ne.dotsVertical, size: pe.sx }) }),
        /* @__PURE__ */ c(N, { grow: !0, className: $("overflow-hidden"), children: /* @__PURE__ */ A(I, { children: [
          /* @__PURE__ */ c(N, { grow: !0, className: $("overflow-ellipsis overflow-hidden"), children: i(n) }),
          !!a && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c("div", { className: $("w-4 h-4 gjs-bg-white", se.b, se.rnd), style: a(n) }) })
        ] }) }),
        /* @__PURE__ */ c(
          N,
          {
            className: $(Qe.click),
            onClick: (m) => {
              ds(m), s == null || s(n);
            },
            children: /* @__PURE__ */ c(oe, { icon: ne.close, size: pe.sx })
          }
        )
      ]
    },
    n.getIndex ? n.getIndex() : n.id || n.cid
  ) });
}
const Ea = (e) => e.cid ?? e.id;
function gr({
  className: e,
  items: t,
  selected: n,
  children: r,
  title: o,
  titleAdd: s,
  label: i,
  select: a,
  add: l,
  move: u,
  remove: d,
  renderItem: p,
  previewStyle: f
}) {
  const h = RL(
    lg(Zp),
    lg(Yp, { coordinateGetter: hk })
  );
  function g(v) {
    const { active: b, over: y } = v;
    if (b.id !== (y == null ? void 0 : y.id)) {
      const w = t.find((x) => Ea(x) === b.id), S = t.findIndex((x) => Ea(x) === (y == null ? void 0 : y.id));
      w && (u == null || u(w, S));
    }
  }
  const m = $(se.rnd, z.br, t.length && se.b, t.length && "gjs-mt-1");
  return /* @__PURE__ */ A("div", { className: $(e, "w-full"), children: [
    !!(i || l) && /* @__PURE__ */ A(I, { items: "center", children: [
      /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c($t, { size: "s", children: i }) }),
      !!l && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(yt, { title: s, inline: !0, children: /* @__PURE__ */ c(Ze, { onClick: l, size: "s", children: /* @__PURE__ */ c(oe, { icon: ne.plus, size: pe.s }) }) }) })
    ] }),
    /* @__PURE__ */ c(
      Rr,
      {
        placement: "left",
        size: "s",
        buttonAs: "div",
        title: o,
        classNameBody: "gs-utl-gap-2 gs-utl-flex gs-utl-flex-col",
        open: !!n,
        onClose: () => a == null ? void 0 : a(null),
        handler: /* @__PURE__ */ c(
          WL,
          {
            sensors: h,
            collisionDetection: oL,
            onDragEnd: g,
            modifiers: [ek, QL],
            children: /* @__PURE__ */ c(ok, { items: t.map(Ea), strategy: nk, children: /* @__PURE__ */ c("div", { className: m, children: t.map((v, b) => {
              const y = Ea(v), w = v === n, S = $(
                "gjs-px-2 gjs-py-2 text-xs",
                z.br,
                b && se.bt,
                !w && z.hBgH2,
                w && z.bgH
              );
              return /* @__PURE__ */ c(
                gk,
                {
                  id: y,
                  item: v,
                  className: S,
                  select: a,
                  remove: d,
                  renderItem: p,
                  previewStyle: f
                },
                y
              );
            }) }) })
          }
        ),
        children: r
      }
    )
  ] });
}
const fr = "gs-cmp-file-field";
function ki({
  className: e,
  value: t,
  label: n,
  btnLabel: r,
  nameLabel: o,
  size: s,
  isContain: i,
  clear: a,
  inputField: l,
  placeholder: u,
  description: d,
  preview: p = 50,
  onChange: f,
  onOpen: h
}) {
  var w;
  const g = (t || "").replace(/^"|"$/gi, ""), m = ((w = g.split("/").pop()) == null ? void 0 : w.split("?")[0]) || "", v = { minWidth: p, minHeight: p }, b = g ? { ...v, backgroundImage: `url("${g}")` } : v, y = q(
    " gs-utl-w-full gs-utl-bg-checker gs-utl-bg-no-repeat gs-utl-bg-center",
    i ? "gs-utl-bg-contain" : "gs-utl-bg-cover",
    se.b,
    se.rnd,
    z.br
  );
  return /* @__PURE__ */ A(I, { className: q(fr, e, "gs-utl-gap-1"), col: !0, nowrap: !0, children: [
    !!n && /* @__PURE__ */ c($t, { className: q(`${fr}-label`), size: s, m: "", children: n }),
    !!d && /* @__PURE__ */ c($t, { className: q(`${fr}-desc`, z.txtLowEmphasis), size: s, as: "span", m: "", capitalize: !1, children: d }),
    /* @__PURE__ */ A(I, { className: q(`${fr}-content gs-utl-gap-1`, z.bg), items: "center", nowrap: !0, children: [
      /* @__PURE__ */ c(N, { className: q(`${fr}-preview`), children: /* @__PURE__ */ c("div", { className: y, style: b }) }),
      /* @__PURE__ */ A(N, { className: q(`${fr}-fields gs-utl-overflow-hidden`), grow: !0, children: [
        m && o !== !1 && /* @__PURE__ */ c(
          $t,
          {
            className: q(`${fr}-name`, "gs-utl-mb-2", Qe.txtEllips),
            as: "div",
            size: s,
            capitalize: !1,
            children: m
          }
        ),
        /* @__PURE__ */ A(I, { className: q(`${fr}-buttons`), space: "s", nowrap: !0, children: [
          /* @__PURE__ */ c(Ze, { onClick: () => h == null ? void 0 : h(t), size: s, type: "button", block: !0, full: !0, children: r || "Select image" }),
          !!t && a && /* @__PURE__ */ c(
            Ft,
            {
              onClick: () => f == null ? void 0 : f(""),
              title: a.tooltip,
              size: s,
              icon: { icon: ne.close, size: pe.s },
              type: "button",
              block: !0
            }
          )
        ] })
      ] })
    ] }),
    l && /* @__PURE__ */ c(
      ft,
      {
        className: q(`${fr}-input`),
        value: g,
        onChange: f,
        size: s,
        placeholder: u
      }
    )
  ] });
}
function vl(e) {
  return e.isFull() || ["slider", "composite", "stack", "file"].includes(e.getType());
}
function mk(e) {
  return ["composite", "stack"].includes(e.getType());
}
function bl({ property: e }) {
  switch (e.getType()) {
    case "number":
    case "slider":
    case "integer":
      return /* @__PURE__ */ c(Me, { ...qe(e) });
    case "color":
      return /* @__PURE__ */ c(Lr, { ...Mr(e) });
    case "select":
      return /* @__PURE__ */ c(Ae, { ...Fe(e) });
    case "radio":
      return /* @__PURE__ */ c(Bt, { ...Fe(e) });
    case "file":
      return /* @__PURE__ */ c(ki, { ...Rk(e) });
    case "composite":
      return /* @__PURE__ */ c(
        Yt,
        {
          property: e,
          corners: e.get("corners"),
          generic: e.get("generic")
        }
      );
    case "stack":
      return /* @__PURE__ */ c(gr, { ...Br(e), children: e.getProperties().map((t) => /* @__PURE__ */ c(he, { property: t, className: F(vl(t) && "col-span-full"), children: /* @__PURE__ */ c(bl, { property: t }) }, t.getId())) });
    default:
      return /* @__PURE__ */ c(ft, { ...Mr(e) });
  }
}
function vk({ sector: e }) {
  const t = e.getProperties().filter((n) => n.isVisible());
  return /* @__PURE__ */ c("div", { className: F("grid grid-cols-2 gap-2"), children: t.map(
    (n) => mk(n) ? /* @__PURE__ */ c("div", { className: F(vl(n) && "col-span-full"), children: /* @__PURE__ */ c(bl, { property: n }) }, n.getId()) : /* @__PURE__ */ c(he, { property: n, className: F(vl(n) && "col-span-full"), children: /* @__PURE__ */ c(bl, { property: n }) }, n.getId())
  ) });
}
const bk = "gs-cmp-sector-row";
function be({ className: e, children: t, bottom: n, separator: r, separatorTop: o, property: s, ...i }) {
  const a = /* @__PURE__ */ c("div", { className: $("gjs-mb-2 -gjs-ml-2 -gjs-mr-2", se.bb, z.br) }), l = $(bk, e, "w-full gs-utl-gap-2", n), u = (Array.isArray(s) ? s : [s]).filter(Boolean);
  return (u.length ? u.some((p) => p.isVisible()) : !0) ? /* @__PURE__ */ A(ae, { children: [
    o && a,
    /* @__PURE__ */ c(I, { className: l, nowrap: !0, ...i, children: t }),
    r && a
  ] }) : null;
}
function qs(e, t, n = {}) {
  const r = e.getType(), { compact: o = !1 } = n, s = e.getParent(), i = e.getDefaultValue();
  if (r === "select") {
    const l = { property: s.getName() };
    return /* @__PURE__ */ c(
      Ae,
      {
        ...Fe(e, l),
        ...t ? {
          value: t.same ? e.getValue({ noDefault: !0 }) : "",
          emptyState: t.same ? e.getOptionLabel(i, l) || i : "Custom",
          onChange: (u) => t.all.map((d) => d.upValue(u))
        } : {}
      }
    );
  } else
    return r === "color" ? /* @__PURE__ */ c(
      Lr,
      {
        ...Mr(e),
        ...t ? {
          value: t.same ? e.getValue({ noDefault: !0 }) : "",
          placeholder: t.same ? i : "Custom",
          onChange: (a, l) => t.all.map((u) => u.upValue(a, { partial: l }))
        } : {}
      }
    ) : /* @__PURE__ */ c(
      Me,
      {
        ...qe(e),
        ...o ? { pan: e.getLabel()[0] } : {},
        ...t ? {
          value: t.same ? e.getValue({ noDefault: !0 }) : "",
          valueUnit: t.same ? e.getUnit() : "",
          placeholder: t.same ? i : "Custom",
          onChange: (a, l) => t.all.map((u) => u.upValue(a, { partial: l })),
          onChangeUnit: (a) => t.all.map((l) => l.upUnit(a))
        } : {}
      }
    );
}
function Yt({ property: e, corners: t, compact: n, generic: r, children: o, options: s }) {
  const i = {
    id: "custom",
    label: /* @__PURE__ */ c(oe, { icon: ne.borderStyle, size: pe.s }),
    title: "Custom"
  }, a = [
    { id: "all", label: /* @__PURE__ */ c(oe, { icon: ne.borderAllVariant, size: pe.s }), title: "All" },
    i
  ], [l, u] = W(null), d = e.isDetached(), p = e.getProperties(), f = p.length, [h, g, m, v] = p, b = h.getFullValue(), w = p.map((U) => U.getFullValue()).every((U) => U === b), S = l !== null ? l : w || s ? "all" : i.id, x = s ? [...s, i] : [], C = e.getFullValue(), P = x.some((U) => U.id === C), _ = S === i.id || (s ? !P : !1) || !!r, O = /* @__PURE__ */ c(he, { property: n ? null : h, shallow: !d, children: qs(h, null, { compact: n }) }), E = /* @__PURE__ */ c(he, { property: n ? null : g, shallow: !d, children: qs(g, null, { compact: n }) }), T = !!m && /* @__PURE__ */ c(he, { property: n ? null : m, shallow: !d, children: qs(m, null, { compact: n }) }), R = !!v && /* @__PURE__ */ c(he, { property: n ? null : v, shallow: !d, children: qs(v, null, { compact: n }) }), B = n ? { label: e.getLabel() } : { property: e };
  return e != null && e.isVisible() ? /* @__PURE__ */ A(I, { className: $("w-full gs-utl-gap-2"), col: !0, nowrap: !0, children: [
    /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { ...B, children: !r && /* @__PURE__ */ c(be, { bottom: "0", children: o !== void 0 ? o : s ? /* @__PURE__ */ c(ae, { children: /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(
      Bt,
      {
        size: "s",
        options: x,
        value: _ ? i.id : C,
        onChange: (U) => {
          U === i.id ? u(U) : (e.upValue(U), u(""));
        }
      }
    ) }) }) : /* @__PURE__ */ A(ae, { children: [
      /* @__PURE__ */ c(N, { grow: !0, children: qs(h, { same: w, all: p }) }),
      /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(Bt, { size: "s", options: a, value: S, onChange: u }) })
    ] }) }) }) }),
    _ && /* @__PURE__ */ c(be, { col: !0, className: $("gjs-px-2 gjs-py-1", z.bgH2, se.rnd, se.b, z.br), children: r ? /* @__PURE__ */ c("div", { className: $("grid grid-cols-2 gap-2"), children: p.map((U) => /* @__PURE__ */ c(
      he,
      {
        property: U,
        shallow: !d,
        className: $(vl(U) && "col-span-full"),
        children: /* @__PURE__ */ c(bl, { property: U })
      },
      U.getId()
    )) }) : f === 2 ? /* @__PURE__ */ c(ae, { children: /* @__PURE__ */ A(I, { space: "s", children: [
      /* @__PURE__ */ c(N, { grow: !0, children: O }),
      /* @__PURE__ */ c(N, { grow: !0, children: E })
    ] }) }) : f === 3 ? /* @__PURE__ */ A(ae, { children: [
      /* @__PURE__ */ A(I, { space: "s", children: [
        /* @__PURE__ */ c(N, { grow: !0, children: O }),
        /* @__PURE__ */ c(N, { grow: !0, children: E })
      ] }),
      /* @__PURE__ */ c(I, { space: "s", children: /* @__PURE__ */ c(N, { grow: !0, children: T }) })
    ] }) : t ? /* @__PURE__ */ A(ae, { children: [
      /* @__PURE__ */ A(I, { space: "s", children: [
        /* @__PURE__ */ c(N, { grow: !0, children: O }),
        /* @__PURE__ */ c(N, { grow: !0, children: E })
      ] }),
      /* @__PURE__ */ A(I, { space: "s", children: [
        /* @__PURE__ */ c(N, { grow: !0, children: R }),
        /* @__PURE__ */ c(N, { grow: !0, children: T })
      ] })
    ] }) : /* @__PURE__ */ A(ae, { children: [
      /* @__PURE__ */ c(I, { className: $("gs-utl-w-1/2 gjs-m-auto"), children: O }),
      /* @__PURE__ */ A(I, { space: "s", children: [
        /* @__PURE__ */ c(N, { grow: !0, children: R }),
        /* @__PURE__ */ c(N, { grow: !0, children: E })
      ] }),
      /* @__PURE__ */ c(I, { className: $("gs-utl-w-1/2 gjs-m-auto"), children: T })
    ] }) })
  ] }) : null;
}
function yk({ sector: e }) {
  const t = e.getProperty("border-radius");
  return /* @__PURE__ */ A(ae, { children: [
    /* @__PURE__ */ c(Yt, { property: t, corners: !0 }),
    /* @__PURE__ */ c(Yt, { property: e.getProperty("border-width") }),
    /* @__PURE__ */ c(Yt, { property: e.getProperty("border-style") }),
    /* @__PURE__ */ c(Yt, { property: e.getProperty("border-color") })
  ] });
}
const po = (e) => ac({ value: parseFloat(e), min: -3, max: 3 }), gu = (e, t = "filter") => {
  const n = e.getProperty(`${t}-value`), r = e.getProperty(`${t}-name`).getOption() || {}, o = r.units || [], s = n.getUnit(), i = H3(s, o) ? s : o[0];
  return {
    ...qe(n),
    units: o,
    valueUnit: i,
    onChange: (a, l) => {
      n.upValue(a, {
        partial: l,
        units: o,
        min: r.min,
        max: r.max
      });
    }
  };
}, fg = (e, t) => {
  const n = e.getProperty(`${t}-name`), r = e.getProperty(`${t}-value`);
  return {
    ...Fe(n),
    onChange: (o) => {
      n.upValue(o), r.upValue("");
    }
  };
}, wk = {
  "text-shadow-h": "1px",
  "text-shadow-v": "1px",
  "text-shadow-blur": "5px"
};
function Sk({ sector: e }) {
  const t = e.getProperty("box-shadow"), n = e.getProperty("text-shadow"), r = e.getProperty("filter"), o = e.getProperty("backdrop-filter"), s = e.getProperty("transition"), i = e.getProperty("transform"), a = e.getProperty("perspective-origin"), l = e.getProperty("backface-visibility"), u = e.getProperty("perspective"), d = e.getProperty("transform-style"), p = e.getProperty("opacity"), f = e.getProperty("mix-blend-mode"), h = e.getProperty("cursor"), g = (v) => {
    const {
      boxShadowH: b,
      boxShadowV: y,
      boxShadowBlur: w,
      boxShadowColor: S,
      boxShadowSpread: x,
      boxShadowType: C
    } = v.getValues({ camelCase: !0 }), P = po(b), _ = po(y), O = po(w), E = po(x), T = `${P}px ${_}px ${O}px ${E}px ${S} ${C}`.trim();
    return /* @__PURE__ */ A(I, { space: "s", items: "center", children: [
      /* @__PURE__ */ A(N, { grow: !0, children: [
        b,
        " ",
        y,
        " ",
        w,
        " ",
        x
      ] }),
      /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c("div", { className: $("w-4 h-4 gjs-bg-white", se.b, se.rnd), style: { boxShadow: T } }) })
    ] });
  }, m = (v) => {
    const {
      textShadowH: b,
      textShadowV: y,
      textShadowBlur: w,
      textShadowColor: S
    } = v.getValues({ camelCase: !0 }), x = po(b), C = po(y), P = po(w), _ = `${x}px ${C}px ${P}px ${S}`.trim();
    return /* @__PURE__ */ A(I, { space: "s", items: "center", children: [
      /* @__PURE__ */ A(N, { grow: !0, children: [
        b,
        " ",
        y,
        " ",
        w
      ] }),
      /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c("div", { className: $("w-4 h-4 gjs-bg-white", se.b, se.rnd), style: { boxShadow: _ } }) })
    ] });
  };
  return /* @__PURE__ */ A(ae, { children: [
    /* @__PURE__ */ A(be, { property: [p, f], children: [
      /* @__PURE__ */ c(he, { property: p, children: /* @__PURE__ */ c(Me, { ...qe(p) }) }),
      /* @__PURE__ */ c(he, { property: f, children: /* @__PURE__ */ c(Ae, { ...Fe(f) }) })
    ] }),
    /* @__PURE__ */ c(be, { property: h, separator: !0, children: /* @__PURE__ */ c(he, { property: h, children: /* @__PURE__ */ c(Ae, { ...Fe(h) }) }) }),
    /* @__PURE__ */ c(be, { property: t, separator: !0, children: /* @__PURE__ */ A(gr, { ...Br(t), renderItem: g, children: [
      /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(Bt, { ...Fe(t.getProperty("box-shadow-type")) }) }),
      /* @__PURE__ */ A(be, { children: [
        /* @__PURE__ */ c(he, { label: "X offset", children: /* @__PURE__ */ c(Me, { ...qe(t.getProperty("box-shadow-h")) }) }),
        /* @__PURE__ */ c(he, { label: "Y offset", children: /* @__PURE__ */ c(Me, { ...qe(t.getProperty("box-shadow-v")) }) })
      ] }),
      /* @__PURE__ */ A(be, { children: [
        /* @__PURE__ */ c(he, { label: "Blur", children: /* @__PURE__ */ c(Me, { ...qe(t.getProperty("box-shadow-blur")) }) }),
        /* @__PURE__ */ c(he, { label: "Spread", children: /* @__PURE__ */ c(Me, { ...qe(t.getProperty("box-shadow-spread")) }) })
      ] }),
      /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { label: "Color", children: /* @__PURE__ */ c(Lr, { ...Mr(t.getProperty("box-shadow-color")) }) }) })
    ] }) }),
    /* @__PURE__ */ c(be, { property: n, separator: !0, children: /* @__PURE__ */ A(gr, { ...Br(n, wk), renderItem: m, children: [
      /* @__PURE__ */ A(be, { children: [
        /* @__PURE__ */ c(he, { label: "X offset", children: /* @__PURE__ */ c(Me, { ...qe(n.getProperty("text-shadow-h")) }) }),
        /* @__PURE__ */ c(he, { label: "Y offset", children: /* @__PURE__ */ c(Me, { ...qe(n.getProperty("text-shadow-v")) }) })
      ] }),
      /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { label: "Blur", children: /* @__PURE__ */ c(Me, { ...qe(n.getProperty("text-shadow-blur")) }) }) }),
      /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { label: "Color", children: /* @__PURE__ */ c(Lr, { ...Mr(n.getProperty("text-shadow-color")) }) }) })
    ] }) }),
    /* @__PURE__ */ c(be, { property: r, separator: !0, children: /* @__PURE__ */ c(gr, { ...Br(r, { "filter-name": "blur", "filter-value": "3px" }), children: /* @__PURE__ */ A(be, { children: [
      /* @__PURE__ */ c(he, { label: "Type", children: /* @__PURE__ */ c(Ae, { ...fg(r, "filter") }) }),
      /* @__PURE__ */ c(he, { label: "Value", children: /* @__PURE__ */ c(Me, { ...gu(r) }) })
    ] }) }) }),
    /* @__PURE__ */ c(be, { property: o, separator: !0, children: /* @__PURE__ */ c(
      gr,
      {
        ...Br(o, { "backdrop-filter-name": "blur", "backdrop-filter-value": "3px" }),
        children: /* @__PURE__ */ A(be, { children: [
          /* @__PURE__ */ c(he, { label: "Type", children: /* @__PURE__ */ c(Ae, { ...Fe(o.getProperty("backdrop-filter-name")) }) }),
          /* @__PURE__ */ c(he, { label: "Value", children: /* @__PURE__ */ c(Me, { ...gu(o, "backdrop-filter") }) })
        ] })
      }
    ) }),
    /* @__PURE__ */ c(be, { property: s, separator: !0, children: /* @__PURE__ */ A(gr, { ...Br(s), children: [
      /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { label: "Type", children: /* @__PURE__ */ c(Ae, { ...Fe(s.getProperty("transition-property")) }) }) }),
      /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { label: "Easing", children: /* @__PURE__ */ c(
        Ae,
        {
          ...Fe(s.getProperty("transition-timing-function"))
        }
      ) }) }),
      /* @__PURE__ */ A(be, { children: [
        /* @__PURE__ */ c(he, { label: "Duration", children: /* @__PURE__ */ c(Me, { ...qe(s.getProperty("transition-duration")) }) }),
        /* @__PURE__ */ c(he, { label: "Delay", children: /* @__PURE__ */ c(Me, { ...qe(s.getProperty("transition-delay")) }) })
      ] })
    ] }) }),
    /* @__PURE__ */ c(be, { property: i, separator: !0, children: /* @__PURE__ */ c(gr, { ...Br(i), children: /* @__PURE__ */ A(be, { children: [
      /* @__PURE__ */ c(he, { label: "Type", children: /* @__PURE__ */ c(Ae, { ...fg(i, "transform") }) }),
      /* @__PURE__ */ c(he, { label: "Value", children: /* @__PURE__ */ c(Me, { ...gu(i, "transform") }) })
    ] }) }) }),
    /* @__PURE__ */ c(Yt, { property: e.getProperty("transform-origin") }),
    /* @__PURE__ */ c(Yt, { property: e.getProperty("overflow") }),
    /* @__PURE__ */ c(be, { property: l, children: /* @__PURE__ */ c(he, { property: l, children: /* @__PURE__ */ c(Bt, { ...Fe(l) }) }) }),
    /* @__PURE__ */ c(be, { property: [u, d, a], separatorTop: !0, children: "Children transform" }),
    /* @__PURE__ */ A(be, { property: [u, d], children: [
      /* @__PURE__ */ c(he, { property: u, children: /* @__PURE__ */ c(Me, { ...qe(u) }) }),
      /* @__PURE__ */ c(he, { property: d, children: /* @__PURE__ */ c(Bt, { ...Fe(d) }) })
    ] }),
    /* @__PURE__ */ c(Yt, { property: a })
  ] });
}
function xk(e, t) {
  return e.indexOf(t) >= 0;
}
const ot = pe.s, Oa = "M6 6v12h13V6H6zm0 13v5H5V0h1v5h13c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H6zm6-14h1v14h-1V5z", _a = "M6 6v12h13V6H6zm0-1h13c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H6a1 1 0 01-1-1V6c0-.6.4-1 1-1zm6-5h1v24h-1V0z", Ta = "M6 6v12h13V6H6zm13-1V0h1v24h-1v-5H6a1 1 0 01-1-1V6c0-.6.4-1 1-1h13zm-7 0h1v14h-1V5z", hg = "M2 6v12h6V6H2zm0 13v5H1V0h1v5h6c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H2zM16 6v12h6V6h-6zm6-1V0h1v24h-1v-5h-6a1 1 0 01-1-1V6c0-.6.4-1 1-1h6z", gg = "M11 0h1v24h-1V0zM1 6h6v12H1V6zm0-1h6c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H1a1 1 0 01-1-1V6c0-.6.4-1 1-1zm15 1h6v12h-6V6zm0-1h6c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1h-6a1 1 0 01-1-1V6c0-.6.4-1 1-1z", Ck = "M3 6v12h6V6H3zm0-1h6c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H3a1 1 0 01-1-1V6c0-.6.4-1 1-1zM0 0h1v24H0V0zm14 6v12h6V6h-6zm0-1h6c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1h-6a1 1 0 01-1-1V6c0-.6.4-1 1-1zm8-5h1v24h-1V0zM11 0h1v24h-1V0z", mu = "M15 19H9V6h6v13zM8 6v13H0v1h24v-1h-8V6h8V5H0v1h8z";
function Pk({ sector: e }) {
  const { editor: t } = ye(), n = Ne(), [r, o] = W({}), [s, i] = W({}), a = e.getProperty("display"), l = e.getProperty("flex-direction"), u = e.getProperty("justify-content"), d = e.getProperty("align-items"), p = e.getProperty("flex-wrap"), f = e.getProperty("align-content"), h = e.getProperty("align-self"), g = e.getProperty("order"), m = (R) => n.t(`styleManager.layout.${R}`), v = a.getValue(), b = v === "flex", y = (s.display || "").indexOf("flex") >= 0, w = l.getValue(), S = w.indexOf("reverse") >= 0, x = !xk(["column", "column-reverse"], w), C = [
    { id: "row", label: /* @__PURE__ */ c(oe, { icon: ne.arrowRight, size: pe.sx }), title: m("direction.title.row") },
    {
      id: "row-reverse",
      label: /* @__PURE__ */ c(oe, { icon: ne.arrowRight, size: ot, horizontal: !0 }),
      title: m("direction.title.row-reverse")
    },
    {
      id: "column",
      label: /* @__PURE__ */ c(oe, { icon: ne.arrowDown, size: pe.sx }),
      title: m("direction.title.column")
    },
    {
      id: "column-reverse",
      label: /* @__PURE__ */ c(oe, { icon: ne.arrowDown, size: ot, vertical: !0 }),
      title: m("direction.title.column-reverse")
    }
  ], P = [
    {
      id: "flex-start",
      title: "Start",
      label: /* @__PURE__ */ c(
        oe,
        {
          icon: Oa,
          size: ot,
          rotate: x ? 0 : 90,
          horizontal: x && S,
          vertical: !x && S
        }
      )
    },
    { id: "center", title: "Center", label: /* @__PURE__ */ c(oe, { icon: _a, size: ot, rotate: x ? 0 : 90 }) },
    {
      id: "flex-end",
      title: "End",
      label: /* @__PURE__ */ c(
        oe,
        {
          icon: Ta,
          size: ot,
          rotate: x ? 0 : 90,
          horizontal: x && S,
          vertical: !x && S
        }
      )
    },
    {
      id: "space-between",
      title: "Space between",
      label: /* @__PURE__ */ c(oe, { icon: hg, size: ot, rotate: x ? 0 : 90 })
    },
    {
      id: "space-around",
      title: "Space around",
      label: /* @__PURE__ */ c(oe, { icon: gg, size: ot, rotate: x ? 0 : 90 })
    },
    {
      id: "space-evenly",
      title: "Space evenly",
      label: /* @__PURE__ */ c(oe, { icon: Ck, size: ot, rotate: x ? 0 : 90 })
    }
  ], _ = [
    {
      id: "stretch",
      title: "Stretch",
      label: /* @__PURE__ */ c(oe, { icon: mu, size: ot, rotate: x ? 0 : 90 })
    },
    { id: "flex-start", title: "Start", label: /* @__PURE__ */ c(oe, { icon: Oa, size: ot, rotate: x ? 90 : 0 }) },
    { id: "center", title: "Center", label: /* @__PURE__ */ c(oe, { icon: _a, size: ot, rotate: x ? 90 : 0 }) },
    { id: "flex-end", title: "End", label: /* @__PURE__ */ c(oe, { icon: Ta, size: ot, rotate: x ? 90 : 0 }) }
  ], O = [
    {
      id: "flex-start",
      title: "Start",
      label: /* @__PURE__ */ c(
        oe,
        {
          icon: Oa,
          size: ot,
          rotate: x ? 90 : 0,
          horizontal: x && S,
          vertical: !x && S
        }
      )
    },
    { id: "center", title: "Center", label: /* @__PURE__ */ c(oe, { icon: _a, size: ot, rotate: x ? 90 : 0 }) },
    {
      id: "flex-end",
      title: "End",
      label: /* @__PURE__ */ c(
        oe,
        {
          icon: Ta,
          size: ot,
          rotate: x ? 90 : 0,
          horizontal: x && S,
          vertical: !x && S
        }
      )
    },
    {
      id: "space-between",
      title: "Space between",
      label: /* @__PURE__ */ c(oe, { icon: hg, size: ot, rotate: x ? 90 : 0 })
    },
    {
      id: "space-around",
      title: "Space around",
      label: /* @__PURE__ */ c(oe, { icon: gg, size: ot, rotate: x ? 90 : 0 })
    },
    { id: "stretch", title: "Stretch", label: /* @__PURE__ */ c(oe, { icon: mu, size: ot, rotate: x ? 0 : 90 }) }
  ], E = [
    { id: "auto", title: "Auto", label: /* @__PURE__ */ c(oe, { icon: ne.close, size: ot }) },
    { id: "flex-start", title: "Start", label: /* @__PURE__ */ c(oe, { icon: Oa, size: ot, rotate: 90 }) },
    { id: "center", title: "Center", label: /* @__PURE__ */ c(oe, { icon: _a, size: ot, rotate: 90 }) },
    { id: "flex-end", title: "End", label: /* @__PURE__ */ c(oe, { icon: Ta, size: ot, rotate: 90 }) },
    { id: "stretch", title: "Stretch", label: /* @__PURE__ */ c(oe, { icon: mu, size: ot, rotate: 0 }) }
  ], T = [
    { id: "0 0 auto", label: /* @__PURE__ */ c(oe, { icon: ne.close, size: ot }), title: "Auto" },
    // IconNames.formatVerticalAlignCenter
    {
      id: "1 1 0%",
      label: /* @__PURE__ */ c(oe, { icon: ne.unfoldMoreHorizontal, size: ot, rotate: 90 }),
      title: "Fill container"
    },
    {
      id: "0 1 auto",
      label: /* @__PURE__ */ c(oe, { icon: ne.unfoldLessHorizontal, size: ot, rotate: 90 }),
      title: "Hug contents"
    }
  ];
  return G(() => {
    if (!t)
      return () => {
      };
    const { Styles: R } = t, B = () => {
      const L = t.getSelected();
      let M = {}, D = {};
      if (L) {
        const V = L.getEl();
        if (V) {
          M = window.getComputedStyle(V);
          const k = V.parentElement;
          k && (D = window.getComputedStyle(k));
        }
      }
      o(M), i(D);
    }, U = R.events.target;
    return t.on(U, B), B(), () => t.off(U, B);
  }, [t]), /* @__PURE__ */ A(ae, { children: [
    /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { property: a, tooltip: m(`display.tips.${v}`), row: !0, children: /* @__PURE__ */ c(Ae, { ...Fe(a) }) }) }),
    b && /* @__PURE__ */ A(ae, { children: [
      /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { property: l, children: /* @__PURE__ */ c(Bt, { ...Fe(l), options: C }) }) }),
      /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { property: u, children: /* @__PURE__ */ c(Bt, { ...Fe(u), options: P }) }) }),
      /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { property: d, children: /* @__PURE__ */ c(Bt, { ...Fe(d), options: _ }) }) }),
      /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(Yt, { property: e.getProperty("gap") }) }),
      /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { property: p, row: !0, children: /* @__PURE__ */ c(Ae, { ...Fe(p) }) }) }),
      p.getValue() !== "nowrap" && /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { property: f, children: /* @__PURE__ */ c(Bt, { ...Fe(f), options: O }) }) })
    ] }),
    y && /* @__PURE__ */ A(ae, { children: [
      /* @__PURE__ */ c(be, { separatorTop: !0, children: m("flexChild") }),
      /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(Yt, { property: e.getProperty("flex"), options: T }) }),
      /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { property: h, children: /* @__PURE__ */ c(Bt, { ...Fe(h), options: E }) }) }),
      /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { property: g, row: !0, children: /* @__PURE__ */ c(Me, { ...qe(g) }) }) })
    ] })
  ] });
}
const Ek = [
  "topLeft",
  "topRight",
  "bottomLeft",
  "bottomRight",
  "left",
  "right",
  "bottom",
  "top",
  "full"
];
function Ok({ sector: e }) {
  var f;
  const t = Ne(), n = e.getProperty("position"), r = n.getValue(), o = e.getProperty("top"), s = e.getProperty("right"), i = e.getProperty("bottom"), a = e.getProperty("left"), l = (h) => t.t(`styleManager.position.${h}`), u = Ek.map((h) => ({ id: h, label: l(`presets.options.${h}`) })), d = ["absolute", "fixed"].includes(r), p = (h) => {
    let g = "auto", m = "auto", v = "auto", b = "auto";
    switch (h) {
      case "topLeft":
        g = "0%", b = "0%";
        break;
      case "topRight":
        g = "0%", m = "0%";
        break;
      case "bottomLeft":
        v = "0%", b = "0%";
        break;
      case "bottomRight":
        v = "0%", m = "0%";
        break;
      case "left":
        g = "0%", v = "0%", b = "0%";
        break;
      case "right":
        g = "0%", v = "0%", m = "0%";
        break;
      case "bottom":
        b = "0%", v = "0%", m = "0%";
        break;
      case "top":
        b = "0%", g = "0%", m = "0%";
        break;
      case "full":
        b = "0%", g = "0%", m = "0%", v = "0%";
        break;
    }
    o.upValue(g), s.upValue(m), i.upValue(v), a.upValue(b);
  };
  return /* @__PURE__ */ A(ae, { children: [
    /* @__PURE__ */ A(be, { children: [
      /* @__PURE__ */ c(he, { property: n, tooltip: l(`tips.${(f = n.getOption()) == null ? void 0 : f.id}`), row: !0, children: /* @__PURE__ */ c(Ae, { ...Fe(n) }) }),
      d && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(yt, { title: l("presets.title"), children: /* @__PURE__ */ c(Ae, { options: u, onChange: p, emptyState: "P", size: "s", caret: "", value: !0 }) }) })
    ] }),
    r !== "static" && /* @__PURE__ */ A(ae, { children: [
      /* @__PURE__ */ A(be, { col: !0, children: [
        /* @__PURE__ */ c(I, { className: $("gs-utl-w-1/2 gjs-m-auto"), children: /* @__PURE__ */ c(he, { property: o, children: /* @__PURE__ */ c(Me, { ...qe(o) }) }) }),
        /* @__PURE__ */ A(I, { space: "s", children: [
          /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(he, { property: a, children: /* @__PURE__ */ c(Me, { ...qe(a) }) }) }),
          /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(he, { property: s, children: /* @__PURE__ */ c(Me, { ...qe(s) }) }) })
        ] }),
        /* @__PURE__ */ c(I, { className: $("gs-utl-w-1/2 gjs-m-auto"), children: /* @__PURE__ */ c(he, { property: i, children: /* @__PURE__ */ c(Me, { ...qe(i) }) }) })
      ] }),
      /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { property: e.getProperty("z-index"), children: /* @__PURE__ */ c(Me, { ...qe(e.getProperty("z-index")) }) }) })
    ] })
  ] });
}
function _k({ sector: e }) {
  const t = e.getProperty("width"), n = e.getProperty("min-width"), r = e.getProperty("max-width"), o = e.getProperty("height"), s = e.getProperty("min-height"), i = e.getProperty("max-height");
  return /* @__PURE__ */ A(ae, { children: [
    /* @__PURE__ */ A(be, { property: [t, o], children: [
      /* @__PURE__ */ c(he, { property: t, children: /* @__PURE__ */ c(Me, { ...qe(t) }) }),
      /* @__PURE__ */ c(he, { property: o, children: /* @__PURE__ */ c(Me, { ...qe(o) }) })
    ] }),
    /* @__PURE__ */ A(be, { property: [n, s], children: [
      /* @__PURE__ */ c(he, { property: n, children: /* @__PURE__ */ c(Me, { ...qe(n) }) }),
      /* @__PURE__ */ c(he, { property: s, children: /* @__PURE__ */ c(Me, { ...qe(s) }) })
    ] }),
    /* @__PURE__ */ A(be, { property: [r, i], children: [
      /* @__PURE__ */ c(he, { property: r, children: /* @__PURE__ */ c(Me, { ...qe(r) }) }),
      /* @__PURE__ */ c(he, { property: i, children: /* @__PURE__ */ c(Me, { ...qe(i) }) })
    ] })
  ] });
}
function Tk({ sector: e }) {
  return /* @__PURE__ */ A(ae, { children: [
    /* @__PURE__ */ c(Yt, { property: e.getProperty("padding") }),
    /* @__PURE__ */ c(Yt, { property: e.getProperty("margin") })
  ] });
}
function Ak({ sector: e }) {
  const t = e.getProperty("font-family"), n = e.getProperty("color"), r = e.getProperty("font-size"), o = e.getProperty("font-weight"), s = e.getProperty("line-height"), i = e.getProperty("letter-spacing"), a = e.getProperty("text-align"), l = e.getProperty("vertical-align"), u = e.getProperty("text-decoration"), d = e.getProperty("text-transform"), p = e.getProperty("direction"), f = e.getProperty("white-space");
  return /* @__PURE__ */ A(ae, { children: [
    !!t && /* @__PURE__ */ c(be, { property: t, children: /* @__PURE__ */ c(he, { property: t, children: /* @__PURE__ */ c(Ae, { ...Fe(t) }) }) }),
    !!n && /* @__PURE__ */ c(be, { property: n, children: /* @__PURE__ */ c(he, { property: n, children: /* @__PURE__ */ c(Lr, { ...Mr(n) }) }) }),
    /* @__PURE__ */ A(be, { property: [r, o], children: [
      !!r && /* @__PURE__ */ c(he, { property: r, children: /* @__PURE__ */ c(Me, { ...qe(r) }) }),
      !!o && /* @__PURE__ */ c(he, { property: o, children: /* @__PURE__ */ c(Ae, { ...Fe(o) }) })
    ] }),
    /* @__PURE__ */ A(be, { property: [s, i], children: [
      !!s && /* @__PURE__ */ c(he, { property: s, children: /* @__PURE__ */ c(Me, { ...qe(s) }) }),
      !!i && /* @__PURE__ */ c(he, { property: i, children: /* @__PURE__ */ c(Me, { ...qe(i) }) })
    ] }),
    /* @__PURE__ */ A(be, { property: [a, l], children: [
      !!a && /* @__PURE__ */ c(he, { property: a, children: /* @__PURE__ */ c(Ae, { ...Fe(a) }) }),
      !!l && /* @__PURE__ */ c(he, { property: l, children: /* @__PURE__ */ c(Ae, { ...Fe(l) }) })
    ] }),
    /* @__PURE__ */ A(be, { property: [d, p], children: [
      !!d && /* @__PURE__ */ c(he, { property: d, children: /* @__PURE__ */ c(Ae, { ...Fe(d) }) }),
      !!p && /* @__PURE__ */ c(he, { property: p, children: /* @__PURE__ */ c(Ae, { ...Fe(p) }) })
    ] }),
    /* @__PURE__ */ A(be, { property: [f, u], children: [
      !!f && /* @__PURE__ */ c(he, { property: f, children: /* @__PURE__ */ c(Ae, { ...Fe(f) }) }),
      !!u && /* @__PURE__ */ c(he, { property: u, children: /* @__PURE__ */ c(Ae, { ...Fe(u) }) })
    ] })
  ] });
}
const Nb = "gs-style-manager", Jp = `${Nb}-sector`, Lk = `${Jp}-header`, kk = `${Jp}-content`, jb = (e, t = 0, n = !0) => $(Lk, z.bgH2, Re.xyS, z.br, t && se.bt, (e || n) && se.bb), Mk = (e, t = {}) => e.getOptions().map((n) => ({
  id: e.getOptionId(n),
  label: e.getOptionLabel(e.getOptionId(n), t),
  title: n.title
})), $k = (e, t) => t.map((n) => ({
  ...n,
  title: e.getOptionLabel(e.getOptionId(n))
})), Fe = (e, t = {}) => ({
  size: "s",
  options: Mk(e, t),
  value: e.getValue(),
  onChange: (n) => e.upValue(n)
}), Br = (e, t = {}) => ({
  title: e.getLabel(),
  titleAdd: `Add new ${e.getLabel()}`,
  items: e.getLayers(),
  selected: e.getSelectedLayer(),
  renderItem: (n) => e.getLayerLabel(n),
  add: () => e.addLayer(t, { at: 0 }),
  select: (n) => e.selectLayer(n),
  remove: (n) => e.removeLayer(n),
  move: (n, r = 0) => e.moveLayer(n, r),
  label: /* @__PURE__ */ c(he, { property: e })
}), qe = (e) => ({
  size: "s",
  value: e.getValue({ noDefault: !0 }),
  valueUnit: e.getUnit(),
  units: e.getUnits(),
  placeholder: e.getDefaultValue(),
  onChangeUnit: (t) => e.upUnit(t),
  onChange: (t, n) => e.upValue(t, { partial: n })
}), Mr = (e) => ({
  size: "s",
  value: e.getValue({ noDefault: !0 }),
  placeholder: e.getDefaultValue(),
  onChange: (t, n) => e.upValue(t, { partial: n })
}), Rk = (e) => ({
  ...Mr(e),
  onOpen() {
    const t = e.em.Assets;
    t.open({
      select(n) {
        e.upValue(n.getSrc()), t.close();
      }
    });
  }
}), Nk = (e) => {
  const t = e.getId();
  let n = vk;
  switch (t) {
    case "gs-layout":
      n = Pk;
      break;
    case "gs-size":
      n = _k;
      break;
    case "gs-space":
      n = Tk;
      break;
    case "gs-position":
      n = Ok;
      break;
    case "gs-borders":
      n = yk;
      break;
    case "gs-effects":
      n = Sk;
      break;
    case "gs-typography":
      n = Ak;
      break;
    case "gs-background":
      n = Uk;
      break;
  }
  return /* @__PURE__ */ c(n, { sector: e });
}, Db = ue(function({
  className: t,
  sectors: n
}) {
  const { editor: r } = ye();
  if (!r)
    return null;
  const { Styles: o } = r, s = o.getSelected(), i = n.length ? n : o.getSectors({ visible: !0 });
  return s ? /* @__PURE__ */ c("div", { className: $(Nb, t, "select-none"), children: i.map((a, l) => /* @__PURE__ */ c(
    $o,
    {
      classNameWrap: Jp,
      sticky: !0,
      handler: () => {
        const u = a.getProperties({ withValue: !0 }).length > 0, d = a.getProperties({ withParentValue: !0 }).length > 0;
        return /* @__PURE__ */ A(I, { space: "xs", items: "center", children: [
          /* @__PURE__ */ c(N, { className: $("gjs-mr-2"), children: a.getName() }),
          u && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c("div", { className: $(Qe.dot, z.bgA2) }) }),
          d && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c("div", { className: $(Qe.dot, z.bgW) }) })
        ] });
      },
      className: (u) => jb(u, l, l === i.length - 1),
      children: /* @__PURE__ */ c(I, { className: $(kk, "gs-utl-p-2 gs-utl-gap-2"), col: !0, children: Nk(a) })
    },
    a.getId()
  )) }) : null;
});
function yl({ value: e, label: t, border: n, size: r = "m", tip: o, disabled: s, onChange: i }) {
  const a = !!e, l = $(
    "relative inline-flex items-center h-6 gjs-rounded-full w-11 transition-colors focus:gs-utl-outline-none",
    a ? z.bgA : z.bgH,
    xi.focus,
    n && `${z.br} ${se.b}`
  );
  return /* @__PURE__ */ c(qc.Group, { children: /* @__PURE__ */ A(I, { full: !0, items: "center", children: [
    !!t && /* @__PURE__ */ c(
      qc.Label,
      {
        className: $("gs-utl-mr-4 gs-utl-flex-1 gs-utl-flex gs-utl-gap-2 gs-utl-items-center"),
        passive: !0,
        children: /* @__PURE__ */ c($t, { as: "span", size: r, tip: o, m: "", children: t })
      }
    ),
    /* @__PURE__ */ c(qc, { checked: a, onChange: i, className: l, disabled: s, children: /* @__PURE__ */ c(
      "span",
      {
        className: $(
          z.bg,
          "inline-block w-4 h-4 transform gjs-rounded-full transition-transform",
          a ? "translate-x-6" : "translate-x-1"
        )
      }
    ) })
  ] }) });
}
const jk = /^-?[0-9]+(\.[0-9]+)?[a-zA-Z%]{0,}$/, Dk = /,(?![^(]*\))/, vu = /\s(?![^(]*\))/, Ik = /^(closest-side|closest-corner|farthest-side|farthest-corner)/i, bu = /^circle|ellipse/i, Qp = (e) => {
  var d;
  const t = [], { name: n, value: r } = rc(e), [o, ...s] = r.split(Dk).map((p) => p.trim()).filter(Boolean), i = s.length > 1, a = i ? o : "", l = { type: "none" }, u = i ? s : [o, ...s];
  if (jk.test(a))
    l.type = "angle", l.value = a;
  else if (/^to\s/.test(a))
    l.type = "side-or-corner", l.value = a;
  else if (Ik.test(a))
    l.type = "size", l.value = a;
  else if (bu.test(a) || /^at\s/.test(a) || /\sat\s/.test(a)) {
    l.type = "at", l.value = a;
    const p = ((d = a.match(bu)) == null ? void 0 : d[0]) || "circle";
    l.shape = p;
    const f = { x: "0%", y: "0%" }, h = { x: "0%", y: "0%" }, [g, m] = a.replace(bu, "").trim().split("at").map((v) => v.trim());
    if (g) {
      const [v, b] = g.split(vu);
      f.x = v, f.y = b || v;
    }
    if (m) {
      const [v, b] = m.split(vu);
      h.x = v, h.y = b || v;
    }
    l.size = f, l.position = h;
  }
  return u.forEach((p) => {
    const [f, h] = p.split(vu);
    t.push({ color: f, hint: h ? parseFloat(h) : null });
  }), t.forEach((p, f) => {
    p.hint === null && (p.hint = f / (t.length - 1) * 100);
  }), {
    name: n,
    orientation: l,
    colorStops: t
  };
}, Dr = ({
  stops: e,
  orientation: t = "to right",
  name: n = "linear-gradient"
}) => {
  const o = (e.length === 1 ? [
    { color: e[0].color, hint: null },
    { color: e[0].color, hint: null }
  ] : e).map((s) => `${s.color} ${s.hint ? `${s.hint}%` : ""}`.trim()).join(", ");
  return o ? `${n}(${t}, ${o})` : "none";
}, Vk = (e) => e.slice().sort((t, n) => (t.hint || 0) - (n.hint || 0)), Hk = "gs-cmp-grad-picker";
function Bk({ className: e, value: t, onChange: n }) {
  var M, D, V;
  const r = Qp(t), [o, s] = W(r.colorStops), [i, a] = W(null), l = K(null), u = $(Hk, "gs-grad-picker gs-utl-select-none gs-utl-gap-1", e, se.rnd), d = r.name || "linear-gradient", p = d.indexOf("radial") >= 0, f = d.indexOf("repeating") >= 0, h = r.orientation.value, g = `${parseFloat(`${h}`) || 180}`, m = `${parseFloat(`${(M = r.orientation.size) == null ? void 0 : M.x}`) || 0}`, v = `${parseFloat(`${(D = r.orientation.position) == null ? void 0 : D.x}`) || 0}`, b = `${parseFloat(`${(V = r.orientation.position) == null ? void 0 : V.y}`) || 0}`, y = 0, w = 100, S = (k, j = !1) => {
    const Y = Vk(k);
    s(Y), n == null || n(Dr({ name: d, orientation: h, stops: Y }), j);
  }, x = (k, j = !1) => {
    n == null || n(Dr({ stops: o, name: d, orientation: `${k}deg` }), j);
  }, C = (k, j = !1) => {
    n == null || n(Dr({ stops: o, name: d, orientation: `${k}px at ${v}% ${b}%` }), j);
  }, P = (k, j = !1) => {
    n == null || n(Dr({ stops: o, name: d, orientation: `${m}px at ${k}% ${b}%` }), j);
  }, _ = (k, j = !1) => {
    n == null || n(Dr({ stops: o, name: d, orientation: `${m}px at ${v}% ${k}%` }), j);
  }, O = (k) => {
    const j = `${k ? "repeating-" : ""}${p ? "radial" : "linear"}-gradient`;
    n == null || n(Dr({ stops: o, orientation: h, name: j }));
  }, E = (k) => {
    const j = `${f ? "repeating-" : ""}${k ? "radial" : "linear"}-gradient`;
    n == null || n(Dr({ stops: o, orientation: k ? "100px at 50% 50%" : "90deg", name: j }));
  };
  G(() => {
    if (!i)
      return;
    const k = parseFloat(`${i.stop.hint}`), j = (J) => {
      let Q = (J.clientX - i.x) * 100;
      Q = Q / i.w, Q = k + Q, Q = Q < y ? y : Q, Q = Q > w ? w : Q, i.stop.hint = parseInt(`${Q}`, 10), S(o, !0);
    }, Y = () => {
      a(null), S(o);
    };
    return window.addEventListener("pointermove", j), window.addEventListener("pointerup", Y), () => {
      window.removeEventListener("pointermove", j), window.removeEventListener("pointerup", Y), Y();
    };
  }, [i]);
  const T = (k, j) => {
    const Y = l.current;
    a({
      stop: j,
      w: (Y == null ? void 0 : Y.clientWidth) || 0,
      h: (Y == null ? void 0 : Y.clientHeight) || 0,
      x: k.clientX,
      y: k.clientY
    });
  }, R = (k) => {
    const j = l.current, Y = (j == null ? void 0 : j.clientWidth) || 0, J = (j == null ? void 0 : j.clientHeight) || 0, le = k.nativeEvent.offsetX - ((j == null ? void 0 : j.clientLeft) || 0), Q = k.nativeEvent.offsetY - ((j == null ? void 0 : j.clientTop) || 0), re = le / Y * 100, ge = document.createElement("canvas"), X = ge.getContext("2d");
    if (!X)
      return;
    ge.width = Y, ge.height = J;
    const Z = X.createLinearGradient(0, 0, Y, J);
    o.forEach((Pe) => Z.addColorStop(parseFloat(`${Pe.hint}`) / 100, Pe.color)), X.fillStyle = Z, X.fillRect(0, 0, ge.width, ge.height), ge.style.background = "black";
    const te = X.getImageData(le, Q, 1, 1).data, de = te[3] ? (100 / 255 * te[3] / 100).toFixed(2) : 0, ce = `rgba(${te[0]}, ${te[1]}, ${te[2]}, ${de})`, Ce = ce === "rgba(0, 0, 0, 0)" ? "#000" : ce;
    S([...o, { color: Ce, hint: re }]);
  }, B = (k) => {
    S(o.filter((j) => j !== k));
  }, U = (k, j, Y) => {
    j && (k.color = j), S(o, Y);
  }, L = (k) => (i == null ? void 0 : i.stop) === k;
  return /* @__PURE__ */ A(I, { className: u, col: !0, children: [
    !!(i != null && i.stop) && /* @__PURE__ */ c("div", { className: $("fixed inset-0 z-50 cursor-colr") }),
    /* @__PURE__ */ A("div", { className: $("relative gjs-mb-6 gjs-mt-3"), children: [
      /* @__PURE__ */ c("div", { className: $("bg-checker h-8", se.rnd), children: /* @__PURE__ */ c(
        "div",
        {
          ref: l,
          className: $("w-full h-full cursor-cross", se.b, se.rnd, z.br),
          style: { backgroundImage: Dr({ stops: o }) },
          onClick: R
        }
      ) }),
      o.map((k, j) => /* @__PURE__ */ A("div", { className: $("absolute top-0 h-full"), style: { left: `${k.hint}%` }, children: [
        /* @__PURE__ */ c(
          "div",
          {
            className: $("cursor-pointer absolute gs-utl-translate-x-[-50%] gs-utl-top-[-14px]"),
            onClick: () => B(k),
            children: /* @__PURE__ */ c(oe, { icon: ne.close, size: pe.s3x })
          }
        ),
        /* @__PURE__ */ c(
          "div",
          {
            onPointerDown: (Y) => T(Y, k),
            className: $(
              "h-full w-1 gs-utl-translate-x-[-50%] cursor-colr opacity-50 gjs-border-white",
              se.br,
              se.bl,
              L(k) ? "gjs-bg-white" : "gjs-bg-black"
            )
          }
        ),
        /* @__PURE__ */ c("div", { className: $("cursor-pointer gs-utl-bottom-[-17px] gs-utl-left-[-7px] absolute"), children: /* @__PURE__ */ c(
          gb,
          {
            value: k.color,
            onChange: (Y, J) => U(k, Y, J),
            className: $("h-4 w-4 gjs-rounded-full gjs-border-2")
          }
        ) })
      ] }, j))
    ] }),
    /* @__PURE__ */ A(I, { space: "s", items: "center", children: [
      /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(yl, { label: "Repeat", value: f, onChange: O }) }),
      /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(yl, { label: "Radial", value: p, onChange: E }) })
    ] }),
    p ? /* @__PURE__ */ A(I, { space: "s", col: !0, children: [
      /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(I, { space: "s", items: "center", children: /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(Me, { pan: "S", size: "s", value: m, onChange: C, valueUnit: "px", units: ["px"] }) }) }) }),
      /* @__PURE__ */ c(N, { children: /* @__PURE__ */ A(I, { space: "s", children: [
        /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(Me, { pan: "X", size: "s", value: v, onChange: P, valueUnit: "%", units: ["%"] }) }),
        /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(Me, { pan: "Y", size: "s", value: b, onChange: _, valueUnit: "%", units: ["%"] }) })
      ] }) })
    ] }) : /* @__PURE__ */ c(I, { space: "s", items: "center", nowrap: !0, children: /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(Me, { pan: "A", size: "s", value: g, onChange: x, valueUnit: "deg", units: ["deg"] }) }) })
  ] });
}
var Gr = /* @__PURE__ */ ((e) => (e.Image = "image", e.Gradient = "gradient", e.Color = "color", e))(Gr || {});
const Za = "background-image", Qn = "__background-type", fi = Za, Ib = "https://placehold.co/150/777/white.png?text=IMAGE", Od = "50px", zk = {
  [Qn]: "image",
  "background-image": `url("${Ib}")`,
  "background-size": `${Od} ${Od}`,
  "background-repeat": "repeat",
  "background-position": "0px 0px"
}, Fk = (e) => (e.includes("gradient(") ? Qp(e).colorStops[0].color : e) || "";
function Uk({ sector: e }) {
  var v;
  const t = Tn(), n = e.getProperty("background"), r = n.getProperty(Qn), o = n.getProperty("background-image"), s = n.getProperty("background-position"), i = n.getProperty("background-size"), a = e.getProperty("background-color"), l = e.getProperty("background-clip"), u = ((v = n.getSelectedLayer()) == null ? void 0 : v.getIndex()) || -1, d = r == null ? void 0 : r.getValue(), p = d === "image", f = o.getValue(), h = () => {
    const b = t.Assets;
    b.open({
      select(y) {
        const w = y.getSrc();
        o.upValue(`url("${w}")`), b.close();
      }
    });
  }, g = (b) => {
    let y = "none", w = "100%";
    b === "image" ? (y = `url("${Ib}")`, w = Od) : b === "gradient" ? y = "linear-gradient(90deg, black 10%, white 90%)" : b === "color" && (y = "rgba(0, 0, 0, 0.5)"), o.upValue(y), r.upValue(b), s.upValue("0 0"), i.upValue(`${w} ${w}`);
  }, m = $k(r, [
    { id: "image", label: /* @__PURE__ */ c(oe, { icon: ne.image, size: pe.s }) },
    { id: "gradient", label: /* @__PURE__ */ c(oe, { icon: ne.gradientVertical, size: pe.s }) },
    { id: "color", label: /* @__PURE__ */ c(oe, { icon: ne.checkboxBlank, size: pe.s }) }
  ]);
  return /* @__PURE__ */ A(ae, { children: [
    /* @__PURE__ */ c(be, { property: n, separator: !0, children: /* @__PURE__ */ A(
      gr,
      {
        ...Br(n, zk),
        previewStyle: (b) => n.getStyleFromLayer(b, { camelCase: !0 }),
        children: [
          /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { label: "Type", children: /* @__PURE__ */ c(Bt, { ...Fe(r), options: m, onChange: g }) }) }),
          /* @__PURE__ */ c(be, { children: /* @__PURE__ */ A(he, { children: [
            p && /* @__PURE__ */ c(ki, { value: rc(f).value, onOpen: h }),
            d === "color" && /* @__PURE__ */ c(Lr, { ...Mr(o), value: Fk(f) }),
            d === "gradient" && /* @__PURE__ */ c(
              Bk,
              {
                value: f,
                onChange: (b, y) => o.upValue(b, { partial: y })
              },
              u
            )
          ] }) }),
          p && /* @__PURE__ */ A(ae, { children: [
            /* @__PURE__ */ c(be, { col: !0, children: /* @__PURE__ */ c(Yt, { property: s }) }),
            /* @__PURE__ */ c(be, { col: !0, children: /* @__PURE__ */ c(Yt, { property: i }) }),
            /* @__PURE__ */ A(be, { children: [
              /* @__PURE__ */ c(he, { label: n.getProperty("background-repeat").getLabel(), children: /* @__PURE__ */ c(Ae, { ...Fe(n.getProperty("background-repeat")) }) }),
              /* @__PURE__ */ c(he, { label: n.getProperty("background-attachment").getLabel(), children: /* @__PURE__ */ c(Ae, { ...Fe(n.getProperty("background-attachment")) }) })
            ] }),
            /* @__PURE__ */ c(be, { children: /* @__PURE__ */ c(he, { label: n.getProperty("background-origin").getLabel(), children: /* @__PURE__ */ c(Ae, { ...Fe(n.getProperty("background-origin")) }) }) })
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ c(be, { property: a, children: /* @__PURE__ */ c(he, { property: a, children: /* @__PURE__ */ c(Lr, { ...Mr(a) }) }) }),
    /* @__PURE__ */ c(be, { property: l, children: /* @__PURE__ */ c(he, { property: l, children: /* @__PURE__ */ c(Ae, { ...Fe(l) }) }) })
  ] });
}
const Aa = ["%"], La = ["s", "ms"], Ys = ["deg", "rad", "grad"], Kn = ["px", "%", "em", "rem", "vw", "vh"], mg = {
  type: "select",
  options: ["visible", "hidden", "scroll", "auto"].map((e) => ({ id: e })),
  default: "visible"
}, Wk = (e) => `linear-gradient(${e} 1%, ${e} 100%)`, wl = (e) => ({ id: e, label: e.split("-").map(yr).join(" ") }), Vb = (e) => ({ property: t, to: n }) => {
  if (n.value) {
    const r = t.getOption(), o = t.getParent().getProperty(e), s = o.getUnit(), i = {
      units: r.units || [],
      min: r.min,
      max: r.max,
      unit: ""
    };
    (!s || (i == null ? void 0 : i.units.indexOf(s)) < 0) && (i.unit = (i == null ? void 0 : i.units[0]) || ""), o.up(i);
  }
}, Gk = (e) => {
  const t = `${e}-name`, n = `${e}-value`;
  return (r, { separatorLayers: o }) => {
    const s = r[e] || "";
    return s ? s.split(o).map((i) => {
      const { name: a, value: l } = rc(i);
      return { [t]: a, [n]: l };
    }) : [];
  };
}, vg = (e) => {
  const t = {
    [fi]: e
  };
  if (e.indexOf("url(") > -1)
    t[Qn] = Gr.Image;
  else if (e.indexOf("gradient(") > -1) {
    const n = Qp(e), r = n.colorStops, o = n.name.indexOf("linear") >= 0;
    r.length === 2 && o && r[0].color === r[1].color ? t[Qn] = Gr.Color : t[Qn] = Gr.Gradient;
  } else
    t[Qn] = Gr.Color, t[fi] = Wk(e);
  return t;
}, bg = (e = "filter") => {
  const t = `${e}-name`, n = `${e}-value`;
  return {
    property: e,
    type: "stack",
    layerSeparator: " ",
    fromStyle(r, { separatorLayers: o }) {
      const s = r[e] || "";
      return s ? s.split(o).map((i) => {
        const { name: a, value: l } = rc(i);
        return { [t]: a, [n]: l };
      }) : [];
    },
    toStyle(r, { name: o }) {
      return { [o]: `${r[t]}(${r[n] || "0"})` };
    },
    properties: [
      {
        property: t,
        type: "select",
        default: "blur",
        options: [
          { id: "blur", label: "Blur", min: 0, units: ["px", "em", "rem", "vw", "vh"] },
          { id: "brightness", label: "Brightness", min: 0, units: ["%"] },
          { id: "contrast", label: "Contrast", min: 0, units: ["%"] },
          { id: "grayscale", label: "Grayscale", min: 0, max: 100, units: ["%"] },
          { id: "hue-rotate", label: "Hue rotate", min: 0, max: 360, units: ["deg", "rad", "grad"] },
          { id: "invert", label: "Invert", min: 0, max: 100, units: ["%"] },
          { id: "saturate", label: "Saturate", min: 0, units: ["%"] },
          { id: "sepia", label: "Sepia", min: 0, max: 100, units: ["%"] }
        ],
        onChange: Vb(n)
      },
      {
        property: n,
        type: "integer"
      }
    ]
  };
}, ka = (e, { x: t, y: n, mergable: r } = {}) => {
  const o = {
    property: `${e}-x`,
    type: "integer",
    units: Kn,
    ...t
  }, s = {
    property: `${e}-y`,
    type: "integer",
    units: Kn,
    ...n
  };
  return {
    property: e,
    type: "composite",
    properties: [o, s],
    ...r && {
      fromStyle(i, { name: a, separator: l, property: u }) {
        const [d, p] = u.getProperties(), [f, h] = (i[a] || "").split(l);
        return {
          [d.getId()]: i[d.getName()] || f || "",
          [p.getId()]: i[p.getName()] || h || f || ""
        };
      },
      toStyle(i, { name: a, property: l }) {
        const [u, d] = l.getProperties(), p = i[u.getId()], f = i[d.getId()];
        return {
          [a]: p === f ? p : `${p} ${f}`
        };
      }
    }
  };
}, Kk = (e, t = "") => {
  const n = `${e}-name`, r = `${e}-value`;
  return (o, { name: s }) => ({ [s]: `${o[n]}(${o[r] || t})` });
}, qk = [
  {
    name: "Size",
    open: !1,
    buildProps: ["width", "height", "max-width", "min-height"],
    properties: [
      {
        property: "icon-size",
        type: "number",
        defaults: "20px",
        units: ["px", "%"]
      }
    ]
  },
  {
    name: "Space",
    open: !1,
    buildProps: ["margin", "padding", "vertical-align"],
    properties: [
      {
        property: "margin",
        properties: [
          { name: "Top", property: "margin-top" },
          { name: "Right", property: "margin-right" },
          { name: "Bottom", property: "margin-bottom" },
          { name: "Left", property: "margin-left" }
        ]
      },
      {
        property: "padding",
        properties: [
          { name: "Top", property: "padding-top" },
          { name: "Right", property: "padding-right" },
          { name: "Bottom", property: "padding-bottom" },
          { name: "Left", property: "padding-left" }
        ]
      },
      {
        property: "vertical-align",
        type: "select",
        options: ["top", "middle", "bottom"].map(wl)
      }
    ]
  },
  {
    name: "Typography",
    open: !1,
    buildProps: [
      "font-family",
      "font-size",
      "font-weight",
      "letter-spacing",
      "color",
      "line-height",
      "text-align",
      "align",
      "text-decoration",
      "font-style"
    ],
    properties: [
      { name: "Font", property: "font-family" },
      { name: "Weight", property: "font-weight" },
      { name: "Font color", property: "color" },
      {
        property: "text-align",
        defaults: "left",
        type: "select",
        options: [
          { id: "left", label: "Left" },
          { id: "center", label: "Center" },
          { id: "right", label: "Right" },
          { id: "justify", label: "Justify" }
        ]
      },
      {
        property: "align",
        defaults: "left",
        type: "select",
        options: [
          { id: "left", label: "Left" },
          { id: "center", label: "Center" },
          { id: "right", label: "Right" },
          { id: "justify", label: "Justify" }
        ]
      },
      {
        property: "text-decoration",
        type: "select",
        defaults: "none",
        options: [
          { id: "none", label: "None" },
          { id: "underline", label: "underline" },
          { id: "line-through", label: "Line-through" }
        ]
      },
      {
        property: "font-style",
        type: "select",
        defaults: "normal",
        options: [
          { id: "normal", label: "Normal" },
          { id: "italic", label: "Italic" }
        ]
      }
    ]
  },
  {
    name: "Borders",
    open: !1,
    buildProps: ["border-radius", "border"],
    properties: [
      {
        property: "border-radius",
        // @ts-ignore custom property for our UI
        corners: !0,
        properties: [
          { name: "Top", property: "border-top-left-radius" },
          { name: "Right", property: "border-top-right-radius" },
          { name: "Bottom", property: "border-bottom-left-radius" },
          { name: "Left", property: "border-bottom-right-radius" }
        ]
      },
      {
        property: "border",
        // @ts-ignore custom property for our UI
        generic: !0
      },
      {
        property: "border-detached",
        name: "Border",
        type: "composite",
        detached: !0,
        // @ts-ignore custom property for our UI
        generic: !0,
        properties: [
          { name: "Width", property: "border-width", type: "integer", units: ["px", "%"] },
          {
            name: "Style",
            property: "border-style",
            type: "select",
            options: ["none", "solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset"].map(
              wl
            )
          },
          { name: "Color", property: "border-color", type: "color" }
        ]
      }
    ]
  },
  {
    name: "Decorations",
    open: !1,
    buildProps: [
      "background-color",
      "container-background-color",
      "background-url",
      "background-repeat",
      "background-size"
    ],
    properties: [
      {
        name: "Background color",
        property: "container-background-color",
        full: !0,
        type: "color"
      },
      {
        property: "background-url",
        type: "file"
      }
    ]
  }
], Yk = [
  {
    id: "gs-layout",
    name: "Layout",
    properties: [
      { extend: "display" },
      {
        extend: "flex-direction",
        name: "Direction",
        type: "radio",
        default: "row"
      },
      {
        extend: "justify-content",
        type: "radio",
        default: "flex-start"
      },
      {
        extend: "align-items",
        type: "radio",
        default: "stretch"
      },
      ka("gap", {
        x: { property: "row-gap", min: 0, default: "0" },
        y: { property: "column-gap", min: 0, default: "0" },
        mergable: !0
      }),
      { extend: "flex-wrap" },
      { extend: "align-content" },
      { extend: "align-self" },
      { extend: "order" },
      {
        property: "flex",
        type: "composite",
        // detached: true,
        properties: [
          {
            type: "integer",
            property: "flex-grow",
            default: "0",
            min: 0
          },
          {
            type: "integer",
            property: "flex-shrink",
            default: "0",
            min: 0
          },
          {
            type: "integer",
            property: "flex-basis",
            fixedValues: ["auto"],
            default: "auto",
            units: Kn,
            min: 0
          }
        ]
      }
    ]
  },
  {
    id: "gs-size",
    name: "Size",
    properties: [
      { extend: "width" },
      { extend: "min-width" },
      { extend: "max-width" },
      { extend: "height" },
      { extend: "min-height" },
      { extend: "max-height" }
    ]
  },
  {
    id: "gs-space",
    name: "Space",
    properties: [
      {
        extend: "padding",
        detached: !0
      },
      {
        extend: "margin",
        detached: !0
      }
    ]
  },
  {
    id: "gs-position",
    name: "Position",
    properties: [
      {
        extend: "position",
        options: [
          { id: "static", label: "Static" },
          { id: "relative", label: "Relative" },
          { id: "absolute", label: "Absolute" },
          { id: "fixed", label: "Fixed" },
          { id: "sticky", label: "Sticky" }
        ],
        onChange({ opts: e, property: t }) {
          if (e.__clear) {
            const n = { top: "", right: "", bottom: "", left: "", "z-index": "" };
            t.__upTargetsStyle(n, e);
          }
        }
      },
      { extend: "top" },
      { extend: "right" },
      { extend: "bottom" },
      { extend: "left" },
      {
        extend: "z-index",
        type: "integer",
        default: "0"
      }
    ]
  },
  {
    id: "gs-typography",
    name: "Typography",
    properties: [
      { extend: "font-family" },
      { extend: "color" },
      { extend: "font-size" },
      { extend: "font-weight" },
      { extend: "line-height", min: 0 },
      { extend: "letter-spacing" },
      { extend: "text-align" },
      {
        property: "vertical-align",
        type: "select",
        default: "baseline",
        options: ["baseline", "top", "middle", "bottom"].map(wl)
      },
      {
        extend: "text-decoration",
        type: "select",
        default: "none",
        options: [
          { id: "none", label: "None" },
          { id: "underline", label: "Underline" },
          { id: "overline", label: "Overline" },
          { id: "line-through", label: "Line through" }
        ]
      },
      {
        extend: "text-transform",
        type: "select",
        default: "none",
        options: [
          { id: "none", label: "None" },
          { id: "capitalize", label: "Capitalize" },
          { id: "uppercase", label: "Uppercase" },
          { id: "lowercase", label: "Lowercase" }
        ]
      },
      {
        extend: "direction",
        type: "radio",
        default: "ltr",
        options: [
          { id: "ltr", label: "LTR" },
          { id: "rtl", label: "RTL" }
        ]
      },
      {
        extend: "white-space",
        type: "select",
        default: "normal",
        options: [
          { id: "normal", label: "Normal" },
          { id: "nowrap", label: "No wrap" },
          { id: "pre", label: "Pre" },
          { id: "pre-wrap", label: "Pre wrap" },
          { id: "pre-line", label: "Pre line" },
          { id: "break-spaces", label: "Break spaces" }
        ]
      }
      // text-overflow: ellipsis; white-space: nowrap; overflow: hidden;
      // List of default fonts: https://stackoverflow.com/a/62755574
      //  Safe webfonts: https://web.mit.edu/jmorzins/www/fonts.html#sans-serif
      //  List per platform: https://granneman.com/webdev/coding/css/fonts-and-formatting/default-fonts
    ]
  },
  {
    id: "gs-background",
    name: "Background",
    properties: [
      // Stack of backgrounds (Color - Gradient - Image/Patterns)
      {
        property: "background",
        type: "stack",
        layerSeparator: new RegExp("(?<!\\(.*[^)]),(?![^(]*\\))"),
        layerJoin: ", ",
        // 1. "simple" -> 1
        // 2. "simple, simple" -> 2
        // 3. "rgba(1px, 2px, 3px)" -> 1
        // 4. "rgba(1px, 2px, 3px), rgba(1px, 2px, 3px)" -> 2
        // 5. "rgba(1px, rgba(11px, 22px, 33px), 3px), rgba(1px, rgba(11px, 22px, 33px), 3px)" -> 2
        // 6. "rgba(1px, rgba(11px, 22px, 33px), 3px)" -> 1
        // 7a. "linear(rgb(1, 2, 3, 5), rgb(1, 2, 3, 5))" -> 1 || "/(?<!\(.*[^)]),(?![^(]*\))/"
        // 7b. "linear(rgb(1, 2, 3, 5) 1px, rgb(1, 2, 3, 5))" -> 1
        // /(?<!\(*[^)]),(?![^(]*\))/ > fails 2.
        // /(?<!\(.*[^)]),(?![^(]*\))/ > fails 7a.
        detached: !0,
        layerLabel: (e, { values: t, property: n }) => n.getProperty(Qn).getOptionLabel(t[Qn]),
        toStyle(e) {
          const t = e[Qn];
          let n = e[fi];
          return t === "color" && n.indexOf("linear-gradient") < 0 && (n = `linear-gradient(${n} 1%, ${n} 100%)`), {
            ...e,
            [fi]: n
          };
        },
        fromStyle(e, { property: t, name: n, separatorLayers: r }) {
          const o = r, s = t.getProperties();
          let i = [];
          return e[Za] ? (i = t.__splitStyleName(e, Za, o).map(vg), s.forEach((a) => {
            const l = a.getId(), u = a.getName();
            u !== Za && t.__splitStyleName(e, u, o).map((d) => ({ [l]: d || a.getDefaultValue() })).forEach((d, p) => {
              i[p] = i[p] ? { ...i[p], ...d } : d;
            });
          })) : e[n] && (i = t.__splitStyleName(e, n, /(?![^)(]*\([^)(]*?\)\)),(?![^\(]*\))/).map((a) => a.substring(0, a.lastIndexOf(")") + 1)).map(vg)), i;
        },
        properties: [
          {
            property: Qn,
            type: "radio",
            default: "image",
            options: [{ id: Gr.Image }, { id: Gr.Gradient }, { id: Gr.Color }]
          },
          {
            // Specs: https://www.w3.org/TR/css-images-3/
            // <url> | <gradient> (https://github.com/rafaelcaricio/gradient-parser)
            // <gradient> = <linear-gradient()> | <repeating-linear-gradient()> | <radial-gradient()> | <repeating-radial-gradient()>
            // <linear-gradient()> = linear-gradient([ <angle> | to <side-or-corner> ]? , <color-stop-list>)
            // <radial-gradient()> = radial-gradient([ <ending-shape> || <size> ]? [ at <position> ]? , <color-stop-list>
            //    radial-gradient(5em circle at top left, yellow, blue)
            // <color-stop-list> = <linear-color-stop> , [ <linear-color-hint>? , <linear-color-stop> ]
            //  fn(red 40%, white) | fn(white calc(-25px + 50%), blue)
            // Regex
            // <side-or-corner>: /^to (left (top|bottom)|right (top|bottom)|top (left|right)|bottom (left|right)|left|right|top|bottom)/i,
            // <ending-shape>: /^circle|ellipse/i,
            // <size>: /^(closest\-side|closest\-corner|farthest\-side|farthest\-corner|contain|cover)/, // | <length> | <length-percentage>{2}
            // <position>: /^at/ // position: at top left, at 20px, at 10% 15%
            property: fi,
            default: "none"
            // url(), gradient, none
          },
          {
            property: "background-position",
            type: "composite",
            // default: '0%', // left | center | right | top | bottom
            properties: ["background-position-x", "background-position-y"].map((e) => ({
              type: "integer",
              property: e,
              units: Kn,
              default: "0px"
            }))
          },
          {
            // Keyword: contain | cover; One-value syntax; Two-value syntax
            property: "background-size",
            type: "composite",
            properties: ["background-size-x", "background-size-y"].map((e) => ({
              type: "integer",
              property: e,
              units: Kn,
              default: "auto"
            }))
          },
          {
            property: "background-repeat",
            // box (x, y)
            default: "repeat",
            type: "select",
            options: [
              // background-repeat-x background-repeat-x
              { id: "repeat", label: "Repeat" },
              { id: "repeat-x", label: "Repeat x" },
              { id: "repeat-y", label: "Repeat y" },
              { id: "no-repeat", label: "No repeat" },
              { id: "space", label: "Space" },
              { id: "round", label: "Round" }
            ]
          },
          {
            property: "background-attachment",
            default: "scroll",
            type: "select",
            options: [
              { id: "scroll", label: "Scroll" },
              { id: "fixed", label: "Fixed" }
            ]
          },
          {
            property: "background-origin",
            default: "padding-box",
            type: "select",
            options: [
              { id: "padding-box", label: "Padding box" },
              { id: "border-box", label: "Border box" },
              { id: "content-box", label: "Content box" }
            ]
          }
        ]
      },
      {
        property: "background-color",
        type: "color",
        default: "none"
      },
      {
        property: "background-clip",
        default: "border-box",
        type: "select",
        options: [
          { id: "border-box", label: "Border box" },
          { id: "padding-box", label: "Padding box" },
          { id: "content-box", label: "Content box" },
          { id: "text", label: "Text" }
        ],
        onChange({ to: e, property: t, opts: n }) {
          const { value: r } = e;
          if (r !== void 0) {
            const o = r === "text";
            t.__upTargetsStyle(
              {
                "-webkit-background-clip": o ? r : "",
                "-webkit-text-fill-color": o ? "transparent" : ""
              },
              n
            );
          }
        }
      }
    ]
  },
  {
    id: "gs-borders",
    name: "Borders",
    properties: [
      {
        extend: "border-radius",
        detached: !0
      },
      {
        extend: "border-width",
        type: "composite",
        detached: !0,
        properties: ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width"].map(
          (e) => ({
            type: "integer",
            property: e,
            default: "0",
            units: Kn
          })
        )
      },
      {
        extend: "border-style",
        type: "composite",
        detached: !0,
        properties: ["border-top-style", "border-right-style", "border-bottom-style", "border-left-style"].map(
          (e) => ({
            type: "select",
            property: e,
            default: "none",
            options: [
              { id: "none", label: "None" },
              { id: "solid", label: "Solid" },
              { id: "dotted", label: "Dotted" },
              { id: "dashed", label: "Dashed" },
              { id: "double", label: "Double" },
              { id: "groove", label: "Groove" },
              { id: "ridge", label: "Ridge" },
              { id: "inset", label: "Inset" },
              { id: "outset", label: "Outset" }
            ]
          })
        )
      },
      {
        extend: "border-color",
        type: "composite",
        detached: !0,
        properties: ["border-top-color", "border-right-color", "border-bottom-color", "border-left-color"].map(
          (e) => ({
            type: "color",
            property: e,
            default: "currentColor"
          })
        )
      }
    ]
  },
  {
    id: "gs-effects",
    name: "Effects",
    properties: [
      {
        property: "opacity",
        type: "integer",
        min: 0,
        max: 100,
        default: "100",
        units: ["%"]
      },
      {
        property: "mix-blend-mode",
        type: "select",
        default: "normal",
        options: [
          { id: "normal", label: "Normal" },
          { id: "multiply", label: "Multiply" },
          { id: "screen", label: "Screen" },
          { id: "overlay", label: "Overlay" },
          { id: "darken", label: "Darken" },
          { id: "lighten", label: "Lighten" },
          { id: "color-dodge", label: "Color dodge" },
          { id: "color-burn", label: "Color burn" },
          { id: "hard-light", label: "Hard light" },
          { id: "soft-light", label: "Soft light" },
          { id: "difference", label: "Difference" },
          { id: "exclusion", label: "Exclusion" },
          { id: "hue", label: "Hue" },
          { id: "saturation", label: "Saturation" },
          { id: "color", label: "Color" },
          { id: "luminosity", label: "Luminosity" }
        ]
      },
      { extend: "cursor" },
      ka("overflow", {
        x: mg,
        y: mg,
        mergable: !0
      }),
      {
        extend: "box-shadow",
        fromStyle(e, { separatorLayers: t }) {
          const n = e["box-shadow"] || "";
          return n ? n.split(t).map((o) => {
            const { x: s, y: i, blur: a, spread: l, inset: u, color: d } = Bh(o);
            return {
              "box-shadow-h": s,
              "box-shadow-v": i,
              "box-shadow-blur": a,
              "box-shadow-spread": l,
              "box-shadow-color": d,
              "box-shadow-type": u ? "inset" : ""
            };
          }) : [];
        }
      },
      {
        extend: "text-shadow",
        fromStyle(e, { separatorLayers: t }) {
          const n = e["text-shadow"] || "";
          return n ? n.split(t).map((o) => {
            const { x: s, y: i, blur: a, color: l } = Bh(o);
            return {
              "text-shadow-h": s,
              "text-shadow-v": i,
              "text-shadow-blur": a,
              "text-shadow-color": l
            };
          }) : [];
        }
      },
      bg(),
      bg("backdrop-filter"),
      {
        property: "transition",
        type: "stack",
        layerLabel: (e, { values: t }) => `${yr(t["transition-property"])}: ${t["transition-duration"]}`,
        properties: [
          {
            property: "transition-property",
            type: "select",
            default: "opacity",
            options: [
              // Size
              "width",
              "height",
              "min-width",
              "min-height",
              "max-width",
              "max-height",
              // Layout
              "padding",
              "margin",
              // Typography
              "color",
              "font-size",
              "line-height",
              "letter-height",
              // Border
              "border",
              "border-radius",
              // 'border-color', 'border-width',
              // Background
              "background",
              // Effects
              "opacity",
              "box-shadow",
              "text-shadow",
              "filter",
              "backdrop-filter",
              "transform",
              // Extra
              "all"
            ].map(wl)
          },
          {
            property: "transition-duration",
            type: "integer",
            default: "1s",
            unit: La[0],
            units: La,
            min: 0
          },
          {
            property: "transition-timing-function",
            type: "select",
            default: "ease",
            options: [
              { id: "ease", label: "Ease" },
              { id: "ease-in", label: "Ease-In" },
              { id: "ease-in-out", label: "Ease-In-Out" },
              { id: "ease-out", label: "Ease-Out" },
              { id: "linear", label: "Linear" }
            ]
          },
          {
            property: "transition-delay",
            type: "integer",
            default: "0s",
            unit: La[0],
            units: La
          }
        ]
      },
      {
        property: "transform",
        type: "stack",
        layerSeparator: " ",
        layerLabel: (e, { values: t, property: n }) => {
          const r = n.getProperty("transform-name").getOptionLabel(t["transform-name"]);
          return `${yr(r)}: ${t["transform-value"]}`;
        },
        fromStyle: Gk("transform"),
        toStyle: Kk("transform", "0"),
        properties: [
          {
            property: "transform-name",
            type: "select",
            default: "translateX",
            options: [
              { id: "translateX", label: "Move X", units: Kn },
              { id: "translateY", label: "Move Y", units: Kn },
              { id: "translateZ", label: "Move Z", units: Kn },
              { id: "rotateX", label: "Rotate X", units: Ys },
              { id: "rotateY", label: "Rotate Y", units: Ys },
              { id: "rotateZ", label: "Rotate Z", units: Ys },
              { id: "scale", label: "Scale", units: Aa },
              { id: "scaleX", label: "Scale X", units: Aa },
              { id: "scaleY", label: "Scale Y", units: Aa },
              { id: "scaleZ", label: "Scale Z", units: Aa },
              { id: "skewX", label: "Skew X", units: Ys },
              { id: "skewY", label: "Skew Y", units: Ys }
            ],
            onChange: Vb("transform-value")
          },
          {
            property: "transform-value",
            type: "integer",
            default: "0"
          }
        ]
      },
      ka("transform-origin", {
        x: { default: "50%" },
        y: { default: "50%" }
      }),
      {
        property: "backface-visibility",
        type: "radio",
        default: "visible",
        options: [
          { id: "visible", label: "Visible" },
          { id: "hidden", label: "Hidden" }
        ]
      },
      {
        // Activate on parent element to enable 3D transforms on all of its children
        property: "perspective",
        type: "integer",
        min: 0,
        default: "none",
        units: Kn
      },
      ka("perspective-origin", {
        x: { default: "50%" },
        y: { default: "50%" }
      }),
      {
        property: "transform-style",
        type: "radio",
        default: "flat",
        options: [
          { id: "flat", label: "2D" },
          { id: "preserve-3d", label: "3D" }
        ]
      }
    ]
  }
];
function Xk(e, t) {
  const { blocks: n } = t.appStore.sdkOptions;
  Array.isArray(n == null ? void 0 : n.default) && e.BlockManager.blocks.add(n.default);
}
const yg = [
  { id: "desktop", name: "Desktop", width: "" },
  { id: "mobilePortrait", name: "Mobile", width: "320px", widthMedia: "480px" }
];
function Hb(e, t) {
  return [
    (n) => Xk(n, t),
    ...Vh[e],
    ...Vh.global,
    (n) => FA(n, t),
    AA(e, t)
  ];
}
function Zk(e, t = {}) {
  var i;
  const n = e === Ve.email, { devices: r } = t, o = r ? {
    default: r.selected,
    devices: r.default ?? (n ? yg : void 0)
  } : n ? {
    devices: yg
  } : {}, s = {
    undoManager: { trackSelection: !1 },
    showOffsets: !0,
    cssIcons: "",
    assetManager: {},
    styleManager: {
      sectors: n ? qk : Yk
    },
    selectorManager: {
      componentFirst: !0
    },
    i18n: {
      messagesAdd: Gu({ en: X5 }, ((i = t.i18n) == null ? void 0 : i.locales) ?? {})
    },
    deviceManager: o,
    canvasCss: `
      [contenteditable] { outline: 0px solid transparent;}
    `,
    canvas: {
      // infiniteCanvas: true,
      customSpots: {
        select: !0,
        hover: !0,
        spacing: !0,
        target: !0
        // resize: true,
      }
    },
    telemetry: !1
  };
  return Gu(s, t.gjsOptions ?? {});
}
class Jk {
  constructor(t) {
    this.loadCounter = 0, this.pendingInstalled = [], this.pendingUninstalled = [], this.selectedShown = !1, this.store = t, Ut(this, {}, { autoBind: !0 });
  }
  get hasPending() {
    return !!this.pendingInstalled.length || !!this.pendingUninstalled.length;
  }
  *initProjectPlugins(t) {
    this.pendingInstalled = [], this.pendingUninstalled = [];
    const r = (yield Mi()).filter((o) => o.projectType.includes(t));
    this.projectPlugins = [...r];
  }
  getPluginsToLoad(t, n) {
    const r = [...Hb(t, { appStore: n }), ...this.projectPlugins || []], o = n.sdkOptions.plugins || [];
    return ct(o) ? o({ plugins: r }) : [...r, ...o];
  }
  addPendingInstalled(t) {
    const { pendingInstalled: n, pendingUninstalled: r } = this, o = t.id;
    r.includes(o) ? this.pendingUninstalled = r.filter((s) => s !== o) : n.includes(o) || n.push(o);
  }
  addPendingUninstalled(t) {
    const { pendingInstalled: n, pendingUninstalled: r } = this, o = t.id;
    n.includes(o) ? this.pendingInstalled = n.filter((s) => s !== o) : r.push(o);
  }
  setSelectedShown(t) {
    this.selectedShown = t;
  }
}
const ef = { db: Mv.gjsStudio }, Mi = () => new Promise(async (e) => {
  let t = [];
  try {
    t = await R5(Ls.Settings, "plugins", ef) || [];
  } catch (n) {
    lr() && console.error(n);
  }
  e(t);
}), Qk = (e) => new Promise(async (t) => {
  try {
    const r = [...await Mi(), e];
    Bb().addPendingInstalled(e), await $v(Ls.Settings, "plugins", r, ef);
  } catch (n) {
    console.error(n);
  }
  t();
}), eM = (e) => new Promise(async (t) => {
  try {
    const r = (await Mi()).filter((o) => o.id !== e.id);
    Bb().addPendingUninstalled(e), await $v(Ls.Settings, "plugins", r, ef);
  } catch (n) {
    console.error(n);
  }
  t();
}), tf = () => It().pluginStore, Bb = () => oa().pluginStore;
let Sl;
const zb = Be(void 0);
class tM {
  constructor(t) {
    this.blockManagerStore = new B5(this), this.appEditorStore = new sM(this, t == null ? void 0 : t.appEditorStore), this.localSettingsStore = new K5(t == null ? void 0 : t.localSettingsStore), this.toastStore = new H5(this), this.modalStore = new Y5(this), this.i18nStore = new O5(this), this.pluginStore = new Jk(this), this.pointerBadgeStore = new L5(this), this.contextMenu = new r5(this), this.layoutStore = new T5(this), this.templatesStore = new V5(this), this.assetsStore = new E5(this), this.globalStylesStore = new U5(this), this.fontsStore = new g5(this), this.appEditorStore.init(), Gd() && (window.__gjss = this);
  }
}
const nM = (e) => {
  q5(e.localSettingsStore), aM(e.appEditorStore);
}, rM = ({ children: e, initialState: t }) => (Sl = ie(() => {
  const n = new tM(t);
  return nM(n), n;
}, []), /* @__PURE__ */ c(zb.Provider, { value: Sl, children: e })), It = () => {
  const e = Le(zb);
  if (!e)
    throw new Error("useStore must be used inside of StoreProvider");
  return e;
}, oa = () => {
  if (!Sl)
    throw new Error("Store has not been initialized");
  return Sl;
}, Ma = ({
  icon: e,
  layout: t,
  tooltip: n,
  className: r,
  forceRemove: o,
  removeLayouts: s
}) => ({
  type: "button",
  icon: e,
  tooltip: n,
  className: r,
  size: "s",
  editorEvents: {
    [`${_r.layoutToggleId}${t.id}`]: ({ fromEvent: i, setState: a }) => {
      a({ active: i.isOpen });
    }
  },
  onClick: ({ editor: i }) => {
    s == null || s.forEach((a) => i.runCommand(me.layoutRemove, { id: a, force: o })), i.runCommand(me.layoutToggle, { ...t });
  }
}), wg = { type: "static", layoutId: "leftPanelsContainer" }, Sg = { width: 240, overflow: "hidden" };
Ma({
  // icon: IconNames.plusBox,
  tooltip: "Blocks",
  removeLayouts: ["pagesLayers", "ps"],
  layout: {
    id: "blocks",
    layout: "panelBlocks",
    header: { label: "Blocks" },
    style: Sg,
    placer: wg
  }
}), Ma({
  // icon: IconNames.layers,
  tooltip: "Pages & Layers",
  removeLayouts: ["blocks", "ps"],
  layout: {
    id: "pagesLayers",
    layout: "panelPagesLayers",
    header: !1,
    style: Sg,
    placer: wg
  }
}), Ma({
  // icon: IconNames.cog,
  tooltip: "Page Settings",
  removeLayouts: ["pagesLayers", "blocks"],
  layout: {
    id: "ps",
    layout: "panelPageSettings",
    header: { label: "Page Settings" },
    style: { marginLeft: 40 }
  }
}), Ma({
  icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,10.11C13.03,10.11 13.87,10.95 13.87,12C13.87,13 13.03,13.85 12,13.85C10.97,13.85 10.13,13 10.13,12C10.13,10.95 10.97,10.11 12,10.11M7.37,20C8,20.38 9.38,19.8 10.97,18.3C10.45,17.71 9.94,17.07 9.46,16.4C8.64,16.32 7.83,16.2 7.06,16.04C6.55,18.18 6.74,19.65 7.37,20M8.08,14.26L7.79,13.75C7.68,14.04 7.57,14.33 7.5,14.61C7.77,14.67 8.07,14.72 8.38,14.77C8.28,14.6 8.18,14.43 8.08,14.26M14.62,13.5L15.43,12L14.62,10.5C14.32,9.97 14,9.5 13.71,9.03C13.17,9 12.6,9 12,9C11.4,9 10.83,9 10.29,9.03C10,9.5 9.68,9.97 9.38,10.5L8.57,12L9.38,13.5C9.68,14.03 10,14.5 10.29,14.97C10.83,15 11.4,15 12,15C12.6,15 13.17,15 13.71,14.97C14,14.5 14.32,14.03 14.62,13.5M12,6.78C11.81,7 11.61,7.23 11.41,7.5C11.61,7.5 11.8,7.5 12,7.5C12.2,7.5 12.39,7.5 12.59,7.5C12.39,7.23 12.19,7 12,6.78M12,17.22C12.19,17 12.39,16.77 12.59,16.5C12.39,16.5 12.2,16.5 12,16.5C11.8,16.5 11.61,16.5 11.41,16.5C11.61,16.77 11.81,17 12,17.22M16.62,4C16,3.62 14.62,4.2 13.03,5.7C13.55,6.29 14.06,6.93 14.54,7.6C15.36,7.68 16.17,7.8 16.94,7.96C17.45,5.82 17.26,4.35 16.62,4M15.92,9.74L16.21,10.25C16.32,9.96 16.43,9.67 16.5,9.39C16.23,9.33 15.93,9.28 15.62,9.23C15.72,9.4 15.82,9.57 15.92,9.74M17.37,2.69C18.84,3.53 19,5.74 18.38,8.32C20.92,9.07 22.75,10.31 22.75,12C22.75,13.69 20.92,14.93 18.38,15.68C19,18.26 18.84,20.47 17.37,21.31C15.91,22.15 13.92,21.19 12,19.36C10.08,21.19 8.09,22.15 6.62,21.31C5.16,20.47 5,18.26 5.62,15.68C3.08,14.93 1.25,13.69 1.25,12C1.25,10.31 3.08,9.07 5.62,8.32C5,5.74 5.16,3.53 6.62,2.69C8.09,1.85 10.08,2.81 12,4.64C13.92,2.81 15.91,1.85 17.37,2.69M17.08,12C17.42,12.75 17.72,13.5 17.97,14.26C20.07,13.63 21.25,12.73 21.25,12C21.25,11.27 20.07,10.37 17.97,9.74C17.72,10.5 17.42,11.25 17.08,12M6.92,12C6.58,11.25 6.28,10.5 6.03,9.74C3.93,10.37 2.75,11.27 2.75,12C2.75,12.73 3.93,13.63 6.03,14.26C6.28,13.5 6.58,12.75 6.92,12M15.92,14.26C15.82,14.43 15.72,14.6 15.62,14.77C15.93,14.72 16.23,14.67 16.5,14.61C16.43,14.33 16.32,14.04 16.21,13.75L15.92,14.26M13.03,18.3C14.62,19.8 16,20.38 16.62,20C17.26,19.65 17.45,18.18 16.94,16.04C16.17,16.2 15.36,16.32 14.54,16.4C14.06,17.07 13.55,17.71 13.03,18.3M8.08,9.74C8.18,9.57 8.28,9.4 8.38,9.23C8.07,9.28 7.77,9.33 7.5,9.39C7.57,9.67 7.68,9.96 7.79,10.25L8.08,9.74M10.97,5.7C9.38,4.2 8,3.62 7.37,4C6.74,4.35 6.55,5.82 7.06,7.96C7.83,7.8 8.64,7.68 9.46,7.6C9.94,6.93 10.45,6.29 10.97,5.7Z" /></svg>',
  tooltip: "Custom Component",
  className: "gs-utl-mt-auto",
  layout: {
    id: "customLayout",
    layout: { type: "custom", component: () => /* @__PURE__ */ c("div", { children: "Custom Reat component" }) },
    header: { label: "Custom" },
    style: { marginLeft: 40 }
  }
});
const oM = {
  type: "row",
  style: { height: "100%" },
  children: [{ type: "sidebarLeft" }, { type: "canvasSidebarTop" }, { type: "sidebarRight" }]
};
class sM {
  constructor(t, n) {
    this.projectType = Ve.web, this.editor = void 0, this.sdkProps = {}, this.sdkLicenseError = "", this.licenseCheckRetry = 0, this.showPoweredBy = !1, this.isInPreview = !1, this.isCssPanelActive = !1, this.isLeftSidebarOpen = !0, this.isRightSidebarOpen = !0, this.isTopSidebarOpen = !0, this.isBottomSidebarOpen = !0, this.isSelectingTarget = !1, this.leftSidebarSize = 240, this.rightSidebarSize = 240, this.transitionTime = 152, this.topBarSize = 36, this.isDev = !1, this.isStage = !1, this.editorKey = 0, this.appInstalled = !1, this.licenseKey = "", this.licenseCheckStarted = !1, this.studioSdkVersion = "1.0.35", this.projectDataCustom = {}, this.displayMode = "browser", this.projectPlugins = [], this.queryParams = {}, this.isCanvasPanning = !1, this.selectedDesignerTab = "style", this.customAssets = void 0, this.nextProjectData = void 0, this.isSaving = !1, this.isReady = !1, this.sdkPagesConfigUpdates = 0, this.panelPageSettings = {
      isOpen: !1,
      width: 300,
      page: void 0
    }, this.rootElWidth = 0, this._projectId = "", this.store = t, n && Object.keys(n).forEach((o) => {
      const s = o, i = n[s];
      i !== void 0 && (this[s] = i);
    });
    const r = lr() ? window.location.search : "";
    this.queryParams = fS(r), Ut(
      this,
      {
        sdkProps: !1
      },
      { autoBind: !0 }
    );
  }
  get baseApiUrl() {
    const { isDev: t, isStage: n } = this;
    return iS({ isDev: t, isStage: n });
  }
  get projectId() {
    var r, o;
    const { project: t, storage: n } = this.sdkOptions;
    return this._projectId || ((o = (r = (n == null ? void 0 : n.project) || (t == null ? void 0 : t.default)) == null ? void 0 : r.custom) == null ? void 0 : o.id) || "";
  }
  get projectIdToLoad() {
    return this.store.localSettingsStore.lastProjectId || this.projectId;
  }
  get currentProjectId() {
    return this.projectDataCustom.id || this.projectId;
  }
  get isBrowserMode() {
    return this.displayMode === "browser";
  }
  get sdkOptions() {
    return this.sdkProps.options;
  }
  get sdkProjectId() {
    var t, n;
    return (n = (t = this.sdkOptions.project) == null ? void 0 : t.id) == null ? void 0 : n.toString();
  }
  get sdkIdentityId() {
    var t, n;
    return (n = (t = this.sdkOptions.identity) == null ? void 0 : t.id) == null ? void 0 : n.toString();
  }
  get sdkPagesConfig() {
    return this.sdkPagesConfigUpdates, this.sdkOptions.pages;
  }
  get sdkLayoutConfig() {
    return this.sdkOptions.layout;
  }
  get sdkComponentsConfig() {
    return this.sdkOptions.components;
  }
  get currentLayout() {
    const { sdkLayoutConfig: t, rootElWidth: n, store: r } = this, { customConfig: o } = r.layoutStore, s = (o == null ? void 0 : o.responsive) || (t == null ? void 0 : t.responsive);
    let i = (o == null ? void 0 : o.default) || (t == null ? void 0 : t.default) || oM;
    if (n && s) {
      const l = Object.keys(s).map(Number).sort((u, d) => u - d).find((u) => n <= u);
      i = l ? s[l] : i;
    }
    return i;
  }
  get sdkCustomIcons() {
    var t;
    return (t = this.sdkOptions.customTheme) == null ? void 0 : t.icons;
  }
  get isProjectTypeEmail() {
    return this.projectType === Ve.email;
  }
  get showPages() {
    return this.isReady && this.sdkPagesConfig !== !1 && !this.isProjectTypeEmail;
  }
  get showSelectors() {
    return !this.isProjectTypeEmail;
  }
  get sdkMisconfigurationError() {
    if (this.store.assetsStore.isUsingAssetCloud || this.isUsingProjectCloud) {
      const n = this.sdkProjectId, r = this.sdkIdentityId;
      if (!n || !r)
        return 'SDK Misconfiguration Error: When using assets.storageType == "cloud" or storage.type === "cloud", project.id and identity.id are required.';
    }
    return "";
  }
  get isUsingProjectSelfHosted() {
    var t;
    return ((t = this.sdkOptions.storage) == null ? void 0 : t.type) === ad.self;
  }
  get isUsingProjectCloud() {
    var t;
    return ((t = this.sdkOptions.storage) == null ? void 0 : t.type) === ad.cloud;
  }
  get publicStateTheme() {
    return {
      theme: this.store.localSettingsStore.theme
    };
  }
  setPublicStateTheme(t) {
    t.theme !== void 0 && (this.store.localSettingsStore.theme = t.theme);
  }
  *init() {
    var p, f;
    const { store: t, sdkOptions: n } = this, { lastProjectId: r, lastProjectType: o } = t.localSettingsStore, s = (p = n.project) == null ? void 0 : p.default, { project: i } = n.storage || {};
    let a, l;
    o && (this.store.templatesStore._projectTypeFilter = o), r && (a = (f = (yield Rv(o)).find((g) => g.id === r)) == null ? void 0 : f.data), a ? l = a : i ? l = i : s && (l = s);
    const u = (l == null ? void 0 : l.custom) || {}, d = u.projectType;
    d && (this.projectType = d), u.projectType = this.projectType, this.setProjectDataCustom({ ...u, id: this.projectIdToLoad }), yield t.pluginStore.initProjectPlugins(this.projectType), this.editorKey++;
  }
  setInstallEvent(t) {
    this.installEvent = t;
  }
  setAppInstalled(t) {
    this.appInstalled = t;
  }
  setDisplayMode(t) {
    this.displayMode = t;
  }
  setProject(t) {
    const n = this.editor, { id: r, data: o, isTemplate: s } = t, i = n.Storage.getConfig().options.local, a = s ? `${r}__${hS()}` : r;
    this._projectId = a, i.key = a, pS(o) || this.loadProjectData({
      ...o,
      custom: {
        ...o.custom,
        id: a,
        projectType: this.store.templatesStore.projectTypeFilter
      }
    });
  }
  setProjectDataCustom(t) {
    const n = {
      ...this.projectDataCustom,
      ...t
    };
    this.projectDataCustom = n, this.projectType = n.projectType || Ve.web, this.editor && C5(this.editor, n), n.id && this.store.localSettingsStore.setLocalState({
      lastProjectId: n.id,
      lastProjectType: this.projectType
    });
  }
  /**
   * Load new GrapesJS JSON (eg. from .grapesjs file)
   */
  loadProjectData(t) {
    const n = t.custom || {};
    if (iM(t) !== this.projectType)
      this.setNextProjectData(t), this.setProjectDataCustom(n), this.updateStudio();
    else {
      const r = this.editor;
      r.loadProjectData(t), r.UndoManager.clear(), this.setProjectDataCustom(n);
    }
  }
  setNextProjectData(t) {
    this.nextProjectData = t;
  }
  setLeftSidebarSize(t) {
    this.leftSidebarSize = t;
  }
  setRightSidebarSize(t) {
    this.rightSidebarSize = t;
  }
  setEditor(t) {
    this.editor = t;
  }
  setPreview(t) {
    this.isInPreview = t;
  }
  toggleCssPanel() {
    this.isCssPanelActive = !this.isCssPanelActive;
  }
  toggleLeftSidebar() {
    this.isLeftSidebarOpen = !this.isLeftSidebarOpen, this.refreshEditorPostTransition();
  }
  setLeftSidebarOpen(t) {
    this.isLeftSidebarOpen = t, this.refreshEditorPostTransition();
  }
  toggleRightSidebar() {
    this.isRightSidebarOpen = !this.isRightSidebarOpen, this.refreshEditorPostTransition();
  }
  setRightSidebarOpen(t) {
    this.isRightSidebarOpen = t, this.refreshEditorPostTransition();
  }
  setTopSidebarOpen(t) {
    this.isTopSidebarOpen = t, this.refreshEditorPostTransition();
  }
  setBottomSidebarOpen(t) {
    this.isBottomSidebarOpen = t, this.refreshEditorPostTransition();
  }
  refreshEditorPostTransition() {
    setTimeout(() => {
      var t;
      return (t = this.editor) == null ? void 0 : t.refresh();
    }, this.transitionTime);
  }
  setCanvasPanning(t) {
    this.isCanvasPanning = t;
  }
  setSelectingTarget(t) {
    this.isSelectingTarget = t;
  }
  setSelectedDesignerTab(t) {
    this.selectedDesignerTab = t;
  }
  setCustomAssets(t) {
    this.customAssets = t;
  }
  setIsSaving(t) {
    this.isSaving = t;
  }
  setIsReady(t) {
    this.isReady = t;
  }
  setPanelPageSettings(t) {
    this.panelPageSettings = {
      ...this.panelPageSettings,
      ...t
    };
  }
  setSdkPagesConfig(t) {
    this.sdkProps.options.pages = t && {
      ...this.sdkPagesConfig,
      ...t
    }, ++this.sdkPagesConfigUpdates;
  }
  setRootElWidth(t) {
    this.rootElWidth = t, this.refreshEditorCanvas();
  }
  *loadLicense() {
    const { editor: t } = this;
    try {
      this.licenseCheckStarted = !0;
      const { licenseKey: n, baseApiUrl: r, studioSdkVersion: o } = this;
      t == null || t.trigger(Xw, { baseApiUrl: r });
      const s = yield ar.post(`${r}/sdk/${n || "na"}`, {
        params: { d: window.location.hostname, v: o }
      });
      if (s instanceof Error)
        throw s;
      const i = s.result || {}, { license: a, error: l, plan: u } = i;
      l ? this.sdkLicenseError = l : (this.sdkLicense = a, u != null && u.poweredBy && (this.showPoweredBy = !0)), t == null || t.trigger(Mf, i);
    } catch (n) {
      this.licenseCheckRetry < 3 ? (this.licenseCheckRetry++, setTimeout(() => this.loadLicense(), 3e3)) : (console.error(n), this.showPoweredBy = !0, t == null || t.trigger(Mf, {}));
    }
  }
  *updateStudio() {
    const { pluginStore: t } = this.store, { projectType: n } = this.projectDataCustom;
    yield t.initProjectPlugins(n), this.editorKey++;
  }
  refreshStudio() {
    var t;
    this.editorKey && (this.setNextProjectData((t = this.editor) == null ? void 0 : t.getProjectData()), this.editorKey++);
  }
  refreshEditorCanvas() {
    var t;
    (t = this.editor) == null || t.refresh({ tools: !0 });
  }
}
const iM = (e) => {
  var t;
  return ((t = e.custom) == null ? void 0 : t.projectType) || Ve.web;
}, aM = (e) => {
  qm(
    () => e.currentLayout,
    () => e.refreshStudio()
  );
}, ye = () => It().appEditorStore, lM = () => {
  try {
    return ye();
  } catch {
  }
}, ts = () => oa().appEditorStore, pc = () => {
  const [e, t] = W(0), n = It().appEditorStore, { transitionTime: r } = n;
  return G(() => {
    setTimeout(() => t((o) => ++o), r);
  }, [r]), [e];
}, Fb = String.raw, ze = (e, t) => {
  if (t == null)
    return "";
  const n = e[0], r = e[1];
  return `${n}${t}${r}`;
}, cM = (e, t = "") => {
  var n, r, o, s, i, a, l, u, d, p, f, h, g, m, v, b, y, w, S, x, C, P, _, O, E, T, R, B, U, L, M, D, V, k, j, Y, J, le, Q, re, ge, X, Z, te, de, ce, Ce, Pe, at, ut, Pt, gt, Je, dn, ht, rt, dt, Tt, vt, Et, An, Vt, Ln, uo, Do, Io;
  return Fb`
  ${t}.${je.txt} {
    ${ze`color: ${(r = (n = e.colors) == null ? void 0 : n.global) == null ? void 0 : r.text};`}
  }

  ${t}.${je.bg} {
    ${ze`background-color: ${(s = (o = e.colors) == null ? void 0 : o.global) == null ? void 0 : s.background3};`}
  }

  ${t}.${je.br} {
    ${ze`border-color: ${(a = (i = e.colors) == null ? void 0 : i.global) == null ? void 0 : a.border};`}
  }

  ${t}.${je.bgA} {
    ${ze`background-color: ${(u = (l = e.colors) == null ? void 0 : l.primary) == null ? void 0 : u.background1};`}
    ${ze`color: ${(p = (d = e.colors) == null ? void 0 : d.primary) == null ? void 0 : p.text};`}
  }

  ${t}.${je.bgA2} {
    ${ze`background-color: ${(h = (f = e.colors) == null ? void 0 : f.primary) == null ? void 0 : h.background1};`}
    ${ze`color: ${(m = (g = e.colors) == null ? void 0 : g.primary) == null ? void 0 : m.text};`}
  }

  ${t}.${je.hBgAct}:hover.${je.hBgAct}:hover,
  ${t}.${je.hBgA2}:hover.${je.hBgA2}:hover {
    ${ze`background-color: ${(b = (v = e.colors) == null ? void 0 : v.primary) == null ? void 0 : b.backgroundHover};`}
  }

  ${t}.${je.tA} {
    ${ze`color: ${(w = (y = e.colors) == null ? void 0 : y.primary) == null ? void 0 : w.background1};`}
  }

  ${t}.${je.tAo} {
    ${ze`color: ${(x = (S = e.colors) == null ? void 0 : S.primary) == null ? void 0 : x.background1};`}
  }

  ${t}.${je.hTAo}:hover.${je.hTAo}:hover,
  ${t}.group:hover .${je.grouphTAo} {
    ${ze`color: ${(P = (C = e.colors) == null ? void 0 : C.primary) == null ? void 0 : P.backgroundHover};`}
  }

  ${t}.${je.bA} {
    ${ze`border-color: ${(O = (_ = e.colors) == null ? void 0 : _.primary) == null ? void 0 : O.background1};`}
  }

  ${t}.${je.bg0} {
    ${ze`background-color: ${(T = (E = e.colors) == null ? void 0 : E.primary) == null ? void 0 : T.background3};`}
    ${ze`color: ${(B = (R = e.colors) == null ? void 0 : R.primary) == null ? void 0 : B.background1};`}
  }

  ${t}.${je.bgH} {
    ${ze`background-color: ${(L = (U = e.colors) == null ? void 0 : U.global) == null ? void 0 : L.background1};`}
  }

  ${t}.${je.bgH2} {
    ${ze`background-color: ${(D = (M = e.colors) == null ? void 0 : M.global) == null ? void 0 : D.background2};`}
  }

  ${t}.${je.hBgH}:hover,
  ${t}.${je.hBgH2}:hover {
    ${ze`background-color: ${(k = (V = e.colors) == null ? void 0 : V.global) == null ? void 0 : k.backgroundHover};`}
  }

  ${t}.${je.sel} {
    ${ze`background-color: ${(Y = (j = e.colors) == null ? void 0 : j.selector) == null ? void 0 : Y.background2};`}
    ${ze`color: ${(le = (J = e.colors) == null ? void 0 : J.selector) == null ? void 0 : le.background1};`}
  }

  ${t}.${je.selBr} {
    ${ze`border-color: ${(re = (Q = e.colors) == null ? void 0 : Q.selector) == null ? void 0 : re.background1};`}
  }

  ${t}.${je.cmp} {
    ${ze`background-color: ${(X = (ge = e.colors) == null ? void 0 : ge.component) == null ? void 0 : X.background1};`}
    ${ze`color: ${(te = (Z = e.colors) == null ? void 0 : Z.component) == null ? void 0 : te.text};`}
  }

  ${t}.${je.cmpBgSoft} {
    ${ze`background-color: ${(ce = (de = e.colors) == null ? void 0 : de.component) == null ? void 0 : ce.background2};`}
  }

  ${t}.${je.cmpBgSoftX} {
    ${ze`background-color: ${(Pe = (Ce = e.colors) == null ? void 0 : Ce.component) == null ? void 0 : Pe.background3};`}
  }

  ${t}.${je.cmpBr} {
    ${ze`border-color: ${(ut = (at = e.colors) == null ? void 0 : at.component) == null ? void 0 : ut.background1};`}
  }

  ${t}.${je.cmpSymbol} {
    ${ze`background-color: ${(gt = (Pt = e.colors) == null ? void 0 : Pt.symbol) == null ? void 0 : gt.background1};`}
    ${ze`color: ${(dn = (Je = e.colors) == null ? void 0 : Je.symbol) == null ? void 0 : dn.text};`}
  }

  ${t}.${je.cmpBgSymbolSoft} {
    ${ze`background-color: ${(rt = (ht = e.colors) == null ? void 0 : ht.symbol) == null ? void 0 : rt.background2};`}
  }

  ${t}.${je.cmpBgSymbolSoftX} {
    ${ze`background-color: ${(Tt = (dt = e.colors) == null ? void 0 : dt.symbol) == null ? void 0 : Tt.background3};`}
  }

  ${t}.${je.cmpSymbolBr} {
    ${ze`border-color: ${(Et = (vt = e.colors) == null ? void 0 : vt.symbol) == null ? void 0 : Et.background1};`}
  }

  ${t}.${je.cmpTxtActive} {
    ${ze`color: ${(Vt = (An = e.colors) == null ? void 0 : An.component) == null ? void 0 : Vt.text};`}
  }

  ${t}.${je.focus}:focus-visible {
    ${ze`box-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) ${(uo = (Ln = e.colors) == null ? void 0 : Ln.global) == null ? void 0 : uo.focus};`}
  }

  ${t}.${je.inputText}::placeholder {
    ${ze`color: ${(Io = (Do = e.colors) == null ? void 0 : Do.global) == null ? void 0 : Io.placeholder};`}
  }
`;
}, uM = () => {
  const e = ye(), { sdkOptions: t } = e, { customTheme: n } = t;
  if (!n)
    return null;
  const r = Fb`
    ${n.default ? cM(
    n.default,
    t.theme === qr.light ? `:not(.gs-utl-${qr.dark}) ` : `.gs-utl-${qr.dark} `
  ) : ""}
  `;
  return /* @__PURE__ */ c("style", { children: r });
}, dM = ue(function() {
  const t = Np(), { isOpen: n, items: r, coordinates: o } = t, { x: s, y: i } = o;
  return G(() => {
    const a = window.document, l = (u) => u.key === "Escape" && t.hide();
    return a.addEventListener("keydown", l), () => {
      a.removeEventListener("keydown", l);
    };
  }, []), /* @__PURE__ */ A(ae, { children: [
    /* @__PURE__ */ c(xv, { open: n, items: r, x: s, y: i }),
    n && /* @__PURE__ */ c("div", { onClick: t.hide, className: F("z-10 fixed inset-0") })
  ] });
});
function St({ children: e, label: t, s: n = "m", pill: r, border: o, nopad: s, className: i, block: a, ...l }) {
  return /* @__PURE__ */ c(
    "div",
    {
      className: $([
        !a && "inline-block",
        i,
        !s && Re.xyS2,
        r ? se.pill : se.rnd,
        o && `${se.b} ${z.br}`,
        n === "s" && "text-sm",
        n === "xs" && "gjs-p-1"
      ]),
      ...l,
      children: t || e
    }
  );
}
const xg = 15, pM = ue(function() {
  const { isActive: t, content: n } = kv(), [r, o] = W({ x: 0, y: 0 });
  G(() => {
    const i = (a) => {
      o({ x: a.clientX, y: Math.max(0, a.clientY) });
    };
    return t && window.addEventListener("pointermove", i), () => {
      window.removeEventListener("pointermove", i);
    };
  }, [t]);
  const s = ie(
    () => ({
      transform: `translate(${r.x + xg}px, ${r.y + xg}px)`
    }),
    [r]
  );
  return /* @__PURE__ */ c(rr, { show: t, ...zi, children: /* @__PURE__ */ c("div", { className: F("fixed top-0 left-0 pointer-badge pointer-events-none z-10"), style: s, children: /* @__PURE__ */ c(St, { className: F("gjs-px-4 gjs-py-2", z.bgBlur, z.txtHighEmphasis), pill: !0, border: !0, nopad: !0, children: n }) }) });
}), fM = ue(function() {
  const t = jv();
  return /* @__PURE__ */ c(
    u5,
    {
      className: $("fixed top-5 right-5 z-20"),
      toasts: t.toasts,
      onDismiss: t.remove
    }
  );
}), yu = typeof window < "u" ? window.location.hostname : "";
yu || // [::1] is the IPv6 localhost address.
yu === "[::1]" || // 127.0.0.0/8 are considered localhost for IPv4.
yu.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/);
function hM(e) {
  if (
    // ({"NODE_ENV":"production","NPM_PACKAGE_VERSION":"1.0.0","STUDIO_NPM_PACKAGE_VERSION":"1.0.35"}).NODE_ENV === 'production' &&
    "serviceWorker" in navigator
  ) {
    if (new URL({ NODE_ENV: "production", NPM_PACKAGE_VERSION: "1.0.0", STUDIO_NPM_PACKAGE_VERSION: "1.0.35" }.PUBLIC_URL || "", window.location.href).origin !== window.location.origin)
      return;
    window.addEventListener("beforeinstallprompt", (o) => {
      o.preventDefault(), ts().setInstallEvent(o);
    }), window.addEventListener("appinstalled", () => {
      ts().setAppInstalled(!0);
    }), navigator.serviceWorker.addEventListener("controllerchange", () => {
    });
    const n = (o) => {
      let s = "browser";
      const i = navigator.standalone || document.referrer.startsWith("android-app://");
      (o || i) && (s = "standalone"), ts().setDisplayMode(s);
    }, r = window.matchMedia("(display-mode: standalone)");
    r.addEventListener("change", (o) => n(o.matches)), n(r.matches);
  }
}
const gM = Rt(function({ children: t }, n) {
  const [r, o] = W(""), s = cn(), i = K(null), a = ye(), {
    style: l,
    className: u,
    options: d = Rd,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onUpdate: p,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onEditor: f,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onReady: h,
    ...g
  } = a.sdkProps, { autoHeight: m = !0, serviceWorker: v } = d;
  Ml(n, () => i.current, []);
  const b = ie(
    () => ({
      ...l,
      height: r || (l == null ? void 0 : l.height) || ""
    }),
    [l, r]
  );
  return G(() => {
    const y = i.current, w = () => {
      var C;
      return (C = y == null ? void 0 : y.parentElement) == null ? void 0 : C.offsetHeight;
    }, S = w(), x = () => {
      const C = y.style.position;
      y.style.position = "absolute";
      const P = w();
      P && o(`${P}px`), y.style.position = C;
    };
    if (S && m)
      return o(`${S}px`), window.addEventListener("resize", x), () => window.removeEventListener("resize", x);
  }, [m, i.current]), G(() => {
    const y = i.current;
    if (!y)
      return;
    s.rootEl || s.setRootEl(y), s.init();
    const w = new ResizeObserver(() => {
      a.setRootElWidth(y.offsetWidth);
    });
    return a.setRootElWidth(y.offsetWidth), w.observe(y), () => {
      w.disconnect();
    };
  }, [i.current]), G(() => {
    v && hM();
  }, []), /* @__PURE__ */ A(
    "div",
    {
      ref: i,
      className: q(F(u1, "gs-studio-editor overflow-hidden h-full w-full text-base"), u),
      style: b,
      ...g,
      children: [
        /* @__PURE__ */ c(uM, {}),
        t,
        /* @__PURE__ */ A("div", { className: F("gs-studio-els", z.txt), children: [
          /* @__PURE__ */ c(fM, {}),
          /* @__PURE__ */ c(pM, {}),
          /* @__PURE__ */ c(dM, {})
        ] })
      ]
    }
  );
});
var ti = /* @__PURE__ */ ((e) => (e.REGULAR = "regular", e.SYMBOLS = "symbols", e))(ti || {});
const $a = "gs-cmp-tabs";
function Ro({
  tabs: e,
  className: t,
  classNamePanel: n,
  classNameTab: r,
  variant: o,
  style: s,
  onChange: i = cS,
  value: a
}) {
  const l = o === "pills", u = l ? q("gs-utl-rounded-full gs-utl-text-sm gs-utl-px-[2px] gs-utl-py-[2px]", z.bgH) : "", d = (m) => l ? q("gs-utl-rounded-full gs-utl-px-3 gs-utl-py-1", m ? z.bg : "") : q("gs-utl-border-b-2", Re.xy), p = (m) => {
    m && (m.tabIndex = -1);
  }, f = (m) => {
    const v = m.currentTarget;
    setTimeout(() => v.blur(), 10);
  }, h = Pr(a) ? e.findIndex((m) => m.id === a) : void 0, g = !e.some((m) => !!m.content);
  return /* @__PURE__ */ A(
    Ws.Group,
    {
      onChange: (m) => i(e[m].id),
      defaultIndex: e.findIndex((m) => m.id === a),
      selectedIndex: h,
      children: [
        /* @__PURE__ */ c(Ws.List, { as: I, className: q($a, t, u), style: s, full: !0, nowrap: !0, children: e.map((m) => /* @__PURE__ */ c(
          Ws,
          {
            disabled: m.disabled,
            className: ({ selected: v }) => q(
              `${$a}__tab`,
              "gs-utl-flex-1 focus:gs-utl-outline-none",
              m.disabled && "gs-utl-cursor-not-allowed gs-utl-opacity-50",
              xi.focus,
              d(v),
              v ? `${z.tAo} ${z.bA}` : z.br,
              r
            ),
            children: m.label
          },
          m.id
        )) }),
        /* @__PURE__ */ c(
          Ws.Panels,
          {
            className: q(
              `${$a}__panels`,
              "gs-utl-overflow-hidden gs-utl-flex-1",
              g && "gs-utl-hidden",
              n
            ),
            children: e.map((m) => /* @__PURE__ */ c(
              Ws.Panel,
              {
                tabIndex: -1,
                className: q(`${$a}__panel`, "gs-utl-h-full"),
                ref: p,
                onFocus: f,
                children: m.content
              },
              m.id
            ))
          }
        )
      ]
    }
  );
}
var Ub = /* @__PURE__ */ ((e) => (e.primary = "primary", e.outline = "outline", e.shallow = "shallow", e))(Ub || {}), Wb = /* @__PURE__ */ ((e) => (e.none = "", e.xs = "xs", e.s = "s", e.m = "m", e.lg = "lg", e))(Wb || {});
const mM = "gs-cmp-button", nf = we(
  ue(function({
    className: t,
    children: n,
    tooltip: r,
    variant: o,
    onClick: s,
    editorEvents: i,
    label: a,
    size: l,
    icon: u,
    active: d,
    buttonType: p,
    disabled: f,
    ...h
  }) {
    const { editor: g } = ye(), [m, v] = W(() => ({
      disabled: f,
      variant: o,
      active: d,
      className: t,
      tooltip: r,
      icon: u,
      size: l,
      label: a
    })), b = m.variant, y = b === "outline", w = b === "primary" ? "pr" : y ? "out-clear" : void 0, S = m.label, x = (C) => {
      g && (s == null || s({ event: C, editor: g, state: m, setState: (P) => v((_) => ({ ..._, ...P })) }));
    };
    return G(() => {
      if (!i || !g)
        return;
      const C = Object.keys(i).reduce(
        (_, O) => (_[O] = (E = {}) => {
          i[O]({
            fromEvent: E,
            editor: g,
            state: m,
            setState: (T) => v((R) => ({ ...R, ...T }))
          });
        }, _),
        {}
      ), P = Object.keys(C);
      return P.forEach((_) => g.on(_, C[_])), () => {
        P.forEach((_) => g.off(_, C[_]));
      };
    }, [g, m]), /* @__PURE__ */ c(
      Ft,
      {
        title: m.tooltip,
        className: q(mM),
        classNameWrp: m.className,
        variant: w,
        icon: m.icon,
        active: m.active,
        size: m.size,
        disabled: m.disabled,
        onClick: x,
        border: y,
        type: p,
        block: !0,
        ...h,
        children: S ? ct(S) ? S({ editor: g }) : S : n
      }
    );
  })
), vM = "gs-cmp-button-group-field", bM = we(
  ue(function({
    className: t,
    label: n,
    name: r,
    value: o,
    options: s,
    size: i,
    required: a,
    disabled: l,
    onChange: u,
    editorEvents: d
  }) {
    const { editor: p } = ye(), [f, h] = W(() => ({
      className: t,
      label: n,
      name: r,
      value: o,
      options: s,
      size: i,
      required: a,
      disabled: l
    })), g = (m) => {
      u({
        value: m,
        editor: p,
        state: f,
        setState: (v) => h((b) => ({ ...b, ...v }))
      });
    };
    return Pc({
      editor: p,
      editorEvents: d,
      localState: f,
      setLocalState: h
    }), /* @__PURE__ */ c(
      Bt,
      {
        className: q(vM, f.className),
        label: f.label,
        name: f.name,
        value: f.value,
        options: f.options ?? [],
        size: f.size,
        required: f.required,
        disabled: f.disabled,
        onChange: g
      }
    );
  })
);
function fc({ colors: e, ...t }) {
  return e ? /* @__PURE__ */ A("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 79 79", ...t, children: [
    /* @__PURE__ */ c("path", { fill: "url(#a)", d: "M39.6 77.1a37.5 37.5 0 1 0 0-75 37.5 37.5 0 0 0 0 75Z" }),
    /* @__PURE__ */ c(
      "path",
      {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeMiterlimit: "10",
        strokeWidth: "5",
        d: "m40 19-14.58 8.79a6.36 6.36 0 0 0-2.82 5.33v14.13a6.14 6.14 0 0 0 3.12 5.13l11.21 5.8a6.12 6.12 0 0 0 6.14 0l11.41-6.3a6.09 6.09 0 0 0 3.12-5.13V33.12c0-1.28-1.4-2.07-2.52-1.48l-15.08 8"
      }
    ),
    /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ A("linearGradient", { id: "a", x1: "2.1", x2: "77.2", y1: "39.6", y2: "39.6", gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ c("stop", { stopColor: "#D7709E" }),
      /* @__PURE__ */ c("stop", { offset: "1", stopColor: "#A84A87" })
    ] }) })
  ] }) : /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 76 76", ...t, children: /* @__PURE__ */ c(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M64.117 64.117a37.5 37.5 0 1 1-53.034-53.034 37.5 37.5 0 0 1 53.034 53.034ZM39.29 19.14a2.5 2.5 0 1 0-2.582-4.282l-14.583 8.79-.05.03-.047.032a8.861 8.861 0 0 0-2.917 3.229 8.729 8.729 0 0 0-1.011 4.203V45.293l.002.047a8.64 8.64 0 0 0 1.25 4.164 8.78 8.78 0 0 0 3.115 3.043l.05.03.053.027 11.165 5.769a8.62 8.62 0 0 0 4.264 1.127c1.507 0 2.99-.394 4.295-1.145l11.394-6.276.006-.004a8.585 8.585 0 0 0 3.178-3.05 8.443 8.443 0 0 0 1.227-4.225V31.123c0-3.265-3.502-5.122-6.19-3.688l-.005.003-15.076 7.995a2.5 2.5 0 0 0 2.342 4.418l13.93-7.387v12.263a3.444 3.444 0 0 1-.502 1.703 3.584 3.584 0 0 1-1.326 1.271l-.003.002-11.409 6.284-.024.014-.023.013a3.619 3.619 0 0 1-1.814.486 3.62 3.62 0 0 1-1.814-.486l-.052-.03-.054-.028-11.155-5.764a3.78 3.78 0 0 1-1.297-1.283 3.642 3.642 0 0 1-.527-1.715V31.081a3.73 3.73 0 0 1 .432-1.806 3.858 3.858 0 0 1 1.23-1.377L39.29 19.14Z",
      clipRule: "evenodd"
    }
  ) });
}
const yM = we(
  ue(function() {
    const { isStage: e, updateStudio: t } = ye(), { isDarkTheme: n } = cn(), r = K(null), { bg: o, text: s } = C1(n);
    return bv({
      ref: r,
      show: e,
      update: n,
      reload: t,
      styles: {
        display: "flex",
        justifyContent: "center",
        position: "absolute",
        bottom: "0",
        right: "0",
        left: "0"
      },
      node: /* @__PURE__ */ A(ae, { children: [
        /* @__PURE__ */ c("style", { children: `
              .gs-banner {
                  box-shadow: 0 0 5px #1c1b1b21;
                  padding: 30px 10px;
                  border-radius: 10px;
                  margin: 5px;
                  font-size: 30px;
                  background-color: ${o};
                  color: ${s};
                  width: 95%;
              }
              .gs-banner-row {
                  justify-content: center;
                  align-items: center;
                  display: flex;
                  gap: 10px;
              }
              .gs-gs-logo {
                  width: 35px;
              }
            ` }),
        /* @__PURE__ */ c(Jt, { className: "gs-banner", children: /* @__PURE__ */ A(I, { className: "gs-banner-row", children: [
          /* @__PURE__ */ c(fc, { className: "gs-gs-logo", colors: !0 }),
          /* @__PURE__ */ c("div", { children: "GrapesJS Studio Demo!" })
        ] }) })
      ] })
    }), /* @__PURE__ */ c("div", { ref: r });
  })
), wM = () => `https://grapesjs.com?ref=${window.location.host}`, SM = we(
  ue(function() {
    const { updateStudio: e, showPoweredBy: t } = ye(), { isDarkTheme: n } = cn(), r = K(null), { bg: o, text: s, link: i } = C1(n);
    return bv({
      ref: r,
      show: t,
      update: n,
      reload: e,
      styles: {
        display: "flex",
        justifyContent: "center",
        position: "absolute",
        bottom: "0",
        left: "0"
      },
      node: /* @__PURE__ */ A(ae, { children: [
        /* @__PURE__ */ c("style", { children: `
              .gs-banner {
                  box-shadow: 0 0 5px #1c1b1b21;
                  padding: 5px 10px;
                  border-radius: 9999px;
                  margin: 5px;
                  font-size: 12px;
                  background-color: ${o};
                  color: ${s};
              }
              .gs-banner-row {
                  justify-content: center;
                  align-items: center;
                  display: flex;
                  gap: 3px;
              }
              .gs-link {
                  color: ${i};
                  text-decoration: none;
              }
              .gs-logo {
                  width: 20px;
              }
             ` }),
        /* @__PURE__ */ c(Jt, { className: "gs-banner", children: /* @__PURE__ */ A(I, { className: "gs-banner-row", children: [
          /* @__PURE__ */ c("a", { className: "gs-link", href: wM(), target: "_blank", children: "GrapesJS Studio" }),
          /* @__PURE__ */ c(fc, { className: "gs-logo", colors: !0 })
        ] }) })
      ] })
    }), /* @__PURE__ */ c("div", { ref: r });
  })
), sa = H.forwardRef(function({ full: t, abs: n, small: r, className: o }, s) {
  const i = F(t && "w-full h-full", n && Qe.coverAbs, o), a = F(
    r ? "w-5 h-5" : "w-10 h-10",
    "animate-spin-fast",
    "!gs-utl-border-y-transparent !gs-utl-border-r-transparent",
    se.pill,
    se.bS,
    se.bA
  );
  return /* @__PURE__ */ c(I, { ref: s, className: i, items: "center", justify: "center", children: /* @__PURE__ */ c("div", { className: a }) });
}), xM = we(
  ue(function() {
    const { isReady: t } = ye();
    return /* @__PURE__ */ A(ae, { children: [
      /* @__PURE__ */ c("div", { children: !t && /* @__PURE__ */ c(sa, { className: F("z-10"), abs: !0, full: !0 }) }),
      /* @__PURE__ */ c(yM, {}),
      /* @__PURE__ */ c(SM, {})
    ] });
  })
), CM = "gs-canvas", Gb = we(function({ className: t, style: n, grow: r }) {
  return /* @__PURE__ */ c(
    ZA,
    {
      style: n,
      className: q(
        CM,
        "gs-utl-relative gs-utl-bg-gray-50 dark:gs-utl-bg-zinc-800",
        r && "gs-utl-flex-grow",
        t
      ),
      children: /* @__PURE__ */ c(Mo, { children: /* @__PURE__ */ c(xM, {}) })
    }
  );
}), hc = ({
  className: e,
  grow: t,
  alignItems: n,
  justifyContent: r
}) => q(
  e,
  z.br,
  t && "gs-utl-flex-grow",
  n === "start" && "gs-utl-items-start",
  n === "end" && "gs-utl-items-end",
  n === "center" && "gs-utl-items-center",
  n === "baseline" && "gs-utl-items-baseline",
  n === "stretch" && "gs-utl-items-stretch",
  r === "start" && "gs-utl-justify-start",
  r === "end" && "gs-utl-justify-end",
  r === "center" && "gs-utl-justify-center",
  r === "between" && "gs-utl-justify-between",
  r === "around" && "gs-utl-justify-around",
  r === "evenly" && "gs-utl-justify-evenly"
), gc = ({
  style: e,
  width: t,
  height: n,
  gap: r
}) => ({
  height: n,
  gap: r,
  width: t,
  ...e
}), No = we(
  ue(function({
    id: t,
    children: n,
    className: r,
    style: o,
    width: s,
    gap: i,
    height: a,
    grow: l,
    alignItems: u,
    justifyContent: d,
    htmlAttrs: p,
    ...f
  }) {
    const { layoutsById: h } = Vp(), [g, m] = W({}), { className: v, style: b, ...y } = p || {}, w = r ?? v, S = o ?? b, x = ie(
      () => gc({
        height: a,
        gap: i,
        width: s,
        style: S
      }),
      [S, s, a, i]
    ), C = hc({ className: w, grow: l, alignItems: u, justifyContent: d });
    G(() => {
      if (t)
        return h.set(t, { state: g, setState: m }), () => {
          h.delete(t);
        };
    }, [h, g]);
    const P = f.as ?? "div";
    return /* @__PURE__ */ c(P, { style: x, className: C, ...f, ...y, children: g.children ?? n });
  })
), rf = (() => {
  if (typeof self > "u")
    return !1;
  if ("top" in self && self !== top)
    try {
      top.window.document._ = 0;
    } catch {
      return !1;
    }
  return "showOpenFilePicker" in self;
})(), PM = rf ? Promise.resolve().then(function() {
  return LM;
}) : Promise.resolve().then(function() {
  return jM;
});
async function EM(...e) {
  return (await PM).default(...e);
}
rf ? Promise.resolve().then(function() {
  return MM;
}) : Promise.resolve().then(function() {
  return IM;
});
const OM = rf ? Promise.resolve().then(function() {
  return RM;
}) : Promise.resolve().then(function() {
  return HM;
});
async function _M(...e) {
  return (await OM).default(...e);
}
const TM = async (e) => {
  const t = await e.getFile();
  return t.handle = e, t;
};
var AM = async (e = [{}]) => {
  Array.isArray(e) || (e = [e]);
  const t = [];
  e.forEach((o, s) => {
    t[s] = { description: o.description || "Files", accept: {} }, o.mimeTypes ? o.mimeTypes.map((i) => {
      t[s].accept[i] = o.extensions || [];
    }) : t[s].accept["*/*"] = o.extensions || [];
  });
  const n = await window.showOpenFilePicker({ id: e[0].id, startIn: e[0].startIn, types: t, multiple: e[0].multiple || !1, excludeAcceptAllOption: e[0].excludeAcceptAllOption || !1 }), r = await Promise.all(n.map(TM));
  return e[0].multiple ? r : r[0];
}, LM = { __proto__: null, default: AM };
function Ja(e) {
  function t(n) {
    if (Object(n) !== n)
      return Promise.reject(new TypeError(n + " is not an object."));
    var r = n.done;
    return Promise.resolve(n.value).then(function(o) {
      return { value: o, done: r };
    });
  }
  return Ja = function(n) {
    this.s = n, this.n = n.next;
  }, Ja.prototype = { s: null, n: null, next: function() {
    return t(this.n.apply(this.s, arguments));
  }, return: function(n) {
    var r = this.s.return;
    return r === void 0 ? Promise.resolve({ value: n, done: !0 }) : t(r.apply(this.s, arguments));
  }, throw: function(n) {
    var r = this.s.return;
    return r === void 0 ? Promise.reject(n) : t(r.apply(this.s, arguments));
  } }, new Ja(e);
}
const Kb = async (e, t, n = e.name, r) => {
  const o = [], s = [];
  var i, a = !1, l = !1;
  try {
    for (var u, d = function(p) {
      var f, h, g, m = 2;
      for (typeof Symbol < "u" && (h = Symbol.asyncIterator, g = Symbol.iterator); m--; ) {
        if (h && (f = p[h]) != null)
          return f.call(p);
        if (g && (f = p[g]) != null)
          return new Ja(f.call(p));
        h = "@@asyncIterator", g = "@@iterator";
      }
      throw new TypeError("Object is not async iterable");
    }(e.values()); a = !(u = await d.next()).done; a = !1) {
      const p = u.value, f = `${n}/${p.name}`;
      p.kind === "file" ? s.push(p.getFile().then((h) => (h.directoryHandle = e, h.handle = p, Object.defineProperty(h, "webkitRelativePath", { configurable: !0, enumerable: !0, get: () => f })))) : p.kind !== "directory" || !t || r && r(p) || o.push(Kb(p, t, f, r));
    }
  } catch (p) {
    l = !0, i = p;
  } finally {
    try {
      a && d.return != null && await d.return();
    } finally {
      if (l)
        throw i;
    }
  }
  return [...(await Promise.all(o)).flat(), ...await Promise.all(s)];
};
var kM = async (e = {}) => {
  e.recursive = e.recursive || !1, e.mode = e.mode || "read";
  const t = await window.showDirectoryPicker({ id: e.id, startIn: e.startIn, mode: e.mode });
  return (await (await t.values()).next()).done ? [t] : Kb(t, e.recursive, void 0, e.skipDirectory);
}, MM = { __proto__: null, default: kM }, $M = async (e, t = [{}], n = null, r = !1, o = null) => {
  Array.isArray(t) || (t = [t]), t[0].fileName = t[0].fileName || "Untitled";
  const s = [];
  let i = null;
  if (e instanceof Blob && e.type ? i = e.type : e.headers && e.headers.get("content-type") && (i = e.headers.get("content-type")), t.forEach((u, d) => {
    s[d] = { description: u.description || "Files", accept: {} }, u.mimeTypes ? (d === 0 && i && u.mimeTypes.push(i), u.mimeTypes.map((p) => {
      s[d].accept[p] = u.extensions || [];
    })) : i ? s[d].accept[i] = u.extensions || [] : s[d].accept["*/*"] = u.extensions || [];
  }), n)
    try {
      await n.getFile();
    } catch (u) {
      if (n = null, r)
        throw u;
    }
  const a = n || await window.showSaveFilePicker({ suggestedName: t[0].fileName, id: t[0].id, startIn: t[0].startIn, types: s, excludeAcceptAllOption: t[0].excludeAcceptAllOption || !1 });
  !n && o && o(a);
  const l = await a.createWritable();
  return "stream" in e ? (await e.stream().pipeTo(l), a) : "body" in e ? (await e.body.pipeTo(l), a) : (await l.write(await e), await l.close(), a);
}, RM = { __proto__: null, default: $M }, NM = async (e = [{}]) => (Array.isArray(e) || (e = [e]), new Promise((t, n) => {
  const r = document.createElement("input");
  r.type = "file";
  const o = [...e.map((l) => l.mimeTypes || []), ...e.map((l) => l.extensions || [])].join();
  r.multiple = e[0].multiple || !1, r.accept = o || "", r.style.display = "none", document.body.append(r);
  const s = (l) => {
    typeof i == "function" && i(), t(l);
  }, i = e[0].legacySetup && e[0].legacySetup(s, () => i(n), r), a = () => {
    window.removeEventListener("focus", a), r.remove();
  };
  r.addEventListener("click", () => {
    window.addEventListener("focus", a);
  }), r.addEventListener("change", () => {
    window.removeEventListener("focus", a), r.remove(), s(r.multiple ? Array.from(r.files) : r.files[0]);
  }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
})), jM = { __proto__: null, default: NM }, DM = async (e = [{}]) => (Array.isArray(e) || (e = [e]), e[0].recursive = e[0].recursive || !1, new Promise((t, n) => {
  const r = document.createElement("input");
  r.type = "file", r.webkitdirectory = !0;
  const o = (i) => {
    typeof s == "function" && s(), t(i);
  }, s = e[0].legacySetup && e[0].legacySetup(o, () => s(n), r);
  r.addEventListener("change", () => {
    let i = Array.from(r.files);
    e[0].recursive ? e[0].recursive && e[0].skipDirectory && (i = i.filter((a) => a.webkitRelativePath.split("/").every((l) => !e[0].skipDirectory({ name: l, kind: "directory" })))) : i = i.filter((a) => a.webkitRelativePath.split("/").length === 2), o(i);
  }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
})), IM = { __proto__: null, default: DM }, VM = async (e, t = {}) => {
  Array.isArray(t) && (t = t[0]);
  const n = document.createElement("a");
  let r = e;
  "body" in e && (r = await async function(i, a) {
    const l = i.getReader(), u = new ReadableStream({ start: (f) => async function h() {
      return l.read().then(({ done: g, value: m }) => {
        if (!g)
          return f.enqueue(m), h();
        f.close();
      });
    }() }), d = new Response(u), p = await d.blob();
    return l.releaseLock(), new Blob([p], { type: a });
  }(e.body, e.headers.get("content-type"))), n.download = t.fileName || "Untitled", n.href = URL.createObjectURL(await r);
  const o = () => {
    typeof s == "function" && s();
  }, s = t.legacySetup && t.legacySetup(o, () => s(), n);
  return n.addEventListener("click", () => {
    setTimeout(() => URL.revokeObjectURL(n.href), 3e4), o();
  }), n.click(), null;
}, HM = { __proto__: null, default: VM };
const BM = { NODE_ENV: "production", NPM_PACKAGE_VERSION: "1.0.0", STUDIO_NPM_PACKAGE_VERSION: "1.0.35" }.REACT_APP_VERSION ?? "1.0.0", zM = ue(function() {
  var n;
  const t = (n = window.grapesjs) == null ? void 0 : n.version;
  return /* @__PURE__ */ A(I, { col: !0, space: "m", children: [
    /* @__PURE__ */ c(I, { justify: "center", children: /* @__PURE__ */ A(N, { className: F("relative"), children: [
      /* @__PURE__ */ c(fc, { className: F("w-24 opacity-50") }),
      t && /* @__PURE__ */ c(St, { className: F(z.bgA, "absolute gs-utl-right-[-20px] bottom-0"), label: `v${t}`, s: "s", pill: !0 })
    ] }) }),
    /* @__PURE__ */ A(N, { children: [
      /* @__PURE__ */ A("p", { children: [
        /* @__PURE__ */ c("b", { children: "GrapesJS Studio" }),
        " is an innovative experimental editor, initially created to improve and extend the customization capability of the",
        " ",
        /* @__PURE__ */ c("a", { className: F(Eo.link), href: "https://grapesjs.com", children: "GrapesJS" }),
        " ",
        "library. Beyond pushing the evolution of the core library itself, this application aspires to empower individuals in creating and managing their web projects autonomously, free from subscriptions or dependency on the internet connection."
      ] }),
      /* @__PURE__ */ c("br", {}),
      /* @__PURE__ */ A("p", { children: [
        "If you like the vision of this project and you're eager to play a role in its continued development, consider becoming a backer or sponsor through",
        " ",
        /* @__PURE__ */ c("a", { className: F(Eo.link), href: "https://opencollective.com/grapesjs", children: "Open Collective" }),
        "."
      ] })
    ] }),
    /* @__PURE__ */ A(N, { className: F(z.txtLowEmphasis, "text-right"), children: [
      "GrapesJS Studio: v",
      BM
    ] })
  ] });
}), FM = ue(function() {
  return /* @__PURE__ */ A(I, { col: !0, space: "m", children: [
    /* @__PURE__ */ c(I, { justify: "center", children: /* @__PURE__ */ c(N, { className: $("relative"), children: /* @__PURE__ */ c(fc, { className: $("w-24 opacity-50") }) }) }),
    /* @__PURE__ */ c(N, { children: /* @__PURE__ */ A("p", { children: [
      "We're excited to introduce the GrapesJS Studio SDK, an embeddable version of the Studio editor.",
      /* @__PURE__ */ c("br", {}),
      /* @__PURE__ */ c("br", {}),
      "The Studio SDK offers a powerful and flexible web editing experience that can be seamlessly integrated into your platform as a white-label editor. This enables your users to effortlessly create and manage content with advanced tools.",
      /* @__PURE__ */ c("br", {}),
      /* @__PURE__ */ c("br", {}),
      "You can try the initial release of the Studio SDK by creating a license and following the instructions on the",
      " ",
      /* @__PURE__ */ c("a", { className: $(Eo.link), href: "/dashboard/sdk/licenses", target: "_blank", children: "Studio SDK license page" }),
      /* @__PURE__ */ c("br", {}),
      /* @__PURE__ */ c("br", {}),
      "If you have any questions or need assistance with specific use cases, please fill out this",
      " ",
      /* @__PURE__ */ c("a", { className: $(Eo.link), href: "https://forms.gle/VUycp3rc8iCpbh9k8", target: "_blank", rel: "noreferrer", children: "form" }),
      " ",
      "and we'll get back to you as soon as possible."
    ] }) })
  ] });
});
function UM({ onCopy: e, getValue: t, value: n, title: r = "Copy", ...o }) {
  const [s, i] = W(!1), a = () => {
    Jw((t == null ? void 0 : t()) ?? n), i(!0), e == null || e();
  };
  return G(() => {
    if (!s)
      return;
    const l = setTimeout(() => i(!1), 3e3);
    return () => clearTimeout(l);
  }, [s]), /* @__PURE__ */ c(Ft, { onClick: a, title: r, type: "button", size: "lg", withBg: !0, ...o, children: /* @__PURE__ */ c(
    oe,
    {
      className: F(s && z.tA),
      icon: s ? ne.check : ne.contentCopy,
      size: pe.s
    }
  ) });
}
function of(e) {
  return e = e.trimStart(), e = e.replace(/\s*([\{\}\:\;\,])\s*/g, "$1"), e = e.replace(/;\s*;/g, ";"), e = e.replace(/\,[\s\.\#\d]*{/g, "{"), e = e.replace(/([^\s])\{([^\s])/g, `$1 {
	$2`), e = e.replace(/([^\s])\}([^\n]*)/g, `$1
}
$2`), e = e.replace(/([^\s]);([^\s\}])/g, `$1;
	$2`), e;
}
const qb = ue(function() {
  const t = Tn(), n = Ne(), { Styles: r } = t, { isDarkTheme: o } = cn(), s = r.getSelected(), [i, a] = W(0), l = s ? of(s == null ? void 0 : s.toCSS({ allowEmpty: !0 })) : "", [u, d] = W(l);
  G(() => {
    const f = () => a((g) => ++g), h = r.events.custom;
    return t.on(h, f), () => {
      t.off(h, f);
    };
  }, [r, t]);
  const p = () => {
    if (u) {
      const f = t.Parser.parseCss(u)[0];
      f && (s == null || s.setStyle(f.style));
    }
  };
  return /* @__PURE__ */ A(I, { className: $("relative"), col: !0, full: !0, children: [
    /* @__PURE__ */ c(N, { grow: !0, children: s ? /* @__PURE__ */ c(
      Jr,
      {
        padding: 5,
        language: "css",
        value: l,
        onChange: d,
        isDarkTheme: o,
        clean: !0
      },
      i
    ) : n.t("noCode") }),
    /* @__PURE__ */ c(Ze, { className: $("absolute right-2 bottom-2 text-sm"), variant: "pr", size: "m2", onClick: p, children: n.t("update") })
  ] });
}), Cg = [
  {
    id: "html",
    label: "HTML"
  },
  {
    id: "mjml",
    label: "MJML"
  }
], WM = ue(function(t) {
  const n = Ne(), r = ye(), { isProjectTypeEmail: o } = r, s = r.editor, [i, a] = W(Cg[0].id), [l, u] = W(), { isDarkTheme: d } = cn(), [p] = W(() => of(s.getCss())), [f, h] = W(), g = (y) => n.t(`actions.showCode.${y}`), m = {
    ...t.options,
    ...o ? { export: !1 } : {}
  }, v = () => {
    s.runCommand("gjs-export-zip", {
      filenamePfx: "gjs-export",
      root: async (y) => {
        const w = await fl(y), S = {};
        for (const x in w) {
          const C = w[x], { filename: P, content: _ } = C;
          if (C.path) {
            const O = C.path.split("/").filter(Boolean);
            let E = S;
            for (const T of O)
              E[T] = E[T] || {}, E = E[T];
            E[P] = _;
          } else
            S[P] = _;
        }
        return S;
      }
    });
  };
  G(() => {
    var y;
    if (o) {
      let w = s.getHtml();
      if (i !== "mjml")
        try {
          const S = s.runCommand("mjml-code-to-html");
          (y = S.errors) != null && y.length && console.warn(S.errors), w = S.html;
        } catch (S) {
          console.error(S);
        }
      u(w);
    } else
      (async () => {
        const x = (await fl(s, {
          page: s.Pages.getSelected(),
          skipProject: !0,
          styles: "skip"
        })).find((C) => C.mimeType === "text/html");
        x && u(x.content);
      })();
  }, [i]), G(() => {
    var y;
    f && ((y = f.getModel()) == null || y.setValue(l), Zv(f));
  }, [f, l]);
  const b = {
    padding: 5,
    isDarkTheme: d,
    clean: !0
  };
  return /* @__PURE__ */ A(I, { col: !0, space: "m", children: [
    /* @__PURE__ */ A(I, { className: $("h-96"), space: "m", children: [
      /* @__PURE__ */ A(N, { className: $("relative"), grow: !0, children: [
        o && /* @__PURE__ */ A(I, { className: $("absolute top-3 right-3 z-10"), space: "s", nowrap: !0, children: [
          /* @__PURE__ */ c(
            Ae,
            {
              value: i,
              onChange: a,
              options: Cg,
              className: $("min-w-24")
            }
          ),
          /* @__PURE__ */ c(UM, { getValue: () => f.getModel().getValue() })
        ] }),
        l !== void 0 && /* @__PURE__ */ c(Jr, { value: l, language: "html", onMount: h, ...b })
      ] }),
      !o && /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(Jr, { value: p, language: "css", ...b }) })
    ] }),
    m.export !== !1 && /* @__PURE__ */ c(I, { justify: "end", children: /* @__PURE__ */ c(Ze, { size: "m2", variant: "pr", onClick: v, children: g("exportButton") }) })
  ] });
}), GM = () => [
  {
    id: Ve.web,
    label: yr(Ve.web),
    content: /* @__PURE__ */ A(I, { space: "s", children: [
      /* @__PURE__ */ c(oe, { icon: ne.web, size: pe.s }),
      /* @__PURE__ */ c("span", { children: yr(Ve.web) })
    ] })
  },
  {
    id: Ve.email,
    label: yr(Ve.email),
    content: /* @__PURE__ */ A(I, { space: "s", children: [
      /* @__PURE__ */ c(oe, { icon: ne.emailOutline, size: pe.s }),
      /* @__PURE__ */ c("span", { children: yr(Ve.email) })
    ] })
  }
], mc = 0, co = 1, Ns = 2, Yb = 4;
function KM(e, t) {
  return (n) => e(t(n));
}
function qM(e, t) {
  return t(e);
}
function Xb(e, t) {
  return (n) => e(t, n);
}
function Pg(e, t) {
  return () => e(t);
}
function sf(e, t) {
  return t(e), e;
}
function jo(...e) {
  return e;
}
function YM(e) {
  e();
}
function Eg(e) {
  return () => e;
}
function XM(...e) {
  return () => {
    e.map(YM);
  };
}
function vc() {
}
function jt(e, t) {
  return e(co, t);
}
function Ot(e, t) {
  e(mc, t);
}
function af(e) {
  e(Ns);
}
function ns(e) {
  return e(Yb);
}
function nt(e, t) {
  return jt(e, Xb(t, mc));
}
function Og(e, t) {
  const n = e(co, (r) => {
    n(), t(r);
  });
  return n;
}
function mt() {
  const e = [];
  return (t, n) => {
    switch (t) {
      case Ns:
        e.splice(0, e.length);
        return;
      case co:
        return e.push(n), () => {
          const r = e.indexOf(n);
          r > -1 && e.splice(r, 1);
        };
      case mc:
        e.slice().forEach((r) => {
          r(n);
        });
        return;
      default:
        throw new Error(`unrecognized action ${t}`);
    }
  };
}
function Se(e) {
  let t = e;
  const n = mt();
  return (r, o) => {
    switch (r) {
      case co:
        o(t);
        break;
      case mc:
        t = o;
        break;
      case Yb:
        return t;
    }
    return n(r, o);
  };
}
function ZM(e) {
  let t, n;
  const r = () => t && t();
  return function(o, s) {
    switch (o) {
      case co:
        return s ? n === s ? void 0 : (r(), n = s, t = jt(e, s), t) : (r(), vc);
      case Ns:
        r(), n = null;
        return;
      default:
        throw new Error(`unrecognized action ${o}`);
    }
  };
}
function hi(e) {
  return sf(mt(), (t) => nt(e, t));
}
function rs(e, t) {
  return sf(Se(t), (n) => nt(e, n));
}
function JM(...e) {
  return (t) => e.reduceRight(qM, t);
}
function Ee(e, ...t) {
  const n = JM(...t);
  return (r, o) => {
    switch (r) {
      case co:
        return jt(e, n(o));
      case Ns:
        af(e);
        return;
    }
  };
}
function Zb(e, t) {
  return e === t;
}
function Kt(e = Zb) {
  let t;
  return (n) => (r) => {
    e(t, r) || (t = r, n(r));
  };
}
function Lt(e) {
  return (t) => (n) => {
    e(n) && t(n);
  };
}
function lt(e) {
  return (t) => KM(t, e);
}
function zr(e) {
  return (t) => () => t(e);
}
function Ra(e, t) {
  return (n) => (r) => n(t = e(t, r));
}
function _d(e) {
  return (t) => (n) => {
    e > 0 ? e-- : t(n);
  };
}
function ni(e) {
  let t = null, n;
  return (r) => (o) => {
    t = o, !n && (n = setTimeout(() => {
      n = void 0, r(t);
    }, e));
  };
}
function _g(e) {
  let t, n;
  return (r) => (o) => {
    t = o, n && clearTimeout(n), n = setTimeout(() => {
      r(t);
    }, e);
  };
}
function Xn(...e) {
  const t = new Array(e.length);
  let n = 0, r = null;
  const o = Math.pow(2, e.length) - 1;
  return e.forEach((s, i) => {
    const a = Math.pow(2, i);
    jt(s, (l) => {
      const u = n;
      n = n | a, t[i] = l, u !== o && n === o && r && (r(), r = null);
    });
  }), (s) => (i) => {
    const a = () => s([i].concat(t));
    n === o ? a() : r = a;
  };
}
function Tg(...e) {
  return function(t, n) {
    switch (t) {
      case co:
        return XM(...e.map((r) => jt(r, n)));
      case Ns:
        return;
      default:
        throw new Error(`unrecognized action ${t}`);
    }
  };
}
function De(e, t = Zb) {
  return Ee(e, Kt(t));
}
function Sr(...e) {
  const t = mt(), n = new Array(e.length);
  let r = 0;
  const o = Math.pow(2, e.length) - 1;
  return e.forEach((s, i) => {
    const a = Math.pow(2, i);
    jt(s, (l) => {
      n[i] = l, r = r | a, r === o && Ot(t, n);
    });
  }), function(s, i) {
    switch (s) {
      case co:
        return r === o && i(n), jt(t, i);
      case Ns:
        return af(t);
      default:
        throw new Error(`unrecognized action ${s}`);
    }
  };
}
function ur(e, t = [], { singleton: n } = { singleton: !0 }) {
  return {
    id: QM(),
    constructor: e,
    dependencies: t,
    singleton: n
  };
}
const QM = () => Symbol();
function e$(e) {
  const t = /* @__PURE__ */ new Map(), n = ({ id: r, constructor: o, dependencies: s, singleton: i }) => {
    if (i && t.has(r))
      return t.get(r);
    const a = o(s.map((l) => n(l)));
    return i && t.set(r, a), a;
  };
  return n(e);
}
function t$(e, t) {
  const n = {}, r = {};
  let o = 0;
  const s = e.length;
  for (; o < s; )
    r[e[o]] = 1, o += 1;
  for (const i in t)
    r.hasOwnProperty(i) || (n[i] = t[i]);
  return n;
}
const Na = typeof document < "u" ? H.useLayoutEffect : H.useEffect;
function n$(e, t, n) {
  const r = Object.keys(t.required || {}), o = Object.keys(t.optional || {}), s = Object.keys(t.methods || {}), i = Object.keys(t.events || {}), a = H.createContext({});
  function l(b, y) {
    b.propsReady && Ot(b.propsReady, !1);
    for (const w of r) {
      const S = b[t.required[w]];
      Ot(S, y[w]);
    }
    for (const w of o)
      if (w in y) {
        const S = b[t.optional[w]];
        Ot(S, y[w]);
      }
    b.propsReady && Ot(b.propsReady, !0);
  }
  function u(b) {
    return s.reduce((y, w) => (y[w] = (S) => {
      const x = b[t.methods[w]];
      Ot(x, S);
    }, y), {});
  }
  function d(b) {
    return i.reduce((y, w) => (y[w] = ZM(b[t.events[w]]), y), {});
  }
  const p = H.forwardRef((b, y) => {
    const { children: w, ...S } = b, [x] = H.useState(() => sf(e$(e), (_) => l(_, S))), [C] = H.useState(Pg(d, x));
    Na(() => {
      for (const _ of i)
        _ in S && jt(C[_], S[_]);
      return () => {
        Object.values(C).map(af);
      };
    }, [S, C, x]), Na(() => {
      l(x, S);
    }), H.useImperativeHandle(y, Eg(u(x)));
    const P = n;
    return /* @__PURE__ */ c(a.Provider, { value: x, children: n ? /* @__PURE__ */ c(P, { ...t$([...r, ...o, ...i], S), children: w }) : w });
  }), f = (b) => H.useCallback(Xb(Ot, H.useContext(a)[b]), [b]), h = (b) => {
    const w = H.useContext(a)[b], S = H.useCallback(
      (x) => jt(w, x),
      [w]
    );
    return H.useSyncExternalStore(
      S,
      () => ns(w),
      () => ns(w)
    );
  }, g = (b) => {
    const w = H.useContext(a)[b], [S, x] = H.useState(Pg(ns, w));
    return Na(
      () => jt(w, (C) => {
        C !== S && x(Eg(C));
      }),
      [w, S]
    ), S;
  }, m = H.version.startsWith("18") ? h : g;
  return {
    Component: p,
    usePublisher: f,
    useEmitterValue: m,
    useEmitter: (b, y) => {
      const S = H.useContext(a)[b];
      Na(() => jt(S, y), [y, S]);
    }
  };
}
const Jb = typeof document < "u" ? H.useLayoutEffect : H.useEffect;
var lf = /* @__PURE__ */ ((e) => (e[e.DEBUG = 0] = "DEBUG", e[e.INFO = 1] = "INFO", e[e.WARN = 2] = "WARN", e[e.ERROR = 3] = "ERROR", e))(lf || {});
const r$ = {
  0: "debug",
  1: "log",
  2: "warn",
  3: "error"
}, o$ = () => typeof globalThis > "u" ? window : globalThis, Qb = ur(
  () => {
    const e = Se(
      3
      /* ERROR */
    );
    return {
      log: Se((n, r, o = 1) => {
        var s;
        const i = (s = o$().VIRTUOSO_LOG_LEVEL) != null ? s : ns(e);
        o >= i && console[r$[o]](
          "%creact-virtuoso: %c%s %o",
          "color: #0253b3; font-weight: bold",
          "color: initial",
          n,
          r
        );
      }),
      logLevel: e
    };
  },
  [],
  { singleton: !0 }
);
function e0(e, t, n) {
  const r = H.useRef(null);
  let o = (s) => {
  };
  if (typeof ResizeObserver < "u") {
    const s = H.useMemo(() => new ResizeObserver((i) => {
      const a = () => {
        const l = i[0].target;
        l.offsetParent !== null && e(l);
      };
      n ? a() : requestAnimationFrame(a);
    }), [e]);
    o = (i) => {
      i && t ? (s.observe(i), r.current = i) : (r.current && s.unobserve(r.current), r.current = null);
    };
  }
  return { ref: r, callbackRef: o };
}
function bc(e, t, n) {
  return e0(e, t, n).callbackRef;
}
function xl(e, t) {
  return Math.round(e.getBoundingClientRect()[t]);
}
function t0(e, t) {
  return Math.abs(e - t) < 1.01;
}
function n0(e, t, n, r = vc, o, s) {
  const i = H.useRef(null), a = H.useRef(null), l = H.useRef(null), u = H.useCallback(
    (f) => {
      const h = f.target, g = h === window || h === document, m = s ? g ? window.pageXOffset || document.documentElement.scrollLeft : h.scrollLeft : g ? window.pageYOffset || document.documentElement.scrollTop : h.scrollTop, v = s ? g ? document.documentElement.scrollWidth : h.scrollWidth : g ? document.documentElement.scrollHeight : h.scrollHeight, b = s ? g ? window.innerWidth : h.offsetWidth : g ? window.innerHeight : h.offsetHeight, y = () => {
        e({
          scrollTop: Math.max(m, 0),
          scrollHeight: v,
          viewportHeight: b
        });
      };
      f.suppressFlushSync ? y() : Nd.flushSync(y), a.current !== null && (m === a.current || m <= 0 || m === v - b) && (a.current = null, t(!0), l.current && (clearTimeout(l.current), l.current = null));
    },
    [e, t]
  );
  H.useEffect(() => {
    const f = o || i.current;
    return r(o || i.current), u({ target: f, suppressFlushSync: !0 }), f.addEventListener("scroll", u, { passive: !0 }), () => {
      r(null), f.removeEventListener("scroll", u);
    };
  }, [i, u, n, r, o]);
  function d(f) {
    const h = i.current;
    if (!h || (s ? "offsetWidth" in h && h.offsetWidth === 0 : "offsetHeight" in h && h.offsetHeight === 0))
      return;
    const g = f.behavior === "smooth";
    let m, v, b;
    h === window ? (v = Math.max(
      xl(document.documentElement, s ? "width" : "height"),
      s ? document.documentElement.scrollWidth : document.documentElement.scrollHeight
    ), m = s ? window.innerWidth : window.innerHeight, b = s ? document.documentElement.scrollLeft : document.documentElement.scrollTop) : (v = h[s ? "scrollWidth" : "scrollHeight"], m = xl(h, s ? "width" : "height"), b = h[s ? "scrollLeft" : "scrollTop"]);
    const y = v - m;
    if (f.top = Math.ceil(Math.max(Math.min(y, f.top), 0)), t0(m, v) || f.top === b) {
      e({ scrollTop: b, scrollHeight: v, viewportHeight: m }), g && t(!0);
      return;
    }
    g ? (a.current = f.top, l.current && clearTimeout(l.current), l.current = setTimeout(() => {
      l.current = null, a.current = null, t(!0);
    }, 1e3)) : a.current = null, s && (f = { left: f.top, behavior: f.behavior }), h.scrollTo(f);
  }
  function p(f) {
    s && (f = { left: f.top, behavior: f.behavior }), i.current.scrollBy(f);
  }
  return { scrollerRef: i, scrollByCallback: p, scrollToCallback: d };
}
const yc = ur(
  () => {
    const e = mt(), t = mt(), n = Se(0), r = mt(), o = Se(0), s = mt(), i = mt(), a = Se(0), l = Se(0), u = Se(0), d = Se(0), p = mt(), f = mt(), h = Se(!1), g = Se(!1), m = Se(!1);
    return nt(
      Ee(
        e,
        lt(({ scrollTop: v }) => v)
      ),
      t
    ), nt(
      Ee(
        e,
        lt(({ scrollHeight: v }) => v)
      ),
      i
    ), nt(t, o), {
      // input
      scrollContainerState: e,
      scrollTop: t,
      viewportHeight: s,
      headerHeight: a,
      fixedHeaderHeight: l,
      fixedFooterHeight: u,
      footerHeight: d,
      scrollHeight: i,
      smoothScrollTargetReached: r,
      horizontalDirection: g,
      skipAnimationFrameInResizeObserver: m,
      // signals
      scrollTo: p,
      scrollBy: f,
      // state
      statefulScrollTop: o,
      deviation: n,
      scrollingInProgress: h
    };
  },
  [],
  { singleton: !0 }
), s$ = typeof document < "u" && "scrollBehavior" in document.documentElement.style;
function i$(e) {
  const t = typeof e == "number" ? { index: e } : e;
  return t.align || (t.align = "start"), (!t.behavior || !s$) && (t.behavior = "auto"), t.offset || (t.offset = 0), t;
}
const Cl = "up", gi = "down", a$ = "none", l$ = {
  atBottom: !1,
  notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
  state: {
    offsetBottom: 0,
    scrollTop: 0,
    viewportHeight: 0,
    scrollHeight: 0
  }
}, c$ = 0, r0 = ur(([{ scrollContainerState: e, scrollTop: t, viewportHeight: n, headerHeight: r, footerHeight: o, scrollBy: s }]) => {
  const i = Se(!1), a = Se(!0), l = mt(), u = mt(), d = Se(4), p = Se(c$), f = rs(
    Ee(
      Tg(Ee(De(t), _d(1), zr(!0)), Ee(De(t), _d(1), zr(!1), _g(100))),
      Kt()
    ),
    !1
  ), h = rs(
    Ee(Tg(Ee(s, zr(!0)), Ee(s, zr(!1), _g(200))), Kt()),
    !1
  );
  nt(
    Ee(
      Sr(De(t), De(p)),
      lt(([y, w]) => y <= w),
      Kt()
    ),
    a
  ), nt(Ee(a, ni(50)), u);
  const g = hi(
    Ee(
      Sr(e, De(n), De(r), De(o), De(d)),
      Ra((y, [{ scrollTop: w, scrollHeight: S }, x, C, P, _]) => {
        const O = w + x - S > -_, E = {
          viewportHeight: x,
          scrollTop: w,
          scrollHeight: S
        };
        if (O) {
          let R, B;
          return w > y.state.scrollTop ? (R = "SCROLLED_DOWN", B = y.state.scrollTop - w) : (R = "SIZE_DECREASED", B = y.state.scrollTop - w || y.scrollTopDelta), {
            atBottom: !0,
            state: E,
            atBottomBecause: R,
            scrollTopDelta: B
          };
        }
        let T;
        return E.scrollHeight > y.state.scrollHeight ? T = "SIZE_INCREASED" : x < y.state.viewportHeight ? T = "VIEWPORT_HEIGHT_DECREASING" : w < y.state.scrollTop ? T = "SCROLLING_UPWARDS" : T = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM", {
          atBottom: !1,
          notAtBottomBecause: T,
          state: E
        };
      }, l$),
      Kt((y, w) => y && y.atBottom === w.atBottom)
    )
  ), m = rs(
    Ee(
      e,
      Ra(
        (y, { scrollTop: w, scrollHeight: S, viewportHeight: x }) => {
          if (t0(y.scrollHeight, S))
            return {
              scrollTop: w,
              scrollHeight: S,
              jump: 0,
              changed: !1
            };
          {
            const C = S - (w + x) < 1;
            return y.scrollTop !== w && C ? {
              scrollHeight: S,
              scrollTop: w,
              jump: y.scrollTop - w,
              changed: !0
            } : {
              scrollHeight: S,
              scrollTop: w,
              jump: 0,
              changed: !0
            };
          }
        },
        { scrollHeight: 0, jump: 0, scrollTop: 0, changed: !1 }
      ),
      Lt((y) => y.changed),
      lt((y) => y.jump)
    ),
    0
  );
  nt(
    Ee(
      g,
      lt((y) => y.atBottom)
    ),
    i
  ), nt(Ee(i, ni(50)), l);
  const v = Se(gi);
  nt(
    Ee(
      e,
      lt(({ scrollTop: y }) => y),
      Kt(),
      Ra(
        (y, w) => ns(h) ? { direction: y.direction, prevScrollTop: w } : { direction: w < y.prevScrollTop ? Cl : gi, prevScrollTop: w },
        { direction: gi, prevScrollTop: 0 }
      ),
      lt((y) => y.direction)
    ),
    v
  ), nt(Ee(e, ni(50), zr(a$)), v);
  const b = Se(0);
  return nt(
    Ee(
      f,
      Lt((y) => !y),
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      zr(0)
    ),
    b
  ), nt(
    Ee(
      t,
      ni(100),
      Xn(f),
      Lt(([y, w]) => !!w),
      Ra(([y, w], [S]) => [w, S], [0, 0]),
      lt(([y, w]) => w - y)
    ),
    b
  ), {
    isScrolling: f,
    isAtTop: a,
    isAtBottom: i,
    atBottomState: g,
    atTopStateChange: u,
    atBottomStateChange: l,
    scrollDirection: v,
    atBottomThreshold: d,
    atTopThreshold: p,
    scrollVelocity: b,
    lastJumpDueToItemResize: m
  };
}, jo(yc)), u$ = ur(
  ([{ log: e }]) => {
    const t = Se(!1), n = hi(
      Ee(
        t,
        Lt((r) => r),
        Kt()
      )
    );
    return jt(t, (r) => {
      r && ns(e)("props updated", {}, lf.DEBUG);
    }), { propsReady: t, didMount: n };
  },
  jo(Qb),
  { singleton: !0 }
);
function o0(e, t) {
  e == 0 ? t() : requestAnimationFrame(() => o0(e - 1, t));
}
function d$(e, t) {
  const n = t - 1;
  return typeof e == "number" ? e : e.index === "LAST" ? n : e.index;
}
function Td(e, t) {
  return !!(e && e[0] === t[0] && e[1] === t[1]);
}
function p$(e, t) {
  return !!(e && e.startIndex === t.startIndex && e.endIndex === t.endIndex);
}
const Pl = "top", El = "bottom", Ag = "none";
function Lg(e, t, n) {
  return typeof e == "number" ? n === Cl && t === Pl || n === gi && t === El ? e : 0 : n === Cl ? t === Pl ? e.main : e.reverse : t === El ? e.main : e.reverse;
}
function kg(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const f$ = ur(
  ([{ scrollTop: e, viewportHeight: t, deviation: n, headerHeight: r, fixedHeaderHeight: o }]) => {
    const s = mt(), i = Se(0), a = Se(0), l = Se(0), u = rs(
      Ee(
        Sr(
          De(e),
          De(t),
          De(r),
          De(s, Td),
          De(l),
          De(i),
          De(o),
          De(n),
          De(a)
        ),
        lt(
          ([
            d,
            p,
            f,
            [h, g],
            m,
            v,
            b,
            y,
            w
          ]) => {
            const S = d - y, x = v + b, C = Math.max(f - S, 0);
            let P = Ag;
            const _ = kg(w, Pl), O = kg(w, El);
            return h -= y, h += f + b, g += f + b, g -= y, h > d + x - _ && (P = Cl), g < d - C + p + O && (P = gi), P !== Ag ? [
              Math.max(S - f - Lg(m, Pl, P) - _, 0),
              S - C - b + p + Lg(m, El, P) + O
            ] : null;
          }
        ),
        Lt((d) => d != null),
        Kt(Td)
      ),
      [0, 0]
    );
    return {
      // input
      listBoundary: s,
      overscan: l,
      topListHeight: i,
      increaseViewportBy: a,
      // output
      visibleRange: u
    };
  },
  jo(yc),
  { singleton: !0 }
), h$ = ur(
  ([{ scrollVelocity: e }]) => {
    const t = Se(!1), n = mt(), r = Se(!1);
    return nt(
      Ee(
        e,
        Xn(r, t, n),
        Lt(([o, s]) => !!s),
        lt(([o, s, i, a]) => {
          const { exit: l, enter: u } = s;
          if (i) {
            if (l(o, a))
              return !1;
          } else if (u(o, a))
            return !0;
          return i;
        }),
        Kt()
      ),
      t
    ), jt(
      Ee(Sr(t, e, n), Xn(r)),
      ([[o, s, i], a]) => o && a && a.change && a.change(s, i)
    ), { isSeeking: t, scrollSeekConfiguration: r, scrollVelocity: e, scrollSeekRangeChanged: n };
  },
  jo(r0),
  { singleton: !0 }
);
function g$(e) {
  let t = !1, n;
  return () => (t || (t = !0, n = e()), n);
}
const m$ = ur(([{ scrollTo: e, scrollContainerState: t }]) => {
  const n = mt(), r = mt(), o = mt(), s = Se(!1), i = Se(void 0);
  return nt(
    Ee(
      Sr(n, r),
      lt(([{ viewportHeight: a, scrollTop: l, scrollHeight: u }, { offsetTop: d }]) => ({
        scrollTop: Math.max(0, l - d),
        scrollHeight: u,
        viewportHeight: a
      }))
    ),
    t
  ), nt(
    Ee(
      e,
      Xn(r),
      lt(([a, { offsetTop: l }]) => ({
        ...a,
        top: a.top + l
      }))
    ),
    o
  ), {
    // config
    useWindowScroll: s,
    customScrollParent: i,
    // input
    windowScrollContainerState: n,
    windowViewportRect: r,
    // signals
    windowScrollTo: o
  };
}, jo(yc)), wu = "-webkit-sticky", Mg = "sticky", s0 = g$(() => {
  if (typeof document > "u")
    return Mg;
  const e = document.createElement("div");
  return e.style.position = wu, e.style.position === wu ? wu : Mg;
});
function v$(e, t, n) {
  const r = H.useRef(null), o = H.useCallback(
    (l) => {
      if (l === null || !l.offsetParent)
        return;
      const u = l.getBoundingClientRect(), d = u.width;
      let p, f;
      if (t) {
        const h = t.getBoundingClientRect(), g = u.top - h.top;
        p = h.height - Math.max(0, g), f = g + t.scrollTop;
      } else
        p = window.innerHeight - Math.max(0, u.top), f = u.top + window.pageYOffset;
      r.current = {
        offsetTop: f,
        visibleHeight: p,
        visibleWidth: d
      }, e(r.current);
    },
    [e, t]
  ), { callbackRef: s, ref: i } = e0(o, !0, n), a = H.useCallback(() => {
    o(i.current);
  }, [o, i]);
  return H.useEffect(() => {
    if (t) {
      t.addEventListener("scroll", a);
      const l = new ResizeObserver(() => {
        requestAnimationFrame(a);
      });
      return l.observe(t), () => {
        t.removeEventListener("scroll", a), l.unobserve(t);
      };
    } else
      return window.addEventListener("scroll", a), window.addEventListener("resize", a), () => {
        window.removeEventListener("scroll", a), window.removeEventListener("resize", a);
      };
  }, [a, t]), s;
}
H.createContext(void 0);
const i0 = H.createContext(void 0);
function b$(e) {
  return e;
}
s0();
const y$ = {
  height: "100%",
  outline: "none",
  overflowY: "auto",
  position: "relative",
  WebkitOverflowScrolling: "touch"
}, w$ = {
  outline: "none",
  overflowX: "auto",
  position: "relative"
}, a0 = (e) => ({
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0,
  ...e ? { display: "flex", flexDirection: "column" } : {}
});
s0();
function bo(e, t) {
  if (typeof e != "string")
    return { context: t };
}
function S$({ usePublisher: e, useEmitter: t, useEmitterValue: n }) {
  return H.memo(function({ style: s, children: i, ...a }) {
    const l = e("scrollContainerState"), u = n("ScrollerComponent"), d = e("smoothScrollTargetReached"), p = n("scrollerRef"), f = n("context"), h = n("horizontalDirection") || !1, { scrollerRef: g, scrollByCallback: m, scrollToCallback: v } = n0(
      l,
      d,
      u,
      p,
      void 0,
      h
    );
    return t("scrollTo", v), t("scrollBy", m), /* @__PURE__ */ c(
      u,
      {
        ref: g,
        style: { ...h ? w$ : y$, ...s },
        "data-testid": "virtuoso-scroller",
        "data-virtuoso-scroller": !0,
        tabIndex: 0,
        ...a,
        ...bo(u, f),
        children: i
      }
    );
  });
}
function x$({ usePublisher: e, useEmitter: t, useEmitterValue: n }) {
  return H.memo(function({ style: s, children: i, ...a }) {
    const l = e("windowScrollContainerState"), u = n("ScrollerComponent"), d = e("smoothScrollTargetReached"), p = n("totalListHeight"), f = n("deviation"), h = n("customScrollParent"), g = n("context"), { scrollerRef: m, scrollByCallback: v, scrollToCallback: b } = n0(
      l,
      d,
      u,
      vc,
      h
    );
    return Jb(() => (m.current = h || window, () => {
      m.current = null;
    }), [m, h]), t("windowScrollTo", b), t("scrollBy", v), /* @__PURE__ */ c(
      u,
      {
        style: { position: "relative", ...s, ...p !== 0 ? { height: p + f } : {} },
        "data-virtuoso-scroller": !0,
        ...a,
        ...bo(u, g),
        children: i
      }
    );
  });
}
const $g = {
  items: [],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  bottom: 0,
  itemHeight: 0,
  itemWidth: 0
}, C$ = {
  items: [{ index: 0 }],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  bottom: 0,
  itemHeight: 0,
  itemWidth: 0
}, { round: Rg, ceil: Ng, floor: Ol, min: Su, max: mi } = Math;
function P$(e) {
  return {
    ...C$,
    items: e
  };
}
function jg(e, t, n) {
  return Array.from({ length: t - e + 1 }).map((r, o) => {
    const s = n === null ? null : n[o + e];
    return { index: o + e, data: s };
  });
}
function E$(e, t) {
  return e && e.column === t.column && e.row === t.row;
}
function ja(e, t) {
  return e && e.width === t.width && e.height === t.height;
}
const O$ = /* @__PURE__ */ ur(
  ([
    { overscan: e, visibleRange: t, listBoundary: n, increaseViewportBy: r },
    { scrollTop: o, viewportHeight: s, scrollBy: i, scrollTo: a, smoothScrollTargetReached: l, scrollContainerState: u, footerHeight: d, headerHeight: p },
    f,
    h,
    { propsReady: g, didMount: m },
    { windowViewportRect: v, useWindowScroll: b, customScrollParent: y, windowScrollContainerState: w, windowScrollTo: S },
    x
  ]) => {
    const C = Se(0), P = Se(0), _ = Se($g), O = Se({ height: 0, width: 0 }), E = Se({ height: 0, width: 0 }), T = mt(), R = mt(), B = Se(0), U = Se(null), L = Se({ row: 0, column: 0 }), M = mt(), D = mt(), V = Se(!1), k = Se(0), j = Se(!0), Y = Se(!1), J = Se(!1);
    jt(
      Ee(
        m,
        Xn(k),
        Lt(([Z, te]) => !!te)
      ),
      () => {
        Ot(j, !1);
      }
    ), jt(
      Ee(
        Sr(m, j, E, O, k, Y),
        Lt(([Z, te, de, ce, , Ce]) => Z && !te && de.height !== 0 && ce.height !== 0 && !Ce)
      ),
      ([, , , , Z]) => {
        Ot(Y, !0), o0(1, () => {
          Ot(T, Z);
        }), Og(Ee(o), () => {
          Ot(n, [0, 0]), Ot(j, !0);
        });
      }
    ), nt(
      Ee(
        D,
        Lt((Z) => Z != null && Z.scrollTop > 0),
        zr(0)
      ),
      P
    ), jt(
      Ee(
        m,
        Xn(D),
        Lt(([, Z]) => Z != null)
      ),
      ([, Z]) => {
        Z && (Ot(O, Z.viewport), Ot(E, Z == null ? void 0 : Z.item), Ot(L, Z.gap), Z.scrollTop > 0 && (Ot(V, !0), Og(Ee(o, _d(1)), (te) => {
          Ot(V, !1);
        }), Ot(a, { top: Z.scrollTop })));
      }
    ), nt(
      Ee(
        O,
        lt(({ height: Z }) => Z)
      ),
      s
    ), nt(
      Ee(
        Sr(
          De(O, ja),
          De(E, ja),
          De(L, (Z, te) => Z && Z.column === te.column && Z.row === te.row),
          De(o)
        ),
        lt(([Z, te, de, ce]) => ({
          viewport: Z,
          item: te,
          gap: de,
          scrollTop: ce
        }))
      ),
      M
    ), nt(
      Ee(
        Sr(
          De(C),
          t,
          De(L, E$),
          De(E, ja),
          De(O, ja),
          De(U),
          De(P),
          De(V),
          De(j),
          De(k)
        ),
        Lt(([, , , , , , , Z]) => !Z),
        lt(
          ([
            Z,
            [te, de],
            ce,
            Ce,
            Pe,
            at,
            ut,
            ,
            Pt,
            gt
          ]) => {
            const { row: Je, column: dn } = ce, { height: ht, width: rt } = Ce, { width: dt } = Pe;
            if (ut === 0 && (Z === 0 || dt === 0))
              return $g;
            if (rt === 0) {
              const js = d$(gt, Z), Ec = Math.max(js + ut - 1, 0);
              return P$(jg(js, Ec, at));
            }
            const Tt = l0(dt, rt, dn);
            let vt, Et;
            Pt ? te === 0 && de === 0 && ut > 0 ? (vt = 0, Et = ut - 1) : (vt = Tt * Ol((te + Je) / (ht + Je)), Et = Tt * Ng((de + Je) / (ht + Je)) - 1, Et = Su(Z - 1, mi(Et, Tt - 1)), vt = Su(Et, mi(0, vt))) : (vt = 0, Et = -1);
            const An = jg(vt, Et, at), { top: Vt, bottom: Ln } = Dg(Pe, ce, Ce, An), uo = Ng(Z / Tt), Io = uo * ht + (uo - 1) * Je - Ln;
            return { items: An, offsetTop: Vt, offsetBottom: Io, top: Vt, bottom: Ln, itemHeight: ht, itemWidth: rt };
          }
        )
      ),
      _
    ), nt(
      Ee(
        U,
        Lt((Z) => Z !== null),
        lt((Z) => Z.length)
      ),
      C
    ), nt(
      Ee(
        Sr(O, E, _, L),
        Lt(([Z, te, { items: de }]) => de.length > 0 && te.height !== 0 && Z.height !== 0),
        lt(([Z, te, { items: de }, ce]) => {
          const { top: Ce, bottom: Pe } = Dg(Z, ce, te, de);
          return [Ce, Pe];
        }),
        Kt(Td)
      ),
      n
    );
    const le = Se(!1);
    nt(
      Ee(
        o,
        Xn(le),
        lt(([Z, te]) => te || Z !== 0)
      ),
      le
    );
    const Q = hi(
      Ee(
        De(_),
        Lt(({ items: Z }) => Z.length > 0),
        Xn(C, le),
        Lt(([{ items: Z }, te, de]) => de && Z[Z.length - 1].index === te - 1),
        lt(([, Z]) => Z - 1),
        Kt()
      )
    ), re = hi(
      Ee(
        De(_),
        Lt(({ items: Z }) => Z.length > 0 && Z[0].index === 0),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        zr(0),
        Kt()
      )
    ), ge = hi(
      Ee(
        De(_),
        Xn(V),
        Lt(([{ items: Z }, te]) => Z.length > 0 && !te),
        lt(([{ items: Z }]) => ({
          startIndex: Z[0].index,
          endIndex: Z[Z.length - 1].index
        })),
        Kt(p$),
        ni(0)
      )
    );
    nt(ge, h.scrollSeekRangeChanged), nt(
      Ee(
        T,
        Xn(O, E, C, L),
        lt(([Z, te, de, ce, Ce]) => {
          const Pe = i$(Z), { align: at, behavior: ut, offset: Pt } = Pe;
          let gt = Pe.index;
          gt === "LAST" && (gt = ce - 1), gt = mi(0, gt, Su(ce - 1, gt));
          let Je = Ad(te, Ce, de, gt);
          return at === "end" ? Je = Rg(Je - te.height + de.height) : at === "center" && (Je = Rg(Je - te.height / 2 + de.height / 2)), Pt && (Je += Pt), { top: Je, behavior: ut };
        })
      ),
      a
    );
    const X = rs(
      Ee(
        _,
        lt((Z) => Z.offsetBottom + Z.bottom)
      ),
      0
    );
    return nt(
      Ee(
        v,
        lt((Z) => ({ width: Z.visibleWidth, height: Z.visibleHeight }))
      ),
      O
    ), {
      // input
      data: U,
      totalCount: C,
      viewportDimensions: O,
      itemDimensions: E,
      scrollTop: o,
      scrollHeight: R,
      overscan: e,
      increaseViewportBy: r,
      scrollBy: i,
      scrollTo: a,
      scrollToIndex: T,
      smoothScrollTargetReached: l,
      windowViewportRect: v,
      windowScrollTo: S,
      useWindowScroll: b,
      customScrollParent: y,
      windowScrollContainerState: w,
      deviation: B,
      scrollContainerState: u,
      footerHeight: d,
      headerHeight: p,
      initialItemCount: P,
      gap: L,
      restoreStateFrom: D,
      ...h,
      initialTopMostItemIndex: k,
      horizontalDirection: J,
      // output
      gridState: _,
      totalListHeight: X,
      ...f,
      startReached: re,
      endReached: Q,
      rangeChanged: ge,
      stateChanged: M,
      propsReady: g,
      stateRestoreInProgress: V,
      ...x
    };
  },
  jo(f$, yc, r0, h$, u$, m$, Qb)
);
function Dg(e, t, n, r) {
  const { height: o } = n;
  if (o === void 0 || r.length === 0)
    return { top: 0, bottom: 0 };
  const s = Ad(e, t, n, r[0].index), i = Ad(e, t, n, r[r.length - 1].index) + o;
  return { top: s, bottom: i };
}
function Ad(e, t, n, r) {
  const o = l0(e.width, n.width, t.column), s = Ol(r / o), i = s * n.height + mi(0, s - 1) * t.row;
  return i > 0 ? i + t.row : i;
}
function l0(e, t, n) {
  return mi(1, Ol((e + n) / (Ol(t) + n)));
}
const _$ = /* @__PURE__ */ ur(() => {
  const e = Se((p) => `Item ${p}`), t = Se({}), n = Se(null), r = Se("virtuoso-grid-item"), o = Se("virtuoso-grid-list"), s = Se(b$), i = Se("div"), a = Se(vc), l = (p, f = null) => rs(
    Ee(
      t,
      lt((h) => h[p]),
      Kt()
    ),
    f
  ), u = Se(!1), d = Se(!1);
  return nt(De(d), u), {
    readyStateChanged: u,
    reportReadyState: d,
    context: n,
    itemContent: e,
    components: t,
    computeItemKey: s,
    itemClassName: r,
    listClassName: o,
    headerFooterTag: i,
    scrollerRef: a,
    FooterComponent: l("Footer"),
    HeaderComponent: l("Header"),
    ListComponent: l("List", "div"),
    ItemComponent: l("Item", "div"),
    ScrollerComponent: l("Scroller", "div"),
    ScrollSeekPlaceholder: l("ScrollSeekPlaceholder", "div")
  };
}), T$ = /* @__PURE__ */ ur(([e, t]) => ({ ...e, ...t }), jo(O$, _$)), A$ = /* @__PURE__ */ H.memo(function() {
  const t = pt("gridState"), n = pt("listClassName"), r = pt("itemClassName"), o = pt("itemContent"), s = pt("computeItemKey"), i = pt("isSeeking"), a = Sn("scrollHeight"), l = pt("ItemComponent"), u = pt("ListComponent"), d = pt("ScrollSeekPlaceholder"), p = pt("context"), f = Sn("itemDimensions"), h = Sn("gap"), g = pt("log"), m = pt("stateRestoreInProgress"), v = Sn("reportReadyState"), b = bc(
    H.useMemo(
      () => (y) => {
        const w = y.parentElement.parentElement.scrollHeight;
        a(w);
        const S = y.firstChild;
        if (S) {
          const { width: x, height: C } = S.getBoundingClientRect();
          f({ width: x, height: C });
        }
        h({
          row: Ig("row-gap", getComputedStyle(y).rowGap, g),
          column: Ig("column-gap", getComputedStyle(y).columnGap, g)
        });
      },
      [a, f, h, g]
    ),
    !0,
    !1
  );
  return Jb(() => {
    t.itemHeight > 0 && t.itemWidth > 0 && v(!0);
  }, [t]), m ? null : /* @__PURE__ */ c(
    u,
    {
      ref: b,
      className: n,
      ...bo(u, p),
      style: { paddingTop: t.offsetTop, paddingBottom: t.offsetBottom },
      "data-testid": "virtuoso-item-list",
      children: t.items.map((y) => {
        const w = s(y.index, y.data, p);
        return i ? /* @__PURE__ */ c(
          d,
          {
            ...bo(d, p),
            index: y.index,
            height: t.itemHeight,
            width: t.itemWidth
          },
          w
        ) : /* @__PURE__ */ is(
          l,
          {
            ...bo(l, p),
            className: r,
            "data-index": y.index,
            key: w
          },
          o(y.index, y.data, p)
        );
      })
    }
  );
}), L$ = H.memo(function() {
  const t = pt("HeaderComponent"), n = Sn("headerHeight"), r = pt("headerFooterTag"), o = bc(
    H.useMemo(() => (i) => n(xl(i, "height")), [n]),
    !0,
    !1
  ), s = pt("context");
  return t ? /* @__PURE__ */ c(r, { ref: o, children: /* @__PURE__ */ c(t, { ...bo(t, s) }) }) : null;
}), k$ = H.memo(function() {
  const t = pt("FooterComponent"), n = Sn("footerHeight"), r = pt("headerFooterTag"), o = bc(
    H.useMemo(() => (i) => n(xl(i, "height")), [n]),
    !0,
    !1
  ), s = pt("context");
  return t ? /* @__PURE__ */ c(r, { ref: o, children: /* @__PURE__ */ c(t, { ...bo(t, s) }) }) : null;
}), M$ = ({ children: e }) => {
  const t = H.useContext(i0), n = Sn("itemDimensions"), r = Sn("viewportDimensions"), o = bc(
    H.useMemo(
      () => (s) => {
        r(s.getBoundingClientRect());
      },
      [r]
    ),
    !0,
    !1
  );
  return H.useEffect(() => {
    t && (r({ height: t.viewportHeight, width: t.viewportWidth }), n({ height: t.itemHeight, width: t.itemWidth }));
  }, [t, r, n]), /* @__PURE__ */ c("div", { style: a0(!1), ref: o, children: e });
}, $$ = ({ children: e }) => {
  const t = H.useContext(i0), n = Sn("windowViewportRect"), r = Sn("itemDimensions"), o = pt("customScrollParent"), s = v$(n, o, !1);
  return H.useEffect(() => {
    t && (r({ height: t.itemHeight, width: t.itemWidth }), n({ offsetTop: 0, visibleHeight: t.viewportHeight, visibleWidth: t.viewportWidth }));
  }, [t, n, r]), /* @__PURE__ */ c("div", { ref: s, style: a0(!1), children: e });
}, R$ = /* @__PURE__ */ H.memo(function({ ...t }) {
  const n = pt("useWindowScroll"), r = pt("customScrollParent");
  return /* @__PURE__ */ c(r || n ? D$ : j$, { ...t, children: /* @__PURE__ */ A(r || n ? $$ : M$, { children: [
    /* @__PURE__ */ c(L$, {}),
    /* @__PURE__ */ c(A$, {}),
    /* @__PURE__ */ c(k$, {})
  ] }) });
}), {
  Component: N$,
  usePublisher: Sn,
  useEmitterValue: pt,
  useEmitter: c0
} = /* @__PURE__ */ n$(
  T$,
  {
    optional: {
      context: "context",
      totalCount: "totalCount",
      overscan: "overscan",
      itemContent: "itemContent",
      components: "components",
      computeItemKey: "computeItemKey",
      data: "data",
      initialItemCount: "initialItemCount",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      headerFooterTag: "headerFooterTag",
      listClassName: "listClassName",
      itemClassName: "itemClassName",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel",
      restoreStateFrom: "restoreStateFrom",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      increaseViewportBy: "increaseViewportBy"
    },
    methods: {
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      scrollToIndex: "scrollToIndex"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      stateChanged: "stateChanged",
      readyStateChanged: "readyStateChanged"
    }
  },
  R$
), j$ = /* @__PURE__ */ S$({ usePublisher: Sn, useEmitterValue: pt, useEmitter: c0 }), D$ = /* @__PURE__ */ x$({ usePublisher: Sn, useEmitterValue: pt, useEmitter: c0 });
function Ig(e, t, n) {
  return t !== "normal" && !(t != null && t.endsWith("px")) && n(`${e} was not resolved to pixel value correctly`, t, lf.WARN), t === "normal" ? 0 : parseInt(t ?? "0", 10);
}
const ia = N$, cf = (e) => {
  const t = "gs-utl-grid-cols-4", n = parseInt(`${e || 4}`, 10);
  return n === 1 ? "gs-utl-grid-cols-1" : n === 2 ? "gs-utl-grid-cols-2" : n === 3 ? "gs-utl-grid-cols-3" : n === 4 ? t : n === 5 ? "gs-utl-grid-cols-5" : n === 6 ? "gs-utl-grid-cols-6" : n === 7 ? "gs-utl-grid-cols-7" : n === 8 ? "gs-utl-grid-cols-8" : n === 9 ? "gs-utl-grid-cols-9" : n === 10 ? "gs-utl-grid-cols-10" : n === 11 ? "gs-utl-grid-cols-11" : n === 12 ? "gs-utl-grid-cols-12" : t;
}, I$ = (e) => !!(e && !Array.isArray(e) && typeof e == "object");
async function V$(e) {
  const t = e.map(({ id: i, src: a }) => ({ id: i, src: a })), n = e.reduce(
    (i, a) => (i[a.id] = a, i),
    {}
  ), r = [], o = [];
  return (await tS(t)).forEach((i) => {
    i.status === "fulfilled" ? r.push(n[i.value]) : o.push(n[i.reason]);
  }), { loaded: r, failed: o };
}
const H$ = async (e) => {
  const t = [...e], n = {};
  if (t.length) {
    const r = {}, o = [];
    if (t.forEach((s, i) => {
      I$(s) && (r[s.id] = { index: i }, o.push(s));
    }), o.length) {
      const { loaded: s } = await V$(o);
      s.forEach(({ id: i, options: a }) => {
        r[i].loaded = !0, n[i] = a || {};
      });
    }
    Object.keys(r).forEach((s) => {
      const i = r[s];
      i.loaded ? t[i.index] = s : t[i.index] = !1;
    });
  }
  return {
    plugins: t.filter(Boolean),
    pluginOptions: n
  };
}, B$ = (e, t, n) => {
  e.loadData(t);
  let r = `${e.getHtml()}<style>${e.getCss()}</style>`;
  if (n === Ve.email)
    try {
      r = e.runCommand("mjml-code-to-html").html;
    } catch (o) {
      console.error(o);
    }
  return r.replace("<body", "<div data-body").replace("</body>", "</div>");
}, z$ = async (e, t, n) => {
  const r = Hb(t, { appStore: n }), o = await H$(r);
  return e.init({
    headless: !0,
    projectData: {},
    noticeOnUnload: !1,
    storageManager: !1,
    plugins: [
      ...o.plugins,
      (s) => {
        s.Storage.setCurrent("");
      }
    ],
    pluginsOpts: o.pluginOptions,
    protectedCss: `
      * { box-sizing: border-box; }
      [data-body] {
        margin: 0;
        background-color: white;
        width: 100%;
        height: 100%;
        color: initial;
        font-family: initial;
        font-weight: initial;
        line-height: initial;
      }
      [data-body]:before {
        content: "";
        display: block;
        height: 0px;
        overflow: hidden;
      }
    `
  });
};
function uf({
  children: e,
  text: t,
  onConfirm: n,
  onCancel: r,
  className: o = "w-[200px]",
  confirmButtonProps: s = {},
  ...i
}) {
  const a = Ne();
  return /* @__PURE__ */ c(Rr, { ...i, overlay: !0, title: !1, buttonAs: "span", handler: e, children: ({ close: l }) => /* @__PURE__ */ A(I, { className: $(o), space: "m", col: !0, children: [
    /* @__PURE__ */ c(N, { grow: !0, className: $("text-center"), children: t || a.t("confirmAction") }),
    /* @__PURE__ */ A(I, { justify: "center", items: "center", space: "m", children: [
      /* @__PURE__ */ c(
        Ze,
        {
          variant: "pr",
          size: "m2",
          onClick: () => {
            l(), n == null || n();
          },
          ...s,
          children: a.t("confirm")
        }
      ),
      /* @__PURE__ */ c(
        Ze,
        {
          size: "m2",
          onClick: () => {
            l(), r == null || r();
          },
          children: a.t("cancel")
        }
      )
    ] })
  ] }) });
}
const Vg = /* @__PURE__ */ new Map(), Hg = /* @__PURE__ */ new Map(), F$ = async ({ html: e = "", el: t }) => {
  const n = e, r = {};
  if (document.body.attachShadow) {
    const o = t.shadowRoot || t.attachShadow({ mode: "open" });
    o.innerHTML = n;
  }
  return r;
}, U$ = ue(function({
  template: t,
  projectType: n,
  skipProjectNamePopover: r,
  className: o,
  onSelect: s,
  onRemove: i
}) {
  var P;
  const a = Ne(), l = ye(), u = l.editor, [d, p] = W(""), f = K(null), h = a.t("projectManager.projectName"), g = !t.isTemplate && l.currentProjectId === ((P = t.data.custom) == null ? void 0 : P.id), m = n === Ve.web, v = !t.isTemplate || r, b = () => {
    v && (s == null || s({ editor: u, template: t, loadTemplate: y }));
  }, y = l.setProject, w = (_) => {
    _.preventDefault(), s({ editor: u, template: t, loadTemplate: y });
  };
  G(() => {
    const O = setTimeout(async () => {
      if (!f.current || !u)
        return;
      const E = `${t.isTemplate ? "t-" : ""}${t.id}`;
      let T = Vg.get(E);
      if (!T) {
        let B = Hg.get(n);
        B || (B = await z$(u.config.grapesjs, n, l), Hg.set(n, B)), T = B$(B, t.data, n), Vg.set(E, T);
      }
      const R = f.current;
      F$({ el: R, html: T });
    });
    return () => clearTimeout(O);
  }, [f, u, n, t.data]);
  const { media: S, author: x } = t, C = /* @__PURE__ */ c(Ze, { className: F("text-sm"), size: "m2", variant: "pr", onClick: b, disabled: g, children: a.t("select") });
  return /* @__PURE__ */ c(Jt, { padding: !1, className: F("overflow-hidden max-w-full group", o), children: /* @__PURE__ */ A(I, { col: !0, children: [
    /* @__PURE__ */ A(N, { className: F("relative group h-36 bg-checker max-w-full"), children: [
      /* @__PURE__ */ c(
        "div",
        {
          className: F(
            "gs-utl-relative",
            "gs-utl-h-full",
            "gs-utl-overflow-hidden",
            "gs-utl-flex",
            "gs-utl-justify-center"
          ),
          children: S ? /* @__PURE__ */ c("img", { src: S, alt: t.name, className: F("max-w-full") }) : /* @__PURE__ */ c(
            "div",
            {
              className: F(
                "gs-utl-w-[1200px]",
                "gs-utl-flex-shrink-0",
                "gs-utl-flex-grow-0",
                "gs-utl-origin-top",
                "gs-utl-bg-white",
                // height needs to be the inverse of scale
                "gs-utl-scale-[0.232]",
                "gs-utl-h-[431.034%]"
              ),
              ref: f
            }
          )
        }
      ),
      g && /* @__PURE__ */ c(St, { className: F("absolute top-2 right-2", z.bgA2), label: a.t("current"), s: "s", pill: !0 }),
      /* @__PURE__ */ c(
        I,
        {
          justify: "center",
          items: "center",
          className: F(Qe.coverAbs, z.bgH75, "group-hover:gs-utl-opacity-100 opacity-0 transition-opacity"),
          children: v ? C : /* @__PURE__ */ c(Rr, { overlay: !0, title: !1, buttonAs: "span", handler: C, children: () => /* @__PURE__ */ c("form", { onSubmit: w, children: /* @__PURE__ */ A(I, { space: "m", col: !0, children: [
            /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
              ft,
              {
                size: "s",
                value: d,
                onChange: p,
                placeholder: h,
                required: !0
              }
            ) }),
            /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(Ze, { type: "submit", variant: "pr", size: "m2", full: !0, children: a.t("load") }) })
          ] }) }) })
        }
      )
    ] }),
    /* @__PURE__ */ A(I, { className: F("gjs-p-2 max-w-full", se.bt, z.br), col: !0, space: "s", children: [
      /* @__PURE__ */ A(I, { className: F("text-sm w-full"), space: "s", nowrap: !0, children: [
        /* @__PURE__ */ c(N, { className: F(Qe.txtEllips, "max-w-full"), grow: !0, children: t.name }),
        !!x && /* @__PURE__ */ A(N, { children: [
          "by",
          " ",
          /* @__PURE__ */ c("a", { className: F(Eo.link), href: x.link, rel: "noreferrer", target: "_blank", children: x.name })
        ] })
      ] }),
      /* @__PURE__ */ A(I, { items: "center", children: [
        m && /* @__PURE__ */ A(N, { className: F("gjs-mr-auto"), children: [
          a.t("projectManager.pages"),
          ": ",
          t.data.pages.length
        ] }),
        !t.isTemplate && i && /* @__PURE__ */ c(N, { className: F("gjs-ml-auto"), children: /* @__PURE__ */ c(uf, { onConfirm: () => i(t), className: "", children: /* @__PURE__ */ c(Ft, { title: a.t("delete"), children: /* @__PURE__ */ c(oe, { icon: ne.delete, size: pe.sx }) }) }) })
      ] })
    ] })
  ] }) });
}), u0 = ue(function({
  templates: e,
  projectType: t,
  content: n,
  skipProjectNamePopover: r,
  onSelect: o,
  onRemove: s
}) {
  const [i] = pc(), l = Ne().tScoped("templates"), d = ye().editor, p = cf(n == null ? void 0 : n.itemsPerRow), f = o ?? (({ template: h, loadTemplate: g }) => g(h));
  return /* @__PURE__ */ c(ae, { children: d && e ? e.length === 0 ? /* @__PURE__ */ c(I, { justify: "center", children: l("notFound") }) : /* @__PURE__ */ c(
    ia,
    {
      data: e,
      listClassName: F("grid gap-2 gjs-pr-2", p),
      itemContent: (h, g) => /* @__PURE__ */ c(
        U$,
        {
          template: g,
          projectType: t,
          onSelect: f,
          onRemove: s,
          skipProjectNamePopover: r
        },
        g.id
      )
    },
    i
  ) : /* @__PURE__ */ c(sa, {}) });
}), W$ = ue(function() {
  var m;
  const t = ye(), n = Nv(), { filteredTemplates: r, projectSourceFilter: o, projectTypeFilter: s } = n, i = Ne(), a = Bn(), { sdkOptions: l } = t, u = i.tScoped("projectManager"), d = async ({ loadTemplate: v, template: b }) => {
    v(b), a.close();
  }, p = async (v) => {
    n.setProjectTypeFilter(v), await n.loadAllTemplates();
  }, f = (v) => {
    n.removeProject(v.id), n.loadProjects();
  }, h = ie(
    () => [
      {
        id: Oi.Existing,
        label: u("existentProjects")
      },
      {
        id: Oi.Templates,
        label: u("templates")
      }
    ],
    [i]
  ), g = ((m = l.project) == null ? void 0 : m.types) && Gd();
  return G(() => {
    n.loadAllTemplates();
  }, []), /* @__PURE__ */ A(I, { col: !0, full: !0, space: "m", children: [
    g && /* @__PURE__ */ c(I, { items: "center", space: "m", children: /* @__PURE__ */ c(N, { className: F("gjs-ml-auto"), children: /* @__PURE__ */ c(
      Ae,
      {
        value: s,
        onChange: p,
        options: GM(),
        handlerSelected: (v) => /* @__PURE__ */ A(ae, { children: [
          /* @__PURE__ */ c("b", { children: u("projectType") }),
          ": ",
          v.label
        ] })
      }
    ) }) }),
    /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(Ro, { tabs: h, value: o, onChange: n.setProjectSourceFilter }) }),
    /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(
      u0,
      {
        templates: r,
        projectType: Ve[s],
        onSelect: d,
        onRemove: f,
        content: { itemsPerRow: 3 }
      }
    ) })
  ] });
}), G$ = [
  { id: qr.auto, label: "Auto" },
  { id: qr.dark, label: "Dark" },
  { id: qr.light, label: "Light" }
], K$ = { size: "s" }, xu = ".grapesjs", q$ = (e, t) => {
  const n = e == null ? void 0 : e.settingsMenu;
  return n !== !1 && (n == null ? void 0 : n[t]) !== !1;
}, Y$ = ({
  actions: e,
  editor: t,
  buttons: n,
  sdkOptions: r
}) => {
  const o = r.actions;
  return o === !1 ? [] : ct(o) ? o({ actions: e, editor: t }) : o || (n ? ct(n) ? n({ items: e, editor: t }) : n : e);
}, X$ = "gs-cmp-topbar-right", Z$ = ue(function({
  editor: t,
  className: n,
  buttons: r,
  ...o
}) {
  var U;
  const s = ye(), { theme: i, setTheme: a } = cn(), { Commands: l, UndoManager: u, Components: d } = t, { installEvent: p, appInstalled: f, isBrowserMode: h, setInstallEvent: g, sdkOptions: m, isProjectTypeEmail: v } = s, b = Bn(), y = Ne(), w = (L) => y.t(`actions.${L}`), S = (U = m.commands) == null ? void 0 : U.options, x = t.Storage.events, C = l.events, P = "change:changesCount", _ = (L, M) => () => {
    ct(L) ? L({ editor: t }) : l.isActive(L) ? l.stop(L) : l.run(L, M);
  }, O = (L) => ({
    [`${C.runCommand}${L}`]: ({ setState: M }) => M({ active: !0 }),
    [`${C.stopCommand}${L}`]: ({ setState: M }) => M({ active: !1 })
  }), E = [
    {
      id: kn.componentOutline,
      icon: ne.borderRadius,
      tooltip: w("componentOutline.title"),
      onClick: _("core:component-outline"),
      editorEvents: O("core:component-outline")
    },
    {
      id: kn.preview,
      icon: ne.eye,
      tooltip: w("preview.title"),
      onClick: _("core:preview"),
      editorEvents: O("core:preview")
    },
    {
      id: kn.fullscreen,
      icon: ne.fullscreen,
      tooltip: w("fullscreen.title"),
      onClick: _("core:fullscreen", { target: "body" }),
      editorEvents: O("core:fullscreen")
    },
    {
      id: kn.showCode,
      icon: ne.xml,
      tooltip: w("showCode.title"),
      onClick: () => b.open({
        title: w("showCode.title"),
        content: () => /* @__PURE__ */ c(WM, { options: S == null ? void 0 : S[kn.showCode] })
      })
    },
    {
      id: kn.showImportCode,
      icon: ne.trayArrowDown,
      tooltip: w("importCode.title"),
      onClick: () => b.open({
        title: w("importCode.title"),
        content: () => /* @__PURE__ */ c(Jv, {})
      })
    },
    {
      id: kn.clearCanvas,
      icon: ne.delete,
      tooltip: w("clearCanvas.title"),
      onClick: () => b.confirm({
        title: w("clearCanvas.title"),
        content: w("clearCanvas.content"),
        confirmButton: { variant: "danger", children: w("clearCanvas.title") },
        onConfirm: () => {
          var L;
          if (v) {
            const M = (L = d.getWrapper()) == null ? void 0 : L.findType("mjml")[0];
            M == null || M.components().forEach((D) => {
              D.components("");
            });
          } else
            t.Components.clear();
        }
      })
    },
    {
      id: kn.store,
      tooltip: w("store.title"),
      onClick: async () => !s.isSaving && t.store(),
      editorEvents: {
        "change:changesCount": ({ setState: L }) => L({}),
        [x.startStore]: ({ setState: L }) => L({ disabled: !0 }),
        [x.endStore]: ({ setState: L }) => L({ disabled: !1 })
      },
      label: () => /* @__PURE__ */ A("div", { className: $("relative"), children: [
        /* @__PURE__ */ c(oe, { icon: ne.floppy, size: pe.s }),
        !!t.getDirtyCount() && !s.isSaving && /* @__PURE__ */ c("div", { className: $("absolute right-0 gjs-p-0.5 bottom-0 gjs-rounded-full", z.bg), children: /* @__PURE__ */ c("div", { className: $(Qe.dot, z.bgW) }) }),
        s.isSaving && /* @__PURE__ */ c("div", { className: $("absolute right-0 bottom-0 gjs-rounded-full", z.bg), children: /* @__PURE__ */ c(oe, { icon: ne.refresh, size: "11px", className: $(Qe.spin) }) })
      ] })
    },
    {
      id: kn.undo,
      icon: ne.arrowULeftTop,
      disabled: !0,
      onClick: _("core:undo"),
      editorEvents: {
        [P]: ({ setState: L }) => L({ disabled: !u.hasUndo() })
      }
    },
    {
      id: kn.redo,
      icon: ne.arrowURightTop,
      disabled: !0,
      onClick: _("core:redo"),
      editorEvents: {
        [P]: ({ setState: L }) => L({ disabled: !u.hasRedo() })
      }
    }
  ], T = Y$({ actions: E, sdkOptions: m, editor: t, buttons: r }), R = [
    {
      id: "about",
      label: w("about.title"),
      icon: ne.helpCircle,
      action: () => b.open({
        size: "m",
        title: w("about.title"),
        content: () => /* @__PURE__ */ c(zM, {})
      })
    },
    {
      id: "embed",
      label: w("embed.title"),
      icon: ne.powerPlug,
      action: () => b.open({
        size: "m",
        title: w("embed.title"),
        content: () => /* @__PURE__ */ c(FM, {})
      })
    },
    {
      id: "openProject",
      label: w("open.title"),
      icon: ne.folder,
      action: async () => {
        let L = "";
        try {
          L = await (await EM({ extensions: [xu] })).text();
        } catch (M) {
          return console.error(M);
        }
        s.loadProjectData(JSON.parse(L));
      }
    },
    {
      id: "saveProject",
      label: w("save.title"),
      icon: ne.contentSave,
      action: async () => {
        const L = t.getProjectData(), M = new Blob([JSON.stringify(L)]), D = `Untitled-${(/* @__PURE__ */ new Date()).toISOString().replace("T", "-").replace(/:|\./g, "").substring(0, 17)}`;
        try {
          await _M(M, {
            fileName: `${D}${xu}`,
            extensions: [xu]
          });
        } catch (V) {
          return console.error(V);
        }
      }
    },
    // {
    //     id: 'shortcuts',
    //     label: 'Shortcuts',
    //     icon: IconNames.keyboard,
    //     action: () => alert('Open shortcuts'),
    // },
    {
      id: "loadProject",
      label: w("newProject.title"),
      icon: ne.newspaperVariantOutline,
      action: () => b.open({
        fullH: !0,
        title: w("newProject.title"),
        content: () => /* @__PURE__ */ c(W$, {})
      })
    },
    {
      id: "installApp",
      label: w(f ? "installApp.installed" : "installApp.title"),
      icon: ne.applicationBracketsOutline,
      action: async () => {
        if (f)
          return;
        p == null || p.prompt();
        const L = await (p == null ? void 0 : p.userChoice);
        (L == null ? void 0 : L.outcome) === "accepted" && g();
      }
    },
    ...m.customTheme ? [] : [
      {
        id: "theme",
        label: /* @__PURE__ */ A(I, { items: "center", space: "m", children: [
          /* @__PURE__ */ c(N, { children: "Theme" }),
          /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
            Ro,
            {
              tabs: G$,
              onChange: (L) => a(L),
              value: i,
              variant: "pills"
            }
          ) })
        ] })
      }
    ]
  ].filter(({ id: L }) => !((!h || !p) && L === "installApp" || !q$(m, L))), B = (L, M) => (D) => {
    ct(L) && (L(D), M());
  };
  return /* @__PURE__ */ A(I, { space: "s", items: "center", justify: "end", className: $(X$, Re.xS, n), nowrap: !0, ...o, children: [
    T.map(({ id: L, ...M }) => /* @__PURE__ */ c(nf, { size: "s", ...M }, L)),
    /* @__PURE__ */ c(N, { children: m.settingsMenu !== !1 && R.length > 0 && /* @__PURE__ */ c(
      Rr,
      {
        placement: "bottom-end",
        title: !1,
        padding: !1,
        handler: /* @__PURE__ */ c(oe, { icon: ne.cog, size: pe.s }),
        buttonProps: K$,
        overlay: !0,
        children: ({ close: L }) => /* @__PURE__ */ c(ae, { children: R.map((M) => /* @__PURE__ */ c(
          ec,
          {
            action: B(M.action, L),
            icon: M.icon,
            label: M.label
          },
          M.id
        )) })
      }
    ) })
  ] });
}), J$ = ({
  items: e,
  editor: t,
  customItems: n
}) => n === !1 ? [] : ct(n) ? n({ items: e, editor: t }) : n || e, Bg = (e) => ({
  icon: ne.plus,
  size: pe.s,
  className: $("gs-utl-transition-transform", e && "gs-utl-rotate-45")
}), Q$ = "gs-cmp-topbar-left", e4 = ue(function({
  buttons: t,
  className: n,
  style: r
}) {
  const o = ye(), s = Ne(), { isOpen: i, toggleOpen: a } = Dv(), l = o.editor, d = s.tScoped("blockManager")("blocks"), p = J$({
    items: [
      {
        id: `blocks-${d}`,
        tooltip: d,
        size: Wb.s,
        icon: Bg(i),
        variant: Ub.primary,
        editorEvents: {
          [_r.toggleBlocksPanel]: ({ fromEvent: f, setState: h }) => {
            h({ icon: Bg(f.isOpen) });
          }
        },
        onClick: () => a()
      }
    ],
    customItems: t,
    editor: l
  });
  return /* @__PURE__ */ c(I, { space: "s", items: "center", justify: "start", className: $(Q$, Re.xS, n), style: r, nowrap: !0, children: p.map(({ id: f, ...h }) => /* @__PURE__ */ c(nf, { ...h }, f)) });
});
function t4({ devices: e, selected: t, className: n, style: r, select: o }) {
  const s = e.map((i) => ({
    id: i.id,
    label: i.getName()
  }));
  return s.length ? /* @__PURE__ */ c(
    Ae,
    {
      size: "xs",
      className: n,
      style: { ...r },
      value: t,
      options: s,
      onChange: o
    }
  ) : null;
}
const n4 = "gs-devices", d0 = we(function({ className: t, style: n }) {
  return /* @__PURE__ */ c(JA, { children: (r) => /* @__PURE__ */ c(t4, { className: q(n4, t), style: n, ...r }) });
}), Xs = "gs-cmp-editor-topbar", r4 = ue(function({
  className: t,
  height: n,
  style: r,
  children: o,
  leftContainer: s,
  rightContainer: i,
  devices: a
}) {
  const { topBarSize: l, isInPreview: u, editor: d, isTopSidebarOpen: p } = ye(), f = n ?? l, h = ie(
    () => ({
      ...r,
      minHeight: f,
      marginTop: u || !p ? `-${f}px` : 0
    }),
    [u, p, r]
  );
  return /* @__PURE__ */ A(ae, { children: [
    /* @__PURE__ */ c(
      N,
      {
        className: q(Xs, "gs-utl-transition-spacing gs-utl-w-full", se.bb, z.br, t),
        style: h,
        children: o ?? /* @__PURE__ */ A(I, { className: q(`${Xs}__wrp`, "gs-utl-h-full"), items: "center", full: !0, nowrap: !0, children: [
          /* @__PURE__ */ c(N, { className: q(`${Xs}__wrp-left`), grow: !0, children: s !== !1 && /* @__PURE__ */ c(e4, { ...s }) }),
          /* @__PURE__ */ c(N, { className: q(`${Xs}__wrp-center`), children: a !== !1 && /* @__PURE__ */ c(d0, { ...a }) }),
          /* @__PURE__ */ c(N, { className: q(`${Xs}__wrp-right`), grow: !0, children: i !== !1 && d && /* @__PURE__ */ c(Z$, { editor: d, ...i }) })
        ] })
      }
    ),
    /* @__PURE__ */ c(
      N,
      {
        className: q(
          "gs-utl-transition-transform gs-utl-absolute gs-utl-top-0 gs-utl-left-0 gs-utl-z-10",
          !u && "-gs-utl-translate-y-full"
        ),
        children: /* @__PURE__ */ c(
          Ze,
          {
            className: q("gs-cmp-close-preview gs-utl-m-4", z.bg),
            size: "s",
            onClick: () => d == null ? void 0 : d.Commands.stop("core:preview"),
            children: /* @__PURE__ */ c(oe, { icon: ne.eyeOff, size: pe.s })
          }
        )
      }
    )
  ] });
}), o4 = "gs-sidebar-top", p0 = we(
  ue(function({ height: t, children: n, ...r }) {
    return /* @__PURE__ */ c(
      r4,
      {
        height: t,
        ...r,
        style: gc(r),
        className: q(o4, "gs-utl-flex", hc(r)),
        children: n ? un(n) : void 0
      }
    );
  })
), s4 = "gs-canvas-sidebar-top", i4 = we(
  ue(function({ className: t, sidebarTop: n, ...r }) {
    return /* @__PURE__ */ A(No, { className: q(s4, "gs-utl-flex gs-utl-flex-col", t), grow: !0, ...r, children: [
      /* @__PURE__ */ c(p0, { ...n }),
      /* @__PURE__ */ c(Gb, { grow: !0 })
    ] });
  })
), a4 = "gs-cmp-column", l4 = we(function({ className: t, children: n, full: r, ...o }) {
  return /* @__PURE__ */ c(
    No,
    {
      className: q(a4, z.bg, "gs-utl-flex gs-utl-flex-col", r && "gs-utl-h-full", t),
      ...o,
      children: un(n)
    }
  );
}), c4 = "gs-cmp-input-field", u4 = we(
  ue(function({
    className: t,
    style: n,
    label: r,
    name: o,
    value: s,
    size: i,
    disabled: a,
    inputType: l,
    readOnly: u,
    required: d,
    placeholder: p,
    onChange: f,
    onInput: h,
    editorEvents: g
  }) {
    const { editor: m } = ye(), [v, b] = W(() => ({
      className: t,
      style: n,
      label: r,
      name: o,
      value: s,
      size: i,
      readOnly: u,
      disabled: a,
      required: d,
      placeholder: p
    })), y = (x) => ({
      value: x,
      editor: m,
      state: v,
      setState: (C) => b((P) => ({ ...P, ...C }))
    }), w = (x) => f == null ? void 0 : f(y(x)), S = (x) => h == null ? void 0 : h(y(x));
    return Pc({
      editor: m,
      editorEvents: g,
      localState: v,
      setLocalState: b
    }), /* @__PURE__ */ c(
      ft,
      {
        type: l,
        className: q(c4, v.className),
        style: v.style,
        label: v.label,
        name: v.name,
        value: v.value,
        size: v.size,
        required: v.required,
        disabled: v.disabled,
        readOnly: v.readOnly,
        placeholder: v.placeholder,
        onChange: w,
        onInput: S
      }
    );
  })
);
function d4({ children: e, accept: t, onChange: n, multiple: r = !0, ...o }) {
  const s = Ne(), i = K(null), a = () => {
    const { current: l } = i;
    l && (l.value = "", l.click());
  };
  return /* @__PURE__ */ A(ae, { children: [
    /* @__PURE__ */ c(
      "input",
      {
        className: $("hidden"),
        ref: i,
        type: "file",
        multiple: r,
        accept: t,
        onChange: n
      }
    ),
    /* @__PURE__ */ c(Ze, { variant: "pr", size: "m2", ...o, onClick: a, children: e || s.t("upload") })
  ] });
}
const p4 = ue(d4), f4 = ue(function({
  editor: t,
  assetProps: n,
  itemLayout: r,
  onSelect: o,
  onRemove: s
}) {
  const i = ea();
  return un(
    r({
      asset: Fr(i.toAsset(n)),
      assetProps: Fr(n),
      onSelect: (a) => o(i.toAssetProps(a)),
      onDelete: s && ((a) => s(i.toAssetProps(a))),
      editor: t
    })
  );
}), h4 = "gs-cmp-asset-card", g4 = ue(function(t) {
  var p;
  const { assetProps: n, onSelect: r, onRemove: o, className: s, itemLayout: i } = t, a = Ne(), { editor: l } = ye();
  if (i)
    return l ? /* @__PURE__ */ c(f4, { ...t, editor: l, itemLayout: i }) : null;
  const { src: u } = n, d = n.name || ((p = u.split("/").pop()) == null ? void 0 : p.split("?").shift());
  return /* @__PURE__ */ c(Jt, { padding: !1, className: F(h4, "overflow-hidden max-w-full group", s), children: /* @__PURE__ */ A(I, { col: !0, children: [
    /* @__PURE__ */ A(N, { className: F("relative group h-24 cursor-pointer bg-checker"), onClick: () => r(n), children: [
      /* @__PURE__ */ c(
        "div",
        {
          className: F("w-full h-full bg-contain bg-no-repeat bg-center"),
          style: { backgroundImage: `url("${u}")` }
        }
      ),
      /* @__PURE__ */ c(
        I,
        {
          justify: "center",
          items: "center",
          className: F(Qe.coverAbs, z.bgH75, "group-hover:gs-utl-opacity-100 opacity-0 transition-opacity"),
          children: /* @__PURE__ */ c(Ze, { className: F("text-sm"), size: "m2", variant: "pr", children: a.t("select") })
        }
      )
    ] }),
    /* @__PURE__ */ A(I, { className: F("gjs-p-1 max-w-full"), space: "s", items: "center", nowrap: !0, children: [
      /* @__PURE__ */ c(N, { className: F(Qe.txtEllips, "text-sm gjs-mr-auto"), children: d }),
      o && /* @__PURE__ */ c(
        uf,
        {
          onConfirm: () => o == null ? void 0 : o(n),
          text: /* @__PURE__ */ A(I, { col: !0, space: "m", items: "stretch", children: [
            /* @__PURE__ */ c("p", { className: F("text-center", z.txtHighEmphasis), children: a.t("assetManager.deleteConfirmQuestion") }),
            /* @__PURE__ */ c("p", { className: F("text-center"), children: a.t("assetManager.deleteConfirmExplanation") })
          ] }),
          confirmButtonProps: { variant: "danger" },
          children: /* @__PURE__ */ c(Ft, { title: a.t("delete"), children: /* @__PURE__ */ c(oe, { icon: ne.delete, size: pe.sx }) })
        }
      )
    ] })
  ] }) });
}), Cu = "gs-asset-manager", m4 = {
  search: !0,
  addUrl: !0,
  upload: !0
}, v4 = ue(function({
  assetProps: t,
  typeFilterOptions: n,
  providerFilterOptions: r,
  typeFilter: o,
  providerFilter: s,
  searchValue: i,
  isLoading: a,
  optionalType: l,
  useLocalSearch: u,
  itemLayout: d,
  content: p,
  onSelect: f,
  onChangeTypeFilter: h,
  onChangeProviderFilter: g,
  onChangeSearchValue: m,
  onChangeUpload: v,
  onAddUrl: b,
  onRemove: y,
  onEndReached: w
}) {
  const S = ye(), { editor: x } = S, C = Ne(), [P] = pc(), _ = cf(p == null ? void 0 : p.itemsPerRow), [O, E] = W(""), T = (p == null ? void 0 : p.header) === !1 ? !1 : { ...m4, ...ps(p == null ? void 0 : p.header) ? p.header : {} };
  if (!x)
    return;
  const R = u ? t.filter((B) => !(i && !Qo(B.src, i) && !Qo(B.name ?? "", i))) : t;
  return /* @__PURE__ */ A(I, { className: $(Cu, "relative gs-utl-h-full", a && Qe.disabled), nowrap: !0, col: !0, space: "m", children: [
    T !== !1 && /* @__PURE__ */ A(I, { className: $(`${Cu}__header`, "gs-utl-gap-4"), justify: "between", items: "center", children: [
      /* @__PURE__ */ A(I, { items: "center", space: "m", children: [
        T.search && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
          ft,
          {
            size: "s",
            type: "search",
            value: i,
            onInput: m,
            placeholder: `${C.t("search")}...`
          }
        ) }),
        n.length > (l ? 0 : 1) && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
          Ae,
          {
            className: $("items-center"),
            size: "m",
            options: n,
            value: o,
            onChange: h,
            emptyState: C.t("assetManager.assetTypes.all"),
            includeEmpty: l
          }
        ) }),
        r.length > 0 && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
          Ae,
          {
            className: $("items-center"),
            size: "m",
            options: r.map((B) => ({
              ...B,
              label: ct(B.label) ? B.label({ editor: x }) : B.label
            })),
            value: s,
            onChange: g,
            emptyState: C.t("assetManager.noProvider"),
            includeEmpty: !0
          }
        ) })
      ] }),
      /* @__PURE__ */ A(I, { items: "center", space: "m", children: [
        T.upload && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(p4, { onChange: v }) }),
        T.addUrl && !!b && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
          Rr,
          {
            overlay: !0,
            placement: "bottom-end",
            title: !1,
            buttonAs: "span",
            handler: /* @__PURE__ */ c(Ze, { variant: "pr", size: "m2", children: C.t("assetManager.addUrl") }),
            children: ({ close: B }) => /* @__PURE__ */ A(I, { space: "m", children: [
              /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
                ft,
                {
                  type: "url",
                  size: "s",
                  value: O,
                  onChange: E,
                  placeholder: C.t("assetManager.inputPlh")
                }
              ) }),
              /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
                Ze,
                {
                  variant: "pr",
                  size: "m2",
                  onClick: () => {
                    b(O), B();
                  },
                  children: C.t("add")
                }
              ) })
            ] })
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ c(I, { className: $(`${Cu}__content`, "gs-utl-h-[75vh] gs-utl-flex-grow"), space: "m", col: !0, nowrap: !0, children: !a && !R.length ? /* @__PURE__ */ c(I, { justify: "center", children: C.t("noItems") }) : (
      // Ensure  to render Virtuoso when the transition ends to avoid "holes" in the grid
      !!P && /* @__PURE__ */ c(
        ia,
        {
          data: R,
          listClassName: $("gs-utl-grid gs-utl-gap-2", _),
          endReached: w,
          itemContent: (B, U) => /* @__PURE__ */ c(
            g4,
            {
              assetProps: U,
              onSelect: f,
              onRemove: y,
              itemLayout: d
            },
            U.id
          ),
          components: { Footer: w ? b4 : void 0 }
        }
      )
    ) }),
    a && /* @__PURE__ */ c(sa, { abs: !0 })
  ] });
}), b4 = () => /* @__PURE__ */ c(
  "div",
  {
    style: {
      padding: "2rem",
      display: "flex",
      justifyContent: "center",
      height: 200
    }
  }
), f0 = ue(function({
  panelId: t,
  content: n,
  assets: r,
  types: o,
  providers: s,
  typeId: i,
  providerId: a,
  optionalType: l,
  onSelect: u,
  close: d
}) {
  const { appEditorStore: p, i18nStore: f } = It(), { editor: h } = p, g = ea(), { customOnLoad: m } = g, v = Lv(t);
  G(() => {
    const x = (P) => Mt(P) ? { id: P, label: f.t(`assetManager.assetTypes.${P}`) || P } : P;
    v.setCustomTypes(o == null ? void 0 : o.map(x)), v.setCustomProviders(Mt(s) ? [s] : s), i ? v.setTypeFilter(i) : v.initTypeFilter(), a ? v.setProviderFilter(a) : v.initProviderFilter(), l ? v.setOptionalType(l) : v.initOptionalType();
    const C = setTimeout(() => v.loadAssets());
    return () => clearTimeout(C);
  }, [o, s, i, a, l]);
  const b = (x) => {
    g.addToProjectAssets([{ id: x, src: x }]);
  }, y = (x) => {
    h && (u == null || u({ asset: g.toAsset(x), assetProps: x, editor: h }), d == null || d());
  }, w = r == null ? void 0 : r.map(g.toAssetProps), S = v.shouldLoadNextPage ? () => v.loadAssets(!1) : void 0;
  return /* @__PURE__ */ c(
    v4,
    {
      assetProps: w ?? v.assetProps,
      typeFilter: v.typeFilter,
      typeFilterOptions: v.typeFilterOptions,
      providerFilter: v.providerFilter,
      providerFilterOptions: v.providerFilterOptions,
      searchValue: v.searchValue,
      onChangeTypeFilter: (x) => {
        v.setTypeFilter(x), v.loadAssets();
      },
      onChangeProviderFilter: (x) => {
        v.setProviderFilter(x), v.loadAssets();
      },
      onChangeSearchValue: v.setSearchValue,
      onSelect: y,
      onAddUrl: m ? void 0 : b,
      onChangeUpload: (x) => g.uploadFile(x.nativeEvent),
      onRemove: w ? void 0 : v.handleDelete,
      onEndReached: S,
      isLoading: v.isLoading,
      itemLayout: v.itemLayout,
      content: n,
      optionalType: v.optionalType,
      useLocalSearch: !v.reloadOnInput
    }
  );
});
var y4 = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var s in o)
        Object.prototype.hasOwnProperty.call(o, s) && (r[s] = o[s]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), bt = globalThis && globalThis.__assign || function() {
  return bt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, bt.apply(this, arguments);
}, zg = {
  width: "100%",
  height: "10px",
  top: "0px",
  left: "0px",
  cursor: "row-resize"
}, Fg = {
  width: "10px",
  height: "100%",
  top: "0px",
  left: "0px",
  cursor: "col-resize"
}, Da = {
  width: "20px",
  height: "20px",
  position: "absolute"
}, w4 = {
  top: bt(bt({}, zg), { top: "-5px" }),
  right: bt(bt({}, Fg), { left: void 0, right: "-5px" }),
  bottom: bt(bt({}, zg), { top: void 0, bottom: "-5px" }),
  left: bt(bt({}, Fg), { left: "-5px" }),
  topRight: bt(bt({}, Da), { right: "-10px", top: "-10px", cursor: "ne-resize" }),
  bottomRight: bt(bt({}, Da), { right: "-10px", bottom: "-10px", cursor: "se-resize" }),
  bottomLeft: bt(bt({}, Da), { left: "-10px", bottom: "-10px", cursor: "sw-resize" }),
  topLeft: bt(bt({}, Da), { left: "-10px", top: "-10px", cursor: "nw-resize" })
}, S4 = (
  /** @class */
  function(e) {
    y4(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.onMouseDown = function(r) {
        n.props.onResizeStart(r, n.props.direction);
      }, n.onTouchStart = function(r) {
        n.props.onResizeStart(r, n.props.direction);
      }, n;
    }
    return t.prototype.render = function() {
      return Ue.createElement("div", { className: this.props.className || "", style: bt(bt({ position: "absolute", userSelect: "none" }, w4[this.props.direction]), this.props.replaceStyles || {}), onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart }, this.props.children);
    }, t;
  }(Ue.PureComponent)
), x4 = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var s in o)
        Object.prototype.hasOwnProperty.call(o, s) && (r[s] = o[s]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), qn = globalThis && globalThis.__assign || function() {
  return qn = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, qn.apply(this, arguments);
}, C4 = {
  width: "auto",
  height: "auto"
}, Ia = function(e, t, n) {
  return Math.max(Math.min(e, n), t);
}, Ug = function(e, t, n) {
  var r = Math.round(e / t);
  return r * t + n * (r - 1);
}, Fo = function(e, t) {
  return new RegExp(e, "i").test(t);
}, Va = function(e) {
  return !!(e.touches && e.touches.length);
}, P4 = function(e) {
  return !!((e.clientX || e.clientX === 0) && (e.clientY || e.clientY === 0));
}, Wg = function(e, t, n) {
  n === void 0 && (n = 0);
  var r = t.reduce(function(s, i, a) {
    return Math.abs(i - e) < Math.abs(t[s] - e) ? a : s;
  }, 0), o = Math.abs(t[r] - e);
  return n === 0 || o < n ? t[r] : e;
}, Pu = function(e) {
  return e = e.toString(), e === "auto" || e.endsWith("px") || e.endsWith("%") || e.endsWith("vh") || e.endsWith("vw") || e.endsWith("vmax") || e.endsWith("vmin") ? e : e + "px";
}, Ha = function(e, t, n, r) {
  if (e && typeof e == "string") {
    if (e.endsWith("px"))
      return Number(e.replace("px", ""));
    if (e.endsWith("%")) {
      var o = Number(e.replace("%", "")) / 100;
      return t * o;
    }
    if (e.endsWith("vw")) {
      var o = Number(e.replace("vw", "")) / 100;
      return n * o;
    }
    if (e.endsWith("vh")) {
      var o = Number(e.replace("vh", "")) / 100;
      return r * o;
    }
  }
  return e;
}, E4 = function(e, t, n, r, o, s, i) {
  return r = Ha(r, e.width, t, n), o = Ha(o, e.height, t, n), s = Ha(s, e.width, t, n), i = Ha(i, e.height, t, n), {
    maxWidth: typeof r > "u" ? void 0 : Number(r),
    maxHeight: typeof o > "u" ? void 0 : Number(o),
    minWidth: typeof s > "u" ? void 0 : Number(s),
    minHeight: typeof i > "u" ? void 0 : Number(i)
  };
}, O4 = function(e) {
  return Array.isArray(e) ? e : [e, e];
}, _4 = [
  "as",
  "ref",
  "style",
  "className",
  "grid",
  "gridGap",
  "snap",
  "bounds",
  "boundsByDirection",
  "size",
  "defaultSize",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
  "lockAspectRatio",
  "lockAspectRatioExtraWidth",
  "lockAspectRatioExtraHeight",
  "enable",
  "handleStyles",
  "handleClasses",
  "handleWrapperStyle",
  "handleWrapperClass",
  "children",
  "onResizeStart",
  "onResize",
  "onResizeStop",
  "handleComponent",
  "scale",
  "resizeRatio",
  "snapGap"
], Gg = "__resizable_base__", T4 = (
  /** @class */
  function(e) {
    x4(t, e);
    function t(n) {
      var r, o, s, i, a = e.call(this, n) || this;
      return a.ratio = 1, a.resizable = null, a.parentLeft = 0, a.parentTop = 0, a.resizableLeft = 0, a.resizableRight = 0, a.resizableTop = 0, a.resizableBottom = 0, a.targetLeft = 0, a.targetTop = 0, a.appendBase = function() {
        if (!a.resizable || !a.window)
          return null;
        var l = a.parentNode;
        if (!l)
          return null;
        var u = a.window.document.createElement("div");
        return u.style.width = "100%", u.style.height = "100%", u.style.position = "absolute", u.style.transform = "scale(0, 0)", u.style.left = "0", u.style.flex = "0 0 100%", u.classList ? u.classList.add(Gg) : u.className += Gg, l.appendChild(u), u;
      }, a.removeBase = function(l) {
        var u = a.parentNode;
        u && u.removeChild(l);
      }, a.state = {
        isResizing: !1,
        width: (o = (r = a.propsSize) === null || r === void 0 ? void 0 : r.width) !== null && o !== void 0 ? o : "auto",
        height: (i = (s = a.propsSize) === null || s === void 0 ? void 0 : s.height) !== null && i !== void 0 ? i : "auto",
        direction: "right",
        original: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        backgroundStyle: {
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0,0,0,0)",
          cursor: "auto",
          opacity: 0,
          position: "fixed",
          zIndex: 9999,
          top: "0",
          left: "0",
          bottom: "0",
          right: "0"
        },
        flexBasis: void 0
      }, a.onResizeStart = a.onResizeStart.bind(a), a.onMouseMove = a.onMouseMove.bind(a), a.onMouseUp = a.onMouseUp.bind(a), a;
    }
    return Object.defineProperty(t.prototype, "parentNode", {
      get: function() {
        return this.resizable ? this.resizable.parentNode : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "window", {
      get: function() {
        return !this.resizable || !this.resizable.ownerDocument ? null : this.resizable.ownerDocument.defaultView;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "propsSize", {
      get: function() {
        return this.props.size || this.props.defaultSize || C4;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "size", {
      get: function() {
        var n = 0, r = 0;
        if (this.resizable && this.window) {
          var o = this.resizable.offsetWidth, s = this.resizable.offsetHeight, i = this.resizable.style.position;
          i !== "relative" && (this.resizable.style.position = "relative"), n = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : o, r = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : s, this.resizable.style.position = i;
        }
        return { width: n, height: r };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "sizeStyle", {
      get: function() {
        var n = this, r = this.props.size, o = function(a) {
          var l;
          if (typeof n.state[a] > "u" || n.state[a] === "auto")
            return "auto";
          if (n.propsSize && n.propsSize[a] && (!((l = n.propsSize[a]) === null || l === void 0) && l.toString().endsWith("%"))) {
            if (n.state[a].toString().endsWith("%"))
              return n.state[a].toString();
            var u = n.getParentSize(), d = Number(n.state[a].toString().replace("px", "")), p = d / u[a] * 100;
            return p + "%";
          }
          return Pu(n.state[a]);
        }, s = r && typeof r.width < "u" && !this.state.isResizing ? Pu(r.width) : o("width"), i = r && typeof r.height < "u" && !this.state.isResizing ? Pu(r.height) : o("height");
        return { width: s, height: i };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getParentSize = function() {
      if (!this.parentNode)
        return this.window ? { width: this.window.innerWidth, height: this.window.innerHeight } : { width: 0, height: 0 };
      var n = this.appendBase();
      if (!n)
        return { width: 0, height: 0 };
      var r = !1, o = this.parentNode.style.flexWrap;
      o !== "wrap" && (r = !0, this.parentNode.style.flexWrap = "wrap"), n.style.position = "relative", n.style.minWidth = "100%", n.style.minHeight = "100%";
      var s = {
        width: n.offsetWidth,
        height: n.offsetHeight
      };
      return r && (this.parentNode.style.flexWrap = o), this.removeBase(n), s;
    }, t.prototype.bindEvents = function() {
      this.window && (this.window.addEventListener("mouseup", this.onMouseUp), this.window.addEventListener("mousemove", this.onMouseMove), this.window.addEventListener("mouseleave", this.onMouseUp), this.window.addEventListener("touchmove", this.onMouseMove, {
        capture: !0,
        passive: !1
      }), this.window.addEventListener("touchend", this.onMouseUp));
    }, t.prototype.unbindEvents = function() {
      this.window && (this.window.removeEventListener("mouseup", this.onMouseUp), this.window.removeEventListener("mousemove", this.onMouseMove), this.window.removeEventListener("mouseleave", this.onMouseUp), this.window.removeEventListener("touchmove", this.onMouseMove, !0), this.window.removeEventListener("touchend", this.onMouseUp));
    }, t.prototype.componentDidMount = function() {
      if (!(!this.resizable || !this.window)) {
        var n = this.window.getComputedStyle(this.resizable);
        this.setState({
          width: this.state.width || this.size.width,
          height: this.state.height || this.size.height,
          flexBasis: n.flexBasis !== "auto" ? n.flexBasis : void 0
        });
      }
    }, t.prototype.componentWillUnmount = function() {
      this.window && this.unbindEvents();
    }, t.prototype.createSizeForCssProperty = function(n, r) {
      var o = this.propsSize && this.propsSize[r];
      return this.state[r] === "auto" && this.state.original[r] === n && (typeof o > "u" || o === "auto") ? "auto" : n;
    }, t.prototype.calculateNewMaxFromBoundary = function(n, r) {
      var o = this.props.boundsByDirection, s = this.state.direction, i = o && Fo("left", s), a = o && Fo("top", s), l, u;
      if (this.props.bounds === "parent") {
        var d = this.parentNode;
        d && (l = i ? this.resizableRight - this.parentLeft : d.offsetWidth + (this.parentLeft - this.resizableLeft), u = a ? this.resizableBottom - this.parentTop : d.offsetHeight + (this.parentTop - this.resizableTop));
      } else
        this.props.bounds === "window" ? this.window && (l = i ? this.resizableRight : this.window.innerWidth - this.resizableLeft, u = a ? this.resizableBottom : this.window.innerHeight - this.resizableTop) : this.props.bounds && (l = i ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft), u = a ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop));
      return l && Number.isFinite(l) && (n = n && n < l ? n : l), u && Number.isFinite(u) && (r = r && r < u ? r : u), { maxWidth: n, maxHeight: r };
    }, t.prototype.calculateNewSizeFromDirection = function(n, r) {
      var o = this.props.scale || 1, s = O4(this.props.resizeRatio || 1), i = s[0], a = s[1], l = this.state, u = l.direction, d = l.original, p = this.props, f = p.lockAspectRatio, h = p.lockAspectRatioExtraHeight, g = p.lockAspectRatioExtraWidth, m = d.width, v = d.height, b = h || 0, y = g || 0;
      return Fo("right", u) && (m = d.width + (n - d.x) * i / o, f && (v = (m - y) / this.ratio + b)), Fo("left", u) && (m = d.width - (n - d.x) * i / o, f && (v = (m - y) / this.ratio + b)), Fo("bottom", u) && (v = d.height + (r - d.y) * a / o, f && (m = (v - b) * this.ratio + y)), Fo("top", u) && (v = d.height - (r - d.y) * a / o, f && (m = (v - b) * this.ratio + y)), { newWidth: m, newHeight: v };
    }, t.prototype.calculateNewSizeFromAspectRatio = function(n, r, o, s) {
      var i = this.props, a = i.lockAspectRatio, l = i.lockAspectRatioExtraHeight, u = i.lockAspectRatioExtraWidth, d = typeof s.width > "u" ? 10 : s.width, p = typeof o.width > "u" || o.width < 0 ? n : o.width, f = typeof s.height > "u" ? 10 : s.height, h = typeof o.height > "u" || o.height < 0 ? r : o.height, g = l || 0, m = u || 0;
      if (a) {
        var v = (f - g) * this.ratio + m, b = (h - g) * this.ratio + m, y = (d - m) / this.ratio + g, w = (p - m) / this.ratio + g, S = Math.max(d, v), x = Math.min(p, b), C = Math.max(f, y), P = Math.min(h, w);
        n = Ia(n, S, x), r = Ia(r, C, P);
      } else
        n = Ia(n, d, p), r = Ia(r, f, h);
      return { newWidth: n, newHeight: r };
    }, t.prototype.setBoundingClientRect = function() {
      var n = 1 / (this.props.scale || 1);
      if (this.props.bounds === "parent") {
        var r = this.parentNode;
        if (r) {
          var o = r.getBoundingClientRect();
          this.parentLeft = o.left * n, this.parentTop = o.top * n;
        }
      }
      if (this.props.bounds && typeof this.props.bounds != "string") {
        var s = this.props.bounds.getBoundingClientRect();
        this.targetLeft = s.left * n, this.targetTop = s.top * n;
      }
      if (this.resizable) {
        var i = this.resizable.getBoundingClientRect(), a = i.left, l = i.top, u = i.right, d = i.bottom;
        this.resizableLeft = a * n, this.resizableRight = u * n, this.resizableTop = l * n, this.resizableBottom = d * n;
      }
    }, t.prototype.onResizeStart = function(n, r) {
      if (!(!this.resizable || !this.window)) {
        var o = 0, s = 0;
        if (n.nativeEvent && P4(n.nativeEvent) ? (o = n.nativeEvent.clientX, s = n.nativeEvent.clientY) : n.nativeEvent && Va(n.nativeEvent) && (o = n.nativeEvent.touches[0].clientX, s = n.nativeEvent.touches[0].clientY), this.props.onResizeStart && this.resizable) {
          var i = this.props.onResizeStart(n, r, this.resizable);
          if (i === !1)
            return;
        }
        this.props.size && (typeof this.props.size.height < "u" && this.props.size.height !== this.state.height && this.setState({ height: this.props.size.height }), typeof this.props.size.width < "u" && this.props.size.width !== this.state.width && this.setState({ width: this.props.size.width })), this.ratio = typeof this.props.lockAspectRatio == "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var a, l = this.window.getComputedStyle(this.resizable);
        if (l.flexBasis !== "auto") {
          var u = this.parentNode;
          if (u) {
            var d = this.window.getComputedStyle(u).flexDirection;
            this.flexDir = d.startsWith("row") ? "row" : "column", a = l.flexBasis;
          }
        }
        this.setBoundingClientRect(), this.bindEvents();
        var p = {
          original: {
            x: o,
            y: s,
            width: this.size.width,
            height: this.size.height
          },
          isResizing: !0,
          backgroundStyle: qn(qn({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(n.target).cursor || "auto" }),
          direction: r,
          flexBasis: a
        };
        this.setState(p);
      }
    }, t.prototype.onMouseMove = function(n) {
      var r = this;
      if (!(!this.state.isResizing || !this.resizable || !this.window)) {
        if (this.window.TouchEvent && Va(n))
          try {
            n.preventDefault(), n.stopPropagation();
          } catch {
          }
        var o = this.props, s = o.maxWidth, i = o.maxHeight, a = o.minWidth, l = o.minHeight, u = Va(n) ? n.touches[0].clientX : n.clientX, d = Va(n) ? n.touches[0].clientY : n.clientY, p = this.state, f = p.direction, h = p.original, g = p.width, m = p.height, v = this.getParentSize(), b = E4(v, this.window.innerWidth, this.window.innerHeight, s, i, a, l);
        s = b.maxWidth, i = b.maxHeight, a = b.minWidth, l = b.minHeight;
        var y = this.calculateNewSizeFromDirection(u, d), w = y.newHeight, S = y.newWidth, x = this.calculateNewMaxFromBoundary(s, i);
        this.props.snap && this.props.snap.x && (S = Wg(S, this.props.snap.x, this.props.snapGap)), this.props.snap && this.props.snap.y && (w = Wg(w, this.props.snap.y, this.props.snapGap));
        var C = this.calculateNewSizeFromAspectRatio(S, w, { width: x.maxWidth, height: x.maxHeight }, { width: a, height: l });
        if (S = C.newWidth, w = C.newHeight, this.props.grid) {
          var P = Ug(S, this.props.grid[0], this.props.gridGap ? this.props.gridGap[0] : 0), _ = Ug(w, this.props.grid[1], this.props.gridGap ? this.props.gridGap[1] : 0), O = this.props.snapGap || 0, E = O === 0 || Math.abs(P - S) <= O ? P : S, T = O === 0 || Math.abs(_ - w) <= O ? _ : w;
          S = E, w = T;
        }
        var R = {
          width: S - h.width,
          height: w - h.height
        };
        if (g && typeof g == "string") {
          if (g.endsWith("%")) {
            var B = S / v.width * 100;
            S = B + "%";
          } else if (g.endsWith("vw")) {
            var U = S / this.window.innerWidth * 100;
            S = U + "vw";
          } else if (g.endsWith("vh")) {
            var L = S / this.window.innerHeight * 100;
            S = L + "vh";
          }
        }
        if (m && typeof m == "string") {
          if (m.endsWith("%")) {
            var B = w / v.height * 100;
            w = B + "%";
          } else if (m.endsWith("vw")) {
            var U = w / this.window.innerWidth * 100;
            w = U + "vw";
          } else if (m.endsWith("vh")) {
            var L = w / this.window.innerHeight * 100;
            w = L + "vh";
          }
        }
        var M = {
          width: this.createSizeForCssProperty(S, "width"),
          height: this.createSizeForCssProperty(w, "height")
        };
        this.flexDir === "row" ? M.flexBasis = M.width : this.flexDir === "column" && (M.flexBasis = M.height);
        var D = this.state.width !== M.width, V = this.state.height !== M.height, k = this.state.flexBasis !== M.flexBasis, j = D || V || k;
        j && vm(function() {
          r.setState(M);
        }), this.props.onResize && j && this.props.onResize(n, f, this.resizable, R);
      }
    }, t.prototype.onMouseUp = function(n) {
      var r, o, s = this.state, i = s.isResizing, a = s.direction, l = s.original;
      if (!(!i || !this.resizable)) {
        var u = {
          width: this.size.width - l.width,
          height: this.size.height - l.height
        };
        this.props.onResizeStop && this.props.onResizeStop(n, a, this.resizable, u), this.props.size && this.setState({ width: (r = this.props.size.width) !== null && r !== void 0 ? r : "auto", height: (o = this.props.size.height) !== null && o !== void 0 ? o : "auto" }), this.unbindEvents(), this.setState({
          isResizing: !1,
          backgroundStyle: qn(qn({}, this.state.backgroundStyle), { cursor: "auto" })
        });
      }
    }, t.prototype.updateSize = function(n) {
      var r, o;
      this.setState({ width: (r = n.width) !== null && r !== void 0 ? r : "auto", height: (o = n.height) !== null && o !== void 0 ? o : "auto" });
    }, t.prototype.renderResizer = function(n) {
      var r = this, o = this.props, s = o.enable, i = o.handleStyles, a = o.handleClasses, l = o.handleWrapperStyle, u = o.handleWrapperClass, d = o.handleComponent;
      if (!s)
        return null;
      var p = n.filter(function(f) {
        return s[f] !== !1;
      }).map(function(f) {
        return s[f] !== !1 ? Ue.createElement(S4, { key: f, direction: f, onResizeStart: r.onResizeStart, replaceStyles: i && i[f], className: a && a[f] }, d && d[f] ? d[f] : null) : null;
      });
      return Ue.createElement("div", { className: u, style: l }, p);
    }, t.prototype.render = function() {
      var n = this, r = Object.keys(this.props).reduce(function(i, a) {
        return _4.indexOf(a) !== -1 || (i[a] = n.props[a]), i;
      }, {}), o = qn(qn(qn({ position: "relative", userSelect: this.state.isResizing ? "none" : "auto" }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: "border-box", flexShrink: 0 });
      this.state.flexBasis && (o.flexBasis = this.state.flexBasis);
      var s = this.props.as || "div";
      return Ue.createElement(
        s,
        qn({ style: o, className: this.props.className }, r, {
          // `ref` is after `extendsProps` to ensure this one wins over a version
          // passed in
          ref: function(i) {
            i && (n.resizable = i);
          }
        }),
        this.state.isResizing && Ue.createElement("div", { style: this.state.backgroundStyle }),
        this.renderResizer(["topLeft", "top", "topRight", "left"]),
        this.props.children,
        this.renderResizer(["right", "bottomLeft", "bottom", "bottomRight"])
      );
    }, t.defaultProps = {
      as: "div",
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      enable: {
        top: !0,
        right: !0,
        bottom: !0,
        left: !0,
        topRight: !0,
        bottomRight: !0,
        bottomLeft: !0,
        topLeft: !0
      },
      style: {},
      grid: [1, 1],
      gridGap: [0, 0],
      lockAspectRatio: !1,
      lockAspectRatioExtraWidth: 0,
      lockAspectRatioExtraHeight: 0,
      scale: 1,
      resizeRatio: 1,
      snapGap: 0
    }, t;
  }(Ue.PureComponent)
);
function wc({
  className: e,
  children: t,
  top: n,
  bottom: r,
  right: o,
  left: s,
  width: i,
  height: a,
  minHeight: l,
  minWidth: u,
  maxHeight: d,
  maxWidth: p,
  style: f,
  onResize: h,
  onResizeStop: g,
  ...m
}) {
  const v = {
    top: n || !1,
    right: o || !1,
    bottom: r || !1,
    left: s || !1,
    topRight: !1,
    bottomRight: !1,
    bottomLeft: !1,
    topLeft: !1
  }, b = {
    width: i || "auto",
    height: a || "auto"
  }, y = $("z-10", z.hBgAct), w = {
    bottom: y,
    right: y,
    left: y
  }, S = {
    bottom: { bottom: 0, height: 2 },
    right: { right: -1, width: 2 },
    left: { left: -1, width: 2 }
  };
  return /* @__PURE__ */ c(
    T4,
    {
      className: e,
      enable: m.enable ?? v,
      defaultSize: b,
      handleStyles: S,
      handleClasses: w,
      onResize: h,
      onResizeStop: g,
      minHeight: l,
      minWidth: u,
      maxHeight: d,
      maxWidth: p,
      style: f,
      children: t
    }
  );
}
const Zs = "gs-studio-panel", h0 = (e, t = {}) => ({
  ...t,
  ...e === !0 ? {} : e || void 0
}), zn = we(function({
  children: t,
  header: n,
  resizable: r,
  className: o,
  classNameAccordion: s,
  classNameAccordionContent: i,
  ...a
}) {
  const l = /* @__PURE__ */ c(No, { className: q(Zs, o), ...a, children: t }), u = r ? r === !0 ? {
    top: !0,
    right: !0,
    bottom: !0,
    left: !0
  } : r : void 0, d = u ? /* @__PURE__ */ c(wc, { className: q([`${Zs}__resizer`]), ...u, children: l }) : l, p = n === !0 ? { collapsible: !0 } : n || void 0;
  return p ? /* @__PURE__ */ c(
    $o,
    {
      classNameWrap: q(`${Zs}__accordion`, s),
      className: q(`${Zs}__accordion-header`, Re.xy, p.className),
      classNameContent: q(`${Zs}__accordion-content`, i),
      disabled: p.collapsible === !1,
      style: p.style,
      handler: /* @__PURE__ */ A(I, { space: "s", items: "center", children: [
        !!p.icon && /* @__PURE__ */ c(oe, { icon: p.icon, size: pe.s }),
        /* @__PURE__ */ c(N, { grow: !0, children: p.label })
      ] }),
      open: n ? p.collapsed !== !0 : !0,
      children: d
    }
  ) : d;
}), A4 = "gs-panel-assets", L4 = we(
  ue(function({
    className: t,
    onSelect: n,
    content: r,
    assets: o,
    types: s,
    providers: i,
    typeId: a,
    providerId: l,
    optionalType: u,
    ...d
  }) {
    const p = ye(), f = ea(), h = p.editor, [g] = W(() => d.id || f1());
    return G(() => (f.createAssetManager(g), () => {
      f.removeAssetManager(g);
    }), [g]), Lv(g) ? /* @__PURE__ */ c(
      zn,
      {
        className: q(A4, "gs-utl-overflow-hidden gs-utl-h-full", t),
        classNameAccordion: q("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        classNameAccordionContent: q("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        ...d,
        children: h && /* @__PURE__ */ c(
          f0,
          {
            panelId: g,
            assets: o,
            types: s,
            providers: i,
            onSelect: n,
            typeId: a,
            providerId: l,
            content: r,
            optionalType: u
          }
        )
      }
    ) : null;
  })
), g0 = Rt(function({ children: t, className: n, ...r }, o) {
  return /* @__PURE__ */ c("div", { className: q(F("gs-block-manager-after"), n), ref: o, ...r, children: t });
}), m0 = Rt(function({ children: t, className: n, ...r }, o) {
  return /* @__PURE__ */ c("div", { className: q(F("gs-block-manager-before"), n), ref: o, ...r, children: t });
}), k4 = "gs-panel-blocks", M4 = we(
  ue(function({
    className: t,
    symbols: n,
    search: r,
    hideCategories: o,
    blocks: s,
    itemLayout: i,
    ...a
  }) {
    const l = ye().sdkProps.children, u = {
      search: r,
      symbols: n,
      hideCategories: o,
      isOpen: !0,
      blocks: s,
      itemLayout: i
    };
    return /* @__PURE__ */ c(
      zn,
      {
        className: q(k4, "gs-utl-overflow-hidden", t),
        classNameAccordion: q("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        classNameAccordionContent: q("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        ...a,
        children: /* @__PURE__ */ A(Mo, { children: [
          qt(l, m0),
          /* @__PURE__ */ c(V0, { className: q("gs-utl-overflow-hidden gs-utl-flex-nowrap"), ...u }),
          qt(l, g0)
        ] })
      }
    );
  })
), $4 = (e, { t, id: n }) => t(`fields.${n}.label`) || yr(`${e}`.replace(/-/g, " ")), v0 = (e, { t, id: n }) => {
  const r = Mt(e) ? { id: e, label: e } : e;
  return {
    ...r,
    label: t(`fields.${n}.options.${r.id}`) || r.label
  };
}, b0 = (e) => e.get("defaultValue") || "", Sc = (e) => e.get("field"), y0 = (e) => `${e.get("value") || b0(e) || ""}`, R4 = (e, t) => e || b0(t) || "", _l = ({
  record: e,
  value: t,
  partial: n
}) => {
  e.set({ value: R4(t, e) }, { partial: n }), e.em.refreshCanvas({ tools: !0 });
}, Tl = (e, t) => ({
  className: "gs-utl-w-full",
  size: "s",
  value: y0(e),
  label: $4(e.get("label") || e.id || "", t),
  onChange: (n, r) => _l({ record: e, value: n, partial: r })
}), N4 = (e, t) => {
  const n = Sc(e), r = ps(n) ? n : void 0, o = (r == null ? void 0 : r.units) || [], s = D3(y0(e)), i = s.number, a = s.unit || o[0] || "";
  return {
    ...Tl(e, t),
    value: i,
    valueUnit: a,
    min: r == null ? void 0 : r.min,
    max: r == null ? void 0 : r.max,
    step: r == null ? void 0 : r.step,
    units: r == null ? void 0 : r.units,
    onChange: (l, u) => {
      _l({ value: l ? `${l}${a}` : "", record: e, partial: u });
    },
    onChangeUnit: (l) => {
      _l({ value: i ? `${i}${l}` : "", record: e });
    }
  };
}, w0 = (e, t) => {
  var s;
  const n = Sc(e), r = ps(n) ? n : void 0, o = ((s = r == null ? void 0 : r.options) == null ? void 0 : s.map((i) => v0(i, t))) || [];
  return {
    ...Tl(e, t),
    options: o,
    onChange: (i) => _l({ value: i, record: e })
  };
}, j4 = (e, t) => {
  var s;
  const n = Sc(e), r = ps(n) ? n : void 0, o = ((s = r == null ? void 0 : r.options) == null ? void 0 : s.map((i) => v0(i, t))) || [];
  return {
    ...w0(e, t),
    size: "s",
    options: o
  };
};
function D4(e, t) {
  const n = Sc(e);
  switch (Mt(n) ? n : n == null ? void 0 : n.type) {
    case "radio":
      return /* @__PURE__ */ c(Bt, { ...j4(e, t) });
    case "select":
      return /* @__PURE__ */ c(Ae, { ...w0(e, t) });
    case "number":
      return /* @__PURE__ */ c(Me, { ...N4(e, t) });
    case "color":
      return /* @__PURE__ */ c(Lr, { ...Tl(e, t) });
    default:
      return /* @__PURE__ */ c(ft, { ...Tl(e, t) });
  }
}
const Kg = "gs-cmp-global-style-field", I4 = ue(function({ record: t }) {
  const n = ye(), o = Ne().tScoped("globalStyleManager"), [, s] = W(0), i = n.editor, a = t.id, l = { t: o, id: a };
  return G(() => {
    if (!i)
      return;
    const u = `data:path:${t.getPath("value")}`, d = () => s((p) => ++p);
    return i.on(u, d), () => {
      i.off(u, d);
    };
  }, [i]), /* @__PURE__ */ c(I, { className: q(Kg, `${Kg}__${a}`), children: D4(t, l) });
}), vi = "gs-cmp-global-style-manager", qg = ({ items: e, category: t, className: n }) => {
  const r = q(
    t ? `${vi}__cat-fields--${t.id}` : `${vi}__uncat-fields`,
    "gs-utl-gap-2",
    Re.xy,
    n
  );
  return /* @__PURE__ */ c(I, { className: r, nowrap: !0, col: !0, children: e.map((o) => /* @__PURE__ */ c(I4, { record: o }, o.id)) });
}, V4 = ue(function() {
  const t = W5(), { recordsByCategory: n, openCategories: r } = t, s = Ne().tScoped("globalStyleManager");
  return /* @__PURE__ */ c(I, { col: !0, full: !0, nowrap: !0, className: q(vi, "gs-utl-flex-grow gs-utl-overflow-hidden"), children: /* @__PURE__ */ c(I, { col: !0, nowrap: !0, className: q(`${vi}__fields`, Qe.scrollY, "gs-utl-select-none"), children: n.length ? n.map(
    ({ category: i, items: a }, l) => i ? /* @__PURE__ */ c(
      $o,
      {
        sticky: !0,
        open: r.get(i.id) ?? i.open,
        handler: s(`categories.${i.id}.label`) || i.label || i.id,
        onChange: ({ open: u }) => t.setCategoryOpen(i.id, u),
        className: (u) => q(
          `${vi}__cat-fields`,
          Qd.itemList({ index: l, open: u, length: n.length }),
          l === 0 && se.bt
        ),
        children: /* @__PURE__ */ c(qg, { category: i, items: a })
      },
      i.id
    ) : /* @__PURE__ */ c(
      qg,
      {
        items: a,
        className: q(n.length !== 1 && [se.bt, z.br])
      },
      l
    )
  ) : /* @__PURE__ */ c(I, { className: q("gs-utl-text-center"), justify: "center", children: s("notFound") }) }) });
}), H4 = "gs-panel-global-styles", B4 = we(
  ue(function({ className: t, ...n }) {
    return /* @__PURE__ */ c(
      zn,
      {
        className: q(H4, "gs-utl-overflow-auto", t),
        classNameAccordion: q("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        classNameAccordionContent: q("gs-utl-overflow-auto"),
        ...n,
        children: /* @__PURE__ */ c(Mo, { children: /* @__PURE__ */ c(V4, {}) })
      }
    );
  })
);
function df({ className: e, value: t, onChange: n }) {
  const [r, o] = W(t), s = K(null), i = (u) => {
    const { value: d } = u.target;
    o(d);
  }, a = () => {
    n(r || t);
  }, l = (u) => {
    switch (u.key) {
      case "Escape":
        n(t);
        break;
      case "Enter":
        n(r || t);
        break;
    }
  };
  return G(() => {
    s.current && s.current.select();
  }, []), /* @__PURE__ */ c(
    "input",
    {
      autoFocus: !0,
      className: $([e, "w-full", z.bgTr]),
      value: r,
      onChange: i,
      onBlur: a,
      onKeyDown: l,
      onPointerDown: ds,
      ref: s
    }
  );
}
const z4 = { maxWidth: `${uS}px` }, F4 = "gs-cmp-layer-item";
function S0({ component: e, draggingCmp: t, dragParent: n, ...r }) {
  const o = Tn(), { Layers: s } = o, i = K(null), [a, l] = W(!1), [u, d] = W(s.getLayerData(e)), { open: p, selected: f, hovered: h, components: g, visible: m, locked: v, name: b } = u, y = g.map((V) => V.cid), w = t === e, S = y.join("-"), x = r.level + 1, C = h || n === e;
  G(() => {
    x === 0 && d(s.getLayerData(e)), i.current && (i.current.__cmp = e);
  }, [e]), G(() => {
    const V = i.current;
    if (!V)
      return;
    const { select: k } = o.Components.events, j = (Y) => Y === e && V.scrollIntoView({ block: "nearest" });
    return o.on(k, j), () => {
      o.off(k, j);
    };
  }, [e, i.current]), G(() => {
    const V = (j) => {
      j === e && d(s.getLayerData(j));
    }, k = s.events.component;
    return o.on(k, V), () => {
      o.off(k, V);
    };
  }, [o, s, e]);
  const P = ie(() => g.map((V) => /* @__PURE__ */ c(S0, { component: V, level: x, draggingCmp: t, dragParent: n }, V.cid)), [S, t, n]), _ = (V) => {
    s.setLayerData(e, { name: V }), l(!1);
  }, O = (V) => {
    V.stopPropagation(), s.setLayerData(e, { open: !p });
  }, E = (V) => {
    V.stopPropagation(), s.setLayerData(e, { visible: !m });
  }, T = (V) => {
    V.stopPropagation(), s.setLayerData(e, { locked: !v });
  }, R = (V) => {
    V.stopPropagation(), s.setLayerData(e, { selected: !0 }, { event: V });
  }, B = (V) => {
    V.preventDefault(), o.runCommand(me.contextMenuComponent, {
      source: Rp.layers,
      component: e,
      event: V.nativeEvent,
      x: V.clientX,
      y: V.clientY
    });
  }, U = (V) => {
    (!V || !t) && s.setLayerData(e, { hovered: V });
  }, L = Bl(e), M = $(
    "layer-item",
    (f || L.isSymbol) && L.bgSoftX,
    (!m || w) && "opacity-50"
  ), D = $(Re.xyS, se.b, C ? L.border : se.bT, f && L.bgSoft);
  return /* @__PURE__ */ c("div", { className: F4, children: /* @__PURE__ */ A(I, { col: !0, className: M, children: [
    /* @__PURE__ */ c(
      N,
      {
        onClick: R,
        onContextMenu: B,
        onMouseEnter: () => U(!0),
        onMouseLeave: () => U(!1),
        className: $("group max-w-full"),
        "data-layer-item": !0,
        ref: i,
        children: /* @__PURE__ */ A(I, { items: "center", space: "xs", className: D, children: [
          /* @__PURE__ */ c(
            N,
            {
              style: { marginLeft: `${x * 10}px` },
              className: $("cursor-pointer", !g.length && "pointer-events-none opacity-0"),
              onClick: O,
              children: /* @__PURE__ */ c(oe, { icon: ne.menuDown, size: pe.sx, rotate: p ? 0 : -90 })
            }
          ),
          /* @__PURE__ */ c(N, { children: Ev(e) }),
          /* @__PURE__ */ c(N, { className: $("truncate"), onDoubleClick: () => l(!0), style: z4, grow: !0, children: a ? /* @__PURE__ */ c(df, { value: b, onChange: _ }) : /* @__PURE__ */ c(ae, { children: b }) }),
          !a && /* @__PURE__ */ A(ae, { children: [
            /* @__PURE__ */ c(
              N,
              {
                className: $("group-hover:gs-utl-opacity-100 cursor-pointer", v ? "opacity-100" : "opacity-0"),
                onClick: T,
                children: /* @__PURE__ */ c(oe, { icon: v ? ne.lock : ne.lockOpenVariant, size: pe.s3x })
              }
            ),
            /* @__PURE__ */ c(
              N,
              {
                className: $("group-hover:gs-utl-opacity-100 cursor-pointer", m ? "opacity-0" : "opacity-100"),
                onClick: E,
                children: /* @__PURE__ */ c(oe, { icon: m ? ne.eyeOutline : ne.eyeOffOutline, size: pe.sx })
              }
            )
          ] })
        ] })
      }
    ),
    !!(p && g.length) && /* @__PURE__ */ c(N, { className: $("max-w-full", !p && "hidden"), children: P })
  ] }) });
}
const U4 = {
  touchAction: "none"
}, Yg = 5, W4 = (e) => {
  const t = document.elementFromPoint(e.clientX, e.clientY), n = t == null ? void 0 : t.closest("[data-layer-item]");
  return {
    el: n,
    cmp: n == null ? void 0 : n.__cmp
  };
}, x0 = ue(function({ root: t, header: n }) {
  const { editor: r } = ye(), [o, s] = W(!1), [i, a] = W({}), [l, u] = W(), [d, p] = W(), [f, h] = W(), [g, m] = W(), v = K(null);
  if (G(() => {
    const O = window.document, E = (T) => {
      T.key === "Escape" && (a({ ...i, result: !1 }), S());
    };
    return O.addEventListener("keydown", E), () => {
      O.removeEventListener("keydown", E);
    };
  }, []), !r)
    return null;
  const { Components: b } = r, y = (O) => {
    O.button === 0 && s(!0);
  }, w = (O) => {
    if (!o)
      return;
    const { cmp: E, el: T } = W4(O);
    if (!T || !E)
      return;
    const R = T.getBoundingClientRect(), B = T.offsetHeight, U = T.offsetTop, L = O.clientY, M = L < R.y + B / 2, D = d || E, V = E.parent(), k = E.index() + (M ? 0 : 1);
    !d && p(E), u(E);
    const j = b.canMove(V, D, k), Y = b.canMove(E, D), J = {
      ...j,
      canMoveInside: Y,
      index: k
    };
    let le = !1;
    Y.result && L > R.y + Yg && L < R.y + B - Yg && (le = !0, J.target = E, delete J.index), h(le ? E : void 0), a(J), m({
      pointerInside: le,
      y: U + (M ? 0 : B),
      h: B
    });
  }, S = () => {
    var O;
    i != null && i.result && ((O = i.source) == null || O.move(i.target, { at: i.index })), a({}), s(!1), p(void 0), u(void 0), h(void 0), m(void 0);
  }, x = (l ? l.parents() : []).length, C = !!(d && g && (i != null && i.result) && !g.pointerInside), P = C ? { top: g.y, left: 0, marginLeft: x * 10 + 20 } : {}, _ = n && (n == null ? void 0 : n.label) || "Layers";
  return /* @__PURE__ */ A(I, { col: !0, full: !0, nowrap: !0, className: $("gs-layer-manager flex-grow overflow-hidden"), children: [
    n !== !1 && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ A(I, { space: "s", items: "center", className: $([Re.xy, se.bb, z.br]), children: [
      /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(oe, { icon: ne.layers, size: pe.s }) }),
      /* @__PURE__ */ c(N, { grow: !0, children: _ })
    ] }) }),
    /* @__PURE__ */ A(
      N,
      {
        className: $("overflow-y-auto overflow-x-hidden text-sm select-none relative"),
        style: U4,
        onPointerDown: y,
        onPointerMove: w,
        onPointerUp: S,
        grow: !0,
        children: [
          !!t && /* @__PURE__ */ c(S0, { component: t, level: -1, draggingCmp: d, dragParent: f }),
          C && /* @__PURE__ */ c("div", { ref: v, className: $("absolute w-full gs-utl-h-0.5", z.cmp), style: P })
        ]
      }
    )
  ] });
}), C0 = Rt(function({ children: t, className: n, ...r }, o) {
  return /* @__PURE__ */ c("div", { className: q(F("gs-layer-manager-after"), n), ref: o, ...r, children: t });
}), P0 = Rt(function({ children: t, className: n, ...r }, o) {
  return /* @__PURE__ */ c("div", { className: q(F("gs-layer-manager-before"), n), ref: o, ...r, children: t });
}), G4 = "gs-panel-layers", E0 = we(
  ue(function({ className: t, ...n }) {
    const r = ye().sdkProps.children;
    return /* @__PURE__ */ c(
      zn,
      {
        className: q(G4, "gs-utl-overflow-auto", t),
        classNameAccordion: q("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        classNameAccordionContent: q("gs-utl-overflow-auto"),
        ...n,
        children: /* @__PURE__ */ c(ib, { children: (o) => /* @__PURE__ */ A(ae, { children: [
          qt(r, P0),
          /* @__PURE__ */ c(x0, { ...o, header: !1 }),
          qt(r, C0)
        ] }) })
      }
    );
  })
), O0 = H.forwardRef(function({ size: t = "m", className: n, border: r = !0, children: o, ...s }, i) {
  const a = F(
    z.bg,
    z.br,
    r && `${se.b} ${se.rnd}`,
    t === "m" && Re.xy,
    t === "s" && "gjs-px-3 gjs-py-1",
    n
  );
  return /* @__PURE__ */ c(I, { className: a, items: "center", space: "x2s", ...s, ref: i, children: /* @__PURE__ */ c(N, { grow: !0, children: o }) });
}), K4 = "gs-field-textarea";
function Xg(e) {
  const { className: t, value: n, label: r, size: o, description: s, placeholder: i, readOnly: a, disabled: l, required: u, onChange: d } = e, p = Up(e);
  return /* @__PURE__ */ A("div", { className: $(K4, t), children: [
    !!r && /* @__PURE__ */ c($t, { size: o, children: r }),
    !!s && /* @__PURE__ */ c($t, { size: o, as: "span", className: $(z.txtLowEmphasis), capitalize: !1, children: s }),
    /* @__PURE__ */ c(O0, { size: o, children: /* @__PURE__ */ c(
      "textarea",
      {
        className: $(p),
        value: n,
        placeholder: i,
        readOnly: a,
        disabled: l,
        required: u,
        onChange: (f) => d == null ? void 0 : d(f.target.value)
      }
    ) })
  ] });
}
const xc = "gs-page-settings", q4 = `${xc}-header`, Y4 = `${xc}-content`, X4 = `${xc}-footer`, Zg = "", _0 = ue(function({
  className: t,
  classNameHeader: n,
  classNameContent: r,
  classNameFooter: o,
  page: s,
  size: i = ic.m
}) {
  const a = ye(), { isDarkTheme: l } = cn(), u = Ne(), [d, p] = W(s), [f, h] = W(() => yh(d, a)), [g, m] = W(() => u.t("update")), v = u.tScoped("pageManager.settings"), b = u.tScoped("pageManager.settings.fields"), y = a.editor, w = {
    containerClassName: F("min-h-80"),
    size: i,
    padding: 5,
    isDarkTheme: l,
    clean: !0
  }, S = (T) => h((R) => ({ ...R, ...T })), x = (T) => {
    T.preventDefault();
    const { name: R, ...B } = f;
    B.customCodeHead = oS(B.customCodeHead), B.customCodeBody = rS(B.customCodeBody), d ? (S5(d, B), d.setName(R)) : a.setProjectDataCustom({
      globalPageSettings: B
    }), m(u.t("updated")), setTimeout(() => m(u.t("update")), 2e3), Ov(y), y.trigger(_r.pageSettingsUpdate, { page: d, data: { name: R, ...B } });
  }, C = { tooltip: u.t("clear") }, P = (d == null ? void 0 : d.getId()) ?? Zg, _ = (T) => {
    const R = y.Pages.get(T);
    p(R), h(yh(R, a));
  }, O = w5(d), E = [
    {
      id: Zg,
      label: v("global")
    },
    ...y.Pages.getAll().map((T) => ({
      id: T.getId(),
      label: T.getName()
    }))
  ];
  return /* @__PURE__ */ c("form", { onSubmit: x, className: F(xc, "h-full", t), children: /* @__PURE__ */ A(I, { col: !0, full: !0, className: F("gap-1 gs-utl-overflow-hidden"), nowrap: !0, children: [
    /* @__PURE__ */ c(N, { className: F(q4, n, z.br, se.bb), children: /* @__PURE__ */ c(
      Ae,
      {
        value: P,
        onChange: _,
        options: E,
        handlerSelected: (T) => /* @__PURE__ */ A(ae, { children: [
          /* @__PURE__ */ c("b", { children: u.t("pageManager.page") }),
          ": ",
          T.label
        ] })
      }
    ) }),
    /* @__PURE__ */ A(I, { col: !0, className: F(Y4, "gap-5 overflow-y-auto", r), nowrap: !0, children: [
      !!P && /* @__PURE__ */ A(ae, { children: [
        /* @__PURE__ */ c(
          ft,
          {
            size: i,
            value: f.name,
            onChange: (T) => S({ name: T }),
            label: b("name.label"),
            description: b("name.description"),
            required: !0
          }
        ),
        !O && /* @__PURE__ */ c(
          ft,
          {
            size: i,
            value: f.slug,
            onChange: (T) => S({ slug: Kd(T) }),
            label: b("slug.label"),
            description: b("slug.description"),
            required: !0
          }
        )
      ] }),
      /* @__PURE__ */ c(
        ft,
        {
          size: i,
          value: f.title,
          onChange: (T) => S({ title: T }),
          label: b("title.label"),
          description: b("title.description")
        }
      ),
      /* @__PURE__ */ c(
        Xg,
        {
          size: i,
          value: f.description,
          onChange: (T) => S({ description: T }),
          label: b("description.label"),
          description: b("description.description")
        }
      ),
      /* @__PURE__ */ c(
        ki,
        {
          size: i,
          clear: C,
          value: f.favicon,
          onChange: (T) => S({ favicon: T }),
          onOpen: () => {
            y.Assets.open({
              select(T) {
                S({ favicon: T.getSrc() }), y.Assets.close();
              }
            });
          },
          label: b("favicon.label"),
          description: b("favicon.description")
        }
      ),
      /* @__PURE__ */ c(
        ft,
        {
          size: i,
          value: f.keywords,
          onChange: (T) => S({ keywords: T }),
          label: b("keywords.label"),
          description: b("keywords.description")
        }
      ),
      /* @__PURE__ */ c(
        ft,
        {
          size: i,
          value: f.socialTitle,
          onChange: (T) => S({ socialTitle: T }),
          label: b("socialTitle.label"),
          description: b("socialTitle.description")
        }
      ),
      /* @__PURE__ */ c(
        ki,
        {
          size: i,
          clear: C,
          value: f.socialImage,
          onChange: (T) => S({ socialImage: T }),
          onOpen: () => {
            y.Assets.open({
              select(T) {
                S({ socialImage: T.getSrc() }), y.Assets.close();
              }
            });
          },
          label: b("socialImage.label"),
          description: b("socialImage.description")
        }
      ),
      /* @__PURE__ */ c(
        Xg,
        {
          size: i,
          value: f.socialDescription,
          onChange: (T) => S({ socialDescription: T }),
          label: b("socialDescription.label"),
          description: b("socialDescription.description")
        }
      ),
      /* @__PURE__ */ c(
        Jr,
        {
          language: "html",
          value: f.customCodeHead,
          onChange: (T) => S({ customCodeHead: T }),
          label: b("customCodeHead.label"),
          description: b("customCodeHead.description"),
          ...w
        },
        `head-${P}`
      ),
      /* @__PURE__ */ c(
        Jr,
        {
          language: "html",
          value: f.customCodeBody,
          onChange: (T) => S({ customCodeBody: T }),
          label: b("customCodeBody.label"),
          description: b("customCodeBody.description"),
          ...w
        },
        `body-${P}`
      )
    ] }),
    /* @__PURE__ */ c(I, { className: F(X4, "mt-auto", o, z.br, se.bt), children: /* @__PURE__ */ c(Ze, { type: "submit", variant: "pr", size: "m2", full: !0, children: g }) })
  ] }) });
}), Z4 = "gs-panel-page-settings", J4 = we(
  ue(function({ className: t, page: n, ...r }) {
    return /* @__PURE__ */ c(
      zn,
      {
        className: q(Z4, "gs-utl-overflow-hidden", t),
        classNameAccordion: q("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        classNameAccordionContent: q("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        ...r,
        children: /* @__PURE__ */ c(Mo, { children: /* @__PURE__ */ c(
          _0,
          {
            className: q("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
            page: n,
            size: ic.s,
            classNameHeader: Re.s,
            classNameContent: Re.s,
            classNameFooter: Re.s
          }
        ) })
      }
    );
  })
), Eu = "gs-page-item", Jg = ue(function({ page: t, rename: n, setRename: r, commandItems: o }) {
  const s = ye(), i = Ne(), a = s.editor, { Pages: l } = a, { sdkPagesConfig: u } = s, d = u == null ? void 0 : u.settings, p = (w) => i.t(`pageManager.${w}`), f = (w) => l.select(w), h = (w) => l.getSelected() === w, g = (w) => w === n, m = (w) => w.getName() || w.getId(), v = (w) => {
    n == null || n.set({ name: w }), r(void 0);
  }, b = F("group-hover:gs-utl-opacity-100 opacity-0 cursor-pointer transition-opacity"), y = () => a.runCommand(me.setPageSettings, { page: t, isOpen: !0 });
  return /* @__PURE__ */ A(
    I,
    {
      space: "s",
      items: "center",
      onClick: () => f(t),
      className: F([
        Eu,
        "group cursor-default",
        Re.xy,
        h(t) && z.bgH,
        !h(t) && z.hBgH2
      ]),
      children: [
        /* @__PURE__ */ c(N, { className: F(`${Eu}__name truncate`), grow: !0, children: g(t) ? /* @__PURE__ */ c(df, { value: m(t), onChange: v }) : /* @__PURE__ */ c(ae, { children: m(t) }) }),
        /* @__PURE__ */ A(I, { className: `${Eu}__actions`, space: "xs", onClick: ds, items: "center", children: [
          !n && d !== !1 && /* @__PURE__ */ c(
            Ft,
            {
              className: b,
              size: "xs",
              border: !1,
              title: p("settings.label"),
              onClick: y,
              block: !0,
              children: /* @__PURE__ */ c(oe, { icon: ne.cog, size: pe.s3x })
            }
          ),
          h(t) && !!o.length && /* @__PURE__ */ c(
            Rr,
            {
              placement: "right-start",
              handler: /* @__PURE__ */ c(oe, { icon: ne.dotsVertical, size: pe.s }),
              title: !1,
              padding: !1,
              fixed: !0,
              overlay: !0,
              children: ({ close: w }) => o.map((S) => /* @__PURE__ */ c(
                ec,
                {
                  label: ct(S.label) ? S.label({ editor: a }) : S.label,
                  action: () => {
                    var x;
                    w(), (x = S.cmd) == null || x.call(S, { page: t, editor: a });
                  }
                },
                S.id
              ))
            }
          )
        ] })
      ]
    },
    t.getId()
  );
});
function Q4({ dragging: e, dragRect: t }) {
  const n = !!(e && t), r = n ? { top: t.y, left: 0, marginLeft: 0 } : {};
  return {
    showIndicator: n,
    indicatorStyle: r
  };
}
var T0 = /* @__PURE__ */ ((e) => (e.horizontal = "horizontal", e.vertical = "vertical", e))(T0 || {});
const Ou = "gs-cmp-sortable", eR = ({ items: e, direction: t, onDrop: n, renderItem: r }) => {
  const [o, s] = W(null), [i, a] = W(-1), [l, u] = W(), d = K(null), { showIndicator: p, indicatorStyle: f } = Q4({ dragging: !!o, dragRect: l }), h = ie(() => [], [e]);
  G(() => {
    const x = window.document, C = (P) => P.key === "Escape" && v(P);
    return x.addEventListener("keydown", C), () => x.removeEventListener("keydown", C);
  }, []);
  const g = (x) => (C) => {
    C.button === 0 && (d.current = { x: C.clientX, y: C.clientY }, s(x), C.target.setPointerCapture(C.pointerId));
  }, m = (x) => {
    if (!o || !d.current)
      return;
    const C = x.clientY;
    let P = -1;
    h.forEach((E, T) => {
      const R = E.getBoundingClientRect();
      C > R.top + R.height / 2 && (P = T);
    });
    const _ = e.findIndex((E) => E.id === o.id);
    P < _ && (P += 1), P = Math.min(P, e.length - 1), a(P);
    const O = h[P];
    if (O) {
      const { height: E, top: T } = O.getBoundingClientRect(), R = C < T + E / 2;
      u({
        y: O.offsetTop + (R ? 0 : E),
        h: E
      });
    }
  }, v = (x) => {
    s(null), d.current = null, u(void 0);
    const C = x.target, { pointerId: P } = x;
    P && (C == null || C.releasePointerCapture(P));
  }, b = (x) => {
    !o || !d.current || (l && i !== -1 && (n == null || n(o, i)), v(x));
  }, y = q(Ou, "gs-utl-relative"), w = q(`${Ou}__indicator`, z.cmp, "gs-utl-absolute gs-utl-w-full gs-utl-h-0.5"), S = (x) => q(`${Ou}__item`, p && (o == null ? void 0 : o.id) === x.id && "gs-utl-opacity-50 gs-utl-select-none");
  return /* @__PURE__ */ A(ae, { children: [
    /* @__PURE__ */ c(I, { col: t === "vertical", className: y, children: e.map((x, C) => /* @__PURE__ */ c(
      N,
      {
        ref: (P) => {
          P && (h[C] = P);
        },
        className: S(x),
        onPointerDown: g(x),
        onPointerMove: m,
        onPointerUp: b,
        children: r(x)
      },
      x.id
    )) }),
    p && /* @__PURE__ */ c("div", { className: w, style: f })
  ] });
}, tR = ({ pages: e, commandItems: t, rename: n, setRename: r, editor: o }) => {
  if (!o.Pages.move)
    return e.map((l) => /* @__PURE__ */ c(Jg, { page: l, commandItems: t, rename: n, setRename: r }, l.getId()));
  const s = (l, u) => {
    o.Pages.move(l.entity, { at: u });
  }, i = (l) => /* @__PURE__ */ c(Jg, { page: l.entity, commandItems: t, rename: n, setRename: r }, l.id), a = e.map((l) => ({
    id: l.getId(),
    entity: l
  }));
  return /* @__PURE__ */ c(eR, { items: a, direction: T0.vertical, onDrop: s, renderItem: i });
}, nR = ({
  items: e,
  editor: t,
  sdkPageConfig: n
}) => {
  const r = n == null ? void 0 : n.commandItems;
  return r === !1 ? [] : ct(r) ? r({ items: e, editor: t }) : r || e;
}, _u = "gs-panel-page-manager", A0 = ue(function({
  pages: t,
  select: n,
  add: r,
  remove: o,
  header: s,
  resizable: i = { bottom: !0 },
  height: a = 200
}) {
  const l = ye(), u = Bn(), d = Ne(), { sdkPagesConfig: p } = l, f = l.editor, [h, g] = W(), m = (R) => d.t(`pageManager.${R}`), v = p == null ? void 0 : p.add, b = p == null ? void 0 : p.duplicate, y = p == null ? void 0 : p.remove, w = (R) => {
    if (ds(R), v)
      return v({ editor: f, rename: g });
    const B = t.length + 1, U = r(
      {
        name: `${m("page")} ${B}`,
        component: `<div>${m("newPage")} ${B}</div>`
      },
      { select: !0 }
    );
    U && g(U);
  }, S = ({ page: R }) => {
    if (y)
      return y({ editor: f, page: R });
    u.confirm({
      title: m("deletePage"),
      content: m("confirmDelete"),
      confirmButton: { variant: "danger", children: m("deletePage") },
      onConfirm: () => {
        const B = t.indexOf(R), U = t[B + 1] || t[0];
        n(U), o(R);
      }
    });
  }, x = ({ page: R }) => {
    if (b)
      return b({ editor: f, page: R, rename: g });
    const B = R.getMainComponent(), U = r(
      {
        name: `${R.getName()} (${m("copy")})`,
        component: B.clone()
      },
      { select: !0 }
    );
    U && g(U);
  }, C = [
    { id: "rename", label: m("rename"), cmd: ({ page: R }) => g(R) },
    b !== !1 && { id: "duplicate", label: m("duplicate"), cmd: x },
    t.length > 1 && y !== !1 && { id: "remove", label: m("delete"), cmd: S }
  ].filter(Boolean), P = nR({ items: C, editor: f, sdkPageConfig: p }), _ = h0(s, {
    collapsible: !0,
    label: m("pages"),
    icon: ne.textBoxMultiple
  }), O = i ? i === !0 ? {
    top: !0,
    right: !0,
    bottom: !0,
    left: !0
  } : i : void 0, E = /* @__PURE__ */ c(tR, { pages: t, commandItems: P, rename: h, setRename: g, editor: f }), T = O ? /* @__PURE__ */ c(
    wc,
    {
      className: $([`${_u}__content`, "text-sm overflow-auto", se.bt, z.br]),
      height: a,
      ...O,
      children: E
    }
  ) : E;
  return /* @__PURE__ */ c(
    $o,
    {
      classNameWrap: _u,
      className: $(`${_u}__header`, Re.xy, s === !1 && "gs-utl-hidden"),
      disabled: _ && _.collapsible === !1,
      handler: /* @__PURE__ */ A(I, { space: "s", items: "center", children: [
        !!_.icon && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(oe, { icon: _.icon, size: pe.s }) }),
        /* @__PURE__ */ c(N, { grow: !0, children: _.label }),
        v !== !1 && /* @__PURE__ */ c(yt, { title: m("add"), children: /* @__PURE__ */ c(I, { onClick: w, className: $("cursor-pointer"), children: /* @__PURE__ */ c(oe, { icon: ne.plus, size: pe.s }) }) })
      ] }),
      open: _ ? _.collapsed !== !0 : !0,
      children: T
    }
  );
}), L0 = Rt(function({ children: t, className: n, ...r }, o) {
  return /* @__PURE__ */ c("div", { className: q(F("gs-page-manager-after"), n), ref: o, ...r, children: t });
}), k0 = Rt(function({ children: t, className: n, ...r }, o) {
  return /* @__PURE__ */ c("div", { className: q(F("gs-page-manager-before"), n), ref: o, ...r, children: t });
}), rR = "gs-panel-pages", M0 = we(
  ue(function({ className: t, header: n, height: r, resizable: o, ...s }) {
    const i = ye().sdkProps.children;
    return /* @__PURE__ */ c(No, { className: q(rR, t), ...s, children: /* @__PURE__ */ c(ab, { children: (a) => /* @__PURE__ */ A(ae, { children: [
      qt(i, k0),
      /* @__PURE__ */ c(A0, { header: n, height: r, resizable: o, ...a }),
      qt(i, L0)
    ] }) }) });
  })
), oR = "gs-panel-pages-layers", sR = we(
  ue(function({
    className: t,
    panelPagesProps: n,
    panelLayersProps: r,
    ...o
  }) {
    const { showPages: s } = ye(), i = Ne(), { className: a, ...l } = n || {}, u = h0(r == null ? void 0 : r.header, {
      icon: ne.layers,
      collapsible: !1,
      label: i.t("layerManager.layers"),
      className: q(se.bb, z.br)
    });
    return /* @__PURE__ */ A(zn, { className: q(oR, "gs-utl-flex gs-utl-flex-col gs-utl-h-full", t), ...o, children: [
      s && /* @__PURE__ */ c(M0, { className: q(a, se.bb, z.br), ...l }),
      /* @__PURE__ */ c(E0, { ...r, header: u })
    ] });
  })
), iR = "gs-trait-custom", aR = ue(function({ trait: t, editor: n }) {
  const [, r] = W(0), o = K(null), s = t.get("component"), i = t.get("render"), a = t.target, l = o.current;
  return G(() => {
    if (a) {
      let u = () => {
      }, d = () => {
      };
      const p = () => {
        d(), r((f) => ++f);
      };
      if (a.on("change", p), !s && i && l) {
        const f = (m) => l.appendChild(m), h = (m) => l.removeChild(m), g = i({
          editor: n,
          component: a,
          trait: t,
          addEl: f,
          removeEl: h,
          onUpdate: (m) => {
            d = m;
          }
        });
        g instanceof HTMLElement ? (f(g), u = () => h(g)) : ct(g) && (u = () => g());
      }
      return () => {
        a.off("change", p), u();
      };
    }
  }, [a, l]), a ? s ? /* @__PURE__ */ c(s, { trait: t, component: a, editor: n }) : i ? /* @__PURE__ */ c("div", { className: iR, ref: o }) : null : null;
});
function $0({
  className: e,
  options: t,
  value: n,
  name: r,
  label: o,
  border: s,
  hideCaret: i,
  size: a = "s",
  autoFocus: l,
  open: u,
  allowNew: d,
  onChange: p,
  onBlur: f,
  placeholder: h
}) {
  const [g, m] = W(null), [v, b] = W(null), { styles: y, attributes: w } = Ts(g, v, jp), [S, x] = W(""), C = Up(), P = S === "" ? t : t.filter((U) => U.label.toLowerCase().includes(S.toLowerCase())), _ = (U) => x(U.target.value), O = (U) => U == null ? void 0 : U.label, E = d && S.length > 0 && !P.some((U) => U.label === S), T = ct(d) ? d(S) : d, R = {
    minWidth: `${g == null ? void 0 : g.offsetWidth}px`,
    maxHeight: 200
  }, B = () => f == null ? void 0 : f();
  return /* @__PURE__ */ A("div", { className: $("w-full", e), children: [
    !!o && /* @__PURE__ */ c($t, { size: a, children: o }),
    /* @__PURE__ */ A(zo, { value: n, onChange: p, name: r, nullable: !0, children: [
      /* @__PURE__ */ c(O0, { size: a, ref: m, border: s, children: /* @__PURE__ */ A(I, { nowrap: !0, children: [
        /* @__PURE__ */ c(
          zo.Input,
          {
            autoFocus: l,
            className: C,
            displayValue: O,
            onChange: _,
            onBlur: B,
            placeholder: h
          }
        ),
        !i && /* @__PURE__ */ c(zo.Button, { children: /* @__PURE__ */ c(oe, { icon: ne.chevronDown, size: pe.sx }) })
      ] }) }),
      /* @__PURE__ */ c(
        zo.Options,
        {
          static: u,
          className: wv,
          ref: b,
          style: y.popper,
          ...w.popper,
          children: /* @__PURE__ */ A(Jt, { className: $("h-full"), padding: !1, style: R, children: [
            E && /* @__PURE__ */ c(zo.Option, { value: { id: null, label: S }, children: ({ active: U }) => /* @__PURE__ */ c(fh, { option: { id: null, label: T }, active: U, selected: n }) }),
            !E && P.length === 0 && /* @__PURE__ */ c("div", { className: $(Re.xy), children: "No items found" }),
            P.map((U) => /* @__PURE__ */ c(zo.Option, { value: U, children: ({ active: L }) => /* @__PURE__ */ c(fh, { option: U, active: L, selected: n }) }, U.id))
          ] })
        }
      )
    ] })
  ] });
}
const lR = "page://", R0 = "#", Qa = "mailto:", Tu = "subject=", Ld = "tel:", Qg = (e) => e.startsWith(Ld) ? "phone" : e.startsWith(Qa) ? "email" : e.startsWith(lR) ? "pages" : e.startsWith(R0) ? "elements" : "url", em = (e) => `${e.getName()} - #${e.getId()}`, cR = ue(function({ trait: t }) {
  const n = t.getValue(), r = ye(), { isSelectingTarget: o } = r, [, s] = W(0), [i, a] = W(() => Qg(n)), [l, u] = W(""), [d, p] = W(""), [f, h] = W(""), [g, m] = W(!0), [v, b] = W([]), y = Tn(), w = Ne(), S = y.Pages.getAll(), x = w.tScoped("traitManager.traits.labels"), C = () => s((M) => ++M), P = (M) => {
    t.setValue(M);
  }, _ = (M) => {
    a(M), u(""), p(""), h(""), P("");
  }, O = (M) => {
    P(M), C();
  }, E = (M) => {
    M && (P(M.id), C());
  }, T = (M) => {
    P(`${Ld}${M}`), h(M);
  }, R = (M) => {
    P(`${Qa}${M}${d ? `?${Tu}${d}` : ""}`), u(M);
  }, B = (M) => {
    P(`${Qa}${l}${M ? `?${Tu}${M}` : ""}`), p(M);
  }, U = () => {
    r.setSelectingTarget(!o);
  }, L = (M) => {
    const D = M.replace(R0, ""), V = y.Components.componentsById[D];
    return {
      id: M,
      label: V ? em(V) : M
    };
  };
  return G(() => {
    var D;
    const M = [];
    if (g) {
      const V = ["path", "br", "b", "u", "i", "strike"], k = (D = y.Pages.getSelected()) == null ? void 0 : D.getMainComponent();
      k == null || k.forEachChild((j) => {
        !j.is("comment") && !j.is("textnode") && !V.includes(j.get("tagName")) && M.push({ id: `#${j.getId()}`, label: em(j) });
      });
    }
    b(M);
  }, [g]), G(() => {
    let M = () => {
    };
    const D = () => {
      M(), y.stopCommand(gl);
    };
    return o && (M = Qw(D), y.runCommand(gl, {
      onSelect: (V) => P(`#${V.getId()}`)
    })), D;
  }, [o]), G(() => {
    if (!n)
      return;
    const M = Qg(n);
    switch (M) {
      case "phone":
        h(n.replace(Ld, ""));
        break;
      case "email": {
        const [D, V = ""] = n.replace(Qa, "").split("?");
        u(D), p(V.replace(Tu, ""));
        break;
      }
    }
    a(M);
  }, [n]), /* @__PURE__ */ c(
    Ro,
    {
      onChange: _,
      classNamePanel: $("gjs-p-1"),
      value: i,
      tabs: [
        {
          id: "url",
          label: /* @__PURE__ */ c(oe, { icon: ne.link, size: pe.s }),
          content: /* @__PURE__ */ c(
            ft,
            {
              placeholder: "eg. https://google.com",
              value: n,
              label: "URL",
              onChange: P,
              size: "s",
              type: "url"
            }
          )
        },
        {
          id: "pages",
          label: /* @__PURE__ */ c(oe, { icon: ne.textBoxMultiple, size: pe.s }),
          content: /* @__PURE__ */ c(
            Ae,
            {
              size: "s",
              options: S.map((M) => ({ id: `page://${M.getId()}`, label: M.getName() })),
              value: n,
              onChange: O,
              label: "Page"
            }
          )
        },
        {
          id: "elements",
          label: /* @__PURE__ */ c(oe, { icon: ne.viewDayOutline, size: pe.s }),
          content: /* @__PURE__ */ A(I, { space: "s", col: !0, children: [
            /* @__PURE__ */ c($t, { size: "s", children: "Element ID" }),
            /* @__PURE__ */ A(I, { space: "xs", nowrap: !0, children: [
              g ? /* @__PURE__ */ c(
                $0,
                {
                  options: v,
                  onChange: E,
                  value: L(n),
                  placeholder: w.t("selectList")
                }
              ) : /* @__PURE__ */ c(
                ft,
                {
                  size: "s",
                  placeholder: "eg. #my-element-in-page",
                  value: n,
                  onChange: P,
                  className: $("flex-1")
                }
              ),
              /* @__PURE__ */ c(
                Ft,
                {
                  title: w.t("selectTarget"),
                  size: "m2",
                  active: o,
                  onClick: U,
                  className: $("h-7"),
                  children: /* @__PURE__ */ c(oe, { icon: ne.target, size: pe.sx })
                }
              )
            ] }),
            /* @__PURE__ */ c(yl, { value: g, onChange: m, label: x("showList") })
          ] })
        },
        {
          id: "email",
          label: /* @__PURE__ */ c(oe, { icon: ne.email, size: pe.s }),
          content: /* @__PURE__ */ A(I, { space: "s", col: !0, children: [
            /* @__PURE__ */ c(
              ft,
              {
                placeholder: "eg. mail@gmail.com",
                value: l,
                onChange: R,
                size: "s",
                label: "Email",
                type: "email"
              }
            ),
            /* @__PURE__ */ c(
              ft,
              {
                placeholder: "eg. My subject",
                value: d,
                onChange: B,
                label: "Subject",
                size: "s"
              }
            )
          ] })
        },
        {
          id: "phone",
          label: /* @__PURE__ */ c(oe, { icon: ne.phone, size: pe.s }),
          content: /* @__PURE__ */ c(
            ft,
            {
              size: "s",
              type: "tel",
              label: "Phone",
              placeholder: "eg. +55123456789",
              value: f,
              onChange: T
            }
          )
        }
      ]
    },
    i
  );
});
function uR({ trait: e }) {
  const [t, n] = W(), r = e.get("properties"), o = e.get("addItem"), s = e.get("labelItem"), i = e.getValue(), a = i.findIndex((l) => l.id === (t == null ? void 0 : t.id));
  return /* @__PURE__ */ c(
    gr,
    {
      items: i,
      selected: a > -1 ? t : null,
      add: () => {
        const l = i.length + 1, u = o ? o(l) : { id: `opt${l}`, label: `New option ${l}` };
        e.setValue([...i, u]);
      },
      select: n,
      move: (l, u) => {
        const d = e.getValue().filter((p) => p.id !== l.id);
        d.splice(u, 0, l), e.setValue(d);
      },
      remove: (l) => {
        const u = e.getValue().filter((d) => d.id !== l.id);
        e.setValue(u, { removed: l });
      },
      label: e.getLabel({ locale: !0 }),
      renderItem: (l) => s ? s(l) : l.label,
      children: /* @__PURE__ */ c(I, { space: "m", col: !0, children: !!t && r.map((l) => {
        const { name: u, getValue: d } = l, p = l.setValue, f = l.label || u, h = i[a];
        if (!h)
          return null;
        const g = h[u], m = d ? d(g) : g, v = (y) => {
          const w = { ...h };
          h[u] = p ? p(y, m) : y, e.setValue([...i], { item: h, previous: w }), u === "id" && n(h);
        };
        let b = /* @__PURE__ */ c(ft, { label: f, value: m, onChange: v });
        switch (l.type) {
          case "select":
            b = /* @__PURE__ */ c(Ae, { label: f, options: l.options, value: m, onChange: v });
        }
        return /* @__PURE__ */ c(wt, { children: b }, u);
      }) })
    }
  );
}
const dR = "gs-trait-custom-type", pR = ue(function({ trait: t, editor: n }) {
  const r = K(null), o = t.getType(), s = t.target, { Traits: i } = n, a = i.getType(o), l = !!(s && a), u = r.current;
  return G(() => {
    if (a && u && s) {
      const d = new a({
        model: t,
        config: i.getConfig(),
        attributes: t.get("attributes")
      }), p = d.render().el;
      return u.appendChild(p), d.listenTo(s, "change", () => d.postUpdate()), () => {
        u.removeChild(p), d.removeView();
      };
    }
  }, [u]), l && /* @__PURE__ */ c("div", { className: dR, ref: r });
}), Cc = (e) => yr((e || "").replace(/-/g, " ")), N0 = (e) => ({
  size: "s",
  tip: e.get("tip")
}), os = (e, t) => ({
  ...N0(e),
  type: e.getType(),
  value: e.getValue(),
  label: e.get("label") !== !1 && Cc(e.getLabel({ locale: !0 })),
  placeholder: (t == null ? void 0 : t.t(`traitManager.traits.attributes.${e.getId()}.placeholder`)) || e.get("placeholder") || "",
  onChange: (n, r) => e.setValue(n, { partial: r })
}), tm = (e) => {
  const t = e.get("labelToTitle");
  return {
    ...os(e),
    options: e.getOptions().map((n) => {
      const r = n.labelReact || n.name || n.label || n.value;
      return Mt(n) ? { id: n, label: n } : {
        id: n.id || n.value,
        title: t ? r : n.title,
        icon: n.icon,
        label: t ? "" : r
      };
    }),
    onChange: (n) => e.setValue(n)
  };
}, fR = (e) => ({
  ...os(e),
  min: e.get("min"),
  max: e.get("max"),
  step: e.get("step"),
  units: e.get("units"),
  onChange: (t, n) => {
    e.setValue(n ? t : parseFloat(t), { partial: n });
  }
}), hR = (e) => ({
  children: Cc(e.getLabel() || e.get("text") || e.get("labelButton")),
  onClick: () => {
    const t = e.em.Editor, n = e.get("command");
    Mt(n) ? t.runCommand(n) : n == null || n(t, e);
  },
  full: !0
}), gR = (e) => ({
  ...N0(e),
  value: !!e.getValue({ useType: !0 }),
  label: Cc(e.getLabel()),
  onChange: (t) => e.setValue(t)
}), mR = (e) => ({
  language: "css",
  ...e.get("typeProps") || {},
  value: e.getValue(),
  label: Cc(e.getLabel()),
  onChange: (n) => e.setValue(n)
}), vR = (e, t) => {
  const n = e.get("typeProps") || {};
  return {
    ...os(e, t),
    isContain: !0,
    onOpen() {
      const r = t == null ? void 0 : t.Assets;
      r == null || r.open({
        select(o) {
          e.setValue(o.getSrc()), r.close();
        }
      });
    },
    btnLabel: e.get("text"),
    ...n
  };
};
function bR(e, t, n = {}) {
  var s;
  const r = e.get("visible"), o = e.getType();
  if (ct(r) && r({ component: e.target, trait: e }) === !1)
    return null;
  switch (o) {
    case "text":
      return /* @__PURE__ */ c(ft, { ...os(e, t) });
    case "select":
      return /* @__PURE__ */ c(Ae, { ...tm(e) });
    case "number":
      return /* @__PURE__ */ c(Me, { ...fR(e) });
    case "checkbox":
      return /* @__PURE__ */ c(yl, { ...gR(e) });
    case "color":
      return /* @__PURE__ */ c(Lr, { ...os(e) });
    case "button":
      return /* @__PURE__ */ c(Ze, { ...hR(e) });
    case "radio":
      return /* @__PURE__ */ c(Bt, { ...tm(e) });
    case "code":
      return /* @__PURE__ */ c(Jr, { ...mR(e), ...n }, ((s = t == null ? void 0 : t.getSelected()) == null ? void 0 : s.getId()) || "");
    case "image":
    case "file":
      return /* @__PURE__ */ c(ki, { ...vR(e, t) });
    case "stack":
      return /* @__PURE__ */ c(uR, { trait: e });
    case "href":
      return /* @__PURE__ */ c(cR, { trait: e });
    case "custom":
      return /* @__PURE__ */ c(aR, { editor: t, trait: e });
    default:
      return !!t.Traits.getType(o) ? /* @__PURE__ */ c(pR, { editor: t, trait: e }) : /* @__PURE__ */ c(ft, { ...os(e, t) });
  }
}
const kd = "gs-trait-manager", nm = ({ trait: e, isDarkTheme: t }) => /* @__PURE__ */ c(N, { className: $(`${kd}-field gs-utl-mb-2 gs-utl-w-full`), children: bR(e, e.em.getEditor(), { isDarkTheme: t }) });
function yR({ traits: e, className: t }) {
  var l;
  const n = Tn(), { isDarkTheme: r } = cn(), o = n.Traits.getTraitsByCategory(e), s = (l = o.find((u) => !u.category)) == null ? void 0 : l.items, i = o.filter((u) => u.category), a = $("gs-utl-text-center");
  return /* @__PURE__ */ c(I, { className: $(kd, t), col: !0, children: n.getSelected() ? e.length ? /* @__PURE__ */ A(ae, { children: [
    s == null ? void 0 : s.map((u) => /* @__PURE__ */ c(nm, { trait: u, isDarkTheme: r }, u.id)),
    i.map(({ category: u, items: d }, p) => /* @__PURE__ */ c(
      $o,
      {
        open: !!(u != null && u.get("open")),
        onChange: ({ open: f }) => u == null ? void 0 : u.set({ open: f }),
        handler: u == null ? void 0 : u.getLabel(),
        handlerIcon: u == null ? void 0 : u.get("icon"),
        classNameContent: "gs-utl-p-2",
        classNameWrap: `${kd}-category -gs-utl-mx-2`,
        className: (f) => $(
          Qd.itemList({
            index: p + (s ? 1 : 0),
            open: f,
            length: i.length
          })
        ),
        children: d.map((f) => /* @__PURE__ */ c(nm, { trait: f, isDarkTheme: r }, f.id))
      },
      u == null ? void 0 : u.id
    ))
  ] }) : /* @__PURE__ */ c(N, { className: a, children: "No properties available" }) : /* @__PURE__ */ c(N, { className: a, children: n.t("traitManager.empty") }) });
}
const Md = ue(yR), wR = "gs-panel-properties", SR = we(
  ue(function({ className: t, ...n }) {
    return /* @__PURE__ */ c(
      zn,
      {
        className: q(wR, "gs-utl-overflow-auto gs-utl-h-full", t),
        classNameAccordion: q("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        classNameAccordionContent: q("gs-utl-overflow-auto"),
        ...n,
        children: /* @__PURE__ */ c(hd, { children: (r) => /* @__PURE__ */ c(Md, { ...r }) })
      }
    );
  })
), xR = async ({ html: e = "", css: t = "", el: n }) => {
  const r = `<span style="color: initial; display: inline-block;"><style> body { margin: 0; } ${t}</style>${e}</span>`, o = {};
  if (document.body.attachShadow) {
    const s = n.shadowRoot || n.attachShadow({ mode: "open" });
    s.innerHTML = r;
  }
  return o;
}, CR = ue(function({ rule: t, onSelect: n, onRemove: r, className: o }) {
  const s = K(null), a = ye().editor, l = Ne(), u = t.getDevice(), d = t.getState(), { isDarkTheme: p } = cn(), [f, h] = W(t.toCSS({ allowEmpty: !0 })), [g, m] = W(f), v = t.selectorsToString(), b = () => {
    a.select(), setTimeout(() => a.Selectors.select(t)), n == null || n();
  }, y = () => {
    a.Css.remove(t), r == null || r();
  }, w = () => {
    if (g) {
      const S = a.Parser.parseCss(g)[0];
      S && (t.setStyle(S.style), h(g));
    }
  };
  return G(() => {
    if (s.current) {
      const S = s.current;
      xR({
        el: S,
        html: '<div class="prv-rule">Preview</div>',
        css: `
        .prv-rule {
          background-color: #fff;
          padding: 5px;
        }
        .prv-rule, ${f}
        `
      });
    }
  }, [s, f]), /* @__PURE__ */ c(Jt, { padding: !1, className: F("overflow-hidden max-w-full group", o), children: /* @__PURE__ */ A(I, { col: !0, space: "xs", children: [
    /* @__PURE__ */ c(I, { className: F("bg-checker gjs-p-3 overflow-auto overflow-x-hidden h-20"), justify: "center", items: "center", children: /* @__PURE__ */ c("div", { ref: s, className: F("relative flex items-center justify-center") }) }),
    /* @__PURE__ */ A(I, { className: F("gjs-p-1 w-full"), col: !0, space: "s", children: [
      /* @__PURE__ */ A(I, { nowrap: !0, items: "center", space: "xs", full: !0, children: [
        /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c("pre", { className: F("text-xs bg-white/10", z.txt, se.rnd, Re.xyS), children: v }) }),
        !!u && u.getWidthMedia() && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
          yt,
          {
            title: /* @__PURE__ */ A(ae, { children: [
              l.t("deviceManager.device"),
              ": ",
              /* @__PURE__ */ c("b", { children: u.getName() })
            ] }),
            children: /* @__PURE__ */ c(oe, { icon: ne.cellphoneLink, size: pe.sx })
          }
        ) }),
        !!d && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
          yt,
          {
            title: /* @__PURE__ */ A(ae, { children: [
              l.t("selectorManager.state"),
              ": ",
              /* @__PURE__ */ c("b", { children: d.getLabel() })
            ] }),
            children: /* @__PURE__ */ c(oe, { icon: ne.flare, size: pe.sx })
          }
        ) })
      ] }),
      /* @__PURE__ */ A(I, { nowrap: !0, className: F(Qe.txtEllips), space: "s", children: [
        /* @__PURE__ */ c(N, { className: F("group-hover:gs-utl-opacity-100 opacity-0 transition-opacity"), grow: !0, children: /* @__PURE__ */ c(Ze, { onClick: b, className: F("text-sm gjs-mr-auto"), size: "m2", full: !0, children: l.t("select") }) }),
        /* @__PURE__ */ c(
          Rr,
          {
            overlay: !0,
            title: !1,
            padding: !1,
            buttonAs: "span",
            handler: /* @__PURE__ */ c(Ft, { title: l.t("selectorManager.showCSS"), children: /* @__PURE__ */ c(oe, { icon: ne.codeBraces, size: pe.sx }) }),
            children: ({ close: S }) => /* @__PURE__ */ A(I, { className: F("relative w-80 h-48"), col: !0, children: [
              /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(
                Jr,
                {
                  value: of(f),
                  onChange: m,
                  language: "css",
                  padding: 5,
                  isDarkTheme: p,
                  clean: !0
                }
              ) }),
              /* @__PURE__ */ c(
                Ze,
                {
                  className: F("absolute right-2 bottom-2 text-sm"),
                  variant: "pr",
                  size: "m2",
                  onClick: () => {
                    w(), S();
                  },
                  children: l.t("update")
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ c(uf, { onConfirm: y, className: F("w-48"), children: /* @__PURE__ */ c(Ft, { title: l.t("selectorManager.deleteStyle"), children: /* @__PURE__ */ c(oe, { icon: ne.delete, size: pe.sx }) }) })
      ] })
    ] })
  ] }, t.cid) });
}), PR = ue(function() {
  const [t] = pc(), n = Bn(), r = Ne(), [o, s] = W(""), [i, a] = W(""), u = ye().editor, [d, p] = W(u.Css.getRules("")), f = u.Devices.getDevices().map((m) => ({
    id: m.id,
    label: m.getName()
  })), h = d.filter((m) => {
    var v;
    return !(o && !Qo(m.selectorsToString(), o) || i && ((v = m.getDevice()) == null ? void 0 : v.id) !== i);
  }), g = () => p(u.Css.getRules(""));
  return /* @__PURE__ */ A(I, { col: !0, space: "m", children: [
    /* @__PURE__ */ A(I, { items: "center", space: "m", children: [
      /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
        ft,
        {
          size: "s",
          type: "search",
          value: o,
          onInput: s,
          placeholder: `${r.t("selectorManager.searchStyle")}...`
        }
      ) }),
      /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
        Ae,
        {
          includeEmpty: !0,
          size: "s",
          value: i,
          options: f,
          onChange: a,
          emptyState: r.t("deviceManager.allDevices"),
          handlerSelected: (m) => /* @__PURE__ */ A(I, { space: "s", items: "center", children: [
            /* @__PURE__ */ c(oe, { icon: ne.cellphoneLink, size: pe.sx }),
            /* @__PURE__ */ c("span", { children: m.label })
          ] })
        }
      ) })
    ] }),
    /* @__PURE__ */ c(N, { className: F("gs-utl-h-[75vh] w-full overflow-auto"), children: h.length ? /* @__PURE__ */ c(
      ia,
      {
        data: h,
        listClassName: F("grid grid-cols-4 gap-2 gjs-pr-2"),
        itemContent: (m, v) => /* @__PURE__ */ c(CR, { rule: v, onRemove: g, onSelect: n.close }, v.cid)
      },
      t
    ) : /* @__PURE__ */ c(I, { justify: "center", children: r.t("modals.styleCatalog.noStyles") }) })
  ] });
});
function j0({
  className: e,
  value: t,
  active: n,
  unstyled: r,
  activable: o,
  onChange: s,
  onActive: i,
  ...a
}) {
  const [l, u] = W(n);
  G(() => {
    u(n);
  }, [n]);
  const d = (f) => {
    i == null || i(f), u(f);
  }, p = (f) => {
    s(f), d(!1);
  };
  return /* @__PURE__ */ c("div", { className: $("truncate", e), ...a, onDoubleClick: () => o && d(!0), children: l ? /* @__PURE__ */ c(df, { className: $(r && Qe.noFocusOut), value: t, onChange: p }) : /* @__PURE__ */ c(ae, { children: t }) });
}
const ER = ue(function({ selector: t, className: n, removable: r, toggleable: o }) {
  const s = Ne(), i = ye(), [a, l] = W(), [u, d] = W(t.getActive()), p = i.editor, { Selectors: f } = p, h = t.getLabel(), g = /* @__PURE__ */ c(oe, { icon: ne.dotsVertical, size: pe.sx }), m = () => {
    f.removeSelected(t);
  }, v = (C) => {
    a && f.rename(a, C), l(void 0);
  }, b = () => {
    f.duplicateSelected(t);
  }, y = () => {
    const C = !t.getActive();
    d(C), t.setActive(C);
  }, S = [
    { id: "rename", label: s.t("rename"), action: () => l(t) },
    { id: "duplicate", label: s.t("duplicate"), action: b },
    r && { id: "delete", label: s.t("delete"), action: m },
    o && { id: "active", label: s.t(u ? "disable" : "enable"), action: y }
  ].filter(Boolean), x = (C, P) => (_) => {
    C(), ct(P) && P(_);
  };
  return /* @__PURE__ */ c(St, { className: F(["gjs-ml-1 gjs-my-1 group overflow-hidden cursor-default relative", z.sel, n]), s: "s", children: /* @__PURE__ */ A(I, { items: "center", children: [
    /* @__PURE__ */ c(N, { className: F("gjs-mr-4", !a && !u && "opacity-50 line-through"), children: /* @__PURE__ */ c(j0, { value: h, onChange: v, active: !!a, unstyled: !0 }) }),
    /* @__PURE__ */ c(I, { className: F("absolute h-full right-0 transition-opacity", z.sel, z.selBr, se.bl), children: /* @__PURE__ */ c(Rr, { handler: g, title: !1, padding: !1, fixed: !0, overlay: !0, children: ({ close: C }) => S.map((P) => /* @__PURE__ */ c(
      ec,
      {
        className: F(z.txt),
        label: P.label,
        action: x(C, P.action)
      },
      P.id
    )) }) })
  ] }) });
}), OR = (e) => {
  var r, o;
  let t = (r = e == null ? void 0 : e.selectorsToString) == null ? void 0 : r.call(e);
  const n = (o = e == null ? void 0 : e.getAtRule) == null ? void 0 : o.call(e);
  return t && n && (t = `${n} {
	${t}
}`), t;
}, D0 = ue(function({
  selectedState: t,
  states: n,
  addSelector: r,
  setState: o,
  styleCatalog: s,
  stateSelector: i
}) {
  var Q, re, ge;
  const a = Ne(), l = Bn(), [u, d] = W(!1), { toggleCssPanel: p, isCssPanelActive: f, editor: h } = ye();
  if (!h)
    return null;
  const { Selectors: g, Styles: m } = h, v = g.getComponentFirst(), b = g.getSelectedAll(), y = g.getAll({ array: !0 }), w = h.getSelectedAll(), S = n.map((X) => ({ id: X.getName(), label: X.getLabel() })), x = h.getModel(), C = m.getSelected(), P = (Q = C == null ? void 0 : C.getDevice) == null ? void 0 : Q.call(C), _ = (re = C == null ? void 0 : C.getState) == null ? void 0 : re.call(C), O = b.reduce((X, Z) => {
    const te = X.indexOf(Z);
    return te >= 0 && X.splice(te, 1), X;
  }, y), E = $("overflow-hidden gjs-mb-2", se.b, se.rnd, z.br), T = $(z.bA), R = $("flex h-full cursor-pointer gjs-p-2", se.br, z.br), B = `${z.bgA}`, U = OR(C), L = b.length > 0, M = w.length > 0, D = L || M, V = v && M || !v && !L, k = V ? "Components" : "Selectors", j = (X) => a.t(`selectorManager.${X}`), Y = a.t("modals.styleCatalog.title"), J = () => l.open({ title: Y, content: /* @__PURE__ */ c(PR, {}) }), le = O.filter((X) => X.isClass()).map((X) => ({
    id: X,
    label: X.getLabel()
  }));
  return /* @__PURE__ */ A(ae, { children: [
    /* @__PURE__ */ A(I, { items: "center", className: $("gjs-mb-2"), children: [
      /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ A(I, { items: "center", space: "s", children: [
        /* @__PURE__ */ c(N, { children: j("selection") }),
        s !== !1 && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(yt, { className: $("cursor-pointer"), onClick: J, title: Y, children: /* @__PURE__ */ c(oe, { icon: ne.paletteSwatch, size: pe.s }) }) })
      ] }) }),
      !!C && i !== !1 && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
        Ae,
        {
          size: "s",
          value: t,
          options: S,
          includeEmpty: !0,
          onChange: o,
          emptyState: `- ${j("state")} -`,
          className: $([t && z.bA])
        }
      ) })
    ] }),
    D ? /* @__PURE__ */ A(ae, { children: [
      /* @__PURE__ */ A(I, { items: "stretch", space: "xs", className: $(E, !V && T), children: [
        /* @__PURE__ */ c(
          yt,
          {
            title: j(L ? "applyOnSelector" : "noSelectors"),
            className: $(R, !V && B),
            onClick: () => L && g.setComponentFirst(!1),
            children: /* @__PURE__ */ c(I, { className: $("h-full"), items: "center", children: /* @__PURE__ */ c(oe, { icon: ne.tag, size: pe.sx }) })
          }
        ),
        /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(I, { className: $("h-full gjs-pr-1"), items: "center", children: u ? /* @__PURE__ */ c(
          $0,
          {
            autoFocus: !0,
            open: !0,
            hideCaret: !0,
            border: !1,
            options: le,
            allowNew: j("addNewSelector"),
            onBlur: () => setTimeout(() => d(!1), 100),
            onChange: (X) => {
              X && (r(X.id || X.label), d(!1));
            }
          }
        ) : /* @__PURE__ */ A(ae, { children: [
          M && /* @__PURE__ */ c(yt, { title: j("addNewSelector"), children: /* @__PURE__ */ c(Ze, { variant: "out", size: "s", onClick: () => d(!0), children: /* @__PURE__ */ c(oe, { icon: ne.plus, size: pe.s }) }) }),
          b.map((X) => /* @__PURE__ */ c(
            ER,
            {
              selector: X,
              removable: M,
              toggleable: M && b.filter((Z) => Z.getActive() || Z === X).length > 1
            },
            X.toString()
          ))
        ] }) }) })
      ] }),
      /* @__PURE__ */ A(I, { items: "stretch", space: "xs", className: $(E, V && T), children: [
        /* @__PURE__ */ c(
          yt,
          {
            title: j(M ? "applyOnComponents" : "noComponents"),
            onClick: () => M && g.setComponentFirst(!0),
            className: $(R, V && B),
            children: /* @__PURE__ */ c(I, { className: $("h-full"), items: "center", children: /* @__PURE__ */ c(oe, { icon: ne.targetVariant, size: pe.sx }) })
          }
        ),
        /* @__PURE__ */ c(N, { grow: !0, className: $("gjs-py-0.5"), children: /* @__PURE__ */ c(I, { className: $("h-full gjs-pr-1"), items: "center", children: w.map((X) => /* @__PURE__ */ c(
          St,
          {
            s: "s",
            className: $(["gjs-ml-1 gjs-my-0.5 cursor-default", z.cmp]),
            onPointerEnter: () => x.setHovered(X),
            onPointerOut: () => x.setHovered(),
            label: X.getName()
          },
          X.getId()
        )) }) })
      ] }),
      /* @__PURE__ */ A(I, { space: "s", items: "center", justify: "between", children: [
        /* @__PURE__ */ c(
          yt,
          {
            title: /* @__PURE__ */ A(ae, { children: [
              /* @__PURE__ */ c("div", { children: j("selected") }),
              /* @__PURE__ */ c(
                "pre",
                {
                  className: $(
                    "gs-utl-text-xs gs-utl-mt-1 gs-utl-bg-white/10 gs-utl-text-gray-400",
                    se.rnd,
                    Re.xyS
                  ),
                  children: U
                }
              ),
              /* @__PURE__ */ c("div", { className: $("gs-utl-text-xs gs-utl-mt-1.5"), children: j("currentSelection") })
            ] }),
            children: /* @__PURE__ */ c(St, { className: $(se.b, se.rnd, z.br), s: "xs", nopad: !0, block: !0, children: /* @__PURE__ */ c(oe, { icon: ne.target, size: pe.sx }) })
          }
        ),
        /* @__PURE__ */ c(N, { className: $("text-sm"), children: /* @__PURE__ */ c(St, { className: $(se.b, se.rnd, z.br), s: "xs", nopad: !0, children: /* @__PURE__ */ A(I, { space: "xs", items: "center", nowrap: !0, children: [
          !!P && P.getWidthMedia() && /* @__PURE__ */ A(ae, { children: [
            /* @__PURE__ */ c(
              yt,
              {
                title: /* @__PURE__ */ A(ae, { children: [
                  j("device"),
                  ": ",
                  /* @__PURE__ */ c("b", { children: P.getName() })
                ] }),
                children: /* @__PURE__ */ c(oe, { icon: ne.cellphoneLink, size: pe.sx })
              }
            ),
            /* @__PURE__ */ c(N, { className: $("opacity-30"), children: "|" })
          ] }),
          /* @__PURE__ */ c(
            yt,
            {
              title: /* @__PURE__ */ A(ae, { children: [
                j("target"),
                ": ",
                /* @__PURE__ */ c("b", { children: k }),
                /* @__PURE__ */ A("span", { className: $("text-xs opacity-75"), children: [
                  " ",
                  (ge = C == null ? void 0 : C.selectorsToString) == null ? void 0 : ge.call(C, { skipState: 1 })
                ] })
              ] }),
              children: /* @__PURE__ */ c(oe, { icon: V ? ne.targetVariant : ne.tag, size: pe.sx })
            }
          ),
          !!_ && /* @__PURE__ */ A(ae, { children: [
            /* @__PURE__ */ c(N, { className: $("opacity-30"), children: "|" }),
            /* @__PURE__ */ c(
              yt,
              {
                title: /* @__PURE__ */ A(ae, { children: [
                  j("state"),
                  ": ",
                  /* @__PURE__ */ c("b", { children: _.getLabel() })
                ] }),
                children: /* @__PURE__ */ c(oe, { icon: ne.flare, size: pe.sx })
              }
            )
          ] })
        ] }) }) }),
        /* @__PURE__ */ c(
          Ft,
          {
            title: a.t("toggleCss"),
            onClick: p,
            active: f,
            size: "s",
            children: /* @__PURE__ */ c(oe, { icon: ne.codeBraces, size: pe.sx })
          }
        )
      ] })
    ] }) : /* @__PURE__ */ A(I, { className: $("text-sm leading-6 gjs-my-5"), col: !0, children: [
      /* @__PURE__ */ c(N, { children: j("noSelecton") }),
      /* @__PURE__ */ A("ul", { className: $("list-disc gjs-pl-5 gjs-mt-2"), children: [
        /* @__PURE__ */ c("li", { children: j("selectFromCanvas") }),
        /* @__PURE__ */ c("li", { children: j("selectFromList") })
      ] })
    ] })
  ] });
}), _R = "gs-panel-selectors", TR = we(
  ue(function({
    className: t,
    styleCatalog: n,
    stateSelector: r,
    ...o
  }) {
    return /* @__PURE__ */ c(zn, { className: q(_R, t), ...o, children: /* @__PURE__ */ c(lb, { children: (s) => /* @__PURE__ */ c(D0, { ...s, styleCatalog: n, stateSelector: r }) }) });
  })
), AR = Rt(function({ children: t, className: n, content: r, ...o }, s) {
  return /* @__PURE__ */ c("div", { className: q(F("gs-design-manager-tab"), n), ref: s, ...o, children: t });
}), Au = $("overflow-y-auto overflow-x-hidden max-w-full"), I0 = ue(function() {
  var w, S, x;
  const {
    isCssPanelActive: t,
    selectedDesignerTab: n,
    showSelectors: r,
    setSelectedDesignerTab: o,
    sdkProps: s,
    sdkOptions: i,
    isProjectTypeEmail: a
  } = ye(), l = Ne(), u = $(t && "hidden"), p = (((w = qt(s.children, AR)) == null ? void 0 : w.filter(Boolean)) || []).map(({ props: C }, P) => ({
    id: C.id,
    label: C.label,
    content: /* @__PURE__ */ c(Mo, { children: C.children }),
    order: C.order ?? 2 + P + 1
  })), f = (S = i.designPanel) == null ? void 0 : S.propsInStyles, h = (x = i.designPanel) == null ? void 0 : x.hideTabs, g = f === !0 || a && f !== !1, m = h === !0 || a && h !== !1, v = l.t("traitManager.panelLabel"), y = [
    {
      id: "style",
      label: l.t("styleManager.panelLabel"),
      order: 1,
      content: /* @__PURE__ */ A(I, { col: !0, full: !0, children: [
        !!r && /* @__PURE__ */ c(N, { className: $(Re.s, se.bb, z.br), children: /* @__PURE__ */ c(lb, { children: (C) => /* @__PURE__ */ c(D0, { ...C }) }) }),
        g && /* @__PURE__ */ c(N, { className: Au, children: /* @__PURE__ */ c($o, { handler: v, className: jb(!1), sticky: !0, open: !0, children: /* @__PURE__ */ c(hd, { children: (C) => /* @__PURE__ */ c(Md, { ...C, className: $("gjs-p-2", z.br, se.bb) }) }) }) }),
        /* @__PURE__ */ c(N, { className: Au, grow: !0, children: /* @__PURE__ */ c(cb, { children: (C) => /* @__PURE__ */ A(ae, { children: [
          t && /* @__PURE__ */ c(qb, {}),
          /* @__PURE__ */ c(Db, { className: u, ...C })
        ] }) }) })
      ] })
    },
    !g && {
      id: "props",
      label: v,
      order: 2,
      content: /* @__PURE__ */ c(I, { col: !0, full: !0, children: /* @__PURE__ */ c(N, { className: $(Re.s, Au), children: /* @__PURE__ */ c(hd, { children: (C) => /* @__PURE__ */ c(Md, { ...C }) }) }) })
    },
    ...p
  ].filter(Boolean).sort((C, P) => C.order - P.order);
  return /* @__PURE__ */ c(I, { col: !0, full: !0, nowrap: !0, children: /* @__PURE__ */ c(
    Ro,
    {
      value: n,
      onChange: o,
      tabs: y,
      className: $(m && "hidden")
    }
  ) });
}), LR = "gs-panel-sidebar-tabs", kR = we(
  ue(function({ className: t, ...n }) {
    return /* @__PURE__ */ c(zn, { className: q(LR, "gs-utl-h-full", t), ...n, children: /* @__PURE__ */ c(I0, {}) });
  })
), MR = "gs-panel-styles", $R = we(
  ue(function({ className: t, ...n }) {
    const { isCssPanelActive: r } = ye(), o = q(r && " gs-utl-hidden");
    return /* @__PURE__ */ c(
      zn,
      {
        className: q(MR, "gs-utl-overflow-auto gs-utl-h-full", t),
        classNameAccordion: q("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        classNameAccordionContent: q("gs-utl-overflow-auto"),
        ...n,
        children: /* @__PURE__ */ c(cb, { children: (s) => /* @__PURE__ */ A(ae, { children: [
          r && /* @__PURE__ */ c(qb, {}),
          /* @__PURE__ */ c(Db, { className: o, ...s })
        ] }) })
      }
    );
  })
), RR = "gs-panel-templates", NR = we(
  ue(function({
    className: t,
    templates: n,
    content: r,
    onSelect: o,
    ...s
  }) {
    const i = Nv(), { projectTypeFilter: a } = i;
    let l = n ?? i.templates;
    return l = l == null ? void 0 : l.map((u) => ({ ...u, isTemplate: !0 })), G(() => {
      n || i.loadTemplates();
    }, [n]), /* @__PURE__ */ c(
      zn,
      {
        className: q(RR, "gs-utl-overflow-hidden gs-utl-h-full", t),
        classNameAccordion: q("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        classNameAccordionContent: q("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        ...s,
        children: /* @__PURE__ */ c(I, { className: F("relative gs-utl-h-full"), nowrap: !0, col: !0, space: "m", children: /* @__PURE__ */ c(I, { className: F("gs-utl-h-[75vh] gs-utl-flex-grow"), nowrap: !0, col: !0, space: "m", children: /* @__PURE__ */ c(
          u0,
          {
            templates: l,
            projectType: Ve[a],
            content: r,
            onSelect: o,
            skipProjectNamePopover: !0
          }
        ) }) })
      }
    );
  })
), jR = "gs-cmp-row", DR = we(function({ className: t, children: n, full: r, ...o }) {
  return /* @__PURE__ */ c(No, { className: q(jR, z.bg, "gs-utl-flex", r && "gs-utl-w-full", t), ...o, children: un(n) });
}), IR = "gs-cmp-select-field", VR = we(
  ue(function({
    className: t,
    style: n,
    label: r,
    name: o,
    value: s,
    options: i,
    size: a,
    onChange: l,
    required: u,
    disabled: d,
    emptyState: p,
    editorEvents: f
  }) {
    const { editor: h } = ye(), [g, m] = W(() => ({
      required: u,
      disabled: d,
      style: n,
      className: t,
      label: r,
      name: o,
      value: s,
      options: i,
      size: a,
      emptyState: p
    })), v = (b) => {
      l({
        value: b,
        editor: h,
        state: g,
        setState: (y) => m((w) => ({ ...w, ...y }))
      });
    };
    return Pc({
      editor: h,
      editorEvents: f,
      localState: g,
      setLocalState: m
    }), /* @__PURE__ */ c(
      Ae,
      {
        classNameContainer: q(IR, g.className),
        style: g.style,
        label: g.label,
        name: g.name,
        value: g.value ?? "",
        options: g.options ?? [],
        size: g.size,
        required: g.required,
        disabled: g.disabled,
        emptyState: g.emptyState,
        onChange: v
      }
    );
  })
), HR = "gs-sidebar-bottom", BR = we(
  ue(function({ children: t, className: n, style: r, height: o, ...s }) {
    const { isInPreview: i, isBottomSidebarOpen: a } = ye(), l = o ?? 35, u = ie(
      () => ({
        height: l,
        marginBottom: i || !a ? `-${l}px` : 0,
        ...r
      }),
      [i, a, r]
    );
    return /* @__PURE__ */ c(
      No,
      {
        className: q(HR, "gs-utl-flex gs-utl-transition-spacing", se.bt, z.br, n),
        style: u,
        ...s,
        children: t ? un(t) : void 0
      }
    );
  })
), zR = ue(function(t) {
  var w;
  const { leftSidebarSize: n, setLeftSidebarSize: r, editor: o, isInPreview: s, isLeftSidebarOpen: i, sdkProps: a, showPages: l } = ye(), u = a.children, d = ((w = t.style) == null ? void 0 : w.width) ?? t.width, p = d ?? n, f = t.resizable === !1, h = q(t.className, "gs-utl-h-full gs-utl-transition-spacing", se.br, z.br), g = q("gs-utl-w-full", se.bb, z.br), m = q("gs-utl-w-full gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"), v = ie(
    () => ({
      marginLeft: s || !i ? `-${p}px` : 0,
      ...t.style
    }),
    [p, s, i, t.style]
  );
  return /* @__PURE__ */ c(
    wc,
    {
      className: h,
      enable: f ? !1 : void 0,
      right: !f,
      style: v,
      height: "100%",
      width: p,
      minWidth: d ?? 200,
      maxWidth: d ?? 400,
      onResize: () => o == null ? void 0 : o.refresh(),
      onResizeStop: (S, x, C) => {
        r(C.getBoundingClientRect().width);
      },
      children: t.children ?? /* @__PURE__ */ A(I, { full: !0, col: !0, children: [
        l && /* @__PURE__ */ c(N, { className: g, children: /* @__PURE__ */ c(ab, { children: (S) => /* @__PURE__ */ A(ae, { children: [
          qt(u, k0),
          /* @__PURE__ */ c(A0, { ...S }),
          qt(u, L0)
        ] }) }) }),
        /* @__PURE__ */ c(N, { className: m, grow: !0, children: /* @__PURE__ */ c(ib, { children: (S) => /* @__PURE__ */ A(ae, { children: [
          qt(u, P0),
          /* @__PURE__ */ c(x0, { ...S }),
          qt(u, C0)
        ] }) }) })
      ] })
    }
  );
}), FR = "gs-sidebar-left", UR = we(
  ue(function({ children: t, width: n, resizable: r, ...o }) {
    return /* @__PURE__ */ c(
      zR,
      {
        className: q(FR, "gs-utl-flex gs-utl-flex-col gs-utl-flex-nowrap", hc(o)),
        width: n,
        resizable: r,
        style: gc(o),
        children: t ? un(t) : void 0
      }
    );
  })
), WR = ue(function(t) {
  var g;
  const { rightSidebarSize: n, setRightSidebarSize: r, editor: o, isInPreview: s, isRightSidebarOpen: i } = ye(), a = ((g = t.style) == null ? void 0 : g.width) ?? t.width, l = a ?? n, u = t.resizable === !1, d = q(t.className, "gs-utl-h-full gs-utl-transition-spacing", se.bl, z.br), p = ie(
    () => ({
      marginRight: s || !i ? `-${l}px` : 0,
      ...t.style
    }),
    [l, s, i, t.style]
  );
  return /* @__PURE__ */ c(
    wc,
    {
      className: d,
      enable: u ? !1 : void 0,
      left: !u,
      style: p,
      height: "100%",
      width: l,
      minWidth: a ?? 200,
      maxWidth: a ?? 400,
      onResize: () => o == null ? void 0 : o.refresh(),
      onResizeStop: (m, v, b) => {
        r(b.getBoundingClientRect().width);
      },
      children: t.children ?? /* @__PURE__ */ c(I0, {})
    }
  );
}), GR = "gs-sidebar-right", KR = we(
  ue(function({ children: t, resizable: n, ...r }) {
    return /* @__PURE__ */ c(
      WR,
      {
        className: q(GR, "gs-utl-flex gs-utl-flex-col gs-utl-flex-nowrap", hc(r)),
        resizable: n,
        style: gc(r),
        children: t ? un(t) : void 0
      }
    );
  })
), qR = ue(function({
  className: t,
  variant: n,
  value: r,
  tabs: o,
  style: s,
  editorEvents: i,
  onChange: a
}) {
  const { editor: l } = ye(), [u, d] = W(() => ({
    tabs: o,
    style: s,
    value: r,
    variant: n,
    className: t
  })), p = ie(
    () => {
      var h;
      return ((h = u.tabs) == null ? void 0 : h.map((g) => ({
        ...g,
        content: un(g.children)
      }))) || [];
    },
    [u.tabs]
  ), f = (h) => {
    a && l ? a({
      value: h,
      editor: l,
      state: u,
      setState: (g) => d((m) => ({ ...m, ...g }))
    }) : d((g) => ({ ...g, value: h }));
  };
  return Pc({
    editor: l,
    editorEvents: i,
    localState: u,
    setLocalState: d
  }), /* @__PURE__ */ c(
    Ro,
    {
      tabs: p,
      className: q(u.className),
      variant: u.variant,
      value: u.value,
      style: u.style,
      onChange: f
    }
  );
}), YR = "gs-cmp-text", XR = we(function({ className: t, content: n, children: r, ...o }) {
  return /* @__PURE__ */ c(No, { className: q(YR, t), ...o, children: r || n });
}), ZR = "gs-cmp-virtual-list", JR = ue(function({
  id: t,
  items: n,
  itemLayout: r,
  itemsPerRow: o = 12,
  className: s,
  style: i,
  htmlAttrs: a
}) {
  const { editor: l } = ye(), u = cf(o);
  return /* @__PURE__ */ c(
    ia,
    {
      ...a,
      data: n,
      className: q(ZR, "gs-utl-h-full", s),
      listClassName: `gs-utl-grid gs-utl-gap-2 gs-utl-pr-2 ${u}`,
      style: i,
      itemContent: (d, p) => /* @__PURE__ */ c(H.Fragment, { children: r ? un(r({ item: p, editor: l })) : /* @__PURE__ */ c("pre", { children: JSON.stringify(p, void 0, 2) }) }, p.id ?? d)
    },
    t
  );
});
var $d = /* @__PURE__ */ ((e) => (e.text = "text", e.row = "row", e.column = "column", e.button = "button", e.buttonGroupField = "buttonGroupField", e.inputField = "inputField", e.selectField = "selectField", e.tabs = "tabs", e.devices = "devices", e.custom = "custom", e.panelLayers = "panelLayers", e.panelPages = "panelPages", e.panelSelectors = "panelSelectors", e.panelStyles = "panelStyles", e.panelProperties = "panelProperties", e.panelSidebarTabs = "panelSidebarTabs", e.panelPagesLayers = "panelPagesLayers", e.panelBlocks = "panelBlocks", e.panelPageSettings = "panelPageSettings", e.panelGlobalStyles = "panelGlobalStyles", e.panelAssets = "panelAssets", e.panelTemplates = "panelTemplates", e.sidebarLeft = "sidebarLeft", e.sidebarRight = "sidebarRight", e.sidebarTop = "sidebarTop", e.sidebarBottom = "sidebarBottom", e.canvas = "canvas", e.canvasSidebarTop = "canvasSidebarTop", e.virtualList = "virtualList", e))($d || {});
const QR = {
  row: DR,
  column: l4,
  text: XR,
  tabs: qR,
  button: nf,
  buttonGroupField: bM,
  inputField: u4,
  selectField: VR,
  devices: d0,
  panelPages: M0,
  panelPageSettings: J4,
  panelLayers: E0,
  panelPagesLayers: sR,
  panelBlocks: M4,
  panelGlobalStyles: B4,
  panelSelectors: TR,
  panelStyles: $R,
  panelProperties: SR,
  panelSidebarTabs: kR,
  panelAssets: L4,
  panelTemplates: NR,
  sidebarRight: KR,
  sidebarLeft: UR,
  sidebarTop: p0,
  sidebarBottom: BR,
  canvas: Gb,
  canvasSidebarTop: i4,
  virtualList: JR
}, un = (e) => {
  const t = Array.isArray(e) ? e : e ? [e] : [], n = A5();
  return t.filter(Boolean).map((r, o) => {
    const { id: s = "", type: i, ...a } = Mt(r) ? { type: $d.text, content: r } : r || {}, l = QR[i], u = n.layoutChildren.get(s), d = s || o;
    return u ? /* @__PURE__ */ c(ud, { id: s, ...u }, d) : i === $d.custom ? /* @__PURE__ */ c(ud, { id: s, ...a }, d) : l ? /* @__PURE__ */ c(l, { id: s, ...a }, d) : null;
  });
}, Pc = (e) => {
  const { editorEvents: t, editor: n, localState: r, setLocalState: o } = e;
  G(() => {
    if (!t || !n)
      return;
    const s = Object.keys(t).reduce(
      (a, l) => (a[l] = (u = {}) => {
        const d = t[l];
        d({
          fromEvent: u,
          editor: n,
          state: r,
          setState: (p) => o((f) => ({ ...f, ...p }))
        });
      }, a),
      {}
    ), i = Object.keys(s);
    return i.forEach((a) => n.on(a, s[a])), () => {
      i.forEach((a) => n.off(a, s[a]));
    };
  }, [n, r]);
}, rm = "gs-block-item", eN = q("gs-utl-text-center gs-utl-w-full", Qe.txtEllips), tN = ({ block: e, className: t, itemLayout: n }) => {
  const { editor: r } = ye(), o = Ne(), [, s] = W(0), i = o.tScoped("blockManager.labels"), a = e.getId(), l = !!e.get("full"), u = e.get("onClick"), d = e.get("disable"), p = e.get("mediaReact"), f = e.getMedia(), h = e.get("attributes") || {}, g = i(a) || e.getLabel(), m = q(
    rm,
    `${rm}--${a}`,
    t,
    "gs-utl-py-2 gs-utl-px-2 gs-utl-transition-colors",
    se.b,
    se.rnd,
    z.br,
    l && "gs-utl-col-span-full",
    d ? Qe.disabledM : q("gs-utl-cursor-pointer", z.hTAo, z.hBgH)
  ), v = Pr(h.class) ? h.class : q("gs-utl-block-media gs-utl-max-h-10 gs-utl-max-w-10 gs-utl-w-full");
  if (G(() => {
    if (!r)
      return;
    const { Blocks: C } = r, P = C.events.update, _ = (O) => O === e && s((E) => ++E);
    return r.on(P, _), () => {
      r.off(P, _);
    };
  }, [e, r]), !r)
    return null;
  const { Blocks: b } = r, S = {
    className: m,
    ...!d && {
      onDragStart: () => b.startDrag(e),
      onDragEnd: () => b.endDrag(!1),
      draggable: !0
    },
    ...!!u && {
      onClick: () => u(e, r)
    }
  }, x = n == null ? void 0 : n({ editor: r, block: e, attributes: S });
  return x && un(x) || /* @__PURE__ */ A(I, { items: "center", col: !0, ...S, children: [
    p || /* @__PURE__ */ c("div", { className: v, dangerouslySetInnerHTML: { __html: f } }),
    /* @__PURE__ */ c("div", { className: eN, title: g, children: g })
  ] });
}, om = ue(tN), sm = F("text-sm w-full", Qe.txtEllips), nN = ({ symbol: e, className: t }) => {
  const n = Tn(), { Components: r } = n, o = Ne(), s = Bn(), i = o.tScoped("blockManager.symbols"), a = () => {
    const { draggable: b, droppable: y, attributes: w, type: S, tagName: x } = e.attributes;
    n.Canvas.startDrag({
      // @ts-expect-error Allow to return Components
      content: () => r.addSymbol(e),
      model: e,
      dragDef: {
        type: S,
        tagName: x,
        draggable: b,
        droppable: y,
        attributes: w
      }
    });
  }, l = () => {
    n.Canvas.endDrag();
  }, u = e.getIcon(), d = e.getName(), p = r.getSymbolInfo(e).instances.length, f = F("h-10 w-10 block-media", z.grouphTAo), h = F("gjs-pt-1 gjs-mt-2", se.bt, z.br), g = F("cursor-pointer gjs-p-2 transition-colors group", se.b, se.rnd, z.br, z.hBgH, t), m = () => {
    s.confirm({
      title: i("delete"),
      content: i("deleteConfirm"),
      onConfirm: () => e.remove()
    });
  }, v = (b) => {
    e.set("custom-name", b);
  };
  return /* @__PURE__ */ A(I, { className: g, onDragStart: a, onDragEnd: l, items: "center", draggable: !0, col: !0, children: [
    /* @__PURE__ */ c("div", { className: f, dangerouslySetInnerHTML: { __html: u } }),
    /* @__PURE__ */ A(I, { items: "center", justify: "between", className: h, space: "m", full: !0, children: [
      /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(I, { className: F(sm, "gjs-mr-auto"), children: /* @__PURE__ */ c(yt, { title: `${p} ${i("instancesProject")}`, children: /* @__PURE__ */ c(St, { label: `${p}`, className: F(z.bgH75) }) }) }) }),
      /* @__PURE__ */ c(N, { className: F("truncate"), grow: !0, title: d, children: /* @__PURE__ */ c(j0, { activable: !0, value: d, className: sm, onChange: v }) }),
      /* @__PURE__ */ c(N, { className: F(Qe.hoverGroup), children: /* @__PURE__ */ c(I, { justify: "end", full: !0, children: /* @__PURE__ */ c(Ft, { onClick: m, title: i("delete"), border: !1, size: "", block: !0, children: /* @__PURE__ */ c(oe, { icon: ne.delete, size: pe.s }) }) }) })
    ] })
  ] });
}, rN = ue(nN), Ir = "gs-block-manager", im = (e, t) => {
  const n = t == null ? void 0 : t.getId();
  return n && e.I18n.t(`blockManager.categories.${n}`) || (t == null ? void 0 : t.getLabel()) || "";
}, V0 = ue(function({
  isOpen: t,
  className: n,
  hideCategories: r,
  itemLayout: o,
  ...s
}) {
  var re, ge;
  const { editor: i } = ye(), a = Ne(), [l, u] = W(0), [d, p] = W(ti.REGULAR), [f, h] = W(""), [g, m] = W([]), v = d === ti.SYMBOLS, b = K(null), y = a.tScoped("blockManager");
  if (G(() => {
    if (!i)
      return;
    const { Blocks: X, Components: Z } = i, te = X.events.custom, de = Z.events.symbol, ce = () => {
      m(Z.getSymbols()), u((Ce) => ++Ce);
    };
    return i.on(de, ce), i.on(te, ce), () => {
      i.off(de, ce), i.off(te, ce);
    };
  }, [i]), G(() => {
    if (b.current && t) {
      const X = b.current.querySelector("input");
      setTimeout(() => X == null ? void 0 : X.focus(), S1);
    }
  }, [b.current, t]), !i)
    return null;
  const { Blocks: w } = i, S = (X) => y(`labels.${X.getId()}`) || X.getLabel(), x = g.filter((X) => Qo(X.getName(), f)), C = w.getAll().map((X) => X), _ = (((re = s.blocks) == null ? void 0 : re.call(s, { blocks: C })) || C).filter((X) => {
    const Z = im(i, X.category);
    return !(f && !Qo(Z, f) && !Qo(S(X), f));
  }), O = w.getBlocksByCategory(_), E = r ? _ : (ge = O.find((X) => !X.category)) == null ? void 0 : ge.items, T = r ? [] : O.filter((X) => X.category), R = s.symbols !== !1, B = s.search !== !1, U = !R && !B, L = y("search") || a.t("search"), M = q(Ir, n, "gap-2"), D = q(`${Ir}__header`, "gs-utl-pt-2", Re.xS, U && "gs-utl-hidden"), V = q(`${Ir}__content`, Qe.scrollY, z.br, se.bt), k = q(`${Ir}__symbols`, "gs-utl-grid gs-utl-grid-cols-1 gs-utl-gap-2 gs-utl-p-2"), j = q(`${Ir}__not-found`, "gs-utl-text-center gs-utl-p-4"), Y = q(`${Ir}__blocks`, "gs-utl-grid gs-utl-grid-cols-2 gs-utl-gap-2 gs-utl-p-2 gs-utl-text-sm"), J = q(`${Ir}__no-category`, Y, z.br, T.length && se.bb), le = `${Ir}__category`, Q = [
    { id: ti.REGULAR, label: y("types.regular") },
    { id: ti.SYMBOLS, label: y("types.symbols") }
  ];
  return /* @__PURE__ */ A(I, { className: M, col: !0, full: !0, children: [
    /* @__PURE__ */ A(I, { className: D, space: "s", col: !0, children: [
      R && /* @__PURE__ */ c(Ro, { tabs: Q, onChange: p, value: d, variant: "pills" }),
      B && /* @__PURE__ */ c(
        ft,
        {
          ref: b,
          size: "s",
          value: f,
          onInput: h,
          placeholder: L,
          type: "search"
        }
      )
    ] }),
    /* @__PURE__ */ A(N, { className: V, grow: !0, children: [
      v && (x.length ? /* @__PURE__ */ c(I, { className: k, children: x.map((X) => /* @__PURE__ */ c(rN, { symbol: X }, `${l}_${X.getId()}`)) }) : /* @__PURE__ */ c(I, { className: j, justify: "center", children: y("symbols.notFound") })),
      !v && (_.length ? /* @__PURE__ */ A(ae, { children: [
        !!(E != null && E.length) && /* @__PURE__ */ c(I, { className: J, children: E == null ? void 0 : E.map((X) => /* @__PURE__ */ c(om, { block: X, itemLayout: o }, X.id)) }),
        T.map(({ category: X, items: Z }, te) => /* @__PURE__ */ c(
          $o,
          {
            sticky: !0,
            className: (de) => Qd.itemList({ index: te, open: de, length: T.length }),
            open: !!(X != null && X.get("open")),
            onChange: ({ open: de }) => X == null ? void 0 : X.set({ open: de }),
            handler: im(i, X),
            handlerIcon: X == null ? void 0 : X.get("icon"),
            classNameWrap: q(le, `${le}--${X == null ? void 0 : X.id}`),
            children: /* @__PURE__ */ c(I, { className: Y, children: Z.map((de) => /* @__PURE__ */ c(om, { block: de, itemLayout: o }, de.id)) })
          },
          X == null ? void 0 : X.id
        ))
      ] }) : /* @__PURE__ */ c(I, { className: j, justify: "center", children: y("notFound") }))
    ] })
  ] });
}), oN = {
  add: ne.plus
}, am = (e, t) => t || oN[e];
function pf({ className: e, icon: t, title: n, onClose: r, actions: o = [], children: s }) {
  const { t: i } = Ne();
  return /* @__PURE__ */ A(I, { className: $("gjs-card-title", e), items: "center", children: [
    /* @__PURE__ */ c(N, { className: $("truncate"), grow: !0, children: n }),
    s,
    /* @__PURE__ */ A(I, { space: "s", children: [
      !!o.length && /* @__PURE__ */ c(I, { space: "xs", className: $("gjs-px-1"), children: o.map(({ id: a, icon: l, className: u, ...d }) => /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
        Ft,
        {
          block: !0,
          border: !1,
          size: "xs",
          icon: am(a, l) ? { icon: am(a, l), size: pe.s } : void 0,
          className: $(Qe.click, u),
          ...d
        }
      ) }, a)) }),
      (r || t) && /* @__PURE__ */ c(
        Ft,
        {
          title: i("close"),
          onClick: r,
          border: !1,
          className: $(Qe.click),
          icon: { icon: ne.close, size: pe.s },
          size: "xs",
          block: !0
        }
      )
    ] })
  ] });
}
const Un = "1.0.11", sN = [
  {
    id: "grapesjs-component-countdown",
    name: "Countdown",
    description: "Countdown component",
    src: "https://unpkg.com/grapesjs-component-countdown@1.0.1/dist/index.js",
    version: "1.0.1",
    projectType: [Ve.web],
    options: {
      props: {
        emptyState: !0
      }
    }
  },
  {
    id: "grapesjs-tabs",
    name: "Tabs",
    description: "Tabs component",
    src: "https://unpkg.com/grapesjs-tabs@1.0.6/dist/grapesjs-tabs.min.js",
    version: "1.0.6",
    projectType: [Ve.web],
    options: { tabsBlock: { category: "Extra", select: !0 } }
  },
  {
    id: "grapesjs-custom-code",
    name: "Custom code",
    description: "Component for the embed of custom code",
    src: "https://unpkg.com/grapesjs-custom-code@1.0.1/dist/index.js",
    version: "1.0.1",
    projectType: [Ve.web]
  },
  {
    id: "grapesjs-tooltip",
    name: "Tooltip",
    description: "Simple, CSS only, tooltip component",
    src: "https://unpkg.com/grapesjs-tooltip@0.1.7/dist/index.js",
    version: "0.1.7",
    projectType: [Ve.web],
    options: {
      propsTooltip: {
        emptyState: { styleOut: "width: 80px;" }
      }
    }
  },
  {
    id: "grapesjs-typed",
    name: "Typed",
    description: "Typed component based on Typed.js library",
    src: "https://unpkg.com/grapesjs-typed@2.0.1/dist/index.js",
    version: "2.0.1",
    projectType: [Ve.web],
    options: { block: { category: "Extra" } }
  },
  {
    id: "StudioSdkPlugins_tableComponent",
    name: "Table",
    description: "Add table component with additional functionalities.",
    src: `https://unpkg.com/@grapesjs/studio-sdk-plugins@${Un}/dist/tableComponent/index.umd.js`,
    version: Un,
    projectType: [Ve.web],
    options: { block: { category: "Extra" } }
  },
  {
    id: "StudioSdkPlugins_listPagesComponent",
    name: "List Pages",
    description: "Add a list component that dynamically generates navigation links based on the pages in your project.",
    src: `https://unpkg.com/@grapesjs/studio-sdk-plugins@${Un}/dist/listPagesComponent/index.umd.js`,
    version: Un,
    projectType: [Ve.web],
    options: { block: { category: "Extra" } }
  },
  {
    id: "StudioSdkPlugins_fsLightboxComponent",
    name: "FsLightbox",
    description: "Image viewer plugin based on FsLightbox.",
    src: `https://unpkg.com/@grapesjs/studio-sdk-plugins@${Un}/dist/fsLightboxComponent/index.umd.js`,
    version: Un,
    projectType: [Ve.web],
    options: { block: { category: "Extra" } }
  },
  {
    id: "StudioSdkPlugins_lightGalleryComponent",
    name: "LightGallery",
    description: "Gallery component based on lightGallery.",
    src: `https://unpkg.com/@grapesjs/studio-sdk-plugins@${Un}/dist/lightGalleryComponent/index.umd.js`,
    version: Un,
    projectType: [Ve.web],
    options: { block: { category: "Extra" } }
  },
  {
    id: "StudioSdkPlugins_swiperComponent",
    name: "Swiper (Slider)",
    description: "Slider component plugin based on Swiper.",
    src: `https://unpkg.com/@grapesjs/studio-sdk-plugins@${Un}/dist/swiperComponent/index.umd.js`,
    version: Un,
    projectType: [Ve.web],
    options: { block: { category: "Extra" } }
  }
], iN = () => new Promise((e) => {
  setTimeout(() => e(sN), 100);
}), lm = ue(function({
  plugin: t,
  selected: n,
  className: r,
  installed: o,
  onInstall: s,
  onSelect: i
}) {
  const a = Ne(), l = (d) => a.t(`pluginManager.${d}`), u = o[t.id];
  return /* @__PURE__ */ c(Jt, { className: F("overflow-hidden max-w-full group gjs-px-4 gjs-py-3", r), padding: !1, children: /* @__PURE__ */ c(I, { space: "s", col: !0, children: /* @__PURE__ */ c(I, { className: F("max-w-full"), nowrap: !0, children: /* @__PURE__ */ c(N, { grow: !0, className: F("w-full"), children: /* @__PURE__ */ A(I, { space: "s", col: !0, children: [
    /* @__PURE__ */ A(I, { items: "center", space: "s", nowrap: !0, children: [
      /* @__PURE__ */ c(N, { className: F(Qe.txtEllips, "cursor-pointer"), onClick: () => i == null ? void 0 : i(t), children: /* @__PURE__ */ c("b", { children: t.name }) }),
      /* @__PURE__ */ c(N, { grow: !0, children: /* @__PURE__ */ c(St, { className: F("opacity-90"), label: `v${t.version}`, s: "s", pill: !0, border: !0 }) }),
      /* @__PURE__ */ c(I, { children: /* @__PURE__ */ c(Ze, { className: F("text-sm"), size: "m2", variant: "pr", onClick: () => s(t), children: l(u ? "uninstall" : "install") }) })
    ] }),
    /* @__PURE__ */ c(N, { className: F(!n && Qe.txtEllips, "text-sm max-w-full"), children: t.description })
  ] }) }) }) }) });
}), H0 = ue(function({ selectedId: t }) {
  const n = Ne(), [r] = pc(), o = tf(), s = ye(), [i, a] = W(), [l, u] = W(), [d, p] = W(), [f, h] = W(
    "all"
    /* All */
  ), g = f === "all" ? d : l, m = n.tScoped("pluginManager");
  G(() => {
    (async () => {
      !l && u(await Mi()), !d && p(await iN());
    })();
  }, [l, d]), G(() => {
    if (t && d && !o.selectedShown) {
      const S = d.find((x) => x.id === t);
      S && a(S), o.setSelectedShown(!0);
    }
  }, [d]);
  const v = ie(
    () => [
      {
        id: "all",
        label: m("all")
      },
      {
        id: "installed",
        label: m("installed")
      }
    ],
    [n]
  ), b = it(
    async (S) => {
      l != null && l.find((x) => x.id === S.id) ? await eM(S) : await Qk(S), u(await Mi());
    },
    [l]
  ), y = ie(
    () => (l == null ? void 0 : l.reduce((S, x) => (S[x.id] = x.version, S), {})) || {},
    [l]
  ), w = !!(i || o.hasPending);
  return /* @__PURE__ */ A(I, { col: !0, full: !0, space: "m", children: [
    w && /* @__PURE__ */ A(I, { children: [
      !!i && /* @__PURE__ */ c(Ze, { onClick: () => a(void 0), className: F(z.tAo), border: !1, children: /* @__PURE__ */ A(I, { space: "xs", items: "center", children: [
        /* @__PURE__ */ c(oe, { icon: ne.chevronLeft, size: pe.s }),
        /* @__PURE__ */ c("div", { children: m("allPlugins") })
      ] }) }),
      o.hasPending && /* @__PURE__ */ c(Ze, { className: F("text-sm gjs-ml-auto"), size: "m2", variant: "out", onClick: s.updateStudio, children: m("updateStudio") })
    ] }),
    i ? /* @__PURE__ */ c(N, { grow: !0, className: F("w-full"), children: /* @__PURE__ */ c(lm, { plugin: i, installed: y, onInstall: b, selected: !0 }) }) : /* @__PURE__ */ A(ae, { children: [
      /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(Ro, { tabs: v, onChange: h, value: f }) }),
      /* @__PURE__ */ c(N, { grow: !0, children: g ? g.length ? /* @__PURE__ */ c(
        ia,
        {
          data: g,
          listClassName: F("grid grid-cols-1 gap-2 gjs-pr-2"),
          itemContent: (S, x) => /* @__PURE__ */ c(
            lm,
            {
              plugin: x,
              installed: y,
              onInstall: b,
              onSelect: a
            },
            x.id
          )
        },
        r
      ) : /* @__PURE__ */ c(I, { justify: "center", children: n.t("notItemsFound") }) : /* @__PURE__ */ c(sa, {}) })
    ] })
  ] });
}), aN = ue(function() {
  const { isOpen: t, toggleOpen: n } = Dv(), { editor: r, sdkProps: o, sdkOptions: s, isProjectTypeEmail: i } = ye(), a = Bn(), l = Ne(), u = o.children, d = l.tScoped("blockManager"), p = $(
    "absolute left-0 top-0 h-full transition-transform z-10",
    !t && "-translate-x-full",
    se.br,
    z.br,
    z.bg
  ), f = () => {
    a.open({
      fullH: !0,
      title: l.t("pluginManager.plugins"),
      content: () => /* @__PURE__ */ c(H0, {})
    });
  }, h = ie(
    () => [
      !!s.pluginManager && !i && {
        id: "add",
        title: d("add"),
        className: z.tAo,
        onClick: f,
        icon: ne.viewGridPlus
      }
    ].filter(Boolean),
    [r]
  );
  return /* @__PURE__ */ A(I, { className: p, style: { width: 240 }, col: !0, nowrap: !0, children: [
    /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(pf, { title: d("blocks"), onClose: n, className: $(Re.s), actions: h }) }),
    /* @__PURE__ */ A(Mo, { children: [
      qt(u, m0),
      /* @__PURE__ */ c(N, { className: $("overflow-hidden"), grow: !0, children: /* @__PURE__ */ c(V0, { isOpen: t }) }),
      qt(u, g0)
    ] })
  ] });
}), lN = {
  pointerEvents: "all"
};
function ss({ spot: e, children: t, style: n, spotStyles: r, ...o }) {
  const s = {
    ...r || e.getStyle(),
    ...n
  };
  return /* @__PURE__ */ c("div", { ...o, style: s, children: /* @__PURE__ */ c("div", { style: lN, children: t }) });
}
const Yn = Rt(function({ children: t, className: n, position: r, out: o, ...s }, i) {
  var f;
  const { Canvas: a } = Tn(), l = ((f = a.getCanvasView()) == null ? void 0 : f.clsUnscale) || "", u = [], d = {};
  switch (r) {
    case "top-left":
      u.push("top-0", "left-0"), d.transformOrigin = "top left", o && (d.translate = "0 -100%", d.transformOrigin = "bottom left");
      break;
    case "top-center":
      u.push("top-0"), d.left = "50%", d.translate = "-50% 0", d.transformOrigin = "top center", o && (d.translate = "-50% -100%", d.transformOrigin = "bottom center");
      break;
    case "top-right":
      u.push("top-0", "right-0"), d.transformOrigin = "top right", o && (d.translate = "0 -100%", d.transformOrigin = "bottom right");
      break;
    case "center-left":
      u.push("left-0"), d.top = "50%", d.translate = "0 -50%", d.transformOrigin = "center left", o && (d.translate = "-100% -50%", d.transformOrigin = "center right");
      break;
    case "center-center":
      d.top = "50%", d.left = "50%", d.translate = "-50% -50%", d.transformOrigin = "center";
      break;
    case "center-right":
      u.push("right-0"), d.top = "50%", d.translate = "0 -50%", d.transformOrigin = "center right", o && (d.translate = "100% -50%", d.transformOrigin = "center left");
      break;
    case "bottom-left":
      u.push("left-0", "bottom-0"), d.transformOrigin = "bottom left", o && (d.translate = "0 100%", d.transformOrigin = "top left");
      break;
    case "bottom-center":
      u.push("bottom-0"), d.left = "50%", d.translate = "-50% 0", d.transformOrigin = "bottom center", o && (d.translate = "-50% 100%", d.transformOrigin = "top center");
      break;
    case "bottom-right":
      u.push("right-0", "bottom-0"), d.transformOrigin = "bottom right", o && (d.translate = "0 100%", d.transformOrigin = "top right");
      break;
  }
  const p = {
    ...d,
    ...s.style
  };
  return /* @__PURE__ */ c(
    "div",
    {
      ...s,
      className: q(l, F("gs-utl-flex gs-utl-absolute", n, u.join(" "))),
      style: p,
      ref: i,
      children: t
    }
  );
}), cm = "top-left";
function B0({ spot: e, className: t }) {
  const n = Tn(), { Canvas: r } = n, [o, s] = W(cm), i = e.component, a = e.getBoxRect(), l = r.getWorldRectToScreen(a), u = K(null), d = r.getElement().clientHeight;
  return vv(u, {
    zoomMultiplier: r.getZoomMultiplier(),
    boxRectScreen: l,
    vwHeight: d,
    setPos: s,
    initialPos: cm
  }), !i || i.get("badgable") === !1 ? null : /* @__PURE__ */ c(Yn, { className: F("pointer-events-none"), ref: u, style: z0, position: o, out: !0, children: /* @__PURE__ */ c(St, { className: F("shadow-md", t || Bl(i).bg), s: "s", children: /* @__PURE__ */ A(I, { space: "xs", items: "center", nowrap: !0, children: [
    Ev(i),
    /* @__PURE__ */ c("div", { className: F("whitespace-nowrap max-w-36 truncate"), children: i.getName() })
  ] }) }) });
}
function cN({ spot: e, className: t }) {
  const n = F("gjs-border", Bl(e.component).border, t);
  return /* @__PURE__ */ c(ss, { spot: e, className: n, children: /* @__PURE__ */ c(B0, { spot: e }) });
}
function uN({ spot: e, className: t }) {
  const n = Tn(), r = ye(), o = K(null), [s] = W(z0), [i, a] = W([]), [l, u] = W([]), [d, p] = W("top-right"), f = e.component, h = e.getBoxRect(), { Canvas: g } = n, m = g.getWorldRectToScreen(h), v = e.getStyle({ boxRect: h }), b = n.getSelected() === f, y = g.getElement().clientHeight, w = Np();
  G(() => {
    const E = setTimeout(async () => {
      const T = await w.getItemsForComponent(f);
      a(T);
    }, 10);
    return () => clearTimeout(E);
  }, [f]), G(() => {
    const E = setTimeout(async () => {
      const T = await dN(f, r);
      u(T);
    }, 10);
    return () => clearTimeout(E);
  }, [f]), vv(o, {
    zoomMultiplier: g.getZoomMultiplier(),
    boxRectScreen: m,
    vwHeight: y,
    setPos: p
  });
  const S = (O) => {
    Mt(O) ? n.runCommand(O) : O == null || O(n, "", {});
  }, x = (O) => {
    const E = O.currentTarget.getBoundingClientRect();
    w.show({
      items: i,
      x: E.x + E.width,
      y: E.y
    });
  }, C = Bl(f), P = F("border-2", C.border, t), _ = F(C.bg, "overflow-hidden shadow-md");
  return /* @__PURE__ */ c(ss, { spot: e, spotStyles: v, className: P, children: b && /* @__PURE__ */ c(Yn, { ref: o, style: s, position: d, out: !0, children: /* @__PURE__ */ c(St, { className: _, s: "s", nopad: !0, block: !0, children: /* @__PURE__ */ A(I, { space: "x2s", items: "center", nowrap: !0, children: [
    l.map(({ label: O, command: E = "" }) => /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
      Ze,
      {
        border: !1,
        rounded: !1,
        size: "s",
        className: F("block gs-utl-py-1.5 gs-utl-px-1.5", z.hBgDark),
        onMouseDown: () => S(E),
        children: O != null && O.startsWith("<svg") ? /* @__PURE__ */ c(Xd, { className: F("w-4 fill-current"), svg: O }) : O
      }
    ) }, O)),
    !!i.length && /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
      Ze,
      {
        border: !1,
        rounded: !1,
        size: "s",
        className: F("block", z.hBgDark),
        onClick: x,
        children: /* @__PURE__ */ c(oe, { icon: ne.dotsVertical, size: pe.s })
      }
    ) })
  ] }) }) }) });
}
async function dN(e, t) {
  var d;
  if (!(e != null && e.em))
    return [];
  const n = e.em.getEditor(), r = e.toolbar.filter(Boolean), o = e.get("toolbarItems"), s = await Lu(o, { items: r, component: e, editor: n }), i = {
    items: s,
    component: e,
    editor: n
  }, a = await Lu(s, i), l = (d = t.sdkComponentsConfig) == null ? void 0 : d.toolbar;
  return await Lu(l, { ...i, items: a });
}
const Lu = async (e, t) => ct(e) ? (await e(t)).filter(Boolean) : t.items;
var Mn = /* @__PURE__ */ ((e) => (e.PaddingTop = "padding-top", e.PaddingRight = "padding-right", e.PaddingBottom = "padding-bottom", e.PaddingLeft = "padding-left", e.MarginTop = "margin-top", e.MarginRight = "margin-right", e.MarginBottom = "margin-bottom", e.MarginLeft = "margin-left", e))(Mn || {});
const { PaddingTop: Ba, PaddingRight: ku, PaddingBottom: za, PaddingLeft: Mu, MarginTop: Fa, MarginRight: $u, MarginBottom: Ua, MarginLeft: Ru } = Mn, pN = (e, t) => {
  const n = t != null && t.startsWith("p") ? "padding" : "margin";
  return P5(e, n, t);
}, Vr = (e, t, n = {}) => {
  const r = Tn(), o = kv(), [s, i] = W(), a = (d) => {
    const f = r.Canvas.getFramesEl().classList, h = d ? "add" : "remove";
    f[h]("gs-utl-pointer-events-none"), f[h]("gs-utl-select-none");
  }, l = (d) => {
    var p, f;
    (p = n.setAltKey) == null || p.call(n, d.altKey), (f = n.setShiftKey) == null || f.call(n, d.shiftKey);
  };
  return G(() => {
    var T;
    const d = [Ba, za, Fa, Ua].includes(t), p = document.body.classList, f = e.component.getEl(), h = r.Styles.getSelected(), g = window.getComputedStyle(f), m = d ? "!cursor-ns-resize" : "!cursor-ew-resize", v = r.Canvas.getZoomMultiplier(), b = {};
    let y = parseFloat(g[t]) ?? 0, w, S = "", x = {};
    for (const R of Object.values(Mn)) {
      const B = R;
      b[B] = g[B];
    }
    const C = (R, B) => {
      const U = t == null ? void 0 : t.startsWith("p"), { altKey: L, shiftKey: M } = B, D = b, V = {
        [Ba]: M || t === za && L ? R : D[Ba],
        [ku]: M || t === Mu && L ? R : D[ku],
        [za]: M || t === Ba && L ? R : D[za],
        [Mu]: M || t === ku && L ? R : D[Mu]
      }, k = {
        [Fa]: M || t === Ua && L ? R : D[Fa],
        [$u]: M || t === Ru && L ? R : D[$u],
        [Ua]: M || t === Fa && L ? R : D[Ua],
        [Ru]: M || t === $u && L ? R : D[Ru]
      };
      return V[t] = R, k[t] = R, U ? V : k;
    }, P = (R) => {
      S && (w ? w.upValue(S, R) : h == null || h.addStyle(x, R));
    }, _ = (R) => {
      if (!s || !h)
        return;
      const B = d ? R.clientY - s.y : R.clientX - s.x, U = Math.max(0, parseInt(`${y + B * v}`));
      S = `${U}px`, x = C(S, R), P({ partial: !0 }), o.show(U);
    }, O = () => {
      !s || !h || (i(void 0), a(!1), o.hide(), P());
    }, E = (R) => {
      l(R), x = C(S, R), P({ partial: !0 });
    };
    return s && (document.addEventListener("pointermove", _), document.addEventListener("pointerup", O), document.addEventListener("keydown", E), document.addEventListener("keyup", E), p.add(m), (T = n.onActive) == null || T.call(n, t), n.useStyleProperty && (w = pN(r, t), y = (w == null ? void 0 : w.getValue()) ?? y)), () => {
      var R;
      document.removeEventListener("pointermove", _), document.removeEventListener("pointerup", O), document.removeEventListener("keydown", E), document.removeEventListener("keyup", E), p.remove(m), (R = n.onActive) == null || R.call(n, void 0);
    };
  }, [s]), [it((d) => {
    if (d.button !== 0)
      return;
    const { clientX: p, clientY: f } = d;
    i({ x: p, y: f }), a(!0), l(d.nativeEvent);
  }, []), !!s];
}, Wa = "gs-utl-border-2 gs-utl-border-white !gs-utl-box-content", um = "gs-utl-bg-[#7fc65e]", dm = "gs-utl-bg-[#ebae70]", pm = "gs-utl-h-5 gs-utl-w-1 gs-utl-mx-2 gs-utl-cursor-ew-resize", fm = "gs-utl-h-1 gs-utl-w-5 gs-utl-my-2 gs-utl-cursor-ns-resize", fN = we(function({
  spot: t,
  disabledHandler: n,
  useStyleProperty: r,
  onActive: o
}) {
  const [s, i] = W(!1), [a, l] = W(!1), u = { onActive: o, setAltKey: i, setShiftKey: l, useStyleProperty: r }, [d, p] = Vr(t, "padding-top", u), [f, h] = Vr(t, "padding-right", u), [g, m] = Vr(t, "padding-bottom", u), [v, b] = Vr(t, "padding-left", u), [y, w] = Vr(t, "margin-top", u), [S, x] = Vr(t, "margin-right", u), [C, P] = Vr(t, "margin-bottom", u), [_, O] = Vr(t, "margin-left", u), E = F(Wa, um, pm), T = F(Wa, um, fm), R = F(Wa, dm, pm), B = F(Wa, dm, fm), U = p || h || m || b, L = w || x || P || O, M = U || L, D = (Z, te) => {
    let de = !1;
    const ce = U && a, Ce = L && a;
    switch (te) {
      case "padding-top":
        de = m && s || ce;
        break;
      case "padding-right":
        de = b && s || ce;
        break;
      case "padding-bottom":
        de = p && s || ce;
        break;
      case "padding-left":
        de = h && s || ce;
        break;
      case "margin-top":
        de = P && s || Ce;
        break;
      case "margin-right":
        de = O && s || Ce;
        break;
      case "margin-bottom":
        de = w && s || Ce;
        break;
      case "margin-left":
        de = x && s || Ce;
        break;
    }
    return !M || Z || de;
  }, V = !!(n != null && n.padding), k = !!(n != null && n.margin), j = !V && D(
    p,
    "padding-top"
    /* PaddingTop */
  ), Y = !V && D(
    h,
    "padding-right"
    /* PaddingRight */
  ), J = !V && D(
    m,
    "padding-bottom"
    /* PaddingBottom */
  ), le = !V && D(
    b,
    "padding-left"
    /* PaddingLeft */
  ), Q = !k && D(
    w,
    "margin-top"
    /* MarginTop */
  ), re = !k && D(
    x,
    "margin-right"
    /* MarginRight */
  ), ge = !k && D(
    P,
    "margin-bottom"
    /* MarginBottom */
  ), X = !k && D(
    O,
    "margin-left"
    /* MarginLeft */
  );
  return /* @__PURE__ */ A(ae, { children: [
    j && /* @__PURE__ */ c(Yn, { position: "top-center", onPointerDown: d, children: /* @__PURE__ */ c(St, { className: T, s: "s", pill: !0, block: !0, nopad: !0 }) }),
    Y && /* @__PURE__ */ c(Yn, { position: "center-right", onPointerDown: f, children: /* @__PURE__ */ c(St, { className: E, s: "s", pill: !0, block: !0, nopad: !0 }) }),
    J && /* @__PURE__ */ c(Yn, { position: "bottom-center", onPointerDown: g, children: /* @__PURE__ */ c(St, { className: T, s: "s", pill: !0, block: !0, nopad: !0 }) }),
    le && /* @__PURE__ */ c(Yn, { position: "center-left", onPointerDown: v, children: /* @__PURE__ */ c(St, { className: E, s: "s", pill: !0, block: !0, nopad: !0 }) }),
    Q && /* @__PURE__ */ c(Yn, { position: "top-center", onPointerDown: y, out: !0, children: /* @__PURE__ */ c(St, { className: B, s: "s", pill: !0, block: !0, nopad: !0 }) }),
    re && /* @__PURE__ */ c(Yn, { position: "center-right", onPointerDown: S, out: !0, children: /* @__PURE__ */ c(St, { className: R, s: "s", pill: !0, block: !0, nopad: !0 }) }),
    ge && /* @__PURE__ */ c(Yn, { position: "bottom-center", onPointerDown: C, out: !0, children: /* @__PURE__ */ c(St, { className: B, s: "s", pill: !0, block: !0, nopad: !0 }) }),
    X && /* @__PURE__ */ c(Yn, { position: "center-left", onPointerDown: _, out: !0, children: /* @__PURE__ */ c(St, { className: R, s: "s", pill: !0, block: !0, nopad: !0 }) })
  ] });
}), hm = (e, t) => {
  var n;
  return !!((n = Av(e, t)) != null && n.isVisible());
}, hN = (e = {}) => {
  const [t, n, r, o] = Ah(e.padding || ""), [s, i, a, l] = Ah(e.margin || "");
  return {
    paddingTop: e[Mn.PaddingTop] || t,
    paddingRight: e[Mn.PaddingRight] || n,
    paddingBottom: e[Mn.PaddingBottom] || r,
    paddingLeft: e[Mn.PaddingLeft] || o,
    marginTop: e[Mn.MarginTop] || s,
    marginRight: e[Mn.MarginTop] || i,
    marginBottom: e[Mn.MarginTop] || a,
    marginLeft: e[Mn.MarginTop] || l
  };
};
function gN({ spot: e, className: t }) {
  const n = Tn(), { isProjectTypeEmail: r } = ye(), [o, s] = W(), [i, a] = W({
    padding: !1,
    margin: !1
  }), { el: l, component: u } = e, d = e.getBoxRect(), p = n.Canvas.getZoomDecimal(), f = d.height * p, h = d.width * p, g = e.getStyle({ boxRect: d }), m = n.getSelectedAll().includes(u), v = n.getSelected() === u, b = (o == null ? void 0 : o.startsWith("p")) ?? !1, y = (o == null ? void 0 : o.startsWith("m")) ?? !1, w = hN(r ? u == null ? void 0 : u.getStyle() : {});
  if (G(() => {
    m && a({
      padding: !hm(n, "padding"),
      margin: !hm(n, "margin")
    });
  }, [m]), e.type === "spacing" && m)
    return null;
  const S = {
    borderColor: "rgba(196, 222, 184, 0.5)",
    // '#c4deb8',
    borderStyle: "solid"
  }, x = {
    borderColor: "rgba(249, 204, 158, 0.5)",
    // '#f9cc9e',
    borderStyle: "solid",
    boxSizing: "content-box"
  }, C = window.getComputedStyle(l);
  S.borderTopWidth = w.paddingTop || C.paddingTop, S.borderRightWidth = w.paddingRight || C.paddingRight, S.borderBottomWidth = w.paddingBottom || C.paddingBottom, S.borderLeftWidth = w.paddingLeft || C.paddingLeft, x.borderTopWidth = w.marginTop || C.marginTop, x.borderRightWidth = w.marginTop || C.marginRight, x.borderBottomWidth = w.marginTop || C.marginBottom, x.borderLeftWidth = w.marginTop || C.marginLeft;
  const P = {
    ...g,
    ...S
  }, _ = {
    ...g,
    ...x,
    translate: `${d.x - parseFloat(C.marginLeft)}px ${d.y - parseFloat(C.marginTop)}px`
  };
  return /* @__PURE__ */ A(ae, { children: [
    (!m || b) && /* @__PURE__ */ c(ss, { spot: e, spotStyles: P, className: F(t) }),
    (!m || y) && /* @__PURE__ */ c(ss, { spot: e, spotStyles: _, className: F(t) }),
    v && (f > 60 && h > 60 || o) && /* @__PURE__ */ c(ss, { spot: e, spotStyles: g, className: F(t), children: /* @__PURE__ */ c(
      fN,
      {
        spot: e,
        onActive: s,
        disabledHandler: i,
        useStyleProperty: r
      }
    ) })
  ] });
}
function mN({ spot: e, className: t }) {
  const n = F("gjs-border-2", z.cmpTargetBr, z.cmpTargetBgOpac, t);
  return /* @__PURE__ */ c(ss, { spot: e, className: n, children: /* @__PURE__ */ c(B0, { spot: e, className: F(z.cmpTargetBg) }) });
}
const vN = 9, z0 = {
  padding: `${vN}px 0`
};
function bN({ spot: e }) {
  const t = Tn(), { Canvas: n } = t, r = ye(), o = t.getEditing(), { type: s, component: i } = e, a = s === "select", l = s === "spacing", u = s === "hover", d = s === "target";
  return !e.el || !n.hasCustomSpot(s) || // When selecting a target, skip any other spot besides the 'target'
  r.isSelectingTarget && !d || // Avoid hover/spacing spots on inner components during editing
  (u || l) && o && (i != null && i.isChildOf(o)) ? null : /* @__PURE__ */ A(ae, { children: [
    (l || a) && /* @__PURE__ */ c(gN, { spot: e, className: F("z-0") }),
    d && /* @__PURE__ */ c(mN, { spot: e, className: F("z-10") }),
    a && /* @__PURE__ */ c(uN, { spot: e, className: F("z-20") }),
    u && /* @__PURE__ */ c(cN, { spot: e, className: F("z-30") })
  ] });
}
const gm = /* @__PURE__ */ new WeakMap();
function F0(e) {
  if (!e)
    return () => null;
  const t = gm.get(e);
  if (t)
    return t;
  const n = function({ children: o }) {
    return Nd.createPortal(o, e);
  };
  return gm.set(e, n), n;
}
const yN = we(function({ children: t }) {
  const n = Hp(), [r, o] = W([]), [s, i] = W({});
  G(() => {
    if (!n)
      return;
    n.onReady(() => {
      const d = n.Canvas.getSpotsEl(), p = F0(d);
      i({ Container: p });
    });
    const l = "canvas:spot", u = () => {
      const d = n.Canvas.getSpots();
      o(d);
    };
    return n.on(l, u), () => {
      n.off(l, u);
    };
  }, [n]);
  const { Container: a } = s;
  return n && a ? /* @__PURE__ */ c(a, { children: t({ spots: r }) }) : null;
}), wN = ue(function() {
  const { isCanvasPanning: t } = ye();
  return /* @__PURE__ */ c(yN, { children: ({ spots: n }) => /* @__PURE__ */ c(rr, { show: !t, ...x1, children: n.map((r) => /* @__PURE__ */ c(bN, { spot: r }, r.id)) }) });
}), Uo = "gs-layout-panel", SN = we(
  ue(function({ className: t, layout: n, children: r }) {
    const o = Vp(), s = Bn(), [i, a] = W(!1), [l, u] = W(null), { id: d, header: p, layout: f, props: h, full: g = !0, style: m, toRemove: v, disablePropagation: b } = n, y = () => {
      a(!1), setTimeout(() => o.remove(d, { force: !0 }), 150);
    }, w = n.placer || { type: Ko.absolute, position: Go.left }, S = w.type === Ko.absolute ? w : null, x = w.type === Ko.popover ? w : null, C = w.type === Ko.static ? w : null, P = w.type === Ko.dialog ? w : null, _ = (S == null ? void 0 : S.position) === Go.left, O = (S == null ? void 0 : S.position) === Go.right, E = (S == null ? void 0 : S.position) === Go.top, T = (S == null ? void 0 : S.position) === Go.bottom, R = C || P, B = Mt(f) ? { type: f } : f, U = !!S, { x: L, y: M } = x || {}, D = (x == null ? void 0 : x.w) || (x == null ? void 0 : x.width), V = (x == null ? void 0 : x.h) || (x == null ? void 0 : x.height), k = ie(
      () => ({
        // avoid popper loop bug
        clientWidth: 0,
        clientHeight: 0,
        getBoundingClientRect: () => new DOMRect(L, M, D, V)
      }),
      [L, M, D, V, i]
    ), j = Ts(k, l, {
      ...Sv,
      placement: "auto",
      ...x == null ? void 0 : x.options
    }), Y = q(
      Uo,
      z.br,
      z.bg,
      z.txt,
      "gs-utl-z-10",
      U && "gs-utl-absolute gs-utl-transition",
      (_ || E) && "gs-utl-top-0 gs-utl-left-0",
      O && "gs-utl-top-0 gs-utl-right-0",
      T && "gs-utl-bottom-0 gs-utl-left-0",
      U && g && (_ || O ? "gs-utl-h-full" : "gs-utl-w-full"),
      !i && U ? "gs-utl-opacity-0" : "gs-utl-opacity-100",
      !i && _ && "-gs-utl-translate-x-full",
      !i && O && "gs-utl-translate-x-full",
      !i && E && "-gs-utl-translate-y-full",
      !i && T && "gs-utl-translate-y-full",
      x && se.rnd,
      x && se.b,
      n.className,
      t
    );
    G(() => {
      const re = setTimeout(() => a(!0));
      return () => clearTimeout(re);
    }, []), G(() => {
      v && y();
    }, [v]);
    const J = {
      ...m,
      width: (m == null ? void 0 : m.width) || (_ || O ? 240 : void 0)
    };
    mv(
      { current: l },
      {
        onTrigger: y,
        enabled: (x == null ? void 0 : x.closeOnClickAway) && i
      }
    );
    const le = (re) => {
      b && re.nativeEvent.stopImmediatePropagation();
    }, Q = /* @__PURE__ */ A(I, { className: Y, style: J, col: !0, nowrap: !0, onPointerDown: le, onMouseDown: le, children: [
      p !== !1 && /* @__PURE__ */ c(N, { className: q(`${Uo}__header`, p == null ? void 0 : p.className), style: p == null ? void 0 : p.style, children: /* @__PURE__ */ c(
        pf,
        {
          onClose: (p == null ? void 0 : p.close) !== !1 ? y : void 0,
          className: F(Re.s),
          title: /* @__PURE__ */ A(I, { className: `${Uo}__title`, space: "s", items: "center", children: [
            !!(p != null && p.icon) && /* @__PURE__ */ c(oe, { icon: p.icon, size: pe.s }),
            !!(p != null && p.label) && /* @__PURE__ */ c(N, { grow: !0, children: p.label })
          ] })
        }
      ) }),
      /* @__PURE__ */ c(N, { className: q(`${Uo}__content`, "gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"), grow: !0, children: f || d ? un({ ...h, id: d, ...B }) : r })
    ] });
    return G(() => {
      if (i) {
        if (C) {
          const re = o.layoutsById.get(C.layoutId);
          if (re)
            return re.setState({ children: Q }), () => {
              !n.placer.skipCleanup && re.setState({ children: null });
            };
        } else if (P)
          return s.open({
            // use function to avoid mobx errors
            content: () => Q,
            disablePropagation: b,
            title: P.title,
            size: P.size,
            onClose: y
          }), () => {
            s.close();
          };
      }
    }, [i]), R ? null : x ? /* @__PURE__ */ c(
      "div",
      {
        className: F(Uo, `${Uo}-popover`, "gs-utl-z-20"),
        ref: u,
        style: j.styles.popper,
        ...j.attributes.popper,
        children: /* @__PURE__ */ c(rr, { show: i, ...zi, unmount: !1, children: Q })
      }
    ) : Q;
  })
), xN = ue(function({
  className: t,
  ...n
}) {
  const { layouts: r } = Vp();
  return /* @__PURE__ */ c("div", { className: q("gs-layout-panel-container", t), ...n, children: r.map((o) => /* @__PURE__ */ c(SN, { layout: o }, o.id)) });
}), hr = "gs-cmp-modal";
function U0({
  open: e = !1,
  title: t,
  disablePropagation: n,
  isDarkTheme: r,
  description: o,
  children: s,
  onClose: i,
  closable: a = !0,
  fullH: l,
  buttons: u = [],
  size: d
}) {
  const p = () => a && i(), f = q(
    u1,
    `${hr} gs-utl-fixed gs-utl-z-20 gs-utl-inset-0 gs-utl-overflow-y-auto`,
    r && dd
  ), h = q(
    `${hr}-wrapper gs-utl-relative gs-utl-flex gs-utl-justify-center gs-utl-min-h-screen`,
    l ? "gs-utl-items-stretch" : "gs-utl-items-center"
  ), g = q(
    `${hr}-container`,
    "gs-utl-relative gs-utl-w-full gs-utl-p-5 gs-utl-my-8 gs-utl-overflow-hidden gs-utl-shadow-xl gs-utl-rounded-xl gs-utl-flex gs-utl-flex-col",
    se.b,
    z.br,
    z.bg,
    z.txt,
    d === "lg" ? "gs-utl-max-w-lg" : d === "l" ? "gs-utl-max-w-5xl" : d === "s" ? "gs-utl-max-w-sm" : "gs-utl-max-w-md"
  ), m = q(
    `${hr}-overlay gs-utl-absolute gs-utl-inset-0 gs-utl-bg-black/50 gs-utl-transition-opacity`
  ), v = q(`${hr}-close gs-utl-absolute gs-utl-top-0 gs-utl-right-0 gs-utl-m-3`), b = q(`${hr}-title gs-utl-text-lg gs-utl-font-medium gs-utl-leading-6 gs-utl-m-0`), y = q(`${hr}-desc gs-utl-m-0`), w = q(`${hr}-content gs-utl-mt-4 gs-utl-h-full`), S = q(`${hr}-buttons gs-utl-mt-4`), x = (C) => {
    n && C.nativeEvent.stopImmediatePropagation();
  };
  return /* @__PURE__ */ c(rr, { show: e, as: wt, children: /* @__PURE__ */ c(Fs, { onClose: p, className: f, onPointerDown: x, onMouseDown: x, children: /* @__PURE__ */ A("div", { className: h, children: [
    /* @__PURE__ */ c(rr.Child, { as: wt, ...zi, children: /* @__PURE__ */ c(Fs.Overlay, { className: m }) }),
    /* @__PURE__ */ c(rr.Child, { as: wt, ...Zd, children: /* @__PURE__ */ A("div", { className: g, children: [
      a && /* @__PURE__ */ c("div", { className: v, children: /* @__PURE__ */ c(Ft, { block: !0, border: !1, onClick: p, children: /* @__PURE__ */ c(oe, { icon: ne.close, size: 1 }) }) }),
      /* @__PURE__ */ c(Fs.Title, { as: "h3", className: b, children: t }),
      /* @__PURE__ */ c(Fs.Description, { className: y, children: o }),
      /* @__PURE__ */ c("div", { className: w, children: s }),
      u.length > 0 && /* @__PURE__ */ c(I, { className: S, space: "m", items: "center", justify: "end", children: u.map((C, P) => /* @__PURE__ */ c(Ze, { ...C }, P)) })
    ] }) }),
    /* @__PURE__ */ c(Fs, { onClose: () => {
    }, open: !1 })
  ] }) }) });
}
const CN = ue(function() {
  const { isOpen: t, close: n, content: r, modalProps: o } = Bn(), { isDarkTheme: s } = cn();
  return /* @__PURE__ */ c(U0, { open: t, onClose: n, isDarkTheme: s, ...o, children: ct(r) ? r() : r });
}), PN = "gs-panel-page-settings-cnt", EN = ue(function() {
  const t = Ne(), n = ye(), { panelPageSettings: r } = n, o = t.tScoped("pageManager.settings"), { isOpen: s, page: i, width: a } = r, l = $(
    PN,
    "absolute left-0 top-0 h-full transition-transform z-10",
    !s && "-translate-x-full",
    se.br,
    z.br,
    z.bg
  ), u = $(Re.s), d = () => n.setPanelPageSettings({ isOpen: !1 });
  return /* @__PURE__ */ A(I, { className: l, style: { width: a }, col: !0, nowrap: !0, children: [
    /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(pf, { title: o("title"), onClose: d, className: u }) }),
    /* @__PURE__ */ c(Mo, { children: /* @__PURE__ */ c(N, { className: $("overflow-hidden"), grow: !0, children: r.isOpen && /* @__PURE__ */ c(
      _0,
      {
        page: i,
        size: ic.s,
        classNameHeader: u,
        classNameContent: u,
        classNameFooter: u
      }
    ) }) })
  ] });
}), mm = "gs-cmp-custom-rte", ON = ue(function({ items: t }) {
  const n = (r) => r.nativeEvent.stopImmediatePropagation();
  return /* @__PURE__ */ c(
    Jt,
    {
      className: q(mm, "gs-utl-m-2"),
      size: "s",
      onPointerDown: n,
      onMouseDown: n,
      classNameBody: q(`${mm}__body`, "gs-utl-flex gs-utl-gap-1 gs-utl-items-center"),
      children: un(t)
    }
  );
});
function _N({ children: e }) {
  const t = Hp(), [n, r] = W({
    enabled: !1,
    actions: [],
    Container: () => null
  });
  G(() => {
    if (!t)
      return;
    const l = t.RichTextEditor, u = l.events.custom, d = (p) => {
      let f;
      const h = l.customRte, g = h == null ? void 0 : h.toolbar, m = l.model.attributes.currentView;
      g && (m != null && m.model) && (f = g({
        editor: t,
        view: m,
        component: m.model,
        el: m.getChildrenContainer()
      }));
      const v = l.getAll().map((b) => ({
        id: b.name,
        icon: b.icon,
        run: () => l.run(b),
        state: b.currentState
      }));
      r({
        customRte: h,
        customToolbar: f,
        enabled: p.enabled,
        Container: F0(p.container),
        actions: v
      });
    };
    return t.on(u, d), () => {
      t.off(u, d);
    };
  }, [t]);
  const { Container: o, customToolbar: s, customRte: i } = n;
  return t && o ? /* @__PURE__ */ c(o, { children: i ? s ? /* @__PURE__ */ c(ON, { items: s }) : null : e(n) }) : null;
}
function TN() {
  return /* @__PURE__ */ c(_N, { children: ({ actions: e }) => /* @__PURE__ */ c(I, { className: $(z.bg, se.b, se.rnd, z.br, "gjs-m-2"), nowrap: !0, children: e.map((t, n) => /* @__PURE__ */ c(
    Ze,
    {
      border: !1,
      rounded: !1,
      active: t.state === 1,
      disabled: t.state === -1,
      className: $("w-6", z.br, n !== 0 && se.bl),
      dangerouslySetInnerHTML: { __html: t.icon },
      onClick: t.run
    },
    t.id
  )) }) });
}
const AN = ue((e) => {
  const { select: t, close: n, Container: r, open: o } = e, s = ea(), { editor: i } = ye();
  if (!i || !o)
    return /* @__PURE__ */ c(r, { children: null });
  const { providers: a, onSelect: l, typeId: u, providerId: d, types: p, optionalType: f, content: h } = i.Assets.__customData().options;
  return /* @__PURE__ */ c(r, { children: /* @__PURE__ */ c(
    f0,
    {
      panelId: s.mainPanelId,
      onSelect: l ?? (({ asset: g }) => t(g)),
      close: n,
      types: p,
      providers: a,
      typeId: u,
      providerId: d,
      optionalType: f,
      content: h
    }
  ) });
}), LN = ue(function() {
  var b, y;
  const t = ye(), n = ea(), { projectType: r, editorKey: o, setEditor: s, sdkProps: i, sdkOptions: a, currentLayout: l } = t, { isDarkTheme: u } = cn(), d = !!((y = (b = a.gjsOptions) == null ? void 0 : b.assetManager) != null && y.custom), p = tf(), [f, h] = ie(
    () => [Zk(r, a), p.getPluginsToLoad(r, t)],
    [r, o]
  ), g = (w) => {
    var S, x;
    s(w), n.onEditor(), (S = i.onEditor) == null || S.call(i, w), (x = a.onEditor) == null || x.call(a, w), w.on("destroy", () => {
      var C;
      s(), (C = a.onDestroy) == null || C.call(a, w), t.setIsReady(!1);
    });
  }, m = (w) => {
    var S, x;
    (S = i.onReady) == null || S.call(i, w), (x = a.onReady) == null || x.call(a, w), t.setIsReady(!0);
  }, v = (w, S) => {
    var x, C;
    (x = i.onUpdate) == null || x.call(i, w, S), (C = a.onUpdate) == null || C.call(a, w, S);
  };
  return /* @__PURE__ */ A(
    o3,
    {
      className: $("gs-editor-gjs h-full w-full", se.b, z.br),
      grapesjs: a.gjsScript,
      grapesjsCss: a.gjsStyle,
      options: f,
      plugins: h,
      onEditor: g,
      onReady: m,
      onUpdate: v,
      children: [
        un(l),
        /* @__PURE__ */ c(xN, {}),
        /* @__PURE__ */ c(aN, {}),
        /* @__PURE__ */ c(EN, {}),
        !d && /* @__PURE__ */ c(XA, { children: (w) => /* @__PURE__ */ c(AN, { ...w }) }),
        /* @__PURE__ */ c(s3, { children: ({ open: w, title: S, close: x, content: C }) => /* @__PURE__ */ c(U0, { open: w, onClose: x, title: /* @__PURE__ */ c(ae, { children: S }), isDarkTheme: u, size: "l", children: /* @__PURE__ */ c(ae, { children: C }) }) }),
        /* @__PURE__ */ c(wN, {}),
        /* @__PURE__ */ c(TN, {}),
        /* @__PURE__ */ c(CN, {})
      ]
    },
    o
  );
}), W0 = "0.22.6", kN = `https://cdn.jsdelivr.net/npm/grapesjs@${W0}/dist/grapes.min.js`, MN = `https://cdn.jsdelivr.net/npm/grapesjs@${W0}/dist/css/grapes.min.css`, $N = !1, RN = ue(function() {
  const t = ye(), { updateAppShell: n } = cn(), { editor: r, editorKey: o, sdkLicenseError: s, sdkMisconfigurationError: i, isReady: a, licenseCheckStarted: l, rootElWidth: u } = t, d = Bn(), p = Ne(), f = tf();
  jv();
  const h = !!o && !!u;
  return G(() => {
    n && document.querySelector("body").classList.add(...F(z.bg, "overflow-hidden").split(" "));
  }, []), G(() => {
    if (a && !l && !Gd()) {
      const g = setTimeout(() => t.loadLicense(), 100);
      return () => clearTimeout(g);
    }
  }, [a, l]), G(() => {
    i && console.error(i);
  }, [i]), G(() => {
    if (!r)
      return;
    "launchQueue" in window && "LaunchParams" in window && window.launchQueue.setConsumer(async (v) => {
      if (!v.files.length)
        return;
      const w = await (await v.files[0].getFile()).text();
      t.loadProjectData(JSON.parse(w));
    });
    const { plg: g } = t.queryParams;
    g && !f.selectedShown && d.open({
      fullH: !0,
      title: p.t("pluginManager.plugins"),
      content: () => /* @__PURE__ */ c(H0, { selectedId: g })
    });
    const m = As(() => t.refreshEditorCanvas(), 100);
    return window.addEventListener("scroll", m, !0), () => window.removeEventListener("scroll", m, !0);
  }, [r]), G(() => {
  }, []), /* @__PURE__ */ A(I, { className: F("relative transition-colors h-full", z.bg, z.txt), justify: "center", items: "center", col: !0, children: [
    h && (s ? /* @__PURE__ */ A(I, { col: !0, justify: "center", items: "center", children: [
      /* @__PURE__ */ c("div", { children: "SDK License Error" }),
      /* @__PURE__ */ c("span", { className: F("text-sm"), children: s })
    ] }) : i ? /* @__PURE__ */ c(I, { col: !0, justify: "center", items: "center", children: /* @__PURE__ */ c("div", { children: "SDK Misconfiguration Error" }) }) : /* @__PURE__ */ c(LN, {})),
    /* @__PURE__ */ c(rr, { show: !h, as: wt, ...zi, children: /* @__PURE__ */ c(sa, { className: F("z-10", z.bg), abs: !0 }) })
  ] });
});
function NN({
  projectType: e,
  project: t
}) {
  const n = jN({ projectType: e }), r = { type: e, default: { pages: [n] } };
  return t ? (t.default = t.default ?? r.default, t) : r;
}
function jN({ projectType: e }) {
  const t = { name: "Web", component: DN }, n = { name: "Email", component: IN };
  switch (e) {
    case Ve.web:
      return t;
    case Ve.email:
      return n;
    default:
      return t;
  }
}
const Al = "https://app.grapesjs.com/docs-sdk/configuration/projects#self-hosted-storage", Ll = "https://app.grapesjs.com/docs-sdk/configuration/projects#setup", G0 = "https://app.grapesjs.com/docs-sdk/img/grapesjs-logo-black.svg", DN = `<body>
    <header class="head">
      <img class="logo" src="${G0}" alt="GrapesJS Logo">
    </header>
    <div class="card">
        <h1 class="title">Welcome to GrapesJS Studio SDK!</h1>
        <p class="subtitle">You're currently viewing the default fallback project for web.</p>

        <p class="paragraph">
          This appears because no storage has been configured yet. To set up your own storage, follow the guide here:
          <br/>
          👉 <a class="link" href="${Al}" target="_blank">${Al}</a>
        </p>

        <p class="paragraph">
          Want to customize the fallback project? You can do so by setting options.project.default. Learn more here:
          <br/>
          👉 <a class="link" href="${Ll}" target="_blank">${Ll}</a>
        </p>

        <footer class="footer">Happy building! 🚀</footer>
    </div>
    <style>
      body {
        background-color: #e7e7e7;
        font-family: Arial, sans-serif;
      }
      .head {
        padding: 50px 50px 35px;
      }
      .logo {
        max-width: 250px;
        display: block;
        margin: 0 auto;
      }
      .card {
        max-width: 600px;
        padding: 40px 45px;
        background-color: white;
        border-radius: 15px;
        margin: 0 auto;
        color: #333333;
        font-size: 16px;
      }
      .title {
        color: #af4e8a;
        font-size: 24px;
        font-weight: bold;
        margin: 0;
        text-align: center;
      }
      .subtitle {
        text-align: center;
        margin: 0;
        padding: 25px 0;
      }
      .paragraph {
        line-height: 1.5;
        margin-bottom: 40px;
      }
      .link {
        color:#af4e8a;
        text-decoration:none;
        font-size:13px;
      }
      .footer {
        margin-top: 30px;
        text-align: center;
      }
  </style>
</body>`, IN = `<mjml>
  <mj-body background-color="#E7E7E7">
    <mj-section full-width="full-width" padding="50px 50px 35px 50px">
      <mj-column width="100%">
        <mj-image src="${G0}" width="250px" padding="0px" />
      </mj-column>
    </mj-section>
    <mj-section padding="0px">
      <mj-column background-color="white" border-radius="15px" padding="40px 20px">
        <mj-text color="#af4e8a" font-size="24px" font-weight="bold" align="center">
          Welcome to GrapesJS Studio SDK!
        </mj-text>
        <mj-text font-size="16px" color="#333333" line-height="1.5" align="center" padding="10px 25px 25px 25px">
          You're currently viewing the default fallback project for emails.
        </mj-text>
        <mj-text font-size="16px" color="#333333" line-height="1.5" padding="10px 25px 30px 25px">
          This appears because no storage has been configured yet. To set up your own storage, follow the guide here:
          <br/>
          👉 <a href="${Al}" style="color:#af4e8a;text-decoration:none;font-size:13px;">
            ${Al}
          </a>
        </mj-text>
        <mj-text font-size="16px" color="#333333" line-height="1.5">
          Want to customize the fallback project? You can do so by setting options.project.default. Learn more here:
          <br/>
          👉 <a id="iu9rf-2" href="${Ll}" style="color:#af4e8a;text-decoration:none;font-size:13px;">
            ${Ll}
          </a>
        </mj-text>
        <mj-text font-size="16px" color="#333333" align="center" padding="30px 25px 10px 25px">Happy building! 🚀
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`, Rd = {
  licenseKey: "",
  settingsMenu: {
    // These were made mainly for the standalone editor, probably not suitable for the embedded one.
    // Need to revesit the interface to allow custom setting menu items.
    about: !1,
    embed: !1,
    openProject: !1,
    saveProject: !1,
    loadProject: !1,
    installApp: !1
  }
}, VN = Rt(function(t, n) {
  var d;
  const { options: r = Rd } = t, o = { theme: r.theme }, s = r.localStorage, i = s ? Hv(s, o) : o, a = (i == null ? void 0 : i.lastProjectType) || ((d = r.project) == null ? void 0 : d.type) || Ve.web, l = NN({ projectType: a, project: r.project }), u = {
    localSettingsStore: {
      ...i,
      key: s,
      updateAppShell: r.updateAppShell,
      rootEl: r.root
    },
    appEditorStore: {
      isDev: $N,
      isStage: !!r.stg,
      licenseKey: r.licenseKey,
      projectType: a,
      sdkProps: {
        ...t,
        options: {
          ...Rd,
          gjsScript: kN,
          gjsStyle: MN,
          ...r,
          project: l
        }
      }
    }
  };
  return /* @__PURE__ */ c(rM, { initialState: u, children: /* @__PURE__ */ c(gM, { ref: n, children: /* @__PURE__ */ c(RN, {}) }) });
});
const UN = VN;
export {
  id as AssetStorageType,
  Ip as AssetType,
  g0 as BlockManagerAfter,
  m0 as BlockManagerBefore,
  kn as BuiltInActionButtons,
  Hr as ComponentContextMenuItem,
  Rp as ComponentContextMenuSource,
  AR as DesignManagerTab,
  d5 as GlobalStyleFieldType,
  ne as IconNames,
  C0 as LayerManagerAfter,
  P0 as LayerManagerBefore,
  ib as LayersProvider,
  Ko as LayoutPlacers,
  Go as LayoutPosition,
  L0 as PageManagerAfter,
  k0 as PageManagerBefore,
  ab as PagesProvider,
  ad as ProjectStorageType,
  lb as SelectorsProvider,
  me as StudioCommands,
  ud as StudioCustomLayout,
  UN as StudioEditor,
  _r as StudioEvents,
  qr as ThemeValue,
  Ht as ToastVariant,
  UN as default,
  Tn as useEditor
};
